import { n as getThumbnailMeasure, r as sanitizeUrl, t as getPreviewSizeFrom } from "./util-DB31IoJE.js";
import * as React$1 from "react";
import React, { Suspense, createContext, createElement, forwardRef, memo, useCallback, useContext, useEffect, useId, useLayoutEffect, useMemo, useRef, useState, useSyncExternalStore } from "react";
import { deepEqual, shallowEqual } from "fast-equals";
import { Alert, AlertCircleIcon, AlertTriangleIcon, AlignLeftIcon, ArrowDownIcon, ArrowLeftIcon, ArrowRightToLineIcon, ArrowUpDownIcon, ArrowUpIcon, Badge, BooleanSwitchWithLabel, Button, CHIP_COLORS, CHIP_SEED_KEYS, CalendarIcon, Card, CardView, CenteredView, CheckCircleIcon, CheckIcon, Checkbox, ChevronDownIcon, ChevronRightIcon, ChevronUpIcon, ChevronsUpDownIcon, Chip, CircleIcon, CircularProgress, CircularProgressCenter, CodeIcon, Collapse, ColumnsIcon, CopyIcon, DateTimeField, Dialog, DialogActions, DialogContent, DialogTitle, ErrorBoundary, ExpandablePanel, ExternalLinkIcon, EyeIcon, EyeOffIcon, FileTextIcon, FileUpload, FilterChip, FilterIcon, FilterXIcon, FlagIcon, FolderUpIcon, FunctionSquareIcon, GlobeIcon, HandleIcon, HashIcon, HistoryIcon, IconButton, ImageOffIcon, KanbanIcon, KanbanView, KeyRoundIcon, Label, LayoutGridIcon, Link2Icon, LinkIcon, ListIcon, ListOrderedIcon, ListView, LoadingButton, LucideIconByName, MailIcon, Markdown, Maximize2Icon, Menu, MenuItem, MinusIcon, MoreVerticalIcon, MultiSelect, MultiSelectItem, PanelLeftCloseIcon, PanelLeftOpenIcon, PencilIcon, PlusIcon, Popover, PopoverPrimitive, Portal, QuoteIcon, RadioGroup, RadioGroupItem, RefreshCwIcon, RepeatIcon, ResizablePanels, Rows3Icon, SearchBar, SearchIcon, Select, SelectItem, Separator, SettingsIcon, Sheet, Skeleton, Tab, Table, TableBody, TableCell, TableHeader, TableIcon, TableRow, Tabs, TextField, TextIcon, TextareaAutosize, ToggleButtonGroup, Tooltip, Trash2Icon, Typography, Unlink2Icon, UploadIcon, UserIcon, VirtualTable, VirtualTableDateField, VirtualTableInput, VirtualTableInput as VirtualTableInput$1, VirtualTableNumberInput, VirtualTableSwitch, VoteIcon, XCircleIcon, XIcon, cls, coolIconKeys, createVirtualTableSelectionStore, debounce, defaultBorderMixin, fieldBackgroundDisabledMixin, fieldBackgroundHoverMixin, fieldBackgroundInvisibleMixin, fieldBackgroundMixin, focusedDisabled, getColorSchemeForSeed, iconSize, lazyChunk, paperMixin, useDebouncedCallback, useOutsideAlerter, usePortalContainer } from "@rebasepro/ui";
import { CollectionRegistry, DEFAULT_ONE_OF_TYPE, DEFAULT_ONE_OF_VALUE, canReadCollection, enumToObjectEntries, getArrayResolvedProperties, getDefaultValueFor, getDefaultValueFortype, getDefaultValuesFor, getEntityChildViews, getLabelOrConfigFrom, getReferenceFrom, getRelationFrom, getRelationTargetPath, getSubcollections, getTableName, isPropertyBuilder, normalizeOrderBy, normalizeToEntityRelation, resolveArrayProperties, resolveEnumValues, resolveProperty, resolveRelationProperty, resolveStorageFilenameString, resolveStoragePathString, resolveStorageSource, serializeOrderBy } from "@rebasepro/common";
import { CONTAINER_FULL_WIDTH, CollectionScopeProvider, DEFAULT_PAGE_SIZE, EntityDisplayCache, ErrorTooltip, ErrorView, IconForView, PluginProviderStack, SIDE_PANEL_DEFAULT_WIDTH, StorageSourceContext, UnsavedChangesDialog, UserDisplay, addInitialSlash, apiBaseOf, buildEnumLabel, createFormexStub, deleteEntityWithCallbacks, entityDisplayKey, flattenKeys, getAdminEntityChildViews, getCollectionBySlugWithin, getCollectionPathsCombinations, getColorScheme, getColumnKeysForProperty, getDisplayPropertyKey, getDisplayResolver, getEntityFromCache, getEntityFromMemoryCache, getEntityImagePreviewPropertyKey, getEntityPreviewKeys, getFormFieldKeys, getIcon, getLastSegment as getLastSegment$1, getLeadingRelationTitleKey, getLocalChangesBackup, getNavigationEntriesFromPath, getParentReferencesFromPath, getPropertyInPath, getRedundantChildViewColumnIds, getRelationIncludeParams, getRowHeight, getTitlePropertyCandidates, getTitlePropertyKey, getTitlePropertyKeyForValues, hasDeclaredDisplay, iconsSearch, isDisabled, isFilterableRelation, isHidden, isReadOnly, looksLikeIdentifierValue, removeEntityFromCache, removeEntityFromMemoryCache, removeInitialAndTrailingSlashes, removeInitialAndTrailingSlashes as removeInitialAndTrailingSlashes$1, removeInitialSlash, removeTrailingSlash, removeTrailingSlash as removeTrailingSlash$1, resolveCollectionPathIds, resolveCollectionPathIds as resolveCollectionPathIds$1, resolveComponentRef, resolveDefaultSelectedView, resolveFilterOperators, resolveFormLayout, saveEntityToCache, saveEntityToMemoryCache, saveEntityWithCallbacks, useAnalyticsController, useApiBase, useApiConfig, useAuthController, useBridgeRegistration, useCollectionScope, useColumnIds, useComponentOverride, useCustomizationController, useData, useDataTableController, useFetch, useLargeLayout, useNavigationBlocker, usePermissions, useRebaseClient, useRebaseContext, useRelationSelector, useResolvedComponent, useScrollRestoration, useSlot, useSnackbarController, useStorageSource, useStorageSources, useStorageUploadController, useTranslation, useUnsavedChangesDialog, useUserConfigurationPersistence } from "@rebasepro/app";
import { Field, Formex, getIn, setIn, useCreateFormex, useFormex } from "@rebasepro/forms";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { EntityReference, EntityRelation, GeoPoint, MAX_LIST_LIMIT, Vector, getCollectionDataPath, getDataSourceCapabilities, isRelationalCollectionConfig, resourceKeyOf } from "@rebasepro/types";
import { defaultDateFormat, formatRelativeTime, getHashValue, getValueInPath, hydrateRegExp, isArrayValue, isObject, isPrototypePollutingKey, mergeDeep, pathTraversesPrototype, prettifyIdentifier, randomString, readStoredJson, toArray, writeStoredJson } from "@rebasepro/utils";
import { resolveAdminCollection } from "@rebasepro/cms-types";
import { format } from "date-fns";
import { Command } from "cmdk";
import { useDropzone } from "react-dropzone";
import { z } from "zod";
import useMeasure from "react-use-measure";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router";
import { DndContext, KeyboardSensor, PointerSensor, closestCenter, useSensor, useSensors } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { SortableContext, horizontalListSortingStrategy, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { inferTypeFromValue } from "@rebasepro/inference";
import { generateKeyBetween, generateNKeysBetween } from "fractional-indexing";
//#region src/util/property_utils.tsx
/**
* Resolve a size value (string token or number) to a numeric pixel value
* suitable for passing to Lucide icons.
*/
function resolveSize(size) {
	if (typeof size === "number") return size;
	return iconSize[size];
}
function isReferenceProperty(property) {
	if (!property) return null;
	if (property.type === "reference") return true;
	if (property.type === "array") if (Array.isArray(property.of)) return false;
	else return property.of?.type === "reference";
	return false;
}
function isRelationProperty(property) {
	if (!property) return null;
	if (property.type === "relation") return true;
	if (property.type === "array") if (Array.isArray(property.of)) return false;
	else return property.of?.type === "relation";
	return false;
}
function getIconForWidget(widget, size) {
	return /* @__PURE__ */ jsx(widget?.Icon ?? CircleIcon, { size: resolveSize(size) });
}
/**
* Returns a default Lucide icon component based on property type.
* This provides a sensible fallback when no PropertyConfig is available.
*/
function getDefaultIconForProperty(property) {
	switch (property.type) {
		case "string":
			if (property.storage) return UploadIcon;
			if (property.admin?.urlPreview) return GlobeIcon;
			if (property.email) return MailIcon;
			if (property.admin?.multiline || property.admin?.markdown) return AlignLeftIcon;
			return TextIcon;
		case "number": return HashIcon;
		case "boolean": return FlagIcon;
		case "date": return CalendarIcon;
		case "map": return VoteIcon;
		case "array": {
			const of = property.of;
			if (property.oneOf) return Rows3Icon;
			if (of && !Array.isArray(of)) {
				if (of.type === "reference") return LinkIcon;
				if (of.type === "string" && of.storage) return UploadIcon;
			}
			return RepeatIcon;
		}
		case "reference": return LinkIcon;
		case "relation": return LinkIcon;
		case "vector": return HashIcon;
		default: return CircleIcon;
	}
}
function getIconForProperty(property, size = "small", fields = {}) {
	const px = resolveSize(size);
	if (isPropertyBuilder(property)) return /* @__PURE__ */ jsx(FunctionSquareIcon, { size: px });
	const configId = property.propertyConfig || void 0;
	const widget = configId ? fields[configId] : void 0;
	if (widget?.Icon) return getIconForWidget(widget, size);
	return /* @__PURE__ */ jsx(getDefaultIconForProperty(property), { size: px });
}
/**
* Get a property in a property tree from a path like
* `address.street`
* @param properties
* @param path
*/
function getPropertyInPath$1(properties, path) {
	if (typeof properties === "object") {
		if (path in properties) return properties[path];
		if (path.includes(".")) {
			const pathSegments = path.split(".");
			const childProperty = properties[pathSegments[0]];
			if (typeof childProperty === "object" && childProperty.type === "map" && childProperty.properties) return getPropertyInPath$1(childProperty.properties, pathSegments.slice(1).join("."));
		}
	}
}
function getResolvedPropertyInPath(properties, path) {
	if (typeof properties === "object") {
		if (path in properties) return properties[path];
		if (path.includes(".")) {
			const pathSegments = path.split(".");
			const childProperty = properties[pathSegments[0]];
			if (childProperty?.type === "map" && childProperty.properties) return getResolvedPropertyInPath(childProperty.properties, pathSegments.slice(1).join("."));
		}
	}
}
function getBracketNotation(path) {
	return path.replace(/\.([^.]*)/g, "[$1]");
}
/**
* Get properties sorted by their order, but include ALL properties.
* Nested keys (like "data.mode") in propertiesOrder are ignored - they're for column ordering.
* @param properties
* @param propertiesOrder
*/
function getPropertiesWithPropertiesOrder(properties, propertiesOrder) {
	if (!propertiesOrder) return properties;
	const propertyKeys = Object.keys(properties);
	const validOrderKeys = propertiesOrder.filter((key) => !key.includes(".") && properties[key]);
	const result = {};
	validOrderKeys.forEach((key) => {
		const property = properties[key];
		if (typeof property === "object" && property.type === "map" && property.properties) {
			const mapProp = property;
			result[key] = {
				...mapProp,
				properties: getPropertiesWithPropertiesOrder(mapProp.properties, mapProp.propertiesOrder ?? [])
			};
		} else if (property) result[key] = property;
	});
	propertyKeys.forEach((key) => {
		if (!result[key]) {
			const property = properties[key];
			if (typeof property === "object" && property.type === "map" && property.properties) {
				const mapProp = property;
				result[key] = {
					...mapProp,
					properties: getPropertiesWithPropertiesOrder(mapProp.properties, mapProp.propertiesOrder ?? [])
				};
			} else if (property) result[key] = property;
		}
	});
	return result;
}
function getDefaultPropertiesOrder(collection) {
	if (collection.propertiesOrder) return collection.propertiesOrder;
	return [...Object.keys(collection.properties), ...(collection.additionalFields ?? []).map((field) => field.key)];
}
//#endregion
//#region src/components/PropertyKeyHint.tsx
/**
* A property's key, shown beside its label while the label is hovered, and
* copied when clicked.
*
* Inline, in the label row's own empty space, rather than a tooltip. The tooltip
* this replaces wrapped the field's control as well as its label, so it opened
* the moment a field took focus and sat on top of the label of the very field
* being filled in. Closing again on blur, it was also what threw Tab out of the
* dialog (see `useRestoreInterruptedFocus` in `@rebasepro/ui`). A key a
* developer copies now and then is not worth a layer over the form.
*
* Revealed by hovering the nearest `group/label` ancestor, after a pause, so a
* pointer crossing the form does not flicker keys on and off; hidden again at
* once. Out of the tab order: a stop per field would double the keystrokes it
* takes to get through a form, for something only the pointer needs.
*
* Gives up its width before the label does (`shrink-[999]`), so a long field
* name in a narrow column is never truncated to make room for a key that is not
* even showing.
*/
function PropertyKeyHint({ propertyKey, className }) {
	const { t } = useTranslation();
	const [copied, setCopied] = useState(false);
	const copy = (event) => {
		event.preventDefault();
		event.stopPropagation();
		navigator.clipboard?.writeText(propertyKey).then(() => {
			setCopied(true);
			setTimeout(() => setCopied(false), 1600);
		}, () => void 0);
	};
	return /* @__PURE__ */ jsxs("button", {
		type: "button",
		tabIndex: -1,
		onClick: copy,
		"aria-label": `${t("copy")} ${propertyKey}`,
		className: cls("inline-flex items-center gap-1 min-w-0 shrink-[999] px-1 -my-0.5 rounded-md", "font-mono text-[11px] font-normal leading-tight", "text-text-disabled dark:text-text-disabled-dark", "hover:text-text-secondary dark:hover:text-text-secondary-dark hover:bg-surface-hover", "opacity-0 transition-opacity duration-150 group-hover/label:opacity-100 group-hover/label:delay-500", className),
		children: [/* @__PURE__ */ jsx("span", {
			className: "truncate",
			children: propertyKey
		}), copied ? /* @__PURE__ */ jsx(CheckIcon, {
			size: 11,
			className: "shrink-0"
		}) : /* @__PURE__ */ jsx(CopyIcon, {
			size: 11,
			className: "shrink-0"
		})]
	});
}
//#endregion
//#region src/form/components/FieldBlock.tsx
/**
* Grid placement for a span.
*
* Written out as literal class strings rather than composed, because Tailwind
* scans source text: a template literal would produce classes that exist at
* runtime and were never generated into the stylesheet.
*
* Below the column breakpoint every field takes the single available column, so
* the side panel, the dialog and mobile all get a plain stack.
*
* Lives here rather than in the form, because the read-only rendering of a
* record places its fields on the same grid — a record that changes shape when
* you press Edit is the bug this whole layout exists to avoid.
*/
function spanClass(span) {
	switch (span) {
		case 1: return "@2xl/col:col-span-1";
		case 2: return "@2xl/col:col-span-2";
		case 3: return "@2xl/col:col-span-3";
		case 4: return "@2xl/col:col-span-4";
	}
}
/**
* Does this property's editor supply its own heading?
*
* Arrays, maps, `oneOf` blocks and key-value editors render as a collapsible
* panel whose header *is* the label — hiding it would leave a panel you cannot
* identify or, worse, cannot expand. Those keep their own; everything else gets
* its label from {@link FieldBlock}, which is what makes a text field and a
* select finally agree on where a label goes.
*
* Exported because the layout resolver's span rules and this rule have to stay
* in step: the self-labelling types are exactly the ones that take a full row.
*/
function isSelfLabellingProperty(property) {
	if (!property) return false;
	switch (property.type) {
		case "map": return !property.admin?.spreadChildren;
		case "array": {
			if (property.oneOf) return true;
			if (Array.isArray(property.of) || !property.of) return true;
			const of = property.of;
			if (of.type === "string" && (of.enum || of.storage)) return false;
			if (of.type === "number" && of.enum) return false;
			return true;
		}
		default: return false;
	}
}
/**
* The type icon in a field label, in px.
*
* Matched to the label's 13px rather than taken from `iconSize.smallest` (16),
* which is sized for buttons. Exported so the surfaces that draw a label
* themselves — the additional-field cards, the rail — can stay in step.
*/
var LABEL_ICON_SIZE = 14;
/**
* One field's worth of the form grid: label, control, description.
*
* The same block frames the read-only rendering of a record, so a field sits in
* the same place, at the same width, under the same label whether or not you are
* editing it — see {@link EntityViewBinding}.
*
* The label is one size down from the control it names (13px against the body's
* 14) with its icon matched to it at 14px. Labels are scaffolding: you read them
* to find the value, then read the value. Setting them at body size made a
* column of records scan as a column of field names with data attached.
*/
function FieldBlock({ propertyKey, property, showLabel, mode = "edit", label, icon, children }) {
	const reading = mode === "read";
	const description = property?.description?.trim();
	const required = Boolean(property?.validation?.required);
	return /* @__PURE__ */ jsxs("div", {
		id: `form_field_${propertyKey}`,
		className: "relative flex flex-col min-w-0",
		children: [
			showLabel && /* @__PURE__ */ jsxs("div", {
				className: cls("group/label flex items-center gap-1.5 min-w-0 font-medium leading-tight mb-1.5", "text-[13px] text-text-primary dark:text-text-primary-dark"),
				children: [
					(property || icon) && /* @__PURE__ */ jsx("span", {
						className: "shrink-0 text-text-disabled dark:text-text-disabled-dark",
						children: property ? getIconForProperty(property, 14) : icon
					}),
					/* @__PURE__ */ jsx("span", {
						className: "truncate",
						children: property?.name ?? label ?? propertyKey
					}),
					required && /* @__PURE__ */ jsx("span", {
						className: "text-red-500 dark:text-red-500 -ml-1",
						children: "*"
					}),
					property && /* @__PURE__ */ jsx(PropertyKeyHint, { propertyKey })
				]
			}),
			/* @__PURE__ */ jsx("div", {
				className: "min-w-0",
				children: /* @__PURE__ */ jsx(ErrorBoundary, { children })
			}),
			showLabel && description && !reading && /* @__PURE__ */ jsx(Typography, {
				variant: "caption",
				color: "disabled",
				className: "mt-1.5 ml-0.5 leading-snug",
				children: description
			})
		]
	});
}
//#endregion
//#region src/components/AdditionalFieldValue.tsx
/**
* Renders an `additionalFields` entry that supplies a `value` rather than a
* `Builder`.
*
* `value` is typed `string | number | Promise<string | number>`, and the promise
* arm has been part of that type from the start — the CSV export awaits it
* correctly. Every *renderer* called `.toString()` on the result instead, so an
* async value drew the literal text `[object Promise]` in the cell: a shape the
* type promised, that worked in one of its two consumers, and failed silently in
* the other. That is what made the obvious port of a FireCMS column — one that
* fetches a title from a subcollection — look supported and not be.
*
* Three call sites had the same three lines copied between them (the table cell,
* the form and the read-only record), which is why the bug reached all three.
* Now there is one.
*/
function AdditionalFieldValue({ field, entity, context }) {
	const [resolved, setResolved] = useState(() => {
		const value = field.value?.({
			entity,
			context
		});
		return isPromise(value) ? void 0 : value;
	});
	useEffect(() => {
		const value = field.value?.({
			entity,
			context
		});
		if (!isPromise(value)) {
			setResolved(value);
			return;
		}
		let live = true;
		value.then((result) => {
			if (live) setResolved(result);
		}, (error) => {
			if (live) setResolved(void 0);
			console.warn(`[rebase] Additional field "${field.key}" failed to resolve:`, error);
		});
		return () => {
			live = false;
		};
	}, [
		field,
		entity,
		context
	]);
	return /* @__PURE__ */ jsx(Fragment, { children: resolved === void 0 || resolved === null ? null : String(resolved) });
}
function isPromise(value) {
	return typeof value?.then === "function";
}
//#endregion
//#region src/form/components/FormRail.tsx
/**
* The metadata column beside the form.
*
* This replaces a `w-80 2xl:w-96` rail that held a Save button and several
* hundred pixels of nothing. It renders only when it has something to say, and
* the actions it used to hold now live in the identity bar, where they stay
* visible while you scroll.
*/
function FormRail({ fields, showRecordMeta, entity, renderField }) {
	if (!fields.length && !showRecordMeta) return null;
	return /* @__PURE__ */ jsxs("aside", {
		className: cls("flex flex-col gap-6 shrink-0 w-76 @7xl/form:w-84 overflow-y-auto", "px-5 py-6 bg-surface-sheet"),
		children: [fields.length > 0 && /* @__PURE__ */ jsx("div", {
			className: "flex flex-col gap-5",
			children: fields.map(renderField)
		}), showRecordMeta && entity && /* @__PURE__ */ jsx(RecordMeta, { entity })]
	});
}
/**
* The record's id and audit timestamps.
*
* Exported because the rail is not the only place it renders. The rail is shown
* only when it has been *measured* to fit, and every layout narrower than that —
* the split pane, the side panel, the dialog — folds its contents back into the
* column. The fields folded back but this block did not, so on three of the four
* layouts a record simply had no id on screen: the only copy of it was the
* truncated `e166a394…b422` chip in the identity bar.
*/
function RecordMeta({ entity }) {
	const createdAt = pickDate(entity.values, [
		"created_at",
		"createdAt",
		"created_on"
	]);
	const updatedAt = pickDate(entity.values, [
		"updated_at",
		"updatedAt",
		"modified_at"
	]);
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col gap-2.5",
		children: [
			/* @__PURE__ */ jsx(Typography, {
				variant: "caption",
				className: "text-xs font-semibold uppercase tracking-wider text-text-disabled dark:text-text-disabled-dark",
				children: "Record"
			}),
			/* @__PURE__ */ jsx(MetaRow, {
				label: "ID",
				value: String(entity.id),
				copyable: true
			}),
			createdAt && /* @__PURE__ */ jsx(MetaRow, {
				label: "Created",
				value: createdAt
			}),
			updatedAt && /* @__PURE__ */ jsx(MetaRow, {
				label: "Updated",
				value: updatedAt
			})
		]
	});
}
function MetaRow({ label, value, copyable }) {
	const [copied, setCopied] = React.useState(false);
	const copy = () => {
		navigator.clipboard?.writeText(value).then(() => {
			setCopied(true);
			setTimeout(() => setCopied(false), 1600);
		}, () => void 0);
	};
	return /* @__PURE__ */ jsxs("div", {
		className: "flex items-baseline justify-between gap-3 min-w-0",
		children: [/* @__PURE__ */ jsx("span", {
			className: "text-xs text-text-disabled dark:text-text-disabled-dark shrink-0",
			children: label
		}), /* @__PURE__ */ jsxs("span", {
			className: "flex items-center gap-1 min-w-0",
			children: [/* @__PURE__ */ jsx("span", {
				className: "font-mono text-xs text-text-secondary dark:text-text-secondary-dark truncate",
				title: value,
				children: value
			}), copyable && /* @__PURE__ */ jsx(Tooltip, {
				title: copied ? "Copied" : "Copy",
				children: /* @__PURE__ */ jsx(IconButton, {
					size: "smallest",
					onClick: copy,
					children: copied ? /* @__PURE__ */ jsx(CheckIcon, { size: iconSize.smallest }) : /* @__PURE__ */ jsx(CopyIcon, { size: iconSize.smallest })
				})
			})]
		})]
	});
}
/**
* Audit timestamps are a convention, not a contract — a collection may name them
* anything or not have them at all — so this reads the values it recognises and
* stays quiet otherwise rather than rendering an empty row.
*/
function pickDate(values, keys) {
	if (!values) return void 0;
	for (const key of keys) {
		const value = values[key];
		if (value instanceof Date) return value.toLocaleDateString();
		if (typeof value === "string" && value) {
			const parsed = new Date(value);
			if (!Number.isNaN(parsed.getTime())) return parsed.toLocaleDateString();
		}
	}
}
//#endregion
//#region src/form/components/FormSections.tsx
function FormSections({ sections, collapsed, onToggle, errorKeys, renderField, mode = "edit", renderSummaryField }) {
	const reading = mode === "read";
	return /* @__PURE__ */ jsx("div", {
		className: cls("flex flex-col", reading ? "gap-10" : "gap-8"),
		children: sections.map((section) => {
			const hasError = section.fields.some((f) => errorKeys.has(f.key));
			const isCollapsed = section.collapsible && collapsed.has(section.key) && !hasError;
			const summary = reading && section.readVariant === "summary" && Boolean(renderSummaryField);
			return /* @__PURE__ */ jsxs("section", {
				className: "min-w-0",
				children: [section.title && /* @__PURE__ */ jsx(Header, {
					title: section.title,
					collapsible: section.collapsible,
					collapsed: isCollapsed,
					controls: `form_section_${section.key}`,
					onToggle: () => onToggle(section.key)
				}), !isCollapsed && (summary ? /* @__PURE__ */ jsx("div", {
					id: `form_section_${section.key}`,
					className: "flex flex-col min-w-0 @2xl:max-w-md @2xl:ml-auto",
					children: section.fields.map((field, index) => renderSummaryField(field, index, section.fields.length))
				}) : /* @__PURE__ */ jsx("div", {
					id: `form_section_${section.key}`,
					className: cls("grid min-w-0", reading ? "gap-x-8 gap-y-7" : "gap-x-4 gap-y-5", "grid-cols-1 @2xl:grid-cols-4"),
					children: section.fields.map(renderField)
				}))]
			}, section.key);
		})
	});
}
function Header({ title, collapsible, collapsed, controls, onToggle }) {
	const content = /* @__PURE__ */ jsxs(Fragment, { children: [
		collapsible && /* @__PURE__ */ jsx(ChevronDownIcon, {
			size: iconSize.smallest,
			className: cls("text-text-disabled dark:text-text-disabled-dark transition-transform duration-150", collapsed && "-rotate-90")
		}),
		/* @__PURE__ */ jsx("span", {
			className: "text-xs font-semibold uppercase tracking-wider text-text-disabled dark:text-text-disabled-dark whitespace-nowrap",
			children: title
		}),
		/* @__PURE__ */ jsx("span", { className: cls("flex-1 border-t", defaultBorderMixin) })
	] });
	const className = "flex items-center gap-2.5 w-full mb-3.5";
	if (!collapsible) return /* @__PURE__ */ jsx("div", {
		className,
		children: content
	});
	return /* @__PURE__ */ jsx("button", {
		type: "button",
		onClick: onToggle,
		"aria-expanded": !collapsed,
		"aria-controls": collapsed ? void 0 : controls,
		className: cls(className, "text-left hover:opacity-80 transition-opacity"),
		children: content
	});
}
//#endregion
//#region src/form/components/useRailVisible.tsx
/**
* Below this the form is a single column and the rail is not shown.
*
* Roughly the 320px rail plus a content column still wide enough to hold a
* four-up row — at the threshold that leaves ~680px, which is four columns of
* ~145px once the gutters are taken out. Above it the rail is worth having even
* in the split view; below it — a narrow split pane, the side panel, the dialog,
* a phone — its fields fold back into the column.
*/
var RAIL_MIN_WIDTH = 1e3;
/**
* Is there room beside the form for the metadata rail?
*
* Measured on the form element rather than the viewport, because the same form
* renders in a side panel and a dialog inside a wide window — a media query
* would say "desktop" and hand a 600px panel a rail it cannot fit.
*
* This has to be a real measurement rather than a CSS `hidden` class: the
* layout resolver *moves* fields into the rail, so hiding it with CSS did not
* fold them back into the column, it made them unreachable. Status, category
* and any other rail field simply could not be edited in the side panel, the
* dialog, or on a phone.
*/
function useRailVisible(ref) {
	const [visible, setVisible] = useState(false);
	useLayoutEffect(() => {
		const element = ref.current;
		if (!element) return;
		const measure = () => setVisible(element.getBoundingClientRect().width >= RAIL_MIN_WIDTH);
		measure();
		if (typeof ResizeObserver === "undefined") return;
		const observer = new ResizeObserver(measure);
		observer.observe(element);
		return () => observer.disconnect();
	}, [ref]);
	return visible;
}
//#endregion
//#region src/preview/components/EmptyValue.tsx
/**
* @group Preview components
*/
function EmptyValue({ className }) {
	return /* @__PURE__ */ jsx("div", { className: "rounded-full bg-surface-200/30 dark:bg-surface-200/20 w-5 h-2 inline-block" });
}
//#endregion
//#region src/preview/components/ImagePreview.tsx
/**
* @group Preview components
*/
function ImagePreview({ size, url, fill }) {
	const [hasError, setHasError] = useState(false);
	useEffect(() => {
		setHasError(false);
	}, [url]);
	const handleError = () => setHasError(true);
	const imageSize = useMemo(() => getThumbnailMeasure(size), [size]);
	const { t } = useTranslation();
	if (fill) {
		if (hasError) return /* @__PURE__ */ jsx("div", {
			className: "w-full h-full flex items-center justify-center bg-surface-raised rounded-md",
			children: /* @__PURE__ */ jsx(ImageOffIcon, { className: "text-surface-400 dark:text-surface-500" })
		});
		return /* @__PURE__ */ jsx("img", {
			src: url,
			className: "w-full h-full object-cover",
			loading: "lazy",
			onError: handleError
		}, "fill_image_preview_" + url);
	}
	if (size === "small") {
		if (hasError) return /* @__PURE__ */ jsx("div", {
			className: "flex items-center justify-center bg-surface-raised rounded-md",
			style: {
				width: imageSize,
				height: imageSize,
				maxHeight: "100%"
			},
			children: /* @__PURE__ */ jsx(ImageOffIcon, { className: "text-surface-400 dark:text-surface-500" })
		});
		return /* @__PURE__ */ jsx("img", {
			src: url,
			className: "rounded-md",
			onError: handleError,
			style: {
				position: "relative",
				objectFit: "cover",
				width: imageSize,
				height: imageSize,
				maxHeight: "100%"
			}
		}, "tiny_image_preview_" + url);
	}
	return /* @__PURE__ */ jsxs("div", {
		className: "relative flex items-center justify-center max-w-full max-h-full group",
		style: {
			width: imageSize,
			height: imageSize
		},
		children: [hasError ? /* @__PURE__ */ jsx("div", {
			className: "w-full h-full flex items-center justify-center bg-surface-raised rounded-md",
			children: /* @__PURE__ */ jsx(ImageOffIcon, { className: "text-surface-400 dark:text-surface-500" })
		}) : /* @__PURE__ */ jsx("img", {
			src: url,
			className: "rounded-md",
			style: {
				maxWidth: "100%",
				maxHeight: "100%"
			},
			onError: handleError
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex flex-row gap-2 absolute bottom-[-4px] right-[-4px] invisible group-hover:visible",
			children: [navigator && /* @__PURE__ */ jsx(Tooltip, {
				asChild: true,
				title: t("copy_url_to_clipboard"),
				side: "bottom",
				children: /* @__PURE__ */ jsx(IconButton, {
					variant: "filled",
					size: "smallest",
					onClick: (e) => {
						e.stopPropagation();
						e.preventDefault();
						return navigator.clipboard.writeText(url);
					},
					children: /* @__PURE__ */ jsx(CopyIcon, { className: "text-surface-700 dark:text-surface-300" })
				})
			}), /* @__PURE__ */ jsx(Tooltip, {
				title: t("open_image_in_new_tab"),
				side: "bottom",
				children: /* @__PURE__ */ jsx(IconButton, {
					className: "invisible group-hover:visible",
					variant: "filled",
					component: "a",
					href: sanitizeUrl(url),
					rel: "noopener noreferrer",
					target: "_blank",
					size: "smallest",
					onClick: (e) => e.stopPropagation(),
					children: /* @__PURE__ */ jsx(ExternalLinkIcon, { className: "text-surface-700 dark:text-surface-300" })
				})
			})]
		})]
	}, "image_preview_" + url);
}
//#endregion
//#region src/preview/components/UrlComponentPreview.tsx
/**
* @group Preview components
*/
function UrlComponentPreview({ url, previewType, size, hint, interactive = true, fill }) {
	if (!previewType) {
		if (!url || !url.trim()) return /* @__PURE__ */ jsx(EmptyValue, {});
		return /* @__PURE__ */ jsxs("a", {
			className: "flex gap-4 break-words items-center font-medium text-primary visited:text-primary dark:visited:text-primary dark:text-primary",
			href: sanitizeUrl(url),
			rel: "noopener noreferrer",
			onMouseDown: (e) => {
				e.preventDefault();
			},
			target: "_blank",
			children: [/* @__PURE__ */ jsx(ExternalLinkIcon, {}), url]
		});
	}
	if (previewType === "image") return /* @__PURE__ */ jsx(ImagePreview, {
		url,
		size,
		fill
	});
	else if (previewType === "audio") return /* @__PURE__ */ jsxs("audio", {
		controls: true,
		className: "max-w-100%",
		src: url,
		children: [
			"Your browser does not support the",
			/* @__PURE__ */ jsx("code", { children: "audio" }),
			" element."
		]
	});
	else if (previewType === "video") return /* @__PURE__ */ jsx(VideoPreview, {
		size,
		src: url,
		interactive
	});
	else return /* @__PURE__ */ jsx(Tooltip, {
		title: hint,
		children: /* @__PURE__ */ jsxs("a", {
			href: sanitizeUrl(url),
			rel: "noopener noreferrer",
			target: "_blank",
			onClick: (e) => e.stopPropagation(),
			className: "flex flex-col items-center justify-center",
			style: {
				width: getThumbnailMeasure(size),
				height: getThumbnailMeasure(size)
			},
			children: [/* @__PURE__ */ jsx(FileTextIcon, { className: "text-surface-700 dark:text-surface-300" }), hint && /* @__PURE__ */ jsx(Typography, {
				className: "max-w-full truncate rtl text-left",
				variant: "caption",
				children: hint
			})]
		})
	});
}
function VideoPreview({ size, src, interactive }) {
	return /* @__PURE__ */ jsx("video", {
		style: {
			position: "relative",
			objectFit: "cover",
			width: useMemo(() => {
				if (size === "small") return "140px";
				else if (size === "medium") return "240px";
				else if (size === "large") return "100%";
				else throw new Error("Invalid size");
			}, [size]),
			minWidth: "140px",
			maxHeight: "100%"
		},
		controls: interactive,
		className: cls("max-w-100% rounded-xs", { "pointer-events-none": !interactive }),
		children: /* @__PURE__ */ jsx("source", { src })
	});
}
//#endregion
//#region src/preview/property_previews/SkeletonPropertyComponent.tsx
/**
* @group Preview components
*/
function SkeletonPropertyComponent({ property, size }) {
	if (!property) console.error("No property assigned for skeleton component", property, size);
	let content;
	if (property.type === "string") {
		const stringProperty = property;
		if (stringProperty.admin?.urlPreview) content = renderUrlComponent(stringProperty, size);
		else if (stringProperty.storage) content = renderSkeletonImageThumbnail(size);
		else content = renderSkeletonText();
	} else if (property.type === "array") {
		const arrayProperty = property;
		if (arrayProperty.of) if (Array.isArray(arrayProperty.of)) content = /* @__PURE__ */ jsxs(Fragment, { children: [arrayProperty.of.map((p, i) => renderGenericArrayCell(p, i)), " "] });
		else if (arrayProperty.of.type === "map" && arrayProperty.of.properties) content = renderArrayOfMaps(arrayProperty.of.properties, size, arrayProperty.of.admin?.previewProperties);
		else if (arrayProperty.of.type === "string") if (arrayProperty.of.enum) content = renderArrayEnumTableCell();
		else if (arrayProperty.of.storage) content = renderGenericArrayCell(arrayProperty.of);
		else content = renderArrayOfStrings();
		else content = renderGenericArrayCell(arrayProperty.of);
	} else if (property.type === "map") content = renderMap(property, size);
	else if (property.type === "date") content = renderSkeletonText();
	else if (property.type === "reference") content = renderReference();
	else if (property.type === "boolean") content = renderSkeletonText();
	else content = renderSkeletonText();
	return content || null;
}
function renderMap(property, size) {
	if (!property.properties) return /* @__PURE__ */ jsx(Fragment, {});
	let mapPropertyKeys;
	if (size === "large") mapPropertyKeys = Object.keys(property.properties);
	else {
		mapPropertyKeys = property.admin?.previewProperties || Object.keys(property.properties);
		if (size === "medium") mapPropertyKeys = mapPropertyKeys.slice(0, 3);
		else if (size === "small") mapPropertyKeys = mapPropertyKeys.slice(0, 1);
	}
	if (size !== "large") return /* @__PURE__ */ jsx("div", {
		className: "w-full flex flex-col space-y-4",
		children: mapPropertyKeys.map((key, index) => /* @__PURE__ */ jsx("div", { children: property.properties && property.properties[key] && /* @__PURE__ */ jsx(SkeletonPropertyComponent, {
			property: property.properties[key],
			size: "medium"
		}) }, `map_${key}`))
	});
	return /* @__PURE__ */ jsx(Table, {
		className: "table-auto",
		children: /* @__PURE__ */ jsx(TableBody, { children: mapPropertyKeys && mapPropertyKeys.map((key, index) => {
			return /* @__PURE__ */ jsxs(TableRow, { children: [/* @__PURE__ */ jsx(TableCell, {
				className: "align-top",
				style: { width: "30%" },
				children: /* @__PURE__ */ jsx(Typography, {
					variant: "caption",
					color: "secondary",
					children: property.properties[key].name
				})
			}, `table-cell-title--${key}`), /* @__PURE__ */ jsx(TableCell, {
				style: { width: "70%" },
				children: property.properties && property.properties[key] && /* @__PURE__ */ jsx(SkeletonPropertyComponent, {
					property: property.properties[key],
					size: "medium"
				})
			}, `table-cell-${key}`)] }, `map_preview_table__${index}`);
		}) })
	});
}
function renderArrayOfMaps(properties, size, previewProperties) {
	let tableProperties = previewProperties;
	if (!tableProperties || !tableProperties.length) {
		tableProperties = Object.keys(properties);
		if (size) tableProperties = tableProperties.slice(0, 3);
	}
	return /* @__PURE__ */ jsx(Table, {
		className: "table-auto",
		children: /* @__PURE__ */ jsx(TableBody, { children: [
			0,
			1,
			2
		].map((value, index) => {
			return /* @__PURE__ */ jsx(TableRow, { children: tableProperties && tableProperties.map((key) => /* @__PURE__ */ jsx(TableCell, { children: /* @__PURE__ */ jsx(SkeletonPropertyComponent, {
				property: properties[key],
				size: "medium"
			}) }, `table-cell-${key}`)) }, `table_${value}_${index}`);
		}) })
	});
}
function renderArrayOfStrings() {
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-col gap-2",
		children: [0, 1].map((value, index) => renderSkeletonText(index))
	});
}
function renderArrayEnumTableCell() {
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-col gap-2",
		children: [0, 1].map((value, index) => /* @__PURE__ */ jsx(Fragment, { children: renderSkeletonText(index) }))
	});
}
function renderGenericArrayCell(property, index = 0) {
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-col gap-2",
		children: [0, 1].map((value, index) => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(SkeletonPropertyComponent, {
			property,
			size: "medium"
		}, `i_${index}`) }))
	}, "array_index_" + index);
}
function renderSkeletonImageThumbnail(size) {
	const imageSize = size === "small" ? 40 : size === "medium" ? 100 : 200;
	return /* @__PURE__ */ jsx(Skeleton, {
		width: imageSize,
		height: imageSize
	});
}
function renderReference() {
	return /* @__PURE__ */ jsx(Skeleton, {
		width: 200,
		height: 100
	});
}
function renderUrlComponent(property, size = "large") {
	if (typeof property.admin?.urlPreview === "boolean") return /* @__PURE__ */ jsxs("div", {
		style: { display: "flex" },
		children: [renderSkeletonIcon(), renderSkeletonText()]
	});
	return renderUrlFile(size);
}
function renderUrlFile(size) {
	return /* @__PURE__ */ jsx("div", {
		className: `w-${getThumbnailMeasure(size)} h-${getThumbnailMeasure(size)}`,
		children: renderSkeletonIcon()
	});
}
function renderSkeletonText(index, width = 120) {
	return /* @__PURE__ */ jsx(Skeleton, { width }, `skeleton_${index}`);
}
function renderSkeletonCaptionText(index) {
	return /* @__PURE__ */ jsx(Skeleton, { height: 20 });
}
function renderSkeletonIcon() {
	return /* @__PURE__ */ jsx(Skeleton, {
		width: 24,
		height: 24
	});
}
//#endregion
//#region src/preview/components/StorageThumbnail.tsx
/**
* @group Preview components
*/
var StorageThumbnail = React.memo(StorageThumbnailInternal, areEqual$1);
function areEqual$1(prevProps, nextProps) {
	return prevProps.size === nextProps.size && prevProps.storagePathOrDownloadUrl === nextProps.storagePathOrDownloadUrl && prevProps.storeUrl === nextProps.storeUrl && prevProps.interactive === nextProps.interactive && prevProps.fill === nextProps.fill && prevProps.storageSourceKey === nextProps.storageSourceKey;
}
var URL_CACHE = {};
/**
* The signed-URL request currently in flight for a given cache key.
*
* A collection view draws one thumbnail per row and rows share images far more
* often than not — the demo's 200 blog posts are illustrated by 20 hero images.
* Every one of those thumbnails mounts in the same tick, and each used to call
* `getSignedUrl` on its own: {@link URL_CACHE} is only written when a response
* *lands*, so it is still empty while the burst goes out and dedupes nothing.
* The result was five or more identical requests per distinct file, and minting
* a download token is a real request — `/api/storage/metadata/<path>` — against
* a rate-limited surface. One page view was enough to exhaust the budget and
* every thumbnail on the screen then failed with a 429.
*
* Sharing the promise collapses that burst to one request per file. It
* deliberately does not extend how long anything is cached: `DownloadConfig.url`
* is temporal, so a later mount still refetches exactly as it did before.
*/
var IN_FLIGHT = /* @__PURE__ */ new Map();
function getSignedUrlOnce(storage, path, cacheKey) {
	const existing = IN_FLIGHT.get(cacheKey);
	if (existing) return existing;
	const request = storage.getSignedUrl(path).finally(() => {
		IN_FLIGHT.delete(cacheKey);
	});
	IN_FLIGHT.set(cacheKey, request);
	return request;
}
function StorageThumbnailInternal({ storeUrl, interactive, storagePathOrDownloadUrl, size, fill, storageSourceKey }) {
	const { t } = useTranslation();
	const [error, setError] = React.useState(void 0);
	const defaultStorage = useStorageSource();
	const storage = resolveStorageSource({
		sourceKey: storageSourceKey,
		sources: useStorageSources().sources,
		defaultSource: defaultStorage
	});
	const cacheKey = `${storageSourceKey ?? ""}::${storagePathOrDownloadUrl}`;
	const [downloadConfig, setDownloadConfig] = React.useState(URL_CACHE[cacheKey]);
	useEffect(() => {
		if (!storagePathOrDownloadUrl) return;
		let unmounted = false;
		getSignedUrlOnce(storage, storagePathOrDownloadUrl, cacheKey).then(function(downloadConfig) {
			if (!unmounted) {
				setDownloadConfig(downloadConfig);
				URL_CACHE[cacheKey] = downloadConfig;
			}
		}).catch(setError);
		return () => {
			unmounted = true;
		};
	}, [storagePathOrDownloadUrl, cacheKey]);
	if (!storagePathOrDownloadUrl) return null;
	const filetype = downloadConfig?.metadata ? getFiletype(downloadConfig?.metadata.contentType) : void 0;
	const previewType = filetype?.startsWith("image") ? "image" : filetype?.startsWith("video") ? "video" : filetype?.startsWith("audio") ? "audio" : "file";
	if (downloadConfig?.fileNotFound) return /* @__PURE__ */ jsx(FileNotFoundThumbnail, {
		message: t("file_not_found"),
		size,
		fill
	});
	return downloadConfig?.url ? /* @__PURE__ */ jsx(UrlComponentPreview, {
		previewType,
		url: downloadConfig.url,
		interactive,
		size,
		fill,
		hint: storagePathOrDownloadUrl
	}) : fill ? /* @__PURE__ */ jsx(Skeleton, { className: "w-full h-full" }) : renderSkeletonImageThumbnail(size);
}
/**
* The placeholder for a path the storage source answered 404 for.
*
* It occupies the box the image would have — the card's whole 4:3 thumbnail
* when `fill`, otherwise the same measure as the skeleton it replaces — and
* centres its contents in it. This was `ErrorView`, which is a
* left-aligned block with a red triangle and `m-2` around it: laid over a card
* thumbnail it sat in the top-left corner with the icon colliding with the
* text, and a grid of them read as a page of errors rather than as missing
* pictures. A file that is not there is the same absence `ImagePreview`
* already draws for an image that fails to load, so it is drawn the same way.
*
* At `small` the box is 40px and no label fits, so the message becomes the
* tooltip instead of being clipped.
*/
function FileNotFoundThumbnail({ message, size, fill }) {
	const measure = fill ? void 0 : getThumbnailMeasure(size);
	const labelled = fill || size !== "small";
	const body = /* @__PURE__ */ jsxs("div", {
		className: cls("flex flex-col items-center justify-center gap-1 text-center overflow-hidden", "bg-surface-raised rounded-md p-2", fill ? "w-full h-full" : ""),
		style: measure === void 0 ? void 0 : {
			width: measure,
			height: measure,
			maxHeight: "100%"
		},
		children: [/* @__PURE__ */ jsx(ImageOffIcon, {
			size: labelled ? iconSize.small : iconSize.smallest,
			className: "shrink-0 text-surface-400 dark:text-surface-500"
		}), labelled && /* @__PURE__ */ jsx(Typography, {
			variant: "caption",
			color: "secondary",
			className: "max-w-full line-clamp-2 leading-tight",
			children: message
		})]
	});
	return labelled ? body : /* @__PURE__ */ jsx(Tooltip, {
		title: message,
		children: body
	});
}
function getFiletype(input) {
	if (input.startsWith("image")) return "image/*";
	else if (input.startsWith("video")) return "video/*";
	else if (input.startsWith("audio")) return "audio/*";
	else if (input.startsWith("application")) return "application/*";
	else if (input.startsWith("text")) return "text/*";
	else if (input.startsWith("font")) return "font/*";
	else return input;
}
//#endregion
//#region src/preview/components/EnumValuesChip.tsx
/**
* @group Preview components
*/
function EnumValuesChip({ enumValues, enumKey, size, className, children }) {
	if (!enumValues) return null;
	const enumValuesConfig = enumToObjectEntries(enumValues);
	const label = buildEnumLabel(enumKey !== void 0 ? getLabelOrConfigFrom(enumValuesConfig, enumKey) : void 0);
	return /* @__PURE__ */ jsxs(Chip, {
		className,
		colorScheme: getColorScheme(enumValuesConfig, enumKey),
		error: !label,
		outlined: false,
		size,
		children: [children, !children && (label !== void 0 ? label : String(enumKey))]
	});
}
//#endregion
//#region src/preview/compact_text.ts
/**
* Turning block content into the one line a compact preview has room for.
*
* A preview slot inside a card is a single line that cannot grow. Rendering
* Markdown there does not produce a small version of the document — it
* produces the whole document, headings and lists included, inside a 44px box.
* These helpers take the opening line instead, which is what a person reads
* off a card anyway.
*/
/** Longer than any card line; the cap only keeps the DOM node small. */
var DEFAULT_MAX_LENGTH = 280;
var FENCED_CODE = /```[\s\S]*?```|~~~[\s\S]*?~~~/g;
var HTML_TAG = /<[^>]*>/g;
var IMAGE = /!\[([^\]]*)\]\([^)]*\)/g;
var LINK = /\[([^\]]*)\]\([^)]*\)/g;
var REFERENCE_LINK = /\[([^\]]*)\]\[[^\]]*\]/g;
var HEADING = /^\s{0,3}#{1,6}\s+/gm;
var BLOCKQUOTE = /^\s{0,3}>\s?/gm;
var LIST_MARKER = /^\s*(?:[-*+]|\d+[.)])\s+/gm;
var THEMATIC_BREAK = /^\s{0,3}(?:[-*_]\s*){3,}$/gm;
var TABLE_PIPE = /[|]/g;
var EMPHASIS = /(\*\*|__|\*|_|~~|`)/g;
/**
* The readable text of a Markdown document, as one line.
*
* Deliberately a lexical strip rather than a parse: this runs once per preview
* cell in a table that can hold hundreds, and the result is truncated to a line
* regardless, so the cost of being exactly right is not worth paying. Anything
* it fails to strip degrades to a stray `*`, never to a broken layout.
*/
function markdownToPlainText(source, maxLength = DEFAULT_MAX_LENGTH) {
	if (!source) return "";
	return collapseToSingleLine(source.replace(FENCED_CODE, " ").replace(IMAGE, "$1").replace(LINK, "$1").replace(REFERENCE_LINK, "$1").replace(THEMATIC_BREAK, " ").replace(HEADING, "").replace(BLOCKQUOTE, "").replace(LIST_MARKER, "").replace(HTML_TAG, "").replace(TABLE_PIPE, " ").replace(EMPHASIS, ""), maxLength);
}
/**
* Whitespace — including the newlines that would otherwise let a `truncate`
* container grow — collapsed to single spaces, capped to `maxLength`.
*/
function collapseToSingleLine(source, maxLength = DEFAULT_MAX_LENGTH) {
	if (!source) return "";
	const collapsed = source.replace(/\s+/g, " ").trim();
	if (collapsed.length <= maxLength) return collapsed;
	const cut = collapsed.slice(0, maxLength);
	if (collapsed[maxLength] === " ") return cut.trimEnd() + "…";
	const lastSpace = cut.lastIndexOf(" ");
	return (lastSpace > maxLength * .6 ? cut.slice(0, lastSpace) : cut).trimEnd() + "…";
}
//#endregion
//#region src/preview/property_previews/StringPropertyPreview.tsx
/**
* @group Preview components
*/
function StringPropertyPreview({ propertyKey, value, property, size, textOnly, compact }) {
	const strValue = value;
	if (property.enum) return /* @__PURE__ */ jsx(EnumValuesChip, {
		enumKey: strValue,
		enumValues: property.enum,
		size
	});
	else if (property.admin?.previewAsTag) return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(Chip, {
		colorScheme: getColorSchemeForSeed(propertyKey ?? ""),
		size,
		children: strValue
	}) });
	else if (property.admin?.urlPreview || property.url) return /* @__PURE__ */ jsx(UrlComponentPreview, {
		size,
		url: strValue,
		previewType: typeof property.admin?.urlPreview === "string" ? property.admin?.urlPreview : void 0
	});
	else {
		if (!strValue) return /* @__PURE__ */ jsx(Fragment, {});
		if (textOnly || compact) {
			const singleLine = collapseToSingleLine(strValue);
			return size === "small" ? /* @__PURE__ */ jsx("span", {
				className: "text-sm",
				children: singleLine
			}) : /* @__PURE__ */ jsx(Fragment, { children: singleLine });
		}
		return strValue.includes("\n") ? /* @__PURE__ */ jsx("div", {
			className: cls("whitespace-pre-line line-clamp-3 overflow-hidden", size === "small" ? "text-sm" : ""),
			children: strValue
		}) : size === "small" ? /* @__PURE__ */ jsx("span", {
			className: "text-sm",
			children: strValue
		}) : /* @__PURE__ */ jsx(Fragment, { children: strValue });
	}
}
//#endregion
//#region src/preview/property_previews/ArrayPropertyPreview.tsx
/**
* @group Preview components
*/
function ArrayPropertyPreview({ propertyKey, value, property, size, compact }) {
	if (property.type !== "array") throw Error("Picked wrong preview component ArrayPreview");
	if (!property.of) throw Error(`You need to specify an 'of' prop (or specify a custom field) in your array property ${propertyKey}`);
	const authController = useAuthController();
	const resolvedProperties = resolveArrayProperties({
		propertyKey,
		property,
		propertyConfigs: useCustomizationController().propertyConfigs,
		authController
	});
	const values = value;
	if (!values) return null;
	if (compact) return /* @__PURE__ */ jsx("span", {
		className: "text-sm truncate",
		children: values.length === 1 ? "1 item" : `${values.length} items`
	});
	const childSize = size === "medium" ? "medium" : "small";
	return /* @__PURE__ */ jsx("div", {
		className: "w-full flex flex-col gap-2",
		children: values && values.map((val, index) => {
			if (!resolvedProperties) throw Error("Property resolvedProperties is undefined");
			const of = resolvedProperties[index] ?? resolvedProperties[index] ?? (Array.isArray(property.of) ? property.of[index] : property.of);
			return of ? /* @__PURE__ */ jsx(React.Fragment, { children: /* @__PURE__ */ jsx("div", {
				className: cls(defaultBorderMixin, "m-1 border-b last:border-b-0"),
				children: /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(PropertyPreview, {
					propertyKey,
					value: val,
					property: of,
					size: childSize
				}) })
			}) }, "preview_array_" + index) : null;
		})
	});
}
//#endregion
//#region src/util/previews.ts
/**
* The property that fills the title slot for a collection.
*
* Ranking lives in `@rebasepro/common` so every surface (list rows, cards,
* board cards, detail header, relation chips) agrees on what an entity is
* called. Identifiers are excluded from the property *schema* — primary keys,
* foreign keys, UUID columns — not from the key name.
*/
function getEntityTitlePropertyKey(collection) {
	return getTitlePropertyKey(collection);
}
/**
* Same as {@link getEntityTitlePropertyKey}, but skips candidates that carry
* no readable value for this particular entity (empty, or an opaque id).
*/
function getEntityTitlePropertyKeyForEntity(collection, values, entityId) {
	return getTitlePropertyKeyForValues(collection, values, entityId);
}
/**
* True when a property key points at a user picker, whose stored value is an
* auth user id that has to be resolved before it can be displayed.
*/
function isUserSelectProperty(collection, propertyKey) {
	if (!propertyKey) return false;
	const property = collection.properties[propertyKey];
	if (!property || isPropertyBuilder(property)) return false;
	const prop = property;
	return prop.type === "string" && Boolean(prop.userSelect);
}
/**
* Attempt to turn a title value (which might be a relation, reference, date, array, or other complex object)
* into a renderable, human-readable string.
*/
function resolveTitleToString(title) {
	if (title === null || title === void 0) return "";
	if (typeof title !== "object") return String(title);
	if ("__type" in title && title.__type === "relation") {
		if (title.data && title.data.values) {
			const values = title.data.values;
			for (const key of [
				"name",
				"title",
				"label",
				"displayName"
			]) if (values[key] !== void 0 && values[key] !== null) return String(values[key]);
			for (const val of Object.values(values)) if (typeof val === "string" && val.length > 0 && val.length < 200) return val;
		}
		if (title.id !== void 0 && title.id !== null) return String(title.id);
	}
	if ("isEntityReference" in title && typeof title.isEntityReference === "function" && title.isEntityReference()) return String(title.id);
	if ("id" in title && "path" in title && !("__type" in title)) return String(title.id);
	if (title instanceof Date) return title.toLocaleDateString();
	if ("name" in title && title.name !== void 0 && title.name !== null && typeof title.name !== "object") return String(title.name);
	if ("title" in title && title.title !== void 0 && title.title !== null && typeof title.title !== "object") return String(title.title);
	if ("label" in title && title.label !== void 0 && title.label !== null && typeof title.label !== "object") return String(title.label);
	if ("id" in title && title.id !== void 0 && title.id !== null && typeof title.id !== "object") return String(title.id);
	try {
		const str = String(title);
		if (str !== "[object Object]") return str;
		return JSON.stringify(title);
	} catch {
		return "";
	}
}
//#endregion
//#region src/hooks/useResolvedUsers.ts
var caches = /* @__PURE__ */ new Map();
function getCache(baseUrl) {
	let cache = caches.get(baseUrl);
	if (!cache) {
		cache = {
			users: /* @__PURE__ */ new Map(),
			pending: /* @__PURE__ */ new Map(),
			queue: /* @__PURE__ */ new Set()
		};
		caches.set(baseUrl, cache);
	}
	return cache;
}
async function fetchUsers(apiBase, ids, token) {
	const resolved = /* @__PURE__ */ new Map();
	for (const id of ids) resolved.set(id, null);
	const params = new URLSearchParams({ ids: ids.join(",") });
	const response = await fetch(`${apiBase}/admin/users?${params}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
	if (!response.ok) return resolved;
	const data = await response.json();
	const rows = data.users ?? data.data ?? [];
	for (const row of rows) {
		const uid = row.uid ?? row.id;
		if (!uid) continue;
		resolved.set(uid, {
			uid,
			email: row.email ?? "",
			displayName: row.displayName ?? row.display_name ?? null,
			photoURL: row.photoURL ?? row.photo_url ?? null,
			providerId: "custom",
			isAnonymous: false,
			roles: row.roles ?? []
		});
	}
	return resolved;
}
function requestUser(baseUrl, uid, getAuthToken) {
	const cache = getCache(baseUrl);
	const existing = cache.pending.get(uid);
	if (existing) return existing;
	cache.queue.add(uid);
	const promise = new Promise((resolve, reject) => {
		if (cache.flush) clearTimeout(cache.flush);
		cache.flush = setTimeout(async () => {
			const ids = [...cache.queue];
			cache.queue.clear();
			cache.flush = void 0;
			try {
				const resolved = await fetchUsers(baseUrl, ids, await getAuthToken?.());
				for (const id of ids) {
					cache.users.set(id, resolved.get(id) ?? null);
					cache.pending.delete(id);
				}
				resolve();
			} catch (error) {
				for (const id of ids) cache.pending.delete(id);
				reject(error);
			}
		}, 0);
	});
	cache.pending.set(uid, promise);
	return promise;
}
/**
* The auth user behind a `userSelect` value, or `null` while it is loading or
* when it cannot be resolved.
*/
function useResolvedUser(uid) {
	const client = useRebaseClient();
	const { getAuthToken } = useAuthController();
	const baseUrl = apiBaseOf(client);
	const [user, setUser] = useState(() => baseUrl && uid ? getCache(baseUrl).users.get(uid) ?? null : null);
	useEffect(() => {
		if (!baseUrl || !uid) {
			setUser(null);
			return;
		}
		const cache = getCache(baseUrl);
		if (cache.users.has(uid)) {
			setUser(cache.users.get(uid) ?? null);
			return;
		}
		let active = true;
		requestUser(baseUrl, uid, getAuthToken).then(() => {
			if (active) setUser(getCache(baseUrl).users.get(uid) ?? null);
		}).catch(() => {
			if (active) setUser(null);
		});
		return () => {
			active = false;
		};
	}, [
		baseUrl,
		uid,
		getAuthToken
	]);
	return user;
}
/** Human-readable label for a resolved user. */
function getUserLabel(user) {
	return user.displayName || user.email || user.uid;
}
//#endregion
//#region src/hooks/useEntityDisplay.tsx
/**
* One shared store, so every surface agrees on a record and resolves it once.
*
* Module-level rather than a provider: two app instances on one page share a
* cache keyed by collection path and record id, which *is* the same record.
* Nothing here is user-specific — a resolver that reads per-user data must
* invalidate on sign-out, which {@link useEntityDisplayCache} exposes.
*/
var sharedCache;
/**
* The store behind {@link useEntityDisplay}, for invalidating after a write.
*
* Built on first use rather than at module scope. Importing a module should not
* construct anything: it runs during SSR where there is nothing to cache, and it
* made this module unimportable from any test that stubs `@rebasepro/app` —
* which several do, and which is a legitimate thing for them to do.
*/
function useEntityDisplayCache() {
	if (!sharedCache) sharedCache = new EntityDisplayCache();
	return sharedCache;
}
/**
* What fills one display role of one record.
*
* This is the only implementation. Before it there were seven for the title
* alone — the identity bar, the detail header, inline previews, reference cards,
* list slots, relation chips and the headless view — each re-deriving it from
* `collection.properties` and disagreeing about the answer.
*
* Resolution order, per role:
*
* 1. `admin.display[role]` as a **resolver** — awaited, cached per record and
*    role, with the derived value showing meanwhile so nothing flickers empty.
* 2. `admin.display[role]` as a **property path** (or, for the title, the
*    deprecated `titleProperty`).
* 3. The **derived** answer: for the title, the best-ranked property carrying a
*    readable value; for the rest, today's per-role heuristics.
*
* A user-picker title resolves to the person behind the id, as it always did —
* that path is now here rather than in two of the seven.
*/
function useEntityDisplay(role, { collection, entity, values: valuesProp, enabled = true }) {
	const context = useRebaseContext();
	const cache = useEntityDisplayCache();
	const values = valuesProp ?? entity?.values;
	const declaredKey = collection ? getDisplayPropertyKey(collection, role) : void 0;
	const propertyKey = collection && role === "title" && !declaredKey ? getEntityTitlePropertyKeyForEntity(collection, values, entity?.id) : declaredKey;
	const rawValue = values && propertyKey ? getValueInPath(values, propertyKey) : void 0;
	const titleUser = useResolvedUser(collection && role === "title" && isUserSelectProperty(collection, propertyKey) && typeof rawValue === "string" ? rawValue : void 0);
	const derived = useMemo(() => {
		if (titleUser) return getUserLabel(titleUser);
		if (rawValue === void 0 || rawValue === null) return void 0;
		if (role === "title" || role === "subtitle" || role === "status") return resolveTitleToString(rawValue) || void 0;
		return rawValue;
	}, [
		titleUser,
		rawValue,
		role
	]);
	const resolver = collection ? getDisplayResolver(collection, role) : void 0;
	const canResolve = Boolean(enabled && resolver && entity);
	const key = entity ? entityDisplayKey(entity.path, entity.id, role) : void 0;
	const resolved = useSyncExternalStore((cb) => cache.subscribe(cb), () => canResolve && key ? cache.peek(key) : void 0, () => void 0);
	const loading = Boolean(canResolve && key && resolved === void 0);
	useEffect(() => {
		if (!canResolve || !key || !resolver || !entity) return;
		if (cache.peek(key) !== void 0) return;
		cache.resolve(key, () => resolver({
			entity,
			context
		})).catch(() => {});
	}, [
		cache,
		canResolve,
		key,
		resolver,
		entity,
		context,
		role
	]);
	const value = (canResolve && resolved !== null ? resolved : void 0) ?? derived;
	return useMemo(() => ({
		value,
		loading,
		source: collection && propertyKey && value === derived && derived !== void 0 ? {
			key: propertyKey,
			property: getPropertyInPath(collection.properties, propertyKey),
			value: rawValue
		} : void 0
	}), [
		value,
		loading,
		propertyKey,
		derived,
		collection,
		rawValue
	]);
}
/**
* Every display role of a record at once — what a list row, a card or a board
* card needs, in one call rather than six.
*
* The role list is iterated from {@link ENTITY_DISPLAY_ROLES} so the hook order
* is fixed and adding a role does not mean editing every caller.
*/
function useEntityDisplayValues(params) {
	const title = useEntityDisplay("title", params);
	const subtitle = useEntityDisplay("subtitle", params);
	const image = useEntityDisplay("image", params);
	const status = useEntityDisplay("status", params);
	const date = useEntityDisplay("date", params);
	const tags = useEntityDisplay("tags", params);
	return useMemo(() => ({
		title,
		subtitle,
		image,
		status,
		date,
		tags,
		loading: title.loading || subtitle.loading || image.loading || status.loading || date.loading || tags.loading
	}), [
		title,
		subtitle,
		image,
		status,
		date,
		tags
	]);
}
/**
* What the record is called — the one role asked for often enough on its own to
* deserve a name.
*/
function useEntityTitle(params) {
	return useEntityDisplay("title", params);
}
//#endregion
//#region src/components/CollectionViewBinding/usePreviewSlots.ts
/** Whether an authored relation yields many rows. Derived from its kind. */
function relationCardinality$4(relation) {
	if (!relation) return void 0;
	if (relation.kind === "via") return relation.cardinality;
	if (relation.kind === "hasMany" || relation.kind === "manyToMany") return "many";
	if (relation.kind === "belongsTo" || relation.kind === "hasOne") return "one";
	return relation.cardinality;
}
/**
* Resolve which property key fills each slot for a given collection.
* Pure function — call inside `useMemo`.
*/
function resolveCollectionSlotKeys(collection, authController, propertyConfigs) {
	const rankedCandidates = getTitlePropertyCandidates(collection);
	const leadingRelationKey = getLeadingRelationTitleKey(collection);
	const titleKeyCandidates = leadingRelationKey ? [leadingRelationKey, ...rankedCandidates.filter((key) => key !== leadingRelationKey)] : rankedCandidates;
	const titleKey = titleKeyCandidates[0];
	const imageKey = getEntityImagePreviewPropertyKey(collection);
	let statusKey = getDisplayPropertyKey(collection, "status");
	if (!statusKey && collection.previewProperties) for (const key of collection.previewProperties) {
		const p = collection.properties[key];
		if (p?.type === "string" && "enum" in p && p.enum && key !== titleKey) {
			statusKey = key;
			break;
		}
	}
	if (!statusKey && collection.propertiesOrder) {
		for (const key of collection.propertiesOrder) if (typeof key === "string" && !key.startsWith("subcollection:")) {
			const p = collection.properties[key];
			if (p?.type === "string" && "enum" in p && p.enum && key !== titleKey) {
				statusKey = key;
				break;
			}
		}
	}
	if (!statusKey) for (const [key, prop] of Object.entries(collection.properties)) {
		const p = prop;
		if (p.type === "string" && "enum" in p && p.enum && key !== titleKey) {
			statusKey = key;
			break;
		}
	}
	let dateKey = getDisplayPropertyKey(collection, "date");
	const dateCandidates = [
		"updated_at",
		"updatedAt",
		"modified_at",
		"modifiedAt",
		"created_at",
		"createdAt"
	];
	if (!dateKey) {
		for (const candidate of dateCandidates) if (collection.properties[candidate]) {
			dateKey = candidate;
			break;
		}
	}
	if (!dateKey) {
		for (const [key, prop] of Object.entries(collection.properties)) if (prop.type === "date") {
			dateKey = key;
			break;
		}
	}
	const hasExplicitOrder = !!collection.propertiesOrder;
	const relationKeys = [];
	if (!hasExplicitOrder) {
		for (const [key, prop] of Object.entries(collection.properties)) if (prop.type === "relation" && key !== titleKey) relationKeys.push(key);
	}
	const excludeKeys = /* @__PURE__ */ new Set([
		titleKey,
		imageKey,
		statusKey,
		dateKey,
		...relationKeys
	]);
	const previewKeys = getEntityPreviewKeys(authController, collection, propertyConfigs, void 0, 10).filter((k) => !excludeKeys.has(k) && k !== "id");
	const sortedPreviewKeys = hasExplicitOrder ? previewKeys : [...previewKeys].sort((a, b) => {
		const propA = collection.properties[a];
		const propB = collection.properties[b];
		const scoreA = propA?.type === "string" ? propA.admin?.multiline ? 2 : 1 : 0;
		return (propB?.type === "string" ? propB.admin?.multiline ? 2 : 1 : 0) - scoreA;
	});
	return {
		titleKey,
		titleKeyCandidates,
		imageKey,
		subtitleKey: getDisplayPropertyKey(collection, "subtitle") ?? (sortedPreviewKeys.length > 0 ? sortedPreviewKeys[0] : void 0),
		relationKeys,
		statusKey,
		dateKey,
		tagsKey: getDisplayPropertyKey(collection, "tags")
	};
}
/**
* Unwrap image property + value from potential array-of-images.
* Returns `{ property, value }` where property is the *inner* property
* and value is the first element (for arrays) or the raw value.
*/
function resolveImageSlot(collection, imageKey, entity) {
	const imageProperty = collection.properties[imageKey];
	if (!imageProperty) return void 0;
	const ofProp = "of" in imageProperty ? imageProperty.of : void 0;
	const resolvedProperty = ofProp ? Array.isArray(ofProp) ? ofProp[0] : ofProp : imageProperty;
	const rawValue = getValueInPath(entity.values, imageKey);
	const resolvedValue = ofProp ? (rawValue ?? []).length > 0 ? rawValue[0] : void 0 : rawValue;
	if (resolvedValue === void 0 || resolvedValue === null) return void 0;
	return {
		role: "image",
		property: resolvedProperty,
		propertyKey: imageKey,
		value: resolvedValue
	};
}
/**
* Walk the collection's ranked title candidates and return the first one that
* holds something a person can read for this entity. Candidates are already
* ordered and free of identifier properties; this only rejects values —
* empties, and strings that turn out to be an id at runtime.
*/
function resolveEntityTitleKey(entity, candidates) {
	for (const key of candidates) {
		const value = getValueInPath(entity.values, key);
		if (value === void 0 || value === null || value === "") continue;
		if (typeof value === "string") {
			if (looksLikeIdentifierValue(value)) continue;
			if (value === String(entity.id)) continue;
		}
		return key;
	}
	return candidates[0];
}
function formatDateValue$1(value) {
	if (!value) return "";
	const date = value instanceof Date ? value : new Date(value);
	if (isNaN(date.getTime())) return String(value);
	const now = /* @__PURE__ */ new Date();
	const relative = formatRelativeTime(date, { now });
	if (relative) return relative;
	return date.toLocaleDateString(void 0, {
		month: "short",
		day: "numeric",
		year: date.getFullYear() !== now.getFullYear() ? "numeric" : void 0
	});
}
/**
* Resolves which property key fills each preview slot for a collection.
* Memoized — only recomputes when the collection definition changes.
*
* Use this in the parent list/grid component, then pass the result to
* `resolveEntitySlots` for each entity row.
*/
function useCollectionSlotKeys(collection, authController, propertyConfigs) {
	return useMemo(() => resolveCollectionSlotKeys(collection, authController, propertyConfigs), [
		collection,
		authController,
		propertyConfigs
	]);
}
/**
* Resolve concrete slot values for a single entity.
* This is a pure function (no hooks) so it can be called inside
* `React.memo` render functions or loops without violating hook rules.
*/
function resolveEntitySlots(entity, collection, slotKeys) {
	const { titleKey, titleKeyCandidates, imageKey, subtitleKey, relationKeys, statusKey, dateKey, tagsKey } = slotKeys;
	const image = imageKey ? resolveImageSlot(collection, imageKey, entity) : void 0;
	const resolvedTitleKey = resolveEntityTitleKey(entity, titleKeyCandidates ?? (titleKey ? [titleKey] : []));
	let title;
	if (resolvedTitleKey) {
		const prop = collection.properties[resolvedTitleKey];
		const val = getValueInPath(entity.values, resolvedTitleKey);
		if (prop) title = {
			role: "title",
			property: prop,
			propertyKey: resolvedTitleKey,
			value: val
		};
	}
	let subtitle;
	if (subtitleKey && subtitleKey !== resolvedTitleKey) {
		const prop = collection.properties[subtitleKey];
		const val = getValueInPath(entity.values, subtitleKey);
		if (prop && val !== void 0 && val !== null && val !== "") subtitle = {
			role: "subtitle",
			property: prop,
			propertyKey: subtitleKey,
			value: val
		};
	}
	const relations = [];
	const MAX_CHIPS_PER_RELATION = 3;
	for (const relKey of relationKeys) {
		const prop = collection.properties[relKey];
		if (!prop || prop.type !== "relation") continue;
		const val = getValueInPath(entity.values, relKey);
		if (val === void 0 || val === null) continue;
		const items = [];
		let totalCount = 0;
		const isMany = relationCardinality$4(prop.relation) === "many";
		if (isMany && Array.isArray(val)) {
			totalCount = val.length;
			for (let i = 0; i < Math.min(val.length, MAX_CHIPS_PER_RELATION); i++) {
				const rel = val[i];
				if (rel && typeof rel === "object") {
					const displayName = resolveRelationDisplayName(rel, prop);
					const id = rel.id ?? i;
					if (displayName) items.push({
						displayName,
						id
					});
				}
			}
		} else if (!isMany && val && typeof val === "object") {
			const obj = val;
			if ("__type" in obj && obj.__type === "relation" || typeof obj.isEntityRelation === "function" && obj.isEntityRelation()) {
				const relation = obj;
				const displayName = resolveRelationDisplayName(relation, prop);
				totalCount = 1;
				if (displayName) items.push({
					displayName,
					id: relation.id
				});
			}
		}
		if (items.length > 0) {
			const colorScheme = CHIP_COLORS[CHIP_SEED_KEYS[relationKeys.indexOf(relKey) % CHIP_SEED_KEYS.length]];
			relations.push({
				property: prop,
				propertyKey: relKey,
				label: prop.name || relKey,
				items,
				totalCount,
				colorScheme
			});
		}
	}
	let status;
	if (statusKey) {
		const prop = collection.properties[statusKey];
		const val = getValueInPath(entity.values, statusKey);
		if (prop && val !== void 0 && val !== null) status = {
			role: "status",
			property: prop,
			propertyKey: statusKey,
			value: val
		};
	}
	let date;
	if (dateKey) {
		const prop = collection.properties[dateKey];
		const val = getValueInPath(entity.values, dateKey);
		if (prop && val !== void 0 && val !== null) date = {
			role: "date",
			property: prop,
			propertyKey: dateKey,
			value: val,
			formatted: formatDateValue$1(val)
		};
	}
	let tags;
	if (tagsKey) {
		const prop = collection.properties[tagsKey];
		const val = getValueInPath(entity.values, tagsKey);
		const empty = val === void 0 || val === null || val === "" || Array.isArray(val) && val.length === 0;
		if (prop && !empty) tags = {
			role: "tags",
			property: prop,
			propertyKey: tagsKey,
			value: val
		};
	}
	return {
		image,
		title,
		subtitle,
		relations,
		status,
		date,
		tags,
		entityId: entity.id
	};
}
/**
* Extract a human-readable display name from an eagerly-loaded EntityRelation.
* Uses the target collection's title property when available, otherwise
* walks the entity values for the first short string.
*/
function resolveRelationDisplayName(relation, prop) {
	const data = "data" in relation ? relation.data : void 0;
	let targetCollection;
	try {
		const resolved = prop.relation?.target?.() ?? (typeof prop.relation?.target === "function" ? prop.relation?.target() : void 0);
		if (resolved && typeof resolved === "object") targetCollection = resolved;
	} catch {}
	const extractDisplayName = (values) => {
		if (targetCollection) for (const key of getTitlePropertyCandidates(targetCollection)) {
			const value = getValueInPath(values, key);
			if (value === void 0 || value === null || value === "") continue;
			if (typeof value === "string" && looksLikeIdentifierValue(value)) continue;
			return String(value);
		}
		for (const [, v] of Object.entries(values)) if (typeof v === "string" && v.length > 0 && v.length < 200) return v;
	};
	if (data && data.values) {
		const result = extractDisplayName(data.values);
		if (result) return result;
	}
	const id = "id" in relation ? relation.id : void 0;
	if (id !== void 0 && targetCollection) try {
		const slug = targetCollection.slug ?? ("table" in targetCollection ? targetCollection.table : void 0);
		if (slug) {
			const cached = getEntityFromCache(`${slug}/${id}`);
			if (cached?.values) {
				const result = extractDisplayName(cached.values);
				if (result) return result;
			}
		}
	} catch {}
	return id !== void 0 ? String(id) : void 0;
}
/**
* The slots for one record, with `admin.display` resolvers applied.
*
* {@link resolveEntitySlots} answers the question from values already in hand —
* which is everything a slot filled by a property needs, and nothing a slot
* filled by a *resolver* can use. A computed title may have to be fetched, so it
* arrives after the first render; this hook is where the two meet.
*
* Until a resolver lands, the derived slot shows. That is deliberate: a list of
* fifty rows must not blank its titles for a beat while fifty promises settle,
* and the derived answer — the best-ranked property carrying a readable value —
* is a reasonable thing to be looking at meanwhile. When the resolved value
* arrives it replaces the slot outright, property and all, because there is no
* property behind a computed value (see {@link PreviewSlot}).
*
* Every role is hooked unconditionally, so the hook order is fixed regardless of
* what a given collection declares.
*/
function useEntitySlots(entity, collection, slotKeys) {
	const derived = useMemo(() => resolveEntitySlots(entity, collection, slotKeys), [
		entity,
		collection,
		slotKeys
	]);
	const params = {
		collection,
		entity
	};
	const title = useEntityDisplay("title", params);
	const subtitle = useEntityDisplay("subtitle", params);
	const image = useEntityDisplay("image", params);
	const status = useEntityDisplay("status", params);
	const date = useEntityDisplay("date", params);
	const tags = useEntityDisplay("tags", params);
	return useMemo(() => {
		const computed = (role, resolved) => resolved.value !== void 0 && resolved.source === void 0 ? {
			role,
			value: resolved.value
		} : void 0;
		const computedDate = computed("date", date);
		return {
			...derived,
			title: computed("title", title) ?? derived.title,
			subtitle: computed("subtitle", subtitle) ?? derived.subtitle,
			image: computed("image", image) ?? derived.image,
			status: computed("status", status) ?? derived.status,
			date: computedDate ? {
				...computedDate,
				formatted: formatDateValue$1(computedDate.value)
			} : derived.date,
			tags: computed("tags", tags) ?? derived.tags
		};
	}, [
		derived,
		title,
		subtitle,
		image,
		status,
		date,
		tags
	]);
}
//#endregion
//#region src/hooks/navigation/contexts/CollectionRegistryContext.tsx
var CollectionRegistryContext = createContext({
	getCollection: () => void 0,
	getRawCollection: () => void 0,
	getParentReferencesFromPath: () => [],
	getParentCollectionSlugs: () => [],
	getParentEntityIds: () => [],
	convertIdsToPaths: () => [],
	initialised: false
});
function useCollectionRegistryController() {
	const context = React.useContext(CollectionRegistryContext);
	if (context === void 0) throw new Error("useCollectionRegistryController must be used within a CollectionRegistryContext.Provider");
	return context;
}
//#endregion
//#region src/hooks/useSidePanel.tsx
var SidePanelControllerContext = React.createContext({});
/**
* Use this hook to retrieve a entity controller that allows you to open
* a side dialog to edit a entity.
*
* @see SidePanelController
* @group Hooks and utilities
*/
var useSidePanel = () => useContext(SidePanelControllerContext);
//#endregion
//#region src/components/EntityPreviewNesting.tsx
/**
* How deep the current entity preview is nested inside another one.
*
* A reference or relation rendered on its own (a form field, a table cell) is
* at depth 0 and gets the full card treatment: image slot, id, title, preview
* properties and a link to the side panel. A reference rendered *inside*
* another entity preview is at depth 1+, where repeating that card produces a
* box-inside-a-box with its own borders, id line and action button. Nested
* previews collapse to a compact chip instead.
*/
var EntityPreviewDepthContext = React$1.createContext(0);
/**
* Current entity preview nesting depth. 0 means "not inside another preview".
*/
function useEntityPreviewDepth() {
	return React$1.useContext(EntityPreviewDepthContext);
}
/**
* True when the preview being rendered lives inside another entity preview,
* and should therefore render its compact variant.
*/
function useIsNestedEntityPreview() {
	return useEntityPreviewDepth() > 0;
}
/**
* Marks its children as being rendered inside an entity preview, so any
* reference or relation below collapses to a chip.
*/
function NestedEntityPreviewBoundary({ children }) {
	const depth = useEntityPreviewDepth();
	return /* @__PURE__ */ jsx(EntityPreviewDepthContext.Provider, {
		value: depth + 1,
		children
	});
}
//#endregion
//#region src/components/EntityPreviewBinding.tsx
/**
* This component contains the main logic and content for displaying a entity preview,
* without any container wrapper. Used internally by EntityPreviewBinding.
*/
function EntityPreviewBindingData({ actions, collection: collectionProp, previewKeys, size = "medium", includeId = true, onSidePanelClick, includeTitle = true, includeEntityLink = true, includeImage = true, entity }) {
	const authController = useAuthController();
	const analyticsController = useAnalyticsController();
	const sidePanelController = useSidePanel();
	const customizationController = useCustomizationController();
	const collectionRegistryController = useCollectionRegistryController();
	const collection = collectionProp ?? collectionRegistryController.getCollection(entity.path);
	const title = useEntityTitle({
		collection,
		entity
	});
	const statedKeys = previewKeys ?? collection?.previewProperties;
	const listProperties = useMemo(() => {
		if (!collection) return [];
		if (statedKeys && statedKeys.length > 0) return statedKeys.filter((key) => getPropertyInPath$1(collection.properties, key));
		const slotKeys = resolveCollectionSlotKeys(collection, authController, customizationController.propertyConfigs);
		return [slotKeys.subtitleKey, slotKeys.statusKey].filter(Boolean);
	}, [
		statedKeys,
		collection,
		authController,
		customizationController.propertyConfigs
	]);
	if (!collection) return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(ErrorView, { error: `Collection not found: ${entity.path}` }) });
	const titleProperty = includeTitle ? title.source?.key : void 0;
	const imagePropertyKey = includeImage ? getEntityImagePreviewPropertyKey(collection) : void 0;
	const imageProperty = imagePropertyKey ? collection.properties[imagePropertyKey] : void 0;
	const ofProp = imageProperty && "of" in imageProperty ? imageProperty.of : void 0;
	const usedImageProperty = ofProp ? Array.isArray(ofProp) ? ofProp[0] : ofProp : imageProperty;
	const restProperties = listProperties.filter((p) => p !== titleProperty && p !== imagePropertyKey);
	const imageValue = imagePropertyKey ? getValueInPath(entity.values, imagePropertyKey) : void 0;
	const usedImageValue = imageProperty !== void 0 ? "of" in imageProperty ? (imageValue ?? []).length > 0 ? imageValue[0] : void 0 : imageValue : void 0;
	return /* @__PURE__ */ jsxs(NestedEntityPreviewBoundary, { children: [
		/* @__PURE__ */ jsxs("div", {
			className: cls("flex shrink-0 overflow-hidden", {
				"w-6 h-6 mx-1 my-0.5": size === "small" || size === "smallest",
				"w-8 h-8 ml-1 mr-2 m-2 self-start": size === "medium",
				"w-10 h-10 ml-2 mr-2 m-2 self-start": size === "large"
			}),
			children: [usedImageProperty && usedImageValue ? /* @__PURE__ */ jsx(PropertyPreview, {
				property: usedImageProperty,
				propertyKey: imagePropertyKey,
				size: "small",
				value: usedImageValue
			}) : null, !usedImageProperty || !usedImageValue ? /* @__PURE__ */ jsx(IconForView, {
				collectionOrView: collection,
				color: "primary",
				size,
				className: "m-auto"
			}) : null]
		}),
		/* @__PURE__ */ jsxs("div", {
			className: "flex flex-col grow w-full m-1 shrink min-w-0 text-text-primary dark:text-text-primary-dark flex-1 mr-2",
			children: [
				includeId && (entity ? /* @__PURE__ */ jsx("div", {
					className: "block whitespace-nowrap overflow-hidden truncate",
					children: /* @__PURE__ */ jsx(Typography, {
						variant: "caption",
						color: "disabled",
						className: "font-mono",
						children: entity.id
					})
				}) : /* @__PURE__ */ jsx(Skeleton, {})),
				includeTitle && (titleProperty || title.value) && /* @__PURE__ */ jsx("div", {
					className: "truncate my-0.5 text-sm font-medium text-text-primary dark:text-text-primary-dark",
					children: !entity && titleProperty ? /* @__PURE__ */ jsx(SkeletonPropertyComponent, {
						property: getPropertyInPath$1(collection.properties, titleProperty),
						size: "medium"
					}) : titleProperty ? /* @__PURE__ */ jsx(PropertyPreview, {
						propertyKey: titleProperty,
						value: title.source?.value,
						property: getPropertyInPath$1(collection.properties, titleProperty),
						size: "medium"
					}) : title.value
				}),
				restProperties && restProperties.map((key) => {
					const childProperty = getPropertyInPath$1(collection.properties, key);
					if (!childProperty) return null;
					const valueInPath = getValueInPath(entity.values, key);
					return /* @__PURE__ */ jsx("div", {
						className: cls("truncate min-w-0 max-h-8 overflow-hidden", restProperties.length > 1 ? "my-0.5" : "my-0"),
						children: entity ? /* @__PURE__ */ jsx(PropertyPreview, {
							propertyKey: key,
							value: valueInPath,
							property: childProperty,
							size: "small"
						}) : /* @__PURE__ */ jsx(SkeletonPropertyComponent, {
							property: childProperty,
							size: "small"
						})
					}, "ref_prev_" + key);
				})
			]
		}),
		entity && includeEntityLink && /* @__PURE__ */ jsx("div", {
			className: "flex-shrink-0",
			children: /* @__PURE__ */ jsx(Tooltip, {
				title: `See details for ${entity.id}`,
				className: "shrink-0",
				children: /* @__PURE__ */ jsx(IconButton, {
					color: "inherit",
					size: "small",
					className: size !== "small" ? "self-start" : "",
					onClick: (e) => {
						e.stopPropagation();
						e.preventDefault();
						onSidePanelClick?.(entity);
						analyticsController.onAnalyticsEvent?.("entity_click_from_reference", {
							path: entity.path,
							entityId: entity.id
						});
						sidePanelController.open({
							entityId: entity.id,
							path: entity.path,
							collection,
							updateUrl: true
						});
					},
					children: /* @__PURE__ */ jsx(ArrowRightToLineIcon, {})
				})
			})
		}),
		actions && /* @__PURE__ */ jsx("div", {
			className: "flex-shrink-0",
			children: actions
		})
	] });
}
/**
* This view is used to display a preview of a entity.
* It is used by default in reference fields and whenever a reference is displayed.
*/
function EntityPreviewBinding({ actions, disabled, hover, collection, previewKeys, onClick, size = "medium", includeId = true, includeTitle = true, includeEntityLink = true, includeImage = true, onSidePanelClick, entity }) {
	return /* @__PURE__ */ jsx(EntityPreviewContainer, {
		onClick: disabled ? void 0 : onClick,
		hover: disabled ? void 0 : hover,
		size,
		children: /* @__PURE__ */ jsx(EntityPreviewBindingData, {
			actions,
			collection,
			previewKeys,
			size,
			includeId,
			includeTitle,
			includeEntityLink,
			includeImage,
			onSidePanelClick,
			entity
		})
	});
}
var EntityPreviewContainer = React$1.forwardRef(({ children, hover, onClick, size = "medium", style, className, fullwidth = true, ...props }, ref) => {
	return /* @__PURE__ */ jsx("div", {
		ref,
		tabIndex: 0,
		style,
		className: cls("bg-surface-card", size === "small" ? "min-h-[32px]" : "min-h-[48px]", fullwidth ? "w-full" : "", "items-center overflow-hidden", hover ? "hover:bg-surface-hover group-hover:bg-surface-hover" : "", size === "small" ? "p-1" : "px-2 py-1", "flex border rounded-lg", onClick ? "cursor-pointer" : "", defaultBorderMixin, className),
		role: onClick ? "button" : void 0,
		onClick: (event) => {
			if (onClick) {
				event.preventDefault();
				onClick(event);
			}
		},
		onKeyDown: (event) => {
			if (onClick && (event.key === "Enter" || event.key === " ")) {
				event.preventDefault();
				onClick(event);
			}
		},
		...props,
		children
	});
});
EntityPreviewContainer.displayName = "EntityPreviewContainer";
//#endregion
//#region src/components/InlineEntityPreview.tsx
var inlineMixin = "inline-flex items-center gap-1 min-w-0 max-w-full align-middle";
/**
* An entity rendered as one line of text: a small link glyph that marks it as
* pointing elsewhere, then the target's title in whatever typography surrounds
* it.
*
* This is what a reference or relation renders as when it is *not* the subject
* of its slot — nested inside another entity preview, or filling a title slot.
* The card treatment (image, id, preview properties, side-panel button) only
* makes sense at the top level; repeating it one level down produces a bordered
* box inside a bordered box, each with its own action buttons.
*
* @group Preview components
*/
function InlineEntityPreview({ entity, collection: collectionProp, label, disabled, onClick, includeEntityLink = true, iconSize = 12, className }) {
	const collectionRegistryController = useCollectionRegistryController();
	const analyticsController = useAnalyticsController();
	const sidePanelController = useSidePanel();
	const collection = collectionProp ?? collectionRegistryController.getCollection(entity.path);
	const { value: title } = useEntityTitle({
		collection,
		entity,
		enabled: Boolean(collection)
	});
	const resolvedLabel = label ?? title ?? String(entity.id);
	const interactive = !disabled && (onClick !== void 0 || includeEntityLink && collection !== void 0);
	const handleClick = (event) => {
		if (!interactive) return;
		event.preventDefault();
		event.stopPropagation();
		if (onClick) {
			onClick(event);
			return;
		}
		analyticsController.onAnalyticsEvent?.("entity_click_from_reference", {
			path: entity.path,
			entityId: entity.id
		});
		sidePanelController.open({
			entityId: entity.id,
			path: entity.path,
			collection,
			updateUrl: true
		});
	};
	const content = /* @__PURE__ */ jsxs("span", {
		tabIndex: interactive ? 0 : void 0,
		role: interactive ? "button" : void 0,
		onClick: interactive ? handleClick : void 0,
		onKeyDown: interactive ? (event) => {
			if (event.key === "Enter" || event.key === " ") handleClick(event);
		} : void 0,
		className: cls(inlineMixin, interactive ? "cursor-pointer hover:underline underline-offset-2" : "", className),
		children: [/* @__PURE__ */ jsx(LinkIcon, {
			size: iconSize,
			className: "shrink-0 opacity-40"
		}), /* @__PURE__ */ jsx("span", {
			className: "truncate",
			children: resolvedLabel
		})]
	});
	if (!interactive) return content;
	return /* @__PURE__ */ jsx(Tooltip, {
		title: `See details for ${resolvedLabel}`,
		asChild: true,
		children: content
	});
}
/**
* Placeholder shown while the target of an inline reference is being fetched.
*/
function InlineEntityPreviewSkeleton({ className }) {
	return /* @__PURE__ */ jsxs("span", {
		className: cls(inlineMixin, className),
		children: [/* @__PURE__ */ jsx(LinkIcon, {
			size: 12,
			className: "shrink-0 opacity-40"
		}), /* @__PURE__ */ jsx(Skeleton, { className: "w-20 h-3" })]
	});
}
/**
* Shown when the target of an inline reference cannot be resolved — a deleted
* row, or a collection that is not registered. Keeps the line readable instead
* of dropping an error box into the middle of a card.
*/
function InlineEntityPreviewMissing({ label, tooltip, className }) {
	const content = /* @__PURE__ */ jsxs("span", {
		className: cls(inlineMixin, "text-text-secondary dark:text-text-secondary-dark", className),
		children: [/* @__PURE__ */ jsx(LinkIcon, {
			size: 12,
			className: "shrink-0 opacity-40"
		}), /* @__PURE__ */ jsx("span", {
			className: "truncate italic",
			children: label
		})]
	});
	if (!tooltip) return content;
	return /* @__PURE__ */ jsx(Tooltip, {
		title: tooltip,
		asChild: true,
		children: content
	});
}
//#endregion
//#region src/preview/components/ReferencePreview.tsx
/**
* @group Preview components
*/
var ReferencePreview = function ReferencePreview(props) {
	const reference = props.reference;
	const nested = useIsNestedEntityPreview();
	if (!(typeof reference === "object" && "isEntityReference" in reference && reference.isEntityReference())) {
		console.warn("Reference preview received value of type", typeof reference);
		if (props.textOnly || nested) return /* @__PURE__ */ jsx("span", { children: String(reference) });
		return /* @__PURE__ */ jsx(EntityPreviewContainer, {
			onClick: props.onClick,
			size: props.size ?? "medium",
			children: /* @__PURE__ */ jsx(ErrorView, {
				error: "Unexpected value. Click to edit",
				tooltip: JSON.stringify(reference)
			})
		});
	}
	return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(ReferencePreviewInternal, { ...props }) });
};
var DefaultMissingReference$2 = () => null;
function ReferencePreviewInternalInner({ disabled, reference, previewProperties, size, hover, onClick, includeEntityLink = true, includeId = true, textOnly, collection }) {
	const ResolvedMissingReference = useComponentOverride("Entity.MissingReference", DefaultMissingReference$2);
	const nested = useIsNestedEntityPreview();
	if (!collection) if (ResolvedMissingReference !== DefaultMissingReference$2) return /* @__PURE__ */ jsx(ResolvedMissingReference, { path: reference.path });
	else {
		if (textOnly) return /* @__PURE__ */ jsx("span", { children: reference.path });
		if (nested) return /* @__PURE__ */ jsx(InlineEntityPreviewMissing, {
			label: String(reference.id),
			tooltip: `Collection not found: ${reference.path}`
		});
		return /* @__PURE__ */ jsx(EntityPreviewContainer, {
			onClick,
			size: size ?? "medium",
			children: /* @__PURE__ */ jsx(ErrorView, {
				error: "Unexpected reference value. Click to edit",
				tooltip: reference.pathWithId
			})
		});
	}
	return /* @__PURE__ */ jsx(ReferencePreviewExisting, {
		reference,
		collection,
		previewProperties,
		size,
		disabled,
		includeEntityLink,
		includeId,
		onClick,
		textOnly,
		hover
	});
}
function ReferencePreviewInternal(props) {
	const collection = useCollectionRegistryController().getCollection(props.reference.path);
	const content = /* @__PURE__ */ jsx(ReferencePreviewInternalInner, {
		...props,
		collection
	});
	if (collection) return /* @__PURE__ */ jsx(CollectionScopeProvider, {
		collection,
		children: content
	});
	return content;
}
function ReferencePreviewExisting({ reference, collection, previewProperties, size, disabled, includeEntityLink, includeId, onClick, hover, textOnly }) {
	const ResolvedEntityPreview = useComponentOverride("EntityPreview", EntityPreviewBinding);
	useCustomizationController();
	const inline = useIsNestedEntityPreview() || Boolean(textOnly) || size === "small";
	const { entity, dataLoading, dataLoadingError } = useFetch({
		path: reference.path,
		entityId: reference.id,
		collection,
		useCache: true
	});
	const usedEntity = entity;
	let body;
	if (!reference) body = /* @__PURE__ */ jsx(ErrorView, { error: "Reference not set" });
	else if (usedEntity && !usedEntity.values) body = /* @__PURE__ */ jsx(ErrorView, {
		error: "Reference does not exist",
		tooltip: reference.path
	});
	if (body) {
		if (inline) return /* @__PURE__ */ jsx(InlineEntityPreviewMissing, {
			label: String(reference.id),
			tooltip: reference.pathWithId
		});
		return /* @__PURE__ */ jsx(EntityPreviewContainer, {
			onClick: disabled ? void 0 : onClick,
			hover: disabled ? void 0 : hover,
			size,
			children: body
		});
	}
	if (dataLoading && !usedEntity) {
		if (inline) return /* @__PURE__ */ jsx(InlineEntityPreviewSkeleton, {});
		return /* @__PURE__ */ jsx(EntityPreviewContainer, {
			onClick: disabled ? void 0 : onClick,
			hover: disabled ? void 0 : hover,
			size,
			children: /* @__PURE__ */ jsx(Skeleton, {})
		});
	}
	if (!usedEntity) {
		if (inline) return /* @__PURE__ */ jsx(InlineEntityPreviewMissing, {
			label: String(reference.id),
			tooltip: "Entity not found"
		});
		return /* @__PURE__ */ jsx(EntityPreviewContainer, {
			onClick: disabled ? void 0 : onClick,
			hover: disabled ? void 0 : hover,
			size,
			children: /* @__PURE__ */ jsx(ErrorView, { error: "Entity not found" })
		});
	}
	if (inline) return /* @__PURE__ */ jsx(InlineEntityPreview, {
		entity: usedEntity,
		collection,
		disabled,
		onClick,
		includeEntityLink: !textOnly && includeEntityLink !== false
	});
	return /* @__PURE__ */ jsx(ResolvedEntityPreview, {
		size,
		previewKeys: previewProperties,
		disabled,
		entity: usedEntity,
		collection,
		onClick,
		includeEntityLink,
		includeId,
		hover
	});
}
//#endregion
//#region src/preview/components/InlineEntityListPreview.tsx
/**
* How many links a nested list shows before collapsing the rest into a count.
*/
var MAX_INLINE_ITEMS = 3;
/**
* One wrapping line of inline entity links, with the overflow collapsed into a
* `+N`. Used for arrays of references or relations that are nested inside
* another preview, where stacking full-width cards turns a card into a wall.
*
* @group Preview components
*/
function InlineEntityListPreview({ items, renderItem, max = MAX_INLINE_ITEMS, className }) {
	if (!items || items.length === 0) return null;
	const shown = items.slice(0, max);
	const overflow = items.length - shown.length;
	return /* @__PURE__ */ jsxs("span", {
		className: cls("inline-flex flex-wrap items-center gap-x-2 gap-y-0.5 min-w-0 max-w-full", className),
		children: [shown.map((item, index) => renderItem(item, index)), overflow > 0 && /* @__PURE__ */ jsxs("span", {
			className: "text-text-secondary dark:text-text-secondary-dark shrink-0",
			children: ["+", overflow]
		})]
	});
}
//#endregion
//#region src/preview/property_previews/ArrayOfReferencesPreview.tsx
/**
* @group Preview components
*/
function ArrayOfReferencesPreview({ propertyKey, value, property, size, textOnly }) {
	const nested = useIsNestedEntityPreview();
	if (Array.isArray(property?.of)) throw Error("Using array properties instead of single one in `of` in ArrayProperty");
	if (property?.type !== "array" || !property.of || property.of.type !== "reference") throw Error("Picked wrong preview component ArrayOfReferencesPreview");
	const childSize = size === "medium" ? "medium" : "small";
	const ofProperty = property.of;
	if (nested || textOnly) return /* @__PURE__ */ jsx(InlineEntityListPreview, {
		items: value ?? [],
		renderItem: (reference, index) => /* @__PURE__ */ jsx(ReferencePreview, {
			disabled: !ofProperty.path,
			previewProperties: ofProperty.admin?.previewProperties,
			size: childSize,
			reference,
			textOnly,
			includeId: ofProperty.admin?.includeId,
			includeEntityLink: ofProperty.admin?.includeEntityLink
		}, `preview_array_ref_${propertyKey}_${index}`)
	});
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-col w-full",
		children: value ? value.map((reference, index) => {
			const ofProperty = property.of;
			return /* @__PURE__ */ jsx("div", {
				className: "mt-1 mb-1 w-full",
				children: /* @__PURE__ */ jsx(ReferencePreview, {
					disabled: !ofProperty.path,
					previewProperties: ofProperty.admin?.previewProperties,
					size: childSize,
					reference,
					includeId: ofProperty.admin?.includeId,
					includeEntityLink: ofProperty.admin?.includeEntityLink
				})
			}, `preview_array_ref_${propertyKey}_${index}`);
		}) : null
	});
}
//#endregion
//#region src/preview/components/RelationPreview.tsx
/**
* Extract a display name from a plain relation-shaped object that isn't
* a proper EntityRelation instance. Tries common name fields in the
* entity's values, then falls back to the id.
*/
function extractDisplayFromPlainObject(obj) {
	if (!obj || typeof obj !== "object") return "—";
	const record = obj;
	const data = record.data;
	if (data && typeof data === "object") {
		const dataRecord = data;
		const values = dataRecord.values && typeof dataRecord.values === "object" ? dataRecord.values : dataRecord;
		for (const field of [
			"name",
			"title",
			"label",
			"display_name",
			"displayName",
			"email",
			"username"
		]) {
			const v = values[field];
			if (v && typeof v === "string") return v;
		}
	}
	for (const field of [
		"name",
		"title",
		"label",
		"display_name",
		"displayName",
		"email"
	]) {
		const v = record[field];
		if (v && typeof v === "string") return v;
	}
	if ("id" in record && record.id != null) return String(record.id);
	return "—";
}
/**
* @group Preview components
*/
var RelationPreview = function RelationPreview(props) {
	const relation = props.relation;
	const nested = useIsNestedEntityPreview();
	if (!(typeof relation === "object" && "isEntityRelation" in relation && relation.isEntityRelation())) {
		console.warn("Relation preview received value of type", typeof relation);
		if (props.textOnly || nested) return /* @__PURE__ */ jsx("span", {
			className: "truncate",
			children: extractDisplayFromPlainObject(relation)
		});
		return /* @__PURE__ */ jsx(EntityPreviewContainer, {
			onClick: props.onClick,
			size: props.size,
			children: /* @__PURE__ */ jsx(ErrorView, {
				error: "Unexpected value. Click to edit",
				tooltip: JSON.stringify(relation)
			})
		});
	}
	return /* @__PURE__ */ jsx(RelationPreviewInternal, { ...props });
};
var DefaultMissingReference$1 = () => null;
function RelationPreviewInternalInner({ disabled, relation, previewProperties, size, hover, onClick, includeEntityLink = true, includeId = true, textOnly, collection }) {
	const ResolvedMissingReference = useComponentOverride("Entity.MissingReference", DefaultMissingReference$1);
	const nested = useIsNestedEntityPreview();
	if (!collection) if (ResolvedMissingReference !== DefaultMissingReference$1) return /* @__PURE__ */ jsx(ResolvedMissingReference, { path: relation.path });
	else {
		if (textOnly) return /* @__PURE__ */ jsx("span", { children: relation.path });
		if (nested) return /* @__PURE__ */ jsx(InlineEntityPreviewMissing, {
			label: String(relation.id),
			tooltip: `Collection not found: ${relation.path}`
		});
		return /* @__PURE__ */ jsx(EntityPreviewContainer, {
			size,
			children: /* @__PURE__ */ jsx(ErrorView, { error: `Collection not found: ${relation.path}` })
		});
	}
	return /* @__PURE__ */ jsx(RelationPreviewExisting, {
		relation,
		collection,
		previewProperties,
		size,
		disabled,
		includeEntityLink,
		includeId,
		onClick,
		textOnly,
		hover
	});
}
function RelationPreviewInternal(props) {
	const collection = useCollectionRegistryController().getCollection(props.relation.path);
	const content = /* @__PURE__ */ jsx(RelationPreviewInternalInner, {
		...props,
		collection
	});
	if (collection) return /* @__PURE__ */ jsx(CollectionScopeProvider, {
		collection,
		children: content
	});
	return content;
}
function RelationPreviewExisting({ relation, collection, previewProperties, size, disabled, includeEntityLink, includeId, onClick, hover, textOnly }) {
	const passedEntity = relation.data;
	const ResolvedEntityPreview = useComponentOverride("EntityPreview", EntityPreviewBinding);
	useCustomizationController();
	const inline = useIsNestedEntityPreview() || Boolean(textOnly) || size === "small";
	const { entity, dataLoading, dataLoadingError } = useFetch({
		path: relation.path,
		entityId: passedEntity ? void 0 : relation.id,
		collection,
		useCache: true
	});
	const usedEntity = passedEntity ?? entity;
	let body;
	if (!relation) body = /* @__PURE__ */ jsx(ErrorView, { error: "Relation not set" });
	else if (usedEntity && !usedEntity.values) body = /* @__PURE__ */ jsx(ErrorView, {
		error: "Relation does not exist",
		tooltip: relation.path
	});
	if (body) {
		if (inline) return /* @__PURE__ */ jsx(InlineEntityPreviewMissing, {
			label: String(relation.id),
			tooltip: relation.pathWithId
		});
		return /* @__PURE__ */ jsx(EntityPreviewContainer, {
			onClick: disabled ? void 0 : onClick,
			hover: disabled ? void 0 : hover,
			size,
			children: body
		});
	}
	if (dataLoading && !usedEntity) {
		if (inline) return /* @__PURE__ */ jsx(InlineEntityPreviewSkeleton, {});
		return /* @__PURE__ */ jsx(EntityPreviewContainer, {
			onClick: disabled ? void 0 : onClick,
			hover: disabled ? void 0 : hover,
			size,
			children: /* @__PURE__ */ jsx(Skeleton, {})
		});
	}
	if (!usedEntity) {
		if (inline) return /* @__PURE__ */ jsx(InlineEntityPreviewMissing, {
			label: String(relation.id),
			tooltip: "Entity not found"
		});
		return /* @__PURE__ */ jsx(EntityPreviewContainer, {
			onClick: disabled ? void 0 : onClick,
			hover: disabled ? void 0 : hover,
			size,
			children: /* @__PURE__ */ jsx(ErrorView, { error: "Entity not found" })
		});
	}
	if (inline) return /* @__PURE__ */ jsx(InlineEntityPreview, {
		entity: usedEntity,
		collection,
		disabled,
		onClick,
		includeEntityLink: !textOnly && includeEntityLink !== false
	});
	return /* @__PURE__ */ jsx(ResolvedEntityPreview, {
		size,
		previewKeys: previewProperties,
		disabled,
		entity: usedEntity,
		collection,
		onClick,
		includeEntityLink,
		includeId: false,
		hover
	});
}
//#endregion
//#region src/preview/property_previews/ArrayOfRelationsPreview.tsx
/**
* @group Preview components
*/
function ArrayOfRelationsPreview({ propertyKey, value, property, size, textOnly }) {
	const nested = useIsNestedEntityPreview();
	if (Array.isArray(property?.of)) throw Error("Using array properties instead of single one in `of` in ArrayProperty");
	if (property?.type !== "array" || !property.of || property.of.type !== "relation") throw Error("Picked wrong preview component ArrayOfRelationsPreview");
	const ofProperty = property.of;
	const relationTargetPath = getRelationTargetPath(ofProperty);
	if (nested || textOnly) return /* @__PURE__ */ jsx(InlineEntityListPreview, {
		items: (value ?? []).map((relation) => normalizeToEntityRelation(relation, "relation", relationTargetPath)).filter((relation) => Boolean(relation)),
		renderItem: (relation, index) => /* @__PURE__ */ jsx(RelationPreview, {
			disabled: !ofProperty.relation,
			previewProperties: ofProperty.admin?.previewProperties,
			size: "small",
			relation,
			textOnly,
			includeId: ofProperty.admin?.includeId,
			includeEntityLink: ofProperty.admin?.includeEntityLink
		}, `preview_array_rel_${propertyKey}_${index}`)
	});
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-col w-full gap-0.5",
		children: value ? value.map((relation, index) => {
			const entityRelation = normalizeToEntityRelation(relation, "relation", relationTargetPath);
			if (!entityRelation) return null;
			return /* @__PURE__ */ jsx("div", {
				className: "w-full",
				children: /* @__PURE__ */ jsx(RelationPreview, {
					disabled: !ofProperty.relation,
					previewProperties: ofProperty.admin?.previewProperties,
					size: "small",
					relation: entityRelation,
					includeId: ofProperty.admin?.includeId,
					includeEntityLink: ofProperty.admin?.includeEntityLink
				})
			}, `preview_array_rel_${propertyKey}_${index}`);
		}) : null
	});
}
//#endregion
//#region src/preview/property_previews/ArrayOfStorageComponentsPreview.tsx
/**
* @group Preview components
*/
function ArrayOfStorageComponentsPreview({ propertyKey, value, property, size }) {
	useAuthController();
	useCustomizationController();
	if (Array.isArray(property.of)) throw Error("Using array properties instead of single one in `of` in ArrayProperty");
	if (property.type !== "array" || !property.of || property.of.type !== "string") throw Error("Picked wrong preview component ArrayOfStorageComponentsPreview");
	const childSize = size === "medium" ? "medium" : "small";
	if (!property.of) throw Error(`You need to specify an 'of' prop (or specify a custom field) in your array property ${propertyKey}`);
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-wrap gap-2",
		children: value ? value.map((v, index) => /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(PropertyPreview, {
			propertyKey,
			value: v,
			property: property.of,
			size: childSize
		}) }, `preview_array_storage_${propertyKey}_${index}`)) : null
	});
}
//#endregion
//#region src/preview/components/ArrayEnumPreview.tsx
/**
* @group Preview components
*/
function ArrayEnumPreview({ name, value, enumValues, size }) {
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-wrap gap-1.5",
		children: value && value.map((enumKey, index) => {
			return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(EnumValuesChip, {
				enumKey,
				enumValues,
				size: size !== "medium" ? "small" : "medium"
			}) }, `preview_array_ref_${name}_${index}`);
		})
	});
}
//#endregion
//#region src/preview/property_previews/ArrayPropertyEnumPreview.tsx
/**
* @group Preview components
*/
function ArrayPropertyEnumPreview({ propertyKey, value, property, size }) {
	if (property.type !== "array") throw Error("Picked wrong preview component ArrayEnumPreview");
	const ofProperty = property.of;
	if (!ofProperty.enum) throw Error("Picked wrong preview component ArrayEnumPreview");
	if (!value) return null;
	const enumValues = resolveEnumValues(ofProperty.enum);
	if (!enumValues) throw Error(`Enum values not resolved for property ${propertyKey}`);
	return /* @__PURE__ */ jsx(ArrayEnumPreview, {
		name: propertyKey,
		value,
		enumValues,
		size
	});
}
//#endregion
//#region src/preview/property_previews/ArrayOfStringsPreview.tsx
/**
* @group Preview components
*/
function ArrayOfStringsPreview({ propertyKey, value, property, size, compact }) {
	if (Array.isArray(property.of)) throw Error("Using array properties instead of single one in `of` in ArrayProperty");
	if (!property.of || property.type !== "array" || property.of.type !== "string") throw Error("Picked wrong preview component ArrayOfStringsPreview");
	if (value && !Array.isArray(value)) return /* @__PURE__ */ jsx("div", { children: `Unexpected value: ${value}` });
	const stringProperty = property.of;
	const arrayValues = value;
	if (compact) return /* @__PURE__ */ jsx("span", {
		className: "inline-flex items-center gap-1 min-w-0 truncate",
		children: arrayValues && arrayValues.map((v, index) => /* @__PURE__ */ jsxs(React.Fragment, { children: [index > 0 && /* @__PURE__ */ jsx("span", {
			className: "opacity-40",
			"aria-hidden": true,
			children: "·"
		}), /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(StringPropertyPreview, {
			propertyKey,
			property: stringProperty,
			value: v,
			compact: true,
			size
		}) })] }, `preview_array_strings_${propertyKey}_${index}`))
	});
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-col gap-2",
		children: arrayValues && arrayValues.map((v, index) => /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(StringPropertyPreview, {
			propertyKey,
			property: stringProperty,
			value: v,
			size
		}) }) }, `preview_array_strings_${propertyKey}_${index}`))
	});
}
//#endregion
//#region src/preview/property_previews/ArrayOneOfPreview.tsx
/**
* @group Preview components
*/
function ArrayOneOfPreview({ propertyKey, value, property, size, compact }) {
	if (property.type !== "array") throw Error(`You need to specify an 'of' or 'oneOf' prop (or specify a custom field) in your array property ${propertyKey}`);
	useAuthController();
	useCustomizationController();
	if (property?.type !== "array") throw Error("Picked wrong preview component ArrayPreview");
	if (!property?.oneOf) throw Error(`You need to specify an 'of' or 'oneOf' prop (or specify a custom field) in your array property ${propertyKey}`);
	const values = value;
	if (!values) return null;
	if (compact) return /* @__PURE__ */ jsx("span", {
		className: "text-sm truncate",
		children: values.length === 1 ? "1 block" : `${values.length} blocks`
	});
	const childSize = size === "medium" ? "medium" : "small";
	const typeField = property.oneOf.typeField ?? DEFAULT_ONE_OF_TYPE;
	const valueField = property.oneOf.valueField ?? DEFAULT_ONE_OF_VALUE;
	const properties = property.oneOf.properties;
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-col",
		children: values && values.map((val, index) => {
			const resolvedProperty = properties[val?.[typeField]];
			if (!val || !resolvedProperty) return null;
			return /* @__PURE__ */ jsx(React.Fragment, { children: /* @__PURE__ */ jsx("div", {
				className: cls(defaultBorderMixin, "m-1 border-b last:border-b-0 py-2"),
				children: /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(PropertyPreview, {
					propertyKey,
					value: val[valueField],
					property: resolvedProperty,
					size: childSize
				}) })
			}) }, "preview_array_" + index);
		})
	});
}
//#endregion
//#region src/preview/property_previews/MapPropertyPreview.tsx
/**
* @group Preview components
*/
function MapPropertyPreview({ propertyKey, value, property, size, compact }) {
	if (property.type !== "map") throw Error("Picked wrong preview component MapPropertyPreview");
	const mapProperty = property;
	if (compact) return /* @__PURE__ */ jsx(CompactMapPreview, {
		property: mapProperty,
		value
	});
	if (!mapProperty.properties || Object.keys(mapProperty.properties ?? {}).length === 0) return /* @__PURE__ */ jsx(KeyValuePreview, { value });
	if (!value) return null;
	const mapValue = value;
	const mapPropertyKeys = Object.keys(mapProperty.properties);
	if (size === "small") return /* @__PURE__ */ jsx("div", {
		className: "w-full flex flex-col space-y-1 md:space-y-2",
		children: mapPropertyKeys.map((key, index) => /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(PropertyPreview, {
			propertyKey: key,
			value: mapValue[key],
			property: mapProperty.properties[key],
			size
		}) }, "map_preview_" + mapProperty.name + key + index) }, `map_${key}`))
	});
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-col gap-1 w-full",
		children: mapPropertyKeys && mapPropertyKeys.map((key, index) => {
			const childProperty = mapProperty.properties[key];
			const isArrayOrMap = childProperty.type === "map" || childProperty.type === "array";
			return /* @__PURE__ */ jsxs("div", {
				className: cls(defaultBorderMixin, "last:border-b-0 border-b"),
				children: [/* @__PURE__ */ jsxs("div", {
					className: "flex flex-row pt-0.5 pb-0.5 gap-2",
					children: [/* @__PURE__ */ jsx("div", {
						className: "min-w-[140px] w-[25%] py-1",
						children: /* @__PURE__ */ jsx(Typography, {
							variant: "caption",
							className: "break-words font-semibold",
							color: "secondary",
							children: childProperty.name
						})
					}), /* @__PURE__ */ jsx("div", {
						className: "grow max-w-[75%]",
						children: /* @__PURE__ */ jsx(ErrorBoundary, { children: !isArrayOrMap && /* @__PURE__ */ jsx(PropertyPreview, {
							propertyKey: key,
							value: mapValue[key],
							property: childProperty,
							size
						}) })
					})]
				}), isArrayOrMap && /* @__PURE__ */ jsx("div", {
					className: cls(defaultBorderMixin, "border-l pl-4 ml-2 my-2"),
					children: /* @__PURE__ */ jsx(PropertyPreview, {
						propertyKey: key,
						value: mapValue[key],
						property: childProperty,
						size
					})
				})]
			}, `map_preview_table_${key}}`);
		})
	});
}
/** How many leaf values a one-line map summary shows before it gives up. */
var COMPACT_MAP_ENTRIES = 3;
/**
* A map in one line: its first few leaf values, labelled, joined by dots.
*
* Nested maps and arrays are skipped rather than flattened — a line that says
* `[object Object]` is worse than a line that says nothing about that field —
* and a map with no leaves at all falls back to stating its size, which is at
* least true.
*/
function CompactMapPreview({ property, value }) {
	if (!value || typeof value !== "object") return /* @__PURE__ */ jsx(EmptyValue, {});
	const declared = property.properties;
	const keys = declared ? Object.keys(declared) : Object.keys(value);
	const parts = [];
	for (const key of keys) {
		if (parts.length >= COMPACT_MAP_ENTRIES) break;
		const childValue = value[key];
		if (childValue === void 0 || childValue === null || childValue === "") continue;
		if (typeof childValue === "object") continue;
		const label = declared?.[key]?.name ?? key;
		parts.push(`${label}: ${String(childValue)}`);
	}
	if (parts.length === 0) {
		const count = Object.keys(value).length;
		return /* @__PURE__ */ jsx(Typography, {
			variant: "caption",
			color: "secondary",
			className: "truncate",
			children: count === 1 ? "1 field" : `${count} fields`
		});
	}
	return /* @__PURE__ */ jsx("span", {
		className: "truncate text-sm",
		children: parts.join(" · ")
	});
}
function KeyValuePreview({ value }) {
	if (typeof value !== "object") return null;
	if (!value) return /* @__PURE__ */ jsx(EmptyValue, {});
	return /* @__PURE__ */ jsx("div", {
		className: "flex flex-col gap-1 w-full",
		children: Object.entries(value).map(([key, childValue]) => /* @__PURE__ */ jsxs("div", {
			className: cls(defaultBorderMixin, "last:border-b-0 border-b"),
			children: [/* @__PURE__ */ jsxs("div", {
				className: "flex flex-row pt-0.5 pb-0.5 gap-2",
				children: [/* @__PURE__ */ jsx("div", {
					className: "min-w-[140px] w-[25%] py-1",
					children: /* @__PURE__ */ jsx(Typography, {
						variant: "caption",
						className: "font-semibold break-words",
						color: "secondary",
						children: key
					})
				}, `table-cell-title-${key}-${key}`), /* @__PURE__ */ jsx("div", {
					className: "grow max-w-[75%]",
					children: childValue && typeof childValue !== "object" && /* @__PURE__ */ jsx(Typography, { children: /* @__PURE__ */ jsx(ErrorBoundary, { children: childValue.toString() }) })
				})]
			}), typeof childValue === "object" && /* @__PURE__ */ jsx("div", {
				className: cls(defaultBorderMixin, "border-l pl-4"),
				children: /* @__PURE__ */ jsx(KeyValuePreview, { value: childValue })
			})]
		}, `map_preview_table_${key}}`))
	});
}
//#endregion
//#region src/preview/components/date_fns_locales.ts
/**
* One date-fns locale, fetched when the admin is actually configured to use it.
*
* `DatePreview` used to open with:
*
*     import * as locales from "date-fns/locale";
*
* and then index that namespace with the configured locale. A namespace import
* of a barrel is a reference to every member of it, so all ~77 locales were
* bundled — 640 kB, in the entry chunk's static graph, to format dates in the
* one locale a given deployment has configured (and `undefined`, meaning
* en-US, for nearly all of them).
*
* A map of thunks is written out rather than derived from the locale key,
* because `import(`date-fns/locale/${name}`)` is not statically analysable:
* the bundler cannot see which modules it must emit, and the import fails at
* runtime in a build. Each entry below is its own async chunk, and exactly one
* of them is ever fetched.
*
* `fil` is in the `Locale` union and has no date-fns locale to import; it
* resolved to `undefined` through the namespace too, so it still does.
*/
var dateFnsLocaleLoaders = {
	af: () => import("date-fns/locale/af").then((m) => m.af),
	ar: () => import("date-fns/locale/ar").then((m) => m.ar),
	arDZ: () => import("date-fns/locale/ar-DZ").then((m) => m.arDZ),
	arMA: () => import("date-fns/locale/ar-MA").then((m) => m.arMA),
	arSA: () => import("date-fns/locale/ar-SA").then((m) => m.arSA),
	az: () => import("date-fns/locale/az").then((m) => m.az),
	be: () => import("date-fns/locale/be").then((m) => m.be),
	bg: () => import("date-fns/locale/bg").then((m) => m.bg),
	bn: () => import("date-fns/locale/bn").then((m) => m.bn),
	ca: () => import("date-fns/locale/ca").then((m) => m.ca),
	cs: () => import("date-fns/locale/cs").then((m) => m.cs),
	cy: () => import("date-fns/locale/cy").then((m) => m.cy),
	da: () => import("date-fns/locale/da").then((m) => m.da),
	de: () => import("date-fns/locale/de").then((m) => m.de),
	el: () => import("date-fns/locale/el").then((m) => m.el),
	enAU: () => import("date-fns/locale/en-AU").then((m) => m.enAU),
	enCA: () => import("date-fns/locale/en-CA").then((m) => m.enCA),
	enGB: () => import("date-fns/locale/en-GB").then((m) => m.enGB),
	enIN: () => import("date-fns/locale/en-IN").then((m) => m.enIN),
	enNZ: () => import("date-fns/locale/en-NZ").then((m) => m.enNZ),
	enUS: () => import("date-fns/locale/en-US").then((m) => m.enUS),
	eo: () => import("date-fns/locale/eo").then((m) => m.eo),
	es: () => import("date-fns/locale/es").then((m) => m.es),
	et: () => import("date-fns/locale/et").then((m) => m.et),
	eu: () => import("date-fns/locale/eu").then((m) => m.eu),
	faIR: () => import("date-fns/locale/fa-IR").then((m) => m.faIR),
	fi: () => import("date-fns/locale/fi").then((m) => m.fi),
	fr: () => import("date-fns/locale/fr").then((m) => m.fr),
	frCA: () => import("date-fns/locale/fr-CA").then((m) => m.frCA),
	frCH: () => import("date-fns/locale/fr-CH").then((m) => m.frCH),
	gd: () => import("date-fns/locale/gd").then((m) => m.gd),
	gl: () => import("date-fns/locale/gl").then((m) => m.gl),
	gu: () => import("date-fns/locale/gu").then((m) => m.gu),
	he: () => import("date-fns/locale/he").then((m) => m.he),
	hi: () => import("date-fns/locale/hi").then((m) => m.hi),
	hr: () => import("date-fns/locale/hr").then((m) => m.hr),
	hu: () => import("date-fns/locale/hu").then((m) => m.hu),
	hy: () => import("date-fns/locale/hy").then((m) => m.hy),
	id: () => import("date-fns/locale/id").then((m) => m.id),
	is: () => import("date-fns/locale/is").then((m) => m.is),
	it: () => import("date-fns/locale/it").then((m) => m.it),
	ja: () => import("date-fns/locale/ja").then((m) => m.ja),
	ka: () => import("date-fns/locale/ka").then((m) => m.ka),
	kk: () => import("date-fns/locale/kk").then((m) => m.kk),
	kn: () => import("date-fns/locale/kn").then((m) => m.kn),
	ko: () => import("date-fns/locale/ko").then((m) => m.ko),
	lb: () => import("date-fns/locale/lb").then((m) => m.lb),
	lt: () => import("date-fns/locale/lt").then((m) => m.lt),
	lv: () => import("date-fns/locale/lv").then((m) => m.lv),
	mk: () => import("date-fns/locale/mk").then((m) => m.mk),
	ms: () => import("date-fns/locale/ms").then((m) => m.ms),
	mt: () => import("date-fns/locale/mt").then((m) => m.mt),
	nb: () => import("date-fns/locale/nb").then((m) => m.nb),
	nl: () => import("date-fns/locale/nl").then((m) => m.nl),
	nlBE: () => import("date-fns/locale/nl-BE").then((m) => m.nlBE),
	nn: () => import("date-fns/locale/nn").then((m) => m.nn),
	pl: () => import("date-fns/locale/pl").then((m) => m.pl),
	pt: () => import("date-fns/locale/pt").then((m) => m.pt),
	ptBR: () => import("date-fns/locale/pt-BR").then((m) => m.ptBR),
	ro: () => import("date-fns/locale/ro").then((m) => m.ro),
	ru: () => import("date-fns/locale/ru").then((m) => m.ru),
	sk: () => import("date-fns/locale/sk").then((m) => m.sk),
	sl: () => import("date-fns/locale/sl").then((m) => m.sl),
	sr: () => import("date-fns/locale/sr").then((m) => m.sr),
	srLatn: () => import("date-fns/locale/sr-Latn").then((m) => m.srLatn),
	sv: () => import("date-fns/locale/sv").then((m) => m.sv),
	ta: () => import("date-fns/locale/ta").then((m) => m.ta),
	te: () => import("date-fns/locale/te").then((m) => m.te),
	th: () => import("date-fns/locale/th").then((m) => m.th),
	tr: () => import("date-fns/locale/tr").then((m) => m.tr),
	ug: () => import("date-fns/locale/ug").then((m) => m.ug),
	uk: () => import("date-fns/locale/uk").then((m) => m.uk),
	uz: () => import("date-fns/locale/uz").then((m) => m.uz),
	vi: () => import("date-fns/locale/vi").then((m) => m.vi),
	zhCN: () => import("date-fns/locale/zh-CN").then((m) => m.zhCN),
	zhTW: () => import("date-fns/locale/zh-TW").then((m) => m.zhTW)
};
var cache = /* @__PURE__ */ new Map();
/** The locale if it has already been fetched, otherwise `undefined`. Never fetches. */
function getLoadedDateFnsLocale(locale) {
	return locale ? cache.get(locale) : void 0;
}
/**
* Fetch a date-fns locale. Resolves to `undefined` for a locale date-fns does
* not ship, which is what indexing the namespace used to yield.
*/
async function loadDateFnsLocale(locale) {
	if (!locale) return void 0;
	const cached = cache.get(locale);
	if (cached) return cached;
	const loader = dateFnsLocaleLoaders[locale];
	if (!loader) return void 0;
	const loaded = await loader();
	cache.set(locale, loaded);
	return loaded;
}
//#endregion
//#region src/preview/components/DatePreview.tsx
/**
* @group Preview components
*/
function DatePreview({ date, mode = "date_time", timezone }) {
	const customizationController = useCustomizationController();
	const configuredLocale = customizationController?.locale;
	const [dateUtilsLocale, setDateUtilsLocale] = React.useState(() => getLoadedDateFnsLocale(configuredLocale));
	React.useEffect(() => {
		let cancelled = false;
		loadDateFnsLocale(configuredLocale).then((loaded) => {
			if (!cancelled) setDateUtilsLocale(loaded);
		}).catch((error) => console.error(`[rebase] could not load the "${configuredLocale}" date locale`, error));
		return () => {
			cancelled = true;
		};
	}, [configuredLocale]);
	if (!date || !(date instanceof Date) || isNaN(date.getTime())) return /* @__PURE__ */ jsx(Fragment, {});
	if (timezone) {
		const options = {
			year: "numeric",
			month: "short",
			day: "numeric",
			timeZone: timezone
		};
		if (mode === "date_time") {
			options.hour = "2-digit";
			options.minute = "2-digit";
		}
		const formattedDate = new Intl.DateTimeFormat(customizationController?.locale ?? "en-US", options).format(date);
		const tzAbbrev = new Intl.DateTimeFormat("en-US", {
			timeZone: timezone,
			timeZoneName: "short"
		}).formatToParts(date).find((p) => p.type === "timeZoneName")?.value ?? "";
		return /* @__PURE__ */ jsxs("span", {
			className: "flex items-center gap-1 font-mono tabular-nums",
			children: [formattedDate, tzAbbrev && /* @__PURE__ */ jsxs("span", {
				className: "text-xs text-slate-500 dark:text-slate-400",
				children: [
					"(",
					tzAbbrev,
					")"
				]
			})]
		});
	}
	let dateFormat;
	if (mode === "date") dateFormat = customizationController?.dateTimeFormat ? customizationController.dateTimeFormat.replace(/[, ]*[HhKk].*$/, "").trim() : "PP";
	else dateFormat = customizationController?.dateTimeFormat ?? defaultDateFormat;
	return /* @__PURE__ */ jsx("span", {
		className: "font-mono tabular-nums",
		children: format(date, dateFormat, { locale: dateUtilsLocale })
	});
}
//#endregion
//#region src/preview/components/BooleanPreview.tsx
/**
* @group Preview components
*/
function BooleanPreview({ value, size, property, hideLabel }) {
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-row gap-2 items-center",
		children: [/* @__PURE__ */ jsx(Checkbox, {
			checked: value,
			padding: false,
			size,
			color: "primary"
		}), !hideLabel && property.name && /* @__PURE__ */ jsx("span", {
			className: cls("text-text-secondary dark:text-text-secondary-dark", size === "small" ? "text-sm" : ""),
			children: property.name
		})]
	});
}
//#endregion
//#region src/util/number_format.ts
/**
* Write a number out for reading, per a property's declared `admin.format`.
*
* Nothing is inferred here. With no options the number is returned as it came
* out of the database — `String(value)`, not a locale-grouped rendering — so a
* panel that declares nothing shows exactly the stored value, and an author who
* wants thousands separators asks for them.
*
* `Intl.NumberFormat` throws on a bad currency code or an out-of-range fraction
* count, and a record must not blank because one property is misconfigured, so a
* failure falls back to the raw value.
*/
function formatNumber(value, options, fallbackLocale) {
	if (!options) return String(value);
	const style = options.style ?? (options.currency ? "currency" : "decimal");
	if (style === "currency" && !options.currency) return String(value);
	try {
		return new Intl.NumberFormat(options.locale ?? fallbackLocale ?? void 0, {
			style,
			currency: options.currency,
			minimumFractionDigits: options.minimumFractionDigits,
			maximumFractionDigits: options.maximumFractionDigits,
			notation: options.notation
		}).format(value);
	} catch {
		return String(value);
	}
}
//#endregion
//#region src/preview/property_previews/NumberPropertyPreview.tsx
/**
* @group Preview components
*/
function NumberPropertyPreview({ value, property, size }) {
	const customizationController = useCustomizationController();
	const numValue = value;
	if (property.enum) {
		const enumKey = numValue;
		const enumValues = enumToObjectEntries(property.enum);
		if (!enumValues) return /* @__PURE__ */ jsx("span", {
			className: size === "small" ? "font-mono tabular-nums text-sm" : "font-mono tabular-nums",
			children: numValue
		});
		return /* @__PURE__ */ jsx(EnumValuesChip, {
			enumKey,
			enumValues,
			size: size !== "medium" ? "small" : "medium"
		});
	} else return /* @__PURE__ */ jsx("span", {
		className: size === "small" ? "font-mono tabular-nums text-sm" : "font-mono tabular-nums",
		children: formatNumber(numValue, property.admin?.format, customizationController?.locale)
	});
}
//#endregion
//#region src/preview/components/UserPreview.tsx
/**
* Preview component for displaying a user reference value.
*
* Resolves the stored auth user id to a name (or email) the same way a
* relation resolves its target, and falls back to the raw id only while the
* lookup is in flight or when the user cannot be resolved.
*
* @group Preview components
*/
function UserPreview({ value }) {
	const uid = typeof value === "string" && value ? value : void 0;
	const user = useResolvedUser(uid);
	if (!uid) return /* @__PURE__ */ jsx(EmptyValue, {});
	return /* @__PURE__ */ jsx(Typography, {
		variant: "caption",
		color: "secondary",
		className: "truncate",
		children: user ? getUserLabel(user) : uid
	});
}
//#endregion
//#region src/preview/PropertyPreview.tsx
/**
* @group Preview components
*/
var PropertyPreview = React.memo(function PropertyPreview(props) {
	const authController = useAuthController();
	const customizationController = useCustomizationController();
	const nested = useIsNestedEntityPreview();
	let content;
	const { property: inputProperty, propertyKey, value, size, height, width, interactive, fill } = props;
	const compact = props.compact ?? (nested || Boolean(props.textOnly));
	const property = resolveProperty({
		propertyKey,
		property: inputProperty,
		propertyConfigs: customizationController.propertyConfigs,
		authController
	});
	if (property === null) content = /* @__PURE__ */ jsx(EmptyValue, {});
	else if (property.admin?.Preview) {
		const ResolvedPreview = resolveComponentRef(property.admin.Preview);
		if (ResolvedPreview) content = /* @__PURE__ */ jsx(Suspense, {
			fallback: null,
			children: createElement(ResolvedPreview, {
				propertyKey,
				value,
				property,
				size,
				height,
				width,
				customProps: property.admin?.customProps
			})
		});
	} else if (value === void 0 || value === null) content = /* @__PURE__ */ jsx(EmptyValue, {});
	else if (property.type === "string") {
		const stringProperty = property;
		if (typeof value === "string") if (stringProperty.storage) {
			const filePath = stringProperty.storage.previewUrl ? stringProperty.storage.previewUrl(value) : value;
			content = /* @__PURE__ */ jsx(StorageThumbnail, {
				interactive,
				storeUrl: property.storage?.storeUrl ?? false,
				storageSourceKey: stringProperty.storage.storageSource === void 0 ? void 0 : resourceKeyOf(stringProperty.storage.storageSource),
				size: props.size,
				fill,
				storagePathOrDownloadUrl: filePath
			});
		} else if (stringProperty.admin?.urlPreview) {
			if (typeof stringProperty.admin?.urlPreview === "boolean") content = /* @__PURE__ */ jsx(UrlComponentPreview, {
				size: props.size,
				url: value,
				fill
			});
			else if (typeof stringProperty.admin?.urlPreview === "string") content = /* @__PURE__ */ jsx(UrlComponentPreview, {
				size: props.size,
				url: value,
				interactive,
				fill,
				previewType: stringProperty.admin?.urlPreview
			});
		} else if (stringProperty.admin?.markdown) content = compact ? /* @__PURE__ */ jsx("span", {
			className: "text-sm",
			children: markdownToPlainText(value)
		}) : /* @__PURE__ */ jsx(Markdown, {
			source: value,
			size: "small"
		});
		else if (stringProperty.userSelect) content = /* @__PURE__ */ jsx(UserPreview, {
			value,
			property: stringProperty,
			propertyKey,
			size: props.size
		});
		else content = /* @__PURE__ */ jsx(StringPropertyPreview, {
			...props,
			compact,
			property: stringProperty,
			value
		});
		else content = buildWrongValueType(propertyKey, property.type, value);
	} else if (property.type === "array") if (Array.isArray(value)) {
		const arrayProperty = property;
		if (!arrayProperty.of && !arrayProperty.oneOf) throw Error(`You need to specify an 'of' or 'oneOf' prop (or specify a custom field) in your array property ${propertyKey}`);
		if (arrayProperty.of) if (Array.isArray(arrayProperty.of)) content = /* @__PURE__ */ jsx(ArrayPropertyPreview, {
			...props,
			compact,
			value,
			property: arrayProperty
		});
		else if (arrayProperty.of.type === "reference") content = /* @__PURE__ */ jsx(ArrayOfReferencesPreview, {
			...props,
			value,
			property
		});
		else if (arrayProperty.of.type === "relation") content = /* @__PURE__ */ jsx(ArrayOfRelationsPreview, {
			...props,
			value,
			property
		});
		else if (arrayProperty.of.type === "string") if (arrayProperty.of.enum) content = /* @__PURE__ */ jsx(ArrayPropertyEnumPreview, {
			...props,
			value,
			property
		});
		else if (arrayProperty.of.storage) content = /* @__PURE__ */ jsx(ArrayOfStorageComponentsPreview, {
			...props,
			value,
			property
		});
		else content = /* @__PURE__ */ jsx(ArrayOfStringsPreview, {
			...props,
			compact,
			property,
			value
		});
		else if (arrayProperty.of.type === "number" && arrayProperty.of.enum) content = /* @__PURE__ */ jsx(ArrayPropertyEnumPreview, {
			...props,
			value,
			property
		});
		else content = /* @__PURE__ */ jsx(ArrayPropertyPreview, {
			...props,
			compact,
			value,
			property
		});
		else if (arrayProperty.oneOf) content = /* @__PURE__ */ jsx(ArrayOneOfPreview, {
			...props,
			compact,
			value,
			property
		});
	} else content = buildWrongValueType(propertyKey, property.type, value);
	else if (property.type === "map") if (typeof value === "object") content = /* @__PURE__ */ jsx(MapPropertyPreview, {
		...props,
		compact,
		value,
		property
	});
	else content = buildWrongValueType(propertyKey, property.type, value);
	else if (property.type === "date") {
		const date = asDate(value);
		if (date) content = /* @__PURE__ */ jsx(DatePreview, {
			date,
			mode: property.mode
		});
		else content = buildWrongValueType(propertyKey, property.type, value);
	} else if (property.type === "reference") if (typeof property.path === "string") if (typeof value === "object" && value !== null && "isEntityReference" in value && value.isEntityReference()) content = /* @__PURE__ */ jsx(ReferencePreview, {
		disabled: !property.path,
		previewProperties: property.admin?.previewProperties,
		includeId: property.admin?.includeId,
		includeEntityLink: property.admin?.includeEntityLink,
		size: props.size,
		reference: value,
		textOnly: props.textOnly
	});
	else content = buildWrongValueType(propertyKey, property.type, value);
	else content = /* @__PURE__ */ jsx(EmptyValue, {});
	else if (property.type === "relation") {
		const relationTargetPath = getRelationTargetPath(property);
		if (!value) content = /* @__PURE__ */ jsx(EmptyValue, {});
		else if (Array.isArray(value)) {
			const relations = value.map((item) => normalizeToEntityRelation(item, "relation", relationTargetPath)).filter(Boolean);
			const renderRelation = (entityRelation, index) => /* @__PURE__ */ jsx(RelationPreview, {
				disabled: !property.relation,
				previewProperties: property.admin?.previewProperties,
				includeId: property.admin?.includeId,
				includeEntityLink: property.admin?.includeEntityLink,
				size: "small",
				relation: entityRelation,
				textOnly: props.textOnly
			}, `preview_rel_${propertyKey}_${index}`);
			content = nested || props.textOnly ? /* @__PURE__ */ jsx(InlineEntityListPreview, {
				items: relations,
				renderItem: renderRelation
			}) : /* @__PURE__ */ jsx("div", {
				className: "flex flex-col w-full gap-0.5",
				children: relations.map((entityRelation, index) => /* @__PURE__ */ jsx("div", {
					className: "w-full",
					children: renderRelation(entityRelation, index)
				}, `preview_rel_wrapper_${propertyKey}_${index}`))
			});
		} else {
			const relationValue = normalizeToEntityRelation(value, "relation", relationTargetPath);
			if (relationValue) content = /* @__PURE__ */ jsx(RelationPreview, {
				disabled: !property.relation,
				previewProperties: property.admin?.previewProperties,
				includeId: property.admin?.includeId,
				includeEntityLink: property.admin?.includeEntityLink,
				size: props.size,
				relation: relationValue,
				textOnly: props.textOnly
			});
			else content = buildWrongValueType(propertyKey, property.type, value);
		}
	} else if (property.type === "boolean") if (typeof value === "boolean") content = /* @__PURE__ */ jsx(BooleanPreview, {
		value,
		size,
		property,
		hideLabel: props.hideLabel
	});
	else content = buildWrongValueType(propertyKey, property.type, value);
	else if (property.type === "number") if (typeof value === "number") content = /* @__PURE__ */ jsx(NumberPropertyPreview, {
		...props,
		value,
		property
	});
	else content = buildWrongValueType(propertyKey, property.type, value);
	else content = JSON.stringify(value);
	return content === void 0 || content === null || Array.isArray(content) && content.length === 0 ? /* @__PURE__ */ jsx(EmptyValue, {}) : content;
}, deepEqual);
/**
* A `Date`, or a string/number that unambiguously names one. Returns null for
* anything else, so an actual type mismatch still reports as one.
*/
function asDate(value) {
	if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
	if (typeof value !== "string" && typeof value !== "number") return null;
	const parsed = new Date(value);
	return isNaN(parsed.getTime()) ? null : parsed;
}
function buildWrongValueType(name, type, value) {
	console.warn(`Unexpected value for property ${name}, of type ${type}`, value);
	return /* @__PURE__ */ jsx(ErrorView, {
		title: "Unexpected value",
		error: `${JSON.stringify(value)}`
	});
}
//#endregion
//#region src/preview/property_previews/ArrayOfMapsPreview.tsx
/**
* @group Preview components
*/
function ArrayOfMapsPreview({ propertyKey, value, property, size }) {
	if (Array.isArray(property?.of)) throw Error("Using array properties instead of single one in `of` in ArrayProperty");
	if (property?.type !== "array" || !property.of || property.of.type !== "map") throw Error("Picked wrong preview component ArrayOfMapsPreview");
	const mapProperty = property.of;
	const properties = mapProperty.properties;
	if (!properties) throw Error(`You need to specify a 'properties' prop (or specify a custom field) in your map property '${propertyKey}'${mapProperty.name ? ` ("${mapProperty.name}")` : ""}`);
	const values = value;
	const previewProperties = mapProperty.admin?.previewProperties;
	if (!values) return null;
	let mapProperties = previewProperties;
	if (!mapProperties || !mapProperties.length) {
		mapProperties = Object.keys(properties);
		if (size) mapProperties = mapProperties.slice(0, 3);
	}
	return /* @__PURE__ */ jsx("div", {
		className: "table-auto text-xs",
		children: /* @__PURE__ */ jsx("div", { children: values && values.map((v, index) => {
			return /* @__PURE__ */ jsx("div", {
				className: "border-b last:border-b-0 py-2",
				children: mapProperties && mapProperties.map((key) => /* @__PURE__ */ jsx("div", {
					className: "table-cell",
					children: /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(PropertyPreview, {
						propertyKey: key,
						value: v[key],
						property: properties[key],
						size: "small"
					}) })
				}, `table-cell-${key}`))
			}, `table_${v}_${index}`);
		}) })
	});
}
//#endregion
//#region src/form/components/FieldHelperText.tsx
/**
* Normalize an error value to a displayable string.
* Handles cases where the error is an array (e.g. per-element validation
* errors from array fields) or an object (e.g. raw Zod issue objects).
*/
function normalizeError(error) {
	if (error === void 0 || error === null) return void 0;
	if (typeof error === "string") return error;
	if (Array.isArray(error)) {
		const firstError = error.find((e) => !!e);
		if (!firstError) return void 0;
		return normalizeError(firstError);
	}
	if (typeof error === "object") {
		if ("message" in error) return String(error.message);
		const messages = [];
		const extractMessages = (obj) => {
			for (const key in obj) if (typeof obj[key] === "string") messages.push(obj[key]);
			else if (typeof obj[key] === "object" && obj[key] !== null) extractMessages(obj[key]);
		};
		extractMessages(error);
		if (messages.length > 0) return Array.from(new Set(messages)).join(", ");
	}
	return String(error);
}
/**
* Component in charge of rendering the description of a field
* as well as the error message if any.
*/
function FieldHelperText({ error, showError, property, includeDescription = true, disabled }) {
	const displayError = normalizeError(error);
	const hasDescription = property.description !== void 0 && property.description.trim().length > 0;
	if (!(showError && displayError) && (!includeDescription || !hasDescription)) return null;
	if (showError && displayError) return /* @__PURE__ */ jsx(Typography, {
		variant: "caption",
		className: "ml-3.5 text-red-500 dark:text-red-500",
		children: displayError
	});
	const disabledTooltip = typeof property.admin?.disabled === "object" ? property.admin?.disabled.disabledMessage : void 0;
	return /* @__PURE__ */ jsx("div", {
		className: "flex ml-3.5 mt-1",
		children: /* @__PURE__ */ jsx(Typography, {
			variant: "caption",
			color: disabled ? "disabled" : "secondary",
			className: "grow",
			children: disabledTooltip || property.description
		})
	});
}
//#endregion
//#region src/form/components/LabelWithIcon.tsx
/**
* Render the label of with an icon and the title of a property
* @group Form custom fields
*/
var LabelWithIcon = forwardRef(({ icon, title, small, className, required, labelId, propertyKey }, ref) => {
	return /* @__PURE__ */ jsxs("div", {
		ref,
		className: cls("group/label align-middle inline-flex items-center min-w-0 my-0.5", small ? "gap-1" : "gap-2", className),
		children: [
			icon,
			/* @__PURE__ */ jsx("span", {
				id: labelId,
				className: `text-start font-medium text-${small ? "base" : "sm"} origin-top-left transform ${small ? "translate-x-2 scale-75" : ""}`,
				children: (title ?? "") + (required ? " *" : "")
			}),
			propertyKey && /* @__PURE__ */ jsx(PropertyKeyHint, { propertyKey })
		]
	});
});
LabelWithIcon.displayName = "LabelWithIcon";
//#endregion
//#region src/form/field_bindings/ReadOnlyFieldBinding.tsx
/**
*
* Simply render the non-editable preview of a field
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function ReadOnlyFieldBinding({ propertyKey, value, error, showError, minimalistView, property, includeDescription, hideLabel, context, size = "large" }) {
	const skipCardWrapper = property.type === "relation" || property.type === "reference";
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		!minimalistView && !hideLabel && /* @__PURE__ */ jsx(LabelWithIcon, {
			propertyKey,
			icon: getIconForProperty(property, "small"),
			required: property.validation?.required,
			title: property.name ?? propertyKey,
			className: "h-8 text-text-secondary dark:text-text-secondary-dark ml-3"
		}),
		/* @__PURE__ */ jsx("div", {
			className: cls("w-full overflow-x-scroll no-scrollbar flex items-center", skipCardWrapper ? "" : cls("rounded-lg border border-hairline-strong px-3 text-sm opacity-80", {
				"min-h-[34px]": size === "small",
				"min-h-[42px]": size === "medium",
				"min-h-[50px]": size === "large"
			})),
			children: /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(PropertyPreview, {
				propertyKey,
				value,
				property,
				hideLabel: hideLabel || !minimalistView,
				size: "medium"
			}) })
		}),
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError,
			error,
			property
		})
	] });
}
//#endregion
//#region src/form/useClearRestoreValue.tsx
/**
* Hook we use to restore a value after it has been cleared
* @param property
* @param value
* @param setValue
* @ignore
*/
function useClearRestoreValue({ property, value, setValue }) {
	const clearedValueRef = useRef(null);
	useEffect(() => {
		if (typeof property.admin?.disabled === "object" && Boolean(property.admin?.disabled.clearOnDisabled)) {
			if (value != null) {
				clearedValueRef.current = value;
				setValue(null);
			}
		} else if (clearedValueRef.current) {
			setValue(clearedValueRef.current);
			clearedValueRef.current = null;
		}
	}, [property]);
}
//#endregion
//#region src/form/field_bindings/ArrayCustomShapedFieldBinding.tsx
/**
* Array field used for custom
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function ArrayCustomShapedFieldBinding({ propertyKey, value, error, showError, isSubmitting, setValue, setFieldValue, customProps, minimalistView: minimalistViewProp, property, includeDescription, context, disabled }) {
	const authController = useAuthController();
	const minimalistView = minimalistViewProp || property.admin?.minimalistView;
	const resolvedProperties = getArrayResolvedProperties({
		propertyValue: value,
		propertyKey,
		property,
		ignoreMissingFields: false,
		authController
	});
	const expanded = property.admin?.expanded === void 0 ? true : property.admin?.expanded;
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	const title = /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(LabelWithIcon, {
		propertyKey,
		icon: getIconForProperty(property, "small"),
		required: property.validation?.required,
		title: property.name ?? propertyKey,
		className: "h-8 grow text-text-secondary dark:text-text-secondary-dark"
	}), Array.isArray(value) && /* @__PURE__ */ jsxs(Typography, {
		variant: "caption",
		className: "px-4",
		children: [
			"(",
			value.length,
			")"
		]
	})] });
	const body = (resolvedProperties ?? []).map((childProperty, index) => {
		const thisDisabled = isReadOnly(childProperty) || isDisabled(childProperty);
		return /* @__PURE__ */ jsx("div", {
			className: "pb-4",
			children: /* @__PURE__ */ jsx(PropertyFieldBinding, {
				propertyKey: `${propertyKey}[${index}]`,
				disabled: disabled || thisDisabled,
				property: childProperty,
				includeDescription,
				context,
				partOfArray: true,
				minimalistView: false,
				autoFocus: false,
				value,
				setValue,
				setFieldValue,
				customProps
			})
		}, `custom_shaped_array_${index}`);
	});
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		!minimalistView && /* @__PURE__ */ jsx(ExpandablePanel, {
			initiallyExpanded: expanded,
			title,
			innerClassName: "px-2 md:px-4 pb-2 md:pb-4 pt-1 md:pt-2",
			children: body
		}),
		minimalistView && body,
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError,
			error,
			disabled,
			property
		})
	] });
}
//#endregion
//#region src/components/SelectableTable/SelectionStore.ts
function createSelectionStore() {
	return createVirtualTableSelectionStore();
}
function useCellSelected(store, propertyKey, entityPath, entityId) {
	const selectorRef = useRef({
		propertyKey,
		entityPath,
		entityId
	});
	selectorRef.current = {
		propertyKey,
		entityPath,
		entityId
	};
	const getEntity = useCallback(() => {
		const cell = store.getEntity();
		if (!cell) return false;
		const s = selectorRef.current;
		return cell.propertyKey === s.propertyKey && cell.entityPath === s.entityPath && cell.entityId === s.entityId;
	}, [store]);
	return useSyncExternalStore(store.subscribe, getEntity, getEntity);
}
//#endregion
//#region src/components/CollectionTableBinding/fields/VirtualTableSelect.tsx
function VirtualTableSelect(props) {
	const { enumValues, internalValue, disabled, small, focused, updateValue, multiple, valueType } = props;
	const validValue = Array.isArray(internalValue) && multiple || !Array.isArray(internalValue) && !multiple;
	const ref = React.useRef(null);
	useEffect(() => {
		if (ref.current && focused) ref.current?.focus({ preventScroll: true });
	}, [focused, ref]);
	const onChange = useCallback((updatedValue) => {
		if (valueType === "number") if (multiple) {
			const newValue = updatedValue.map((v) => parseFloat(v));
			updateValue(newValue);
		} else updateValue(parseFloat(updatedValue));
		else if (valueType === "string") if (!updatedValue) updateValue(null);
		else updateValue(updatedValue);
		else throw Error("Missing mapping in TableSelect");
	}, [
		multiple,
		updateValue,
		valueType
	]);
	const resolvedEnumValues = resolveEnumValues(enumValues);
	const renderValue = (enumKey) => {
		return /* @__PURE__ */ jsx(EnumValuesChip, {
			enumKey: String(enumKey),
			enumValues,
			size: small ? "small" : "medium"
		}, `${enumKey}`);
	};
	const handleOpenChange = useCallback((open) => {
		if (!open && ref.current) setTimeout(() => {
			ref.current?.focus({ preventScroll: true });
		}, 0);
	}, []);
	return multiple ? /* @__PURE__ */ jsx(MultiSelect, {
		invisible: true,
		inputRef: ref,
		className: "w-full h-full p-0 bg-transparent outline-none",
		position: "item-aligned",
		disabled,
		includeClear: false,
		useChips: false,
		value: validValue ? internalValue.map((v) => v.toString()) : [],
		onValueChange: onChange,
		onOpenChange: handleOpenChange,
		children: resolvedEnumValues?.map((enumConfig) => /* @__PURE__ */ jsx(MultiSelectItem, {
			value: String(enumConfig.id),
			children: /* @__PURE__ */ jsx(EnumValuesChip, {
				enumKey: enumConfig.id,
				enumValues,
				size: small ? "small" : "medium"
			})
		}, enumConfig.id))
	}) : /* @__PURE__ */ jsx(Select, {
		inputRef: ref,
		invisible: true,
		fullWidth: true,
		className: "w-full h-full p-0 bg-transparent outline-none [&_button]:ring-0 [&_button]:ring-offset-0",
		inputClassName: "ring-0 ring-offset-0 focus:ring-0 focus-visible:ring-0 outline-none focus:outline-none focus-visible:outline-none focus-visible:ring-offset-0",
		position: "item-aligned",
		disabled,
		padding: false,
		value: validValue ? internalValue?.toString() : "",
		onValueChange: onChange,
		onOpenChange: handleOpenChange,
		renderValue,
		children: resolvedEnumValues?.map((enumConfig) => /* @__PURE__ */ jsx(SelectItem, {
			value: String(enumConfig.id),
			children: /* @__PURE__ */ jsx(EnumValuesChip, {
				enumKey: enumConfig.id,
				enumValues,
				size: small ? "small" : "medium"
			})
		}, enumConfig.id))
	});
}
//#endregion
//#region src/components/UserSelector.tsx
var DEFAULT_PAGE_SIZE$2 = 10;
/**
* Local hook to fetch users from the collection REST API with search and pagination.
*/
function useUserSelector({ pageSize = DEFAULT_PAGE_SIZE$2 } = {}) {
	const client = useRebaseClient();
	const { getAuthToken } = useAuthController();
	const [items, setItems] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const [currentSearch, setCurrentSearch] = useState("");
	const offsetRef = useRef(0);
	const userCacheRef = useRef(/* @__PURE__ */ new Map());
	const requestIdRef = useRef(0);
	const searchTimeoutRef = useRef(null);
	const fetchUsers = useCallback(async (searchStr, offset, append) => {
		const apiBase = apiBaseOf(client);
		if (!apiBase) return;
		const requestId = ++requestIdRef.current;
		const superseded = () => requestId !== requestIdRef.current;
		setIsLoading(true);
		try {
			const token = await getAuthToken?.();
			const params = new URLSearchParams({
				limit: String(pageSize),
				offset: String(offset)
			});
			if (searchStr) params.set("search", searchStr);
			const response = await fetch(`${apiBase}/admin/users?${params}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
			if (!response.ok) throw new Error("Failed to fetch users");
			const data = await response.json();
			if (superseded()) return;
			const newItems = (data.data ?? data.users ?? []).map((r) => {
				const user = {
					uid: r.uid ?? r.id ?? "",
					email: r.email ?? "",
					displayName: r.displayName ?? r.display_name ?? null,
					photoURL: r.photoURL ?? r.photo_url ?? null,
					providerId: "custom",
					isAnonymous: false,
					roles: r.roles ?? []
				};
				userCacheRef.current.set(user.uid, user);
				return {
					uid: user.uid,
					label: user.displayName ?? user.email ?? user.uid,
					user
				};
			});
			setItems((prev) => append ? [...prev, ...newItems] : newItems);
			setHasMore(newItems.length >= pageSize);
			offsetRef.current = offset + newItems.length;
		} catch {
			if (superseded()) return;
			setHasMore(false);
		} finally {
			if (!superseded()) setIsLoading(false);
		}
	}, [
		client?.baseUrl,
		client?.apiPath,
		getAuthToken,
		pageSize
	]);
	useEffect(() => {
		offsetRef.current = 0;
		fetchUsers("", 0, false);
	}, [fetchUsers]);
	const search = useCallback((searchStr) => {
		if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
		searchTimeoutRef.current = setTimeout(() => {
			setCurrentSearch(searchStr);
			offsetRef.current = 0;
			fetchUsers(searchStr, 0, false);
		}, searchStr.trim() ? 300 : 0);
	}, [fetchUsers]);
	useEffect(() => {
		return () => {
			if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
		};
	}, []);
	return {
		items,
		isLoading,
		hasMore,
		search,
		loadMore: useCallback(() => {
			fetchUsers(currentSearch, offsetRef.current, true);
		}, [fetchUsers, currentSearch]),
		getUser: useCallback((uid) => {
			return userCacheRef.current.get(uid) ?? null;
		}, [])
	};
}
var UserSelector = React$1.forwardRef(({ value, size = "medium", onValueChange, invisible, disabled, placeholder, clearable = true, className, pageSize, searchPlaceholder = "Search users...", noResultsText = "No users found.", loadingText = "Loading..." }, ref) => {
	const { items: availableItems, isLoading, hasMore, search, loadMore, getUser } = useUserSelector({ pageSize });
	const [isPopoverOpen, setIsPopoverOpen] = useState(false);
	const [searchString, setSearchString] = useState("");
	const contextPortalContainer = usePortalContainer();
	const scrollContainerRef = useRef(null);
	const sentinelRef = useRef(null);
	const observerRef = useRef(null);
	const localTriggerRef = useRef(null);
	const handleButtonRef = useCallback((node) => {
		localTriggerRef.current = node;
		if (typeof ref === "function") ref(node);
		else if (ref) ref.current = node;
	}, [ref]);
	const contentRef = useRef(null);
	const searchInputRef = useRef(null);
	const listedUser = (value ? getUser(value) ?? null : null) ?? (value ? availableItems.find((i) => i.uid === value)?.user ?? null : null);
	const fetchedUser = useResolvedUser(value && !listedUser ? value : void 0);
	const resolvedUser = listedUser ?? fetchedUser;
	const sentinelCallbackRef = useCallback((node) => {
		if (observerRef.current) {
			observerRef.current.disconnect();
			observerRef.current = null;
		}
		if (sentinelRef.current !== node) sentinelRef.current = node;
		if (!node || !hasMore || isLoading || !loadMore) return;
		const observer = new IntersectionObserver((entries) => {
			if (entries[0].isIntersecting && hasMore && !isLoading) loadMore();
		}, {
			root: scrollContainerRef.current,
			rootMargin: "20px",
			threshold: 0
		});
		observer.observe(node);
		observerRef.current = observer;
	}, [
		hasMore,
		isLoading,
		loadMore
	]);
	useEffect(() => () => {
		if (observerRef.current) observerRef.current.disconnect();
	}, []);
	useEffect(() => {
		const scrollContainer = scrollContainerRef.current;
		if (!scrollContainer || !hasMore || isLoading || !isPopoverOpen) return;
		const handleScroll = () => {
			const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
			if (scrollTop + clientHeight >= scrollHeight - 100 && hasMore && !isLoading) loadMore();
		};
		scrollContainer.addEventListener("scroll", handleScroll, { passive: true });
		return () => {
			scrollContainer.removeEventListener("scroll", handleScroll);
		};
	}, [
		hasMore,
		isLoading,
		loadMore,
		isPopoverOpen
	]);
	const handleSearchChange = useCallback((newSearchString) => {
		setSearchString(newSearchString);
		search(newSearchString);
	}, [search]);
	const handleItemClick = useCallback((item) => {
		if (value === item.uid) onValueChange?.(null);
		else onValueChange?.(item.uid);
		setIsPopoverOpen(false);
	}, [value, onValueChange]);
	const handleClear = useCallback((e) => {
		e.stopPropagation();
		e.preventDefault();
		onValueChange?.(null);
	}, [onValueChange]);
	const handleRootOpenChange = useCallback((next) => {
		if (disabled) return;
		if (next) setIsPopoverOpen(true);
	}, [disabled]);
	useEffect(() => {
		if (!isPopoverOpen) return;
		function handlePointerDown(ev) {
			const target = ev.target;
			const triggerEl = localTriggerRef.current;
			const contentEl = contentRef.current;
			if (triggerEl?.contains(target)) return;
			if (contentEl?.contains(target)) return;
			setIsPopoverOpen(false);
		}
		function handleKey(ev) {
			if (ev.key === "Escape") setIsPopoverOpen(false);
		}
		document.addEventListener("mousedown", handlePointerDown, true);
		document.addEventListener("keydown", handleKey, true);
		return () => {
			document.removeEventListener("mousedown", handlePointerDown, true);
			document.removeEventListener("keydown", handleKey, true);
		};
	}, [isPopoverOpen]);
	const resolvedPlaceholder = placeholder || /* @__PURE__ */ jsx(EmptyValue, { className: "ml-2" });
	const portalContainer = contextPortalContainer ?? (typeof document !== "undefined" ? document.body : void 0) ?? void 0;
	return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(PopoverPrimitive.Root, {
		open: isPopoverOpen,
		onOpenChange: handleRootOpenChange,
		modal: false,
		children: [/* @__PURE__ */ jsx(PopoverPrimitive.Trigger, {
			asChild: true,
			children: /* @__PURE__ */ jsx("button", {
				ref: handleButtonRef,
				type: "button",
				"aria-haspopup": "listbox",
				"aria-expanded": isPopoverOpen,
				"data-user-selector-trigger": true,
				disabled,
				onClick: () => {
					if (disabled) return;
					setIsPopoverOpen((o) => !o);
				},
				className: cls({
					"min-h-[42px] py-1 px-2": size === "small",
					"min-h-[56px] py-2 px-4": size === "medium",
					"min-h-[48px] py-1 px-4": size === "large"
				}, "w-full select-none rounded-lg text-sm relative flex items-center", invisible ? fieldBackgroundInvisibleMixin : fieldBackgroundMixin, disabled ? fieldBackgroundDisabledMixin : fieldBackgroundHoverMixin, className),
				children: /* @__PURE__ */ jsxs("div", {
					className: "flex justify-between items-center w-full",
					children: [resolvedUser ? /* @__PURE__ */ jsx("div", {
						className: "flex flex-row items-center gap-1 truncate flex-1 min-w-0 mr-2",
						children: /* @__PURE__ */ jsx(UserDisplay, { user: resolvedUser })
					}) : value ? /* @__PURE__ */ jsx("span", {
						className: "text-sm truncate text-text-primary dark:text-text-primary-dark",
						children: value
					}) : /* @__PURE__ */ jsx("span", {
						className: "text-sm text-text-secondary dark:text-text-secondary-dark",
						children: resolvedPlaceholder
					}), /* @__PURE__ */ jsxs("div", {
						className: "flex-shrink-0 flex items-center gap-1",
						children: [clearable && !disabled && value && /* @__PURE__ */ jsx(IconButton, {
							size: "small",
							onClick: handleClear,
							children: /* @__PURE__ */ jsx(XIcon, { size: iconSize.small })
						}), /* @__PURE__ */ jsx(ChevronDownIcon, {
							size: size === "small" ? iconSize.small : iconSize.medium,
							className: cls("transition", isPopoverOpen ? "rotate-180" : "")
						})]
					})]
				})
			})
		}), /* @__PURE__ */ jsx(PopoverPrimitive.Portal, {
			container: portalContainer,
			children: /* @__PURE__ */ jsx(PopoverPrimitive.Content, {
				ref: contentRef,
				"data-user-selector-content": true,
				className: cls("z-50 overflow-hidden border bg-surface-card rounded-lg min-w-72", defaultBorderMixin),
				align: "start",
				sideOffset: 8,
				side: "bottom",
				avoidCollisions: true,
				collisionPadding: 16,
				onOpenAutoFocus: (_e) => {},
				onCloseAutoFocus: (e) => {
					e.preventDefault();
				},
				style: { width: "var(--radix-popover-trigger-width)" },
				children: /* @__PURE__ */ jsxs(Command, {
					shouldFilter: false,
					children: [
						/* @__PURE__ */ jsxs("div", {
							className: "flex flex-row items-center",
							children: [/* @__PURE__ */ jsxs("div", {
								className: "relative flex-1",
								children: [/* @__PURE__ */ jsx(SearchIcon, {
									className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary dark:text-text-secondary-dark",
									size: iconSize.smallest
								}), /* @__PURE__ */ jsx(Command.Input, {
									ref: searchInputRef,
									className: cls(focusedDisabled, "bg-transparent outline-hidden flex-1 h-full w-full pl-10 pr-4 py-3 text-text-primary dark:text-text-primary-dark placeholder:text-text-secondary dark:placeholder:text-text-secondary-dark"),
									placeholder: searchPlaceholder,
									value: searchString,
									onValueChange: handleSearchChange
								})]
							}), isLoading && /* @__PURE__ */ jsx("div", {
								className: "flex items-center justify-center px-3",
								children: /* @__PURE__ */ jsx(CircularProgress, { size: "smallest" })
							})]
						}),
						/* @__PURE__ */ jsx(Separator, {
							orientation: "horizontal",
							className: "my-0"
						}),
						/* @__PURE__ */ jsxs(Command.List, {
							ref: scrollContainerRef,
							style: {
								maxHeight: "40vh",
								overflowY: "auto"
							},
							children: [
								isLoading && availableItems.length === 0 && /* @__PURE__ */ jsxs("div", {
									className: "flex items-center justify-center py-6",
									children: [/* @__PURE__ */ jsx(CircularProgress, { size: "small" }), /* @__PURE__ */ jsx("span", {
										className: "ml-2 text-sm text-text-secondary dark:text-text-secondary-dark",
										children: loadingText
									})]
								}),
								!isLoading && availableItems.length === 0 && /* @__PURE__ */ jsx(Command.Empty, {
									className: "px-4 py-6 text-center text-text-secondary dark:text-text-secondary-dark",
									children: noResultsText
								}),
								/* @__PURE__ */ jsxs(Command.Group, { children: [
									availableItems.map((item) => {
										const isSelected = value === item.uid;
										return /* @__PURE__ */ jsx(Command.Item, {
											value: item.uid,
											onMouseDown: (e) => {
												e.preventDefault();
												e.stopPropagation();
											},
											onSelect: () => handleItemClick(item),
											className: cls("flex flex-row items-center gap-1.5 m-1 p-1.5 rounded-xs cursor-pointer ring-offset-transparent", isSelected && "bg-surface-active", "aria-selected:outline-hidden aria-selected:bg-surface-active"),
											children: /* @__PURE__ */ jsx(UserDisplay, { user: item.user })
										}, item.uid);
									}),
									availableItems.length > 0 && hasMore && /* @__PURE__ */ jsx("div", {
										ref: sentinelCallbackRef,
										className: "h-1 w-full",
										style: { visibility: "hidden" }
									}),
									isLoading && availableItems.length > 0 && /* @__PURE__ */ jsxs("div", {
										className: "flex items-center justify-center py-4",
										children: [/* @__PURE__ */ jsx(CircularProgress, { size: "smallest" }), /* @__PURE__ */ jsx("span", {
											className: "ml-2 text-xs text-text-secondary dark:text-text-secondary-dark",
											children: "Loading..."
										})]
									})
								] })
							]
						})
					]
				})
			})
		})]
	}) });
});
UserSelector.displayName = "UserSelector";
//#endregion
//#region src/components/CollectionTableBinding/fields/VirtualTableUserSelect.tsx
function VirtualTableUserSelect(props) {
	const { internalValue, disabled, small, focused, updateValue, multiple } = props;
	return /* @__PURE__ */ jsx(UserSelector, {
		value: Array.isArray(internalValue) ? internalValue[0] ?? null : internalValue ?? null,
		onValueChange: (userId) => {
			updateValue(userId);
		},
		disabled,
		size: "small",
		clearable: true,
		invisible: true
	});
}
//#endregion
//#region src/form/components/StorageUploadProgress.tsx
function StorageUploadProgress({ storagePath, entry, metadata, onFileUploadComplete, imageSize, simple, storageSource: storageSourceProp }) {
	const defaultStorageSource = useStorageSource();
	const storageSource = storageSourceProp ?? defaultStorageSource;
	const snackbarController = useSnackbarController();
	const [error, setError] = React.useState();
	const [loading, setLoading] = React.useState(false);
	const mounted = React.useRef(false);
	const uploading = React.useRef(false);
	const upload = useCallback((file, fileName) => {
		if (uploading.current) return;
		uploading.current = true;
		setError(void 0);
		setLoading(true);
		const key = storagePath && fileName ? `${storagePath}/${fileName}` : fileName || storagePath || "unnamed";
		storageSource.putObject({
			file,
			key,
			metadata
		}).then(async ({ key: resultKey, storageUrl }) => {
			console.debug("Upload successful", resultKey);
			await onFileUploadComplete(resultKey, entry, metadata, storageUrl);
			if (mounted.current) setLoading(false);
		}).catch((e) => {
			console.warn("Upload error", e);
			if (mounted.current) {
				setError(e);
				setLoading(false);
				snackbarController.open({
					type: "error",
					message: "Error uploading file: " + e.message
				});
			}
		}).finally(() => {
			uploading.current = false;
		});
	}, [
		entry,
		metadata,
		onFileUploadComplete,
		storageSource,
		storagePath
	]);
	React.useEffect(() => {
		mounted.current = true;
		if (entry.file) upload(entry.file, entry.fileName);
		return () => {
			mounted.current = false;
		};
	}, [
		entry.file,
		entry.fileName,
		upload
	]);
	if (simple) return /* @__PURE__ */ jsx("div", {
		style: {
			width: imageSize,
			height: imageSize
		},
		children: loading && /* @__PURE__ */ jsx(Skeleton, {
			width: imageSize,
			height: imageSize
		})
	});
	return /* @__PURE__ */ jsxs("div", {
		className: cls(paperMixin, "p-4 relative border-box flex items-center justify-center", `min-w-[${imageSize}px] min-h-[${imageSize}px]`),
		children: [loading && /* @__PURE__ */ jsx(Skeleton, { className: "w-full h-full" }), error && /* @__PURE__ */ jsx(ErrorView, {
			title: "Error uploading file",
			error
		})]
	});
}
//#endregion
//#region src/components/CollectionTableBinding/internal/EntityTableCellActions.tsx
function EntityTableCellActions({ showError, disabled, showExpandIcon, selected, openPopup, children }) {
	const ref = useRef(null);
	const doOpenPopup = useCallback(() => {
		if (openPopup) openPopup(ref && ref?.current?.getBoundingClientRect());
	}, []);
	const iconRef = useRef(void 0);
	useEffect(() => {
		if (iconRef.current && selected) iconRef.current.focus({ preventScroll: true });
	}, [selected]);
	return /* @__PURE__ */ jsx(Fragment, { children: (showError || !disabled && showExpandIcon) && /* @__PURE__ */ jsxs("div", {
		ref,
		className: "absolute top-0.5 right-0.5 flex items-center",
		children: [
			selected && children,
			selected && !disabled && showExpandIcon && /* @__PURE__ */ jsx(IconButton, {
				ref: iconRef,
				color: "inherit",
				size: "small",
				onClick: doOpenPopup,
				children: /* @__PURE__ */ jsxs("svg", {
					fill: "#888",
					width: "20",
					height: "20",
					viewBox: "0 0 24 24",
					children: [/* @__PURE__ */ jsx("path", {
						className: "cls-2",
						d: "M20,5a1,1,0,0,0-1-1L14,4h0a1,1,0,0,0,0,2h2.57L13.29,9.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L18,7.42V10a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1Z"
					}), /* @__PURE__ */ jsx("path", {
						className: "cls-2",
						d: "M10.71,13.29a1,1,0,0,0-1.42,0L6,16.57V14a1,1,0,0,0-1-1H5a1,1,0,0,0-1,1l0,5a1,1,0,0,0,1,1h5a1,1,0,0,0,0-2H7.42l3.29-3.29A1,1,0,0,0,10.71,13.29Z"
					})]
				})
			}),
			showError && /* @__PURE__ */ jsx(ErrorTooltip, {
				side: "left",
				title: showError.message,
				children: /* @__PURE__ */ jsx("div", {
					className: "flex items-center justify-center",
					style: {
						width: 32,
						height: 32
					},
					children: /* @__PURE__ */ jsx(AlertCircleIcon, {})
				})
			})
		]
	}) });
}
//#endregion
//#region src/components/CollectionTableBinding/fields/TableStorageUpload.tsx
var dropZoneClasses$1 = "max-w-full box-border relative pt-[2px] items-center border border-transparent outline-hidden rounded-md duration-200 ease-[cubic-bezier(0.4,0,0.2,1)] focus:border-primary";
var activeDropClasses$1 = "pt-0 border-2 border-solid";
var acceptDropClasses$1 = "transition-colors duration-200 ease-[cubic-bezier(0,0,0.2,1)] border-2 border-solid border-green-500 bg-green-50 dark:bg-green-900";
var rejectDropClasses$1 = "transition-colors duration-200 ease-[cubic-bezier(0,0,0.2,1)] border-2 border-solid border-red-500 bg-red-50 dark:bg-red-900";
/**
* Field that allows to upload files to Google Cloud Storage.
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function TableStorageUpload(props) {
	const { propertyKey, error, selected, openPopup, value, disabled, property, entity, path, previewSize, updateValue } = props;
	const storageSource = useStorageSource();
	const { internalValue, setInternalValue, onFilesAdded, storage, onFileUploadComplete, storagePathBuilder, multipleFilesSupported, resolvedStorageSource } = useStorageUploadController({
		entityValues: entity.values,
		entityId: entity.id,
		path,
		property,
		propertyKey,
		storageSource,
		onChange: updateValue,
		value,
		disabled
	});
	return /* @__PURE__ */ jsx(StorageSourceContext.Provider, {
		value: resolvedStorageSource,
		children: /* @__PURE__ */ jsx(StorageUpload$1, {
			internalValue,
			setInternalValue,
			name: propertyKey,
			disabled,
			autoFocus: false,
			openPopup,
			error,
			selected,
			property,
			onChange: updateValue,
			entity,
			storagePathBuilder,
			storage,
			multipleFilesSupported,
			onFilesAdded,
			onFileUploadComplete,
			previewSize
		})
	});
}
function StorageUpload$1({ property, name, internalValue, setInternalValue, openPopup, entity, selected, error, onChange, multipleFilesSupported, previewSize: previewSizeInput, disabled, autoFocus, storage, onFilesAdded, onFileUploadComplete, storagePathBuilder }) {
	const previewSize = previewSizeInput;
	if (multipleFilesSupported) {
		const arrayProperty = property;
		if (Array.isArray(arrayProperty.of)) throw Error("Using array properties instead of single one in `of` in ArrayProperty");
		if (arrayProperty.of) {
			if (arrayProperty.of.type !== "string") throw Error("Storage field using array must be of data type string");
		} else throw Error("Storage field using array must be of data type string");
	}
	const metadata = storage?.metadata;
	const hasValue = Boolean(internalValue);
	const snackbarContext = useSnackbarController();
	const { t } = useTranslation();
	const { open, getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
		accept: storage.acceptedFiles ? storage.acceptedFiles.map((e) => ({ [e]: [] })).reduce((a, b) => ({
			...a,
			...b
		}), {}) : void 0,
		disabled,
		maxSize: storage.maxSize,
		noClick: true,
		noKeyboard: true,
		onDrop: onFilesAdded,
		onDropRejected: (fileRejections, event) => {
			for (const fileRejection of fileRejections) for (const error of fileRejection.errors) {
				console.error("Error uploading file: ", error);
				if (error.code === "file-too-large") snackbarContext.open({
					type: "error",
					message: t("error_uploading_file_size", { maxSize: String(storage.maxSize) })
				});
				else if (error.code === "file-invalid-type") snackbarContext.open({
					type: "error",
					message: t("error_uploading_file_type")
				});
			}
		}
	});
	const { ...rootProps } = getRootProps();
	const helpText = multipleFilesSupported ? t("drag_drop_files") : t("drag_drop_file");
	const renderProperty = multipleFilesSupported ? property.of : property;
	const imageSize = useMemo(() => getThumbnailMeasure(previewSize), [previewSize]);
	const showError = !disabled && error;
	return /* @__PURE__ */ jsxs("div", {
		...rootProps,
		className: cls(dropZoneClasses$1, "relative w-full h-full flex", `justify-${hasValue ? "start" : "center"}`, isDragActive ? activeDropClasses$1 : "", isDragAccept ? acceptDropClasses$1 : "", isDragReject ? rejectDropClasses$1 : ""),
		children: [
			/* @__PURE__ */ jsx("input", {
				autoFocus,
				...getInputProps()
			}),
			internalValue.map((entry, index) => {
				let child;
				if (entry.storagePathOrDownloadUrl) child = /* @__PURE__ */ jsx(TableStorageItemPreview, {
					propertyKey: name,
					property: renderProperty,
					value: entry.storagePathOrDownloadUrl,
					entity,
					size: previewSize
				}, `storage_preview_${index}`);
				else if (entry.file) child = /* @__PURE__ */ jsx(StorageUploadProgress, {
					entry,
					metadata,
					storagePath: storagePathBuilder(entry.file),
					onFileUploadComplete,
					imageSize,
					simple: true
				}, `storage_progress_${index}`);
				return child;
			}),
			!internalValue && /* @__PURE__ */ jsx("div", {
				className: "grow m-2 max-w-[200px]",
				onClick: open,
				children: /* @__PURE__ */ jsx(Typography, {
					className: "text-surface-400 dark:text-surface-600",
					variant: "body2",
					align: "center",
					children: helpText
				})
			}),
			/* @__PURE__ */ jsx(EntityTableCellActions, {
				showError,
				disabled,
				showExpandIcon: true,
				selected,
				openPopup: !disabled ? openPopup : void 0,
				children: /* @__PURE__ */ jsx(IconButton, {
					color: "inherit",
					size: "small",
					onClick: open,
					children: /* @__PURE__ */ jsx(PencilIcon, { className: "text-surface-500" })
				})
			})
		]
	});
}
function TableStorageItemPreview({ propertyKey, property, value, size, entity }) {
	return /* @__PURE__ */ jsx("div", {
		className: "relative p-2 max-w-full",
		children: value && /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(PropertyPreview, {
			propertyKey,
			value,
			property,
			size
		}) })
	});
}
//#endregion
//#region src/components/CollectionTableBinding/fields/CompactEntityCellField.tsx
/**
* The one-line editor a reference or relation cell shows while selected, at
* the row sizes that carry small previews (`xs`, `s`, `m`).
*
* The flow it replaces: at 48px the selected cell swapped its resting inline
* line for the card editor built for 140px rows, which was clipped to its top
* third and whose only click opened the picker — there was no way to look at
* the record. Here the line stays (its title opens the record in the side
* panel, exactly as it does at rest), a pencil opens the picker and a cross
* clears the value. Click the name to see it, click the pencil to change it.
*/
function CompactEntityCellField({ children, empty, disabled, onEdit, onClear, emptyLabel }) {
	const { t } = useTranslation();
	return /* @__PURE__ */ jsxs("div", {
		className: "w-full min-w-0 flex items-center gap-0.5 min-h-8",
		children: [/* @__PURE__ */ jsx("div", {
			className: "grow min-w-0 flex items-center gap-x-3 overflow-hidden text-sm",
			children: empty ? /* @__PURE__ */ jsx("button", {
				type: "button",
				disabled,
				onClick: (e) => {
					e.stopPropagation();
					onEdit();
				},
				className: cls("truncate text-left text-text-secondary dark:text-text-secondary-dark", !disabled && "cursor-pointer hover:text-text-primary dark:hover:text-text-primary-dark"),
				children: emptyLabel ?? t("select_reference")
			}) : children
		}), !disabled && /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(Tooltip, {
			title: t("edit"),
			children: /* @__PURE__ */ jsx(IconButton, {
				size: "small",
				"aria-label": t("edit"),
				onClick: (e) => {
					e.stopPropagation();
					onEdit();
				},
				children: /* @__PURE__ */ jsx(PencilIcon, {})
			})
		}), !empty && /* @__PURE__ */ jsx(Tooltip, {
			title: t("clear"),
			children: /* @__PURE__ */ jsx(IconButton, {
				size: "small",
				"aria-label": t("clear"),
				onClick: (e) => {
					e.stopPropagation();
					onClear();
				},
				children: /* @__PURE__ */ jsx(XIcon, {})
			})
		})] })]
	});
}
//#endregion
//#region src/components/CollectionTableBinding/fields/TableReferenceField.tsx
var DefaultMissingReference = () => null;
function TableReferenceFieldResolver(props) {
	const ResolvedMissingReference = useComponentOverride("Entity.MissingReference", DefaultMissingReference);
	const { path, collection } = props;
	if (!collection) if (ResolvedMissingReference !== DefaultMissingReference) return /* @__PURE__ */ jsx(ResolvedMissingReference, { path });
	else return /* @__PURE__ */ jsx(ErrorView, { error: `Collection not found: ${path}` });
	return /* @__PURE__ */ jsx(TableReferenceFieldInternal, {
		...props,
		collection
	});
}
function TableReferenceField(props) {
	const collectionRegistryController = useCollectionRegistryController();
	const { path } = props;
	const collection = collectionRegistryController.getCollection(path);
	const content = /* @__PURE__ */ jsx(TableReferenceFieldResolver, {
		...props,
		collection
	});
	if (collection) return /* @__PURE__ */ jsx(CollectionScopeProvider, {
		collection,
		children: content
	});
	return content;
}
var TableReferenceFieldInternal = React.memo(function TableReferenceFieldInternal(props) {
	const { name, internalValue, updateValue, multiselect, path, size, previewProperties, title, disabled, fixedFilter, collection, includeId, includeEntityLink } = props;
	const onSingleEntitySelected = useCallback((entity) => {
		updateValue(entity ? getReferenceFrom(entity) : null);
	}, [updateValue]);
	const referenceDialogController = useSelectionDialog({
		multiselect,
		path,
		collection,
		onMultipleEntitiesSelected: useCallback((entities) => {
			updateValue(entities.map((e) => getReferenceFrom(e)));
		}, [updateValue]),
		onSingleEntitySelected,
		selectedEntityIds: internalValue ? Array.isArray(internalValue) ? internalValue.map((ref) => ref.id) : internalValue.id ? [internalValue.id] : [] : [],
		fixedFilter
	});
	const handleOpen = () => {
		if (disabled) return;
		referenceDialogController.open();
	};
	const valueNotSet = !internalValue || Array.isArray(internalValue) && internalValue.length === 0;
	const buildSingleReferenceField = () => {
		if (internalValue && !Array.isArray(internalValue) && internalValue.isEntityReference && internalValue.isEntityReference()) return /* @__PURE__ */ jsx(ReferencePreview, {
			onClick: disabled ? void 0 : handleOpen,
			size: getPreviewSizeFrom(size),
			reference: internalValue,
			hover: !disabled,
			disabled: !path,
			previewProperties,
			includeId,
			includeEntityLink
		});
		else return /* @__PURE__ */ jsx(EntityPreviewContainer, {
			onClick: disabled ? void 0 : handleOpen,
			size: getPreviewSizeFrom(size),
			children: /* @__PURE__ */ jsx(ErrorView, {
				title: "Value is not a reference.",
				error: "Click to edit"
			})
		});
	};
	const buildMultipleReferenceField = () => {
		if (Array.isArray(internalValue)) return /* @__PURE__ */ jsx(Fragment, { children: internalValue.map((reference, index) => /* @__PURE__ */ jsx("div", {
			className: "w-full my-0.5",
			children: /* @__PURE__ */ jsx(ReferencePreview, {
				onClick: disabled ? void 0 : handleOpen,
				size: "small",
				reference,
				hover: !disabled,
				disabled: !path,
				previewProperties,
				includeId,
				includeEntityLink
			})
		}, `preview_array_ref_${name}_${index}`)) });
		else return /* @__PURE__ */ jsx(ErrorView, { error: "Data is not an array of references" });
	};
	if (!collection) return /* @__PURE__ */ jsx(ErrorView, { error: "The specified collection does not exist" });
	if (getPreviewSizeFrom(size) === "small") return /* @__PURE__ */ jsx(CompactEntityCellField, {
		empty: valueNotSet,
		disabled,
		onEdit: handleOpen,
		onClear: () => updateValue(multiselect ? [] : null),
		emptyLabel: title,
		children: (!internalValue ? [] : Array.isArray(internalValue) ? internalValue : [internalValue]).map((reference, index) => reference && reference.isEntityReference && reference.isEntityReference() ? /* @__PURE__ */ jsx(ReferencePreview, {
			size: "small",
			reference,
			hover: false,
			disabled: !path,
			previewProperties,
			includeId,
			includeEntityLink
		}, `compact_ref__`) : /* @__PURE__ */ jsx(ErrorView, { error: "Value is not a reference" }, `compact_ref__`))
	});
	return /* @__PURE__ */ jsxs("div", {
		className: "w-full group",
		children: [
			internalValue && !multiselect && buildSingleReferenceField(),
			internalValue && multiselect && buildMultipleReferenceField(),
			valueNotSet && /* @__PURE__ */ jsxs(EntityPreviewContainer, {
				className: cls("px-3 py-2 text-sm font-medium flex items-center", multiselect ? "gap-4" : "gap-6", disabled ? "text-surface-accent-500" : "cursor-pointer text-text-secondary dark:text-text-secondary-dark hover:bg-surface-hover group-hover:bg-surface-hover"),
				onClick: handleOpen,
				size: "medium",
				children: [/* @__PURE__ */ jsx(PencilIcon, { className: "ml-2 mr-1 text-surface-300 dark:text-surface-600" }), title]
			})
		]
	});
}, deepEqual);
//#endregion
//#region src/components/CollectionTableBinding/fields/TableMultipleRelationField.tsx
function TableMultipleRelationField(props) {
	const collection = props.relation.target();
	return /* @__PURE__ */ jsx(TableMultipleRelationFieldInternal, {
		...props,
		collection
	});
}
var TableMultipleRelationFieldInternal = React.memo(function TableMultipleRelationFieldInternal(props) {
	const { name, internalValue, updateValue, previewProperties, title, disabled, fixedFilter, collection, includeId, includeEntityLink, size } = props;
	const value = Array.isArray(internalValue) ? internalValue : [];
	const onMultipleEntitiesSelected = useCallback((entities) => {
		updateValue(entities.map((e) => getRelationFrom(e)));
	}, [updateValue]);
	const selectedEntityIds = value.map((ref) => ref.id);
	const relationDialogController = useSelectionDialog({
		multiselect: true,
		path: getCollectionDataPath(collection),
		collection,
		onMultipleEntitiesSelected,
		selectedEntityIds,
		fixedFilter
	});
	const handleOpen = () => {
		if (disabled) return;
		relationDialogController.open();
	};
	const valueNotSet = !internalValue || Array.isArray(internalValue) && internalValue.length === 0;
	const buildMultipleRelationField = () => {
		if (Array.isArray(internalValue)) return /* @__PURE__ */ jsx(Fragment, { children: internalValue.map((item, index) => {
			const relationItem = normalizeToEntityRelation(item);
			if (!relationItem) return null;
			return /* @__PURE__ */ jsx("div", {
				className: "w-full my-0.5",
				children: /* @__PURE__ */ jsx(RelationPreview, {
					onClick: disabled ? void 0 : handleOpen,
					size: "small",
					relation: relationItem,
					hover: !disabled,
					previewProperties,
					includeId,
					includeEntityLink
				})
			}, `preview_array_ref_${name}_${index}`);
		}) });
		else return /* @__PURE__ */ jsx(ErrorView, { error: "Data is not an array of relations" });
	};
	if (!collection) return /* @__PURE__ */ jsx(ErrorView, { error: "The specified collection does not exist" });
	if (getPreviewSizeFrom(size) === "small") return /* @__PURE__ */ jsx(CompactEntityCellField, {
		empty: valueNotSet,
		disabled,
		onEdit: handleOpen,
		onClear: () => updateValue([]),
		emptyLabel: title,
		children: value.map((item, index) => {
			const relationItem = normalizeToEntityRelation(item);
			if (!relationItem) return null;
			return /* @__PURE__ */ jsx(RelationPreview, {
				size: "small",
				relation: relationItem,
				hover: false,
				previewProperties,
				includeId,
				includeEntityLink
			}, `compact_rel__`);
		})
	});
	return /* @__PURE__ */ jsxs("div", {
		className: "w-full group",
		children: [internalValue && buildMultipleRelationField(), valueNotSet && /* @__PURE__ */ jsxs(EntityPreviewContainer, {
			className: cls("px-3 py-2 text-sm font-medium flex items-center gap-4", disabled ? "text-surface-accent-500" : "cursor-pointer text-text-secondary dark:text-text-secondary-dark hover:bg-surface-hover group-hover:bg-surface-hover"),
			onClick: handleOpen,
			size: "medium",
			children: [/* @__PURE__ */ jsx(PencilIcon, { className: "ml-2 mr-1 text-surface-300 dark:text-surface-600" }), title]
		})]
	});
}, deepEqual);
//#endregion
//#region src/components/CollectionTableBinding/fields/TableRelationField.tsx
/** Whether an authored relation yields many rows. Derived from its kind. */
function relationCardinality$3(relation) {
	if (!relation) return void 0;
	if (relation.kind === "via") return relation.cardinality;
	if (relation.kind === "hasMany" || relation.kind === "manyToMany") return "many";
	if (relation.kind === "belongsTo" || relation.kind === "hasOne") return "one";
	return relation.cardinality;
}
function TableRelationField(props) {
	const collection = props.relation.target();
	if (relationCardinality$3(props.relation) === "many") return /* @__PURE__ */ jsx(TableMultipleRelationField, {
		name: props.name,
		disabled: props.disabled,
		internalValue: Array.isArray(props.internalValue) ? props.internalValue : [],
		updateValue: (newValue) => props.updateValue(newValue),
		size: props.size,
		previewProperties: props.previewProperties,
		title: props.title,
		relation: props.relation,
		fixedFilter: props.fixedFilter,
		includeId: props.includeId,
		includeEntityLink: props.includeEntityLink
	});
	return /* @__PURE__ */ jsx(TableRelationFieldInternal, {
		...props,
		collection
	});
}
var TableRelationFieldInternal = React.memo(function TableRelationFieldInternal(props) {
	const { name, internalValue, updateValue, multiselect, relation, size, previewProperties, title, disabled, fixedFilter, collection, includeId, includeEntityLink } = props;
	const onSingleEntitySelected = useCallback((entity) => {
		updateValue(entity ? getRelationFrom(entity) : null);
	}, [updateValue]);
	const onMultipleEntitiesSelected = useCallback((entities) => {
		updateValue(entities.map((e) => getRelationFrom(e)));
	}, [updateValue]);
	const selectedEntityIds = internalValue ? Array.isArray(internalValue) ? internalValue.map((ref) => ref.id) : internalValue.id ? [internalValue.id] : [] : [];
	const relationDialogController = useSelectionDialog({
		multiselect,
		path: getCollectionDataPath(collection),
		collection,
		onMultipleEntitiesSelected,
		onSingleEntitySelected,
		selectedEntityIds,
		fixedFilter
	});
	const handleOpen = () => {
		if (disabled) return;
		relationDialogController.open();
	};
	const valueNotSet = !internalValue || Array.isArray(internalValue) && internalValue.length === 0;
	const buildSingleRelationField = () => {
		const normalizedRelation = normalizeToEntityRelation(internalValue);
		if (normalizedRelation) return /* @__PURE__ */ jsx(RelationPreview, {
			onClick: disabled ? void 0 : handleOpen,
			size: getPreviewSizeFrom(size),
			relation: normalizedRelation,
			hover: !disabled,
			previewProperties,
			includeId,
			includeEntityLink
		});
		else return /* @__PURE__ */ jsx(EntityPreviewContainer, {
			onClick: disabled ? void 0 : handleOpen,
			size: getPreviewSizeFrom(size),
			children: /* @__PURE__ */ jsx(ErrorView, {
				title: "Value is not a relation.",
				error: "Click to edit"
			})
		});
	};
	const buildMultipleRelationField = () => {
		if (Array.isArray(internalValue)) return /* @__PURE__ */ jsx(Fragment, { children: internalValue.map((relationItem, index) => /* @__PURE__ */ jsx("div", {
			className: "w-full my-0.5",
			children: /* @__PURE__ */ jsx(RelationPreview, {
				onClick: disabled ? void 0 : handleOpen,
				size: "small",
				relation: relationItem,
				hover: !disabled,
				previewProperties,
				includeId,
				includeEntityLink
			})
		}, `preview_array_ref_${name}_${index}`)) });
		else return /* @__PURE__ */ jsx(ErrorView, { error: "Data is not an array of relations" });
	};
	if (!collection) return /* @__PURE__ */ jsx(ErrorView, { error: "The specified collection does not exist" });
	if (getPreviewSizeFrom(size) === "small") return /* @__PURE__ */ jsx(CompactEntityCellField, {
		empty: valueNotSet,
		disabled,
		onEdit: handleOpen,
		onClear: () => updateValue(multiselect ? [] : null),
		emptyLabel: title,
		children: (!internalValue ? [] : Array.isArray(internalValue) ? internalValue : [internalValue]).map((item, index) => {
			const relationItem = normalizeToEntityRelation(item);
			if (!relationItem) return null;
			return /* @__PURE__ */ jsx(RelationPreview, {
				size: "small",
				relation: relationItem,
				hover: false,
				previewProperties,
				includeId,
				includeEntityLink
			}, `compact_rel__`);
		})
	});
	return /* @__PURE__ */ jsxs("div", {
		className: "w-full group",
		children: [
			internalValue && !multiselect && buildSingleRelationField(),
			internalValue && multiselect && buildMultipleRelationField(),
			valueNotSet && /* @__PURE__ */ jsxs(EntityPreviewContainer, {
				className: cls("px-3 py-2 text-sm font-medium flex items-center", multiselect ? "gap-4" : "gap-6", disabled ? "text-surface-accent-500" : "cursor-pointer text-text-secondary dark:text-text-secondary-dark hover:bg-surface-hover group-hover:bg-surface-hover"),
				onClick: handleOpen,
				size: "medium",
				children: [/* @__PURE__ */ jsx(PencilIcon, { className: "ml-2 mr-1 text-surface-300 dark:text-surface-600" }), title]
			})
		]
	});
}, deepEqual);
//#endregion
//#region src/components/RelationSelector.tsx
/** Whether an authored relation yields many rows. Derived from its kind. */
function relationCardinality$2(relation) {
	if (!relation) return void 0;
	if (relation.kind === "via") return relation.cardinality;
	if (relation.kind === "hasMany" || relation.kind === "manyToMany") return "many";
	if (relation.kind === "belongsTo" || relation.kind === "hasOne") return "one";
	return relation.cardinality;
}
var RelationSelector = React$1.forwardRef(({ value, size = "medium", onValueChange, invisible, disabled, placeholder, useChips = true, className, relation, multiple: multipleOverride, fixedFilter, pageSize, emptyPlaceholder, searchPlaceholder = "Search...", noResultsText = "No matches.", emptyText = "Select…", emptyCollectionText, loadingText = "Loading...", allowCreate = true }, ref) => {
	const collection = relation.target();
	const dataPath = getCollectionDataPath(collection);
	const dataClient = useData();
	const sidePanelController = useSidePanel();
	const { canCreate } = usePermissions();
	const { t } = useTranslation();
	const contextPortalContainer = usePortalContainer();
	const multiple = multipleOverride ?? relationCardinality$2(relation) === "many";
	const [isPopoverOpen, setIsPopoverOpen] = useState(false);
	const isPopoverOpenRef = useRef(false);
	const [listRequested, setListRequested] = useState(false);
	const [selectedItems, setSelectedItems] = useState([]);
	const [isLoadingSelectedItems, setIsLoadingSelectedItems] = useState(false);
	const [searchString, setSearchString] = useState("");
	const localSelectionIdsRef = useRef(null);
	const pinnedIdsRef = useRef(null);
	const { items: availableItems, isLoading, hasMore, search, loadMore, entityToRelationItem } = useRelationSelector({
		path: dataPath,
		collection,
		fixedFilter,
		pageSize,
		enabled: listRequested
	});
	const scrollContainerRef = useRef(null);
	const sentinelRef = useRef(null);
	const observerRef = useRef(null);
	const localTriggerRef = useRef(null);
	const handleButtonRef = useCallback((node) => {
		localTriggerRef.current = node;
		if (typeof ref === "function") ref(node);
		else if (ref) ref.current = node;
	}, [ref]);
	const contentRef = useRef(null);
	const searchInputRef = useRef(null);
	const dataClientRef = useRef(dataClient);
	dataClientRef.current = dataClient;
	const entityToRelationItemRef = useRef(entityToRelationItem);
	entityToRelationItemRef.current = entityToRelationItem;
	const collectionSlugRef = useRef(collection.slug);
	collectionSlugRef.current = collection.slug;
	const resolvedIdsRef = useRef("");
	const hasResolvedItemsRef = useRef(false);
	const selectedItemsRef = useRef(selectedItems);
	selectedItemsRef.current = selectedItems;
	const relationsArray = (!value ? [] : Array.isArray(value) ? value : [value]).map((rel) => {
		if (typeof rel === "string" || typeof rel === "number") return rel;
		return normalizeToEntityRelation(rel) ?? rel;
	});
	const incomingIds = relationsArray.map((rel) => {
		return String(typeof rel === "string" || typeof rel === "number" ? rel : rel.id);
	}).sort().join(",");
	const allHaveData = relationsArray.length > 0 && relationsArray.every((rel) => {
		if (typeof rel === "string" || typeof rel === "number") return false;
		return !!rel?.data;
	});
	const relationsArrayRef = useRef(relationsArray);
	relationsArrayRef.current = relationsArray;
	useEffect(() => {
		let active = true;
		const currentRelationsArray = relationsArrayRef.current;
		if (incomingIds === resolvedIdsRef.current && (allHaveData || hasResolvedItemsRef.current)) return;
		if (localSelectionIdsRef.current !== null && incomingIds === localSelectionIdsRef.current) {
			resolvedIdsRef.current = incomingIds;
			hasResolvedItemsRef.current = true;
			return;
		}
		const currentSelected = selectedItemsRef.current;
		const currentSelectedMap = new Map(currentSelected.map((item) => [String(item.id), item]));
		let allCovered = true;
		const newResolvedItems = [];
		const toRelationItem = entityToRelationItemRef.current;
		const slug = collectionSlugRef.current;
		for (const rel of currentRelationsArray) {
			const isPrimitive = typeof rel === "string" || typeof rel === "number";
			const relId = String(isPrimitive ? rel : rel.id);
			if (!isPrimitive && !!rel.data) {
				const r = rel;
				newResolvedItems.push(toRelationItem(r.data, r));
			} else if (currentSelectedMap.has(relId)) {
				const existingItem = currentSelectedMap.get(relId);
				newResolvedItems.push(existingItem);
			} else {
				allCovered = false;
				break;
			}
		}
		if (allCovered) {
			setSelectedItems(newResolvedItems);
			hasResolvedItemsRef.current = true;
			resolvedIdsRef.current = incomingIds;
			setIsLoadingSelectedItems(false);
			return;
		}
		if (!isPopoverOpenRef.current) setIsLoadingSelectedItems(true);
		const client = dataClientRef.current;
		Promise.all(currentRelationsArray.map(async (rel) => {
			const isPrimitive = typeof rel === "string" || typeof rel === "number";
			const relId = isPrimitive ? rel : rel.id;
			const path = isPrimitive ? slug : rel.path;
			const relation = isPrimitive ? new EntityRelation(relId, path) : rel;
			if (!isPrimitive && rel.data) return toRelationItem(rel.data, relation);
			if (currentSelectedMap.has(String(relId))) return currentSelectedMap.get(String(relId));
			try {
				const entity = await client.collection(path).findById(relId);
				if (entity) return toRelationItem(entity, relation);
			} catch (e) {
				console.warn("RelationSelector: could not fetch entity for relation", rel, e);
			}
			return {
				id: relId,
				label: String(relId),
				relation
			};
		})).then((resolved) => {
			if (active) {
				setSelectedItems(resolved);
				setIsLoadingSelectedItems(false);
				hasResolvedItemsRef.current = true;
				resolvedIdsRef.current = incomingIds;
			}
		});
		return () => {
			active = false;
		};
	}, [incomingIds, allHaveData]);
	const sentinelCallbackRef = useCallback((node) => {
		if (observerRef.current) {
			observerRef.current.disconnect();
			observerRef.current = null;
		}
		if (sentinelRef.current !== node) sentinelRef.current = node;
		if (!node || !hasMore || isLoading || !loadMore) return;
		const observer = new IntersectionObserver((entries) => {
			if (entries[0].isIntersecting && hasMore && !isLoading) loadMore();
		}, {
			root: scrollContainerRef.current,
			rootMargin: "20px",
			threshold: 0
		});
		observer.observe(node);
		observerRef.current = observer;
	}, [
		hasMore,
		isLoading,
		loadMore
	]);
	useEffect(() => () => {
		if (observerRef.current) observerRef.current.disconnect();
	}, []);
	useEffect(() => {
		const scrollContainer = scrollContainerRef.current;
		if (!scrollContainer || !hasMore || isLoading || !isPopoverOpen) return;
		const handleScroll = () => {
			const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
			if (scrollTop + clientHeight >= scrollHeight - 100 && hasMore && !isLoading) loadMore();
		};
		scrollContainer.addEventListener("scroll", handleScroll, { passive: true });
		return () => {
			scrollContainer.removeEventListener("scroll", handleScroll);
		};
	}, [
		hasMore,
		isLoading,
		loadMore,
		isPopoverOpen
	]);
	const handleSearchChange = useCallback((newSearchString) => {
		setSearchString(newSearchString);
		search(newSearchString);
	}, [search]);
	const emitValueChange = useCallback((selected) => {
		if (multiple) onValueChange?.(selected.length ? selected.map((i) => i.relation) : void 0);
		else onValueChange?.(selected[0]?.relation);
	}, [onValueChange, multiple]);
	const emitValueChangeRef = useRef(emitValueChange);
	emitValueChangeRef.current = emitValueChange;
	const computeSelectionFingerprint = useCallback((items) => {
		return items.map((i) => String(i.id)).sort().join(",");
	}, []);
	const onItemClick = useCallback((item) => {
		let newSelected;
		if (multiple) newSelected = selectedItems.some((v) => String(v.id) === String(item.id)) ? selectedItems.filter((v) => String(v.id) !== String(item.id)) : [...selectedItems, item];
		else {
			newSelected = [item];
			setIsPopoverOpen(false);
			isPopoverOpenRef.current = false;
			pinnedIdsRef.current = null;
		}
		setSelectedItems(newSelected);
		localSelectionIdsRef.current = computeSelectionFingerprint(newSelected);
		emitValueChange(newSelected);
	}, [
		multiple,
		selectedItems,
		emitValueChange,
		computeSelectionFingerprint
	]);
	const handleClear = useCallback(() => {
		setSelectedItems([]);
		localSelectionIdsRef.current = "";
		onValueChange?.(void 0);
	}, [onValueChange]);
	const handleRemoveItem = useCallback((itemToRemove) => {
		const newSelected = selectedItems.filter((v) => String(v.id) !== String(itemToRemove.id));
		setSelectedItems(newSelected);
		localSelectionIdsRef.current = computeSelectionFingerprint(newSelected);
		emitValueChange(newSelected);
	}, [
		selectedItems,
		emitValueChange,
		computeSelectionFingerprint
	]);
	const handleRootOpenChange = useCallback((next) => {
		if (disabled) return;
		if (next) {
			pinnedIdsRef.current = new Set(selectedItems.map((i) => String(i.id)));
			setListRequested(true);
			setIsPopoverOpen(true);
			isPopoverOpenRef.current = true;
		}
	}, [disabled, selectedItems]);
	useEffect(() => {
		if (!isPopoverOpen) return;
		function handlePointerDown(ev) {
			const target = ev.target;
			const triggerEl = localTriggerRef.current;
			const contentEl = contentRef.current;
			if (triggerEl?.contains(target)) return;
			if (contentEl?.contains(target)) return;
			setIsPopoverOpen(false);
			isPopoverOpenRef.current = false;
			pinnedIdsRef.current = null;
		}
		function handleKey(ev) {
			if (ev.key === "Escape") {
				setIsPopoverOpen(false);
				isPopoverOpenRef.current = false;
				pinnedIdsRef.current = null;
			}
		}
		document.addEventListener("mousedown", handlePointerDown, true);
		document.addEventListener("keydown", handleKey, true);
		return () => {
			document.removeEventListener("mousedown", handlePointerDown, true);
			document.removeEventListener("keydown", handleKey, true);
		};
	}, [isPopoverOpen]);
	const closePopover = useCallback(() => {
		setIsPopoverOpen(false);
		isPopoverOpenRef.current = false;
		pinnedIdsRef.current = null;
	}, []);
	const canCreateTarget = allowCreate && canCreate(collection, dataPath);
	const buildDefaultValues = useCallback((searchText) => {
		const trimmed = searchText.trim();
		if (!trimmed) return void 0;
		const titleKey = getTitlePropertyKey(collection);
		if (!titleKey || titleKey.includes(".")) return void 0;
		const titleProperty = collection.properties?.[titleKey];
		if (!titleProperty || typeof titleProperty === "function") return void 0;
		if (titleProperty.type !== "string" || titleProperty.enum) return void 0;
		return { [titleKey]: trimmed };
	}, [collection]);
	const handleCreateNew = useCallback(() => {
		const defaultValues = buildDefaultValues(searchString);
		closePopover();
		sidePanelController.open({
			path: dataPath,
			collection,
			updateUrl: false,
			closeOnSave: true,
			defaultValues,
			onUpdate: ({ entity }) => {
				if (!entity) return;
				const item = entityToRelationItemRef.current(entity, new EntityRelation(entity.id, dataPath));
				const current = selectedItemsRef.current;
				const newSelected = multiple ? [...current.filter((i) => String(i.id) !== String(item.id)), item] : [item];
				setSelectedItems(newSelected);
				localSelectionIdsRef.current = newSelected.map((i) => String(i.id)).sort().join(",");
				emitValueChangeRef.current(newSelected);
			}
		});
	}, [
		buildDefaultValues,
		searchString,
		closePopover,
		sidePanelController,
		dataPath,
		collection,
		multiple
	]);
	const resolvedPlaceholder = placeholder || emptyPlaceholder || emptyText;
	const portalContainer = contextPortalContainer ?? (typeof document !== "undefined" ? document.body : void 0) ?? void 0;
	return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(PopoverPrimitive.Root, {
		open: isPopoverOpen,
		onOpenChange: handleRootOpenChange,
		modal: false,
		children: [/* @__PURE__ */ jsx(PopoverPrimitive.Trigger, {
			asChild: true,
			children: /* @__PURE__ */ jsx("button", {
				ref: handleButtonRef,
				type: "button",
				"aria-haspopup": "listbox",
				"aria-expanded": isPopoverOpen,
				"data-relation-selector-trigger": true,
				disabled,
				onClick: () => {
					if (disabled) return;
					setListRequested(true);
					setIsPopoverOpen((o) => {
						const next = !o;
						isPopoverOpenRef.current = next;
						if (next) pinnedIdsRef.current = new Set(selectedItems.map((i) => String(i.id)));
						else pinnedIdsRef.current = null;
						return next;
					});
				},
				className: cls({
					"min-h-8 py-0.5 px-2": size === "compact",
					"min-h-[42px] py-1 px-2": size === "small",
					"min-h-[56px] py-2 px-4": size === "medium",
					"min-h-[48px] py-1 px-4": size === "large"
				}, "w-full select-none rounded-lg text-sm relative flex items-center", invisible ? fieldBackgroundInvisibleMixin : fieldBackgroundMixin, disabled ? fieldBackgroundDisabledMixin : fieldBackgroundHoverMixin, className),
				children: /* @__PURE__ */ jsxs("div", {
					className: "flex justify-between items-center w-full",
					children: [isLoadingSelectedItems ? /* @__PURE__ */ jsxs("div", {
						className: "flex items-center gap-2",
						children: [/* @__PURE__ */ jsx(CircularProgress, { size: "smallest" }), /* @__PURE__ */ jsx("span", {
							className: "text-sm text-text-secondary dark:text-text-secondary-dark",
							children: loadingText
						})]
					}) : selectedItems.length > 0 ? /* @__PURE__ */ jsx("div", {
						className: "flex flex-wrap items-center gap-1.5 text-start flex-1 min-w-0 mr-2",
						children: selectedItems.map((item) => {
							if (!useChips || !multiple) {
								if (size === "compact") return item.data ? /* @__PURE__ */ jsx(InlineEntityPreview, {
									entity: item.data,
									onClick: () => {
										closePopover();
										sidePanelController.open({
											entityId: item.data.id,
											path: item.data.path,
											collection,
											updateUrl: true
										});
									}
								}, String(item.id)) : /* @__PURE__ */ jsx("span", {
									className: "text-sm truncate",
									children: item.label
								}, String(item.id));
								return /* @__PURE__ */ jsx("div", {
									className: "flex flex-row items-center gap-1 truncate",
									children: item.data ? /* @__PURE__ */ jsx(EntityPreviewBindingData, {
										size: "medium",
										entity: item.data,
										includeEntityLink: false,
										includeId: false,
										onSidePanelClick: closePopover
									}) : /* @__PURE__ */ jsx("span", {
										className: "text-sm truncate",
										children: item.label
									})
								}, String(item.id));
							}
							return /* @__PURE__ */ jsxs(Chip, {
								size: "small",
								className: cls("flex flex-row items-center gap-1 truncate"),
								children: [item.data ? /* @__PURE__ */ jsx(EntityPreviewBindingData, {
									size: "smallest",
									entity: item.data,
									includeEntityLink: false,
									includeId: false
								}) : /* @__PURE__ */ jsx("span", {
									className: "text-sm truncate",
									children: item.label
								}), /* @__PURE__ */ jsx(XIcon, {
									size: iconSize.smallest,
									onClick: (event) => {
										event.stopPropagation();
										handleRemoveItem(item);
									}
								})]
							}, String(item.id));
						})
					}) : /* @__PURE__ */ jsx("span", {
						className: "text-sm text-text-secondary dark:text-text-secondary-dark",
						children: resolvedPlaceholder
					}), /* @__PURE__ */ jsxs("div", {
						className: "flex items-center flex-shrink-0",
						children: [size !== "compact" && !multiple && selectedItems.length === 1 && selectedItems[0]?.data && /* @__PURE__ */ jsx(Tooltip, {
							title: `Open ${selectedItems[0].label}`,
							children: /* @__PURE__ */ jsx(IconButton, {
								component: "div",
								size: "small",
								color: "inherit",
								className: "opacity-60 hover:opacity-100",
								onClick: (e) => {
									e.stopPropagation();
									e.preventDefault();
									const entity = selectedItems[0].data;
									setIsPopoverOpen(false);
									sidePanelController.open({
										entityId: entity.id,
										path: entity.path,
										collection,
										updateUrl: true
									});
								},
								children: /* @__PURE__ */ jsx(ArrowRightToLineIcon, { size: iconSize.small })
							})
						}), /* @__PURE__ */ jsx(ChevronDownIcon, {
							size: size === "small" || size === "compact" ? iconSize.small : iconSize.medium,
							className: cls("transition", isPopoverOpen ? "rotate-180" : "")
						})]
					})]
				})
			})
		}), /* @__PURE__ */ jsx(PopoverPrimitive.Portal, {
			container: portalContainer,
			children: /* @__PURE__ */ jsx(PopoverPrimitive.Content, {
				ref: contentRef,
				"data-relation-selector-content": true,
				className: cls("z-50 overflow-hidden border bg-surface-card rounded-lg min-w-72", defaultBorderMixin),
				align: "start",
				sideOffset: 8,
				side: "bottom",
				avoidCollisions: true,
				collisionPadding: 16,
				onOpenAutoFocus: (_e) => {},
				onCloseAutoFocus: (e) => {
					e.preventDefault();
				},
				style: { width: "var(--radix-popover-trigger-width)" },
				children: /* @__PURE__ */ jsxs(Command, {
					shouldFilter: false,
					children: [
						/* @__PURE__ */ jsxs("div", {
							className: "flex flex-row items-center",
							children: [
								/* @__PURE__ */ jsxs("div", {
									className: "relative flex-1",
									children: [/* @__PURE__ */ jsx(SearchIcon, {
										className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-text-secondary dark:text-text-secondary-dark",
										size: iconSize.smallest
									}), /* @__PURE__ */ jsx(Command.Input, {
										ref: searchInputRef,
										className: cls(focusedDisabled, "bg-transparent outline-hidden flex-1 h-full w-full pl-10 pr-4 py-3 text-text-primary dark:text-text-primary-dark placeholder:text-text-secondary dark:placeholder:text-text-secondary-dark"),
										placeholder: searchPlaceholder,
										value: searchString,
										onValueChange: handleSearchChange
									})]
								}),
								isLoading && /* @__PURE__ */ jsx("div", {
									className: "flex items-center justify-center px-3",
									children: /* @__PURE__ */ jsx(CircularProgress, { size: "smallest" })
								}),
								selectedItems.length > 0 && /* @__PURE__ */ jsx("div", {
									onClick: handleClear,
									className: "text-sm justify-center cursor-pointer py-3 px-4 text-text-secondary dark:text-text-secondary-dark hover:text-text-primary dark:hover:text-text-primary-dark",
									children: "Clear"
								})
							]
						}),
						/* @__PURE__ */ jsx(Separator, {
							orientation: "horizontal",
							className: "my-0"
						}),
						/* @__PURE__ */ jsxs(Command.List, {
							ref: scrollContainerRef,
							style: {
								maxHeight: "40vh",
								overflowY: "auto"
							},
							children: [
								isLoading && availableItems.length === 0 && /* @__PURE__ */ jsxs("div", {
									className: "flex items-center justify-center py-6",
									children: [/* @__PURE__ */ jsx(CircularProgress, { size: "small" }), /* @__PURE__ */ jsx("span", {
										className: "ml-2 text-sm text-text-secondary dark:text-text-secondary-dark",
										children: loadingText
									})]
								}),
								!isLoading && availableItems.length === 0 && /* @__PURE__ */ jsx(Command.Empty, {
									className: "px-4 py-6 text-center text-text-secondary dark:text-text-secondary-dark",
									children: searchString ? noResultsText : emptyCollectionText ?? `No ${collection.name ?? "entries"} yet.`
								}),
								/* @__PURE__ */ jsxs(Command.Group, { children: [
									(() => {
										const pinned = pinnedIdsRef.current;
										return pinned && pinned.size > 0 ? [...availableItems].sort((a, b) => {
											return (pinned.has(String(a.id)) ? 0 : 1) - (pinned.has(String(b.id)) ? 0 : 1);
										}) : availableItems;
									})().map((item) => {
										const isSelected = selectedItems.some((v) => String(v.id) === String(item.id));
										return /* @__PURE__ */ jsxs(Command.Item, {
											value: String(item.id),
											onMouseDown: (e) => {
												e.preventDefault();
												e.stopPropagation();
											},
											onSelect: () => onItemClick(item),
											className: cls("flex flex-row items-center gap-1.5 m-1 p-1 rounded-xs cursor-pointer ring-offset-transparent", isSelected && "bg-surface-active", "aria-selected:outline-hidden aria-selected:bg-surface-active"),
											children: [multiple && /* @__PURE__ */ jsx(InnerCheckBox, { checked: isSelected }), item.data ? /* @__PURE__ */ jsx("div", {
												className: "flex flex-row items-center gap-2 min-w-0 w-full",
												children: /* @__PURE__ */ jsx(EntityPreviewBindingData, {
													size: multiple ? "smallest" : "medium",
													entity: item.data,
													includeId: false,
													includeEntityLink: true
												})
											}) : /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
												className: "text-sm font-medium text-text-primary dark:text-text-primary-dark",
												children: item.label
											}), item.description && /* @__PURE__ */ jsx("div", {
												className: "text-xs text-text-secondary dark:text-text-secondary-dark",
												children: item.description
											})] })]
										}, String(item.id));
									}),
									availableItems.length > 0 && hasMore && /* @__PURE__ */ jsx("div", {
										ref: sentinelCallbackRef,
										className: "h-1 w-full",
										style: { visibility: "hidden" }
									}),
									isLoading && availableItems.length > 0 && /* @__PURE__ */ jsxs("div", {
										className: "flex items-center justify-center py-4",
										children: [/* @__PURE__ */ jsx(CircularProgress, { size: "smallest" }), /* @__PURE__ */ jsx("span", {
											className: "ml-2 text-xs text-text-secondary dark:text-text-secondary-dark",
											children: "Loading..."
										})]
									})
								] })
							]
						}),
						canCreateTarget && /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(Separator, {
							orientation: "horizontal",
							className: "my-0"
						}), /* @__PURE__ */ jsxs("button", {
							type: "button",
							"data-relation-selector-create": true,
							onMouseDown: (e) => {
								e.preventDefault();
								e.stopPropagation();
							},
							onClick: handleCreateNew,
							className: cls("w-full flex flex-row items-center gap-2 px-4 py-3 text-sm text-left", "text-primary hover:bg-surface-hover"),
							children: [/* @__PURE__ */ jsx(PlusIcon, { size: iconSize.smallest }), /* @__PURE__ */ jsx("span", {
								className: "truncate",
								children: searchString.trim() ? t("add_named", { name: searchString.trim() }) : t("add_specific", { name: collection.singularName ?? collection.name })
							})]
						})] })
					]
				})
			})
		})]
	}) });
});
RelationSelector.displayName = "RelationSelector";
function InnerCheckBox({ checked }) {
	return /* @__PURE__ */ jsx("div", {
		className: cls("p-2 w-8 h-8 inline-flex items-center justify-center text-sm font-medium focus:outline-hidden transition-colors ease-in-out duration-150"),
		children: /* @__PURE__ */ jsx("div", {
			className: cls("border-2 relative transition-colors ease-in-out duration-150 w-4 h-4 rounded-xs flex items-center justify-center", checked ? "bg-primary text-surface-accent-100 dark:text-surface-accent-900 border-transparent" : "bg-surface-card border-surface-accent-800 dark:border-surface-accent-500"),
			children: checked && /* @__PURE__ */ jsx(CheckIcon, {
				size: iconSize.smallest,
				className: "absolute"
			})
		})
	});
}
//#endregion
//#region src/components/CollectionTableBinding/fields/TableRelationSelectorField.tsx
/** Thin wrapper around RelationSelector for table cells */
function TableRelationSelectorField({ disabled = false, internalValue, updateValue, relation, fixedFilter, size = "medium" }) {
	return /* @__PURE__ */ jsx(RelationSelector, {
		disabled,
		size,
		value: internalValue || null,
		onValueChange: (newVal) => updateValue(newVal ?? null),
		relation,
		fixedFilter
	});
}
//#endregion
//#region src/components/CollectionTableBinding/table_bindings.tsx
function isStorageProperty(property) {
	if (property.type === "string" && property.admin?.markdown) return false;
	if (property.type === "string" && property.storage) return true;
	if (property.type === "array") if (Array.isArray(property.of)) return false;
	else return property.of?.type === "string" && property.of?.storage;
	return false;
}
function getTableBindingForProperty(property, selected) {
	if (isStorageProperty(property)) return {
		Component: ({ validationError, error, disabled, selected, openPopup, property, entity, path, internalValue, size, updateValue, propertyKey }) => /* @__PURE__ */ jsx(TableStorageUpload, {
			error: validationError ?? error,
			disabled,
			focused: selected,
			selected,
			openPopup,
			property,
			entity,
			path,
			value: internalValue,
			previewSize: getPreviewSizeFrom(size),
			updateValue,
			propertyKey
		}),
		includeActions: false,
		showExpandIcon: true,
		fullHeight: true,
		removePadding: true
	};
	else if (selected && property.type === "number") {
		const numberProperty = property;
		if (numberProperty.enum) return {
			Component: ({ propertyKey, disabled, selected, size, error, validationError, internalValue, updateValue }) => /* @__PURE__ */ jsx(VirtualTableSelect, {
				name: propertyKey,
				multiple: false,
				disabled,
				focused: selected,
				valueType: "number",
				small: getPreviewSizeFrom(size) !== "medium",
				enumValues: numberProperty.enum,
				error: validationError ?? error,
				internalValue,
				updateValue
			}),
			fullHeight: true
		};
		else return {
			Component: ({ align, error, validationError, selected, disabled, internalValue, updateValue }) => /* @__PURE__ */ jsx(VirtualTableNumberInput, {
				align,
				error: validationError ?? error,
				focused: selected,
				disabled,
				value: internalValue,
				updateValue
			}),
			allowScroll: true
		};
	} else if (selected && property.type === "string") {
		const stringProperty = property;
		if (stringProperty.enum) return {
			Component: ({ propertyKey, disabled, selected, size, error, validationError, internalValue, updateValue }) => /* @__PURE__ */ jsx(VirtualTableSelect, {
				name: propertyKey,
				multiple: false,
				focused: selected,
				disabled,
				valueType: "string",
				small: getPreviewSizeFrom(size) !== "medium",
				enumValues: stringProperty.enum,
				error: validationError ?? error,
				internalValue,
				updateValue
			}),
			fullHeight: true
		};
		else if (stringProperty.userSelect) return {
			Component: ({ propertyKey, disabled, selected, size, error, validationError, internalValue, updateValue }) => /* @__PURE__ */ jsx(VirtualTableUserSelect, {
				name: propertyKey,
				multiple: false,
				focused: selected,
				disabled,
				small: getPreviewSizeFrom(size) !== "medium",
				error: validationError ?? error,
				internalValue,
				updateValue
			}),
			fullHeight: true
		};
		else if (stringProperty.admin?.markdown || !stringProperty.storage) {
			const multiline = Boolean(stringProperty.admin?.multiline) || Boolean(stringProperty.admin?.markdown);
			return {
				Component: ({ error, validationError, disabled, selected, internalValue, updateValue }) => /* @__PURE__ */ jsx(VirtualTableInput, {
					error: validationError ?? error,
					disabled,
					multiline,
					focused: selected,
					value: internalValue,
					updateValue
				}),
				allowScroll: true
			};
		}
	} else if (property.type === "boolean") return { Component: ({ error, validationError, disabled, selected, internalValue, updateValue }) => /* @__PURE__ */ jsx(VirtualTableSwitch, {
		error: validationError ?? error,
		disabled,
		focused: selected,
		internalValue,
		updateValue
	}) };
	else if (property.type === "date") return {
		Component: ({ propertyKey, error, validationError, disabled, selected, size, property, internalValue, updateValue }) => {
			const { locale } = useCustomizationController();
			return /* @__PURE__ */ jsx(VirtualTableDateField, {
				name: propertyKey,
				error: validationError ?? error,
				disabled,
				small: getPreviewSizeFrom(size) !== "medium",
				mode: property.mode,
				focused: selected,
				internalValue,
				updateValue,
				locale
			});
		},
		fullHeight: true,
		hideOverflow: false,
		allowScroll: false
	};
	else if (property.type === "reference") {
		if (property.path) return {
			Component: ({ propertyKey, internalValue, updateValue, disabled, size, property }) => {
				return /* @__PURE__ */ jsx(TableReferenceField, {
					name: propertyKey,
					internalValue,
					updateValue,
					disabled,
					size,
					path: property.path,
					multiselect: false,
					previewProperties: property.admin?.previewProperties,
					includeId: property.admin?.includeId,
					includeEntityLink: property.admin?.includeEntityLink,
					title: property.name ?? propertyKey,
					fixedFilter: property.admin?.fixedFilter
				});
			},
			allowScroll: false
		};
	} else if (property.type === "relation") {
		if (property.relation) {
			if (property.admin?.widget === "dialog") return {
				Component: RelationDialogBindingComponent,
				allowScroll: false
			};
			else if (selected) return {
				Component: RelationSelectorBindingComponent,
				allowScroll: false
			};
		}
	} else if (property.type === "array") {
		const arrayProperty = property;
		if (!arrayProperty.of && !arrayProperty.oneOf) throw Error("You need to specify an 'of' or 'oneOf' prop (or specify a custom field) in your array property");
		else if (arrayProperty.of && !Array.isArray(arrayProperty.of)) {
			const ofProp = arrayProperty.of;
			if (ofProp.type === "string" || ofProp.type === "number") {
				if (selected && ofProp.enum) return {
					Component: ({ propertyKey, disabled, selected, size, error, validationError, internalValue, updateValue }) => /* @__PURE__ */ jsx(VirtualTableSelect, {
						name: propertyKey,
						multiple: true,
						disabled,
						focused: selected,
						small: getPreviewSizeFrom(size) !== "medium",
						valueType: ofProp.type,
						enumValues: ofProp.enum,
						error: validationError ?? error,
						internalValue,
						updateValue
					}),
					allowScroll: true,
					fullHeight: true,
					hideOverflow: false
				};
			} else if (ofProp.type === "reference") {
				const refOfProp = ofProp;
				if (refOfProp.path) return {
					Component: ({ propertyKey, disabled, internalValue, updateValue, size }) => /* @__PURE__ */ jsx(TableReferenceField, {
						name: propertyKey,
						disabled,
						internalValue,
						updateValue,
						size,
						multiselect: true,
						path: refOfProp.path,
						previewProperties: refOfProp.admin?.previewProperties,
						title: arrayProperty.name,
						fixedFilter: refOfProp.admin?.fixedFilter,
						includeId: refOfProp.admin?.includeId,
						includeEntityLink: refOfProp.admin?.includeEntityLink
					}),
					allowScroll: false
				};
			}
		}
	}
}
/** Stable component for relation fields rendered with the dialog widget */
function RelationDialogBindingComponent({ propertyKey, internalValue, updateValue, disabled, size, property }) {
	const relProp = property;
	return /* @__PURE__ */ jsx(TableRelationField, {
		name: propertyKey,
		internalValue,
		updateValue,
		disabled,
		size,
		multiselect: false,
		relation: relProp.relation,
		previewProperties: relProp.admin?.previewProperties,
		includeId: relProp.admin?.includeId,
		includeEntityLink: relProp.admin?.includeEntityLink,
		title: relProp.name ?? propertyKey,
		fixedFilter: relProp.admin?.fixedFilter
	});
}
/** Stable component for relation fields rendered with the inline selector */
function RelationSelectorBindingComponent({ propertyKey, internalValue, updateValue, disabled, property, size }) {
	const relProp = property;
	return /* @__PURE__ */ jsx(TableRelationSelectorField, {
		size: getPreviewSizeFrom(size) === "small" ? "compact" : "medium",
		name: propertyKey,
		internalValue,
		updateValue,
		disabled,
		relation: relProp.relation,
		fixedFilter: relProp.admin?.fixedFilter
	});
}
//#endregion
//#region src/form/validation.ts
/** Whether an authored relation yields many rows. Derived from its kind. */
/**
* What to call this field in a validation message.
*
* `property.name` is the author's label and is optional — a headless project has
* no panel and no reason to invent display names. Every message here
* interpolated it directly, so an unnamed property produced
* "undefined must be min 3 characters long" in front of a user.
*
* The fallback is the field's own key, prettified the same way the panel derives
* a column header, so the message names the field the author would recognise.
*/
function fieldLabel$1(property, name) {
	return property.name ?? (name ? prettifyIdentifier(name) : "This field");
}
function relationCardinality$1(relation) {
	if (!relation) return void 0;
	if (relation.kind === "via") return relation.cardinality;
	if (relation.kind === "hasMany" || relation.kind === "manyToMany") return "many";
	if (relation.kind === "belongsTo" || relation.kind === "hasOne") return "one";
	return relation.cardinality;
}
function getEntitySchema(entityId, properties, customFieldValidator) {
	const shape = {};
	Object.entries(properties).forEach(([name, property]) => {
		const isIdAndAuto = (property.type === "string" || property.type === "number") && "isId" in property && typeof property.isId === "string" && property.isId !== "manual";
		if (entityId === void 0 && isIdAndAuto) return;
		shape[name] = mapPropertyToZod({
			property,
			customFieldValidator,
			name,
			entityId
		});
	});
	return z.object(shape).passthrough();
}
function mapPropertyToZod(propertyContext) {
	const property = propertyContext.property;
	if (isPropertyBuilder(property) && !property.type) {
		console.error("Error in property", propertyContext);
		return z.any().refine(() => false, { message: "Invalid property configuration: property builder should be resolved" });
	}
	if (property.type === "string") return getZodStringSchema(propertyContext);
	else if (property.type === "number") return getZodNumberSchema(propertyContext);
	else if (property.type === "boolean") return getZodBooleanSchema(propertyContext);
	else if (property.type === "map") return getZodMapObjectSchema(propertyContext);
	else if (property.type === "array") return getZodArraySchema(propertyContext);
	else if (property.type === "date") return getZodDateSchema(propertyContext);
	else if (property.type === "geopoint") return getZodGeoPointSchema(propertyContext);
	else if (property.type === "reference") return getZodReferenceSchema(propertyContext);
	else if (property.type === "relation") return getZodRelationSchema(propertyContext);
	else if (property.type === "vector") return getZodVectorSchema(propertyContext);
	else if (property.type === "binary") return getZodBinarySchema(propertyContext);
	console.error("Unsupported data type in zod mapping", property);
	const dataType = "dataType" in property ? String(property.dataType) : "unknown";
	return z.any().refine(() => false, { message: `Unsupported data type: ${dataType}` });
}
function getZodMapObjectSchema({ property, entityId, customFieldValidator, name }) {
	const shape = {};
	const validation = property.validation;
	if (property.properties) Object.entries(property.properties).forEach(([childName, childProperty]) => {
		const typedChildProperty = childProperty;
		try {
			shape[childName] = mapPropertyToZod({
				property: typedChildProperty,
				parentProperty: property,
				customFieldValidator,
				name: `${name}[${childName}]`,
				entityId
			});
		} catch (e) {
			console.error(`Error creating validation schema for property ${childName}:`, e);
			shape[childName] = z.any().refine(() => false, { message: `Validation error: ${e instanceof Error ? e.message : "Unknown error"}` });
		}
	});
	let schema = z.object(shape).passthrough();
	if (validation?.required) schema = schema.nullable().optional().refine((value) => value !== void 0, { message: validation?.requiredMessage ? validation.requiredMessage : "Required" });
	else schema = schema.nullable().optional();
	return schema;
}
function getZodStringSchema({ property, parentProperty, customFieldValidator, name, entityId }) {
	let schema = z.string().nullable().optional();
	const validation = property.validation;
	const isRequired = validation?.required || property.isId === true || property.isId === "manual";
	if (property.enum) {
		if (isRequired) schema = z.string().nullable().optional().refine((value) => value !== void 0 && value !== null && value !== "", { message: validation?.requiredMessage ? validation.requiredMessage : "Required" });
		const entries = enumToObjectEntries(property.enum);
		const allowedValues = (isRequired ? entries : [...entries, null]).map((enumValueConfig) => enumValueConfig?.id ?? null);
		schema = schema.refine((value) => allowedValues.includes(value), { message: `Must be one of: ${allowedValues.filter(Boolean).join(", ")}` });
	}
	if (isRequired && !property.enum) schema = schema.refine((value) => value !== void 0 && value !== null && value !== "", { message: validation?.requiredMessage ? validation.requiredMessage : "Required" });
	if (validation) {
		if (validation.min || validation.min === 0) schema = schema.refine((value) => value == null || typeof value === "string" && value.length >= validation.min, { message: `${fieldLabel$1(property, name)} must be min ${validation.min} characters long` });
		if (validation.max || validation.max === 0) schema = schema.refine((value) => value == null || typeof value === "string" && value.length <= validation.max, { message: `${fieldLabel$1(property, name)} must be max ${validation.max} characters long` });
		if (validation.matches) {
			const regExp = typeof validation.matches === "string" ? hydrateRegExp(validation.matches) : validation.matches;
			if (regExp) schema = schema.refine((value) => value == null || typeof value === "string" && regExp.test(value), { message: validation.matchesMessage ?? "Invalid format" });
		}
		if (validation.trim) schema = z.preprocess((v) => typeof v === "string" ? v.trim() : v, schema);
		if (validation.lowercase) schema = z.preprocess((v) => typeof v === "string" ? v.toLowerCase() : v, schema);
		if (validation.uppercase) schema = z.preprocess((v) => typeof v === "string" ? v.toUpperCase() : v, schema);
		if (property.email) schema = schema.refine((value) => value == null || typeof value === "string" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value), { message: `${fieldLabel$1(property, name)} must be an email` });
		if (property.url) if (!property.storage || property.storage?.storeUrl) schema = schema.refine((value) => {
			if (value == null) return true;
			try {
				new URL(value);
				return true;
			} catch {
				return false;
			}
		}, { message: `${fieldLabel$1(property, name)} must be a url` });
		else console.warn(`Property ${fieldLabel$1(property, name)} has a url validation but its storage configuration is not set to store urls`);
	}
	return schema;
}
function getZodNumberSchema({ property, parentProperty, customFieldValidator, name, entityId }) {
	const validation = property.validation;
	let schema = z.preprocess((val) => {
		if (val === null || val === void 0) return null;
		if (typeof val === "number") return val;
		const n = Number(val);
		return isNaN(n) ? val : n;
	}, z.number({ error: "Must be a number" }).nullable());
	if (validation?.required || property.isId === true || property.isId === "manual") schema = schema.refine((value) => value !== void 0 && value !== null, { message: validation?.requiredMessage ? validation.requiredMessage : "Required" });
	if (validation) {
		if (validation.min || validation.min === 0) schema = schema.refine((value) => value == null || typeof value === "number" && value >= validation.min, { message: `${fieldLabel$1(property, name)} must be higher or equal to ${validation.min}` });
		if (validation.max || validation.max === 0) schema = schema.refine((value) => value == null || typeof value === "number" && value <= validation.max, { message: `${fieldLabel$1(property, name)} must be lower or equal to ${validation.max}` });
		if (validation.lessThan || validation.lessThan === 0) schema = schema.refine((value) => value == null || typeof value === "number" && value < validation.lessThan, { message: `${fieldLabel$1(property, name)} must be higher than ${validation.lessThan}` });
		if (validation.moreThan || validation.moreThan === 0) schema = schema.refine((value) => value == null || typeof value === "number" && value > validation.moreThan, { message: `${fieldLabel$1(property, name)} must be lower than ${validation.moreThan}` });
		if (validation.positive) schema = schema.refine((value) => value == null || typeof value === "number" && value > 0, { message: `${fieldLabel$1(property, name)} must be positive` });
		if (validation.negative) schema = schema.refine((value) => value == null || typeof value === "number" && value < 0, { message: `${fieldLabel$1(property, name)} must be negative` });
		if (validation.integer) schema = schema.refine((value) => value == null || typeof value === "number" && Number.isInteger(value), { message: `${fieldLabel$1(property, name)} must be an integer` });
	}
	return schema;
}
function getZodGeoPointSchema({ property, parentProperty, customFieldValidator, name, entityId }) {
	let schema = z.object({}).passthrough().nullable().optional();
	const validation = property.validation;
	if (validation?.required) schema = schema.refine((value) => value !== void 0 && value !== null, { message: validation.requiredMessage ? validation.requiredMessage : "Required" });
	return schema;
}
function getZodDateSchema({ property, parentProperty, customFieldValidator, name, entityId }) {
	if (property.autoValue) return z.date().nullable().optional();
	let schema = z.custom((v) => v === null || v === void 0 || v instanceof Date, { message: "Expected a Date" }).optional();
	const validation = property.validation;
	if (validation) {
		if (validation.required) schema = schema.refine((value) => value !== void 0 && value !== null, { message: validation?.requiredMessage ? validation.requiredMessage : "Required" });
		if (validation.min) schema = schema.refine((value) => value == null || value instanceof Date && value >= validation.min, { message: `${fieldLabel$1(property, name)} must be after ${validation.min}` });
		if (validation.max) schema = schema.refine((value) => value == null || value instanceof Date && value <= validation.max, { message: `${fieldLabel$1(property, name)} must be before ${validation.min}` });
	}
	return schema;
}
function getZodReferenceSchema({ property, parentProperty, customFieldValidator, name, entityId }) {
	let schema = z.object({}).passthrough().nullable().optional();
	const validation = property.validation;
	if (validation) {
		if (validation.required) schema = schema.refine((value) => value !== void 0 && value !== null, { message: validation?.requiredMessage ? validation.requiredMessage : "Required" });
	}
	return schema;
}
function getZodRelationSchema({ property, parentProperty, customFieldValidator, name, entityId }) {
	const isMany = relationCardinality$1(property.relation) === "many";
	let schema = isMany ? z.array(z.object({}).passthrough()).nullable().optional() : z.object({}).passthrough().nullable().optional();
	const validation = property.validation;
	if (validation) {
		if (validation.required) schema = schema.refine((value) => {
			if (isMany) return value !== void 0 && value !== null && Array.isArray(value) && value.length > 0;
			return value !== void 0 && value !== null;
		}, { message: validation?.requiredMessage ? validation.requiredMessage : "Required" });
	}
	return schema;
}
function getZodBooleanSchema({ property, parentProperty, customFieldValidator, name, entityId }) {
	let schema = z.boolean().nullable().optional();
	const validation = property.validation;
	if (validation) {
		if (validation.required) schema = schema.refine((value) => value !== void 0 && value !== null, { message: validation?.requiredMessage ? validation.requiredMessage : "Required" });
	}
	return schema;
}
function hasUniqueInArrayModifier(property) {
	if (property.validation?.uniqueInArray) return true;
	else if (property.type === "map" && property.properties) return Object.entries(property.properties).filter(([key, childProperty]) => childProperty.validation?.uniqueInArray);
	return false;
}
function getZodArraySchema({ property, parentProperty, customFieldValidator, name, entityId }) {
	let arraySchema = z.array(z.any()).nullable().optional();
	if (property.of) if (Array.isArray(property.of)) {
		const zodProperties = {};
		property.of.forEach((p, index) => {
			try {
				zodProperties[`${name}[${index}]`] = mapPropertyToZod({
					property: p,
					parentProperty: property,
					entityId
				});
			} catch (e) {
				console.error(`Error creating validation schema for array item ${index}:`, e);
				zodProperties[`${name}[${index}]`] = z.any().refine(() => false, { message: `Validation error: ${e instanceof Error ? e.message : "Unknown error"}` });
			}
		});
		arraySchema = z.array(z.any().superRefine(async (object, ctx) => {
			for (const [key, zodProperty] of Object.entries(zodProperties)) if (zodProperty) {
				const result = await zodProperty.safeParseAsync(object);
				if (!result.success) result.error.issues.forEach((issue) => {
					ctx.addIssue({
						code: "custom",
						message: issue.message
					});
				});
			}
		})).nullable().optional();
	} else {
		try {
			const ofSchema = mapPropertyToZod({
				property: property.of,
				parentProperty: property,
				entityId
			});
			arraySchema = z.array(ofSchema).nullable().optional();
		} catch (e) {
			console.error("Error creating validation schema for array of property:", e);
			arraySchema = z.array(z.any().refine(() => false, { message: `Validation error: ${e instanceof Error ? e.message : "Unknown error"}` })).nullable().optional();
		}
		const arrayUniqueFields = hasUniqueInArrayModifier(property.of);
		if (arrayUniqueFields) {
			if (typeof arrayUniqueFields === "boolean") arraySchema = arraySchema.refine((values) => !values || !Array.isArray(values) || values.length === new Set(values).size, { message: `${fieldLabel$1(property, name)} should have unique values within the array` });
			else if (Array.isArray(arrayUniqueFields)) arrayUniqueFields.forEach(([fieldName, childProperty]) => {
				arraySchema = arraySchema.refine((values) => !values || !Array.isArray(values) || values.length === new Set(values.map((v) => v && typeof v === "object" ? v[fieldName] : v)).size, { message: `${fieldLabel$1(property, name)} → ${childProperty.name ?? fieldName}: should have unique values within the array` });
			});
		}
	}
	const validation = property.validation;
	if (validation) {
		if (validation.required) arraySchema = arraySchema.refine((value) => value !== void 0 && value !== null && Array.isArray(value) && value.length > 0, { message: validation?.requiredMessage ? validation.requiredMessage : "Required" });
		if (validation.min || validation.min === 0) arraySchema = arraySchema.refine((value) => !value || !Array.isArray(value) || value.length >= validation.min, { message: `${fieldLabel$1(property, name)} should be min ${validation.min} entries long` });
		if (validation.max) arraySchema = arraySchema.refine((value) => !value || !Array.isArray(value) || value.length <= validation.max, { message: `${fieldLabel$1(property, name)} should be max ${validation.max} entries long` });
		if (validation.uniqueInArray) arraySchema = arraySchema.refine((values) => !values || !Array.isArray(values) || values.length === new Set(values).size, { message: `${fieldLabel$1(property, name)} should have unique values within the array` });
	}
	return arraySchema;
}
function getZodVectorSchema({ property }) {
	let schema = z.preprocess((val) => {
		if (val && typeof val === "object" && "__type" in val && val.__type === "Vector") return val.value;
		if (val && typeof val === "object" && "value" in val && Array.isArray(val.value)) return val.value;
		return val;
	}, z.array(z.number()).nullable().optional());
	if (property.dimensions) schema = schema.refine((val) => val === null || val === void 0 || Array.isArray(val) && val.length === property.dimensions, { message: `${property.name ?? "Vector"} must have exactly ${property.dimensions} dimensions` });
	if (property.validation?.required) schema = schema.refine((val) => val !== null && val !== void 0 && Array.isArray(val) && val.length > 0, { message: property.validation?.requiredMessage ?? "Required" });
	return schema;
}
function getZodBinarySchema({ property }) {
	let schema = z.string().nullable().optional();
	const validation = property.validation;
	if (validation?.required) schema = schema.nullable().optional().refine((value) => value !== void 0 && value !== null && value !== "", { message: validation.requiredMessage ? validation.requiredMessage : "Required" });
	return schema;
}
//#endregion
//#region src/components/CollectionTableBinding/internal/EntityTableCell.tsx
var TableCellInner = ({ justifyContent, scrollable, faded, fullHeight, children }) => {
	return /* @__PURE__ */ jsx("div", {
		className: cls("flex flex-col max-h-full w-full", { "items-start": faded || scrollable }),
		style: {
			justifyContent,
			height: fullHeight ? "100%" : void 0,
			overflow: scrollable ? "auto" : void 0,
			WebkitMaskImage: faded ? "linear-gradient(to bottom, black 60%, transparent 100%)" : void 0,
			maskImage: faded ? "linear-gradient(to bottom, black 60%, transparent 100%)" : void 0
		},
		children
	});
};
var EntityTableCell = React.memo(function EntityTableCell({ children, actions, size, selected, disabled, disabledTooltip, savedTimestamp, error, align, allowScroll, removePadding, fullHeight, onSelect, width, hideOverflow = true, showExpandIcon = true, sortableNodeRef, sortableStyle, sortableAttributes, isDragging, isDraggable, frozen }) {
	const [measureRef, bounds] = useMeasure();
	const ref = useRef(null);
	const maxHeight = useMemo(() => getRowHeight(size), [size]);
	const [onHover, setOnHover] = useState(false);
	const [showSaved, setShowSaved] = useState(false);
	const showError = !disabled && Boolean(error);
	useEffect(() => {
		if (savedTimestamp && savedTimestamp > 0) {
			setShowSaved(true);
			const handler = setTimeout(() => {
				setShowSaved(false);
			}, 400);
			return () => {
				clearTimeout(handler);
			};
		}
	}, [savedTimestamp]);
	let p = 0;
	if (!removePadding) switch (size) {
		case "l":
		case "xl":
			p = 4;
			break;
		case "m":
			p = 2;
			break;
		default:
			p = 1;
			break;
	}
	let justifyContent;
	switch (align) {
		case "right":
			justifyContent = "flex-end";
			break;
		case "center":
			justifyContent = "center";
			break;
		default: justifyContent = "flex-start";
	}
	const onSelectCallback = useCallback(() => {
		if (!onSelect) return;
		const cellRect = ref && ref?.current?.getBoundingClientRect();
		if (disabled) onSelect(void 0);
		else if (!selected && cellRect) onSelect(cellRect);
	}, [
		ref,
		onSelect,
		selected,
		disabled
	]);
	const onFocus = useCallback((event) => {
		event.stopPropagation();
		event.preventDefault();
		onSelectCallback();
	}, [onSelectCallback]);
	const isOverflowing = useMemo(() => {
		if (bounds) return bounds.height > maxHeight;
		return false;
	}, [bounds, maxHeight]);
	const isSelected = !showError && selected;
	const scrollable = !disabled && allowScroll && isOverflowing;
	const faded = !disabled && !allowScroll && isOverflowing;
	const setOnHoverTrue = useCallback(() => setOnHover(true), []);
	const setOnHoverFalse = useCallback(() => setOnHover(false), []);
	const borderClass = showError ? "border-red-500" : isSelected ? "border-primary" : "border-transparent";
	const result = /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", {
		className: cls("transition-colors duration-500", `flex relative h-full rounded-md p-${p} border-4`, showSaved ? "bg-primary/20 dark:bg-primary/20" : onHover && !disabled ? "bg-surface-hover" : "", hideOverflow ? "overflow-hidden" : "", isSelected && !showSaved ? "bg-surface-raised" : "", borderClass),
		ref,
		style: {
			justifyContent,
			alignItems: disabled || !isOverflowing ? "center" : void 0,
			width: width ?? "100%",
			textAlign: align
		},
		tabIndex: selected || disabled ? void 0 : 0,
		onFocus,
		onMouseEnter: setOnHoverTrue,
		onMouseMove: setOnHoverTrue,
		onMouseLeave: setOnHoverFalse,
		children: [/* @__PURE__ */ jsxs(ErrorBoundary, { children: [fullHeight && !faded && children, (!fullHeight || faded) && /* @__PURE__ */ jsx(TableCellInner, {
			fullHeight: fullHeight ?? false,
			justifyContent,
			scrollable: scrollable ?? false,
			faded,
			children: !fullHeight && /* @__PURE__ */ jsx("div", {
				ref: measureRef,
				style: {
					display: "flex",
					width: "100%",
					justifyContent,
					height: fullHeight ? "100%" : void 0
				},
				children
			})
		})] }), actions]
	}) });
	const { tabIndex: _tabIndex, ...sortableAttrsWithoutTabIndex } = sortableAttributes ?? {};
	return sortableNodeRef ? /* @__PURE__ */ jsx("div", {
		ref: sortableNodeRef,
		style: sortableStyle,
		className: cls("flex-shrink-0", frozen && "sticky left-0 z-10 bg-surface-card"),
		...sortableAttrsWithoutTabIndex,
		children: showError ? /* @__PURE__ */ jsx(ErrorTooltip, {
			className: "flex h-full w-full",
			align: "start",
			title: error?.message ?? "Error",
			children: result
		}) : result
	}) : showError ? /* @__PURE__ */ jsx(ErrorTooltip, {
		className: "flex h-full w-full",
		align: "start",
		title: error?.message ?? "Error",
		children: result
	}) : result;
}, (a, b) => {
	return a.error === b.error && a.value === b.value && a.disabled === b.disabled && a.savedTimestamp === b.savedTimestamp && a.allowScroll === b.allowScroll && a.align === b.align && a.size === b.size && a.disabledTooltip === b.disabledTooltip && a.width === b.width && a.showExpandIcon === b.showExpandIcon && a.removePadding === b.removePadding && a.fullHeight === b.fullHeight && a.selected === b.selected && a.isDragging === b.isDragging && a.isDraggable === b.isDraggable && a.frozen === b.frozen;
});
//#endregion
//#region src/components/SelectableTable/SelectableTableContext.tsx
var SelectableTableContext = React.createContext(null);
var useSelectableTableController = () => useContext(SelectableTableContext);
//#endregion
//#region src/components/CollectionTableBinding/PropertyTableCell.tsx
var PropertyTableCell = React.memo(function PropertyTableCell({ propertyKey, customFieldValidator, value, property, align, width, height, path, entity, readonly, disabled: disabledProp, enablePopupIcon = true, sortableNodeRef, sortableStyle, sortableAttributes, isDragging, isDraggable, frozen }) {
	const { onValueChange, size, selectionStore, select, setPopupCell } = useSelectableTableController();
	const dummySelectionStore = useMemo(() => createSelectionStore(), []);
	const selected = useCellSelected(selectionStore || dummySelectionStore, propertyKey, entity.path, entity.id);
	const [internalValue, setInternalValue] = useState(value);
	const internalValueRef = useRef(value);
	const [error, setError] = useState();
	const [validationError, setValidationError] = useState();
	const [savedTimestamp, setSavedTimestamp] = useState(0);
	const onValueUpdated = useCallback(() => {
		setSavedTimestamp(Date.now());
	}, []);
	const customField = Boolean(property.admin?.Field);
	const customPreview = Boolean(property.admin?.Preview);
	const readOnlyProperty = isReadOnly(property);
	const disabledTooltip = typeof property.admin?.disabled === "object" ? property.admin?.disabled.disabledMessage : void 0;
	const disabled = readonly || disabledProp || isDisabled(property);
	const validation = useMemo(() => mapPropertyToZod({
		property,
		entityId: entity.id,
		customFieldValidator,
		name: propertyKey
	}), [
		entity.id,
		property,
		propertyKey
	]);
	useEffect(() => {
		if (!deepEqual(value, internalValueRef.current)) {
			setValidationError(void 0);
			setInternalValue(value);
			internalValueRef.current = value;
			onValueUpdated();
		}
	}, [onValueUpdated, value]);
	const saveValues = async (value) => {
		if (deepEqual(value, internalValueRef.current)) return;
		const result = await validation.safeParseAsync(value);
		if (result.success) {
			setValidationError(void 0);
			internalValueRef.current = value;
			if (onValueChange) try {
				onValueChange({
					value,
					propertyKey,
					setError,
					onValueUpdated,
					data: entity
				});
			} catch (e) {
				console.error("onValueChange error", e);
				setError(e instanceof Error ? e : new Error(String(e)));
			}
		} else setValidationError(result.error);
	};
	useEffect(() => {
		validation.safeParseAsync(internalValue).then((result) => {
			if (result.success) setValidationError(void 0);
			else setValidationError(result.error);
		});
	}, [
		internalValue,
		validation,
		propertyKey,
		property,
		entity
	]);
	const updateValue = (newValue) => {
		let updatedValue;
		if (newValue === void 0) updatedValue = null;
		else updatedValue = newValue;
		setInternalValue(updatedValue);
		saveValues(updatedValue);
	};
	useClearRestoreValue({
		property,
		value: internalValue,
		setValue: updateValue
	});
	const onSelect = useCallback((cellRect) => {
		if (!cellRect) select(void 0);
		else select({
			width,
			height,
			entityPath: entity.path,
			entityId: entity.id,
			cellRect,
			propertyKey
		});
	}, [
		entity,
		height,
		propertyKey,
		select,
		width
	]);
	const openPopup = (cellRect) => {
		if (!setPopupCell) return;
		if (!cellRect) setPopupCell(void 0);
		else setPopupCell({
			width,
			height,
			entityPath: entity.path,
			entityId: entity.id,
			cellRect,
			propertyKey
		});
	};
	const tableBinding = useMemo(() => getTableBindingForProperty(property, selected), [property, selected]);
	let innerComponent;
	let allowScroll = false;
	let showExpandIcon = false;
	let hideOverflow = true;
	let removePadding = false;
	let fullHeight = false;
	let includeActions = true;
	const showError = !disabled && error;
	if (readonly || readOnlyProperty) return /* @__PURE__ */ jsx(EntityTableCell, {
		size,
		width,
		savedTimestamp,
		value: internalValue,
		align: align ?? "left",
		fullHeight: false,
		disabledTooltip: disabledTooltip ?? (readOnlyProperty ? "Read only" : void 0),
		disabled: true,
		sortableNodeRef,
		sortableStyle,
		sortableAttributes,
		isDragging,
		isDraggable,
		frozen,
		children: /* @__PURE__ */ jsx(PropertyPreview, {
			width,
			height: getRowHeight(size),
			propertyKey,
			property,
			value: internalValue,
			size: getPreviewSizeFrom(size)
		})
	}, `${propertyKey}_${entity.path}_${entity.id}`);
	if (!customField && (!customPreview || selected)) {
		if (tableBinding) {
			const Component = tableBinding.Component;
			innerComponent = /* @__PURE__ */ jsx(Component, {
				propertyKey,
				property,
				internalValue,
				updateValue,
				error,
				validationError,
				disabled,
				selected,
				size,
				align,
				entity,
				path,
				openPopup: setPopupCell ? openPopup : void 0
			});
			allowScroll = tableBinding.allowScroll ?? false;
			includeActions = tableBinding.includeActions ?? true;
			showExpandIcon = tableBinding.showExpandIcon ?? false;
			fullHeight = tableBinding.fullHeight ?? false;
			removePadding = tableBinding.removePadding ?? false;
			if (tableBinding.hideOverflow !== void 0) hideOverflow = tableBinding.hideOverflow;
		}
	}
	if (!innerComponent) {
		allowScroll = false;
		showExpandIcon = enablePopupIcon && selected && !innerComponent && !disabled && !readOnlyProperty;
		innerComponent = /* @__PURE__ */ jsx(PropertyPreview, {
			width,
			height,
			propertyKey,
			value: internalValue,
			property,
			size: getPreviewSizeFrom(size)
		});
	}
	return /* @__PURE__ */ jsx(EntityTableCell, {
		size,
		width,
		onSelect,
		selected,
		disabled: disabled || readOnlyProperty,
		disabledTooltip: disabledTooltip ?? "Disabled",
		removePadding,
		fullHeight,
		savedTimestamp,
		error: validationError ?? error,
		align,
		allowScroll,
		showExpandIcon,
		value: internalValue,
		hideOverflow,
		sortableNodeRef,
		sortableStyle,
		sortableAttributes,
		isDragging,
		isDraggable,
		frozen,
		actions: includeActions && /* @__PURE__ */ jsx(EntityTableCellActions, {
			showError,
			disabled,
			showExpandIcon,
			selected,
			openPopup: !disabled ? openPopup : void 0
		}),
		children: innerComponent
	}, `cell_${propertyKey}_${entity.path}_${entity.id}`);
}, areEqual);
function areEqual(prevProps, nextProps) {
	return prevProps.height === nextProps.height && prevProps.propertyKey === nextProps.propertyKey && prevProps.align === nextProps.align && prevProps.width === nextProps.width && deepEqual(prevProps.property, nextProps.property) && deepEqual(prevProps.value, nextProps.value) && prevProps.entity.id === nextProps.entity.id && prevProps.entity.path === nextProps.entity.path && prevProps.isDragging === nextProps.isDragging && prevProps.isDraggable === nextProps.isDraggable && prevProps.frozen === nextProps.frozen;
}
//#endregion
//#region src/contexts/SideDialogsControllerContext.tsx
var SideDialogsControllerContext = React.createContext({});
//#endregion
//#region src/hooks/useSideDialogsController.tsx
var useSideDialogsController = () => useContext(SideDialogsControllerContext);
//#endregion
//#region src/hooks/navigation/contexts/NavigationStateContext.tsx
var NavigationStateContext = createContext({
	loading: true,
	refreshNavigation: () => {}
});
function useNavigationStateController() {
	const context = React.useContext(NavigationStateContext);
	if (context === void 0) throw new Error("useNavigationStateController must be used within a NavigationStateContext.Provider");
	return context;
}
//#endregion
//#region src/hooks/navigation/contexts/UrlContext.tsx
var UrlContext = createContext({
	basePath: "/",
	baseCollectionPath: "/c",
	urlPathToDataPath: () => "",
	homeUrl: "/",
	isUrlCollectionPath: () => false,
	buildUrlCollectionPath: () => "",
	buildAppUrlPath: () => "",
	resolveDatabasePathsFrom: () => "",
	navigate: () => {}
});
function useUrlController() {
	const context = React.useContext(UrlContext);
	if (context === void 0) throw new Error("useUrlController must be used within a UrlContext.Provider");
	return context;
}
//#endregion
//#region src/hooks/useAdminContext.tsx
/**
* Hook that builds a fully-populated admin context by combining the
* core {@link RebaseContext} with admin-specific controllers.
*
* Use this instead of `useRebaseContext()` in admin components that
* need to pass context to entity action callbacks, plugin slots,
* or any consumer that expects admin controllers on the context object.
*
* @group Hooks and utilities
*/
function useAdminContext() {
	const baseContext = useRebaseContext();
	const sidePanelController = useSidePanel();
	const sideDialogsController = useSideDialogsController();
	const urlController = useUrlController();
	const navigationStateController = useNavigationStateController();
	const collectionRegistryController = useCollectionRegistryController();
	return useMemo(() => ({
		...baseContext,
		sidePanelController,
		sideDialogsController,
		urlController,
		navigationStateController,
		collectionRegistryController
	}), [
		baseContext,
		sidePanelController,
		sideDialogsController,
		urlController,
		navigationStateController,
		collectionRegistryController
	]);
}
//#endregion
//#region src/components/CollectionTableBinding/CollectionRowActions.tsx
/**
*
* @param entity
* @param width
* @param frozen
* @param isSelected
* @param selectionEnabled
* @param size
* @param toggleEntitySelection
* @param hideId
*
* @group Collection components
*/
var CollectionRowActions = function CollectionRowActions({ entity, collection, path, width, frozen, isSelected, selectionEnabled, size, highlightEntity, onCollectionChange, unhighlightEntity, actions = [], hideId, selectionController, openEntityMode, sortableNodeRef, sortableStyle, sortableAttributes, isDragging, isDraggable }) {
	const context = useAdminContext();
	const sidePanelCtrl = context.sidePanelController;
	const { t } = useTranslation();
	const slotActions = useSlot("entity.row.actions", React.useMemo(() => ({
		entity,
		entityId: entity.id,
		path,
		collection,
		selectionController,
		context
	}), [
		entity,
		path,
		collection,
		selectionController,
		context
	]));
	const onCheckedChange = useCallback((checked) => {
		selectionController?.toggleEntitySelection(entity, checked);
	}, [entity, selectionController?.toggleEntitySelection]);
	const hasActions = actions.length > 0 || slotActions.length > 0;
	const hasCollapsedActions = actions.some((a) => a.collapsed || a.collapsed === void 0);
	const collapsedActions = actions.filter((a) => a.collapsed || a.collapsed === void 0);
	const uncollapsedActions = actions.filter((a) => a.collapsed === false);
	const hasDraft = (collection ? getLocalChangesBackup(collection) : false) ? getEntityFromCache(path + "/" + entity.id) : false;
	const iconSize = "small";
	const content = /* @__PURE__ */ jsxs("div", {
		className: cls("h-full flex items-center justify-center flex-col z-10", isSelected ? "bg-surface-raised" : "bg-surface-card group-hover:bg-surface-card-hover", frozen ? "sticky left-0" : ""),
		onClick: useCallback((event) => {
			event.stopPropagation();
		}, []),
		style: {
			width,
			position: frozen ? "sticky" : "relative",
			left: frozen ? 0 : "initial",
			contain: "strict"
		},
		children: [(hasActions || selectionEnabled) && /* @__PURE__ */ jsxs("div", {
			className: cls("absolute inset-0 flex items-center justify-center gap-0.5", isSelected ? "bg-surface-raised" : "bg-surface-card group-hover:bg-surface-card-hover opacity-0 group-hover:opacity-100 focus-within:opacity-100 transition-opacity duration-100"),
			children: [
				uncollapsedActions.map((action, index) => {
					const isEditAction = action.key === "edit";
					const tooltip = isEditAction && hasDraft ? t("unsaved_local_changes") : action.name;
					let iconButton = /* @__PURE__ */ jsx(IconButton, {
						onClick: (event) => {
							event.stopPropagation();
							action.onClick({
								view: "collection",
								entity,
								path,
								collection,
								context,
								sidePanelController: sidePanelCtrl,
								selectionController,
								highlightEntity,
								unhighlightEntity,
								onCollectionChange,
								openEntityMode: openEntityMode ?? collection?.openEntityMode
							});
						},
						size: iconSize,
						children: getIcon(action.icon, void 0, void 0, "smallest")
					});
					if (isEditAction && hasDraft) iconButton = /* @__PURE__ */ jsx(Badge, {
						color: "warning",
						children: iconButton
					});
					return /* @__PURE__ */ jsx(Tooltip, {
						title: tooltip,
						asChild: true,
						children: iconButton
					}, index);
				}),
				slotActions,
				hasCollapsedActions && /* @__PURE__ */ jsx(Menu, {
					trigger: /* @__PURE__ */ jsx(IconButton, {
						size: iconSize,
						children: /* @__PURE__ */ jsx(MoreVerticalIcon, {})
					}),
					children: collapsedActions.map((action, index) => /* @__PURE__ */ jsxs(MenuItem, {
						onClick: (e) => {
							e.stopPropagation();
							action.onClick({
								view: "collection",
								entity,
								path,
								collection,
								context,
								sidePanelController: sidePanelCtrl,
								selectionController,
								highlightEntity,
								unhighlightEntity,
								onCollectionChange,
								openEntityMode: openEntityMode ?? collection?.openEntityMode
							});
						},
						children: [getIcon(action.icon, void 0, void 0, "smallest"), action.name]
					}, index))
				}),
				selectionEnabled && /* @__PURE__ */ jsx(Tooltip, {
					title: `Select ${entity.id}`,
					children: /* @__PURE__ */ jsx(Checkbox, {
						size: "smallest",
						checked: Boolean(isSelected),
						onCheckedChange
					})
				})
			]
		}), !hideId && /* @__PURE__ */ jsx("div", {
			className: "w-[138px] overflow-hidden truncate font-mono text-xs text-text-secondary dark:text-text-secondary-dark max-w-full text-ellipsis px-2 align-center justify-center flex items-center gap-1",
			onClick: (event) => {
				event.stopPropagation();
			},
			children: /* @__PURE__ */ jsx("span", {
				className: "min-w-0 truncate text-center",
				children: entity ? entity.id : /* @__PURE__ */ jsx(Skeleton, {})
			})
		})]
	});
	if (sortableNodeRef) {
		const { tabIndex: _tabIndex, ...sortableAttrsWithoutTabIndex } = sortableAttributes ?? {};
		return /* @__PURE__ */ jsx("div", {
			ref: sortableNodeRef,
			style: sortableStyle,
			className: cls("flex-shrink-0", frozen && "sticky left-0 z-10 bg-surface-card"),
			...sortableAttrsWithoutTabIndex,
			children: content
		});
	}
	return content;
};
//#endregion
//#region src/components/CollectionTableBinding/internal/CollectionTableToolbar.tsx
function CollectionTableToolbar({ actions, actionsStart, loading, onTextSearch, title, viewModeToggle, initialSearchText, compact = false }) {
	const largeLayout = useLargeLayout();
	const { t } = useTranslation();
	const actionChildren = React.Children.toArray(actions);
	const addButton = actionChildren.length > 0 ? actionChildren[actionChildren.length - 1] : null;
	const secondaryActions = actionChildren.slice(0, -1);
	return /* @__PURE__ */ jsxs("div", {
		className: cls("no-scrollbar min-h-[52px] overflow-x-auto px-2 md:px-4 bg-surface-sheet flex flex-row justify-between items-center w-full"),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "flex items-center gap-1 md:mr-4 mr-2 min-w-0",
			children: [
				!compact && viewModeToggle,
				title && /* @__PURE__ */ jsx("div", {
					className: "flex items-center",
					children: title
				}),
				actionsStart
			]
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex items-center gap-1",
			children: [
				largeLayout && !compact && loading && /* @__PURE__ */ jsx("div", {
					className: "mr-4",
					children: /* @__PURE__ */ jsx(CircularProgress, { size: "smallest" })
				}),
				!compact && onTextSearch && /* @__PURE__ */ jsx(SearchBar, {
					size: "small",
					placeholder: t("search"),
					onTextSearch,
					expandable: true,
					initialValue: initialSearchText
				}, "search-bar"),
				/* @__PURE__ */ jsx("div", {
					className: "flex items-center gap-1",
					children: secondaryActions
				}),
				addButton
			]
		})]
	});
}
//#endregion
//#region src/components/CollectionTableBinding/internal/common.tsx
function getTableCellAlignment(property) {
	if (property.type === "boolean") return "center";
	else if (property.type === "number") {
		if (property.enum) return "left";
		return "right";
	} else if (property.type === "date") return "right";
	else return "left";
}
function getTablePropertyColumnWidth(property) {
	if (property.admin?.columnWidth) return property.admin?.columnWidth;
	if (property.type === "string") if (property.admin?.urlPreview) return 280;
	else if (property.storage) return 160;
	else if (property.enum) return 200;
	else if (property.admin?.multiline) return 300;
	else if (property.admin?.markdown) return 300;
	else if (property.email) return 200;
	else return 200;
	else if (property.type === "array") {
		const arrayProperty = property;
		if (arrayProperty.of) if (Array.isArray(property.of)) return 300;
		else return getTablePropertyColumnWidth(arrayProperty.of);
		else return 300;
	} else if (property.type === "number") {
		if (property.enum) return 200;
		return 140;
	} else if (property.type === "map") return 360;
	else if (property.type === "date") return 200;
	else if (property.type === "reference") return 220;
	else if (property.type === "relation") return 280;
	else if (property.type === "boolean") return 140;
	else return 200;
}
function getSubcollectionColumnId(collection) {
	return `subcollection:${collection.slug}`;
}
//#endregion
//#region src/components/CollectionTableBinding/column_utils.tsx
function propertiesToColumns({ properties, sortable, fixedFilter, engine, AdditionalHeaderWidget }) {
	const disabledFilter = Boolean(fixedFilter);
	return Object.entries(properties).flatMap(([key, property]) => getColumnKeysForProperty(property, key)).flatMap(({ key, disabled }) => {
		const property = getResolvedPropertyInPath(properties, key);
		if (!property) {
			console.warn(`No property found in path "${key}" — skipping that column.`);
			return [];
		}
		const filterable = filterableProperty(property, false, engine);
		return [{
			key,
			align: getTableCellAlignment(property),
			title: property.name ?? key,
			sortable: sortable && sortableProperty(property),
			filter: !disabledFilter && filterable,
			width: getTablePropertyColumnWidth(property),
			resizable: true,
			custom: {
				resolvedProperty: property,
				disabled
			},
			AdditionalHeaderWidget: AdditionalHeaderWidget ? ({ onHover }) => /* @__PURE__ */ jsx(AdditionalHeaderWidget, {
				property,
				propertyKey: key,
				onHover
			}) : void 0
		}];
	});
}
/**
* The properties a sort can be applied to, as keys and titles.
*
* Only the table renders headers, so the list, card and split views had no way
* to order anything — the controller has carried `sortBy` all along, with no
* control bound to it outside the table. This is the same walk
* `propertiesToColumns` makes, under the same keys and the same
* `sortableProperty` authority, so a sort picked from the toolbar means exactly
* what clicking the header would have meant, and the two cannot drift into
* offering different columns.
*/
function getSortablePropertyOptions(properties) {
	return Object.entries(properties).flatMap(([key, property]) => getColumnKeysForProperty(property, key)).flatMap(({ key }) => {
		const property = getResolvedPropertyInPath(properties, key);
		if (!property || !sortableProperty(property)) return [];
		return [{
			key,
			title: property.name ?? key,
			property
		}];
	});
}
/**
* Whether this column can be ordered by.
*
* `sortable` arrived as one flag for the whole table while `filter` was
* computed per property, so every column advertised a sort — including the ones
* no `ORDER BY` can be written for. A to-many relation is a *set* per row
* (`posts.tags`), and there is no single value to order on; the driver used to
* answer by silently dropping the sort and returning rows in whatever order
* Postgres pleased, which is how a header that did nothing went unnoticed.
*
* Now that the driver refuses instead, offering the control would turn a
* useless header into a failed request. Same authority as the filter side: ask
* the property, not the table.
*/
function sortableProperty(property) {
	if (property.type !== "relation") return true;
	const relationProperty = property;
	const kind = relationProperty.relation?.kind ?? relationProperty.resolvedRelation?.kind;
	if (!kind) return true;
	return kind === "belongsTo";
}
function filterableProperty(property, partOfArray = false, engine) {
	if (!isFilterableRelation(property, engine)) return false;
	if (partOfArray) return [
		"string",
		"number",
		"date",
		"reference",
		"relation"
	].includes(property.type);
	if (property.type === "array") if (property.of && !Array.isArray(property.of)) return filterableProperty(property.of, true, engine);
	else return false;
	return [
		"string",
		"number",
		"boolean",
		"date",
		"reference",
		"relation",
		"array"
	].includes(property.type);
}
//#endregion
//#region src/components/SelectableTable/filters/StringNumberFilterField.tsx
var operationLabels$3 = {
	"==": "==",
	"!=": "!=",
	">": ">",
	"<": "<",
	">=": ">=",
	"<=": "<=",
	in: "In",
	"not-in": "Not in",
	"array-contains": "Contains",
	"array-contains-any": "Any",
	"ilike": "Contains",
	"not-ilike": "Not contains",
	"is-null": "Is null",
	"is-not-null": "Is not null"
};
var multipleSelectOperations$3 = [
	"array-contains-any",
	"in",
	"not-in"
];
/** Operators that match a substring, wrapped in SQL wildcards (`%value%`). */
var containsOperations = ["ilike", "not-ilike"];
/** Strip the surrounding `%` wildcards a contains-filter adds, for display. */
function unwrapContains(value) {
	if (typeof value !== "string") return "";
	return value.replace(/^%/, "").replace(/%$/, "");
}
function StringNumberFilterField({ name, value, setValue, type, isArray, enumValues, title, operators }) {
	const { t } = useTranslation();
	let possibleOperations = isArray ? ["array-contains"] : [
		"==",
		"!=",
		">",
		"<",
		">=",
		"<=",
		"is-null",
		"is-not-null"
	];
	if (!isArray && !enumValues && type === "string") possibleOperations.push("ilike", "not-ilike");
	if (enumValues) if (isArray) possibleOperations.push("array-contains-any");
	else possibleOperations.push("in", "not-in");
	if (operators) possibleOperations = possibleOperations.filter((op) => operators.includes(op));
	const [fieldOperation, fieldValue] = value || [possibleOperations[0], void 0];
	const [operation, setOperation] = useState(fieldOperation === "==" && fieldValue === null ? "is-null" : fieldOperation === "!=" && fieldValue === null ? "is-not-null" : fieldOperation);
	const [internalValue, setInternalValue] = useState(containsOperations.includes(fieldOperation) ? unwrapContains(fieldValue) : fieldValue);
	const isNullOperation = operation === "is-null" || operation === "is-not-null";
	if (possibleOperations.length === 0) return null;
	function updateFilter(op, val) {
		if (op === "is-null" || op === "is-not-null") {
			setOperation(op);
			setInternalValue(null);
			setValue([op, null]);
			return;
		}
		if (op === "ilike" || op === "not-ilike") {
			const raw = typeof val === "string" ? val : "";
			setOperation(op);
			setInternalValue(raw);
			if (raw.length > 0) setValue([op, `%${raw}%`]);
			else setValue(void 0);
			return;
		}
		let newValue = val;
		const prevOpIsArray = multipleSelectOperations$3.includes(operation);
		const newOpIsArray = multipleSelectOperations$3.includes(op);
		if (prevOpIsArray !== newOpIsArray) if (newOpIsArray) if (typeof val === "string") newValue = [val];
		else if (typeof val === "number") newValue = [val];
		else newValue = [];
		else newValue = void 0;
		if (typeof newValue === "number" && isNaN(newValue)) newValue = void 0;
		setOperation(op);
		setInternalValue(newValue);
		const hasNewValue = newValue !== null && Array.isArray(newValue) ? newValue.length > 0 : newValue !== void 0;
		if (op && hasNewValue) setValue([op, newValue]);
		else setValue(void 0);
	}
	const multiple = multipleSelectOperations$3.includes(operation);
	return /* @__PURE__ */ jsxs("div", {
		className: "flex w-full",
		children: [/* @__PURE__ */ jsx("div", {
			className: "w-[100px]",
			children: /* @__PURE__ */ jsx(Select, {
				value: operation,
				size: "medium",
				fullWidth: true,
				position: "item-aligned",
				onValueChange: (value) => {
					updateFilter(value, internalValue);
				},
				renderValue: (op) => operationLabels$3[op],
				children: possibleOperations.map((op) => /* @__PURE__ */ jsx(SelectItem, {
					value: op,
					children: operationLabels$3[op]
				}, op))
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: "grow ml-2 flex flex-col gap-2",
			children: [
				!enumValues && /* @__PURE__ */ jsx(TextField, {
					size: "medium",
					"aria-label": `${title ?? name} filter value`,
					type: type === "number" ? "number" : void 0,
					value: internalValue !== void 0 && internalValue != null ? String(internalValue) : "",
					disabled: isNullOperation,
					placeholder: isNullOperation ? "null" : void 0,
					onChange: (evt) => {
						const val = type === "number" ? parseFloat(evt.target.value) : evt.target.value;
						updateFilter(operation, val);
					},
					endAdornment: internalValue !== void 0 && internalValue != null && /* @__PURE__ */ jsx(IconButton, {
						onClick: (e) => updateFilter(operation, void 0),
						children: /* @__PURE__ */ jsx(XIcon, {})
					})
				}),
				enumValues && !multiple && /* @__PURE__ */ jsx(Select, {
					size: "medium",
					position: "item-aligned",
					fullWidth: true,
					disabled: isNullOperation,
					value: typeof internalValue === "string" ? internalValue : "",
					onValueChange: (value) => {
						if (value !== "") updateFilter(operation, type === "number" ? parseInt(value) : value);
					},
					endAdornment: internalValue && /* @__PURE__ */ jsx(IconButton, {
						onClick: (e) => updateFilter(operation, void 0),
						children: /* @__PURE__ */ jsx(XIcon, {})
					}),
					renderValue: (enumKey) => {
						if (enumKey === null) return t("filter_for_null_values");
						if (enumKey === void 0) return null;
						return /* @__PURE__ */ jsx(EnumValuesChip, {
							enumKey,
							enumValues,
							size: "small"
						}, `select_value_${name}_${enumKey}`);
					},
					children: enumValues.map((enumConfig) => /* @__PURE__ */ jsx(SelectItem, {
						value: String(enumConfig.id),
						children: /* @__PURE__ */ jsx(EnumValuesChip, {
							enumKey: String(enumConfig.id),
							enumValues,
							size: "small"
						})
					}, `select_item_${name}_${enumConfig.id}`))
				}),
				enumValues && multiple && /* @__PURE__ */ jsx(MultiSelect, {
					size: "medium",
					position: "item-aligned",
					value: Array.isArray(internalValue) ? internalValue.map((e) => String(e)) : [],
					disabled: isNullOperation,
					onValueChange: (value) => {
						updateFilter(operation, type === "number" ? (value ?? []).map((v) => parseInt(v)) : value);
					},
					multiple,
					endAdornment: internalValue && /* @__PURE__ */ jsx(IconButton, {
						className: "absolute right-2 top-3",
						onClick: (e) => updateFilter(operation, void 0),
						children: /* @__PURE__ */ jsx(XIcon, {})
					}),
					children: enumValues.map((enumConfig) => /* @__PURE__ */ jsx(MultiSelectItem, {
						value: String(enumConfig.id),
						children: /* @__PURE__ */ jsx(EnumValuesChip, {
							enumKey: String(enumConfig.id),
							enumValues,
							size: "small"
						})
					}, `select_value_${name}_${enumConfig.id}`))
				})
			]
		})]
	});
}
//#endregion
//#region src/components/SelectableTable/filters/BooleanFilterField.tsx
function BooleanFilterField({ name, title, value, setValue, operators }) {
	const { t } = useTranslation();
	if (operators && !operators.includes("==")) return null;
	function updateFilter(val) {
		if (val !== void 0) setValue(["==", val]);
		else setValue(void 0);
	}
	const valueSetToTrue = value && value[1];
	return /* @__PURE__ */ jsx("div", {
		className: "w-full",
		children: /* @__PURE__ */ jsx(BooleanSwitchWithLabel, {
			size: "medium",
			value: valueSetToTrue,
			allowIndeterminate: true,
			onValueChange: (v) => updateFilter(v === null ? void 0 : v),
			label: !!!value ? t("no_filter") : valueSetToTrue ? `${title} ${t("is_true")}` : `${title} ${t("is_false")}`
		})
	});
}
//#endregion
//#region src/components/SelectableTable/filters/DateTimeFilterField.tsx
var operationLabels$2 = {
	"==": "==",
	"!=": "!=",
	">": ">",
	"<": "<",
	">=": ">=",
	"<=": "<=",
	"not-in": "not in",
	in: "in",
	"array-contains": "Contains",
	"array-contains-any": "Any",
	"is-null": "Is null",
	"is-not-null": "Is not null"
};
var multipleSelectOperations$2 = ["array-contains-any", "in"];
function DateTimeFilterField({ name, isArray, mode, value, setValue, title, timezone, operators }) {
	const { locale } = useCustomizationController();
	let possibleOperations = isArray ? ["array-contains"] : [
		"==",
		"!=",
		">",
		"<",
		">=",
		"<=",
		"is-null",
		"is-not-null"
	];
	if (operators) possibleOperations = possibleOperations.filter((op) => operators.includes(op));
	const [fieldOperation, fieldValue] = value || [possibleOperations[0], void 0];
	const [operation, setOperation] = useState(fieldOperation === "==" && fieldValue === null ? "is-null" : fieldOperation === "!=" && fieldValue === null ? "is-not-null" : fieldOperation);
	const [internalValue, setInternalValue] = useState(fieldValue);
	const isNullOperation = operation === "is-null" || operation === "is-not-null";
	if (possibleOperations.length === 0) return null;
	function updateFilter(op, val) {
		if (op === "is-null" || op === "is-not-null") {
			setOperation(op);
			setInternalValue(null);
			setValue([op, null]);
			return;
		}
		let newValue = val;
		const prevOpIsArray = multipleSelectOperations$2.includes(operation);
		const newOpIsArray = multipleSelectOperations$2.includes(op);
		if (prevOpIsArray !== newOpIsArray) newValue = newOpIsArray ? val ? [val] : [] : void 0;
		setOperation(op);
		setInternalValue(Array.isArray(newValue) ? newValue[0] ?? null : newValue);
		const hasNewValue = newValue !== null && Array.isArray(newValue) ? newValue.length > 0 : newValue !== void 0;
		if (op && hasNewValue) setValue([op, newValue]);
		else setValue(void 0);
	}
	return /* @__PURE__ */ jsxs("div", {
		className: "flex w-full",
		children: [/* @__PURE__ */ jsx("div", {
			className: "w-[100px]",
			children: /* @__PURE__ */ jsx(Select, {
				value: operation,
				size: "medium",
				fullWidth: true,
				onValueChange: (value) => {
					updateFilter(value, internalValue);
				},
				renderValue: (op) => operationLabels$2[op],
				children: possibleOperations.map((op) => /* @__PURE__ */ jsx(SelectItem, {
					value: op,
					children: operationLabels$2[op]
				}, op))
			})
		}), /* @__PURE__ */ jsx("div", {
			className: "grow ml-2 flex flex-col gap-2",
			children: /* @__PURE__ */ jsx(DateTimeField, {
				mode,
				size: "medium",
				locale,
				timezone,
				disabled: isNullOperation,
				value: isNullOperation ? void 0 : internalValue ?? void 0,
				onChange: (dateValue) => {
					updateFilter(operation, dateValue === null ? void 0 : dateValue);
				},
				clearable: true
			})
		})]
	});
}
//#endregion
//#region src/components/SelectableTable/filters/null_filter.ts
/** Whether `op` asks about absence rather than about a value. */
function isNullFilterOperator(op) {
	return op === "is-null" || op === "is-not-null";
}
/**
* The null check carrying the same sense as `op`.
*
* The checkbox is a toggle, not an operator, so the operator it is ticked
* alongside is what says which way round it means: `==`/`in` are asking for
* a match, so their null form is "has nothing"; `!=`/`not-in` are asking for
* the absence of one, so theirs is "has something".
*/
function nullFilterOperatorFor(op) {
	if (op === "!=" || op === "not-in" || op === "is-not-null") return "is-not-null";
	return "is-null";
}
/**
* The value operator to return to when the checkbox is unticked.
*
* `is-null` could have been reached from `==` or from `in` — the field cannot
* know which, and it does not matter. What matters is landing on an operator
* the dropdown actually offers, in the same sense, so the control does not
* come back showing something it cannot render.
*/
function valueOperatorFor(op, offered) {
	return (op === "is-not-null" ? ["!=", "not-in"] : [
		"==",
		"in",
		"array-contains"
	]).find((candidate) => offered.includes(candidate)) ?? offered.find((candidate) => !isNullFilterOperator(candidate));
}
//#endregion
//#region src/components/SelectableTable/filters/ReferenceFilterField.tsx
var operationLabels$1 = {
	"==": "==",
	"!=": "!=",
	">": ">",
	"<": "<",
	">=": ">=",
	"<=": "<=",
	in: "In",
	"not-in": "Not in",
	"array-contains": "Contains",
	"array-contains-any": "Contains Any",
	"is-null": "Is null",
	"is-not-null": "Is not null"
};
var multipleSelectOperations$1 = [
	"array-contains-any",
	"in",
	"not-in"
];
function ReferenceFilterField({ value, setValue, isArray, path, includeId = true, previewProperties, setHidden, operators }) {
	const { t } = useTranslation();
	let possibleOperations = isArray ? ["array-contains"] : [
		"==",
		"!=",
		">",
		"<",
		">=",
		"<="
	];
	if (isArray) possibleOperations.push("array-contains-any");
	else possibleOperations.push("in", "not-in");
	possibleOperations.push("is-null", "is-not-null");
	if (operators) possibleOperations = possibleOperations.filter((op) => operators.includes(op));
	const [fieldOperation, fieldValue] = value || [possibleOperations[0], void 0];
	const [operation, setOperation] = useState(fieldOperation);
	const [internalValue, setInternalValue] = useState(fieldValue);
	const selectedEntityIds = internalValue ? Array.isArray(internalValue) ? internalValue.map((ref) => {
		if (!(ref?.isEntityReference && ref?.isEntityReference())) return null;
		return ref.id;
	}).filter(Boolean) : [internalValue.id] : [];
	function updateFilter(op, val) {
		const prevOpIsArray = multipleSelectOperations$1.includes(operation);
		const newOpIsArray = multipleSelectOperations$1.includes(op);
		let newValue = val;
		if (prevOpIsArray !== newOpIsArray) newValue = newOpIsArray ? newValue && !Array.isArray(newValue) && newValue.isEntityReference?.() ? [newValue] : [] : void 0;
		setOperation(op);
		setInternalValue(newValue);
		if (isNullFilterOperator(op)) {
			setValue([op, null]);
			return;
		}
		const hasNewValue = newValue !== null && Array.isArray(newValue) ? newValue.length > 0 : newValue !== void 0;
		if (op && hasNewValue) setValue([op, newValue]);
		else setValue(void 0);
	}
	const collectionRegistryController = useCollectionRegistryController();
	const collection = useMemo(() => {
		return path ? collectionRegistryController.getCollection(path) : void 0;
	}, [path]);
	const onSingleEntitySelected = (entity) => {
		updateFilter(operation, getReferenceFrom(entity));
	};
	const onMultipleEntitiesSelected = (entities) => {
		updateFilter(operation, entities.map((e) => getReferenceFrom(e)));
	};
	const multiple = multipleSelectOperations$1.includes(operation);
	const nullFiltered = isNullFilterOperator(operation);
	const nullFilterId = useId();
	const referenceDialogController = useSelectionDialog({
		multiselect: multiple,
		path,
		collection,
		onSingleEntitySelected,
		onMultipleEntitiesSelected,
		selectedEntityIds,
		onClose: () => {
			setHidden(false);
		}
	});
	const doOpenDialog = () => {
		setHidden(true);
		referenceDialogController.open();
	};
	const buildEntry = (reference) => {
		return /* @__PURE__ */ jsx(ReferencePreview, {
			disabled: !path,
			previewProperties,
			size: "medium",
			onClick: doOpenDialog,
			reference,
			hover: true,
			includeId,
			includeEntityLink: false
		});
	};
	if (possibleOperations.length === 0) return null;
	return /* @__PURE__ */ jsxs("div", {
		className: "flex w-full flex-row",
		children: [/* @__PURE__ */ jsx("div", {
			className: "w-[100px]",
			children: /* @__PURE__ */ jsx(Select, {
				value: operation,
				size: "medium",
				fullWidth: true,
				onValueChange: (value) => {
					updateFilter(value, internalValue);
				},
				renderValue: (op) => operationLabels$1[op],
				children: possibleOperations.map((op) => /* @__PURE__ */ jsx(SelectItem, {
					value: op,
					children: operationLabels$1[op]
				}, op))
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: "grow ml-2 h-full gap-2 flex flex-col",
			children: [
				internalValue && Array.isArray(internalValue) && /* @__PURE__ */ jsx("div", { children: internalValue.map((ref, index) => buildEntry(ref)) }),
				internalValue && !Array.isArray(internalValue) && /* @__PURE__ */ jsx("div", { children: buildEntry(internalValue) }),
				(!internalValue || Array.isArray(internalValue) && internalValue.length === 0) && /* @__PURE__ */ jsx(Button, {
					onClick: doOpenDialog,
					size: "medium",
					className: "h-full w-full",
					children: multiple ? t("select_references") : t("select_reference")
				}),
				!isArray && /* @__PURE__ */ jsxs(Label, {
					className: "border border-hairline cursor-pointer rounded-md p-2 flex items-center gap-2 bg-surface-field hover:bg-surface-field-hover",
					htmlFor: nullFilterId,
					children: [/* @__PURE__ */ jsx(Checkbox, {
						id: nullFilterId,
						checked: nullFiltered,
						size: "small",
						onCheckedChange: () => {
							if (!nullFiltered) updateFilter(nullFilterOperatorFor(operation), null);
							else updateFilter(valueOperatorFor(operation, possibleOperations) ?? operation, void 0);
						}
					}), t("filter_for_null_values")]
				})
			]
		})]
	});
}
//#endregion
//#region src/components/SelectableTable/filters/RelationFilterField.tsx
/** Whether an authored relation yields many rows. Derived from its kind. */
function relationCardinality(relation) {
	if (!relation) return void 0;
	if (relation.kind === "via") return relation.cardinality;
	if (relation.kind === "hasMany" || relation.kind === "manyToMany") return "many";
	if (relation.kind === "belongsTo" || relation.kind === "hasOne") return "one";
	return relation.cardinality;
}
var operationLabels = {
	"==": "==",
	"!=": "!=",
	">": ">",
	"<": "<",
	">=": ">=",
	"<=": "<=",
	in: "In",
	"not-in": "Not in",
	"array-contains": "Contains",
	"array-contains-any": "Contains Any",
	"is-null": "Is empty",
	"is-not-null": "Is not empty"
};
var multipleSelectOperations = [
	"array-contains-any",
	"in",
	"not-in"
];
/**
* What this field can render, before `operators` narrows it.
*
* Every relation gets the whole set. The value selector is told how many
* values to take by the *operator* — see the `multiple` prop passed below —
* so a to-many relation can be asked `== <one tag>` as readily as
* `in <several>`, and the question of what shape the relation stores never
* enters into it.
*
* That is a change: this list used to be split by the value the selector
* produced, because the selector took its multiplicity from the relation's
* cardinality and so a to-many one could only ever emit a list. Every
* single-value operator had to be withheld to keep an array from reaching
* `==`. `ReferenceFilterField` never had the problem — it has always sized its
* dialog from the operator — which is what made the split look like a
* property of relations rather than a limitation of one component.
*
* The array operators are the exception, and belong only to a to-many link,
* which is the only one that *is* a list. On a to-one relation the filter
* compiles to a comparison on a scalar foreign key, and `@>` against one is a
* type error rather than an empty result.
*/
var RELATION_OPERATIONS = [
	"==",
	"!=",
	">",
	"<",
	">=",
	"<=",
	"in",
	"not-in",
	"is-null",
	"is-not-null"
];
var LIST_ONLY_OPERATIONS = ["array-contains", "array-contains-any"];
/**
* The operators this field will actually put on screen.
*
* Exported because the failure mode is silence: when the intersection of what
* the field can render and what the engine can run comes out empty, the field
* returns null and the filter control the table header offered opens onto
* nothing. That is a rendering outcome no unit test of either side alone
* catches, so the intersection itself is the thing worth pinning.
*/
function renderableRelationOperators(relation, operators) {
	const possible = relationCardinality(relation) === "many" ? [...RELATION_OPERATIONS, ...LIST_ONLY_OPERATIONS] : RELATION_OPERATIONS;
	if (!operators) return possible;
	return possible.filter((op) => operators.includes(op));
}
function RelationFilterField({ value, setValue, relation, name: _name, hidden: _hidden, setHidden: _setHidden, operators }) {
	const manyRelation = relationCardinality(relation) === "many";
	const nullFilterId = useId();
	const possibleOperations = renderableRelationOperators(relation, operators);
	const [fieldOperation, fieldValue] = value || [possibleOperations[0], void 0];
	const [operation, setOperation] = useState(fieldOperation);
	const [internalValue, setInternalValue] = useState(fieldValue);
	function updateFilter(op, val) {
		const prevOpIsArray = multipleSelectOperations.includes(operation);
		const newOpIsArray = multipleSelectOperations.includes(op);
		let newValue = val;
		if (prevOpIsArray !== newOpIsArray) newValue = newOpIsArray ? newValue instanceof EntityRelation ? [newValue] : [] : void 0;
		setOperation(op);
		setInternalValue(newValue);
		if (isNullFilterOperator(op)) {
			setValue([op, null]);
			return;
		}
		const hasNewValue = newValue !== null && Array.isArray(newValue) ? newValue.length > 0 : newValue !== void 0;
		if (op && hasNewValue) setValue([op, newValue ?? null]);
		else setValue(void 0);
	}
	const multiple = multipleSelectOperations.includes(operation);
	const nullFiltered = isNullFilterOperator(operation);
	const relationSelectorValue = useMemo(() => {
		if (internalValue === null || internalValue === void 0) return void 0;
		if (Array.isArray(internalValue)) return internalValue.map((ref) => new EntityRelation(ref.id, ref.path));
		return new EntityRelation(internalValue.id, internalValue.path);
	}, [internalValue]);
	const handleRelationSelectorChange = (newVal) => {
		if (newVal === null) {
			updateFilter(operation, null);
			return;
		}
		if (newVal === void 0) {
			updateFilter(operation, void 0);
			return;
		}
		updateFilter(operation, newVal);
	};
	if (possibleOperations.length === 0) return null;
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-row",
		children: [/* @__PURE__ */ jsx("div", {
			className: "",
			children: /* @__PURE__ */ jsx(Select, {
				value: operation,
				fullWidth: true,
				onValueChange: (newOp) => {
					updateFilter(newOp, internalValue);
				},
				renderValue: (op) => operationLabels[op],
				children: possibleOperations.map((op) => /* @__PURE__ */ jsx(SelectItem, {
					value: op,
					children: operationLabels[op]
				}, op))
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: "grow ml-2 h-full gap-2 flex flex-col w-[340px]",
			children: [/* @__PURE__ */ jsx(RelationSelector, {
				relation,
				multiple,
				value: relationSelectorValue,
				onValueChange: handleRelationSelectorChange,
				disabled: nullFiltered,
				size: "medium"
			}), /* @__PURE__ */ jsxs(Label, {
				className: "border border-hairline cursor-pointer rounded-md p-2 flex items-center gap-2 bg-surface-field hover:bg-surface-field-hover",
				htmlFor: nullFilterId,
				children: [/* @__PURE__ */ jsx(Checkbox, {
					id: nullFilterId,
					checked: nullFiltered,
					size: "small",
					onCheckedChange: () => {
						if (!nullFiltered) updateFilter(nullFilterOperatorFor(operation), null);
						else updateFilter(valueOperatorFor(operation, possibleOperations) ?? operation, void 0);
					}
				}), manyRelation ? "Filter for empty relations" : "Filter for null values"]
			})]
		})]
	});
}
//#endregion
//#region src/components/SelectableTable/filters/FilterFieldBinding.tsx
/**
* The single entry point for rendering a collection filter field.
* Used by both the table header filters ({@link SelectableTable}) and the
* Filters dialog.
*
* Resolution order:
* 1. `property.admin.Filter` — per-property replacement (rendered even when the
*    resolved operator list is empty; the component owns filterability).
* 2. `components["Collection.FilterField"]` — collection-level or app-level
*    override (wrap mode supported via `OriginalComponent`).
* 3. Built-in field dispatched by property type.
*
* The operators handed to the field are the intersection of the engine's
* capabilities, the property-type defaults, and `property.admin.filterOperators`
* (see `resolveFilterOperators`). When that intersection is empty and no
* per-property `Filter` is set, nothing is rendered.
*
* @group Components
*/
function FilterFieldBinding({ propertyKey, property, engine, value, setValue, hidden, setHidden }) {
	const isArray = property.type === "array";
	const ofVal = isArray ? property.of : void 0;
	const baseProperty = isArray ? Array.isArray(ofVal) ? ofVal[0] : ofVal : property;
	const scopeCollection = useCollectionScope();
	const ResolvedFilterField = useComponentOverride("Collection.FilterField", DefaultFilterField);
	const PropertyFilter = useResolvedComponent(baseProperty?.admin?.Filter);
	if (!baseProperty) return null;
	const operators = resolveFilterOperators({
		property: baseProperty,
		isArray,
		engine: engine ?? scopeCollection?.engine
	});
	const bindingProps = {
		propertyKey,
		property: baseProperty,
		isArray,
		operators,
		value,
		setValue,
		title: property.name,
		hidden,
		setHidden
	};
	if (PropertyFilter) return /* @__PURE__ */ jsx(Suspense, {
		fallback: null,
		children: /* @__PURE__ */ jsx(PropertyFilter, { ...bindingProps })
	});
	if (operators.length === 0) return null;
	return /* @__PURE__ */ jsx(ResolvedFilterField, { ...bindingProps });
}
/**
* Built-in filter field dispatch by property type. This is the
* `OriginalComponent` received by `"Collection.FilterField"` overrides in
* wrap mode.
*/
function DefaultFilterField({ propertyKey, property, isArray, operators, value, setValue, title, hidden, setHidden }) {
	if (property.type === "reference") {
		const referenceProperty = property;
		return /* @__PURE__ */ jsx(ReferenceFilterField, {
			value,
			setValue,
			name: propertyKey,
			isArray,
			operators,
			path: referenceProperty.path,
			title,
			includeId: referenceProperty.admin?.includeId,
			previewProperties: referenceProperty.admin?.previewProperties,
			hidden: hidden ?? false,
			setHidden: setHidden ?? (() => void 0)
		});
	}
	if (property.type === "relation") {
		const relation = property.relation;
		if (!relation) return null;
		return /* @__PURE__ */ jsx(RelationFilterField, {
			value,
			setValue,
			name: propertyKey,
			operators,
			relation,
			hidden: hidden ?? false,
			setHidden: setHidden ?? (() => void 0)
		});
	}
	if (property.type === "number" || property.type === "string") {
		const enumValues = property.enum ? enumToObjectEntries(property.enum) : void 0;
		return /* @__PURE__ */ jsx(StringNumberFilterField, {
			value,
			setValue,
			name: propertyKey,
			type: property.type,
			isArray,
			operators,
			enumValues,
			title
		});
	}
	if (property.type === "boolean") return /* @__PURE__ */ jsx(BooleanFilterField, {
		value,
		setValue,
		name: propertyKey,
		operators,
		title
	});
	if (property.type === "date") return /* @__PURE__ */ jsx(DateTimeFilterField, {
		value,
		setValue,
		name: propertyKey,
		mode: property.mode,
		isArray,
		operators,
		title
	});
	return null;
}
//#endregion
//#region src/components/SelectableTable/SelectableTable.tsx
/**
* This component is in charge of rendering a collection table with a high
* degree of customization.
*
* This component is used internally by {@link CollectionViewBinding} and
* {@link useReferenceDialog}
*
* Please note that you only need to use this component if you are building
* a custom view. If you just need to create a default view you can do it
* exclusively with config options.
*
* If you want to bind a {@link AdminCollection} to a table with the default
* options you see in collections in the top level navigation, you can
* check {@link CollectionViewBinding}.
*
* The data displayed in the table is managed by a {@link EntityTableController}.
* You can build the default, bound to a path in the driver, by using the hook
* {@link useDataTableController}
*
* @see CollectionTableBindingProps
* @see CollectionViewBinding
* @see VirtualTable
* @group Components
*/
var SelectableTable = function SelectableTable({ onValueChange, cellRenderer, onEntityClick, onColumnResize, hoverRow = true, size = "m", inlineEditing = false, tableController: { data, dataLoading, noMoreToLoad, dataLoadingError, filterValues, setFilterValues, sortBy, setSortBy, itemCount, setItemCount, pageSize = DEFAULT_PAGE_SIZE, paginationEnabled, checkFilterCombination, setPopupCell }, filterable = true, onScroll, initialScroll, emptyComponent, columns, fixedFilter, highlightedRow, endAdornment, AddColumnComponent, onColumnsOrderChange, extraData }) {
	const ref = useRef(null);
	const selectionStore = useMemo(() => createSelectionStore(), []);
	const [localSelectedCell, setLocalSelectedCell] = React.useState(void 0);
	const loadNextPage = useCallback(() => {
		if (!paginationEnabled || dataLoading || noMoreToLoad) return;
		if (itemCount !== void 0) setItemCount?.(itemCount + pageSize);
	}, [
		paginationEnabled,
		dataLoading,
		noMoreToLoad,
		itemCount,
		pageSize,
		setItemCount
	]);
	const resetPagination = useCallback(() => {
		setItemCount?.(pageSize);
	}, [pageSize]);
	const onRowClick = useCallback(({ rowData }) => {
		if (inlineEditing) return;
		return onEntityClick && onEntityClick(rowData);
	}, [onEntityClick, inlineEditing]);
	const select = useCallback((cell) => {
		setLocalSelectedCell(cell);
		if (cell) selectionStore.select({
			...cell,
			columnKey: cell.propertyKey,
			id: cell.entityId
		});
		else selectionStore.select(void 0);
	}, [selectionStore]);
	const unselect = useCallback(() => {
		setLocalSelectedCell(void 0);
		selectionStore.select(void 0);
	}, [selectionStore]);
	useOutsideAlerter(ref, () => {
		if (localSelectedCell) unselect();
	}, Boolean(localSelectedCell));
	useEffect(() => {
		const escFunction = (event) => {
			if (event.key === "Escape") unselect();
		};
		document.addEventListener("keydown", escFunction, false);
		return () => {
			document.removeEventListener("keydown", escFunction, false);
		};
	}, [unselect]);
	const onFilterUpdate = useCallback((updatedFilterValues) => {
		if (setFilterValues) setFilterValues({
			...updatedFilterValues,
			...fixedFilter
		});
	}, [fixedFilter, setFilterValues]);
	const contextValue = useMemo(() => ({
		select,
		onValueChange,
		size: size ?? "m",
		selectionStore,
		setPopupCell
	}), [
		setPopupCell,
		select,
		onValueChange,
		size,
		selectionStore
	]);
	const createFilterField = useCallback(({ id, filterValue, setFilterValue, column, hidden, setHidden }) => {
		if (!column.custom) return null;
		const { resolvedProperty } = column.custom;
		if (!resolvedProperty) return null;
		return /* @__PURE__ */ jsx(FilterFieldBinding, {
			propertyKey: id,
			property: resolvedProperty,
			value: filterValue,
			setValue: setFilterValue,
			hidden,
			setHidden
		});
	}, []);
	return /* @__PURE__ */ jsx(SelectableTableContext.Provider, {
		value: contextValue,
		children: /* @__PURE__ */ jsx("div", {
			className: "h-full w-full flex flex-col bg-surface-card",
			ref,
			children: /* @__PURE__ */ jsx(VirtualTable, {
				data,
				columns,
				cellRenderer,
				onRowClick: inlineEditing ? void 0 : onEntityClick ? onRowClick : void 0,
				onEndReached: loadNextPage,
				onResetPagination: resetPagination,
				error: dataLoadingError,
				onColumnResize,
				rowHeight: getRowHeight(size),
				loading: dataLoading,
				filter: filterValues,
				onFilterUpdate: setFilterValues ? onFilterUpdate : void 0,
				sortBy,
				onSortByUpdate: setSortBy,
				hoverRow,
				initialScroll,
				onScroll,
				checkFilterCombination,
				createFilterField: filterable ? createFilterField : void 0,
				rowClassName: useCallback((entity) => {
					return highlightedRow?.(entity) ? "!bg-surface-raised" : "";
				}, [highlightedRow]),
				className: "grow",
				emptyComponent,
				endAdornment,
				AddColumnComponent,
				onColumnsOrderChange,
				extraData
			})
		})
	});
};
//#endregion
//#region src/components/CollectionTableBinding/CollectionTableBinding.tsx
/**
* This component is in charge of rendering a collection table with a high
* degree of customization.
*
* This component is used internally by {@link CollectionViewBinding} and
* {@link useReferenceDialog}
*
* Please note that you only need to use this component if you are building
* a custom view. If you just need to create a default view you can do it
* exclusively with config options.
*
* If you want to bind a {@link AdminCollection} to a table with the default
* options you see in collections in the top level navigation, you can
* check {@link CollectionViewBinding}.
*
* The data displayed in the table is managed by a {@link EntityTableController}.
* You can build the default, bound to a path in the driver, by using the hook
* {@link useDataTableController}
*
* @see CollectionTableBindingProps
* @see CollectionViewBinding
* @see VirtualTable
* @group Components
*/
var CollectionTableBinding = function CollectionTableBinding({ className, style, fixedFilter, actionsStart, actions, viewModeToggle, title, tableRowActionsBuilder, uniqueFieldValidator, getPropertyFor, onValueChange, selectionController, highlightedEntities, onEntityClick, onColumnResize, initialScroll, onScroll, onSizeChanged, hoverRow = true, inlineEditing = false, additionalFields, displayedColumnIds, defaultSize, properties, tableController, filterable = true, sortable = true, endAdornment, AddColumnComponent, AdditionalHeaderWidget, additionalIDHeaderWidget, emptyComponent, getIdColumnWidth, enablePopupIcon, openEntityMode = "side_panel", onColumnsOrderChange, hideToolbar = false }) {
	const ref = useRef(null);
	const largeLayout = useLargeLayout();
	const hasSelection = Boolean(selectionController?.hasSelection);
	const isRowHighlighted = useCallback((entity) => {
		if (hasSelection) return selectionController.isEntitySelected(entity);
		return Boolean(highlightedEntities?.some((e) => e && e.id === entity.id && e.path === entity.path));
	}, [
		hasSelection,
		selectionController,
		highlightedEntities
	]);
	const cellExtraData = useMemo(() => ({
		selection: selectionController?.selection,
		highlightedEntityIds: highlightedEntities?.map((e) => e?.id)
	}), [selectionController?.selection, highlightedEntities]);
	const context = useRebaseContext();
	const [size, setSize] = React.useState(defaultSize ?? "m");
	React.useEffect(() => {
		if (defaultSize) setSize(defaultSize);
	}, [defaultSize]);
	useCallback((size) => {
		if (onSizeChanged) onSizeChanged(size);
		setSize(size);
	}, []);
	const onTextSearch = useCallback((newSearchString) => tableController.setSearchString?.(newSearchString), []);
	const additionalFieldsMap = useMemo(() => {
		return additionalFields ? additionalFields.map((aC) => ({ [aC.key]: aC })).reduce((a, b) => ({
			...a,
			...b
		}), {}) : {};
	}, [additionalFields]);
	const customFieldValidator = uniqueFieldValidator;
	const propertyCellRenderer = useCallback(({ column, columnIndex, rowData, rowIndex, sortableNodeRef, sortableStyle, sortableAttributes, isDragging, isDraggable, frozen }) => {
		const entity = rowData;
		if (!entity) return null;
		const propertyKey = column.key;
		const columnCustom = column.custom;
		let disabled = columnCustom?.disabled ?? false;
		const property = getPropertyFor?.({
			propertyKey,
			entity
		}) ?? columnCustom?.resolvedProperty;
		if (!property || !isDisabled(property)) disabled = false;
		if (!property) return null;
		return /* @__PURE__ */ jsx(ErrorBoundary, { children: entity ? /* @__PURE__ */ jsx(PropertyTableCell, {
			readonly: !inlineEditing,
			align: column.align ?? "left",
			propertyKey,
			property,
			value: entity?.values ? getValueInPath(entity.values, propertyKey) : void 0,
			customFieldValidator,
			columnIndex,
			width: column.width,
			height: getRowHeight(size),
			entity,
			disabled,
			enablePopupIcon,
			path: entity.path,
			sortableNodeRef,
			sortableStyle,
			sortableAttributes,
			isDragging,
			isDraggable,
			frozen
		}, `property_table_cell_${entity.id}_${propertyKey}`) : renderSkeletonText() });
	}, [
		getPropertyFor,
		customFieldValidator,
		inlineEditing,
		enablePopupIcon,
		size
	]);
	const additionalCellRenderer = useCallback(({ column, rowData, width, sortableNodeRef, sortableStyle, sortableAttributes, isDragging, isDraggable, frozen }) => {
		const entity = rowData;
		if (!entity) return null;
		const additionalField = additionalFieldsMap[column.key];
		const value = additionalField.dependencies ? Object.entries(entity.values).filter(([key, value]) => additionalField.dependencies.includes(key)).reduce((a, b) => ({
			...a,
			...b
		}), {}) : entity;
		const Builder = additionalField.Builder;
		if (!Builder && !additionalField.value) throw new Error("When using additional fields you need to provide a Builder or a value");
		return /* @__PURE__ */ jsx(EntityTableCell, {
			width,
			size,
			value,
			selected: false,
			disabled: true,
			align: "left",
			allowScroll: false,
			showExpandIcon: false,
			disabledTooltip: "This column can't be edited directly",
			sortableNodeRef,
			sortableStyle,
			sortableAttributes,
			isDragging,
			isDraggable,
			frozen,
			children: /* @__PURE__ */ jsx(ErrorBoundary, { children: Builder ? /* @__PURE__ */ jsx(Builder, {
				entity,
				context
			}) : /* @__PURE__ */ jsx(AdditionalFieldValue, {
				field: additionalField,
				entity,
				context
			}) })
		}, `additional_table_cell_${entity.id}_${column.key}`);
	}, [size]);
	const engine = useCollectionScope()?.engine;
	const collectionColumns = useMemo(() => {
		const columnsResult = propertiesToColumns({
			properties,
			sortable,
			fixedFilter,
			engine,
			AdditionalHeaderWidget
		});
		const propertyColumnKeys = new Set(columnsResult.map((col) => col.key));
		const additionalTableColumns = additionalFields ? additionalFields.filter((additionalField) => !propertyColumnKeys.has(additionalField.key)).map((additionalField) => ({
			key: additionalField.key,
			align: "left",
			sortable: false,
			title: additionalField.name,
			width: additionalField.width ?? 200
		})) : [];
		return [...columnsResult, ...additionalTableColumns];
	}, [
		properties,
		sortable,
		fixedFilter,
		engine,
		AdditionalHeaderWidget,
		additionalFields
	]);
	const idColumn = useMemo(() => ({
		key: "id_ewcfedcswdf3",
		width: getIdColumnWidth?.() ?? (largeLayout ? 140 : 120),
		title: "ID",
		resizable: false,
		frozen: largeLayout,
		headerAlign: "center",
		align: "center",
		AdditionalHeaderWidget: () => additionalIDHeaderWidget
	}), [
		getIdColumnWidth,
		largeLayout,
		additionalIDHeaderWidget
	]);
	const columns = useMemo(() => [idColumn, ...displayedColumnIds ? displayedColumnIds.map((p) => {
		return collectionColumns.find((c) => c.key === p.key);
	}).filter(Boolean) : collectionColumns], [
		idColumn,
		displayedColumnIds,
		collectionColumns
	]);
	const cellRenderer = useCallback((props) => {
		const column = props.column;
		const columns = props.columns;
		const columnKey = column.key;
		try {
			if (props.columnIndex === 0) if (tableRowActionsBuilder) return tableRowActionsBuilder({
				entity: props.rowData,
				size,
				width: column.width,
				frozen: column.frozen
			});
			else return /* @__PURE__ */ jsx(CollectionRowActions, {
				entity: props.rowData,
				width: column.width,
				frozen: column.frozen,
				isSelected: false,
				size,
				openEntityMode,
				sortableNodeRef: props.sortableNodeRef,
				sortableStyle: props.sortableStyle,
				sortableAttributes: props.sortableAttributes,
				isDragging: props.isDragging,
				isDraggable: props.isDraggable
			});
			else if (additionalFieldsMap[columnKey]) return additionalCellRenderer(props);
			else if (props.columnIndex < columns.length + 1) return propertyCellRenderer(props);
			else throw Error("Internal: columns not mapped properly");
		} catch (e) {
			console.error("Error rendering cell", e);
			return /* @__PURE__ */ jsx(EntityTableCell, {
				size,
				width: column.width,
				savedTimestamp: void 0,
				value: null,
				align: "left",
				fullHeight: false,
				disabled: true,
				sortableNodeRef: props.sortableNodeRef,
				sortableStyle: props.sortableStyle,
				sortableAttributes: props.sortableAttributes,
				isDragging: props.isDragging,
				isDraggable: props.isDraggable,
				frozen: props.frozen,
				children: /* @__PURE__ */ jsx(ErrorView, { error: e instanceof Error ? e : new Error(String(e)) })
			});
		}
	}, [
		tableRowActionsBuilder,
		additionalCellRenderer,
		propertyCellRenderer,
		size
	]);
	return /* @__PURE__ */ jsxs("div", {
		ref,
		style,
		className: cls("h-full w-full flex flex-col bg-surface-card", className),
		children: [!hideToolbar && /* @__PURE__ */ jsx(CollectionTableToolbar, {
			onTextSearch,
			title,
			actionsStart,
			actions,
			viewModeToggle,
			loading: tableController.dataLoading
		}), /* @__PURE__ */ jsx(SelectableTable, {
			columns,
			size,
			inlineEditing,
			cellRenderer,
			onEntityClick,
			highlightedRow: isRowHighlighted,
			tableController,
			onValueChange,
			initialScroll,
			onScroll,
			onColumnResize,
			hoverRow,
			filterable,
			emptyComponent,
			endAdornment,
			AddColumnComponent,
			onColumnsOrderChange,
			extraData: cellExtraData
		})]
	});
};
//#endregion
//#region src/components/CollectionViewBinding/useSelectionController.tsx
/** Same row: id alone is not unique across a junction-backed tab's two paths. */
function sameEntity(a, b) {
	return a.id === b.id && a.path === b.path;
}
var EMPTY_SELECTION = {
	type: "entities",
	entities: []
};
function useSelectionController(onSelectionChange) {
	const [selection, setSelection] = useState(EMPTY_SELECTION);
	const onSelectionChangeRef = useRef(onSelectionChange);
	onSelectionChangeRef.current = onSelectionChange;
	const toggleEntitySelection = useCallback((entity, newSelectedState) => {
		setSelection((prev) => {
			if (prev.type === "query") {
				const isExcluded = prev.excluded.some((e) => sameEntity(e, entity));
				const shouldSelect = newSelectedState ?? isExcluded;
				if (shouldSelect === !isExcluded) return prev;
				onSelectionChangeRef.current?.(entity, shouldSelect);
				return {
					...prev,
					excluded: shouldSelect ? prev.excluded.filter((e) => !sameEntity(e, entity)) : [...prev.excluded, entity]
				};
			}
			const isSelected = prev.entities.some((e) => sameEntity(e, entity));
			const shouldSelect = newSelectedState ?? !isSelected;
			if (shouldSelect === isSelected) return prev;
			onSelectionChangeRef.current?.(entity, shouldSelect);
			return {
				type: "entities",
				entities: shouldSelect ? [...prev.entities, entity] : prev.entities.filter((e) => !sameEntity(e, entity))
			};
		});
	}, []);
	const isEntitySelected = useCallback((entity) => {
		if (selection.type === "query") return !selection.excluded.some((e) => sameEntity(e, entity));
		return selection.entities.some((e) => sameEntity(e, entity));
	}, [selection]);
	const setSelectedEntities = useCallback((entities) => {
		setSelection({
			type: "entities",
			entities
		});
	}, []);
	const selectAllMatching = useCallback((query, count) => {
		setSelection({
			type: "query",
			query,
			excluded: [],
			count
		});
	}, []);
	const clearSelection = useCallback(() => {
		setSelection(EMPTY_SELECTION);
	}, []);
	const selectedCount = useMemo(() => {
		if (selection.type === "entities") return selection.entities.length;
		if (selection.count === void 0) return void 0;
		return Math.max(0, selection.count - selection.excluded.length);
	}, [selection]);
	const hasSelection = selection.type === "query" ? selectedCount === void 0 || selectedCount > 0 : selection.entities.length > 0;
	return useMemo(() => ({
		selection,
		setSelection,
		selectedCount,
		hasSelection,
		setSelectedEntities,
		selectAllMatching,
		clearSelection,
		isEntitySelected,
		toggleEntitySelection
	}), [
		selection,
		selectedCount,
		hasSelection,
		setSelectedEntities,
		selectAllMatching,
		clearSelection,
		isEntitySelected,
		toggleEntitySelection
	]);
}
//#endregion
//#region src/util/entity_pages.ts
/**
* Read **every** row matching a query, one page at a time.
*
* `find({})` sends no `limit`, and an absent limit is resolved server-side to
* `DEFAULT_LIST_LIMIT` — 50 rows. Anything that means "all of them" and asks
* once gets 50 back, with nothing to say that is what happened.
*
* Termination is driven by the server's `meta.hasMore` where it is reported and
* by an empty page otherwise — never by comparing a page's length against the
* requested limit, since a final page that happens to be exactly full is
* indistinguishable that way and a walk that stops there drops rows.
*
* @throws When more than `maxRows` rows match. A truncated answer is worse than
* no answer: it is indistinguishable from a complete one.
*/
async function walkEntityPages({ accessor, params, pageSize, maxRows, onCeiling, onProgress, signal }) {
	const rows = [];
	let offset = 0;
	for (;;) {
		if (signal?.aborted) break;
		const res = await accessor.find({
			...params,
			limit: pageSize,
			offset
		});
		const page = res?.data ?? [];
		rows.push(...page);
		onProgress?.(rows.length, res?.meta?.total);
		if (rows.length > maxRows) throw new Error(onCeiling(maxRows));
		if (page.length === 0) break;
		if (res?.meta && !res.meta.hasMore) break;
		offset += page.length;
	}
	return rows;
}
//#endregion
//#region src/selection/resolve_selection.ts
/**
* Rows asked for per request while resolving a query selection.
*
* Same ceiling as the export walk, and for the same reason: the server refuses
* a `limit` above its `MAX_LIST_LIMIT` rather than clamping it.
*/
var SELECTION_PAGE_SIZE = 500;
/**
* Most rows one query selection will resolve to ids for.
*
* The write path is per-row — `deleteMany` loops the single-row delete server
* side so hooks and row-level security still run for each — so this is a
* genuine ceiling on the work, not just on memory. Going over it **throws**
* rather than acting on a prefix, which is the failure that cannot be seen:
* "deleted 12,480 rows" reads identically whether it was all of them or the
* first page.
*/
var MAX_SELECTION_ROWS = 2e4;
/**
* A stable string for a selection query, for comparing the query a selection
* was made against with the one the view is showing now.
*
* Filter keys are sorted: `filterValues` is rebuilt on most renders and its key
* order follows whatever order the user touched the columns in, so a plain
* `JSON.stringify` would report the same filter as a different one and drop a
* selection the moment anything re-rendered.
*/
function serializeSelectionQuery(query) {
	const filter = query.filterValues ? Object.keys(query.filterValues).sort().map((k) => `${k}=${JSON.stringify(query.filterValues[k])}`).join("&") : "";
	const order = query.sortBy?.map(([field, direction]) => `${String(field)}:${direction}`).join(",") ?? "";
	return `${query.path}|${filter}|${order}|${query.searchString ?? ""}`;
}
/** Turn a captured selection query into the `find` params that reproduce it. */
function selectionQueryToFindParams(query) {
	return {
		where: query.filterValues && Object.keys(query.filterValues).length > 0 ? query.filterValues : void 0,
		orderBy: query.sortBy && query.sortBy.length > 0 ? query.sortBy.map(([field, direction]) => [String(field), direction]) : void 0,
		searchString: query.searchString
	};
}
/**
* The rows a selection covers.
*
* This is the *only* way to get rows out of a query selection, and it is why
* {@link EntitySelection} is a union: a bulk action has to call it, which means
* it has to deal with the wait, the ceiling and the failure. The array this
* replaced let the same code path read whatever the view had scrolled — 50 rows
* of 12,480 — and report success.
*
* @throws When the query matches more than `maxRows` rows.
*/
async function resolveSelection({ selection, accessor, pageSize = 500, maxRows = MAX_SELECTION_ROWS, onProgress, signal }) {
	if (selection.type === "entities") {
		onProgress?.(selection.entities.length, selection.entities.length);
		return selection.entities;
	}
	if (selection.count !== void 0 && selection.count - selection.excluded.length > maxRows) throw new Error(selectionCeilingMessage(maxRows));
	const rows = await walkEntityPages({
		accessor,
		params: selectionQueryToFindParams(selection.query),
		pageSize,
		maxRows,
		onProgress,
		signal,
		onCeiling: selectionCeilingMessage
	});
	if (selection.excluded.length === 0) return rows;
	const excluded = new Set(selection.excluded.map((e) => `${e.path}/${e.id}`));
	return rows.filter((e) => !excluded.has(`${e.path}/${e.id}`));
}
function selectionCeilingMessage(maxRows) {
	return `This selection covers more than ${maxRows.toLocaleString()} rows, which is more than can be acted on from the browser in one go. Filter the collection down first.`;
}
//#endregion
//#region src/selection/SelectionMenu.tsx
/**
* The whole of selecting rows, in one control: a checkbox for the common case
* and a caret for everything else.
*
* The escalation from "the rows on screen" to "every row that matches" lived in
* a strip under the toolbar, which was wrong in a way that only shows up in
* use: it appears the moment you tick a single checkbox, and the list you were
* reading jumps down by its height. A control that punishes the first click is
* not worth whatever the strip was explaining.
*
* So the escalation is a menu item — clicked deliberately, costing no layout,
* and in the place you already go to select everything.
*/
function SelectionMenu({ selectionController, loadedEntities, query, collectionEntitiesCount, collectionName }) {
	const { t } = useTranslation();
	const { selection, selectedCount, hasSelection, isEntitySelected, setSelectedEntities, selectAllMatching, clearSelection } = selectionController;
	const selectedLoaded = useMemo(() => loadedEntities.filter((e) => isEntitySelected(e)).length, [loadedEntities, isEntitySelected]);
	const allLoadedSelected = loadedEntities.length > 0 && selectedLoaded === loadedEntities.length;
	const someSelected = selectedLoaded > 0 && !allLoadedSelected;
	const isQuery = selection.type === "query";
	const moreThanLoaded = collectionEntitiesCount !== void 0 && collectionEntitiesCount > loadedEntities.length;
	const label = hasSelection ? t("selection_deselect_all") ?? "Deselect all" : t("selection_select_all_loaded") ?? "Select all loaded rows";
	return /* @__PURE__ */ jsxs("div", {
		className: cls("flex items-center rounded-md", hasSelection && "bg-surface-hover"),
		children: [
			/* @__PURE__ */ jsx(Tooltip, {
				title: label,
				children: /* @__PURE__ */ jsx("div", {
					className: "pl-1.5 pr-0.5 py-1 flex items-center",
					children: /* @__PURE__ */ jsx(Checkbox, {
						size: "small",
						padding: false,
						"aria-label": label,
						disabled: loadedEntities.length === 0 && !isQuery,
						checked: allLoadedSelected || isQuery,
						indeterminate: someSelected,
						onCheckedChange: (checked) => {
							if (checked) setSelectedEntities(loadedEntities);
							else clearSelection();
						}
					})
				})
			}),
			/* @__PURE__ */ jsxs(Menu, {
				align: "start",
				trigger: /* @__PURE__ */ jsx("button", {
					type: "button",
					"aria-label": t("selection_options") ?? "Selection options",
					className: cls("pr-1 pl-0 py-1 flex items-center rounded-r-md", "hover:bg-surface-hover focus:outline-none", "text-surface-accent-500 dark:text-surface-accent-300"),
					children: /* @__PURE__ */ jsx(ChevronDownIcon, { size: iconSize.smallest })
				}),
				children: [
					/* @__PURE__ */ jsx(MenuItem, {
						dense: true,
						onClick: () => setSelectedEntities(loadedEntities),
						children: t("selection_menu_all_loaded") ?? "All on this page"
					}),
					moreThanLoaded && /* @__PURE__ */ jsx(MenuItem, {
						dense: true,
						onClick: () => selectAllMatching(query, collectionEntitiesCount),
						children: t("selection_menu_all_matching", {
							total: collectionEntitiesCount.toLocaleString(),
							collection: collectionName
						}) ?? `All ${collectionEntitiesCount.toLocaleString()} ${collectionName}`
					}),
					/* @__PURE__ */ jsx(MenuItem, {
						dense: true,
						disabled: !hasSelection,
						onClick: clearSelection,
						children: t("selection_menu_none") ?? "None"
					})
				]
			}),
			hasSelection && /* @__PURE__ */ jsx("span", {
				"data-testid": "selection-count",
				className: "pl-1 pr-2 text-xs font-mono tabular-nums text-text-secondary dark:text-text-secondary-dark",
				children: selectedCount === void 0 ? "…" : selectedCount.toLocaleString()
			})
		]
	});
}
//#endregion
//#region src/components/CollectionViewBinding/hooks/useCollectionInlineEditor.ts
function useCollectionInlineEditor({ path, collection, dataClient, context }) {
	const uniqueFieldValidator = useCallback(async ({ name, value, property, entityId }) => {
		const conflictingEntities = (await dataClient.collection(path).find({ where: { [name]: ["==", value] } })).data;
		return conflictingEntities.length === 0 || conflictingEntities.length === 1 && conflictingEntities[0].id === entityId;
	}, [path, dataClient]);
	const onValueChange = useCallback(({ value, propertyKey, onValueUpdated, setError, data: entity }) => {
		if (!entity) return;
		const updatedValues = setIn({}, propertyKey, value);
		return saveEntityWithCallbacks({
			path: entity.path ?? path,
			entityId: entity.id,
			values: updatedValues,
			previousValues: entity.values,
			collection,
			status: "existing",
			collection,
			data: dataClient,
			context,
			afterSave: () => {
				setError(void 0);
				onValueUpdated();
			},
			afterSaveError: (e) => {
				console.error("Save failure");
				console.error(e);
				setError(e);
			}
		}).then();
	}, [
		path,
		collection,
		dataClient,
		context
	]);
	return useMemo(() => ({
		onValueChange,
		uniqueFieldValidator
	}), [onValueChange, uniqueFieldValidator]);
}
//#endregion
//#region src/util/view_mode.ts
/**
* Query param that carries the active collection view mode across navigations.
*/
var VIEW_MODE_PARAM = "__view";
/** The view modes every collection has, before custom views are added. */
var VIEW_MODES = [
	"list",
	"table",
	"cards",
	"kanban"
];
var DEFAULT_VIEW_MODE = "list";
var DEFAULT_OPEN_ENTITY_MODE = "split";
/**
* Whether `value` names a view mode this collection can actually render.
*
* `customKeys` are the keys of the collection's resolved custom views. They
* have to be passed in rather than looked up: a custom view is registered per
* collection, so there is no global set to check against, and validating
* against the built-ins alone is what would send `?__view=map` to the table.
*
* Omitting them checks the built-ins only, which is the right answer for
* callers that have no collection in hand.
*/
function isViewMode(value, customKeys) {
	if (!value) return false;
	return VIEW_MODES.includes(value) || Boolean(customKeys?.includes(value));
}
/**
* Read the active view mode from a query string, if it holds one this
* collection can render.
*
* @param search a query string (e.g. `location.search`). Falls back to the
*        current browser location when omitted.
* @param customKeys keys of the collection's custom views, if any.
*/
function getViewModeFromSearch(search, customKeys) {
	const source = search ?? (typeof window !== "undefined" ? window.location.search : "");
	const value = new URLSearchParams(source).get(VIEW_MODE_PARAM);
	return isViewMode(value, customKeys) ? value : null;
}
/**
* Append the active view mode to a URL so the target route keeps rendering the
* view the user was last looking at.
*
* Every entity/collection navigation must go through this — a missed call site
* silently resets the user's view mode mid-session.
*
* @param url the URL to decorate. May already contain a query string and/or hash.
* @param search query string to read the view mode from. Defaults to the
*        current browser location.
*/
function withViewMode(url, search) {
	const source = search ?? (typeof window !== "undefined" ? window.location.search : "");
	const viewMode = new URLSearchParams(source).get(VIEW_MODE_PARAM);
	if (!viewMode) return url;
	const hashIndex = url.indexOf("#");
	const hash = hashIndex >= 0 ? url.substring(hashIndex) : "";
	const base = hashIndex >= 0 ? url.substring(0, hashIndex) : url;
	if (new URLSearchParams(base.split("?")[1] ?? "").has("__view")) return url;
	return `${base}${base.includes("?") ? "&" : "?"}${VIEW_MODE_PARAM}=${viewMode}${hash}`;
}
/**
* Carry the whole of the collection list's URL state onto a navigation target.
*
* `withViewMode` exists because losing the view mode mid-session is jarring.
* Everything else the list writes to the URL — the search string, the filters,
* the sort — is state the user built up deliberately, and losing *that* is
* worse: opening a record from a search and pressing back returned an
* unfiltered list with an empty search box, so the search had to be retyped
* for every record they wanted to look at.
*
* Copies every param the list currently has rather than an allowlist, because
* filters are encoded under the field's own name — there is no fixed set to
* list. Params already on the target win: the caller is more specific.
*
* @param url the URL to decorate. May carry a query string and/or a hash.
* @param search query string to read from. Defaults to the browser location.
*/
function withListState(url, search) {
	const source = search ?? (typeof window !== "undefined" ? window.location.search : "");
	const carried = new URLSearchParams(source);
	if ([...carried].length === 0) return url;
	const hashIndex = url.indexOf("#");
	const hash = hashIndex >= 0 ? url.substring(hashIndex) : "";
	const [pathname, existing] = (hashIndex >= 0 ? url.substring(0, hashIndex) : url).split("?");
	const target = new URLSearchParams(existing ?? "");
	for (const [key, value] of carried) if (!target.has(key)) target.set(key, value);
	const query = target.toString();
	return query ? `${pathname}?${query}${hash}` : `${pathname}${hash}`;
}
/**
* Resolve the view mode for a collection, honouring the documented priority:
* URL param > saved user config > collection default.
*/
function resolveViewMode({ collection, search, savedViewMode, customKeys }) {
	const fromUrl = getViewModeFromSearch(search, customKeys);
	if (fromUrl) return fromUrl;
	if (isViewMode(savedViewMode, customKeys)) return savedViewMode;
	const configured = collection?.defaultViewMode;
	if (isViewMode(configured, customKeys)) return configured;
	return DEFAULT_VIEW_MODE;
}
/**
* Resolve how clicking an entity should present it.
*
* An explicit `collection.openEntityMode` always wins. Otherwise the mode is
* derived from the active view mode, so the presentation suits the surface the
* user is looking at: a board keeps its columns behind an overlay, a wide table
* hands the entity the full width, and list/card views use master-detail.
*
* This is the single source of truth — row clicks, find-by-id and the router
* must all resolve through it, otherwise the same entity opens differently
* depending on how it was reached.
*/
function resolveOpenEntityMode({ collection, viewMode, customView }) {
	if (collection?.openEntityMode) return collection.openEntityMode;
	if (customView) return customView.openEntityMode ?? "side_panel";
	if (viewMode === "kanban") return "side_panel";
	if (viewMode === "table" || viewMode === "cards") return "full_screen";
	return DEFAULT_OPEN_ENTITY_MODE;
}
//#endregion
//#region src/util/navigation_utils.ts
/**
* Navigate to a entity using either a side panel or full-screen mode.
* This is an admin-specific UI concern and lives here (not in common).
*/
function navigateToEntity({ openEntityMode, collection, entityId, copy, path, selectedTab, defaultValues, sidePanelController, onClose, navigation, replace }) {
	if (openEntityMode === "side_panel" || openEntityMode === "dialog") sidePanelController.open({
		entityId,
		path,
		copy,
		selectedTab,
		collection,
		updateUrl: openEntityMode !== "dialog",
		onClose,
		defaultValues
	});
	else {
		let to = navigation.buildUrlCollectionPath(entityId ? `${path ?? path}/${entityId}` : path ?? path);
		if (entityId && selectedTab) to += `/${selectedTab}`;
		to = withListState(to);
		if (!entityId) to += "#new";
		if (copy) to += "#copy";
		const navigateOptions = {};
		if (replace !== void 0) navigateOptions.replace = replace;
		if (defaultValues) navigateOptions.state = { defaultValues };
		const hasOptions = Object.keys(navigateOptions).length > 0;
		navigation.navigate(to, hasOptions ? navigateOptions : void 0);
	}
}
//#endregion
//#region src/util/entity_actions.ts
var reservedKeys = [
	"edit",
	"copy",
	"delete"
];
function mergeEntityActions(currentActions, newActions) {
	const updatedActions = [];
	currentActions.forEach((action) => {
		const newAction = newActions.find((a) => a.key === action.key);
		if (newAction) {
			const mergedAction = {
				...action,
				...newAction
			};
			updatedActions.push(mergedAction);
		} else updatedActions.push(action);
	});
	newActions.forEach((action) => {
		if (!currentActions.find((a) => a.key === action.key) && (!action.key || !reservedKeys.includes(action.key))) updatedActions.push(action);
	});
	return updatedActions;
}
//#endregion
//#region src/util/resolutions.ts
/**
* Built-in entity views that are resolved by token name.
* These are always available without needing to be registered
* in the customization controller's entityViews array.
*/
var BUILTIN_ENTITY_VIEWS = { "__rebase_history": {
	key: "__rebase_history",
	name: "History",
	tabComponent: React.createElement(HistoryIcon, { size: 20 }),
	position: "end"
} };
function resolveEntityView(entityView, contextEntityViews) {
	if (typeof entityView === "string") return BUILTIN_ENTITY_VIEWS[entityView] ?? contextEntityViews?.find((entry) => entry.key === entityView);
	else return entityView;
}
/**
* Resolve a collection's `admin.customViews` into the views it can actually
* render, dropping every entry that names a key nothing registered.
*
* Dropping is deliberate: an unresolvable key must not become a switcher entry
* that renders a blank panel. It falls out of `enabledViews` too, so a user
* whose saved view mode was removed lands on a built-in.
*/
function resolveCollectionViews(customViews, contextCollectionViews) {
	if (!customViews) return [];
	const resolved = [];
	const seen = /* @__PURE__ */ new Set();
	for (const entry of customViews) {
		const view = typeof entry === "string" ? contextCollectionViews?.find((candidate) => candidate.key === entry) : entry;
		if (!view || VIEW_MODES.includes(view.key) || seen.has(view.key)) continue;
		seen.add(view.key);
		resolved.push(view);
	}
	return resolved;
}
function resolveEntityAction(entityAction, contextEntityActions) {
	if (typeof entityAction === "string") return contextEntityActions?.find((entry) => entry.key === entityAction);
	else return entityAction;
}
function resolvedSelectedEntityView(customViews, customizationController, selectedTab, _canEdit) {
	const resolvedEntityViews = customViews ? customViews.map((e) => resolveEntityView(e, customizationController.entityViews)).filter(Boolean).filter((e) => e.key !== "__rebase_history") : [];
	return {
		resolvedEntityViews,
		selectedEntityView: resolvedEntityViews.find((e) => e.key === selectedTab),
		selectedSecondaryForm: customViews && resolvedEntityViews.filter((e) => e.includeActions).find((e) => e.key === selectedTab)
	};
}
var BreadcrumbContext = React.createContext({
	breadcrumbs: [],
	set: () => {}
});
var BreadcrumbsProvider = ({ children }) => {
	const [breadcrumbs, setBreadcrumbs] = useState([]);
	const set = useCallback((props) => {
		setBreadcrumbs((prev) => {
			const next = props.breadcrumbs;
			if (prev.length === next.length && prev.every((p, i) => p.title === next[i].title && p.url === next[i].url && p.id === next[i].id)) return prev;
			return next;
		});
	}, []);
	const value = useMemo(() => ({
		breadcrumbs,
		set
	}), [breadcrumbs, set]);
	return /* @__PURE__ */ jsx(BreadcrumbContext.Provider, {
		value,
		children
	});
};
//#endregion
//#region src/hooks/useBreadcrumbsController.tsx
/**
* Hook to retrieve the BreadcrumbsController.
*
* Consider that in order to use this hook you need to have a parent
* `Rebase`
*
* @see BreadcrumbsController
* @group Hooks and utilities
*/
var useBreadcrumbsController = () => useContext(BreadcrumbContext);
//#endregion
//#region src/components/FieldCaption.tsx
function FieldCaption({ error, children }) {
	if (!children) return null;
	return /* @__PURE__ */ jsx(Typography, {
		variant: "caption",
		color: error ? "error" : "secondary",
		className: "ml-3.5 mt-0.5",
		children
	});
}
//#endregion
//#region src/components/SearchIconsView.tsx
var UPDATE_SEARCH_INDEX_WAIT_MS = 220;
function SearchIconsView({ selectedIcon = "", onIconSelected }) {
	const { t } = useTranslation();
	const [keys, setKeys] = React.useState(null);
	const [query, setQuery] = React.useState("");
	const updateSearchResults = React.useMemo(() => debounce((value) => {
		if (!value || value === "") setKeys(null);
		else {
			const limited = iconsSearch.search(value).slice(0, 50);
			setKeys(limited.map((e) => e.item.key));
		}
	}, UPDATE_SEARCH_INDEX_WAIT_MS), []);
	React.useEffect(() => {
		updateSearchResults(query);
		return () => {
			updateSearchResults.clear();
		};
	}, [query, updateSearchResults]);
	const icons = keys === null ? coolIconKeys : keys;
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(SearchBar, {
		autoFocus: false,
		innerClassName: "w-full sticky top-0 z-10",
		onTextSearch: (value) => setQuery(value ?? ""),
		placeholder: t("search_for_more_icons")
	}), /* @__PURE__ */ jsx("div", {
		className: "flex max-w-full flex-wrap mt-4",
		children: icons.map((icon) => /* @__PURE__ */ jsx(Tooltip, {
			title: icon,
			asChild: true,
			children: /* @__PURE__ */ jsx(IconButton, {
				shape: "square",
				toggled: selectedIcon === icon,
				onClick: onIconSelected ? () => onIconSelected(icon) : void 0,
				className: "box-content m-1",
				children: /* @__PURE__ */ jsx(LucideIconByName, {
					name: icon,
					size: iconSize.medium
				})
			})
		}, icon))
	})] });
}
//#endregion
//#region src/components/PropertyConfigBadge.tsx
function PropertyConfigBadge({ propertyConfig, disabled, size = "medium" }) {
	const sizeClasses = size === "extraSmall" ? "h-5 w-5" : size === "small" ? "h-6 w-6" : "h-8 w-8";
	const iconSize = size === "extraSmall" ? 14 : size === "small" ? "smallest" : "small";
	const classes = `${sizeClasses} flex-shrink-0 flex items-center justify-center rounded-full shadow-2xs text-white ` + (disabled ? "bg-surface-400 dark:bg-surface-600" : "");
	const defaultPropertyConfig = typeof propertyConfig?.property === "object" ? getDefaultFieldConfig(propertyConfig.property) : void 0;
	return /* @__PURE__ */ jsx("div", {
		className: classes,
		style: { background: !disabled ? propertyConfig?.color ?? defaultPropertyConfig?.color ?? "#888" : void 0 },
		children: propertyConfig?.Icon ? getIconForWidget(propertyConfig, iconSize) : getIconForWidget(defaultPropertyConfig, iconSize)
	});
}
//#endregion
//#region src/components/ArrayContainer.tsx
var buildIdsMap = (value) => value && Array.isArray(value) && value.length > 0 ? value.map((v, index) => {
	if (!v) return {};
	return { [getHashValue(v) ?? String(index) + index]: getRandomId$1() };
}).reduce((a, b) => ({
	...a,
	...b
}), {}) : {};
function SortableItem({ id, index, size, disabled, buildEntry, remove, copy, addInIndex, canAddElements, sortable, storedProps, updateItemCustomProps }) {
	const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
	return /* @__PURE__ */ jsx(ArrayContainerItem, {
		nodeRef: setNodeRef,
		style: transform ? {
			transform: CSS.Transform.toString(transform),
			transition
		} : {},
		dragHandleProps: {
			...listeners,
			...attributes
		},
		internalId: id,
		index,
		size,
		disabled,
		buildEntry,
		remove,
		copy,
		addInIndex,
		canAddElements,
		sortable,
		isDragging,
		storedProps,
		updateItemCustomProps
	});
}
function ArrayContainerItem({ nodeRef, style, dragHandleProps, index, internalId, size, disabled, buildEntry, remove, copy, addInIndex, canAddElements, sortable, isDragging, storedProps, updateItemCustomProps }) {
	return /* @__PURE__ */ jsx("div", {
		ref: nodeRef,
		style,
		className: `relative ${!isDragging ? "hover:bg-surface-hover" : ""} rounded-md opacity-100`,
		children: /* @__PURE__ */ jsxs("div", {
			className: "flex items-start",
			children: [/* @__PURE__ */ jsx("div", {
				className: "flex-grow w-[calc(100%-48px)] text-text-primary dark:text-text-primary-dark",
				children: buildEntry({
					index,
					internalId,
					isDragging,
					storedProps,
					storeProps: (props) => updateItemCustomProps(internalId, props)
				})
			}), /* @__PURE__ */ jsx(ArrayItemOptions, {
				dragHandleProps,
				direction: size === "small" ? "row" : "column",
				disabled,
				remove,
				index,
				copy,
				canAddElements,
				sortable,
				addInIndex
			})]
		})
	});
}
function ArrayItemOptions({ dragHandleProps, direction, disabled, remove, index, copy, canAddElements, sortable, addInIndex }) {
	const [menuOpen, setMenuOpen] = useState(false);
	const iconRef = useRef(null);
	const { t } = useTranslation();
	useOutsideAlerter(iconRef, () => {
		if (menuOpen) setMenuOpen(false);
	});
	const showMenu = canAddElements ?? false;
	const handleIconButtonClick = (e) => {
		if (showMenu) {
			e.stopPropagation();
			e.preventDefault();
			setMenuOpen((o) => !o);
		} else if (sortable) {} else {
			e.stopPropagation();
			e.preventDefault();
		}
	};
	return /* @__PURE__ */ jsxs("div", {
		ref: iconRef,
		className: `pl-2 pt-1 pb-1 flex ${direction === "row" ? "flex-row-reverse" : "flex-col"} items-center`,
		children: [/* @__PURE__ */ jsx(Tooltip, {
			delayDuration: 400,
			open: menuOpen ? false : void 0,
			side: direction === "column" ? "left" : void 0,
			title: !disabled && sortable && showMenu ? "Drag to move. Click for options" : !disabled && showMenu ? "Click for options" : !disabled && sortable ? "Drag to move" : void 0,
			children: /* @__PURE__ */ jsx(IconButton, {
				size: "small",
				disabled: disabled || !showMenu && !sortable,
				...sortable ? dragHandleProps : {},
				onClick: handleIconButtonClick,
				onFocus: () => {
					if (sortable && menuOpen) setMenuOpen(false);
				},
				className: cls(disabled || !sortable && !showMenu ? "cursor-inherit" : "", sortable && !disabled ? "cursor-grab" : "", !sortable && showMenu && !disabled ? "cursor-pointer" : ""),
				children: /* @__PURE__ */ jsx(HandleIcon, {})
			})
		}), showMenu && /* @__PURE__ */ jsxs(Menu, {
			portalContainer: iconRef.current,
			open: menuOpen,
			trigger: /* @__PURE__ */ jsx("div", { tabIndex: -1 }),
			children: [
				/* @__PURE__ */ jsxs(MenuItem, {
					dense: true,
					onClick: (e) => {
						setMenuOpen(false);
						remove(index);
					},
					children: [/* @__PURE__ */ jsx(MinusIcon, { size: iconSize.small }), t("remove")]
				}),
				/* @__PURE__ */ jsxs(MenuItem, {
					dense: true,
					onClick: () => {
						setMenuOpen(false);
						copy(index);
					},
					children: [/* @__PURE__ */ jsx(CopyIcon, { size: iconSize.small }), t("copy")]
				}),
				addInIndex && /* @__PURE__ */ jsxs(MenuItem, {
					dense: true,
					onClick: () => {
						setMenuOpen(false);
						addInIndex(index);
					},
					children: [/* @__PURE__ */ jsx(ChevronUpIcon, { size: iconSize.small }), t("add_on_top")]
				}),
				addInIndex && /* @__PURE__ */ jsxs(MenuItem, {
					dense: true,
					onClick: () => {
						setMenuOpen(false);
						addInIndex(index + 1);
					},
					children: [/* @__PURE__ */ jsx(ChevronDownIcon, { size: iconSize.small }), t("add_below")]
				})
			]
		})]
	});
}
function ArrayContainer({ droppableId, addLabel, value, disabled = false, buildEntry, size = "medium", onInternalIdAdded, canAddElements: canAddElementsProp = true, sortable = true, newDefaultEntry, onValueChange, className, min = 0, max = Infinity }) {
	const canAddElements = canAddElementsProp;
	const hasValue = value && Array.isArray(value) && value.length > 0;
	const internalIdsRef = useRef(buildIdsMap(value));
	const [internalIds, setInternalIds] = useState(hasValue ? Object.values(internalIdsRef.current) : []);
	const itemCustomPropsRef = useRef({});
	const updateItemCustomProps = useCallback((internalId, customProps) => {
		itemCustomPropsRef.current[internalId] = customProps;
	}, []);
	const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }), useSensor(KeyboardSensor, {}));
	useEffect(() => {
		if (hasValue && value && value.length !== internalIds.length) {
			const newInternalIds = value.map((v, index) => {
				const hashValue = (getHashValue(v) ?? String(index)) + index;
				if (hashValue in internalIdsRef.current) return internalIdsRef.current[hashValue];
				else {
					const newInternalId = getRandomId$1();
					internalIdsRef.current[hashValue] = newInternalId;
					return newInternalId;
				}
			});
			setInternalIds(newInternalIds);
		}
	}, [
		hasValue,
		internalIds.length,
		value
	]);
	const insertInEnd = (e) => {
		e.preventDefault();
		if (disabled || (value ?? []).length >= max) return;
		const id = getRandomId$1();
		const newIds = [...internalIds, id];
		if (onInternalIdAdded) onInternalIdAdded(id);
		setInternalIds(newIds);
		onValueChange([...value ?? [], newDefaultEntry]);
	};
	const remove = (index) => {
		if ((value ?? []).length <= min) return;
		const newIds = [...internalIds];
		newIds.splice(index, 1);
		setInternalIds(newIds);
		onValueChange((value ?? []).filter((_, i) => i !== index));
	};
	const copy = (index) => {
		if ((value ?? []).length >= max) return;
		const id = getRandomId$1();
		const copyingItem = (value ?? [])[index];
		const newIds = [
			...internalIds.slice(0, index + 1),
			id,
			...internalIds.slice(index + 1)
		];
		if (onInternalIdAdded) onInternalIdAdded(id);
		setInternalIds(newIds);
		onValueChange([
			...(value ?? []).slice(0, index + 1),
			copyingItem,
			...(value ?? []).slice(index + 1)
		]);
	};
	const addInIndex = (index) => {
		if ((value ?? []).length >= max) return;
		const id = getRandomId$1();
		const newIds = [
			...internalIds.slice(0, index),
			id,
			...internalIds.slice(index)
		];
		if (onInternalIdAdded) onInternalIdAdded(id);
		setInternalIds(newIds);
		onValueChange([
			...(value ?? []).slice(0, index),
			newDefaultEntry,
			...(value ?? []).slice(index)
		]);
	};
	const onDragEnd = (event) => {
		const { active, over } = event;
		if (!over || active.id === over.id) return;
		const oldIndex = internalIds.indexOf(active.id);
		const newIndex = internalIds.indexOf(over.id);
		if (oldIndex === -1 || newIndex === -1) return;
		const newIds = arrayMove$1(internalIds, oldIndex, newIndex);
		setInternalIds(newIds);
		onValueChange(arrayMove$1(value ?? [], oldIndex, newIndex));
	};
	return sortable ? /* @__PURE__ */ jsx(DndContext, {
		sensors,
		modifiers: [restrictToVerticalAxis],
		collisionDetection: closestCenter,
		onDragEnd,
		children: /* @__PURE__ */ jsx(SortableContext, {
			items: internalIds,
			strategy: verticalListSortingStrategy,
			children: /* @__PURE__ */ jsxs("div", {
				className: cls("space-y-1", className),
				id: droppableId,
				children: [hasValue && internalIds.map((internalId, index) => /* @__PURE__ */ jsx(SortableItem, {
					id: internalId,
					index,
					size,
					disabled,
					buildEntry,
					remove,
					copy,
					addInIndex,
					canAddElements,
					sortable,
					storedProps: itemCustomPropsRef.current[internalId],
					updateItemCustomProps
				}, `array_field_${internalId}`)), canAddElements && /* @__PURE__ */ jsx("div", {
					className: "my-4 justify-center text-left",
					children: /* @__PURE__ */ jsx(Button, {
						variant: "text",
						size: size === "small" ? "small" : "medium",
						disabled: disabled || (value?.length ?? 0) >= max,
						startIcon: /* @__PURE__ */ jsx(PlusIcon, {}),
						onClick: insertInEnd,
						children: addLabel ?? "Add"
					})
				})]
			})
		})
	}) : /* @__PURE__ */ jsxs("div", {
		className: cls("space-y-1", className),
		id: droppableId,
		children: [hasValue && internalIds.map((internalId, index) => /* @__PURE__ */ jsx(ArrayContainerItem, {
			nodeRef: (node) => {},
			style: {},
			dragHandleProps: {},
			internalId,
			index,
			size,
			disabled,
			buildEntry,
			remove,
			copy,
			addInIndex,
			canAddElements,
			sortable: false,
			isDragging: false,
			storedProps: itemCustomPropsRef.current[internalId],
			updateItemCustomProps
		}, `array_field_${internalId}`)), canAddElements && /* @__PURE__ */ jsx("div", {
			className: "my-4 justify-center text-left",
			children: /* @__PURE__ */ jsx(Button, {
				variant: "text",
				size: size === "small" ? "small" : "medium",
				disabled: disabled || (value?.length ?? 0) >= max,
				startIcon: /* @__PURE__ */ jsx(PlusIcon, {}),
				onClick: insertInEnd,
				children: addLabel ?? "Add"
			})
		})]
	});
}
function arrayMove$1(value, sourceIndex, destinationIndex) {
	const result = Array.from(value);
	const [removed] = result.splice(sourceIndex, 1);
	result.splice(destinationIndex, 0, removed);
	return result;
}
function getRandomId$1() {
	return Math.floor(Math.random() * Math.floor(Number.MAX_SAFE_INTEGER));
}
//#endregion
//#region src/data_import/utils/file_headers.ts
/**
* Read the header names out of the first row.
*
* A column whose header is blank is left out entirely, so it contributes
* neither a field nor a value — the same intent as the old `filter(Boolean)`,
* without the shift.
*/
function getWorksheetHeaders(headerRow) {
	const byColumn = /* @__PURE__ */ new Map();
	const order = [];
	headerRow.forEach((cell, index) => {
		if (cell === null || cell === void 0) return;
		const name = (cell instanceof Date ? cell.toISOString() : String(cell)).trim();
		if (!name) return;
		byColumn.set(index, name);
		order.push(name);
	});
	return {
		byColumn,
		order
	};
}
//#endregion
//#region src/data_import/utils/transforms.ts
/**
* Take an object with keys of type `address.street`, `address.city` and
* convert it to an object with nested objects like `{ address: { street: ..., city: ... } }`
*
* Keys here are the **header row of an uploaded file**, so they are attacker
* data. `res["__proto__"] = …` is the prototype setter rather than an own
* property, so a column named `__proto__.polluted` walked out of the accumulator
* and wrote onto `Object.prototype` for the life of the tab — and
* `constructor.prototype.x` threw a `TypeError` that surfaced as an unreadable
* file. Such a column is refused, not sanitised, the way `setIn` settled it
* (`docs/bug-classes.md` class 22).
*
* @param flatObj
*/
function unflattenObject(flatObj) {
	return Object.keys(flatObj).reduce((nestedObj, key) => {
		if (pathTraversesPrototype(key)) {
			console.warn(`Skipping column "${key}": a header may not reach the prototype chain`);
			return nestedObj;
		}
		let currentObj = nestedObj;
		const keyParts = key.split(".");
		keyParts.forEach((keyPart, i) => {
			if (/^[\w]+\[\d+\]$/.test(keyPart)) {
				const mainPropertyName = keyPart.slice(0, keyPart.indexOf("["));
				const index = parseInt(keyPart.slice(keyPart.indexOf("[") + 1, keyPart.indexOf("]")));
				if (!currentObj[mainPropertyName]) currentObj[mainPropertyName] = [];
				if (i !== keyParts.length - 1) {
					currentObj[mainPropertyName][index] = currentObj[mainPropertyName][index] || {};
					currentObj = currentObj[mainPropertyName][index];
				} else currentObj[mainPropertyName][index] = flatObj[key];
			} else if (i !== keyParts.length - 1) {
				currentObj[keyPart] = currentObj[keyPart] || {};
				currentObj = currentObj[keyPart];
			} else currentObj[keyPart] = flatObj[key];
		});
		return nestedObj;
	}, {});
}
function mapJsonParse(obj) {
	return Object.keys(obj).reduce((acc, key) => {
		if (isPrototypePollutingKey(key)) {
			console.warn(`Skipping column "${key}": a header may not reach the prototype chain`);
			return acc;
		}
		try {
			acc[key] = JSON.parse(obj[key]);
		} catch (e) {
			acc[key] = obj[key];
		}
		return acc;
	}, {});
}
//#endregion
//#region src/data_import/utils/csv.ts
/**
* Delimiters sniffed from the header row, most common first.
*
* A spreadsheet saved as "CSV" in a locale that uses the comma as a decimal
* separator is semicolon-delimited, and a tab-separated file saved as `.csv`
* happens often enough to be worth reading.
*/
var CANDIDATE_DELIMITERS = [
	",",
	";",
	"	"
];
/**
* Split CSV text into rows of raw cells, RFC 4180 style.
*
* Quoted fields may contain the delimiter, newlines and doubled quotes; this is
* the exact inverse of what the export's `entryToCSVRow` writes, so a file this
* admin produced reads back into the cells it was built from.
*/
function parseCsvRows(text, delimiter = ",") {
	const rows = [];
	let row = [];
	let field = "";
	let quoted = false;
	let inQuotes = false;
	let i = 0;
	const endField = () => {
		row.push(field);
		field = "";
		quoted = false;
	};
	while (i < text.length) {
		const char = text[i];
		if (inQuotes) {
			if (char === "\"") {
				if (text[i + 1] === "\"") {
					field += "\"";
					i += 2;
					continue;
				}
				inQuotes = false;
				i++;
				continue;
			}
			field += char;
			i++;
			continue;
		}
		if (char === "\"" && field === "") {
			inQuotes = true;
			quoted = true;
			i++;
			continue;
		}
		if (char === delimiter) {
			endField();
			i++;
			continue;
		}
		if (char === "\r") {
			i++;
			continue;
		}
		if (char === "\n") {
			endField();
			rows.push(row);
			row = [];
			i++;
			continue;
		}
		field += char;
		i++;
	}
	if (field !== "" || quoted || row.length > 0) {
		endField();
		rows.push(row);
	}
	return rows;
}
/**
* Pick the delimiter that splits the header row into the most cells. A
* single-column file matches nothing and stays on the comma.
*/
function detectCsvDelimiter(text) {
	const sample = text.slice(0, 64 * 1024);
	let best = CANDIDATE_DELIMITERS[0];
	let bestCount = 1;
	for (const candidate of CANDIDATE_DELIMITERS) {
		const count = parseCsvRows(sample, candidate)[0]?.length ?? 0;
		if (count > bestCount) {
			best = candidate;
			bestCount = count;
		}
	}
	return best;
}
/**
* Parse CSV text into one object per row, keyed by the header row.
*
* The picker accepts `.csv` and the dialog promises "Upload a CSV, Excel or JSON
* file", but every non-JSON file used to be handed to ExcelJS'
* `workbook.xlsx.load`, which is a zip reader — so every CSV failed with
* "Can't find end of central directory : is this a zip file ?". The export
* writes CSV by default, so the round trip could not close.
*
* A blank header keeps its column rather than collapsing it, so the cells to its
* right stay under their own names.
*/
function parseCsvToObjects(text) {
	const cleaned = text.charCodeAt(0) === 65279 ? text.slice(1) : text;
	const rows = parseCsvRows(cleaned, detectCsvDelimiter(cleaned)).filter((row) => row.some((cell) => cell.trim() !== ""));
	if (rows.length === 0) return {
		headers: [],
		data: []
	};
	const headers = rows[0].map((header, index) => header.trim() || `Column${index + 1}`);
	return {
		headers,
		data: rows.slice(1).map((cells) => {
			const obj = {};
			headers.forEach((header, index) => {
				if (isPrototypePollutingKey(header)) return;
				const cell = cells[index];
				if (cell === void 0) return;
				obj[header] = cell;
			});
			return obj;
		})
	};
}
//#endregion
//#region src/data_import/utils/file_to_json.ts
var xlsxReader;
function loadXlsxReader() {
	xlsxReader ??= import("read-excel-file/browser").then((mod) => {
		const candidate = mod.default ?? mod;
		const fn = typeof candidate === "function" ? candidate : candidate?.default;
		if (typeof fn !== "function") throw new Error("read-excel-file did not resolve to a function");
		return fn;
	});
	return xlsxReader;
}
/**
* Put a date the reader left a millisecond short back on its second.
*
* `read-excel-file` turns Excel's date serials (fractional days) into
* milliseconds with `Math.floor`, and the fraction is rarely exact in floating
* point: a time of 12:30:00 arrives as 12:29:59.999, and a field that shows
* minutes displays 12:29. A date within a millisecond of a whole second is put
* back on it; a genuine sub-second value is left alone.
*/
function snapToSecond(cell) {
	if (!(cell instanceof Date)) return cell;
	const time = cell.getTime();
	const second = Math.round(time / 1e3) * 1e3;
	return Math.abs(time - second) <= 1 ? new Date(second) : cell;
}
/**
* Whether this file is delimited text rather than a workbook.
*
* Browsers report `text/csv`, `application/csv` or nothing at all for the same
* `.csv`, so the extension is the reliable half of the test.
*/
function isCsvFile(file) {
	const name = (file.name ?? "").toLowerCase();
	if (name.endsWith(".csv") || name.endsWith(".tsv")) return true;
	return file.type === "text/csv" || file.type === "application/csv";
}
/** Turn the parsed cells of one sheet/file into the entity-shaped rows the import maps. */
function toImportRows(rows) {
	return rows.map(mapJsonParse).map(unflattenObject);
}
function convertFileToJson(file) {
	return new Promise((resolve, reject) => {
		if (isCsvFile(file)) {
			console.debug("Converting CSV file to JSON", file.name);
			const reader = new FileReader();
			reader.onload = function(e) {
				try {
					const { headers, data } = parseCsvToObjects(e.target?.result);
					if (headers.length === 0) {
						reject(/* @__PURE__ */ new Error("The CSV file is empty"));
						return;
					}
					resolve({
						data: toImportRows(data),
						propertiesOrder: headers
					});
				} catch (err) {
					console.error("Error parsing CSV file", err);
					reject(err);
				}
			};
			reader.onerror = () => reject(reader.error ?? /* @__PURE__ */ new Error("Could not read the file"));
			reader.readAsText(file, "utf-8");
		} else if (file.type === "application/json") {
			console.debug("Converting JSON file to JSON", file.name);
			const reader = new FileReader();
			reader.onload = function(e) {
				try {
					const data = e.target?.result;
					const jsonData = JSON.parse(data);
					if (!Array.isArray(jsonData)) reject(/* @__PURE__ */ new Error("JSON file should contain an array of objects"));
					else resolve({
						data: jsonData,
						propertiesOrder: jsonData.length > 0 ? Object.keys(jsonData[0]) : []
					});
				} catch (e) {
					console.error("Error parsing JSON file", e);
					reject(e);
				}
			};
			reader.readAsText(file);
		} else {
			console.debug("Converting Excel file to JSON", file.name);
			const reader = new FileReader();
			reader.onload = async function(e) {
				try {
					const buffer = e.target?.result;
					const readXlsxFile = await loadXlsxReader();
					const magic = new Uint8Array(buffer, 0, Math.min(2, buffer.byteLength));
					if (magic[0] !== 80 || magic[1] !== 75) {
						reject(/* @__PURE__ */ new Error(`'${file.name}' is not a readable .xlsx workbook. Export it again as .xlsx, or save it as .csv.`));
						return;
					}
					let sheets;
					try {
						sheets = await readXlsxFile(buffer);
					} catch (readError) {
						console.debug("Spreadsheet reader failed", readError);
						reject(/* @__PURE__ */ new Error("No worksheets found in file — it has no sheets, or none this reader can open."));
						return;
					}
					const firstSheet = sheets[0];
					if (!firstSheet) {
						reject(/* @__PURE__ */ new Error("No worksheets found in file"));
						return;
					}
					const [headerRow, ...dataRows] = firstSheet.data;
					if (!headerRow) {
						reject(/* @__PURE__ */ new Error("The spreadsheet is empty"));
						return;
					}
					const headers = getWorksheetHeaders(headerRow);
					if (headers.order.length === 0) {
						reject(/* @__PURE__ */ new Error("The spreadsheet has no column headers in its first row"));
						return;
					}
					const parsedData = [];
					for (const row of dataRows) {
						if (row.every((cell) => cell === null || cell === void 0)) continue;
						const obj = {};
						row.forEach((cell, index) => {
							if (cell === null || cell === void 0) return;
							const header = headers.byColumn.get(index);
							if (header && !isPrototypePollutingKey(header)) obj[header] = snapToSecond(cell);
						});
						parsedData.push(obj);
					}
					resolve({
						data: toImportRows(parsedData),
						propertiesOrder: headers.order
					});
				} catch (err) {
					console.error("Error parsing Excel file", err);
					reject(err);
				}
			};
			reader.readAsArrayBuffer(file);
		}
	});
}
//#endregion
//#region src/data_import/components/ImportFileUpload.tsx
function ImportFileUpload({ onDataAdded }) {
	const snackbarController = useSnackbarController();
	return /* @__PURE__ */ jsx(FileUpload, {
		accept: {
			"text/*": [
				".csv",
				".xls",
				".xlsx"
			],
			"application/vnd.ms-excel": [".xls", ".xlsx"],
			"application/msexcel": [".xls", ".xlsx"],
			"application/vnd.ms-office": [".xls", ".xlsx"],
			"application/xls": [".xls", ".xlsx"],
			"application/x-xls": [".xls", ".xlsx"],
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xls", ".xlsx"],
			"application/json": [".json"]
		},
		preventDropOnDocument: true,
		size: "small",
		maxFiles: 1,
		uploadDescription: /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(UploadIcon, {}), "Drag and drop a file here or click to upload"] }),
		onFilesAdded: (files) => {
			if (files.length > 0) convertFileToJson(files[0]).then(({ data, propertiesOrder }) => {
				onDataAdded(data, propertiesOrder);
			}).catch((error) => {
				console.error("Error parsing file", error);
				snackbarController.open({
					type: "error",
					message: error.message
				});
			});
		}
	});
}
//#endregion
//#region src/data_import/utils/save_entities.ts
/** Rows written per request, and per transaction where the data source has one. */
var IMPORT_BATCH_SIZE = 25;
/** The row a bulk write takes: the values, with the chosen id as a column. */
function toBulkRow(entity) {
	const values = { ...entity.values ?? {} };
	if (entity.id !== void 0 && entity.id !== null && entity.id !== "") values.id = entity.id;
	return values;
}
function isBulkUnsupported(error) {
	if (error?.code === "BULK_UNSUPPORTED") return true;
	const message = error?.message ?? "";
	return /bulk writes are not supported|does not support bulk/i.test(message);
}
function isConflict(error) {
	if ((error?.status ?? error?.statusCode) === 409) return true;
	const code = error?.code;
	return code === "CONFLICT" || code === "23505";
}
/**
* Write one batch, all-or-nothing wherever the data source can.
*
* `POST /<collection>/bulk` validates every row before the transaction opens,
* names a failure by row index, and takes the `upsert` flag the preview screen
* promises — none of which one `create` per row inside a `Promise.all` could
* offer, since `Promise.all` does not cancel its siblings and every request was
* its own transaction.
*/
async function writeBatch(accessor, batch, bulkUnsupported, written) {
	if (accessor.createMany && !bulkUnsupported.current) try {
		await accessor.createMany(batch.map(toBulkRow), { upsert: true });
		written.count = batch.length;
		return;
	} catch (e) {
		if (!isBulkUnsupported(e)) throw e;
		bulkUnsupported.current = true;
	}
	for (const entity of batch) {
		try {
			await accessor.create(entity.values ?? {}, entity.id);
		} catch (e) {
			if (entity.id === void 0 || !isConflict(e)) throw e;
			await accessor.update(entity.id, entity.values ?? {});
		}
		written.count++;
	}
}
/**
* Write imported entities in batches, reporting what was committed.
*
* Resumable on purpose: a failure at row 4 000 leaves rows 1–3 999 in the table
* whatever this does, so the only useful thing to report is where to carry on
* from. `offset` is that point — the Retry button passes back the `committed`
* count of the error it is retrying, instead of starting from zero and
* conflicting on every row that already exists.
*
* @throws {ImportSaveError} naming the rows that were not written.
*/
async function saveImportedEntities(dataClient, path, data, { offset = 0, batchSize = 25, onBatchCommitted = () => void 0, bulkUnsupported = { current: false } } = {}) {
	console.debug("Saving imported data", offset, batchSize);
	const accessor = dataClient.collection(path);
	for (let start = offset; start < data.length; start += batchSize) {
		const batch = data.slice(start, start + batchSize);
		const written = { count: 0 };
		try {
			await writeBatch(accessor, batch, bulkUnsupported, written);
		} catch (e) {
			throw Object.assign(e, {
				committed: start + written.count,
				failedFrom: start + written.count,
				failedTo: start + batch.length
			});
		}
		onBatchCommitted(start + batch.length);
	}
	onBatchCommitted(data.length);
}
//#endregion
//#region src/data_import/components/ImportSaveInProgress.tsx
function ImportSaveInProgress({ path, importConfig, collection, onImportSuccess }) {
	const [errorSaving, setErrorSaving] = useState(void 0);
	const dataClient = useData();
	const savingRef = useRef(false);
	const committedRef = useRef(0);
	const bulkUnsupportedRef = useRef({ current: false });
	const [processedEntities, setProcessedEntities] = useState(0);
	function save() {
		if (savingRef.current) return;
		savingRef.current = true;
		setErrorSaving(void 0);
		saveImportedEntities(dataClient, path, importConfig.entities, {
			offset: committedRef.current,
			batchSize: 25,
			onBatchCommitted: (written) => {
				committedRef.current = written;
				setProcessedEntities(written);
			},
			bulkUnsupported: bulkUnsupportedRef.current
		}).then(() => {
			onImportSuccess(collection);
			savingRef.current = false;
		}).catch((e) => {
			const error = e;
			committedRef.current = error.committed ?? committedRef.current;
			setProcessedEntities(committedRef.current);
			setErrorSaving(error);
			savingRef.current = false;
		});
	}
	useEffect(() => {
		save();
	}, []);
	if (errorSaving) {
		const total = importConfig.entities.length;
		const failedRows = errorSaving.failedTo - errorSaving.failedFrom > 1 ? `rows ${errorSaving.failedFrom + 1}–${errorSaving.failedTo}` : `row ${errorSaving.failedFrom + 1}`;
		return /* @__PURE__ */ jsxs(CenteredView, {
			className: "flex flex-col gap-4 items-center",
			children: [
				/* @__PURE__ */ jsx(Typography, {
					variant: "h6",
					children: "Error saving data"
				}),
				/* @__PURE__ */ jsx(Typography, {
					variant: "body2",
					color: "error",
					children: errorSaving.message
				}),
				/* @__PURE__ */ jsxs(Typography, {
					variant: "body2",
					children: [
						errorSaving.committed,
						" of ",
						total,
						" rows were imported. The import stopped on ",
						failedRows,
						", which ",
						errorSaving.failedTo - errorSaving.failedFrom > 1 ? "were" : "was",
						" not written."
					]
				}),
				/* @__PURE__ */ jsx(Button, {
					onClick: save,
					children: errorSaving.committed > 0 ? `Retry from row ${errorSaving.committed + 1}` : "Retry"
				})
			]
		});
	}
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col gap-4 items-center",
		children: [
			/* @__PURE__ */ jsx(CircularProgress, {}),
			/* @__PURE__ */ jsx(Typography, {
				variant: "h6",
				children: "Saving data"
			}),
			/* @__PURE__ */ jsxs(Typography, {
				variant: "body2",
				children: [
					processedEntities,
					"/",
					importConfig.entities.length,
					" entities saved"
				]
			}),
			/* @__PURE__ */ jsx(Typography, {
				variant: "caption",
				children: "Do not close this tab or the import will be interrupted."
			})
		]
	});
}
//#endregion
//#region src/data_import/hooks/useImportConfig.tsx
var useImportConfig = () => {
	const [inUse, setInUse] = useState(false);
	const [defaultValues, setDefaultValues] = useState({});
	const [idColumn, setIdColumn] = useState();
	const [importData, setImportData] = useState([]);
	const [entities, setEntities] = useState([]);
	const [headersMapping, setHeadersMapping] = useState({});
	const [headingsOrder, setHeadingsOrder] = useState([]);
	const [originProperties, setOriginProperties] = useState({});
	return {
		inUse,
		setInUse,
		idColumn,
		setIdColumn,
		entities,
		setEntities,
		importData,
		setImportData,
		headingsOrder: (headingsOrder ?? []).length > 0 ? headingsOrder : Object.keys(headersMapping),
		setHeadingsOrder,
		headersMapping,
		setHeadersMapping,
		originProperties,
		setOriginProperties,
		defaultValues,
		setDefaultValues
	};
};
//#endregion
//#region src/data_import/utils/get_import_inference_type.ts
function getInferenceType(value) {
	if (value === null || value === void 0) return "string";
	if (typeof value === "number") return "number";
	else if (typeof value === "string") return "string";
	else if (typeof value === "boolean") return "boolean";
	else if (value instanceof Date) return "date";
	else if (Array.isArray(value)) return "array";
	return "map";
}
//#endregion
//#region src/data_import/utils/data.ts
function convertDataToEntity(authController, navigation, data, idColumn, headersMapping, properties, path, defaultValues) {
	const flatObject = flattenEntry(data);
	if (idColumn) delete flatObject[idColumn];
	const mappedKeysObject = Object.entries(flatObject).map(([key, value]) => {
		const mappedKey = getIn(headersMapping, key) ?? key;
		const mappedProperty = getPropertyInPath$1(properties, mappedKey);
		if (!mappedProperty) return {};
		const processedValue = processValueMapping(authController, value, navigation, mappedProperty);
		return { [mappedKey]: processedValue };
	}).reduce((acc, curr) => ({
		...acc,
		...curr
	}), {});
	const values = mergeDeep(defaultValues ?? {}, unflattenObject(mappedKeysObject));
	let id = idColumn ? data[idColumn] : void 0;
	if (typeof id === "string") id = id.trim();
	else if (typeof id === "number") id = id.toString();
	else if (typeof id === "boolean") id = id.toString();
	else if (id instanceof Date) id = id.toISOString();
	else if (id && "toString" in id) id = id.toString();
	return {
		id,
		values,
		path
	};
}
function flattenEntry(obj, parent = "") {
	return Object.keys(obj).reduce((acc, key) => {
		if (isPrototypePollutingKey(key)) {
			console.warn(`Skipping column "${key}": a header may not reach the prototype chain`);
			return acc;
		}
		const prefixedKey = parent ? `${parent}.${key}` : key;
		if (typeof obj[key] === "object" && !(obj[key] instanceof Date) && obj[key] !== null && !Array.isArray(obj[key])) Object.assign(acc, flattenEntry(obj[key], prefixedKey));
		else acc[prefixedKey] = obj[key];
		return acc;
	}, {});
}
function processValueMapping(authController, value, navigation, property) {
	if (value === null) return null;
	if (property === void 0) return value;
	const usedProperty = property;
	if (usedProperty === null) return value;
	const from = inferTypeFromValue(value);
	const to = usedProperty.type;
	if (to === "vector") {
		if (value && typeof value === "object" && "value" in value && Array.isArray(value.value)) return new Vector(value.value);
		else if (Array.isArray(value)) return new Vector(value.map(Number));
		else if (typeof value === "string") {
			let cleaned = value.trim();
			if (cleaned.startsWith("[") && cleaned.endsWith("]")) cleaned = cleaned.slice(1, -1);
			if (cleaned === "") return null;
			return new Vector(cleaned.split(",").map((v) => {
				const num = Number(v.trim());
				return isNaN(num) ? 0 : num;
			}));
		}
		return value;
	}
	if (from === "array" && to === "array" && Array.isArray(value) && usedProperty.of && !Array.isArray(usedProperty.of) && !isPropertyBuilder(usedProperty.of)) return value.map((v) => processValueMapping(authController, v, navigation, usedProperty.of));
	else if (from === "string" && to === "number" && typeof value === "string") {
		const trimmed = value.trim();
		if (trimmed === "") return null;
		const num = Number(trimmed);
		return Number.isNaN(num) ? null : num;
	} else if (from === "string" && to === "array" && typeof value === "string" && usedProperty.of && !Array.isArray(usedProperty.of) && !isPropertyBuilder(usedProperty.of)) return value.split(",").map((v) => processValueMapping(authController, v, navigation, usedProperty.of));
	else if (from === "string" && to === "boolean") return value === "true";
	else if (from === "number" && to === "boolean") return value === 1;
	else if (from === "boolean" && to === "number") return value ? 1 : 0;
	else if (from === "boolean" && to === "string") return value ? "true" : "false";
	else if (from === "number" && to === "string" && typeof value === "number") return value.toString();
	else if (from === "string" && to === "array" && typeof value === "string") return value.split(",").map((v) => v.trim());
	else if (from === "string" && to === "date" && typeof value === "string") try {
		return new Date(value);
	} catch (e) {
		return value;
	}
	else if (value instanceof Date && to === "string") return value.toISOString();
	else if (from === "number" && to === "date" && typeof value === "number") try {
		return new Date(value);
	} catch (e) {
		return value;
	}
	else if (from === "string" && to === "reference" && typeof value === "string") {
		let databaseId = void 0;
		let referencePath = value;
		if (value.includes(":::")) {
			const [dbName, pathPart] = value.split(":::");
			if (dbName && dbName !== "(default)") databaseId = dbName;
			referencePath = pathPart;
		}
		const path = referencePath.split("/").slice(0, -1).join("/");
		const entityId = referencePath.split("/").slice(-1)[0];
		if (databaseId === void 0) databaseId = navigation.getCollection(path)?.databaseId;
		return new EntityReference({
			id: entityId,
			path,
			databaseId
		});
	} else if (from === to) return value;
	else if (from === "array" && to === "string" && Array.isArray(value)) return value.join(",");
	return value;
}
//#endregion
//#region src/data_import/components/DataNewPropertiesMapping.tsx
function DataNewPropertiesMapping({ importConfig, destinationProperties, buildPropertyView }) {
	const { t } = useTranslation();
	const headersMapping = importConfig.headersMapping;
	const headingsOrder = importConfig.headingsOrder;
	const idColumn = importConfig.idColumn;
	const originProperties = importConfig.originProperties;
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx(IdSelectField, {
			idColumn,
			headersMapping,
			onChange: (value) => importConfig.setIdColumn(value ?? void 0)
		}),
		/* @__PURE__ */ jsx("div", { className: "h-4" }),
		/* @__PURE__ */ jsxs(Table, {
			style: { tableLayout: "fixed" },
			children: [/* @__PURE__ */ jsxs(TableHeader, { children: [
				/* @__PURE__ */ jsx(TableCell, {
					header: true,
					style: { width: "20%" },
					children: "Column in file"
				}),
				/* @__PURE__ */ jsx(TableCell, { header: true }),
				/* @__PURE__ */ jsx(TableCell, {
					header: true,
					style: { width: "75%" },
					children: "Map to Property"
				})
			] }), /* @__PURE__ */ jsx(TableBody, { children: destinationProperties && headingsOrder.map((importKey) => {
				const mappedKey = headersMapping[importKey];
				const propertyKey = headersMapping[importKey];
				const property = mappedKey ? getPropertyInPath$1(destinationProperties, mappedKey) : null;
				const originProperty = getPropertyInPath$1(originProperties, importKey);
				const origintype = originProperty ? originProperty.type === "array" && typeof originProperty.of === "object" ? `${originProperty.type} - ${originProperty.of.type}` : originProperty.type : void 0;
				return /* @__PURE__ */ jsxs(TableRow, {
					style: { height: "90px" },
					children: [
						/* @__PURE__ */ jsxs(TableCell, {
							style: { width: "20%" },
							children: [/* @__PURE__ */ jsx(Typography, {
								variant: "body2",
								children: importKey
							}), originProperty && /* @__PURE__ */ jsx(Typography, {
								variant: "caption",
								color: "secondary",
								children: origintype
							})]
						}),
						/* @__PURE__ */ jsx(TableCell, { children: /* @__PURE__ */ jsx(ChevronRightIcon, {}) }),
						/* @__PURE__ */ jsx(TableCell, {
							className: importKey === idColumn ? "text-center" : void 0,
							style: { width: "75%" },
							children: buildPropertyView?.({
								isIdColumn: importKey === idColumn,
								property,
								propertyKey,
								importKey
							})
						})
					]
				}, importKey);
			}) })]
		}),
		/* @__PURE__ */ jsxs(ExpandablePanel, {
			title: "Default values",
			initiallyExpanded: false,
			innerClassName: "p-4 mt-4",
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-sm text-surface-accent-500 dark:text-surface-accent-300 font-medium ml-3.5 mb-1",
				children: "You can select a default value for unmapped columns and empty values:"
			}), /* @__PURE__ */ jsxs(Table, {
				style: { tableLayout: "fixed" },
				children: [/* @__PURE__ */ jsxs(TableHeader, { children: [
					/* @__PURE__ */ jsx(TableCell, {
						header: true,
						style: { width: "30%" },
						children: "Property"
					}),
					/* @__PURE__ */ jsx(TableCell, { header: true }),
					/* @__PURE__ */ jsx(TableCell, {
						header: true,
						style: { width: "65%" },
						children: t("default_value")
					})
				] }), /* @__PURE__ */ jsx(TableBody, { children: destinationProperties && getAllPropertyKeys(destinationProperties).map((key) => {
					const property = getPropertyInPath$1(destinationProperties, key);
					if (typeof property !== "object" || property === null) return null;
					if (![
						"number",
						"string",
						"boolean",
						"map"
					].includes(property.type)) return null;
					return /* @__PURE__ */ jsxs(TableRow, {
						style: { height: "70px" },
						children: [
							/* @__PURE__ */ jsx(TableCell, {
								style: { width: "20%" },
								children: /* @__PURE__ */ jsx(Typography, {
									variant: "body2",
									children: key
								})
							}),
							/* @__PURE__ */ jsx(TableCell, { children: /* @__PURE__ */ jsx(ChevronRightIcon, {}) }),
							/* @__PURE__ */ jsx(TableCell, {
								className: key === idColumn ? "text-center" : void 0,
								style: { width: "75%" },
								children: /* @__PURE__ */ jsx(DefaultValuesField, {
									property,
									defaultValue: getIn(importConfig.defaultValues, key),
									onValueChange: (value) => {
										const newValues = setIn(importConfig.defaultValues, key, value);
										importConfig.setDefaultValues(newValues);
									}
								})
							})
						]
					}, key);
				}) })]
			})]
		})
	] });
}
function getAllPropertyKeys(properties, currentKey) {
	return Object.entries(properties).reduce((acc, [key, property]) => {
		const accumulatedKey = currentKey ? `${currentKey}.${key}` : key;
		if (typeof property !== "function" && property.type === "map" && property.properties) {
			const childProperties = getAllPropertyKeys(property.properties, accumulatedKey);
			return [...acc, ...childProperties];
		}
		return [...acc, accumulatedKey];
	}, []);
}
function IdSelectField({ idColumn, headersMapping, onChange }) {
	return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(Select, {
		size: "medium",
		value: idColumn ?? "",
		fullWidth: true,
		onChange: (event) => {
			const value = event.target.value;
			onChange(value === "__none__" ? null : value);
		},
		placeholder: "Autogenerate ID",
		renderValue: (value) => {
			return /* @__PURE__ */ jsx(Typography, {
				variant: "body2",
				children: value !== "__none__" ? value : "Autogenerate ID"
			});
		},
		label: "Column that will be used as ID for each document",
		children: [/* @__PURE__ */ jsx(SelectItem, {
			value: "__none__",
			children: "Autogenerate ID"
		}), Object.entries(headersMapping).map(([key, value]) => {
			return /* @__PURE__ */ jsx(SelectItem, {
				value: key,
				children: key
			}, key);
		})]
	}) });
}
function DefaultValuesField({ property, onValueChange, defaultValue }) {
	const { t } = useTranslation();
	const defaultValueLabel = t("default_value");
	const ariaLabel = property.name ? `${defaultValueLabel}: ${property.name}` : defaultValueLabel;
	if (property.type === "string") return /* @__PURE__ */ jsx(TextField, {
		size: "medium",
		"aria-label": ariaLabel,
		placeholder: defaultValueLabel,
		value: defaultValue ?? "",
		onChange: (event) => onValueChange(event.target.value)
	});
	else if (property.type === "number") return /* @__PURE__ */ jsx(TextField, {
		size: "medium",
		type: "number",
		"aria-label": ariaLabel,
		value: defaultValue ?? "",
		placeholder: defaultValueLabel,
		onChange: (event) => onValueChange(event.target.value)
	});
	else if (property.type === "boolean") return /* @__PURE__ */ jsx(BooleanSwitchWithLabel, {
		value: defaultValue ?? null,
		allowIndeterminate: true,
		size: "small",
		onValueChange: (v) => onValueChange(v === null ? void 0 : v),
		label: defaultValue === void 0 ? "Do not set value" : defaultValue === true ? "Set value to true" : "Set value to false"
	});
	else if (property.type === "date") return /* @__PURE__ */ jsx(DateTimeField, {
		mode: property.mode ?? "date",
		size: "medium",
		value: defaultValue ?? void 0,
		onChange: (dateValue) => {
			onValueChange(dateValue);
		},
		clearable: true
	});
	return null;
}
//#endregion
//#region src/data_import/components/ImportNewPropertyFieldPreview.tsx
function ImportNewPropertyFieldPreview({ propertyKey, property, onEditClick, includeName = true, onPropertyNameChanged, propertyTypeView }) {
	const { propertyConfigs } = useCustomizationController();
	const widget = property ? getFieldConfig(property, propertyConfigs) : null;
	return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxs("div", {
		className: "flex flex-row w-full items-center",
		children: [/* @__PURE__ */ jsx("div", {
			className: "mx-4",
			children: propertyTypeView ?? /* @__PURE__ */ jsx(PropertyConfigBadge, { propertyConfig: widget ?? void 0 })
		}), /* @__PURE__ */ jsx("div", {
			className: "w-full flex flex-col grow",
			children: /* @__PURE__ */ jsxs("div", {
				className: "flex flex-row items-center gap-2",
				children: [includeName && /* @__PURE__ */ jsx(TextField, {
					size: "medium",
					"aria-label": propertyKey ? `Name of property ${propertyKey}` : "Property name",
					className: "text-base grow",
					value: property?.name ?? "",
					onChange: (e) => {
						if (onPropertyNameChanged && propertyKey) onPropertyNameChanged(propertyKey, e.target.value);
					}
				}), /* @__PURE__ */ jsx(IconButton, {
					onClick: onEditClick,
					size: "small",
					children: /* @__PURE__ */ jsx(PencilIcon, {})
				})]
			})
		})]
	}) });
}
//#endregion
//#region src/collection_editor/CollectionEditorDialogsContext.tsx
var CollectionEditorDialogsContext = createContext(void 0);
function useCollectionEditorDialogsState() {
	return useContext(CollectionEditorDialogsContext);
}
//#endregion
//#region src/collection_editor/ConfigControllerProvider.tsx
var ConfigControllerContext = React.createContext({});
var CollectionEditorContext = React.createContext({});
var ConfigControllerProvider = React.memo(function ConfigControllerProvider({ children, collectionConfigController, collectionInference, extraView, getUser, getData, onAnalyticsEvent, pathSuggestions, generateCollection }) {
	const { databaseAdmin } = useRebaseContext();
	const authController = useAuthController();
	const [unmappedTables, setUnmappedTables] = useState([]);
	useEffect(() => {
		if (!databaseAdmin?.fetchUnmappedTables || authController.initialLoading || !authController.user) return;
		const existingPaths = (collectionConfigController.collections ?? []).map((c) => getTableName(c) ?? "").filter(Boolean);
		databaseAdmin.fetchUnmappedTables(existingPaths).then((tables) => setUnmappedTables(tables)).catch((e) => console.warn("Could not fetch unmapped tables:", e));
	}, [
		databaseAdmin,
		authController.initialLoading,
		authController.user,
		collectionConfigController.collections
	]);
	useBridgeRegistration("schemaEditing", useMemo(() => ({
		available: !collectionConfigController.readOnly,
		updateCollection: (collectionId, patch) => collectionConfigController.updateCollection({
			id: collectionId,
			collectionData: patch
		})
	}), [collectionConfigController]));
	const onFetchTableMetadata = useCallback(async (tableName) => {
		return databaseAdmin?.fetchTableMetadata?.(tableName);
	}, [databaseAdmin]);
	const urlController = useUrlController();
	const navigate = useNavigate();
	const snackbarController = useSnackbarController();
	const { propertyConfigs } = useCustomizationController();
	const [currentDialog, setCurrentDialog] = React.useState();
	const [currentPropertyDialog, setCurrentPropertyDialog] = React.useState();
	const editCollection = useCallback(({ id, path, parentCollectionSlugs, parentEntityIds, parentCollection, existingEntities, initialView, expandKanban }) => {
		console.debug("Edit collection", id, path, parentCollectionSlugs, parentEntityIds, parentCollection);
		onAnalyticsEvent?.("edit_collection", {
			id,
			path
		});
		setCurrentDialog({
			editedCollectionId: id,
			path,
			parentCollectionSlugs,
			parentEntityIds,
			isNewCollection: false,
			parentCollection,
			redirect: false,
			existingEntities,
			pathSuggestions,
			initialView,
			expandKanban
		});
	}, [onAnalyticsEvent, pathSuggestions]);
	const editProperty = useCallback(({ propertyKey, property, editedCollectionId, currentPropertiesOrder, parentCollectionSlugs, parentEntityIds, collection, existingEntities }) => {
		console.debug("Edit property", propertyKey, property, editedCollectionId, currentPropertiesOrder, parentCollectionSlugs, parentEntityIds, collection);
		onAnalyticsEvent?.("edit_property", {
			propertyKey,
			editedCollectionId
		});
		const namespace = propertyKey && propertyKey.includes(".") ? propertyKey.substring(0, propertyKey.lastIndexOf(".")) : void 0;
		const propertyKeyWithoutNamespace = propertyKey && propertyKey.includes(".") ? propertyKey.substring(propertyKey.lastIndexOf(".") + 1) : propertyKey;
		setCurrentPropertyDialog({
			propertyKey: propertyKeyWithoutNamespace,
			property,
			namespace,
			currentPropertiesOrder,
			editedCollectionId,
			parentCollectionSlugs,
			parentEntityIds,
			existingEntities,
			collection
		});
	}, [onAnalyticsEvent]);
	const createCollection = useCallback(({ parentCollectionSlugs, parentEntityIds, parentCollection, initialValues, copyFrom, redirect, sourceClick }) => {
		console.debug("Create collection", {
			parentCollectionSlugs,
			parentEntityIds,
			parentCollection,
			initialValues,
			copyFrom,
			redirect,
			sourceClick
		});
		onAnalyticsEvent?.(copyFrom ? "duplicate_collection" : "create_collection", {
			parentCollectionSlugs,
			parentEntityIds,
			parentCollection,
			initialValues,
			redirect,
			sourceClick
		});
		setCurrentDialog({
			isNewCollection: true,
			parentCollectionSlugs,
			parentEntityIds,
			parentCollection,
			initialValues,
			copyFrom,
			redirect,
			pathSuggestions
		});
	}, [onAnalyticsEvent, pathSuggestions]);
	const collectionDialogProps = useMemo(() => {
		if (!currentDialog) return void 0;
		return {
			open: true,
			configController: collectionConfigController,
			collectionInference,
			...currentDialog,
			getData,
			extraView,
			getUser,
			generateCollection,
			onAnalyticsEvent,
			unmappedTables,
			onFetchTableMetadata,
			handleClose: (collection) => {
				if (currentDialog?.redirect) {
					if (collection && currentDialog?.isNewCollection && !currentDialog.parentCollectionSlugs.length) {
						const url = urlController.buildUrlCollectionPath(collection.slug);
						navigate(url);
					}
				}
				setCurrentDialog(void 0);
			}
		};
	}, [
		currentDialog,
		collectionConfigController,
		collectionInference,
		getData,
		extraView,
		getUser,
		generateCollection,
		onAnalyticsEvent,
		unmappedTables,
		onFetchTableMetadata,
		urlController,
		navigate
	]);
	const propertyDialogProps = useMemo(() => {
		if (!currentPropertyDialog) return void 0;
		return {
			open: true,
			includeIdAndName: true,
			existingProperty: Boolean(currentPropertyDialog.propertyKey),
			autoUpdateId: !currentPropertyDialog.propertyKey,
			autoOpenTypeSelect: !currentPropertyDialog.propertyKey,
			inArray: false,
			getData: currentPropertyDialog.existingEntities || getData && currentPropertyDialog.editedCollectionId ? async () => {
				let data = [];
				if (currentPropertyDialog.existingEntities) data = currentPropertyDialog.existingEntities.map((e) => e.values);
				if (getData && currentPropertyDialog.editedCollectionId) {
					console.debug("Get data for property, path:", currentPropertyDialog.editedCollectionId);
					const fetchedData = await getData(urlController.resolveDatabasePathsFrom(currentPropertyDialog.editedCollectionId), []);
					data.push(...fetchedData);
				}
				return data;
			} : void 0,
			onPropertyChanged: ({ id, property }) => {
				if (!currentPropertyDialog) return;
				if (!id) return;
				const newProperty = !currentPropertyDialog.propertyKey;
				return collectionConfigController.saveProperty({
					path: currentPropertyDialog.editedCollectionId,
					property,
					propertyKey: id,
					newPropertiesOrder: newProperty && currentPropertyDialog.currentPropertiesOrder ? [...currentPropertyDialog.currentPropertiesOrder, id] : void 0,
					namespace: currentPropertyDialog.namespace,
					parentCollectionSlugs: currentPropertyDialog.parentCollectionSlugs
				}).catch((e) => {
					console.error(e);
					snackbarController.open({
						type: "error",
						message: "Error persisting property: " + (e.message ?? "Details in the console")
					});
					return false;
				});
			},
			onPropertyChangedImmediate: false,
			onDelete: () => {
				if (!currentPropertyDialog.propertyKey) return;
				const newPropertiesOrder = currentPropertyDialog.currentPropertiesOrder?.filter((p) => p !== currentPropertyDialog.propertyKey);
				return collectionConfigController.deleteProperty({
					path: currentPropertyDialog.editedCollectionId,
					propertyKey: currentPropertyDialog.propertyKey,
					namespace: currentPropertyDialog.namespace,
					newPropertiesOrder,
					parentCollectionSlugs: currentPropertyDialog.parentCollectionSlugs
				}).then(() => {
					setCurrentPropertyDialog(void 0);
				}).catch((e) => {
					console.error(e);
					snackbarController.open({
						type: "error",
						message: "Error deleting property: " + (e.message ?? "Details in the console")
					});
					return false;
				});
			},
			onError: () => {},
			onOkClicked: () => {
				setCurrentPropertyDialog(void 0);
			},
			onCancel: () => {
				setCurrentPropertyDialog(void 0);
			},
			initialErrors: {},
			forceShowErrors: false,
			existingPropertyKeys: currentPropertyDialog.collection?.properties ? Object.keys(currentPropertyDialog.collection.properties) : [],
			allowDataInference: true,
			propertyConfigs,
			property: currentPropertyDialog.property,
			propertyKey: currentPropertyDialog.propertyKey
		};
	}, [
		currentPropertyDialog,
		getData,
		urlController,
		collectionConfigController,
		snackbarController,
		propertyConfigs
	]);
	const dialogsState = useMemo(() => ({
		collectionDialogProps,
		propertyDialogProps
	}), [collectionDialogProps, propertyDialogProps]);
	const collectionEditorContextValue = useMemo(() => ({
		editCollection,
		createCollection,
		editProperty,
		pathSuggestions,
		configController: collectionConfigController
	}), [
		editCollection,
		createCollection,
		editProperty,
		pathSuggestions,
		collectionConfigController
	]);
	return /* @__PURE__ */ jsx(ConfigControllerContext.Provider, {
		value: collectionConfigController,
		children: /* @__PURE__ */ jsx(CollectionEditorContext.Provider, {
			value: collectionEditorContextValue,
			children: /* @__PURE__ */ jsxs(CollectionEditorDialogsContext.Provider, {
				value: dialogsState,
				children: [children, collectionConfigController.dialog]
			})
		})
	});
}, deepEqual);
//#endregion
//#region src/collection_editor/useCollectionEditorController.tsx
/**
* Hook to access the collection editor controller.
* The methods in this controller can be used to open the collection editor dialog.
*/
var useCollectionEditorController = () => useContext(CollectionEditorContext);
//#endregion
//#region src/collection_editor/ui/EditorCollectionAction.tsx
function EditorCollectionAction({ path, parentCollectionSlugs, parentEntityIds, collection, tableController }) {
	useAuthController();
	const collectionRegistry = useCollectionRegistryController();
	const collectionEditorController = useCollectionEditorController();
	const { t } = useTranslation();
	const parentCollection = parentCollectionSlugs.length > 0 ? collectionRegistry.getCollection(parentCollectionSlugs[parentCollectionSlugs.length - 1]) : void 0;
	const canEditCollection = !collectionEditorController.configController?.readOnly;
	return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Tooltip, {
		asChild: true,
		title: collectionEditorController.configController?.readOnly ? collectionEditorController.configController.readOnlyReason || t("studio_editor_collection_disabled") : canEditCollection ? t("studio_editor_collection_edit") : t("studio_editor_collection_no_permission"),
		children: /* @__PURE__ */ jsx(IconButton, {
			size: "small",
			color: "primary",
			disabled: !canEditCollection,
			onClick: canEditCollection ? () => collectionEditorController?.editCollection({
				id: collection.slug,
				path,
				parentCollectionSlugs,
				parentEntityIds,
				parentCollection,
				existingEntities: tableController?.data ?? []
			}) : void 0,
			children: /* @__PURE__ */ jsx(SettingsIcon, {})
		})
	}) });
}
//#endregion
//#region src/components/CollectionViewBinding/CollectionViewActions.tsx
var ImportCollectionAction = lazyChunk(() => import("./import-Cxnmpyjl.js").then((n) => n.t).then((m) => ({ default: m.ImportCollectionAction })));
var ExportCollectionAction = lazyChunk(() => import("./export-LvIpE7sE.js").then((n) => n.t).then((m) => ({ default: m.ExportCollectionAction })));
function CollectionViewActions({ collection, relativePath, parentCollectionSlugs, parentEntityIds, onNewClick, onAddExistingClick, onMultipleDeleteClick, selectionEnabled, path, selectionController, tableController, collectionEntitiesCount, compact, children, openNewDocument }) {
	const context = useAdminContext();
	const { canCreate, canDelete } = usePermissions();
	const largeLayout = useLargeLayout();
	const { t } = useTranslation();
	const collectionEditorController = useCollectionEditorController();
	const hasCollectionEditor = Boolean(collectionEditorController?.editCollection);
	const { selectedCount, hasSelection } = selectionController;
	const addButton = canCreate(collection, path) && onNewClick && (largeLayout && !compact ? /* @__PURE__ */ jsx(Button, {
		id: `add_entity_${path}`,
		onClick: onNewClick,
		startIcon: /* @__PURE__ */ jsx(PlusIcon, { size: iconSize.small }),
		size: "small",
		variant: "filled",
		color: "primary",
		children: t("add_specific", { name: collection.singularName ?? collection.name })
	}) : /* @__PURE__ */ jsx(IconButton, {
		id: `add_entity_${path}`,
		onClick: onNewClick,
		variant: "filled",
		shape: "square",
		size: "small",
		"aria-label": t("add_specific", { name: collection.singularName ?? collection.name }),
		children: /* @__PURE__ */ jsx(PlusIcon, { size: iconSize.small })
	}));
	const linkButton = onAddExistingClick && (largeLayout && !compact ? /* @__PURE__ */ jsx(Button, {
		id: `link_entity_${path}`,
		onClick: onAddExistingClick,
		startIcon: /* @__PURE__ */ jsx(Link2Icon, { size: iconSize.small }),
		size: "small",
		variant: "outlined",
		color: "primary",
		children: t("add_existing") ?? "Add existing"
	}) : /* @__PURE__ */ jsx(Tooltip, {
		title: t("add_existing") ?? "Add existing",
		children: /* @__PURE__ */ jsx(Button, {
			id: `link_entity_${path}`,
			onClick: onAddExistingClick,
			variant: "outlined",
			color: compact ? "neutral" : "primary",
			size: "small",
			children: /* @__PURE__ */ jsx(Link2Icon, { size: iconSize.small })
		})
	}));
	const multipleDeleteEnabled = canDelete(collection, path, null);
	const countLabel = selectedCount === void 0 ? "…" : selectedCount.toLocaleString();
	let multipleDeleteButton;
	if (hasSelection) {
		const button = largeLayout && !compact ? /* @__PURE__ */ jsxs(Button, {
			variant: "text",
			disabled: !multipleDeleteEnabled,
			startIcon: /* @__PURE__ */ jsx(Trash2Icon, {
				size: iconSize.small,
				className: "shrink-0"
			}),
			onClick: onMultipleDeleteClick,
			color: "primary",
			className: "lg:min-w-20",
			children: [
				"(",
				countLabel,
				")"
			]
		}) : /* @__PURE__ */ jsx(IconButton, {
			size: "small",
			color: "primary",
			disabled: !multipleDeleteEnabled,
			onClick: onMultipleDeleteClick,
			children: /* @__PURE__ */ jsx(Trash2Icon, { size: iconSize.small })
		});
		multipleDeleteButton = /* @__PURE__ */ jsx(Tooltip, {
			title: multipleDeleteEnabled ? t("delete") : t("delete_not_allowed"),
			children: button
		});
	}
	const actionProps = {
		path,
		relativePath,
		parentCollectionSlugs,
		parentEntityIds,
		collection,
		selectionController,
		context,
		tableController,
		collectionEntitiesCount,
		openNewDocument
	};
	const secondaryActions = /* @__PURE__ */ jsxs(Fragment, { children: [
		children,
		/* @__PURE__ */ jsxs(ErrorBoundary, { children: [toArray(collection.Actions).map((actionRef, i) => {
			const Action = resolveComponentRef(actionRef);
			if (!Action) return null;
			return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(Suspense, {
				fallback: null,
				children: /* @__PURE__ */ jsx(Action, { ...actionProps })
			}) }, `actions_${i}`);
		}), useSlot("collection.actions", actionProps)] }),
		/* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(Suspense, {
			fallback: null,
			children: /* @__PURE__ */ jsx(ImportCollectionAction, { ...actionProps })
		}) }),
		/* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(Suspense, {
			fallback: null,
			children: /* @__PURE__ */ jsx(ExportCollectionAction, { ...actionProps })
		}) }),
		hasCollectionEditor && /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(EditorCollectionAction, { ...actionProps }) })
	] });
	const [overflowOpen, setOverflowOpen] = React.useState(false);
	return /* @__PURE__ */ jsxs("div", {
		className: "flex items-center gap-1",
		children: [
			!compact ? secondaryActions : /* @__PURE__ */ jsx(Popover, {
				open: overflowOpen,
				onOpenChange: setOverflowOpen,
				trigger: /* @__PURE__ */ jsx(IconButton, {
					size: "small",
					children: /* @__PURE__ */ jsx(MoreVerticalIcon, { size: iconSize.smallest })
				}),
				children: /* @__PURE__ */ jsx("div", {
					className: "flex flex-row items-center gap-1 p-2",
					children: secondaryActions
				})
			}),
			multipleDeleteButton,
			linkButton,
			addButton
		]
	});
}
//#endregion
//#region src/components/CollectionViewBinding/SearchHighlight.tsx
/**
* Showing a searcher *why* a row is in their results.
*
* A ranked list answers "which rows" and never "why this one". When the term is
* in the title that is self-evident; when it is in a field the list does not
* show — a certification, a nested answer, a note — the row looks arbitrary and
* the only way to find out is to open it. That is the whole reason this exists.
*
* Two jobs, and they are deliberately separate:
*
* 1. {@link Highlighted} marks the term inside a value the list already shows.
* 2. {@link offSlotMatch} finds a match in a field that has no slot, so the
*    caller can put it where the subtitle would have gone.
*/
/** `<mark>` is Postgres's delimiter, and what `ts_headline` emits. */
var MARK = /(<mark>.*?<\/mark>)/g;
/**
* Render a `ts_headline` snippet: text with `<mark>` around each hit.
*
* Split-and-render rather than `dangerouslySetInnerHTML`. The text around the
* marks is whatever a user typed into their own record, and the only markup it
* is allowed to carry is the highlight Postgres put there. Anything else stays
* inert text.
*/
/**
* Context kept before and after a hit, in characters.
*
* Asymmetric on purpose. The snippet renders on one truncated line, so anything
* before the hit competes with the hit itself for the width available — with a
* generous lead-in the mark is pushed off the right edge and the reader sees a
* fragment with nothing highlighted in it, which is worse than no snippet at
* all. Lead with just enough to not start abruptly, then run on.
*/
var SNIPPET_LEAD = 16;
var SNIPPET_TRAIL = 90;
/**
* Pull the first mark near the front of the snippet.
*
* The snippet renders on one truncated line whose width is not knowable here —
* a list column is wide, the same list beside an open record is not. Whatever
* precedes the mark competes with it for that width, and when the mark loses
* the reader gets a fragment of their record with nothing highlighted in it,
* which reads as the feature being broken rather than as a narrow column.
*
* `ts_headline` centres its fragment on the match, so roughly half the window
* is lead-in; that is the right shape for a paragraph and the wrong one for a
* line. Trimming here rather than asking Postgres for a smaller window keeps
* the trailing context, which is what actually explains the hit — and applies
* the same shape to the snippets built in the browser, so a row looks the same
* whichever path produced it.
*/
function trimSnippetLead(text, lead = SNIPPET_LEAD) {
	const at = text.indexOf("<mark>");
	if (at < 0 || at <= lead) return text;
	return "…" + text.slice(at - lead, at).replace(/^\S*\s/, "") + text.slice(at);
}
function Snippet({ text, className }) {
	return /* @__PURE__ */ jsx("span", {
		className,
		children: useMemo(() => trimSnippetLead(text).split(MARK), [text]).map((part, i) => part.startsWith("<mark>") ? /* @__PURE__ */ jsx("mark", {
			className: "bg-amber-200/70 dark:bg-amber-400/30 text-inherit rounded-[3px] px-[1px]",
			children: part.slice(6, -7)
		}, i) : /* @__PURE__ */ jsx(React.Fragment, { children: part }, i))
	});
}
/**
* Mark every occurrence of the searched terms inside a plain value.
*
* Used for values the list already renders, where the server's snippet would be
* the wrong thing to show: the snippet is truncated to a fragment and folded to
* the indexed form, while the cell should keep the record's real text. So the
* terms are re-matched here, on the display value.
*
* Deliberately dumber than the server's matching, and it has to be: this cannot
* stem or unaccent without reimplementing the text search configuration in the
* browser and getting it subtly different. It marks what it can find as a
* prefix, case- and accent-insensitively, and marks nothing when it cannot —
* a highlight that is merely absent reads as "no hit in this field", which is
* the honest answer for a stem the browser cannot reproduce.
*/
function Highlighted({ text, terms, className }) {
	const segments = useMemo(() => splitOnTerms(text, terms), [text, terms]);
	if (segments.length <= 1) return /* @__PURE__ */ jsx("span", {
		className,
		children: text
	});
	return /* @__PURE__ */ jsx("span", {
		className,
		children: segments.map((seg, i) => seg.hit ? /* @__PURE__ */ jsx("mark", {
			className: "bg-amber-200/70 dark:bg-amber-400/30 text-inherit rounded-[3px] px-[1px]",
			children: seg.text
		}, i) : /* @__PURE__ */ jsx(React.Fragment, { children: seg.text }, i))
	});
}
/** Strip diacritics so `gestion` marks `gestión`, mirroring the index's unaccent. */
var fold = (value) => value.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
/**
* Split `text` into hit / non-hit runs.
*
* Matches on the *folded* form but slices the original, so the marked text
* keeps its accents and case — `Gestión`, not `gestion`. Folding is
* length-preserving for the diacritics this handles, which is what makes the
* indices transferable; a fold that changed length would misalign the slices.
*/
function splitOnTerms(text, terms) {
	const haystack = fold(text);
	const needles = terms.map(fold).filter((t) => t.length >= 2);
	if (needles.length === 0) return [{
		text,
		hit: false
	}];
	const bounds = [];
	for (const needle of needles) {
		let from = 0;
		for (;;) {
			const at = haystack.indexOf(needle, from);
			if (at === -1) break;
			const before = at === 0 ? " " : haystack[at - 1];
			if (!/[\p{L}\p{N}]/u.test(before)) bounds.push([at, at + needle.length]);
			from = at + needle.length;
		}
	}
	if (bounds.length === 0) return [{
		text,
		hit: false
	}];
	bounds.sort((a, b) => a[0] - b[0]);
	const merged = [];
	for (const [start, end] of bounds) {
		const last = merged[merged.length - 1];
		if (last && start <= last[1]) last[1] = Math.max(last[1], end);
		else merged.push([start, end]);
	}
	const segments = [];
	let cursor = 0;
	for (const [start, end] of merged) {
		if (start > cursor) segments.push({
			text: text.slice(cursor, start),
			hit: false
		});
		segments.push({
			text: text.slice(start, end),
			hit: true
		});
		cursor = end;
	}
	if (cursor < text.length) segments.push({
		text: text.slice(cursor),
		hit: false
	});
	return segments;
}
/**
* The terms a searcher typed, as things to look for in a rendered value.
*
* Quoted phrases stay whole; `-excluded` terms are dropped, since marking a
* word the user asked *not* to see would be actively wrong. `websearch_to_tsquery`
* reads the same syntax on the server.
*/
function searchTerms(searchString) {
	if (!searchString) return [];
	const terms = [];
	for (const [, phrase, bare] of searchString.matchAll(/"([^"]+)"|(\S+)/g)) {
		const term = phrase ?? bare;
		if (!term || term.startsWith("-")) continue;
		if (/^(or|and)$/i.test(term)) continue;
		terms.push(term);
	}
	return terms;
}
/**
* The best match to show when the term is nowhere the list already displays.
*
* `shownKeys` are the property paths the row is already rendering, so a match
* there needs no explaining — {@link Highlighted} marks it in place and the
* subtitle keeps its own job. Anything else is invisible, and one of those is
* what the subtitle slot gets replaced with.
*
* The first such match wins, and the server returns them in the order the
* collection declared its `search` fields — so the field an author put first is
* the one a reader sees, rather than whichever the database aggregated first.
*/
function offSlotMatch(matches, shownKeys) {
	if (!matches || matches.length === 0) return void 0;
	const shown = new Set(shownKeys.filter((k) => Boolean(k)));
	return matches.find((m) => !shown.has(m.field));
}
/**
* Where a search term appears in a row, computed from the row itself.
*
* The server can say this too — `_matches`, from `ts_headline` — and its answer
* is better, because it knows the stemming the index used. This exists because
* the admin cannot rely on getting it: rows reach the panel over three
* different transports (REST, the realtime socket, the offline cache) and only
* one of them carries query metadata. A feature that explains a result on some
* loads and not others is worse than one that always gives a slightly simpler
* answer.
*
* So: use the server's when it is there, fall back to this. Both produce the
* same `{ field, snippet }` shape, and this one marks with the same `<mark>`.
*/
function localRowMatch(values, properties, terms, shownKeys) {
	if (!values || !properties || terms.length === 0) return void 0;
	const shown = new Set(shownKeys.filter((k) => Boolean(k)));
	for (const [key, property] of Object.entries(properties)) {
		if (shown.has(key)) continue;
		const found = findInValue(values[key], terms, key, property);
		if (found) return found;
	}
}
function findInValue(value, terms, path, property) {
	if (property && "enum" in property && property.enum) return void 0;
	if (typeof value === "string") {
		const snippet = snippetAround(value, terms);
		return snippet ? {
			field: path,
			snippet
		} : void 0;
	}
	if (Array.isArray(value)) {
		for (const item of value) {
			const found = findInValue(item, terms, path, void 0);
			if (found) return found;
		}
		return;
	}
	if (value && typeof value === "object") for (const [key, nested] of Object.entries(value)) {
		const found = findInValue(nested, terms, `${path}.${key}`, void 0);
		if (found) return found;
	}
}
/**
* The text around the first hit, with every hit in view marked.
*
* Trimmed to a readable window rather than the whole field: a match in a long
* body should show the sentence it is in, not the first line of the document,
* and certainly not the document.
*/
function snippetAround(text, terms) {
	const segments = splitOnTerms(text, terms);
	const firstHit = segments.findIndex((s) => s.hit);
	if (firstHit === -1) return void 0;
	const before = segments.slice(0, firstHit).map((s) => s.text).join("");
	const head = before.length > SNIPPET_LEAD ? "…" + before.slice(before.length - SNIPPET_LEAD).replace(/^\S*\s/, "") : before;
	let out = head;
	for (let i = firstHit; i < segments.length; i++) {
		const seg = segments[i];
		out += seg.hit ? `<mark>${seg.text}</mark>` : seg.text;
		if (out.length > head.length + SNIPPET_TRAIL) {
			out += "…";
			break;
		}
	}
	return out.trim();
}
//#endregion
//#region src/components/CollectionViewBinding/SearchExplanation.tsx
/**
* The one place a view asks "why is this row here?" and gets something to draw.
*
* List, cards and board all render the same title-and-subtitle slots over the
* same machinery. An explanation that shows up in one of them and not the others
* reads as randomness rather than as a feature, so the decision and the markup
* live here and each view calls them.
*/
/**
* Terms to mark inside values the row already shows, plus the single match
* worth putting where the subtitle would go — or nothing, when the row is not
* the product of a search or the hit is already visible.
*
* Prefers the server's `_matches`, which knows the stemming the index used, and
* falls back to reading the row directly. That fallback is not belt-and-braces:
* rows reach the panel over REST, the realtime socket and the offline cache,
* and only one of those carries query metadata.
*/
function useSearchExplanation(entity, properties, shownKeys, searchString) {
	const terms = useMemo(() => searchTerms(searchString), [searchString]);
	const shownKey = shownKeys.map((k) => k ?? "").join("|");
	return {
		terms,
		offSlot: useMemo(() => {
			if (terms.length === 0) return void 0;
			const shown = shownKey.split("|").map((k) => k || void 0);
			return offSlotMatch(entity.searchMatches, shown) ?? localRowMatch(entity.values, properties, terms, shown);
		}, [
			entity.searchMatches,
			entity.values,
			properties,
			shownKey,
			terms
		])
	};
}
/**
* Which field the hit was in, and the text around it.
*
* Sits where the subtitle would have gone. Deliberately quiet — a small amber
* caption and one line — because it is context for a result, not the result. It
* has to survive a narrow column, so it truncates rather than wraps.
*/
function MatchExplanation({ match, label }) {
	return /* @__PURE__ */ jsxs("div", {
		className: "mt-0.5 flex items-baseline gap-1.5 min-w-0",
		children: [/* @__PURE__ */ jsx("span", {
			className: "shrink-0 text-[10px] uppercase tracking-wide font-semibold text-amber-700 dark:text-amber-500/90",
			title: match.field,
			children: label
		}), /* @__PURE__ */ jsx("span", {
			className: "truncate text-xs text-surface-500 dark:text-surface-400 min-w-0",
			children: /* @__PURE__ */ jsx(Snippet, { text: match.snippet })
		})]
	});
}
/**
* What to call a matched field on screen.
*
* The path is what the config and the server speak — `questionnaire.
* certifications` — and is unreadable in a list. Resolve it to the property's
* declared `name`, walking into `map` properties for a dotted path, and fall
* back to the last segment humanised, so an unnamed field still reads as words
* rather than as a path.
*/
function fieldLabel(properties, path) {
	const segments = path.split(".");
	let node = properties;
	let named;
	for (const segment of segments) {
		const property = node?.[segment];
		if (!property) break;
		named = property.name ?? named;
		node = property.properties;
	}
	if (named) return named;
	return (segments[segments.length - 1] ?? path).replace(/[_-]+/g, " ").replace(/^./, (c) => c.toUpperCase());
}
//#endregion
//#region src/components/CollectionViewBinding/SlotValue.tsx
/**
* One display slot, rendered.
*
* A slot's value arrives one of two ways and they cannot be rendered the same:
*
* - **From a property** — render it with that property's own preview, so an
*   enum status keeps its colour, a date keeps its format and a storage path
*   becomes a thumbnail. This is why a declared path beats a resolver whenever
*   the value is actually on the record.
* - **From a resolver** — there is no property, because the value was computed
*   or fetched. All that can be said about it is that it is text.
*
* The branch lives here, once, rather than at each of the fourteen places the
* list row, the card and the board card render a slot. That count is the reason:
* the last time a rule like this was inlined per call site, it drifted into
* seven versions.
*/
function SlotValue({ slot, size, textOnly = true, fill }) {
	if (!slot || slot.value === void 0 || slot.value === null) return null;
	if (!slot.property || !slot.propertyKey) {
		if (slot.role === "image" && typeof slot.value === "string" && slot.value.trim()) return /* @__PURE__ */ jsx(ComputedImage, {
			value: slot.value.trim(),
			size,
			fill
		});
		return /* @__PURE__ */ jsx(Fragment, { children: Array.isArray(slot.value) ? slot.value.map((item) => String(item)).join(", ") : String(slot.value) });
	}
	return /* @__PURE__ */ jsx(PropertyPreview, {
		propertyKey: slot.propertyKey,
		value: slot.value,
		property: slot.property,
		size,
		textOnly,
		fill
	});
}
/**
* The `tags` slot, as chips beside the status.
*
* Honours both arms the same way the rest of the file does. A declared **path**
* goes through {@link SlotValue}, so an array of enum values keeps its own
* colours — that is the stated advantage of naming a property. A **resolver**
* returns bare strings with no property to render them as, so they become plain
* chips; a single string is accepted as one tag, which the role's type documents.
*
* Lives here rather than in the list, the card and the board card because that is
* three copies of the same decision, and this file exists to hold exactly one.
*/
function TagChips({ slot, max = 4 }) {
	if (slot.property && slot.propertyKey) return /* @__PURE__ */ jsx(SlotValue, {
		slot,
		size: "small"
	});
	const values = (Array.isArray(slot.value) ? slot.value : [slot.value]).filter((item) => item !== void 0 && item !== null && String(item).trim() !== "").map((item) => String(item));
	if (values.length === 0) return null;
	const shown = values.slice(0, max);
	const hidden = values.length - shown.length;
	return /* @__PURE__ */ jsxs(Fragment, { children: [shown.map((value) => /* @__PURE__ */ jsx(Chip, {
		size: "smallest",
		className: "!text-[10px] !leading-tight !py-0 shrink-0 max-w-[100px] truncate",
		children: value
	}, value)), hidden > 0 && /* @__PURE__ */ jsxs("span", {
		className: "text-[10px] text-surface-400 dark:text-surface-500 shrink-0",
		children: ["+", hidden]
	})] });
}
/**
* Whether a computed image string can be fetched as-is, or has to be resolved
* through storage first.
*
* Exported because it is the whole decision: rendering either branch needs a
* provider (a storage source, a DOM), and the thing worth pinning is which
* branch a given string takes. `//host/x` is protocol-relative and equally
* fetchable; `data:` and `blob:` are already the bytes.
*/
function isFetchableImageUrl(value) {
	return /^(https?:)?\/\//i.test(value) || /^(data|blob):/i.test(value);
}
/**
* A string a resolver returned for the `image` role, rendered as a picture.
*
* Two things can arrive here and they need different handling, which is the whole
* reason a property-path image is preferable: a storage property knows which
* backend holds it, and a bare string does not.
*
* - An **absolute URL** is already fetchable. Rendering it through the storage
*   layer would ask a bucket to sign a path that was never in it.
* - Anything else is read as a **storage path** on the default source, which is
*   the only source a value with no property can be attributed to. A resolver
*   pointing at a named source should name the property instead.
*/
function ComputedImage({ value, size, fill }) {
	if (isFetchableImageUrl(value)) return /* @__PURE__ */ jsx(UrlComponentPreview, {
		previewType: "image",
		url: value,
		size,
		fill,
		hint: value
	});
	return /* @__PURE__ */ jsx(StorageThumbnail, {
		storagePathOrDownloadUrl: value,
		storeUrl: false,
		size,
		fill
	});
}
//#endregion
//#region src/components/CollectionViewBinding/EntityCardBinding.tsx
/**
* Card component for displaying a entity in a grid view.
* Shows thumbnail, title, and preview properties via the shared slot system.
*/
function EntityCardBinding({ entity, collection, onClick, selected, highlighted, onSelectionChange, selectionEnabled, size = "m", searchString }) {
	const authController = useAuthController();
	const analyticsController = useAnalyticsController();
	const slotKeys = useCollectionSlotKeys(collection, authController, useCustomizationController().propertyConfigs);
	const slots = useEntitySlots(entity, collection, slotKeys);
	const { terms, offSlot } = useSearchExplanation(entity, collection.properties, [slotKeys.titleKey, slotKeys.subtitleKey], searchString);
	const handleClick = (e) => {
		if (e && (e.metaKey || e.ctrlKey) && selectionEnabled) {
			e.preventDefault();
			onSelectionChange?.(entity, !selected);
			return;
		}
		if (onClick) {
			analyticsController.onAnalyticsEvent?.("card_view_entity_click", {
				path: entity.path,
				entityId: entity.id
			});
			onClick(entity, e);
		}
	};
	const handleCheckboxClick = (e) => {
		e.stopPropagation();
	};
	const handleSelectionChange = (checked) => {
		onSelectionChange?.(entity, checked);
	};
	return /* @__PURE__ */ jsxs(Card, {
		className: cls("cursor-pointer overflow-hidden group relative", "transition-all duration-200", "hover:shadow-lg hover:-translate-y-0.5", selected && "ring-2 ring-primary bg-surface-raised", highlighted && !selected && "ring-2 ring-primary/50 bg-surface-card-hover"),
		onClick: handleClick,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "aspect-[4/3] relative overflow-hidden bg-surface-raised",
			children: [
				slots.image ? /* @__PURE__ */ jsx("div", {
					className: "w-full h-full",
					children: /* @__PURE__ */ jsx(SlotValue, {
						slot: slots.image,
						size: "medium",
						fill: true
					})
				}) : /* @__PURE__ */ jsx("div", {
					className: "w-full h-full flex items-center justify-center",
					children: /* @__PURE__ */ jsx(IconForView, {
						collectionOrView: collection,
						color: "disabled"
					})
				}),
				/* @__PURE__ */ jsx("div", { className: cls("absolute inset-0 bg-white/0 group-hover:bg-white/[0.06]", "transition-colors duration-200") }),
				selectionEnabled && /* @__PURE__ */ jsx("div", {
					className: cls("absolute", size === "xs" || size === "s" ? "top-1 left-1" : "top-2 left-2"),
					onClick: handleCheckboxClick,
					children: /* @__PURE__ */ jsx(Checkbox, {
						checked: selected ?? false,
						onCheckedChange: handleSelectionChange,
						size: size === "xs" ? "smallest" : "small"
					})
				})
			]
		}), /* @__PURE__ */ jsxs("div", {
			className: "p-3",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: "truncate my-1 text-sm font-medium min-h-[20px]",
					children: slots.title ? terms.length > 0 && typeof slots.title.value === "string" ? /* @__PURE__ */ jsx(Highlighted, {
						text: slots.title.value,
						terms
					}) : /* @__PURE__ */ jsx(SlotValue, {
						slot: slots.title,
						size: "small"
					}) : /* @__PURE__ */ jsx(Typography, {
						variant: "body2",
						className: "text-surface-500",
						children: entity.id
					})
				}),
				offSlot ? /* @__PURE__ */ jsx(MatchExplanation, {
					match: offSlot,
					label: fieldLabel(collection.properties, offSlot.field)
				}) : slots.subtitle && /* @__PURE__ */ jsx("div", {
					className: "line-clamp-3 [&_div]:line-clamp-3 text-xs text-surface-600 dark:text-surface-400 [&_p]:!my-1 [&_p:first-child]:!mt-0 [&_p:last-child]:!mb-0",
					children: terms.length > 0 && typeof slots.subtitle.value === "string" ? /* @__PURE__ */ jsx(Highlighted, {
						text: slots.subtitle.value,
						terms
					}) : /* @__PURE__ */ jsx(SlotValue, {
						slot: slots.subtitle,
						size: "small"
					})
				}),
				slots.relations.length > 0 && /* @__PURE__ */ jsxs("div", {
					className: "flex items-center gap-1 mt-1 overflow-hidden max-w-full flex-wrap",
					children: [slots.relations.map((rel) => rel.items.map((item) => /* @__PURE__ */ jsx(Chip, {
						size: "smallest",
						colorScheme: rel.colorScheme,
						className: "!text-[10px] !leading-tight !py-0 shrink-0 max-w-[100px] truncate",
						children: item.displayName
					}, `${rel.propertyKey}-${item.id}`))), slots.relations.some((r) => r.totalCount > r.items.length) && /* @__PURE__ */ jsxs("span", {
						className: "text-[10px] text-surface-400 dark:text-surface-500 shrink-0",
						children: ["+", slots.relations.reduce((acc, r) => acc + Math.max(0, r.totalCount - r.items.length), 0)]
					})]
				}),
				(slots.status || slots.tags) && /* @__PURE__ */ jsxs("div", {
					className: "flex items-center gap-1 mt-1 flex-wrap",
					children: [slots.status && /* @__PURE__ */ jsx(SlotValue, {
						slot: slots.status,
						size: "small"
					}), slots.tags && /* @__PURE__ */ jsx(TagChips, { slot: slots.tags })]
				}),
				slots.date && /* @__PURE__ */ jsx("div", {
					className: "mt-1 text-[10px] text-surface-500 dark:text-surface-400",
					children: slots.date.formatted
				})
			]
		})]
	});
}
//#endregion
//#region src/components/CollectionViewBinding/CollectionCardViewBinding.tsx
/**
* Card grid view for displaying entities with infinite scroll.
* Alternative to the CollectionTableBinding for visual browsing.
*/
function CollectionCardViewBinding({ collection, tableController, onEntityClick, selectionController, selectionEnabled = true, highlightedEntities, emptyComponent, onScroll, initialScroll, size = "m" }) {
	const ResolvedEntityCard = useComponentOverride("Collection.Card", EntityCardBinding);
	const { data, dataLoading, noMoreToLoad, dataLoadingError, itemCount, setItemCount, pageSize = 50, paginationEnabled } = tableController;
	const handleEntityClick = useCallback((entity) => {
		onEntityClick?.(entity);
	}, [onEntityClick]);
	const handleSelectionChange = useCallback((entity, selected) => {
		selectionController?.toggleEntitySelection(entity, selected);
	}, [selectionController]);
	const selectedIds = useMemo(() => new Set(data.filter((e) => selectionController?.isEntitySelected(e)).map((e) => e.id)), [data, selectionController]);
	const highlightedIds = useMemo(() => new Set(highlightedEntities?.map((e) => e.id)), [highlightedEntities]);
	const handleRowSelectionChange = useCallback((entity, selected) => {
		handleSelectionChange(entity, selected);
	}, [handleSelectionChange]);
	return /* @__PURE__ */ jsx(CardView, {
		data,
		dataLoading,
		noMoreToLoad,
		dataLoadingError,
		itemCount,
		setItemCount,
		pageSize,
		paginationEnabled,
		onItemClick: handleEntityClick,
		selectedIds,
		highlightedIds,
		selectionEnabled,
		onSelectionChange: handleRowSelectionChange,
		onScroll,
		initialScroll,
		size,
		emptyComponent,
		renderCard: useCallback((entity, { selected, highlighted, onClick }) => /* @__PURE__ */ jsx(ResolvedEntityCard, {
			entity,
			collection,
			searchString: tableController.searchString,
			onClick: (_entity, event) => onClick(event),
			selected,
			highlighted,
			onSelectionChange: handleRowSelectionChange,
			selectionEnabled,
			size
		}, `${entity.path}_${entity.id}`), [
			collection,
			selectionEnabled,
			size,
			handleRowSelectionChange,
			ResolvedEntityCard,
			tableController.searchString
		])
	});
}
//#endregion
//#region src/components/CollectionViewBinding/CollectionListViewBinding.tsx
/** A column left over from a sort or filter that is no longer applied. */
var PRIORITY_STALE_REQUEST = 1e3;
/** The collection's own columns. Slots sit just above it, in give-way order. */
var PRIORITY_DECLARED = 2e3;
var PRIORITY_DATE = PRIORITY_DECLARED;
var PRIORITY_STATUS = 2001;
var PRIORITY_TAGS = 2002;
/** The sort or filter currently in force. */
var PRIORITY_ACTIVE_REQUEST = 3e3;
/**
* How wide a column of this property wants to be — the Tailwind class the cell
* gets, and the pixel cost of that class. The two are returned together because
* they must not drift: the budget is only meaningful if it describes the widths
* actually rendered. `lg:` variants key off the viewport, not this panel, so a
* narrow split on a wide screen gets the larger of the two — the cost we budget.
*/
function getIdealColumnWidth(prop) {
	if (prop.type === "string" && "enum" in prop) return {
		width: "flex-shrink-0 w-32",
		widthPx: 128
	};
	if (prop.type === "date" || prop.type === "number" || prop.type === "boolean") return {
		width: "flex-shrink-0 w-28",
		widthPx: 112
	};
	if (prop.type === "reference" || prop.type === "relation") return {
		width: "flex-shrink-0 w-56 lg:w-64",
		widthPx: 256
	};
	if (prop.type === "string") return {
		width: "flex-shrink-0 w-40 lg:w-48",
		widthPx: 192
	};
	return {
		width: "flex-shrink-0 w-40",
		widthPx: 160
	};
}
/**
* Get row padding/spacing classes based on size
*/
function getRowClasses(size) {
	switch (size) {
		case "xs": return "py-2 px-3";
		case "s": return "py-2.5 px-3";
		case "m": return "py-3 px-3";
		case "l": return "py-4 px-3";
		case "xl": return "py-5 px-3";
		default: return "py-3 px-3";
	}
}
/** `mx-2` + `px-3` on both sides: the row is an inset, rounded highlight, not an edge-to-edge bar. */
var ROW_PADDING_WIDTH = 40;
/** `gap-4` between every cell of the row. */
var COLUMN_GAP = 16;
/**
* The title's share of a row, taken before any column bids for width.
*
* A title is a name, and a name truncated to "Lider Sr. en…" has stopped being
* one. Columns are a scanner's convenience; the title is the row's identity, so
* a narrow list spends its width on the title and simply shows fewer columns.
*/
var TITLE_COMFORTABLE_WIDTH = 320;
/** An `IconButton size="small"` (`w-8`), which is what a row action renders as. */
var ACTION_BUTTON_WIDTH = 32;
/** `gap-0.5` between row actions. */
var ACTION_BUTTON_GAP = 2;
/**
* How many rows are read to size the actions cell.
*
* Actions are resolved per record, so the width they need is only knowable by
* asking — and asking every loaded row would mean re-resolving thousands of
* them on every page. The first rows are representative: a collection whose
* actions vary at all varies within its first screenful.
*/
var ACTIONS_SAMPLE_SIZE = 20;
/** Stable empty array for when no list-view actions are available. */
var EMPTY_LIST_VIEW_ACTIONS = [];
/**
* Returns true if a property type should NOT be rendered via
* PropertyPreview in list row columns (because it would blow up height).
*/
function isComplexPropertyType(property) {
	if (property.type === "array") {
		const ofProp = "of" in property ? property.of : void 0;
		const innerProp = ofProp ? Array.isArray(ofProp) ? ofProp[0] : ofProp : void 0;
		if (innerProp && typeof innerProp === "object" && "enum" in innerProp && innerProp.enum) return false;
	}
	return property.type === "array" || property.type === "map" || property.type === "reference" || property.type === "relation";
}
/**
* Render a complex value as a compact, single-line string.
* - Arrays  → "Item, Item +3"
* - Maps    → "4 fields"
* - Refs    → entity ID
* - Relations → entity ID or name
*/
function compactValueSummary(value, property) {
	if (value === void 0 || value === null) return null;
	if (property.type === "array") {
		if (!Array.isArray(value)) return null;
		if (value.length === 0) return null;
		const of = "of" in property ? property.of : void 0;
		const innerProp = of ? Array.isArray(of) ? of[0] : of : void 0;
		const labels = value.map((v) => {
			if (typeof v === "string") return v;
			if (typeof v === "number") return String(v);
			if (v && typeof v === "object" && "id" in v) return String(v.id);
			if (innerProp && "enum" in innerProp && innerProp.enum && typeof v === "string") {
				const enumValues = innerProp.enum;
				if (Array.isArray(enumValues)) {
					const match = enumValues.find((e) => typeof e === "object" && e !== null && "id" in e && e.id === v);
					if (match && typeof match === "object" && "label" in match) return String(match.label);
				} else if (typeof enumValues === "object") {
					const label = enumValues[v];
					if (typeof label === "string") return label;
					if (label && typeof label === "object" && "label" in label) return String(label.label);
				}
				return v;
			}
			return "•";
		});
		const MAX_SHOWN = 2;
		const shown = labels.slice(0, MAX_SHOWN).join(", ");
		const remaining = labels.length - MAX_SHOWN;
		return remaining > 0 ? `${shown} +${remaining}` : shown;
	}
	if (property.type === "map") {
		if (typeof value !== "object" || value === null) return null;
		const count = Object.keys(value).length;
		return count === 0 ? null : `${count} field${count !== 1 ? "s" : ""}`;
	}
	if (property.type === "reference") {
		if (typeof value === "string") return value;
		if (value && typeof value === "object" && "id" in value) return String(value.id);
		return null;
	}
	if (property.type === "relation") {
		if (typeof value === "string" || typeof value === "number") return String(value);
		if (value && typeof value === "object") {
			const obj = value;
			if (obj.data && typeof obj.data === "object") {
				const data = obj.data;
				const values = data.values && typeof data.values === "object" ? data.values : data;
				const name = values.name ?? values.title ?? values.display_name ?? values.displayName ?? values.label ?? values.email;
				if (name && typeof name !== "object") return String(name);
			}
			if ("id" in obj) return String(obj.id);
		}
		return null;
	}
	return null;
}
/**
* Format a date value for display in the list.
*
* A date column holds whatever the developer put in it, so the value is as
* likely to be ahead of now as behind it. The relative phrase therefore comes
* from {@link formatRelativeTime}, which reads the sign: a row due this
* afternoon says "in 2h" rather than the "-1d ago" that flooring a negative
* difference used to produce.
*/
function formatDateValue(value, now = /* @__PURE__ */ new Date()) {
	if (!value) return null;
	let date = null;
	if (value instanceof Date) date = value;
	else if (typeof value === "string" || typeof value === "number") date = new Date(value);
	if (!date || isNaN(date.getTime())) return null;
	const diffMs = now.getTime() - date.getTime();
	const diffDays = Math.floor(diffMs / (1e3 * 60 * 60 * 24));
	if (diffDays === 0) return date.toLocaleTimeString(void 0, {
		hour: "2-digit",
		minute: "2-digit"
	});
	if (diffDays === 1) return "Yesterday";
	const relative = formatRelativeTime(date, { now });
	if (relative) return relative;
	return date.toLocaleDateString(void 0, {
		month: "short",
		day: "numeric",
		year: date.getFullYear() !== now.getFullYear() ? "numeric" : void 0
	});
}
/**
* Classic admin list view for displaying entities.
* Designed to be the most familiar, stereotypical admin content management view:
* - Clean rows with checkbox, icon/avatar, title, metadata, and actions
* - Column-sortable headers
* - Infinite scroll
*/
function CollectionListViewBinding({ collection, tableController, onEntityClick, selectionController, selectionEnabled = true, highlightedEntities, emptyComponent, size = "m", selectedEntityId, getActionsForEntity, path, openEntityMode }) {
	const authController = useAuthController();
	const customizationController = useCustomizationController();
	const analyticsController = useAnalyticsController();
	const context = useAdminContext();
	const containerRef = useRef(null);
	const [containerWidth, setContainerWidth] = useState(void 0);
	useEffect(() => {
		const el = containerRef.current;
		if (!el) return;
		const measure = (width) => setContainerWidth(width > 0 ? width : void 0);
		measure(el.getBoundingClientRect().width);
		if (typeof ResizeObserver === "undefined") return;
		const ro = new ResizeObserver(([entry]) => {
			if (entry) measure(entry.contentRect.width);
		});
		ro.observe(el);
		return () => ro.disconnect();
	}, []);
	const { data, dataLoading, noMoreToLoad, dataLoadingError, itemCount, setItemCount, pageSize = 50, paginationEnabled, sortBy, setSortBy, filterValues, checkFilterCombination, searchString } = tableController;
	const resolvedCollection = collection;
	const slotKeys = useCollectionSlotKeys(resolvedCollection, authController, customizationController.propertyConfigs);
	const { titleKey: titlePropertyKey, imageKey: imagePropertyKey, subtitleKey, statusKey: statusPropertyKey, dateKey: datePropertyKey } = slotKeys;
	const columnMode = !!resolvedCollection.listProperties && resolvedCollection.listProperties.length > 0;
	/**
	* The properties an `ORDER BY` can be written for, under the same authority
	* the table headers and the sort menu ask — so a header that offers a sort
	* here offers it there, and none of the three invents one the driver would
	* silently drop.
	*/
	const sortableKeys = useMemo(() => new Set(getSortablePropertyOptions(resolvedCollection.properties).map((option) => option.key)), [resolvedCollection.properties]);
	/**
	* The row's identity cell — the thumbnail, the title and the subtitle.
	*
	* Labelled by the title slot, because that is what the cell renders. In
	* column mode it used to be labelled by `listProperties[0]` instead, which
	* was right only when the two happened to be the same property and a lie
	* whenever they were not: `listProperties: ["roles", "createdAt"]` on the
	* users collection put a "Roles" header over the name-and-email cell, and
	* the roles themselves appeared in no column at all — the header was the
	* only trace of the property the developer had asked for.
	*
	* The first list property is therefore only consumed here when it *is* the
	* title; otherwise it stays in {@link declaredColumns} and gets a cell.
	*/
	const titleColumn = useMemo(() => {
		const key = titlePropertyKey ?? (columnMode ? resolvedCollection.listProperties?.[0] : void 0);
		if (!key) return void 0;
		const property = resolvedCollection.properties[key];
		return {
			key,
			label: property?.name || (columnMode ? key : "Name"),
			property,
			align: "left",
			width: "flex-1 min-w-0",
			widthPx: TITLE_COMFORTABLE_WIDTH,
			sortable: sortableKeys.has(key),
			priority: Number.MAX_SAFE_INTEGER
		};
	}, [
		columnMode,
		resolvedCollection,
		titlePropertyKey,
		sortableKeys
	]);
	/**
	* The trailing columns the collection itself implies: the developer's
	* `listProperties` when there are any, otherwise the display slots the row
	* has always shown to the right of the title.
	*/
	const declaredColumns = useMemo(() => {
		if (columnMode) {
			const keys = resolvedCollection.listProperties.filter((key) => key !== titleColumn?.key);
			return keys.flatMap((key, index) => {
				const property = resolvedCollection.properties[key];
				if (!property) return [];
				return [{
					key,
					label: property.name || key,
					property,
					align: property.type === "number" || property.type === "date" ? "right" : "left",
					...getIdealColumnWidth(property),
					sortable: sortableKeys.has(key),
					priority: PRIORITY_DECLARED + (keys.length - index)
				}];
			});
		}
		const cols = [];
		const slotColumn = (slot, key, fallbackLabel, layout, priority) => {
			const declared = hasDeclaredDisplay(resolvedCollection, slot);
			if (!key && !declared) return void 0;
			const property = key ? resolvedCollection.properties[key] : void 0;
			return {
				key: key ?? `display:${slot}`,
				label: property?.name || fallbackLabel,
				slot,
				property,
				...layout,
				sortable: !!key && sortableKeys.has(key),
				priority
			};
		};
		const tags = slotColumn("tags", slotKeys.tagsKey, "Tags", {
			align: "left",
			width: "flex-shrink-0 w-40",
			widthPx: 160
		}, PRIORITY_TAGS);
		if (tags) cols.push(tags);
		const status = slotColumn("status", statusPropertyKey, "Status", {
			align: "left",
			width: "flex-shrink-0 w-32",
			widthPx: 128
		}, PRIORITY_STATUS);
		if (status) cols.push(status);
		const date = slotColumn("date", datePropertyKey, "Modified", {
			align: "right",
			width: "flex-shrink-0 w-20",
			widthPx: 80
		}, PRIORITY_DATE);
		if (date) cols.push(date);
		return cols;
	}, [
		columnMode,
		resolvedCollection,
		titleColumn?.key,
		slotKeys.tagsKey,
		statusPropertyKey,
		datePropertyKey,
		sortableKeys
	]);
	/** What the row already shows without a column of its own. */
	const shownKeys = useMemo(() => /* @__PURE__ */ new Set([
		titleColumn?.key,
		imagePropertyKey,
		subtitleKey,
		...declaredColumns.map((col) => col.key),
		...columnMode ? [] : slotKeys.relationKeys
	]), [
		titleColumn,
		imagePropertyKey,
		subtitleKey,
		declaredColumns,
		columnMode,
		slotKeys.relationKeys
	]);
	/** The properties the sort names, minus the ones a cell already shows. */
	const sortedKeys = useMemo(() => (sortBy ?? []).map(([key]) => key).filter((key) => !shownKeys.has(key)), [sortBy, shownKeys]);
	/** The properties the filters name, minus the ones a cell already shows. */
	const filteredKeys = useMemo(() => Object.keys(filterValues ?? {}).filter((key) => !shownKeys.has(key)), [filterValues, shownKeys]);
	/**
	* The last property the sort named, and the last set the filters named.
	*
	* A column earns its place when a sort or a filter names it, and keeps it
	* once that sort or filter is cleared: taking it back would move every
	* column right of it at the moment the user is comparing values across rows,
	* and clearing a sort says nothing about wanting to stop seeing the property
	* it sorted on.
	*
	* What it does *not* do is accumulate. A sort names the properties it names
	* *now*, so ordering by four properties in turn is changing one's mind four
	* times, not asking for four columns — and asking for four is how the row
	* lost its status and its date to a wall of numbers. A new sort therefore
	* replaces the properties the last one left behind, and a new set of filters
	* replaces the set before it. At most one sort's columns and one set of
	* filter columns outlive their request.
	*
	* The list remounts per collection (it is keyed by path), so this is the
	* memory of one visit to one collection, not a preference.
	*/
	const [lastSortedKeys, setLastSortedKeys] = useState([]);
	const [lastFilteredKeys, setLastFilteredKeys] = useState([]);
	useEffect(() => {
		if (sortedKeys.length === 0) return;
		setLastSortedKeys((previous) => previous.length === sortedKeys.length && previous.every((key, i) => key === sortedKeys[i]) ? previous : sortedKeys);
	}, [sortedKeys]);
	useEffect(() => {
		if (filteredKeys.length === 0) return;
		setLastFilteredKeys((previous) => previous.length === filteredKeys.length && previous.every((key, i) => key === filteredKeys[i]) ? previous : filteredKeys);
	}, [filteredKeys]);
	/**
	* Columns for what the user asked to sort or filter by and cannot see.
	*
	* Ordering a list by a property no cell shows produces a shuffle with no
	* explanation in it — the rows move and nothing on screen says why. So the
	* property joins the row as its own column, last: the filters' first, in
	* their own order, then the sort's.
	*/
	const requestedColumns = useMemo(() => {
		const active = /* @__PURE__ */ new Set([...filteredKeys, ...sortedKeys]);
		const keys = [];
		const request = (key) => {
			if (!key || keys.includes(key) || shownKeys.has(key)) return;
			keys.push(key);
		};
		(filteredKeys.length > 0 ? filteredKeys : lastFilteredKeys).forEach(request);
		(sortedKeys.length > 0 ? sortedKeys : lastSortedKeys).forEach(request);
		return keys.flatMap((key, index) => {
			const property = getResolvedPropertyInPath(resolvedCollection.properties, key);
			if (!property) return [];
			return [{
				key,
				label: property.name || key,
				property,
				align: property.type === "number" || property.type === "date" ? "right" : "left",
				...getIdealColumnWidth(property),
				sortable: sortableKeys.has(key),
				priority: (active.has(key) ? PRIORITY_ACTIVE_REQUEST : PRIORITY_STALE_REQUEST) - index
			}];
		});
	}, [
		filteredKeys,
		sortedKeys,
		lastFilteredKeys,
		lastSortedKeys,
		shownKeys,
		resolvedCollection,
		sortableKeys
	]);
	const getListViewActions = useCallback((entity) => {
		if (!getActionsForEntity) return EMPTY_LIST_VIEW_ACTIONS;
		return getActionsForEntity({
			entity,
			customEntityActions: (collection.entityActions ?? []).map((action) => resolveEntityAction(action, customizationController.entityActions)).filter(Boolean)
		}).filter((a) => a.showActionsInListView);
	}, [
		getActionsForEntity,
		collection.entityActions,
		customizationController.entityActions
	]);
	const showImage = size !== "xs";
	/**
	* Does the checkbox ride on the thumbnail rather than sit beside it?
	*
	* Only in the split's compact list — the one layout where the list is a
	* column beside a record rather than the page itself, and where the 48px of
	* checkbox cell is 48px the title does not get. Everywhere else the list has
	* the room, and a checkbox that is always there is easier to find than one
	* that appears under the pointer.
	*
	* Needs a thumbnail to ride on: at `xs` there is none, so the checkbox keeps
	* its cell.
	*/
	const combineSelection = openEntityMode === "split" && selectedEntityId !== void 0 && showImage;
	/**
	* How much room the action buttons take, reserved identically in the header
	* and in every row so the columns line up above one another whether or not a
	* given record has actions.
	*/
	const actionsWidth = useMemo(() => {
		if (!getActionsForEntity) return 0;
		let most = 0;
		for (const entity of data.slice(0, ACTIONS_SAMPLE_SIZE)) most = Math.max(most, getListViewActions(entity).length);
		return most === 0 ? 0 : most * ACTION_BUTTON_WIDTH + (most - 1) * ACTION_BUTTON_GAP;
	}, [
		data,
		getActionsForEntity,
		getListViewActions
	]);
	const visibleColumns = useMemo(() => {
		const columns = [...declaredColumns, ...requestedColumns];
		if (columns.length === 0) return columns;
		if (containerWidth === void 0) return [];
		const chrome = ROW_PADDING_WIDTH + (selectionEnabled && !combineSelection ? 48 : 0) + (showImage ? 56 : 0) + (actionsWidth > 0 ? actionsWidth + COLUMN_GAP : 0);
		const available = containerWidth - chrome - TITLE_COMFORTABLE_WIDTH;
		const cost = (col) => col.widthPx + COLUMN_GAP;
		let total = columns.reduce((acc, col) => acc + cost(col), 0);
		if (total <= available) return columns;
		const dropped = /* @__PURE__ */ new Set();
		for (const col of [...columns].sort((a, b) => a.priority - b.priority)) {
			if (total <= available) break;
			dropped.add(col.key);
			total -= cost(col);
		}
		return columns.filter((col) => !dropped.has(col.key));
	}, [
		declaredColumns,
		requestedColumns,
		containerWidth,
		selectionEnabled,
		combineSelection,
		showImage,
		actionsWidth
	]);
	const handleEntityClick = useCallback((entity) => {
		analyticsController.onAnalyticsEvent?.("entity_click", {
			path: entity.path,
			entityId: entity.id
		});
		onEntityClick?.(entity);
	}, [onEntityClick, analyticsController]);
	const handleSelectionChange = useCallback((entity, selected) => {
		selectionController?.toggleEntitySelection(entity, selected);
	}, [selectionController]);
	useCallback((entity) => {
		return selectionController?.isEntitySelected(entity) ?? false;
	}, [selectionController]);
	useCallback((entity) => {
		return highlightedEntities?.some((e) => e.id === entity.id && e.path === entity.path) ?? false;
	}, [highlightedEntities]);
	const rowClasses = getRowClasses(size);
	const selectedIds = useMemo(() => new Set(data.filter((e) => selectionController?.isEntitySelected(e)).map((e) => e.id)), [data, selectionController]);
	const highlightedIds = useMemo(() => new Set(highlightedEntities?.map((e) => e.id)), [highlightedEntities]);
	const handleRowSelectionChange = useCallback((entity, selected) => {
		handleSelectionChange(entity, selected);
	}, [handleSelectionChange]);
	/** Where each sorted column sits in the order, so a header can show its rank. */
	const sortIndex = useMemo(() => {
		const index = /* @__PURE__ */ new Map();
		(sortBy ?? []).forEach(([key, direction], position) => {
			if (!index.has(key)) index.set(key, {
				direction,
				position
			});
		});
		return index;
	}, [sortBy]);
	/**
	* Order by a column, on the same cycle a table header runs: unordered →
	* ascending → descending → unordered, and shift-click to add the column
	* under the sort already in place. Clicking a header here and clicking it
	* in the table view have to mean the same thing, because they are the same
	* collection under the same controller.
	*/
	const onColumnSort = useCallback((key, additive = false) => {
		if (!setSortBy) return;
		const active = sortIndex.get(key)?.direction;
		const next = active === "asc" ? "desc" : active === "desc" ? void 0 : "asc";
		const existing = sortBy ?? [];
		let updated;
		if (!additive) updated = next ? [[key, next]] : void 0;
		else if (next === void 0) updated = existing.filter(([existingKey]) => existingKey !== key);
		else if (active === void 0) updated = [...existing, [key, next]];
		else updated = existing.map((entry) => entry[0] === key ? [key, next] : entry);
		if (updated?.length === 0) updated = void 0;
		setSortBy(updated);
		setItemCount?.(pageSize);
	}, [
		setSortBy,
		sortBy,
		sortIndex,
		setItemCount,
		pageSize
	]);
	/**
	* Whether a sort can be offered at all next to the filter already applied.
	* A driver may refuse the combination; the table clears the filter to make
	* room, which is a heavier answer than a header click asks for, so the
	* header simply stops offering it — the same choice the sort menu makes.
	*/
	const sortIsAvailable = useCallback((key) => {
		if (!setSortBy) return false;
		if (!checkFilterCombination) return true;
		const active = sortIndex.get(key)?.direction;
		if (active === "desc") return true;
		return checkFilterCombination(filterValues ?? {}, [[key, active === "asc" ? "desc" : "asc"]]);
	}, [
		setSortBy,
		checkFilterCombination,
		filterValues,
		sortIndex
	]);
	return /* @__PURE__ */ jsx("div", {
		ref: containerRef,
		className: "w-full",
		children: /* @__PURE__ */ jsx(ListView, {
			data,
			dataLoading,
			noMoreToLoad,
			dataLoadingError,
			itemCount,
			setItemCount,
			pageSize,
			paginationEnabled,
			onItemClick: handleEntityClick,
			selectedIds,
			highlightedIds,
			selectionEnabled,
			emptyComponent,
			size,
			selectedEntityId,
			header: (titleColumn || visibleColumns.length > 0) && /* @__PURE__ */ jsx(ListHeader, {
				titleColumn,
				columns: visibleColumns,
				selectionEnabled: selectionEnabled && !combineSelection,
				showImage,
				actionsWidth,
				sortIndex,
				onColumnSort,
				sortIsAvailable
			}),
			renderRow: useCallback(({ item: entity, style, className, selected, highlighted, isLast, onClick, onSelectionChange }) => {
				return /* @__PURE__ */ jsx("div", {
					style,
					className,
					children: /* @__PURE__ */ jsx(ListRow, {
						entity,
						collection: resolvedCollection,
						searchString,
						onClick: handleEntityClick,
						selected,
						highlighted,
						onSelectionChange: handleRowSelectionChange,
						selectionEnabled,
						combineSelection,
						columns: visibleColumns,
						slotKeys,
						rowClasses,
						showImage,
						size,
						isLast,
						isActive: selectedEntityId !== void 0 && entity.id === selectedEntityId,
						listViewActions: getListViewActions(entity),
						actionsWidth,
						context,
						path,
						selectionController,
						openEntityMode
					})
				}, entity.id);
			}, [
				resolvedCollection,
				selectionEnabled,
				combineSelection,
				visibleColumns,
				slotKeys,
				rowClasses,
				showImage,
				size,
				selectedEntityId,
				getListViewActions,
				actionsWidth,
				context,
				path,
				selectionController,
				openEntityMode,
				handleRowSelectionChange,
				handleEntityClick,
				searchString
			])
		})
	});
}
/**
* Single row in the list view.
* Uses the shared slot system for a fixed editorial layout:
*   [Checkbox] [Image] [Title + Subtitle] → spacer → [Status] [Date]
*
* When collection.listProperties is explicitly set, falls back to
* the column system for developer-defined table layouts.
*/
var ListRow = React.memo(function ListRow({ entity, collection, onClick, selected, highlighted, onSelectionChange, selectionEnabled, combineSelection = false, columns, slotKeys, rowClasses, showImage, size, isLast, isActive = false, listViewActions = [], actionsWidth = 0, context, path, selectionController, openEntityMode, searchString }) {
	const slots = useEntitySlots(entity, collection, slotKeys);
	const { terms, offSlot } = useSearchExplanation(entity, collection.properties, [slotKeys.titleKey, slotKeys.subtitleKey], searchString);
	const handleClick = useCallback((e) => {
		if ((e.metaKey || e.ctrlKey) && selectionEnabled) {
			e.preventDefault();
			onSelectionChange?.(entity, !selected);
			return;
		}
		onClick?.(entity);
	}, [
		entity,
		onClick,
		selected,
		selectionEnabled,
		onSelectionChange
	]);
	const handleCheckboxClick = useCallback((e) => {
		e.stopPropagation();
	}, []);
	const handleCheckboxChange = useCallback((checked) => {
		onSelectionChange?.(entity, checked);
	}, [entity, onSelectionChange]);
	/** The thumbnail-as-checkbox cell: the square toggles, and never opens the record. */
	const handleSelectionCellClick = useCallback((e) => {
		e.stopPropagation();
		onSelectionChange?.(entity, !selected);
	}, [
		entity,
		onSelectionChange,
		selected
	]);
	const useColumnMode = !!collection.listProperties && collection.listProperties.length > 0;
	return /* @__PURE__ */ jsxs("div", {
		className: cls("@container flex items-center gap-4 cursor-pointer group transition-colors duration-200 relative h-full mx-2 rounded-lg", rowClasses, isActive || selected ? "bg-surface-active" : highlighted ? "bg-surface-hover" : "hover:bg-surface-hover"),
		onClick: handleClick,
		children: [
			selectionEnabled && !combineSelection && /* @__PURE__ */ jsx("div", {
				className: "flex-shrink-0 w-8",
				onClick: handleCheckboxClick,
				children: /* @__PURE__ */ jsx(Checkbox, {
					checked: selected ?? false,
					onCheckedChange: handleCheckboxChange,
					size: "smallest"
				})
			}),
			showImage && /* @__PURE__ */ jsxs("div", {
				className: "flex-shrink-0 relative w-10 h-10",
				children: [slots.image ? /* @__PURE__ */ jsx("div", {
					className: cls("w-10 h-10 rounded-lg border relative overflow-hidden bg-surface-raised", defaultBorderMixin),
					children: /* @__PURE__ */ jsx(SlotValue, {
						slot: slots.image,
						size: "small",
						fill: true
					})
				}) : /* @__PURE__ */ jsx("div", {
					className: cls("w-10 h-10 rounded-lg bg-surface-raised flex items-center justify-center border", defaultBorderMixin),
					children: /* @__PURE__ */ jsx(IconForView, {
						collectionOrView: collection,
						className: "text-surface-500 dark:text-surface-400",
						size: "small"
					})
				}), selectionEnabled && combineSelection && /* @__PURE__ */ jsx("div", {
					className: cls("absolute inset-0 flex items-center justify-center rounded-lg transition-opacity duration-150", "bg-surface-950/55", selected ? "opacity-100" : "opacity-0 group-hover:opacity-100 focus-within:opacity-100"),
					onClick: handleSelectionCellClick,
					children: /* @__PURE__ */ jsx("div", {
						className: "pointer-events-none",
						children: /* @__PURE__ */ jsx(Checkbox, {
							checked: selected ?? false,
							onCheckedChange: handleCheckboxChange,
							size: "smallest"
						})
					})
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "flex-1 min-w-0 overflow-hidden",
				children: [
					/* @__PURE__ */ jsx("div", {
						className: "truncate",
						children: slots.title?.value !== void 0 ? /* @__PURE__ */ jsx(Typography, {
							component: "div",
							variant: "body2",
							className: "font-semibold text-surface-900 dark:text-surface-50 truncate transition-colors group-hover:text-primary dark:group-hover:text-primary-light",
							children: terms.length > 0 && typeof slots.title?.value === "string" ? /* @__PURE__ */ jsx(Highlighted, {
								text: slots.title.value,
								terms
							}) : /* @__PURE__ */ jsx(SlotValue, {
								slot: slots.title,
								size: "small"
							})
						}) : /* @__PURE__ */ jsx(Typography, {
							component: "div",
							variant: "body2",
							className: "font-semibold text-surface-500 dark:text-surface-400 font-mono text-xs transition-colors group-hover:text-primary dark:group-hover:text-primary-light",
							children: entity.id
						})
					}),
					offSlot ? /* @__PURE__ */ jsx(MatchExplanation, {
						match: offSlot,
						label: fieldLabel(collection.properties, offSlot.field)
					}) : slots.subtitle && /* @__PURE__ */ jsx("div", {
						className: "truncate mt-0.5",
						children: /* @__PURE__ */ jsx(Typography, {
							variant: "caption",
							component: "div",
							className: "text-surface-500 dark:text-surface-400 truncate",
							children: terms.length > 0 && typeof slots.subtitle.value === "string" ? /* @__PURE__ */ jsx(Highlighted, {
								text: slots.subtitle.value,
								terms
							}) : /* @__PURE__ */ jsx(SlotValue, {
								slot: slots.subtitle,
								size: "small"
							})
						})
					}),
					!useColumnMode && slots.relations.length > 0 && /* @__PURE__ */ jsxs("div", {
						className: "flex items-center gap-1 mt-1 overflow-hidden max-w-full @max-[350px]:hidden",
						children: [slots.relations.map((rel) => rel.items.map((item) => /* @__PURE__ */ jsx(Chip, {
							size: "smallest",
							colorScheme: rel.colorScheme,
							className: "!text-[10px] !leading-tight !py-0 shrink-0 max-w-[120px] truncate",
							children: item.displayName
						}, `${rel.propertyKey}-${item.id}`))), slots.relations.some((r) => r.totalCount > r.items.length) && /* @__PURE__ */ jsxs("span", {
							className: "text-[10px] text-surface-400 dark:text-surface-500 shrink-0",
							children: ["+", slots.relations.reduce((acc, r) => acc + Math.max(0, r.totalCount - r.items.length), 0)]
						})]
					})
				]
			}),
			columns.length > 0 && /* @__PURE__ */ jsx("div", {
				className: "flex items-center gap-4 flex-shrink-0 ml-auto",
				children: columns.map((col) => /* @__PURE__ */ jsx("div", {
					className: cls(col.width, "flex items-center overflow-hidden", col.align === "center" ? "justify-center" : col.align === "right" ? "justify-end" : "justify-start"),
					children: /* @__PURE__ */ jsx(ListCell, {
						column: col,
						entity,
						slots
					})
				}, col.key))
			}),
			actionsWidth > 0 && /* @__PURE__ */ jsx("div", {
				className: "flex items-center justify-end gap-0.5 flex-shrink-0 ml-auto",
				style: { minWidth: actionsWidth },
				onClick: (e) => e.stopPropagation(),
				children: listViewActions.map((action, index) => /* @__PURE__ */ jsx(Tooltip, {
					title: action.name,
					asChild: true,
					children: /* @__PURE__ */ jsx(IconButton, {
						size: "small",
						onClick: (e) => {
							e.stopPropagation();
							action.onClick({
								view: "collection",
								entity,
								path,
								collection,
								context,
								sidePanelController: context?.sidePanelController,
								selectionController,
								openEntityMode: openEntityMode ?? collection?.openEntityMode ?? "full_screen"
							});
						},
						children: getIcon(action.icon, void 0, void 0, "smallest")
					})
				}, action.key ?? index))
			})
		]
	});
});
/**
* One cell of one row: whatever the column says fills it.
*
* A slot column renders the slot — a status keeps its coloured chip and a date
* its relative wording wherever the value came from — and a property column
* reads the record. Both go through here so the header above them is labelling
* one thing, not two that happen to line up.
*/
function ListCell({ column, entity, slots }) {
	if (column.slot === "tags") {
		if (!slots.tags) return null;
		return /* @__PURE__ */ jsx("div", {
			className: "flex items-center gap-1 overflow-hidden",
			children: /* @__PURE__ */ jsx(TagChips, {
				slot: slots.tags,
				max: 3
			})
		});
	}
	if (column.slot === "status") {
		if (!slots.status) return /* @__PURE__ */ jsx(EmptyCell, {});
		return /* @__PURE__ */ jsx(SlotValue, {
			slot: slots.status,
			size: "small"
		});
	}
	if (column.slot === "date") return /* @__PURE__ */ jsx(Typography, {
		variant: "caption",
		className: "whitespace-nowrap text-surface-400 dark:text-surface-500 font-medium",
		children: slots.date?.formatted ?? "—"
	});
	const property = column.property;
	if (!property) return null;
	const value = getValueInPath(entity.values, column.key);
	if (property.type === "date") return /* @__PURE__ */ jsx(Typography, {
		variant: "caption",
		className: "whitespace-nowrap text-surface-400 dark:text-surface-500 font-medium",
		children: formatDateValue(value) ?? "—"
	});
	if (isComplexPropertyType(property)) return /* @__PURE__ */ jsx(Typography, {
		variant: "caption",
		className: "text-surface-500 dark:text-surface-400 truncate",
		children: compactValueSummary(value, property) ?? "—"
	});
	if (value === void 0 || value === null) return /* @__PURE__ */ jsx(EmptyCell, {});
	return /* @__PURE__ */ jsx(Typography, {
		component: "div",
		variant: "body2",
		className: "text-surface-600 dark:text-surface-300 truncate",
		children: /* @__PURE__ */ jsx(PropertyPreview, {
			propertyKey: column.key,
			value,
			property,
			size: "small"
		})
	});
}
/** What a column shows for a record that has nothing in it. */
function EmptyCell() {
	return /* @__PURE__ */ jsx("span", {
		className: "text-surface-400 dark:text-surface-600",
		children: "—"
	});
}
/**
* The list's column header.
*
* Quiet by design: a list is read row by row, and the header is there to name
* the columns and to be clicked, not to compete with the rows. It lays out
* against the same widths the rows do, and skips the checkbox and the image —
* neither is a column, and neither has anything to be called.
*/
function ListHeader({ titleColumn, columns, selectionEnabled, showImage, actionsWidth, sortIndex, onColumnSort, sortIsAvailable }) {
	const headerCell = (column) => /* @__PURE__ */ jsx(ListHeaderLabel, {
		column,
		direction: sortIndex.get(column.key)?.direction,
		position: sortIndex.size > 1 ? sortIndex.get(column.key)?.position : void 0,
		onSort: column.sortable && sortIsAvailable(column.key) ? (additive) => onColumnSort(column.key, additive) : void 0
	});
	return /* @__PURE__ */ jsxs("div", {
		className: cls("flex items-center gap-4 px-5 py-1.5 select-none border-b bg-surface-sheet", defaultBorderMixin),
		children: [
			selectionEnabled && /* @__PURE__ */ jsx("div", { className: "flex-shrink-0 w-8" }),
			showImage && /* @__PURE__ */ jsx("div", { className: "flex-shrink-0 w-10" }),
			/* @__PURE__ */ jsx("div", {
				className: "flex-1 min-w-0 flex items-center",
				children: titleColumn && headerCell(titleColumn)
			}),
			columns.length > 0 && /* @__PURE__ */ jsx("div", {
				className: "flex items-center gap-4 flex-shrink-0 ml-auto",
				children: columns.map((column) => /* @__PURE__ */ jsx("div", {
					className: cls(column.width, "flex items-center overflow-hidden", column.align === "center" ? "justify-center" : column.align === "right" ? "justify-end" : "justify-start"),
					children: headerCell(column)
				}, column.key))
			}),
			actionsWidth > 0 && /* @__PURE__ */ jsx("div", {
				className: "flex-shrink-0 ml-auto",
				style: { minWidth: actionsWidth }
			})
		]
	});
}
/**
* One header label, clickable when the collection can be ordered by it.
*
* The arrow shows only on the column currently ordering the list: three arrows
* in a header row are three invitations, and only one of them is ever the
* answer to "how is this sorted".
*/
function ListHeaderLabel({ column, direction, position, onSort }) {
	const { t } = useTranslation();
	const content = /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("span", {
			className: "truncate",
			children: column.label
		}),
		direction === "asc" && /* @__PURE__ */ jsx(ArrowUpIcon, {
			size: 12,
			className: "flex-shrink-0"
		}),
		direction === "desc" && /* @__PURE__ */ jsx(ArrowDownIcon, {
			size: 12,
			className: "flex-shrink-0"
		}),
		direction && position !== void 0 && /* @__PURE__ */ jsx("span", {
			className: "flex-shrink-0 text-[9px] font-semibold leading-none tabular-nums",
			children: position + 1
		})
	] });
	const base = "inline-flex items-center gap-1 max-w-full text-[11px] leading-none uppercase tracking-wider font-medium";
	const tone = direction ? "text-surface-600 dark:text-surface-300" : "text-surface-400 dark:text-surface-500";
	if (!onSort) return /* @__PURE__ */ jsx("span", {
		className: cls(base, tone),
		children: content
	});
	const nextAction = direction === "asc" ? t("sort_descending") : direction === "desc" ? t("sort_remove") : t("sort_ascending");
	const rank = direction && position !== void 0 ? ` (${t("sort_key_position", { position: position + 1 })})` : "";
	const label = `${column.label}${rank} — ${nextAction}. ${t("sort_shift_click_hint")}`;
	return /* @__PURE__ */ jsx("button", {
		type: "button",
		title: label,
		"aria-label": label,
		onClick: (event) => onSort(event.shiftKey),
		className: cls(base, tone, "cursor-pointer hover:text-surface-700 dark:hover:text-surface-200 transition-colors"),
		children: content
	});
}
//#endregion
//#region src/components/EntityDisplayHeader.tsx
/**
* The roles whose property the read-only view takes out of its grid.
*
* A role rendered here and left in the grid prints the value twice, so the
* header's own rendering and this list have to agree — but the list is *not*
* simply "every role the header draws". Two are deliberately absent:
*
* `title`, because the heading above a record and a labelled field are not the
* same thing. `Order #` is a column with a name, a description and a format that
* someone reads the record to find; `ORD-2026-0043` sitting in the identity bar
* beside the breadcrumb is a label for the page. Removing the field because the
* page is named after it takes a value out of the record on the grounds that its
* text appears elsewhere, which is not a reason — a value in the database is
* shown.
*
* `date`, because the rail's record block already carries the timestamps, and a
* collection whose `date` role points at a business date — an order date, a due
* date — wants that field where it declared it.
*/
var HEADER_DISPLAY_ROLES = [
	"subtitle",
	"image",
	"status",
	"tags"
];
/**
* What the record *is*, above the fields that say what it holds.
*
* A record's picture, name, state and labels are the things you opened the page
* to see; on the plain grid they were fields like any other, so an order's
* status sat in the second cell of the first row at the same size and weight as
* its shipping cost, and its tags were a wrapped list of grey text.
*
* Every role here comes from `admin.display` and nothing is derived except the
* title, which was already derived for the identity bar. A collection that
* declares no display block therefore gets no header at all rather than a
* heuristic guess at which of its enums is a "status" — the panel does not know
* what these records are, and a wrong guess here is louder than no guess.
*
* A role filled by a *property* renders through {@link PropertyPreview}, so a
* status keeps its enum's colour and an image stays a storage thumbnail. A role
* filled by a resolver has no property behind it and renders as what it
* returned.
*/
function EntityDisplayHeader({ entity, collection, showTitle = false, className }) {
	const display = useEntityDisplayValues({
		collection,
		entity
	});
	const title = showTitle ? asText(display.title.value) : void 0;
	const subtitle = asText(display.subtitle.value);
	const tags = asTags(display.tags.value);
	const hasStatus = display.status.value !== void 0;
	const hasImage = display.image.value !== void 0;
	if (!title && !subtitle && !hasStatus && !hasImage && !tags.length) return null;
	return /* @__PURE__ */ jsxs("div", {
		className: cls("flex items-start gap-4 min-w-0", className),
		children: [hasImage && /* @__PURE__ */ jsx("div", {
			className: "shrink-0 w-16 h-16 rounded-lg overflow-hidden flex items-center justify-center bg-surface-raised",
			children: /* @__PURE__ */ jsx(RoleValue, {
				role: display.image,
				propertyFallback: typeof display.image.value === "string" ? /* @__PURE__ */ jsx("img", {
					src: display.image.value,
					alt: "",
					className: "w-full h-full object-cover"
				}) : null
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col gap-1.5 min-w-0 flex-1",
			children: [
				title && /* @__PURE__ */ jsx(Typography, {
					variant: "h5",
					className: "min-w-0 truncate m-0",
					children: title
				}),
				subtitle && /* @__PURE__ */ jsx(Typography, {
					variant: "body2",
					color: "secondary",
					className: "min-w-0 m-0",
					children: subtitle
				}),
				(hasStatus || tags.length > 0) && /* @__PURE__ */ jsxs("div", {
					className: "flex flex-wrap items-center gap-1.5",
					children: [hasStatus && /* @__PURE__ */ jsx(RoleValue, {
						role: display.status,
						propertyFallback: /* @__PURE__ */ jsx(Chip, {
							size: "small",
							children: asText(display.status.value)
						})
					}), tags.map((tag) => /* @__PURE__ */ jsx(Chip, {
						size: "small",
						outlined: true,
						children: tag
					}, tag))]
				})
			]
		})]
	});
}
/**
* One resolved role, rendered richly when a property is behind it.
*
* `source` is set only when the value came from a property of this collection
* (see `useEntityDisplay`), and it carries what a rich rendering needs. Its
* absence is exactly the "this was computed" signal, and a computed value is a
* bare string with no property to describe it — hence the fallback.
*/
function RoleValue({ role, propertyFallback }) {
	const source = role.source;
	if (!source?.property) return /* @__PURE__ */ jsx(Fragment, { children: propertyFallback });
	return /* @__PURE__ */ jsx(PropertyPreview, {
		propertyKey: source.key,
		value: source.value,
		property: source.property,
		hideLabel: true,
		size: "medium"
	});
}
/** A role's value as a line of text, or nothing when it holds nothing to read. */
function asText(value) {
	if (value === void 0 || value === null) return void 0;
	const text = String(value).trim();
	return text.length ? text : void 0;
}
/** The `tags` role, which takes a single string as shorthand for one tag. */
function asTags(value) {
	if (value === void 0 || value === null) return [];
	return (Array.isArray(value) ? value : [value]).map((entry) => asText(entry)).filter((entry) => Boolean(entry));
}
//#endregion
//#region src/components/EntityViewBinding.tsx
/** Nothing can be in error in a view that cannot be submitted. */
var NO_ERRORS = /* @__PURE__ */ new Set();
/**
* The fields the read-only view lays out, in render order.
*
* The same set the form uses, minus two groups. Both are dropped *before* the
* layout resolves rather than skipped while rendering, because the resolver has
* by then given each one a place on the grid — skipping later leaves that place
* as a hole.
*
* - The `additionalFields` when there is no form context to hand them: those
*   entries are arbitrary components, not values, and one rendered against no
*   context is nothing at all.
* - `headerKeys` — the properties {@link EntityDisplayHeader} has already
*   rendered as the record's picture, subtitle, state and labels. Leaving one in
*   prints its value twice on one screen.
*
* The record's **title property is not among them**, deliberately. It names the
* page in the identity bar, but a heading and a labelled field are different
* things: `Order #` is a column with a name and a description that someone opens
* the record to read, and dropping it because its text also appears in the
* breadcrumb removes a value from the record on the grounds that it is legible
* somewhere else. See {@link HEADER_DISPLAY_ROLES}.
*/
function readOnlyFieldKeys(collection, hasFormContext, headerKeys) {
	const keys = getFormFieldKeys(collection);
	const additional = hasFormContext ? void 0 : new Set((collection.additionalFields ?? []).map((field) => field.key));
	return keys.filter((key) => !additional?.has(key) && !headerKeys?.has(key));
}
/**
* The read-only rendering of a record's values.
*
* This is the same layout as {@link EntityForm}: the sections, the grid spans,
* the labels and the rail all come from the one resolver, so the record does
* not rearrange itself when you press Edit. Only the controls differ — each
* field renders its {@link PropertyPreview} instead of an input.
*
* It used to be a flat two-column table of every value in the record: no
* grouping, no widths, a label column sized for short names and a value column
* that wrapped emails over two lines while the pane beside it stayed empty. A
* boolean and a markdown body were given the same room.
*
* The synthetic `Id` row it used to prepend is gone with the same reasoning the
* form applies: between that row, the collection's own id property and the
* `path/id` chip above them, one UUID appeared three times. The id is a
* copyable chip in the identity bar, and the rail's record block, once each.
*
* The labels are the form's labels, icon and all: a field is the same field
* whether or not you are editing it. What `mode: "read"` drops is the per-field
* *description*, which is input help rather than part of the label — and what it
* adds is room. A control is a bordered box that separates itself from the next
* one; a value is bare text, so the rows and sections are opened up rather than
* inheriting spacing sized for inputs.
*/
function EntityViewBinding({ entity, collection, className, asPage = false, openEntityMode = "full_screen", formContext }) {
	const display = useEntityDisplayValues({
		collection,
		entity
	});
	const headerKeys = useMemo(() => {
		const keys = /* @__PURE__ */ new Set();
		for (const role of HEADER_DISPLAY_ROLES) {
			const key = display[role].source?.key;
			if (key) keys.add(key);
		}
		return keys;
	}, [display]);
	const hasFormContext = Boolean(formContext);
	const fieldKeys = useMemo(() => readOnlyFieldKeys(collection, hasFormContext, headerKeys), [
		collection,
		hasFormContext,
		headerKeys
	]);
	const layout = useMemo(() => resolveFormLayout({
		collection,
		fieldKeys,
		status: "existing"
	}), [collection, fieldKeys]);
	const containerRef = useRef(null);
	const railVisible = useRailVisible(containerRef);
	const showRail = asPage && layout.hasRail && railVisible;
	const [collapsedSections, setCollapsedSections] = useState(() => new Set(layout.sections.filter((section) => section.collapsed).map((section) => section.key)));
	const toggleSection = useCallback((key) => {
		setCollapsedSections((prev) => {
			const next = new Set(prev);
			if (next.has(key)) next.delete(key);
			else next.add(key);
			return next;
		});
	}, []);
	const rebaseContext = useRebaseContext();
	const renderField = useCallback((field) => {
		if (field.additional) {
			const additionalField = collection.additionalFields?.find((f) => f.key === field.key);
			if (!additionalField || !formContext) return null;
			const AdditionalFieldBuilder = additionalField.Builder;
			const child = AdditionalFieldBuilder ? /* @__PURE__ */ jsx(AdditionalFieldBuilder, {
				entity,
				context: rebaseContext
			}) : /* @__PURE__ */ jsx("div", {
				className: "w-full",
				children: /* @__PURE__ */ jsx(AdditionalFieldValue, {
					field: additionalField,
					entity,
					context: rebaseContext
				})
			});
			return /* @__PURE__ */ jsx("div", {
				className: spanClass(field.span),
				children: /* @__PURE__ */ jsx(FieldBlock, {
					propertyKey: field.key,
					showLabel: true,
					mode: "read",
					label: additionalField.name,
					icon: /* @__PURE__ */ jsx(AlignLeftIcon, { size: 14 }),
					children: /* @__PURE__ */ jsx("div", {
						className: cls(paperMixin, "w-full min-h-12 p-4 md:p-6 overflow-x-auto no-scrollbar"),
						children: child
					})
				})
			}, `additional_${field.key}`);
		}
		const property = collection.properties?.[field.key];
		if (!property) return null;
		return /* @__PURE__ */ jsx("div", {
			className: spanClass(field.span),
			children: /* @__PURE__ */ jsx(FieldBlock, {
				propertyKey: field.key,
				property,
				showLabel: true,
				mode: "read",
				children: /* @__PURE__ */ jsx("div", {
					className: "min-h-8 flex flex-col justify-center min-w-0 text-sm text-text-primary dark:text-text-primary-dark",
					children: /* @__PURE__ */ jsx(PropertyPreview, {
						propertyKey: field.key,
						value: getValueInPath(entity.values, field.key),
						property,
						hideLabel: true,
						size: "medium"
					})
				})
			})
		}, `field_${field.key}`);
	}, [
		collection,
		entity,
		formContext,
		rebaseContext
	]);
	/**
	* One field of a `readVariant: "summary"` section: a label/value row rather
	* than a grid cell, with the last one emphasised.
	*
	* The last row is the one a summary exists for — a run of figures is read to
	* arrive at its final line — so it is separated by a rule and set at the
	* weight the grid gave every cell equally.
	*/
	const renderSummaryField = useCallback((field, index, total) => {
		const property = collection.properties?.[field.key];
		if (!property) return null;
		const last = index === total - 1;
		return /* @__PURE__ */ jsxs("div", {
			className: cls("flex items-baseline justify-between gap-4 min-w-0 py-2", last && total > 1 && cls("mt-1.5 pt-3 border-t", defaultBorderMixin)),
			children: [/* @__PURE__ */ jsx("span", {
				className: cls("min-w-0 truncate", last ? "text-sm font-semibold text-text-primary dark:text-text-primary-dark" : "text-sm text-text-secondary dark:text-text-secondary-dark"),
				children: property.name ?? field.key
			}), /* @__PURE__ */ jsx("span", {
				className: cls("shrink-0 text-right text-text-primary dark:text-text-primary-dark", last ? "text-base font-semibold" : "text-sm"),
				children: /* @__PURE__ */ jsx(PropertyPreview, {
					propertyKey: field.key,
					value: getValueInPath(entity.values, field.key),
					property,
					hideLabel: true,
					size: "medium"
				})
			})]
		}, `summary_${field.key}`);
	}, [collection, entity]);
	const sections = showRail || !layout.sidebar.length ? layout.sections : [...layout.sections, {
		key: "__rail",
		title: "Settings",
		collapsible: false,
		collapsed: false,
		fields: layout.sidebar
	}];
	const content = /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx(EntityDisplayHeader, {
			entity,
			collection,
			showTitle: !asPage,
			className: "mb-10"
		}),
		/* @__PURE__ */ jsx(FormSections, {
			sections,
			collapsed: collapsedSections,
			onToggle: toggleSection,
			errorKeys: NO_ERRORS,
			renderField,
			renderSummaryField,
			mode: "read"
		}),
		!showRail && layout.showRecordMeta && /* @__PURE__ */ jsx("div", {
			className: cls("mt-10 pt-6 border-t max-w-sm", defaultBorderMixin),
			children: /* @__PURE__ */ jsx(RecordMeta, { entity })
		})
	] });
	if (!asPage) return /* @__PURE__ */ jsx("div", {
		ref: containerRef,
		className: cls("@container/col w-full min-w-0", className),
		children: content
	});
	return /* @__PURE__ */ jsxs("div", {
		ref: containerRef,
		className: cls("@container/form flex-1 flex flex-row w-full min-h-0", className),
		children: [/* @__PURE__ */ jsx("div", {
			className: "flex-1 min-w-0 overflow-y-auto flex justify-center items-start",
			children: /* @__PURE__ */ jsx("div", {
				className: cls("@container/col w-full max-w-3xl @7xl/form:max-w-4xl 2xl:max-w-4xl flex flex-col", openEntityMode === "dialog" ? "pt-5 pb-8 px-6 sm:px-8" : "pt-6 pb-12 px-5 sm:px-8"),
				children: content
			})
		}), showRail && /* @__PURE__ */ jsx(FormRail, {
			fields: layout.sidebar,
			showRecordMeta: layout.showRecordMeta,
			entity,
			renderField
		})]
	});
}
//#endregion
//#region src/components/EntityIdentityBar.tsx
/**
* The persistent header of an entity view: who this record is, and what you can
* do to it.
*
* The title and the id used to live inside the scrolling form, above 72px of
* empty space — 219px of chrome that carried nothing and scrolled away the
* moment you touched the wheel, leaving no indication of which record you were
* editing. They live here instead, and the left half of a bar that was
* previously empty now does the work.
*/
function EntityIdentityBar({ collection, collectionUrl, title, entityId, status, dirty, saving, onSave, onDiscard, saveDisabled, hasErrors, onSaveAndClose, saveAndClosePlacement = "button", onClose, onBack, onInspect, onViewHistory, externalLink, recordActions, pluginActions, trailing, leading }) {
	const { t } = useTranslation();
	const hasMenu = Boolean(recordActions) || Boolean(onInspect) || Boolean(onViewHistory) || Boolean(externalLink);
	return /* @__PURE__ */ jsxs("div", {
		className: cls("h-[52px] shrink-0 flex items-center gap-2 pl-1.5 pr-2", "bg-surface-sheet"),
		children: [
			leading,
			onBack && /* @__PURE__ */ jsx(Tooltip, {
				title: t("back"),
				children: /* @__PURE__ */ jsx(IconButton, {
					size: "small",
					onClick: onBack,
					"aria-label": t("back"),
					children: /* @__PURE__ */ jsx(ArrowLeftIcon, { size: iconSize.smallest })
				})
			}),
			collectionUrl ? /* @__PURE__ */ jsx(Link, {
				to: collectionUrl,
				className: "visited:text-inherit dark:visited:text-inherit hidden sm:block",
				children: /* @__PURE__ */ jsxs(Typography, {
					variant: "caption",
					className: cls("text-text-disabled dark:text-text-disabled-dark whitespace-nowrap", "hover:text-text-primary dark:hover:text-text-primary-dark transition-colors"),
					children: [collection.name, "\xA0/"]
				})
			}) : /* @__PURE__ */ jsxs(Typography, {
				variant: "caption",
				className: "text-text-disabled dark:text-text-disabled-dark whitespace-nowrap hidden sm:block",
				children: [collection.name, "\xA0/"]
			}),
			/* @__PURE__ */ jsx("span", {
				className: "font-headers font-semibold text-[15px] tracking-tight truncate min-w-0",
				title,
				children: title
			}),
			entityId !== void 0 && /* @__PURE__ */ jsx(IdChip, { value: String(entityId) }),
			/* @__PURE__ */ jsx("div", { className: "flex-1" }),
			pluginActions,
			/* @__PURE__ */ jsx(EntitySaveActions, {
				status,
				dirty,
				saving,
				onSave,
				onDiscard,
				saveDisabled,
				hasErrors,
				onSaveAndClose,
				saveAndClosePlacement
			}),
			hasMenu && /* @__PURE__ */ jsxs(Menu, {
				align: "end",
				trigger: /* @__PURE__ */ jsx(IconButton, {
					size: "small",
					"aria-label": t("more_actions") ?? "More actions",
					children: /* @__PURE__ */ jsx(MoreVerticalIcon, { size: iconSize.smallest })
				}),
				children: [
					externalLink && /* @__PURE__ */ jsxs(MenuItem, {
						onClick: () => window.open(externalLink, "_blank", "noopener,noreferrer"),
						children: [/* @__PURE__ */ jsx(ExternalLinkIcon, { size: iconSize.smallest }), t("open_in_live_site") ?? "Open in the live site"]
					}),
					externalLink && (recordActions || onInspect || onViewHistory) && /* @__PURE__ */ jsx(Separator, { orientation: "horizontal" }),
					recordActions,
					recordActions && (onInspect || onViewHistory) && /* @__PURE__ */ jsx(Separator, { orientation: "horizontal" }),
					onViewHistory && /* @__PURE__ */ jsxs(MenuItem, {
						onClick: onViewHistory,
						children: [/* @__PURE__ */ jsx(HistoryIcon, { size: iconSize.smallest }), t("record_history") ?? "History"]
					}),
					onInspect && /* @__PURE__ */ jsxs(MenuItem, {
						onClick: onInspect,
						children: [/* @__PURE__ */ jsx(CodeIcon, { size: iconSize.smallest }), t("inspect_record") ?? "Inspect record"]
					})
				]
			}),
			trailing,
			onClose && /* @__PURE__ */ jsx(Tooltip, {
				title: `${t("close")} · Esc`,
				children: /* @__PURE__ */ jsx(IconButton, {
					size: "small",
					onClick: onClose,
					"aria-label": t("close"),
					className: "ml-2",
					children: /* @__PURE__ */ jsx(XIcon, { size: iconSize.smallest })
				})
			})
		]
	});
}
/**
* Save, "save and close", Discard, and the words saying where the edit stands.
*
* Its own component because it has two homes. On a page and in the side panel
* it sits in the identity bar, where it stays in view while the form scrolls. In
* the dialog it sits in a footer under the form: a dialog is read top to bottom
* and finished at the bottom, where every other dialog in the app keeps its
* buttons, and the bar at its top is left to say what the record is.
*/
function EntitySaveActions({ status, dirty, saving, onSave, onDiscard, saveDisabled, hasErrors, onSaveAndClose, saveAndClosePlacement = "button" }) {
	const { t } = useTranslation();
	const saveLabel = status === "existing" ? t("save") : status === "copy" ? t("create_copy") : t("create");
	const closeLabel = status === "existing" ? t("save_and_close") : status === "copy" ? t("create_copy_and_close") : t("create_and_close");
	const saveAndCloseButton = Boolean(onSaveAndClose) && saveAndClosePlacement === "button";
	const saveAndCloseMenu = Boolean(onSaveAndClose) && saveAndClosePlacement === "menu";
	const saveTooltip = hasErrors ? t("fix_errors_before_saving") ?? "Fix highlighted errors before saving" : void 0;
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		onSave && /* @__PURE__ */ jsx(SaveState, {
			dirty,
			saving,
			status,
			t
		}),
		onDiscard && dirty && !saving && /* @__PURE__ */ jsx(Button, {
			variant: "text",
			size: "small",
			onClick: onDiscard,
			children: status === "existing" ? t("discard") : t("clear")
		}),
		onSave && /* @__PURE__ */ jsxs("div", {
			className: "flex items-stretch rounded-lg overflow-hidden",
			children: [/* @__PURE__ */ jsx(Tooltip, {
				title: saveTooltip,
				children: /* @__PURE__ */ jsx(LoadingButton, {
					variant: saveAndCloseButton ? "text" : "filled",
					color: "primary",
					size: "small",
					loading: saving && !saveAndCloseButton,
					disabled: saveDisabled,
					onClick: onSave,
					className: saveAndCloseMenu ? "rounded-none" : void 0,
					children: saveLabel
				})
			}), saveAndCloseMenu && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Menu, {
				align: "end",
				trigger: /* @__PURE__ */ jsx(Button, {
					variant: "filled",
					color: "primary",
					size: "small",
					disabled: saveDisabled,
					"aria-label": closeLabel,
					style: { borderLeftColor: "color-mix(in oklab, currentColor 15%, transparent)" },
					className: "rounded-none px-1.5",
					children: /* @__PURE__ */ jsx(ChevronDownIcon, { size: iconSize.smallest })
				}),
				children: /* @__PURE__ */ jsxs(MenuItem, {
					onClick: onSaveAndClose,
					children: [/* @__PURE__ */ jsx(CheckIcon, { size: iconSize.smallest }), closeLabel]
				})
			}) })]
		}),
		saveAndCloseButton && /* @__PURE__ */ jsx(LoadingButton, {
			variant: "filled",
			color: "primary",
			size: "small",
			loading: saving,
			disabled: saveDisabled,
			onClick: onSaveAndClose,
			children: closeLabel
		})
	] });
}
/**
* The words the unlabelled floating circle never said.
*
* That indicator was a ✓ / pencil / spinner chip stuck to the top-right of the
* scroll area in an `h-0 overflow-visible` container, so it drifted across
* field values as you scrolled — and it duplicated what the Save button was
* already able to tell you.
*/
function SaveState({ dirty, saving, status, t }) {
	if (saving) return /* @__PURE__ */ jsx(StateText, { children: t("saving") });
	if (dirty) return /* @__PURE__ */ jsx(StateText, { children: t("unsaved_changes_title") });
	if (status === "existing") return /* @__PURE__ */ jsx(StateText, { children: t("entity_saved") ?? "Saved" });
	return null;
}
function StateText({ children }) {
	return /* @__PURE__ */ jsx("span", {
		className: "text-xs text-text-disabled dark:text-text-disabled-dark whitespace-nowrap hidden md:inline",
		children
	});
}
/**
* The id, as a chip you can copy rather than a full-width alert holding a UUID.
*/
function IdChip({ value }) {
	const { t } = useTranslation();
	const [copied, setCopied] = useState(false);
	const truncated = value.length > 14 ? `${value.slice(0, 8)}…${value.slice(-4)}` : value;
	const copy = () => {
		navigator.clipboard?.writeText(value).then(() => {
			setCopied(true);
			setTimeout(() => setCopied(false), 1600);
		}, () => void 0);
	};
	return /* @__PURE__ */ jsx(Tooltip, {
		title: copied ? t("copied") : value,
		children: /* @__PURE__ */ jsxs("button", {
			type: "button",
			onClick: copy,
			"aria-label": `${t("copy_id")} ${value}`,
			className: cls("hidden md:inline-flex items-center gap-1.5 shrink-0 whitespace-nowrap px-2 py-0.5 rounded-md", "font-mono text-[11px] text-text-secondary dark:text-text-secondary-dark", "bg-surface-field", "hover:bg-surface-field-hover transition-colors"),
			children: [truncated, copied ? /* @__PURE__ */ jsx(CheckIcon, { size: iconSize.smallest }) : /* @__PURE__ */ jsx(CopyIcon, { size: iconSize.smallest })]
		})
	});
}
//#endregion
//#region src/components/CollectionViewBinding/SplitViewContext.tsx
var SplitViewContext = React.createContext(void 0);
/**
* The enclosing split view, or `undefined` when the component is not rendered
* inside one (a side panel, a dialog, a full-screen route).
*/
function useSplitView() {
	return useContext(SplitViewContext);
}
function SplitViewProvider({ value, children }) {
	return /* @__PURE__ */ jsx(SplitViewContext.Provider, {
		value,
		children
	});
}
//#endregion
//#region src/components/CollectionViewBinding/SplitListCloseButton.tsx
/**
* Closes the list of a split view, leaving the open record on its own.
*
* It leads the record's own app bar, where the breadcrumb starts — this is the
* entity pane's old "Open full screen" button, moved to that edge: closing the
* list and opening the record full screen are the same thing, so there is one
* control and one route (`#full`) rather than two. Full screen carries the
* mirrored icon to bring the list back.
*
* A pane glyph rather than the double chevron it wore first. Now that the bar
* ends in a ✕ that dismisses the record, an arrow pointing off the left edge of
* the record's own bar was the other thing on it that read as "close me" — and
* it is the one control here that does not act on the record at all.
*/
function SplitListCloseButton({ onBeforeHide } = {}) {
	const { t } = useTranslation();
	const splitView = useSplitView();
	if (!splitView?.detailOpen) return null;
	return /* @__PURE__ */ jsx(Tooltip, {
		title: t("hide_list"),
		children: /* @__PURE__ */ jsx(IconButton, {
			size: "small",
			onClick: () => {
				onBeforeHide?.();
				splitView.openFullScreen();
			},
			"aria-label": t("hide_list"),
			children: /* @__PURE__ */ jsx(PanelLeftCloseIcon, { size: iconSize.smallest })
		})
	});
}
//#endregion
//#region src/components/CollectionViewBinding/SplitListShowButton.tsx
/**
* Brings the list back beside a record that was opened full screen.
*
* The mirror of {@link SplitListCloseButton}: the same edge of the same bar,
* the same pane glyph opening rather than closing, and the same single route —
* showing the list is dropping the `#full` hash. It replaces the back arrow
* where it applies, because the list it unfolds already holds the record.
*/
function SplitListShowButton({ onClick }) {
	const { t } = useTranslation();
	return /* @__PURE__ */ jsx(Tooltip, {
		title: t("show_list"),
		children: /* @__PURE__ */ jsx(IconButton, {
			size: "small",
			onClick,
			"aria-label": t("show_list"),
			children: /* @__PURE__ */ jsx(PanelLeftOpenIcon, { size: iconSize.smallest })
		})
	});
}
//#endregion
//#region src/components/EntityInspector.tsx
var EntityHistoryView = lazyChunk(() => import("./history-DG6Ln7CV.js").then((m) => ({ default: m.EntityHistoryView })));
/**
* The JSON tab pulls `prism-react-renderer` — 85 kB, and it was EAGER.
*
* A static import here put the syntax highlighter in the set a browser
* downloads before the login screen paints, for a preview that cannot appear
* until somebody has signed in, opened a record, and chosen this tab. Its
* neighbour `EntityHistoryView` is already loaded this way, behind the same
* `Suspense`, for the same reason.
*/
var JsonPreviewBinding = lazyChunk(() => import("./JsonPreviewBinding-v0w3H0fp.js").then((m) => ({ default: m.JsonPreviewBinding })));
/**
* Raw values and revision history, as an inspector rather than as tabs.
*
* These were the first two entries in the entity tab strip — two icon-only tabs
* with no label and no tooltip, sitting *before* the record you opened the page
* to edit. They are developer tools, not places the record lives, so they belong
* behind one affordance in the bar; a content editor should never meet `<>`.
*
* The panel sits below the identity bar and beside the record deliberately: you
* keep seeing which record you are inspecting, and keep being able to edit it.
*/
function EntityInspector({ tab, onTabChange, onClose, collection, entity, formContext, values, includeHistory, refreshToken }) {
	const { t } = useTranslation();
	const open = tab !== null;
	useEffect(() => {
		if (!open) return;
		const onKeyDown = (e) => {
			if (e.key !== "Escape") return;
			if (document.querySelector("[role=\"dialog\"][data-state=\"open\"]")) return;
			e.stopPropagation();
			onClose();
		};
		document.addEventListener("keydown", onKeyDown, true);
		return () => document.removeEventListener("keydown", onKeyDown, true);
	}, [open, onClose]);
	if (!open) return null;
	return /* @__PURE__ */ jsxs("div", {
		className: cls("relative flex flex-col shrink-0 h-full w-full max-w-md border-l", "bg-surface-card", defaultBorderMixin),
		role: "complementary",
		"aria-label": t("inspect_record") ?? "Inspect record",
		children: [/* @__PURE__ */ jsxs("div", {
			className: cls("h-11 shrink-0 flex items-center gap-2 pl-4 pr-1.5 border-b", defaultBorderMixin),
			children: [
				/* @__PURE__ */ jsx("span", {
					className: "text-sm font-semibold",
					children: t("inspect") ?? "Inspect"
				}),
				/* @__PURE__ */ jsx("div", { className: "flex-1" }),
				includeHistory ? /* @__PURE__ */ jsxs(Tabs, {
					value: tab ?? "json",
					className: "!w-fit",
					onValueChange: (v) => onTabChange(v),
					children: [/* @__PURE__ */ jsx(Tab, {
						value: "json",
						className: "text-xs",
						children: t("json")
					}), /* @__PURE__ */ jsx(Tab, {
						value: "history",
						className: "text-xs",
						children: t("record_history") ?? "History"
					})]
				}) : null,
				/* @__PURE__ */ jsx(IconButton, {
					size: "small",
					onClick: onClose,
					"aria-label": t("close_inspector") ?? "Close inspector",
					children: /* @__PURE__ */ jsx(XIcon, { size: iconSize.smallest })
				})
			]
		}), /* @__PURE__ */ jsx("div", {
			className: "flex-1 min-h-0 overflow-auto",
			children: /* @__PURE__ */ jsxs(ErrorBoundary, { children: [tab === "json" && /* @__PURE__ */ jsx(Suspense, {
				fallback: /* @__PURE__ */ jsx(CircularProgressCenter, {}),
				children: /* @__PURE__ */ jsx(JsonPreviewBinding, { values: values ?? entity?.values ?? {} })
			}), tab === "history" && includeHistory && formContext && /* @__PURE__ */ jsx(Suspense, {
				fallback: /* @__PURE__ */ jsx(CircularProgressCenter, {}),
				children: /* @__PURE__ */ jsx(EntityHistoryView, {
					collection,
					entity,
					formContext,
					refreshToken,
					modifiedValues: values ?? entity?.values
				})
			})] })
		})]
	});
}
//#endregion
//#region src/hooks/useEntityDisplayTitle.tsx
/**
* The heading for a record: the identity bar and the breadcrumb.
*
* Everything about *what a record is called* lives in {@link useEntityTitle}.
* What is left here is the heading's own two rules, which are presentation, not
* identity:
*
* The guard on `status` is the first. The title resolver returns the first
* candidate carrying a value, and on a brand new entity the only values are the
* property defaults — so creating a blog post opened a page headed **draft**,
* the default of its `status` enum. A record that does not exist yet has no
* name; it has an intent.
*
* The fallback is the second. A page needs a heading even when the record has
* nothing readable in it, and the honest one is what kind of thing it is.
*/
function useEntityDisplayTitle({ collection, entity, values, status }) {
	const isNew = status === "new";
	const singular = collection.singularName ?? collection.name;
	const { value: title } = useEntityTitle({
		collection,
		entity,
		values,
		enabled: !isNew
	});
	if (isNew) return `New ${singular.toLowerCase()}`;
	return title ?? singular;
}
//#endregion
//#region src/util/view_constants.ts
/**
* Shared tab value constants used by EditViewBinding and DetailViewBinding.
*/
var MAIN_TAB_VALUE = "__main_##Q$SC^#S6";
/**
* Every tab in that row, a custom `tabComponent` included.
*
* `h-full` over the variant's `h-9`: the row is 40px and the tab 36px, so a
* centred tab floated ~2px clear of the row's bottom border and the active
* tab's underline stopped short of the record it opens. Paired with
* `items-stretch` on the Tabs root, which the variant leaves centred.
*/
var ENTITY_VIEW_TAB_CLASS = "h-full";
//#endregion
//#region src/components/DetailViewBinding.tsx
function DetailViewBinding({ entityId, ...props }) {
	const { entity, dataLoading, dataLoadingError } = useFetch({
		path: props.path,
		entityId,
		collection: props.collection,
		useCache: false
	});
	if (!dataLoading && dataLoadingError) return /* @__PURE__ */ jsx(CenteredView, { children: /* @__PURE__ */ jsx(ErrorView, { error: dataLoadingError }) });
	if (!dataLoading && !entity) return /* @__PURE__ */ jsx(CenteredView, { children: /* @__PURE__ */ jsx(Typography, {
		variant: "label",
		children: "Entity not found"
	}) });
	const content = /* @__PURE__ */ jsx(DetailViewBindingInner, {
		...props,
		entityId,
		entity,
		dataLoading
	});
	return /* @__PURE__ */ jsx(CollectionScopeProvider, {
		collection: props.collection,
		children: content
	});
}
function DetailViewBindingInner({ path, entityId, selectedTab: selectedTabProp, collection, parentCollectionSlugs, parentEntityIds, onTabChange, onEditClick, onCloseRequest, entity, dataLoading, layout = "full_screen", barActions, barActionsStart, onShowList }) {
	const ResolvedCollectionView = useComponentOverride("Collection.View", CollectionViewBinding);
	const { t } = useTranslation();
	const context = useRebaseContext();
	const urlController = useUrlController();
	const navigate = useNavigate();
	const customizationController = useCustomizationController();
	const plugins = customizationController.plugins;
	useCollectionRegistryController();
	const { canEdit: canEditHook } = usePermissions();
	const canEdit = useMemo(() => {
		return entity ? canEditHook(collection, path, entity) : false;
	}, [
		canEditHook,
		entity,
		collection,
		path
	]);
	const [usedEntity, setUsedEntity] = useState(entity);
	useEffect(() => {
		if (entity) setUsedEntity(entity);
	}, [entity]);
	const defaultSelectedView = useMemo(() => resolveDefaultSelectedView(collection.defaultSelectedView, {
		status: "existing",
		entityId
	}), [collection, entityId]);
	const userHasChangedTab = useRef(false);
	const [selectedTab, setSelectedTab] = useState(() => {
		const val = selectedTabProp ?? defaultSelectedView ?? "__main_##Q$SC^#S6";
		return val === "edit" ? MAIN_TAB_VALUE : val;
	});
	useEffect(() => {
		const val = userHasChangedTab.current ? selectedTabProp ?? "__main_##Q$SC^#S6" : selectedTabProp ?? defaultSelectedView ?? "__main_##Q$SC^#S6";
		const target = val === "edit" ? MAIN_TAB_VALUE : val;
		if (target !== selectedTab) setSelectedTab(target);
	}, [selectedTabProp, defaultSelectedView]);
	const childViews = getAdminEntityChildViews(collection).filter((v) => !v.collection.hideFromEntityViews);
	const subcollections = childViews.map((v) => v.collection);
	const subcollectionsCount = subcollections?.length ?? 0;
	const customViews = collection.entityViews ?? [];
	const customViewsCount = customViews?.length ?? 0;
	const includeJsonView = collection.includeJsonView === void 0 ? true : collection.includeJsonView;
	const includeHistoryView = Boolean(collection.history);
	const hasAdditionalViews = customViewsCount > 0 || subcollectionsCount > 0;
	const [inspectorTab, setInspectorTab] = useState(null);
	const legacyInspectorTab = selectedTab === "__json" ? "json" : selectedTab === "__rebase_history" ? "history" : void 0;
	useEffect(() => {
		if (legacyInspectorTab) setInspectorTab(legacyInspectorTab);
	}, [legacyInspectorTab]);
	const { resolvedEntityViews } = resolvedSelectedEntityView(customViews, customizationController, void 0, canEdit);
	const activeTab = useMemo(() => {
		return /* @__PURE__ */ new Set([
			"__main_##Q$SC^#S6",
			...resolvedEntityViews.map((v) => v.key),
			...subcollections.map((s) => s.slug)
		]);
	}, [resolvedEntityViews, subcollections]).has(selectedTab) ? selectedTab : MAIN_TAB_VALUE;
	const { selectedEntityView } = resolvedSelectedEntityView(customViews, customizationController, activeTab, canEdit);
	const mainViewVisible = activeTab === MAIN_TAB_VALUE;
	const mountedTabsRef = useRef(/* @__PURE__ */ new Set());
	if (activeTab) mountedTabsRef.current.add(activeTab);
	const readOnlyFormContext = useMemo(() => {
		if (!entityId) return void 0;
		const formexStub = createFormexStub(usedEntity?.values ?? {});
		return {
			entityId,
			disabled: true,
			readOnly: true,
			openEntityMode: layout,
			status: "existing",
			values: usedEntity?.values ?? {},
			setFieldValue: () => {
				throw new Error("Cannot update values in read-only detail view");
			},
			save: () => {
				throw new Error("Cannot save in read-only detail view");
			},
			submit: () => {
				throw new Error("Cannot submit in read-only detail view");
			},
			collection,
			path,
			entity: usedEntity,
			savingError: void 0,
			formex: formexStub
		};
	}, [
		entityId,
		layout,
		usedEntity,
		collection,
		path
	]);
	const pluginActionsTop = useSlot("form.actions.top", useMemo(() => ({
		entityId,
		parentCollectionSlugs,
		parentEntityIds,
		path,
		status: "existing",
		collection,
		context,
		formContext: readOnlyFormContext,
		openEntityMode: layout,
		disabled: true
	}), [
		entityId,
		parentCollectionSlugs,
		parentEntityIds,
		path,
		collection,
		context,
		readOnlyFormContext,
		layout
	]));
	const formViewConfig = collection.formView;
	const FormViewBuilder = formViewConfig?.Builder ? resolveComponentRef(formViewConfig.Builder) : null;
	const title = useEntityDisplayTitle({
		collection,
		entity: usedEntity,
		status: "existing"
	});
	const nonActionCustomViews = useMemo(() => resolvedEntityViews.filter((e) => !e.includeActions), [resolvedEntityViews]);
	const customViewsView = customViews && nonActionCustomViews.map((customView) => {
		if (!customView) return null;
		const Builder = resolveComponentRef(customView.Builder);
		if (!Builder) return null;
		if (!entityId) return null;
		const isActive = activeTab === customView.key;
		const hasBeenMounted = mountedTabsRef.current.has(customView.key);
		if (!isActive && !hasBeenMounted) return null;
		return /* @__PURE__ */ jsx("div", {
			className: cls(defaultBorderMixin, "relative flex-1 w-full h-full overflow-auto", { "hidden": !isActive }),
			role: "tabpanel",
			children: /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(Suspense, {
				fallback: /* @__PURE__ */ jsx(CircularProgressCenter, {}),
				children: readOnlyFormContext && /* @__PURE__ */ jsx(Builder, {
					collection,
					parentCollectionSlugs,
					parentEntityIds,
					entity: usedEntity,
					modifiedValues: usedEntity?.values,
					formContext: readOnlyFormContext
				})
			}) })
		}, `custom_view_${customView.key}`);
	}).filter(Boolean);
	const globalLoading = dataLoading && !usedEntity;
	const subCollectionsViews = childViews && childViews.map(({ collection: subcollection }) => {
		const subcollectionId = subcollection.slug;
		const newFullPath = usedEntity ? `${path}/${usedEntity?.id}/${removeInitialAndTrailingSlashes(getCollectionDataPath(subcollection))}` : void 0;
		if (activeTab !== subcollectionId) return null;
		return /* @__PURE__ */ jsxs("div", {
			className: "relative flex-1 h-full overflow-auto w-full",
			role: "tabpanel",
			children: [globalLoading && /* @__PURE__ */ jsx(CircularProgressCenter, {}), !globalLoading && (usedEntity && newFullPath ? /* @__PURE__ */ jsx(ResolvedCollectionView, {
				path: newFullPath,
				parentCollectionSlugs: [...parentCollectionSlugs, collection.slug],
				parentEntityIds: [...parentEntityIds, String(usedEntity?.id)],
				updateUrl: false,
				...subcollection,
				openEntityMode: layout
			}) : /* @__PURE__ */ jsx("div", {
				className: "flex items-center justify-center w-full h-full p-3",
				children: /* @__PURE__ */ jsx(Typography, {
					variant: "label",
					children: t("save_entity_before_subcollections")
				})
			}))]
		}, `subcol_${subcollectionId}`);
	}).filter(Boolean);
	const onSideTabClick = useCallback((value) => {
		userHasChangedTab.current = true;
		setSelectedTab(value);
		onTabChange?.({
			path,
			entityId,
			selectedTab: value === "__main_##Q$SC^#S6" ? void 0 : value,
			collection
		});
	}, [
		onTabChange,
		path,
		entityId,
		collection
	]);
	const propertyDetailView = () => {
		if (FormViewBuilder && usedEntity) return /* @__PURE__ */ jsx("div", {
			className: "@container/form flex-1 min-w-0 overflow-y-auto flex justify-center items-start",
			children: /* @__PURE__ */ jsx("div", {
				className: cls("w-full max-w-3xl @7xl/form:max-w-4xl 2xl:max-w-4xl flex flex-col", layout === "dialog" ? "pt-5 pb-12 px-6 sm:px-8" : "pt-6 pb-16 px-5 sm:px-8"),
				children: /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(Suspense, {
					fallback: /* @__PURE__ */ jsx(CircularProgressCenter, {}),
					children: /* @__PURE__ */ jsx(FormViewBuilder, {
						collection,
						parentCollectionSlugs,
						parentEntityIds,
						entity: usedEntity,
						modifiedValues: usedEntity?.values,
						formContext: readOnlyFormContext
					})
				}) })
			})
		});
		return /* @__PURE__ */ jsx(Fragment, { children: usedEntity && /* @__PURE__ */ jsx(EntityViewBinding, {
			entity: usedEntity,
			collection,
			path,
			asPage: true,
			openEntityMode: layout,
			formContext: readOnlyFormContext
		}) });
	};
	const subcollectionTabs = subcollections && subcollections.map((subcollection) => {
		const icon = getIcon(subcollection.icon, void 0, void 0, "smallest");
		return /* @__PURE__ */ jsx(Tab, {
			className: cls("h-full", "text-sm min-w-[90px]"),
			value: subcollection.slug,
			children: /* @__PURE__ */ jsxs("span", {
				className: "flex items-center gap-1.5",
				children: [icon, subcollection.name]
			})
		}, `entity_detail_collection_tab_${subcollection.name}`);
	});
	const customViewTabsStart = resolvedEntityViews.filter((view) => view.position === "start").map((view) => {
		const icon = getIcon(view.icon, void 0, void 0, "smallest");
		return /* @__PURE__ */ jsx(Tab, {
			className: cls(ENTITY_VIEW_TAB_CLASS, !view.tabComponent && "text-sm min-w-[90px]"),
			value: view.key,
			children: view.tabComponent ?? /* @__PURE__ */ jsxs("span", {
				className: "flex items-center gap-1.5",
				children: [icon, view.name]
			})
		}, `entity_detail_collection_tab_${view.name}`);
	});
	const customViewTabsEnd = resolvedEntityViews.filter((view) => !view.position || view.position === "end").map((view) => {
		const icon = getIcon(view.icon, void 0, void 0, "smallest");
		return /* @__PURE__ */ jsx(Tab, {
			className: cls(ENTITY_VIEW_TAB_CLASS, !view.tabComponent && "text-sm min-w-[90px]"),
			value: view.key,
			children: view.tabComponent ?? /* @__PURE__ */ jsxs("span", {
				className: "flex items-center gap-1.5",
				children: [icon, view.name]
			})
		}, `entity_detail_collection_tab_${view.name}`);
	});
	const collectionUrl = withViewMode(urlController.buildUrlCollectionPath(path));
	const backToCollection = layout === "full_screen" && !onShowList ? () => navigate(collectionUrl) : void 0;
	const fullScreenButton = !barActions && (layout === "side_panel" || layout === "dialog") && entityId ? /* @__PURE__ */ jsx(Tooltip, {
		title: "Open full screen",
		children: /* @__PURE__ */ jsx(IconButton, {
			size: "small",
			onClick: () => {
				const entityUrl = urlController.buildUrlCollectionPath(`${path}/${entityId}`);
				navigate(`${entityUrl}#full`);
			},
			children: /* @__PURE__ */ jsx(Maximize2Icon, { size: iconSize.smallest })
		})
	}) : null;
	const editButton = canEdit && onEditClick ? /* @__PURE__ */ jsx(Button, {
		variant: "filled",
		color: "primary",
		size: "small",
		startIcon: /* @__PURE__ */ jsx(PencilIcon, { size: iconSize.smallest }),
		onClick: onEditClick,
		children: t("edit_entity")
	}) : null;
	const mainView = /* @__PURE__ */ jsx("div", {
		className: cls("flex-1 flex flex-row w-full min-h-0", !mainViewVisible ? "hidden" : ""),
		children: propertyDetailView()
	});
	let result = /* @__PURE__ */ jsxs("div", {
		className: "relative flex flex-col h-full w-full bg-surface-card",
		children: [
			/* @__PURE__ */ jsx(EntityIdentityBar, {
				collection,
				collectionUrl: layout === "full_screen" || layout === "split" ? collectionUrl : void 0,
				title,
				entityId,
				status: "existing",
				dirty: false,
				saving: false,
				onBack: backToCollection,
				onClose: onCloseRequest,
				onInspect: includeJsonView ? () => setInspectorTab("json") : void 0,
				onViewHistory: includeHistoryView ? () => setInspectorTab("history") : void 0,
				externalLink: usedEntity ? customizationController?.entityLinkBuilder?.({ entity: usedEntity }) : void 0,
				leading: /* @__PURE__ */ jsxs(Fragment, { children: [
					barActionsStart,
					layout === "split" && /* @__PURE__ */ jsx(SplitListCloseButton, {}),
					layout === "full_screen" && onShowList && /* @__PURE__ */ jsx(SplitListShowButton, { onClick: onShowList })
				] }),
				trailing: /* @__PURE__ */ jsxs(Fragment, { children: [
					editButton,
					pluginActionsTop,
					fullScreenButton,
					barActions?.({
						path,
						entityId,
						values: usedEntity?.values ?? {},
						status: "existing",
						dirty: false
					})
				] })
			}),
			hasAdditionalViews && /* @__PURE__ */ jsx("div", {
				className: cls("h-10 shrink-0 flex items-stretch border-b px-2 min-w-0", "bg-surface-sheet", defaultBorderMixin),
				children: /* @__PURE__ */ jsxs(Tabs, {
					className: "!w-full items-stretch",
					innerClassName: "h-full",
					variant: "boxy",
					value: activeTab,
					onValueChange: (value) => {
						onSideTabClick(value);
					},
					children: [
						customViewTabsStart,
						/* @__PURE__ */ jsx(Tab, {
							value: "__main_##Q$SC^#S6",
							className: cls("h-full", "text-sm min-w-[90px]"),
							children: /* @__PURE__ */ jsxs("span", {
								className: "flex items-center gap-1.5",
								children: [getIcon(collection.icon, void 0, void 0, "smallest"), collection.singularName ?? collection.name]
							})
						}),
						customViewTabsEnd,
						subcollectionTabs
					]
				})
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "flex-1 min-h-0 flex",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "flex-1 min-w-0 flex flex-col",
					children: [
						globalLoading ? /* @__PURE__ */ jsx(DetailViewSkeleton, { collection }) : mainView,
						customViewsView,
						subCollectionsViews
					]
				}), /* @__PURE__ */ jsx(EntityInspector, {
					tab: inspectorTab,
					onTabChange: setInspectorTab,
					onClose: () => setInspectorTab(null),
					collection,
					entity: usedEntity,
					formContext: readOnlyFormContext,
					values: usedEntity?.values,
					includeHistory: includeHistoryView
				})]
			})
		]
	});
	if (plugins && plugins.length > 0) result = /* @__PURE__ */ jsx(PluginProviderStack, {
		plugins,
		scope: "form",
		scopeProps: {
			status: "existing",
			path,
			collection,
			entity: usedEntity,
			context,
			formContext: readOnlyFormContext
		},
		children: result
	});
	return result;
}
function DetailViewSkeleton({ collection }) {
	return /* @__PURE__ */ jsx("div", {
		className: "flex-1 flex flex-row w-full overflow-y-auto justify-center",
		children: /* @__PURE__ */ jsx("div", {
			className: "relative flex flex-row max-w-4xl lg:max-w-3xl xl:max-w-4xl 2xl:max-w-6xl w-full h-fit",
			children: /* @__PURE__ */ jsxs("div", {
				className: "flex flex-col w-full pt-12 pb-16 px-4 sm:px-8 md:px-10",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "w-full flex flex-col items-start my-4 lg:my-6",
					children: [/* @__PURE__ */ jsx("div", {
						className: `py-1 my-4 w-2/3 ${collection.hideIdFromForm ? "mb-6" : ""}`,
						children: /* @__PURE__ */ jsx(Skeleton, {
							height: 28,
							className: "w-full rounded-md"
						})
					}), /* @__PURE__ */ jsx(Skeleton, {
						height: 32,
						className: "w-full rounded-md"
					})]
				}), /* @__PURE__ */ jsx("div", {
					className: "mt-12 flex flex-col gap-8",
					children: /* @__PURE__ */ jsxs("div", {
						className: "flex flex-wrap gap-x-4 w-full space-y-8",
						children: [
							/* @__PURE__ */ jsx("div", {
								className: "relative w-full",
								children: /* @__PURE__ */ jsx(Skeleton, {
									height: 60,
									className: "w-full rounded-md"
								})
							}),
							/* @__PURE__ */ jsx("div", {
								className: "relative w-full",
								children: /* @__PURE__ */ jsx(Skeleton, {
									height: 60,
									className: "w-full rounded-md"
								})
							}),
							/* @__PURE__ */ jsx("div", {
								className: "relative w-full",
								children: /* @__PURE__ */ jsx(Skeleton, {
									height: 60,
									className: "w-full rounded-md"
								})
							}),
							/* @__PURE__ */ jsx("div", {
								className: "relative w-full",
								children: /* @__PURE__ */ jsx(Skeleton, {
									height: 60,
									className: "w-full rounded-md"
								})
							})
						]
					})
				})]
			})
		})
	});
}
//#endregion
//#region src/components/CollectionViewBinding/SplitListView.tsx
var PANEL_SIZE_KEY = "rebase_split_list_panel_size";
/**
* Whether the element accepts text, and therefore owns the keystroke.
* Covers native fields plus the ARIA roles custom editors expose.
*/
function isTextEntryTarget(target) {
	if (!target) return false;
	const tag = target.tagName;
	if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
	if (target.isContentEditable) return true;
	return Boolean(target.closest("[contenteditable=\"true\"], [role=\"textbox\"], [role=\"combobox\"], [role=\"searchbox\"]"));
}
/**
* Whether a bare letter shortcut may act on this target. Only the list side of
* the split owns them — inside the detail panel a keystroke belongs to the form.
*/
function isListShortcutTarget(target, detailPanel) {
	if (!target || target === document.body) return true;
	return !detailPanel?.contains(target);
}
/**
* The list's share of the split, as a percentage, before anyone drags it.
*
* The list only has to identify a record — a title, a subtitle and a status
* chip — while the detail beside it carries the whole record and its rail. At
* 30% the list was taking width from the side that had four columns of fields
* to lay out; 26% still was, by about the width of one field.
*
* A default, not a constraint: {@link savePanelSize} remembers the drag per
* collection, so anyone who has already sized this list keeps their size. The
* drag floor is `minPanelSizePx`, and it holds below ~1100px of split — at that
* width this percentage is already the floor.
*/
var DEFAULT_PANEL_SIZE = 22;
function getSavedPanelSize(path) {
	try {
		const saved = localStorage.getItem(`${PANEL_SIZE_KEY}_${path}`);
		if (saved !== null) {
			const val = parseFloat(saved);
			if (!isNaN(val) && val > 0 && val < 100) return val;
		}
	} catch {}
	return DEFAULT_PANEL_SIZE;
}
function savePanelSize(path, size) {
	try {
		localStorage.setItem(`${PANEL_SIZE_KEY}_${path}`, size.toString());
	} catch {}
}
/**
* Master-detail split view.
* Shows the list on the left and the entity edit view on the right.
*
* Animation approach:
* - The list always renders at full width.
* - When a detail opens, the list shrinks to `panelSize%` and the detail slides in.
* - On close, the reverse plays.
*
* State management:
* - The selected entity is driven by the URL path (e.g. /c/authors/14).
*   `selectedEntityId` comes from props via RebaseRoute, NOT from internal state.
* - Clicking a entity navigates to /c/authors/{id} via the standard onEntityClick handler.
* - Closing the detail navigates back to /c/authors.
*/
function SplitListView({ collection, tableController, onEntityClick: externalOnEntityClick, onNewClick: externalOnNewClick, selectionController, selectionEnabled = true, highlightedEntities, emptyComponent, onScroll, initialScroll, size = "m", path, parentCollectionSlugs, parentEntityIds, selectedEntityId, selectedTab, toolbar, children }) {
	const largeLayout = useLargeLayout();
	const collectionRegistryController = useCollectionRegistryController();
	const location = useLocation();
	const isEditMode = location.pathname.endsWith("/edit") || location.pathname.split("/").pop() === "edit";
	const navigate = useNavigate();
	const urlController = useUrlController();
	const dirty = useRef(false);
	const detailPanelRef = useRef(null);
	const setDirty = useCallback((modified) => {
		dirty.current = modified;
	}, []);
	const previousEntityId = useRef(selectedEntityId);
	useEffect(() => {
		if (previousEntityId.current === selectedEntityId) return;
		previousEntityId.current = selectedEntityId;
		dirty.current = false;
	}, [selectedEntityId]);
	const blocker = useNavigationBlocker(useCallback(({ currentLocation, nextLocation }) => {
		if (!dirty.current) return false;
		if (currentLocation.pathname === nextLocation.pathname) return false;
		const nextHash = nextLocation.hash;
		if (nextHash === "#side" || nextHash === "#new_side") return false;
		const currentHash = currentLocation.hash;
		if (currentHash === "#side" || currentHash === "#new_side") return false;
		return true;
	}, []));
	const [panelSize, setPanelSize] = useState(() => getSavedPanelSize(path));
	const handlePanelSizeChange = useCallback((size) => {
		setPanelSize(size);
		savePanelSize(path, size);
	}, [path]);
	const [renderedEntityId, setRenderedEntityId] = useState(selectedEntityId);
	const [animationPhase, setAnimationPhase] = useState(selectedEntityId !== void 0 ? "entered" : "idle");
	const animationTimer = useRef(null);
	const TRANSITION_DURATION = 150;
	useEffect(() => {
		if (animationTimer.current) {
			clearTimeout(animationTimer.current);
			animationTimer.current = null;
		}
		if (selectedEntityId !== void 0) {
			setRenderedEntityId(selectedEntityId);
			if (animationPhase === "idle" || animationPhase === "exiting") {
				setAnimationPhase("entering");
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						setAnimationPhase("entered");
					});
				});
			}
		} else if (animationPhase === "entered" || animationPhase === "entering") {
			setAnimationPhase("exiting");
			animationTimer.current = setTimeout(() => {
				setAnimationPhase("idle");
				setRenderedEntityId(void 0);
			}, TRANSITION_DURATION);
		}
		return () => {
			if (animationTimer.current) clearTimeout(animationTimer.current);
		};
	}, [selectedEntityId]);
	const buildUrl = useCallback((subPath) => {
		return withViewMode(urlController.buildUrlCollectionPath(subPath));
	}, [urlController]);
	const handleCloseDetail = useCallback(() => {
		navigate(buildUrl(path));
	}, [
		navigate,
		buildUrl,
		path
	]);
	const entityIds = useMemo(() => tableController.data.map((e) => e.id), [tableController.data]);
	useEffect(() => {
		const handleKeyDown = (e) => {
			const target = e.target;
			if (document.querySelector("[role=\"dialog\"][data-state=\"open\"]")) return;
			if (e.key === "Escape") {
				if (!selectedEntityId) return;
				if (isTextEntryTarget(target)) {
					target?.blur();
					e.preventDefault();
					return;
				}
				handleCloseDetail();
				e.preventDefault();
				return;
			}
			if (!isListShortcutTarget(target, detailPanelRef.current)) return;
			if (isTextEntryTarget(target)) return;
			if ((e.key === "ArrowDown" || e.key === "j") && !e.metaKey && !e.ctrlKey) {
				e.preventDefault();
				if (entityIds.length === 0) return;
				if (selectedEntityId === void 0) {
					const firstEntity = tableController.data[0];
					if (firstEntity) externalOnEntityClick?.(firstEntity);
				} else {
					const currentIndex = entityIds.indexOf(selectedEntityId);
					if (currentIndex >= 0 && currentIndex < entityIds.length - 1) {
						const nextEntity = tableController.data[currentIndex + 1];
						if (nextEntity) externalOnEntityClick?.(nextEntity);
					}
				}
				return;
			}
			if ((e.key === "ArrowUp" || e.key === "k") && !e.metaKey && !e.ctrlKey) {
				e.preventDefault();
				if (entityIds.length === 0) return;
				if (selectedEntityId === void 0) {
					const lastEntity = tableController.data[tableController.data.length - 1];
					if (lastEntity) externalOnEntityClick?.(lastEntity);
				} else {
					const currentIndex = entityIds.indexOf(selectedEntityId);
					if (currentIndex > 0) {
						const prevEntity = tableController.data[currentIndex - 1];
						if (prevEntity) externalOnEntityClick?.(prevEntity);
					}
				}
				return;
			}
			if (e.key === "n" && !e.metaKey && !e.ctrlKey && !e.altKey) {
				externalOnNewClick?.();
				e.preventDefault();
				return;
			}
		};
		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [
		selectedEntityId,
		handleCloseDetail,
		externalOnEntityClick,
		externalOnNewClick,
		entityIds,
		tableController.data
	]);
	const usedParentCollectionIds = parentCollectionSlugs ?? collectionRegistryController.getParentCollectionSlugs(path);
	const usedParentEntityIds = parentEntityIds ?? collectionRegistryController.getParentEntityIds(path);
	const isDetailVisible = animationPhase !== "idle";
	const listPanel = /* @__PURE__ */ jsxs("div", {
		className: cls("flex flex-col h-full min-w-0 transition-all ease-out w-full", !largeLayout && isDetailVisible ? "opacity-0 -translate-x-1/3 pointer-events-none" : "opacity-100 translate-x-0"),
		style: { transitionDuration: `${TRANSITION_DURATION}ms` },
		children: [toolbar, /* @__PURE__ */ jsx("div", {
			className: "flex-1 overflow-y-auto overflow-x-hidden min-h-0",
			children
		})]
	});
	const detailPanel = renderedEntityId !== void 0 ? /* @__PURE__ */ jsx("div", {
		ref: detailPanelRef,
		className: cls("flex-1 flex flex-col min-w-0 h-full transition-all ease-out w-full", largeLayout && "border-l border-hairline", animationPhase === "entered" ? "opacity-100 translate-x-0" : largeLayout ? "opacity-0 translate-x-8" : "opacity-0 translate-x-1/3"),
		style: { transitionDuration: `${TRANSITION_DURATION}ms` },
		children: /* @__PURE__ */ jsx(ErrorBoundary, { children: collection.defaultEntityAction === "view" && !isEditMode ? /* @__PURE__ */ jsx(DetailViewBinding, {
			path,
			collection,
			entityId: renderedEntityId,
			parentCollectionSlugs: usedParentCollectionIds,
			parentEntityIds: usedParentEntityIds,
			selectedTab,
			layout: "split",
			onCloseRequest: handleCloseDetail,
			onEditClick: () => {
				navigate(buildUrl(`${path}/${renderedEntityId}/edit`));
			},
			onTabChange: (params) => {
				const newSelectedTab = params.selectedTab;
				navigate(buildUrl(newSelectedTab ? `${path}/${renderedEntityId}/${newSelectedTab}` : `${path}/${renderedEntityId}`));
			}
		}, String(renderedEntityId)) : /* @__PURE__ */ jsx(EditViewBinding, {
			path,
			collection,
			entityId: renderedEntityId,
			parentCollectionSlugs: usedParentCollectionIds,
			parentEntityIds: usedParentEntityIds,
			selectedTab,
			layout: "split",
			onCloseRequest: handleCloseDetail,
			onValuesModified: setDirty,
			onSaved: () => {
				setDirty(false);
				navigate(buildUrl(`${path}/${renderedEntityId}`), { replace: true });
			},
			navigateBack: () => {
				navigate(buildUrl(`${path}/${renderedEntityId}`));
			},
			onTabChange: (params) => {
				const newSelectedTab = params.selectedTab;
				navigate(buildUrl(newSelectedTab ? `${path}/${renderedEntityId}/${newSelectedTab}` : `${path}/${renderedEntityId}`));
			}
		}, String(renderedEntityId)) })
	}) : /* @__PURE__ */ jsx(Fragment, {});
	const openFullScreen = useCallback(() => {
		if (selectedEntityId === void 0) return;
		navigate(`${buildUrl(`${path}/${selectedEntityId}${isEditMode ? "/edit" : ""}`)}#full`);
	}, [
		navigate,
		buildUrl,
		path,
		selectedEntityId,
		isEditMode
	]);
	return /* @__PURE__ */ jsxs(SplitViewProvider, {
		value: useMemo(() => ({
			detailOpen: selectedEntityId !== void 0,
			openFullScreen
		}), [selectedEntityId, openFullScreen]),
		children: [/* @__PURE__ */ jsx(ResizablePanels, {
			stacked: !largeLayout,
			firstPanel: listPanel,
			secondPanel: detailPanel,
			showSecondPanel: isDetailVisible,
			panelSizePercent: animationPhase === "entering" ? 100 : panelSize,
			onPanelSizeChange: handlePanelSizeChange,
			minPanelSizePx: 240
		}), /* @__PURE__ */ jsx(UnsavedChangesDialog, {
			open: blocker?.state === "blocked",
			handleOk: () => {
				dirty.current = false;
				blocker?.proceed?.();
			},
			handleCancel: () => blocker?.reset?.(),
			body: /* @__PURE__ */ jsxs(Fragment, { children: [
				"You have unsaved changes in this ",
				/* @__PURE__ */ jsx("b", { children: collection.singularName ?? collection.name }),
				"."
			] })
		})]
	});
}
//#endregion
//#region src/components/CollectionViewBinding/BoardCardBinding.tsx
/**
* Compact card component for displaying a entity in a Kanban board.
* Uses the shared slot system for consistent preview rendering.
*
* Selection UX: The checkbox overlays on top of the image/icon thumbnail area,
* revealed on card hover or when the card is selected. This keeps the card
* layout clean while providing intuitive selection affordance.
*/
function BoardCardBindingInner({ item, isDragging, isGroupedOver, style, collection, onClick, selected, onSelectionChange, selectionEnabled = false }) {
	const entity = item.data;
	const slots = useEntitySlots(entity, collection, useCollectionSlotKeys(collection, useAuthController(), useCustomizationController().propertyConfigs));
	const handleClick = useCallback((e) => {
		if ((e.metaKey || e.ctrlKey) && selectionEnabled) {
			e.preventDefault();
			e.stopPropagation();
			onSelectionChange?.(entity, !selected);
			return;
		}
		if (onClick) {
			e.stopPropagation();
			onClick(entity);
		}
	}, [
		entity,
		onClick,
		onSelectionChange,
		selected,
		selectionEnabled
	]);
	const handleThumbnailClick = useCallback((e) => {
		if (!selectionEnabled) return;
		e.stopPropagation();
		e.preventDefault();
		onSelectionChange?.(entity, !selected);
	}, [
		entity,
		onSelectionChange,
		selected,
		selectionEnabled
	]);
	const handleSelectionChange = useCallback((checked) => {
		onSelectionChange?.(entity, checked);
	}, [entity, onSelectionChange]);
	const backgroundColor = useMemo(() => {
		if (isDragging) return "bg-surface-raised";
		if (isGroupedOver) return "bg-surface-raised";
		return "bg-surface-card hover:bg-surface-hover";
	}, [isDragging, isGroupedOver]);
	const borderColor = useMemo(() => isDragging ? "ring-2 ring-primary" : "", [isDragging]);
	const cardClassName = useMemo(() => cls("group/card p-2 flex items-start border rounded-lg cursor-pointer transition-all duration-200", defaultBorderMixin, borderColor, backgroundColor, selected ? "ring-2 ring-primary bg-primary/[0.03] dark:bg-primary/[0.06]" : "hover:shadow-sm"), [
		borderColor,
		backgroundColor,
		selected
	]);
	return /* @__PURE__ */ jsx("div", {
		style,
		className: "py-1",
		"data-is-dragging": isDragging,
		"data-testid": item.id,
		onClick: handleClick,
		children: /* @__PURE__ */ jsxs("div", {
			className: cardClassName,
			children: [/* @__PURE__ */ jsxs("div", {
				className: "relative w-10 h-10 rounded-md shrink-0 mr-2",
				onClick: handleThumbnailClick,
				children: [slots.image ? /* @__PURE__ */ jsx("div", {
					className: cls("w-10 h-10 rounded-md overflow-hidden transition-opacity duration-200", selectionEnabled && "group-hover/card:opacity-30", selected && "opacity-0"),
					children: /* @__PURE__ */ jsx(SlotValue, {
						slot: slots.image,
						size: "small",
						fill: true
					})
				}) : /* @__PURE__ */ jsx("div", {
					className: cls("w-10 h-10 rounded-md bg-surface-raised flex items-center justify-center transition-opacity duration-200", selectionEnabled && "group-hover/card:opacity-30", selected && "opacity-0"),
					children: /* @__PURE__ */ jsx(IconForView, {
						collectionOrView: collection,
						color: "disabled",
						size: "small"
					})
				}), /* @__PURE__ */ jsx("div", {
					className: cls("absolute inset-0 flex items-center justify-center rounded-md transition-[opacity,background-color] duration-200", !selectionEnabled && "invisible pointer-events-none", selectionEnabled && (selected ? "opacity-100 bg-primary/10 dark:bg-primary/20" : "opacity-0 group-hover/card:opacity-100")),
					children: /* @__PURE__ */ jsx("div", {
						className: cls("transition-transform duration-200", selected ? "scale-100" : "scale-75 group-hover/card:scale-100"),
						children: /* @__PURE__ */ jsx(Checkbox, {
							checked: selected ?? false,
							onCheckedChange: handleSelectionChange,
							size: "small",
							padding: false
						})
					})
				})]
			}), /* @__PURE__ */ jsxs("div", {
				className: "flex-1 min-w-0",
				children: [
					/* @__PURE__ */ jsx("div", {
						className: "line-clamp-2 text-sm font-medium",
						children: slots.title ? /* @__PURE__ */ jsx(SlotValue, {
							slot: slots.title,
							size: "small"
						}) : /* @__PURE__ */ jsx("span", {
							className: "text-surface-500",
							children: entity.id
						})
					}),
					slots.subtitle ? /* @__PURE__ */ jsx("div", {
						className: "text-xs text-surface-500 mt-1 line-clamp-3 opacity-80",
						children: typeof slots.subtitle.value === "string" ? /* @__PURE__ */ jsx(Markdown, {
							source: slots.subtitle.value,
							size: "small"
						}) : /* @__PURE__ */ jsx(SlotValue, {
							slot: slots.subtitle,
							size: "small"
						})
					}) : /* @__PURE__ */ jsx("div", {
						className: "text-xs text-surface-500 font-mono truncate mt-1",
						children: entity.id
					}),
					slots.relations.length > 0 && /* @__PURE__ */ jsxs("div", {
						className: "flex items-center gap-1 mt-1 overflow-hidden max-w-full flex-wrap",
						children: [slots.relations.map((rel) => rel.items.map((item) => /* @__PURE__ */ jsx(Chip, {
							size: "smallest",
							colorScheme: rel.colorScheme,
							className: "!text-[10px] !leading-tight !py-0 shrink-0 max-w-[90px] truncate",
							children: item.displayName
						}, `${rel.propertyKey}-${item.id}`))), slots.relations.some((r) => r.totalCount > r.items.length) && /* @__PURE__ */ jsxs("span", {
							className: "text-[10px] text-surface-400 dark:text-surface-500 shrink-0",
							children: ["+", slots.relations.reduce((acc, r) => acc + Math.max(0, r.totalCount - r.items.length), 0)]
						})]
					}),
					slots.tags && /* @__PURE__ */ jsx("div", {
						className: "flex items-center gap-1 mt-1 flex-wrap",
						children: /* @__PURE__ */ jsx(TagChips, {
							slot: slots.tags,
							max: 3
						})
					}),
					slots.date && /* @__PURE__ */ jsx("div", {
						className: "text-[10px] text-surface-500 dark:text-surface-400 mt-1",
						children: slots.date.formatted
					})
				]
			})]
		})
	});
}
var BoardCardBinding = memo(BoardCardBindingInner);
//#endregion
//#region src/components/CollectionViewBinding/useBoardDataController.tsx
var DEFAULT_PAGE_SIZE$1 = 20;
/**
* How long a column waits for its subscription's first payload before reading
* once over HTTP instead. Long enough that a healthy socket always wins the
* race, short enough that a dead one does not hold a blank board.
*/
var LIVE_FIRST_PAINT_TIMEOUT_MS = 2500;
/**
* Shallow equality for entity value records.
* Handles primitives and reference equality for nested values.
* Avoids JSON.stringify allocation on every comparison.
*/
function shallowEqualValues(a, b) {
	if (a === b) return true;
	if (!a || !b) return false;
	const keysA = Object.keys(a);
	const keysB = Object.keys(b);
	if (keysA.length !== keysB.length) return false;
	for (const key of keysA) if (a[key] !== b[key]) return false;
	return true;
}
/**
* Hook that manages per-column data loading for the Kanban board.
* Each column gets its own independent query to the data source.
*/
function useBoardDataController({ fullPath, collection, columnProperty, columns, orderProperty, pageSize = DEFAULT_PAGE_SIZE$1, searchString, filterValues }) {
	const context = useRebaseContext();
	const dataClient = useData();
	const resolvedPath = fullPath;
	const dataClientRef = useRef(dataClient);
	const collectionRef = useRef(collection);
	const contextRef = useRef(context);
	dataClientRef.current = dataClient;
	collectionRef.current = collection;
	contextRef.current = context;
	const filterValuesRef = useRef(filterValues);
	const columnPropertyRef = useRef(columnProperty);
	const orderPropertyRef = useRef(orderProperty);
	const searchStringRef = useRef(searchString);
	const resolvedPathRef = useRef(resolvedPath);
	filterValuesRef.current = filterValues;
	columnPropertyRef.current = columnProperty;
	orderPropertyRef.current = orderProperty;
	searchStringRef.current = searchString;
	resolvedPathRef.current = resolvedPath;
	const [columnItemCounts, setColumnItemCounts] = useState(() => {
		const initial = {};
		columns.forEach((col) => {
			initial[col] = pageSize;
		});
		return initial;
	});
	const [columnData, setColumnData] = useState(() => {
		const initial = {};
		columns.forEach((col) => {
			initial[col] = {
				entities: [],
				loading: true,
				hasMore: true,
				error: void 0,
				totalCount: void 0
			};
		});
		return initial;
	});
	const unsubscribersRef = useRef({});
	const isCleaningUpRef = useRef(false);
	const pendingItemsRef = useRef({});
	const columnsKey = useMemo(() => [...columns].sort().join(","), [columns]);
	const filterKey = useMemo(() => JSON.stringify(filterValues), [filterValues]);
	const prevColumnItemCountsRef = useRef(columnItemCounts);
	const [subscriptionVersion, setSubscriptionVersion] = useState(0);
	useEffect(() => {
		setSubscriptionVersion((v) => v + 1);
	}, [
		columnsKey,
		resolvedPath,
		columnProperty,
		orderProperty,
		searchString,
		filterKey,
		pageSize
	]);
	useEffect(() => {
		return () => {
			isCleaningUpRef.current = true;
			Object.values(unsubscribersRef.current).forEach((unsub) => unsub?.());
			unsubscribersRef.current = {};
		};
	}, []);
	/**
	* Check if a column value is excluded by the active filter on the columnProperty.
	* E.g. if the user sets "Status IN (Open, In Progress)", this returns true
	* for "Waiting on Customer" since that column should show as empty.
	*/
	const isColumnExcludedByFilter = useCallback((column, filterValues, colProperty) => {
		if (!filterValues || !colProperty) return false;
		const filterForColumn = filterValues[colProperty];
		if (!filterForColumn || !Array.isArray(filterForColumn)) return false;
		const [op, val] = filterForColumn;
		if (op === "==" && typeof val === "string") return column !== val;
		if (op === "!=" && typeof val === "string") return column === val;
		if (op === "in" && Array.isArray(val)) return !val.map(String).includes(column);
		if (op === "not-in" && Array.isArray(val)) return val.map(String).includes(column);
		return false;
	}, []);
	const subscribeToColumn = useCallback((column, itemCount) => {
		if (isCleaningUpRef.current) return;
		const requestedCount = Math.min(itemCount, MAX_LIST_LIMIT);
		const currentDataClient = dataClientRef.current;
		const currentCollection = collectionRef.current;
		const currentContext = contextRef.current;
		const currentFilterValues = filterValuesRef.current;
		const currentColumnProperty = columnPropertyRef.current;
		const currentOrderProperty = orderPropertyRef.current;
		const currentSearchString = searchStringRef.current;
		const currentResolvedPath = resolvedPathRef.current;
		if (isColumnExcludedByFilter(column, currentFilterValues, currentColumnProperty)) {
			setColumnData((prev) => ({
				...prev,
				[column]: {
					entities: [],
					loading: false,
					hasMore: false,
					error: void 0,
					totalCount: 0
				}
			}));
			return;
		}
		const whereFilter = {
			...currentFilterValues ?? {},
			[currentColumnProperty]: ["==", column]
		};
		const orderByParam = currentOrderProperty ? [currentOrderProperty, "asc"] : void 0;
		setColumnData((prev) => ({
			...prev,
			[column]: {
				...prev[column],
				loading: true,
				error: void 0
			}
		}));
		const onUpdate = async (entities) => {
			if (isCleaningUpRef.current) return;
			const pendingMap = pendingItemsRef.current;
			const mergedEntities = entities.map((e) => {
				const pending = pendingMap[String(e.id)];
				if (pending) {
					const expectedCol = pending.expectedValues[currentColumnProperty];
					const expectedOrder = currentOrderProperty ? pending.expectedValues[currentOrderProperty] : void 0;
					let caughtUp = true;
					if (e.values?.[currentColumnProperty] !== expectedCol) caughtUp = false;
					if (currentOrderProperty && e.values?.[currentOrderProperty] !== expectedOrder) caughtUp = false;
					if (caughtUp) {
						delete pendingMap[String(e.id)];
						return e;
					}
					return {
						...e,
						values: {
							...e.values,
							...pending.expectedValues
						}
					};
				}
				return e;
			});
			Object.values(pendingMap).forEach((pending) => {
				if (pending.expectedValues[currentColumnProperty] === column) {
					if (!mergedEntities.some((e) => String(e.id) === String(pending.entity.id))) mergedEntities.push(pending.entity);
				}
			});
			let processed = mergedEntities.filter((e) => e.values?.[currentColumnProperty] === column);
			if (currentOrderProperty) processed = [...processed].sort((a, b) => {
				const valA = a.values?.[currentOrderProperty];
				const valB = b.values?.[currentOrderProperty];
				const isAEmpty = valA === void 0 || valA === null || valA === "";
				const isBEmpty = valB === void 0 || valB === null || valB === "";
				if (isAEmpty && isBEmpty) return 0;
				if (isAEmpty) return 1;
				if (isBEmpty) return -1;
				return valA < valB ? -1 : valA > valB ? 1 : 0;
			});
			if (currentCollection.browserCallbacks?.afterRead) try {
				processed = await Promise.all(processed.map(async (entity) => {
					const processedRow = await currentCollection.browserCallbacks.afterRead({
						collection: currentCollection,
						path: currentResolvedPath,
						row: {
							id: entity.id,
							...entity.values
						},
						context: currentContext
					});
					return {
						...entity,
						values: processedRow
					};
				}));
			} catch (e) {
				console.error("Error in afterRead callback:", e);
			}
			const newHasMore = entities.length >= itemCount;
			setColumnData((prev) => {
				const existing = prev[column];
				if (existing && !existing.loading && existing.entities.length === processed.length) {
					let identical = true;
					for (let i = 0; i < processed.length; i++) {
						const a = existing.entities[i];
						const b = processed[i];
						if (a.id !== b.id) {
							identical = false;
							break;
						}
						if (!shallowEqualValues(a.values, b.values)) {
							identical = false;
							break;
						}
					}
					if (identical && existing.hasMore === newHasMore) return prev;
				}
				return {
					...prev,
					[column]: {
						entities: processed,
						loading: false,
						hasMore: newHasMore,
						error: void 0,
						totalCount: prev[column]?.totalCount
					}
				};
			});
		};
		const accessor = currentDataClient.collection(currentResolvedPath);
		const includeParams = getRelationIncludeParams(currentCollection);
		const fetchOnce = () => accessor.find({
			where: whereFilter,
			limit: requestedCount,
			orderBy: orderByParam,
			include: includeParams,
			searchString: currentSearchString
		});
		const onError = (error) => {
			if (isCleaningUpRef.current) return;
			console.error(`Error loading column ${column}:`, error);
			fetchOnce().then((res) => onUpdate(res.data)).catch(() => {
				if (isCleaningUpRef.current) return;
				setColumnData((prev) => ({
					...prev,
					[column]: {
						...prev[column],
						entities: prev[column]?.entities ?? [],
						loading: false,
						hasMore: false,
						error
					}
				}));
			});
		};
		if (accessor.listen) {
			let liveDataReceived = false;
			const unsubscribe = accessor.listen({
				where: whereFilter,
				limit: requestedCount,
				orderBy: orderByParam,
				include: includeParams,
				searchString: currentSearchString
			}, (res) => {
				liveDataReceived = true;
				onUpdate(res.data);
			}, onError);
			const firstPaintFallback = setTimeout(() => {
				if (liveDataReceived || isCleaningUpRef.current) return;
				fetchOnce().then((res) => {
					if (liveDataReceived || isCleaningUpRef.current) return;
					onUpdate(res.data);
				}).catch(() => void 0);
			}, LIVE_FIRST_PAINT_TIMEOUT_MS);
			unsubscribersRef.current[column] = () => {
				clearTimeout(firstPaintFallback);
				unsubscribe?.();
			};
		} else fetchOnce().then((res) => onUpdate(res.data)).catch((error) => {
			if (isCleaningUpRef.current) return;
			setColumnData((prev) => ({
				...prev,
				[column]: {
					...prev[column],
					entities: prev[column]?.entities ?? [],
					loading: false,
					hasMore: false,
					error
				}
			}));
		});
	}, []);
	useEffect(() => {
		isCleaningUpRef.current = false;
		const existingUnsubscribers = { ...unsubscribersRef.current };
		unsubscribersRef.current = {};
		Object.values(existingUnsubscribers).forEach((unsub) => {
			try {
				unsub?.();
			} catch (e) {}
		});
		const currentDataClient = dataClientRef.current;
		collectionRef.current;
		const currentFilterValues = filterValuesRef.current;
		const currentColumnProperty = columnPropertyRef.current;
		const currentSearchString = searchStringRef.current;
		const currentResolvedPath = resolvedPathRef.current;
		const currentColumns = columns;
		const currentColumnItemCounts = columnItemCounts;
		const timeoutId = setTimeout(() => {
			if (isCleaningUpRef.current) return;
			currentColumns.forEach((column) => {
				const itemCount = currentColumnItemCounts[column] ?? pageSize;
				subscribeToColumn(column, itemCount);
				if (isColumnExcludedByFilter(column, currentFilterValues, currentColumnProperty)) return;
				const accessor = currentDataClient.collection(currentResolvedPath);
				if (accessor.count) {
					const whereFilter = {
						...currentFilterValues ?? {},
						[currentColumnProperty]: ["==", column]
					};
					accessor.count({
						where: whereFilter,
						searchString: currentSearchString
					}).then((count) => {
						if (isCleaningUpRef.current) return;
						setColumnData((prev) => ({
							...prev,
							[column]: {
								...prev[column],
								totalCount: count
							}
						}));
					}).catch((e) => {
						console.warn(`Failed to get count for column ${column}:`, e);
					});
				}
			});
			prevColumnItemCountsRef.current = { ...currentColumnItemCounts };
		}, 0);
		return () => {
			clearTimeout(timeoutId);
			isCleaningUpRef.current = true;
			const unsubscribers = { ...unsubscribersRef.current };
			unsubscribersRef.current = {};
			Object.values(unsubscribers).forEach((unsub) => {
				try {
					unsub?.();
				} catch (e) {}
			});
		};
	}, [
		subscriptionVersion,
		subscribeToColumn,
		pageSize
	]);
	const lastProcessedVersionRef = useRef(subscriptionVersion);
	useEffect(() => {
		if (subscriptionVersion !== lastProcessedVersionRef.current) {
			lastProcessedVersionRef.current = subscriptionVersion;
			prevColumnItemCountsRef.current = { ...columnItemCounts };
			return;
		}
		const prevCounts = prevColumnItemCountsRef.current;
		columns.forEach((column) => {
			const prevCount = prevCounts[column] ?? pageSize;
			const newCount = columnItemCounts[column] ?? pageSize;
			if (newCount > prevCount && !isCleaningUpRef.current) {
				if (unsubscribersRef.current[column]) {
					try {
						unsubscribersRef.current[column]();
					} catch (e) {}
					delete unsubscribersRef.current[column];
				}
				setTimeout(() => {
					if (!isCleaningUpRef.current) subscribeToColumn(column, newCount);
				}, 0);
			}
		});
		prevColumnItemCountsRef.current = { ...columnItemCounts };
	}, [
		columnItemCounts,
		columns,
		pageSize,
		subscribeToColumn,
		subscriptionVersion
	]);
	const loadMoreColumn = useCallback((column) => {
		setColumnItemCounts((prev) => ({
			...prev,
			[column]: (prev[column] ?? pageSize) + pageSize
		}));
	}, [pageSize]);
	const refreshColumn = useCallback((column) => {
		setColumnItemCounts((prev) => ({
			...prev,
			[column]: pageSize
		}));
	}, [pageSize]);
	const refreshAll = useCallback(() => {
		const reset = {};
		columns.forEach((col) => {
			reset[col] = pageSize;
		});
		setColumnItemCounts(reset);
	}, [columns, pageSize]);
	const moveItemOptimistically = useCallback((itemId, sourceColumn, targetColumn, newValues, newIndex) => {
		setColumnData((prev) => {
			const updated = { ...prev };
			let itemToMove;
			const sourceEntities = [...updated[sourceColumn]?.entities || []];
			const itemIndex = sourceEntities.findIndex((e) => String(e.id) === itemId);
			if (itemIndex !== -1) {
				itemToMove = sourceEntities[itemIndex];
				sourceEntities.splice(itemIndex, 1);
			}
			if (itemToMove) {
				const newValuesMerged = {
					...itemToMove.values,
					...newValues || {}
				};
				const updatedEntity = {
					...itemToMove,
					values: newValuesMerged
				};
				pendingItemsRef.current[String(updatedEntity.id)] = {
					entity: updatedEntity,
					expectedValues: newValuesMerged
				};
				const targetEntities = sourceColumn === targetColumn ? sourceEntities : [...updated[targetColumn]?.entities || []];
				if (newIndex !== void 0 && newIndex >= 0 && newIndex <= targetEntities.length) targetEntities.splice(newIndex, 0, updatedEntity);
				else {
					targetEntities.push(updatedEntity);
					if (orderPropertyRef.current) {
						const orderProp = orderPropertyRef.current;
						targetEntities.sort((a, b) => {
							const valA = a.values?.[orderProp];
							const valB = b.values?.[orderProp];
							const isAEmpty = valA === void 0 || valA === null || valA === "";
							const isBEmpty = valB === void 0 || valB === null || valB === "";
							if (isAEmpty && isBEmpty) return 0;
							if (isAEmpty) return 1;
							if (isBEmpty) return -1;
							return valA < valB ? -1 : valA > valB ? 1 : 0;
						});
					}
				}
				updated[sourceColumn] = {
					...updated[sourceColumn],
					entities: sourceColumn === targetColumn ? targetEntities : sourceEntities,
					totalCount: sourceColumn === targetColumn ? updated[sourceColumn].totalCount : Math.max(0, (updated[sourceColumn].totalCount ?? 0) - 1)
				};
				if (sourceColumn !== targetColumn) updated[targetColumn] = {
					...updated[targetColumn],
					entities: targetEntities,
					totalCount: (updated[targetColumn].totalCount ?? 0) + 1
				};
			} else if (sourceColumn !== targetColumn) {
				if (updated[sourceColumn]?.totalCount !== void 0) updated[sourceColumn] = {
					...updated[sourceColumn],
					totalCount: Math.max(0, (updated[sourceColumn].totalCount ?? 0) - 1)
				};
				if (updated[targetColumn]?.totalCount !== void 0) updated[targetColumn] = {
					...updated[targetColumn],
					totalCount: (updated[targetColumn].totalCount ?? 0) + 1
				};
			}
			return updated;
		});
	}, []);
	const decrementColumnCounts = useCallback((columnDeltas) => {
		setColumnData((prev) => {
			const updated = { ...prev };
			for (const [column, delta] of Object.entries(columnDeltas)) if (updated[column]?.totalCount !== void 0) updated[column] = {
				...updated[column],
				totalCount: Math.max(0, (updated[column].totalCount ?? 0) - delta)
			};
			return updated;
		});
	}, []);
	const loading = useMemo(() => {
		return Object.values(columnData).some((col) => col.loading);
	}, [columnData]);
	const error = useMemo(() => {
		return Object.values(columnData).map((col) => col.error).filter(Boolean)[0];
	}, [columnData]);
	return useMemo(() => ({
		columnData,
		loadMoreColumn,
		refreshColumn,
		refreshAll,
		moveItemOptimistically,
		decrementColumnCounts,
		loading,
		error
	}), [
		columnData,
		loadMoreColumn,
		refreshColumn,
		refreshAll,
		moveItemOptimistically,
		decrementColumnCounts,
		loading,
		error
	]);
}
//#endregion
//#region src/components/CollectionViewBinding/hooks/useKanbanDragAndDrop.ts
/**
* The digits a board order key is built from: base36, lower case only.
*
* The library's default alphabet is base62, and its keys only sort correctly
* under byte ordering. The column is sorted by the *database*, and Postgres'
* default collation is not byte ordering — under `en_US.UTF-8`, `"aa"` sorts
* before `"aC"`, so as soon as a board had been dragged around enough to reach
* the upper-case digits its order stopped matching the keys. One case has no
* such ambiguity: digits before letters is true of every collation in use.
*
* A key written with the old alphabet no longer validates, which is what makes
* the board offer to initialise the column — one click, and the order is
* rewritten in a form the database can sort.
*/
var ORDER_KEY_DIGITS = "0123456789abcdefghijklmnopqrstuvwxyz";
/**
* Whether a stored order value is a key `fractional-indexing` can interpolate
* against.
*
* Anything else — a plain `"12"` from a seed or a migration, an empty string —
* makes `generateKeyBetween` throw, and the fallback below then hands out the
* same first key to every card, so each drag lands at the bottom of the column
* on top of the last one that did. Asking the library itself is the only
* definition of "valid" worth trusting.
*/
function isValidOrderKey(value) {
	if (typeof value !== "string" || value.length === 0) return false;
	try {
		generateKeyBetween(value, null, ORDER_KEY_DIGITS);
		return true;
	} catch {
		return false;
	}
}
function useKanbanDragAndDrop({ collection, fullPath, columnProperty, orderProperty, dataClient, context, boardDataController, analyticsController }) {
	const handleItemsReorder = useCallback(async (items, moveInfo) => {
		const entity = items.find((item) => item.id === moveInfo?.itemId)?.data;
		if (!entity || !moveInfo) return;
		analyticsController.onAnalyticsEvent?.("kanban_card_moved", {
			path: fullPath,
			entityId: entity.id,
			sourceColumn: moveInfo.sourceColumn,
			targetColumn: moveInfo.targetColumn
		});
		const isColumnChange = moveInfo.sourceColumn !== moveInfo.targetColumn;
		if (!orderProperty && !isColumnChange) return;
		let updatedValues = {};
		if (orderProperty) {
			const targetColumnItems = items;
			const movedIndex = targetColumnItems.findIndex((item) => item.id === moveInfo.itemId);
			const keyAt = (index) => {
				const value = targetColumnItems[index]?.data.values?.[orderProperty];
				return isValidOrderKey(value) ? value : null;
			};
			const prevKey = movedIndex > 0 ? keyAt(movedIndex - 1) : null;
			const nextKey = movedIndex < targetColumnItems.length - 1 ? keyAt(movedIndex + 1) : null;
			try {
				const a = prevKey;
				let b = nextKey;
				if (a !== null && b !== null && a >= b) b = null;
				const newKey = generateKeyBetween(a, b, ORDER_KEY_DIGITS);
				updatedValues = setIn(updatedValues, orderProperty, newKey);
			} catch (e) {
				console.warn("fractional-indexing error, falling back:", e);
				const newKey = generateKeyBetween(null, null, ORDER_KEY_DIGITS);
				updatedValues = setIn(updatedValues, orderProperty, newKey);
			}
		}
		if (isColumnChange) updatedValues = setIn(updatedValues, columnProperty, moveInfo.targetColumn);
		if (boardDataController.moveItemOptimistically) {
			const targetIndex = items.findIndex((item) => item.id === moveInfo.itemId);
			boardDataController.moveItemOptimistically(moveInfo.itemId, moveInfo.sourceColumn, moveInfo.targetColumn, updatedValues, targetIndex !== -1 ? targetIndex : void 0);
		}
		const saveProps = {
			path: entity.path,
			entityId: entity.id,
			values: updatedValues,
			previousValues: entity.values,
			collection,
			status: "existing"
		};
		try {
			await saveEntityWithCallbacks({
				...saveProps,
				collection,
				data: dataClient,
				context,
				afterSave: () => {},
				afterSaveError: (e) => {
					console.error("Failed to save entity after reorder:", e);
					if (boardDataController.refreshAll) boardDataController.refreshAll();
				}
			});
		} catch (e) {
			console.error("Error saving entity:", e);
			if (boardDataController.refreshAll) boardDataController.refreshAll();
		}
	}, [
		collection,
		columnProperty,
		orderProperty,
		context,
		dataClient,
		boardDataController,
		analyticsController,
		fullPath
	]);
	return useMemo(() => ({ handleItemsReorder }), [handleItemsReorder]);
}
//#endregion
//#region src/components/CollectionViewBinding/CollectionBoardViewBinding.tsx
/**
* Kanban board view for displaying entities grouped by a string enum property.
*/
function CollectionBoardViewBinding({ collection, tableController, fullPath, parentCollectionSlugs = [], parentEntityIds = [], columnProperty, onEntityClick, selectionController, selectionEnabled = true, highlightedEntities, emptyComponent, deletedEntities }) {
	const customizationController = useCustomizationController();
	const context = useRebaseContext();
	const dataClient = useData();
	const sidePanelController = useSidePanel();
	const analyticsController = useAnalyticsController();
	const { t } = useTranslation();
	const plugins = customizationController.plugins ?? [];
	const [showBackfillDialog, setShowBackfillDialog] = useState(false);
	const [backfillLoading, setBackfillLoading] = useState(false);
	const rawOrderProperty = collection.orderProperty;
	const orderProperty = useMemo(() => {
		if (!rawOrderProperty) return void 0;
		if (!getPropertyInPath$1(collection.properties, rawOrderProperty)) {
			console.warn(`orderProperty "${rawOrderProperty}" is defined but does not exist in the collection properties. Treating as unconfigured.`);
			return;
		}
		return rawOrderProperty;
	}, [rawOrderProperty, collection.properties]);
	const { enumColumns, columnLabels, columnColors } = useMemo(() => {
		const property = getPropertyInPath$1(collection.properties, columnProperty);
		if (!property || !("type" in property) || property.type !== "string") return {
			enumColumns: [],
			columnLabels: {}
		};
		const stringProperty = property;
		if (!stringProperty.enum) return {
			enumColumns: [],
			columnLabels: {}
		};
		const enumValues = resolveEnumValues(stringProperty.enum);
		if (!enumValues) return {
			enumColumns: [],
			columnLabels: {}
		};
		return {
			enumColumns: enumValues.map((ev) => String(ev.id)),
			columnLabels: enumValues.reduce((acc, ev) => {
				acc[String(ev.id)] = ev.label;
				return acc;
			}, {}),
			columnColors: enumValues.reduce((acc, ev) => {
				acc[String(ev.id)] = ev.color ?? getColorSchemeForSeed(String(ev.id));
				return acc;
			}, {})
		};
	}, [collection, columnProperty]);
	const [hasUserReordered, setHasUserReordered] = useState(false);
	const [localColumnsOrder, setLocalColumnsOrder] = useState(enumColumns);
	useEffect(() => {
		if (!hasUserReordered) setLocalColumnsOrder(enumColumns);
		else {
			const missingColumns = enumColumns.filter((c) => !localColumnsOrder.includes(c));
			if (missingColumns.length > 0) setLocalColumnsOrder((prev) => [...prev, ...missingColumns]);
		}
	}, [enumColumns, hasUserReordered]);
	const columns = localColumnsOrder;
	const boardDataController = useBoardDataController({
		fullPath,
		collection,
		columnProperty,
		columns,
		orderProperty,
		pageSize: 30,
		searchString: tableController.searchString,
		filterValues: tableController.filterValues
	});
	const dataLoading = boardDataController.loading;
	const dataLoadingError = boardDataController.error;
	const processedDeletedRef = useRef(/* @__PURE__ */ new Set());
	useEffect(() => {
		if (!deletedEntities || deletedEntities.length === 0) return;
		const deltas = {};
		deletedEntities.forEach((entity) => {
			if (processedDeletedRef.current.has(String(entity.id))) return;
			processedDeletedRef.current.add(String(entity.id));
			const col = entity.values?.[columnProperty];
			if (col && typeof col === "string") deltas[col] = (deltas[col] ?? 0) + 1;
		});
		if (Object.keys(deltas).length > 0) boardDataController.decrementColumnCounts(deltas);
	}, [
		deletedEntities,
		columnProperty,
		boardDataController
	]);
	const allEntities = useMemo(() => {
		const entities = [];
		const seenIds = /* @__PURE__ */ new Set();
		columns.forEach((col) => {
			const colData = boardDataController.columnData[col];
			if (colData?.entities) colData.entities.forEach((entity) => {
				const idStr = String(entity.id);
				if (!seenIds.has(idStr)) {
					seenIds.add(idStr);
					entities.push(entity);
				}
			});
		});
		return entities;
	}, [boardDataController.columnData, columns]);
	const allowColumnReorder = useMemo(() => {
		return plugins.some((plugin) => plugin.hooks?.onKanbanColumnsReorder);
	}, [plugins]);
	const handleColumnReorder = useCallback((newColumns) => {
		analyticsController.onAnalyticsEvent?.("kanban_column_reorder", {
			path: fullPath,
			columnProperty
		});
		setHasUserReordered(true);
		setLocalColumnsOrder(newColumns);
		plugins.filter((plugin) => plugin.hooks?.onKanbanColumnsReorder).forEach((plugin) => {
			plugin.hooks.onKanbanColumnsReorder({
				fullPath,
				parentCollectionSlugs,
				parentEntityIds,
				collection,
				kanbanColumnProperty: columnProperty,
				newColumnsOrder: newColumns
			});
		});
	}, [
		plugins,
		fullPath,
		parentCollectionSlugs,
		parentEntityIds,
		collection,
		columnProperty,
		analyticsController
	]);
	const [missingOrderCount, setMissingOrderCount] = useState(0);
	const dataClientRef = useRef(dataClient);
	const collectionRef = useRef(collection);
	dataClientRef.current = dataClient;
	collectionRef.current = collection;
	useEffect(() => {
		const accessor = dataClientRef.current.collection(fullPath);
		if (!orderProperty || !accessor.count) {
			setMissingOrderCount(0);
			return;
		}
		let totalCount = 0;
		let orderedCount = 0;
		let completed = 0;
		accessor.count().then((count) => {
			totalCount = count;
			completed++;
			if (completed === 2) setMissingOrderCount(Math.max(0, totalCount - orderedCount));
		}).catch((e) => console.warn("Failed to get total count:", e));
		accessor.count({ where: { [orderProperty]: ["!=", null] } }).then((count) => {
			orderedCount = count;
			completed++;
			if (completed === 2) setMissingOrderCount(Math.max(0, totalCount - orderedCount));
		}).catch((e) => console.warn("Failed to get ordered count:", e));
	}, [orderProperty, fullPath]);
	const itemsNeedBackfill = useMemo(() => {
		if (!orderProperty || dataLoading) return false;
		if (missingOrderCount > 0) return true;
		return allEntities.some((entity) => !isValidOrderKey(entity.values?.[orderProperty]));
	}, [
		allEntities,
		orderProperty,
		dataLoading,
		missingOrderCount
	]);
	const entityColumnMap = useMemo(() => {
		const map = {};
		columns.forEach((col) => {
			const colData = boardDataController.columnData[col];
			if (colData?.entities) colData.entities.forEach((entity) => {
				map[String(entity.id)] = col;
			});
		});
		return map;
	}, [columns, boardDataController.columnData]);
	const boardItems = useMemo(() => {
		return allEntities.map((entity) => ({
			id: String(entity.id),
			data: entity
		}));
	}, [allEntities]);
	const columnLoadingState = useMemo(() => {
		const state = {};
		columns.forEach((col) => {
			const colData = boardDataController.columnData[col];
			state[col] = {
				loading: colData?.loading ?? true,
				hasMore: colData?.hasMore ?? false,
				itemCount: colData?.entities?.length ?? 0,
				totalCount: colData?.totalCount,
				error: colData?.error
			};
		});
		return state;
	}, [columns, boardDataController.columnData]);
	const assignColumn = useCallback((item) => {
		const column = entityColumnMap[item.id];
		if (column) return column;
		const value = item.data.values?.[columnProperty];
		if (value && columns.includes(String(value))) return String(value);
		return columns[0] || "";
	}, [
		entityColumnMap,
		columnProperty,
		columns
	]);
	const { handleItemsReorder } = useKanbanDragAndDrop({
		collection,
		fullPath,
		columnProperty,
		orderProperty,
		dataClient,
		context,
		boardDataController,
		analyticsController
	});
	const handleBackfill = useCallback(async () => {
		if (!orderProperty) return;
		analyticsController.onAnalyticsEvent?.("kanban_backfill_order", { path: fullPath });
		setBackfillLoading(true);
		try {
			const entitiesToUpdate = (await dataClient.collection(fullPath).find({ limit: MAX_LIST_LIMIT })).data.filter((entity) => !isValidOrderKey(entity.values?.[orderProperty]));
			const keys = generateNKeysBetween(null, null, entitiesToUpdate.length, ORDER_KEY_DIGITS);
			const updates = [];
			entitiesToUpdate.forEach((entity, index) => {
				const updatedValues = setIn({ ...entity.values }, orderProperty, keys[index]);
				const saveProps = {
					path: entity.path,
					entityId: entity.id,
					values: updatedValues,
					previousValues: entity.values,
					collection,
					status: "existing"
				};
				updates.push(saveEntityWithCallbacks({
					...saveProps,
					collection,
					data: dataClient,
					context,
					afterSave: () => {},
					afterSaveError: (e) => console.error("Backfill save failed:", e)
				}).then(() => {}));
			});
			await Promise.all(updates);
			setShowBackfillDialog(false);
			setMissingOrderCount(0);
			boardDataController.refreshAll();
		} catch (e) {
			console.error("Backfill error:", e);
		} finally {
			setBackfillLoading(false);
		}
	}, [
		orderProperty,
		fullPath,
		collection,
		dataClient,
		context,
		boardDataController,
		analyticsController
	]);
	const handleEntityClick = useCallback((entity) => {
		onEntityClick?.(entity);
	}, [onEntityClick]);
	const handleSelectionChange = useCallback((entity, selected) => {
		selectionController?.toggleEntitySelection(entity, selected);
	}, [selectionController]);
	const isEntitySelected = useCallback((entity) => {
		return selectionController?.isEntitySelected(entity) ?? false;
	}, [selectionController]);
	const handleEntityClickRef = useRef(handleEntityClick);
	handleEntityClickRef.current = handleEntityClick;
	const isEntitySelectedRef = useRef(isEntitySelected);
	isEntitySelectedRef.current = isEntitySelected;
	const handleSelectionChangeRef = useRef(handleSelectionChange);
	handleSelectionChangeRef.current = handleSelectionChange;
	const selectionEnabledRef = useRef(selectionEnabled);
	selectionEnabledRef.current = selectionEnabled;
	const stableOnClick = useCallback((entity) => {
		handleEntityClickRef.current(entity);
	}, []);
	const stableOnSelectionChange = useCallback((entity, sel) => {
		handleSelectionChangeRef.current(entity, sel);
	}, []);
	const ItemComponent = useMemo(() => {
		const Comp = (props) => /* @__PURE__ */ jsx(BoardCardBinding, {
			...props,
			collection: collectionRef.current,
			onClick: stableOnClick,
			selected: isEntitySelectedRef.current(props.item.data),
			onSelectionChange: stableOnSelectionChange,
			selectionEnabled: selectionEnabledRef.current
		});
		Comp.displayName = "KanbanItemComponent";
		return Comp;
	}, []);
	const kanbanSetupSlots = useSlot("kanban.setup", {
		collection,
		fullPath,
		parentCollectionSlugs,
		parentEntityIds
	});
	const addKanbanColumnSlots = useSlot("kanban.add-column", {
		collection,
		fullPath,
		parentCollectionSlugs,
		parentEntityIds,
		columnProperty
	});
	const hasError = Boolean(dataLoadingError);
	const errorMessage = dataLoadingError?.message || "";
	const indexUrl = errorMessage.match(/https:\/\/console\.firebase\.google\.com[^\s]+/)?.[0];
	if (!columnProperty || enumColumns.length === 0) return /* @__PURE__ */ jsxs("div", {
		className: "h-full flex flex-col items-center justify-center p-8 gap-4",
		children: [
			/* @__PURE__ */ jsx(Typography, {
				variant: "h6",
				children: t("kanban_view_not_available")
			}),
			/* @__PURE__ */ jsx(Typography, {
				variant: "body2",
				color: "secondary",
				className: "text-center max-w-md",
				children: t("kanban_view_requires_enum")
			}),
			kanbanSetupSlots.length > 0 && kanbanSetupSlots[0]
		]
	});
	if (columns.length === 0) return /* @__PURE__ */ jsx("div", {
		className: "h-full flex items-center justify-center p-8",
		children: /* @__PURE__ */ jsx(Typography, {
			variant: "label",
			color: "secondary",
			children: t("no_enum_values_configured", { property: columnProperty })
		})
	});
	return /* @__PURE__ */ jsxs("div", {
		className: "flex-1 flex flex-col overflow-hidden",
		children: [
			hasError && allEntities.length === 0 && /* @__PURE__ */ jsxs("div", {
				className: "flex items-center gap-4 px-4 py-3 bg-red-50 dark:bg-red-900/20 border-b border-red-200 dark:border-red-800",
				children: [
					/* @__PURE__ */ jsxs(Typography, {
						variant: "body2",
						className: "text-red-700 dark:text-red-300 flex-1",
						children: [
							/* @__PURE__ */ jsx("strong", { children: "Error:" }),
							" ",
							indexUrl ? "A Firestore index is required for this query." : errorMessage
						]
					}),
					/* @__PURE__ */ jsx(Tooltip, {
						title: t("refresh_data"),
						children: /* @__PURE__ */ jsx(IconButton, {
							size: "small",
							onClick: () => boardDataController.refreshAll(),
							children: /* @__PURE__ */ jsx(RefreshCwIcon, { size: iconSize.smallest })
						})
					}),
					indexUrl && /* @__PURE__ */ jsx(Button, {
						size: "small",
						variant: "filled",
						color: "error",
						onClick: () => window.open(indexUrl, "_blank"),
						children: t("create_index")
					})
				]
			}),
			!orderProperty && !dataLoading && /* @__PURE__ */ jsxs("div", {
				className: "flex items-center justify-between gap-4 px-4 py-2 bg-amber-50 dark:bg-amber-900/20 border-b border-amber-200 dark:border-amber-800",
				children: [/* @__PURE__ */ jsx(Typography, {
					variant: "body2",
					color: "secondary",
					children: t("kanban_order_not_configured")
				}), kanbanSetupSlots.length > 0 && kanbanSetupSlots[0]]
			}),
			itemsNeedBackfill && !dataLoading && /* @__PURE__ */ jsxs("div", {
				className: "flex items-center justify-between gap-4 px-4 py-2 bg-amber-50 dark:bg-amber-900/20 border-b border-amber-200 dark:border-amber-800",
				children: [/* @__PURE__ */ jsx(Typography, {
					variant: "body2",
					color: "secondary",
					children: t("items_need_backfill")
				}), /* @__PURE__ */ jsx(Button, {
					size: "small",
					variant: "text",
					onClick: () => setShowBackfillDialog(true),
					children: t("initialize")
				})]
			}),
			/* @__PURE__ */ jsx("div", {
				className: "flex-1 min-h-0 overflow-hidden",
				children: /* @__PURE__ */ jsx(KanbanView, {
					data: boardItems,
					columns,
					columnLabels,
					columnColors,
					assignColumn,
					allowColumnReorder,
					onColumnReorder: handleColumnReorder,
					onItemsReorder: handleItemsReorder,
					ItemComponent,
					columnLoadingState,
					onLoadMoreColumn: (column) => boardDataController.loadMoreColumn(column),
					onAddItemToColumn: (column) => {
						analyticsController.onAnalyticsEvent?.("kanban_new_entity_in_column", {
							path: fullPath,
							column
						});
						sidePanelController.open({
							path: fullPath,
							collection,
							entityId: void 0,
							updateUrl: true,
							formProps: { initialDirtyValues: { [columnProperty]: column } }
						});
					},
					AddColumnComponent: addKanbanColumnSlots.length > 0 ? addKanbanColumnSlots[0] : void 0
				})
			}),
			/* @__PURE__ */ jsxs(Dialog, {
				open: showBackfillDialog,
				onOpenChange: setShowBackfillDialog,
				children: [
					/* @__PURE__ */ jsx(DialogTitle, {
						hidden: true,
						children: t("initialize_kanban_order")
					}),
					/* @__PURE__ */ jsxs(DialogContent, { children: [/* @__PURE__ */ jsx(Typography, {
						variant: "h6",
						className: "mb-4",
						children: t("initialize_kanban_order")
					}), /* @__PURE__ */ jsx(Typography, {
						variant: "body2",
						children: t("initialize_kanban_order_desc")
					})] }),
					/* @__PURE__ */ jsxs(DialogActions, { children: [/* @__PURE__ */ jsx(Button, {
						variant: "text",
						onClick: () => setShowBackfillDialog(false),
						disabled: backfillLoading,
						children: t("cancel")
					}), /* @__PURE__ */ jsx(Button, {
						onClick: handleBackfill,
						disabled: backfillLoading,
						children: backfillLoading ? /* @__PURE__ */ jsx(CircularProgress, { size: "smallest" }) : t("initialize")
					})] })
				]
			})
		]
	});
}
//#endregion
//#region src/components/CollectionViewBinding/ViewModeToggle.tsx
var ALL_VIEW_MODES = [
	"list",
	"table",
	"cards",
	"kanban"
];
function ViewModeToggle({ viewMode = "table", onViewModeChange, enabledViews = ALL_VIEW_MODES, customViews, size, onSizeChanged, open, onOpenChange, kanbanPropertyOptions, selectedKanbanProperty, onKanbanPropertyChange }) {
	const { t } = useTranslation();
	const activeCustomView = customViews?.find((v) => v.key === viewMode);
	const getViewModeIcon = () => {
		if (activeCustomView) return getIcon(activeCustomView.icon, void 0, void 0, "small") ?? /* @__PURE__ */ jsx(ListIcon, { size: iconSize.small });
		if (viewMode === "kanban") return /* @__PURE__ */ jsx(KanbanIcon, { size: iconSize.small });
		if (viewMode === "cards") return /* @__PURE__ */ jsx(LayoutGridIcon, { size: iconSize.small });
		if (viewMode === "table") return /* @__PURE__ */ jsx(TableIcon, { size: iconSize.small });
		return /* @__PURE__ */ jsx(ListIcon, { size: iconSize.small });
	};
	const getViewModeName = () => {
		if (activeCustomView) return activeCustomView.name;
		if (viewMode === "kanban") return t("board");
		if (viewMode === "cards") return t("cards");
		if (viewMode === "table") return t("table_view_mode");
		return t("list");
	};
	const showSizeSelector = size && onSizeChanged && (activeCustomView ? activeCustomView.sizeable : viewMode === "list" || viewMode === "table" || viewMode === "cards");
	const showKanbanPropertySelector = viewMode === "kanban" && kanbanPropertyOptions && kanbanPropertyOptions.length > 0 && onKanbanPropertyChange;
	const viewModeOptions = useMemo(() => {
		const builtIns = {
			list: {
				label: t("list"),
				icon: /* @__PURE__ */ jsx(ListIcon, { size: iconSize.smallest })
			},
			table: {
				label: t("table_view_mode"),
				icon: /* @__PURE__ */ jsx(TableIcon, { size: iconSize.smallest })
			},
			cards: {
				label: t("cards"),
				icon: /* @__PURE__ */ jsx(LayoutGridIcon, { size: iconSize.smallest })
			},
			kanban: {
				label: t("board"),
				icon: /* @__PURE__ */ jsx(KanbanIcon, { size: iconSize.smallest })
			}
		};
		return enabledViews.flatMap((mode) => {
			const builtIn = builtIns[mode];
			if (builtIn) return [{
				value: mode,
				...builtIn
			}];
			const custom = customViews?.find((v) => v.key === mode);
			if (!custom) return [];
			return [{
				value: mode,
				label: custom.name,
				icon: getIcon(custom.icon, void 0, void 0, "smallest") ?? /* @__PURE__ */ jsx(ListIcon, { size: iconSize.smallest })
			}];
		});
	}, [
		t,
		enabledViews,
		customViews
	]);
	if (!onViewModeChange) return null;
	if (viewModeOptions.length <= 1 && !showSizeSelector && !showKanbanPropertySelector) return null;
	return /* @__PURE__ */ jsx("div", {
		className: "overflow-visible",
		children: /* @__PURE__ */ jsx(Popover, {
			open,
			onOpenChange,
			modal: false,
			trigger: /* @__PURE__ */ jsxs(Button, {
				size: "small",
				children: [getViewModeIcon(), /* @__PURE__ */ jsx("span", {
					className: "ml-1 text-sm",
					children: getViewModeName()
				})]
			}),
			children: /* @__PURE__ */ jsxs("div", {
				className: "p-3 flex flex-col gap-3 min-w-[240px]",
				children: [
					viewModeOptions.length > 1 && /* @__PURE__ */ jsx(ToggleButtonGroup, {
						value: viewMode,
						onValueChange: onViewModeChange,
						options: viewModeOptions
					}),
					showSizeSelector && /* @__PURE__ */ jsxs("div", {
						className: "flex flex-row items-center justify-between gap-2",
						children: [/* @__PURE__ */ jsxs("div", {
							className: "flex items-center gap-2 text-sm text-surface-600 dark:text-surface-300",
							children: [/* @__PURE__ */ jsx(ColumnsIcon, { size: iconSize.smallest }), /* @__PURE__ */ jsx("span", { children: t("size_label") })]
						}), /* @__PURE__ */ jsx(Select, {
							value: size,
							size: "small",
							className: "w-20",
							onValueChange: (v) => onSizeChanged?.(v),
							renderValue: (v) => /* @__PURE__ */ jsx("span", {
								className: "font-medium",
								children: v.toUpperCase()
							}),
							children: [
								"xs",
								"s",
								"m",
								"l",
								"xl"
							].map((s) => /* @__PURE__ */ jsx(SelectItem, {
								value: s,
								className: "font-medium text-center",
								children: s.toUpperCase()
							}, s))
						})]
					}),
					showKanbanPropertySelector && /* @__PURE__ */ jsxs("div", {
						className: "flex flex-row items-center justify-between gap-2",
						children: [/* @__PURE__ */ jsxs("div", {
							className: "flex items-center gap-2 text-sm text-surface-600 dark:text-surface-300",
							children: [/* @__PURE__ */ jsx(KanbanIcon, { size: iconSize.smallest }), /* @__PURE__ */ jsx("span", { children: t("group_by") })]
						}), /* @__PURE__ */ jsx(Select, {
							value: selectedKanbanProperty,
							size: "small",
							className: "w-32",
							onValueChange: (v) => onKanbanPropertyChange?.(v),
							renderValue: (v) => {
								const option = kanbanPropertyOptions?.find((o) => o.key === v);
								return /* @__PURE__ */ jsx("span", {
									className: "font-medium truncate",
									children: option?.label ?? v
								});
							},
							children: kanbanPropertyOptions?.map((option) => /* @__PURE__ */ jsx(SelectItem, {
								value: option.key,
								children: option.label
							}, option.key))
						})]
					})
				]
			})
		})
	});
}
//#endregion
//#region src/util/map_with_concurrency.ts
/**
* Run `task` over every item, at most `concurrency` at a time, and return the
* results in the order the items were given.
*
* The bulk delete used to be `Promise.all(entities.map(performDelete))`. That is
* fine for the handful of rows anyone could tick by hand, and it is the reason
* a "select all matching" over a real collection could not simply be poured
* into the existing dialog: twelve thousand entries in that array is twelve
* thousand simultaneous requests, which the browser queues and the server takes
* as a burst.
*
* Rejections are not swallowed and do not cancel: every task is run, and the
* first rejection is thrown once they have all settled, so a bulk action cannot
* half-apply and then report the failure as if nothing had happened.
*/
async function mapWithConcurrency(items, concurrency, task, onSettled) {
	const results = new Array(items.length);
	const limit = Math.max(1, Math.floor(concurrency));
	let next = 0;
	let completed = 0;
	let firstError;
	let failed = false;
	async function worker() {
		for (;;) {
			const index = next++;
			if (index >= items.length) return;
			try {
				results[index] = await task(items[index], index);
			} catch (e) {
				if (!failed) {
					failed = true;
					firstError = e;
				}
			}
			onSettled?.(++completed, items.length);
		}
	}
	await Promise.all(Array.from({ length: Math.min(limit, items.length) }, worker));
	if (failed) throw firstError;
	return results;
}
//#endregion
//#region src/components/DeleteEntityDialog.tsx
/**
* Deletes in flight at once.
*
* The bulk delete used to be `Promise.all(entities.map(performDelete))`, which
* is unremarkable for the handful of rows anyone could tick by hand and
* untenable the moment "select all 12,480 matching" can reach it.
*/
var DELETE_CONCURRENCY = 8;
function isSelection(target) {
	return target.type === "entities" || target.type === "query";
}
function DeleteEntityDialog({ target, collection, onClose, open, onEntityDelete, onMultipleEntitiesDelete, path, variant = "delete" }) {
	const dataClient = useData();
	const snackbarController = useSnackbarController();
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const [progress, setProgress] = useState(void 0);
	const cancelledRef = useRef({ aborted: false });
	const context = useAdminContext();
	const { singleEntity, selection } = useMemo(() => {
		if (!target) return {
			singleEntity: void 0,
			selection: void 0
		};
		if (!isSelection(target)) return {
			singleEntity: target,
			selection: void 0
		};
		if (target.type === "entities" && target.entities.length === 1) return {
			singleEntity: target.entities[0],
			selection: void 0
		};
		return {
			singleEntity: void 0,
			selection: target
		};
	}, [target]);
	/** How many rows this will delete; `undefined` when only the server knows. */
	const selectionCount = selection === void 0 ? 1 : selection.type === "entities" ? selection.entities.length : selection.count === void 0 ? void 0 : Math.max(0, selection.count - selection.excluded.length);
	const handleCancel = useCallback(() => {
		cancelledRef.current.aborted = true;
		onClose();
	}, [onClose]);
	const onDeleteSuccess = useCallback((entity) => {
		console.debug("Deleted", entity);
	}, []);
	const onDeleteFailure = useCallback((entity, e) => {
		snackbarController.open({
			type: "error",
			title: t("error_deleting"),
			message: e?.message
		});
		console.error("Error deleting entity");
		console.error(e);
	}, [collection.name]);
	const performDelete = useCallback((entity) => deleteEntityWithCallbacks({
		data: dataClient,
		entity,
		collection,
		onDeleteSuccess,
		onDeleteFailure,
		context
	}), [
		dataClient,
		collection,
		onDeleteSuccess,
		onDeleteFailure,
		context
	]);
	const handleOk = useCallback(async () => {
		if (singleEntity) {
			setLoading(true);
			const success = await performDelete(singleEntity);
			setLoading(false);
			if (success) {
				onEntityDelete?.(path, singleEntity);
				snackbarController.open({
					type: "success",
					message: t("deleted", { name: collection.singularName ?? collection.name })
				});
				onClose();
			}
			return;
		}
		if (!selection) return;
		setLoading(true);
		cancelledRef.current = { aborted: false };
		let entities;
		try {
			entities = await resolveSelection({
				selection,
				accessor: dataClient.collection(path),
				signal: cancelledRef.current,
				onProgress: (loaded, total) => setProgress(total === void 0 ? t("selection_reading_rows_unknown", { loaded: loaded.toLocaleString() }) ?? `Reading rows… ${loaded}` : t("selection_reading_rows", {
					loaded: loaded.toLocaleString(),
					total: total.toLocaleString()
				}) ?? `Reading rows… ${loaded} of ${total}`)
			});
		} catch (e) {
			setLoading(false);
			setProgress(void 0);
			snackbarController.open({
				type: "error",
				title: t("error_deleting_entities", { collection: collection.name }),
				message: e?.message
			});
			return;
		}
		if (cancelledRef.current.aborted) {
			setLoading(false);
			setProgress(void 0);
			return;
		}
		let results = [];
		try {
			results = await mapWithConcurrency(entities, DELETE_CONCURRENCY, (entity) => cancelledRef.current.aborted ? Promise.resolve(false) : performDelete(entity), (completed, total) => setProgress(t("selection_deleting_progress", {
				completed: completed.toLocaleString(),
				total: total.toLocaleString()
			}) ?? `Deleted ${completed} of ${total}`));
		} catch (e) {
			console.error("Error deleting entities", e);
		}
		setLoading(false);
		setProgress(void 0);
		onMultipleEntitiesDelete?.(path, entities.filter((_, i) => results[i]));
		const deleted = results.filter(Boolean).length;
		if (deleted === entities.length && entities.length > 0) snackbarController.open({
			type: "success",
			message: t("multiple_deleted", { collection: collection.name })
		});
		else if (deleted > 0) snackbarController.open({
			type: "warning",
			message: t("some_entities_deleted", { collection: collection.name })
		});
		else snackbarController.open({
			type: "error",
			message: t("error_deleting_entities", { collection: collection.name })
		});
		onClose();
	}, [
		singleEntity,
		selection,
		performDelete,
		dataClient,
		path,
		onEntityDelete,
		onMultipleEntitiesDelete,
		onClose,
		snackbarController,
		collection.name,
		collection.singularName,
		t
	]);
	const entityName = collection.singularName ?? collection.name;
	let dialogTitle;
	if (singleEntity) dialogTitle = variant === "unlink" ? t("unlink_entity_confirm_title", { entityName }) ?? `Remove this ${entityName} from this record?` : t("delete_entity_confirm_title", { entityName });
	else if (variant === "unlink") dialogTitle = /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("b", { children: collection.name }),
		": ",
		t("confirm_multiple_unlink") ?? "Remove these from this record?"
	] });
	else if (selectionCount === void 0) dialogTitle = t("confirm_delete_selection_unknown") ?? "Delete every row matching the current filter?";
	else dialogTitle = t("confirm_delete_selection", {
		total: selectionCount.toLocaleString(),
		collection: collection.name
	}) ?? `Delete ${selectionCount.toLocaleString()} ${collection.name}?`;
	return /* @__PURE__ */ jsxs(Dialog, {
		maxWidth: singleEntity ? "2xl" : "lg",
		"aria-labelledby": "delete-dialog",
		open,
		onOpenChange: (open) => !open ? onClose() : void 0,
		children: [
			/* @__PURE__ */ jsx(DialogTitle, {
				id: "delete-dialog-title",
				children: dialogTitle
			}),
			/* @__PURE__ */ jsxs(DialogContent, {
				fullHeight: true,
				children: [
					variant === "unlink" && /* @__PURE__ */ jsx("div", {
						className: "px-4 pt-4",
						children: /* @__PURE__ */ jsx(Typography, {
							variant: "body2",
							color: "secondary",
							children: t("unlink_entity_confirm_body", { collectionName: collection.name }) ?? `It stays in ${collection.name} and remains available to other records.`
						})
					}),
					singleEntity && /* @__PURE__ */ jsx("div", {
						className: "p-4",
						children: /* @__PURE__ */ jsx(EntityViewBinding, {
							entity: singleEntity,
							collection,
							path
						})
					}),
					!singleEntity && variant === "delete" && /* @__PURE__ */ jsx("div", {
						className: "px-4 pt-4",
						children: /* @__PURE__ */ jsx(Typography, {
							variant: "body2",
							color: "secondary",
							children: t("confirm_delete_selection_body") ?? "This cannot be undone. Each row is deleted individually, so this may take a while."
						})
					})
				]
			}),
			/* @__PURE__ */ jsxs(DialogActions, { children: [
				loading && /* @__PURE__ */ jsx(CircularProgress, { size: "smallest" }),
				progress && /* @__PURE__ */ jsx(Typography, {
					variant: "caption",
					color: "secondary",
					children: progress
				}),
				/* @__PURE__ */ jsx(Button, {
					onClick: handleCancel,
					variant: "text",
					children: t("cancel")
				}),
				/* @__PURE__ */ jsx(Button, {
					autoFocus: true,
					disabled: loading,
					onClick: handleOk,
					variant: "filled",
					children: t("ok")
				})
			] })
		]
	});
}
//#endregion
//#region src/components/CollectionViewBinding/utils.ts
function addRecentId(collectionId, id) {
	const newRecentIds = [id, ...getRecentIds(collectionId).filter((i) => i !== id)];
	if (newRecentIds.length > 5) newRecentIds.pop();
	saveSearchedIdsLocally(collectionId, newRecentIds);
	return newRecentIds;
}
function saveSearchedIdsLocally(collectionId, ids) {
	writeStoredJson("recent_id_searches::" + collectionId, ids);
}
function getRecentIds(collectionId) {
	return readStoredJson("recent_id_searches::" + collectionId, {
		fallback: [],
		accept: isArrayValue
	});
}
//#endregion
//#region src/components/admin/CreationResultDialog.tsx
function CreationResultDialog({ result, onClose }) {
	const { t } = useTranslation();
	const snackbarController = useSnackbarController();
	const [copied, setCopied] = useState(false);
	const handleCopyPassword = async () => {
		if (!result.temporaryPassword) return;
		try {
			await navigator.clipboard.writeText(result.temporaryPassword);
			setCopied(true);
			snackbarController.open({
				type: "success",
				message: t("password_copied") ?? "Password copied to clipboard"
			});
			setTimeout(() => setCopied(false), 3e3);
		} catch {
			const textArea = document.createElement("textarea");
			textArea.value = result.temporaryPassword;
			document.body.appendChild(textArea);
			textArea.select();
			document.execCommand("copy");
			document.body.removeChild(textArea);
			setCopied(true);
			setTimeout(() => setCopied(false), 3e3);
		}
	};
	if (result.invitationSent) return /* @__PURE__ */ jsxs(Dialog, {
		open: true,
		onOpenChange: (open) => !open ? onClose() : void 0,
		maxWidth: "xl",
		children: [
			/* @__PURE__ */ jsx(DialogTitle, {
				variant: "h5",
				gutterBottom: false,
				children: /* @__PURE__ */ jsxs("div", {
					className: "flex items-center gap-3",
					children: [/* @__PURE__ */ jsx(MailIcon, {}), t("invitation_sent_title") ?? "Invitation Sent"]
				})
			}),
			/* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsx("div", {
				className: "flex flex-col gap-4 py-2",
				children: /* @__PURE__ */ jsx(Alert, {
					color: "success",
					children: /* @__PURE__ */ jsx(Typography, { children: (t("invitation_sent") ?? "An invitation email has been sent to {{email}}. They can use the link to set their password.").replace("{{email}}", result.user.email ?? "") })
				})
			}) }),
			/* @__PURE__ */ jsx(DialogActions, { children: /* @__PURE__ */ jsx(Button, {
				variant: "filled",
				onClick: onClose,
				children: t("ok")
			}) })
		]
	});
	if (result.temporaryPassword) return /* @__PURE__ */ jsxs(Dialog, {
		open: true,
		onOpenChange: (open) => !open ? onClose() : void 0,
		maxWidth: "xl",
		children: [
			/* @__PURE__ */ jsx(DialogTitle, {
				variant: "h5",
				gutterBottom: false,
				children: t("temporary_password") ?? "Temporary Password"
			}),
			/* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsxs("div", {
				className: "flex flex-col gap-4 py-2",
				children: [
					/* @__PURE__ */ jsx(Alert, {
						color: "warning",
						children: /* @__PURE__ */ jsx(Typography, {
							variant: "body2",
							children: result.emailDeliveryFailed ? t("temporary_password_email_failed_description") ?? "The email could not be delivered. Share this temporary password with the user securely. It will not be shown again." : t("temporary_password_description") ?? "Email is not configured. Share this temporary password with the user securely. It will not be shown again."
						})
					}),
					/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(Typography, {
						variant: "caption",
						color: "secondary",
						className: "mb-1",
						children: t("email")
					}), /* @__PURE__ */ jsx(Typography, { children: result.user.email })] }),
					/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(Typography, {
						variant: "caption",
						color: "secondary",
						className: "mb-1",
						children: t("temporary_password") ?? "Temporary Password"
					}), /* @__PURE__ */ jsxs("div", {
						className: "flex items-center gap-2 mt-1",
						children: [/* @__PURE__ */ jsx("code", {
							className: "flex-grow bg-surface-raised border border-hairline-strong rounded px-3 py-2 font-mono text-base select-all",
							children: result.temporaryPassword
						}), /* @__PURE__ */ jsx(Tooltip, {
							title: t("copy_password") ?? "Copy password",
							asChild: true,
							children: /* @__PURE__ */ jsx(IconButton, {
								onClick: handleCopyPassword,
								children: copied ? /* @__PURE__ */ jsx(CheckCircleIcon, { className: "text-green-600" }) : /* @__PURE__ */ jsx(CopyIcon, {})
							})
						})]
					})] })
				]
			}) }),
			/* @__PURE__ */ jsx(DialogActions, { children: /* @__PURE__ */ jsx(Button, {
				variant: "filled",
				onClick: onClose,
				children: t("ok")
			}) })
		]
	});
	return null;
}
//#endregion
//#region src/components/common/default_entity_actions.tsx
var editEntityAction = {
	icon: /* @__PURE__ */ jsx(PencilIcon, { size: iconSize.smallest }),
	key: "edit",
	name: "Edit",
	collapsed: false,
	isEnabled: ({ entity }) => Boolean(entity),
	onClick({ entity, collection, path, context, sidePanelController, highlightEntity, unhighlightEntity, openEntityMode }) {
		if (!entity) throw new Error("INTERNAL: editEntityAction: Entity is undefined");
		if (!sidePanelController) throw new Error("INTERNAL: editEntityAction: sidePanelController is undefined");
		highlightEntity?.(entity);
		context?.analyticsController?.onAnalyticsEvent?.("entity_click", {
			path: entity.path,
			entityId: entity.id
		});
		if (collection) addRecentId(collection.slug, entity.id);
		const newFullIdPath = path ?? collection?.slug ?? entity.path;
		const defaultSelectedView = collection?.defaultEntityAction === "view" ? "edit" : resolveDefaultSelectedView(collection ? collection.defaultSelectedView : void 0, {
			status: "existing",
			entityId: entity.id
		});
		if (!context?.urlController) throw new Error("INTERNAL: editEntityAction: urlController is undefined");
		navigateToEntity({
			openEntityMode,
			collection,
			entityId: entity.id,
			path: newFullIdPath,
			sidePanelController,
			onClose: () => unhighlightEntity?.(entity),
			navigation: context.urlController,
			selectedTab: defaultSelectedView
		});
		return Promise.resolve(void 0);
	}
};
var copyEntityAction = {
	icon: /* @__PURE__ */ jsx(CopyIcon, { size: iconSize.smallest }),
	name: "Copy",
	key: "copy",
	isEnabled: ({ entity }) => Boolean(entity),
	onClick({ entity, collection, context, path, sidePanelController, highlightEntity, unhighlightEntity, openEntityMode }) {
		if (!entity) throw new Error("INTERNAL: copyEntityAction: Entity is undefined");
		if (!sidePanelController) throw new Error("INTERNAL: copyEntityAction: sidePanelController is undefined");
		highlightEntity?.(entity);
		context?.analyticsController?.onAnalyticsEvent?.("copy_entity_click", {
			path: entity.path,
			entityId: entity.id
		});
		const usedPath = path ?? collection?.slug ?? entity.path;
		if (!context?.urlController) throw new Error("INTERNAL: copyEntityAction: urlController is undefined");
		navigateToEntity({
			openEntityMode,
			collection,
			entityId: entity.id,
			path: usedPath,
			copy: true,
			sidePanelController,
			onClose: () => unhighlightEntity?.(entity),
			navigation: context.urlController
		});
		return Promise.resolve(void 0);
	}
};
/**
* The destructive row action, in its two readings.
*
* The mechanics are identical — both issue a DELETE at the row's path — but
* what that *does* is not. On a many-to-many tab the path is
* `posts/1/tags/5`, and the backend removes the junction row: tag 5 keeps
* existing, and every other post keeps it. Labelling that "Delete" and warning
* about permanent removal describes an operation the server will not perform.
*/
function buildRemoveEntityAction({ key, name, icon, variant }) {
	return {
		icon,
		name,
		key,
		isEnabled: ({ entity }) => Boolean(entity),
		onClick({ entity, path, collection, context, selectionController, onCollectionChange, navigateBack, openEntityMode }) {
			if (!entity) throw new Error(`INTERNAL: ${key}EntityAction: Entity is undefined`);
			if (!context?.dialogsController) throw new Error(`INTERNAL: ${key}EntityAction: context.dialogsController is undefined`);
			const { closeDialog } = context.dialogsController.open({
				key: `${key}_entity_dialog_` + entity.id,
				Component: ({ open }) => {
					if (!collection || !path) throw new Error(`${key}EntityAction: Collection is undefined`);
					return /* @__PURE__ */ jsx(DeleteEntityDialog, {
						target: entity,
						path,
						collection,
						variant,
						open,
						onEntityDelete: () => {
							context?.analyticsController?.onAnalyticsEvent?.("single_entity_deleted", { path });
							selectionController?.toggleEntitySelection(entity, false);
							onCollectionChange?.();
							if (openEntityMode === "full_screen" && context?.urlController) {
								const collectionUrl = context.urlController.buildUrlCollectionPath(path);
								context.urlController.navigate(collectionUrl, { replace: true });
							} else navigateBack?.();
						},
						onClose: closeDialog
					});
				}
			});
			return Promise.resolve(void 0);
		}
	};
}
var deleteEntityAction = buildRemoveEntityAction({
	key: "delete",
	name: "Delete",
	icon: /* @__PURE__ */ jsx(Trash2Icon, { size: iconSize.smallest }),
	variant: "delete"
});
/**
* The destructive action on a tab whose rows are shared through a junction.
* Removes the row from *this* parent; the row itself is untouched.
*/
var unlinkEntityAction = buildRemoveEntityAction({
	key: "unlink",
	name: "Remove",
	icon: /* @__PURE__ */ jsx(Unlink2Icon, { size: iconSize.smallest }),
	variant: "unlink"
});
function ResetPasswordActionDialog({ user, open, onClose }) {
	const client = useRebaseClient();
	const { getAuthToken } = useAuthController();
	const snackbarController = useSnackbarController();
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const [creationResult, setCreationResult] = useState(null);
	const [mode, setMode] = useState("email");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [error, setError] = useState(null);
	const passwordsMatch = password === confirmPassword;
	const canSubmit = mode === "email" || password.length > 0 && passwordsMatch;
	const handleConfirm = async () => {
		if (mode === "manual" && !passwordsMatch) {
			setError(t("passwords_dont_match", { defaultValue: "Passwords don't match" }));
			return;
		}
		setLoading(true);
		setError(null);
		try {
			const apiBase = apiBaseOf(client) ?? "";
			const token = await getAuthToken?.();
			const response = await fetch(`${apiBase}/admin/users/${user.uid}/reset-password`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					...token ? { "Authorization": `Bearer ${token}` } : {}
				},
				body: JSON.stringify(mode === "manual" ? { password } : {})
			});
			if (!response.ok) {
				const errorBody = await response.json().catch(() => ({}));
				throw new Error(errorBody.error?.message || errorBody.message || "Failed to reset password");
			}
			const data = await response.json();
			snackbarController.open({
				type: "success",
				message: t("reset_password_success", { defaultValue: "Password reset successfully" })
			});
			if (data.invitationSent || data.temporaryPassword) setCreationResult({
				user,
				invitationSent: data.invitationSent ?? false,
				temporaryPassword: data.temporaryPassword,
				emailDeliveryFailed: data.emailDeliveryFailed ?? false
			});
			else onClose();
		} catch (e) {
			setError(e instanceof Error ? e.message : t("error_resetting_password", { defaultValue: "Error resetting password" }));
		} finally {
			setLoading(false);
		}
	};
	if (creationResult) return /* @__PURE__ */ jsx(CreationResultDialog, {
		result: creationResult,
		onClose: () => {
			setCreationResult(null);
			onClose();
		}
	});
	return /* @__PURE__ */ jsxs(Dialog, {
		open,
		onOpenChange: (o) => !o ? onClose() : void 0,
		maxWidth: "xl",
		children: [
			/* @__PURE__ */ jsx(DialogTitle, {
				variant: "h5",
				gutterBottom: false,
				children: t("reset_password", { defaultValue: "Reset Password" })
			}),
			/* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsxs("div", {
				className: "flex flex-col gap-4 py-2",
				children: [
					/* @__PURE__ */ jsx(Typography, {
						variant: "body2",
						color: "secondary",
						children: user.email
					}),
					/* @__PURE__ */ jsxs(RadioGroup, {
						value: mode,
						onValueChange: (v) => {
							setMode(v);
							setError(null);
						},
						children: [/* @__PURE__ */ jsxs("div", {
							className: "flex items-center gap-2",
							children: [/* @__PURE__ */ jsx(RadioGroupItem, {
								value: "email",
								id: "reset-password-mode-email"
							}), /* @__PURE__ */ jsx(Label, {
								htmlFor: "reset-password-mode-email",
								children: t("reset_password_send_email", { defaultValue: "Send a password reset email" })
							})]
						}), /* @__PURE__ */ jsxs("div", {
							className: "flex items-center gap-2",
							children: [/* @__PURE__ */ jsx(RadioGroupItem, {
								value: "manual",
								id: "reset-password-mode-manual"
							}), /* @__PURE__ */ jsx(Label, {
								htmlFor: "reset-password-mode-manual",
								children: t("reset_password_set_manually", { defaultValue: "Set a password manually" })
							})]
						})]
					}),
					mode === "manual" && /* @__PURE__ */ jsxs(Fragment, { children: [
						/* @__PURE__ */ jsx(TextField, {
							type: "password",
							value: password,
							autoFocus: true,
							autoComplete: "new-password",
							label: t("new_password", { defaultValue: "New Password" }),
							onChange: (e) => {
								setPassword(e.target.value);
								setError(null);
							}
						}),
						/* @__PURE__ */ jsx(TextField, {
							type: "password",
							value: confirmPassword,
							autoComplete: "new-password",
							error: confirmPassword.length > 0 && !passwordsMatch,
							label: t("confirm_password", { defaultValue: "Confirm New Password" }),
							onChange: (e) => {
								setConfirmPassword(e.target.value);
								setError(null);
							}
						}),
						/* @__PURE__ */ jsx(Typography, {
							variant: "caption",
							color: "secondary",
							children: t("reset_password_set_manually_description", { defaultValue: "The password is updated immediately and no email is sent. Share it with the user securely." })
						})
					] }),
					error && /* @__PURE__ */ jsx(Alert, {
						color: "error",
						children: /* @__PURE__ */ jsx(Typography, {
							variant: "body2",
							children: error
						})
					})
				]
			}) }),
			/* @__PURE__ */ jsxs(DialogActions, { children: [/* @__PURE__ */ jsx(Button, {
				variant: "text",
				onClick: onClose,
				disabled: loading,
				children: t("cancel")
			}), /* @__PURE__ */ jsx(LoadingButton, {
				variant: "filled",
				onClick: handleConfirm,
				loading,
				disabled: !canSubmit,
				children: t("reset_password", { defaultValue: "Reset Password" })
			})] })
		]
	});
}
var resetPasswordAction = {
	icon: /* @__PURE__ */ jsx(KeyRoundIcon, { size: iconSize.smallest }),
	name: "Reset Password",
	key: "reset_password",
	collapsed: false,
	showActionsInListView: true,
	isEnabled: ({ entity }) => Boolean(entity),
	onClick({ entity, context }) {
		if (!entity) throw new Error("INTERNAL: resetPasswordAction: Entity is undefined");
		if (!context?.dialogsController) throw new Error("INTERNAL: resetPasswordAction: context.dialogsController is undefined");
		const user = {
			uid: entity.id,
			email: entity.values?.email,
			displayName: entity.values?.displayName || null,
			photoURL: entity.values?.photoURL || null,
			providerId: entity.values?.providerId || "custom",
			isAnonymous: entity.values?.isAnonymous || false,
			roles: entity.values?.roles || []
		};
		const { closeDialog } = context.dialogsController.open({
			key: "reset_password_dialog_" + entity.id,
			Component: ({ open }) => /* @__PURE__ */ jsx(ResetPasswordActionDialog, {
				user,
				open,
				onClose: closeDialog
			})
		});
		return Promise.resolve(void 0);
	}
};
//#endregion
//#region src/components/CollectionTableBinding/internal/popup_field/useDraggable.tsx
/** Tracks events originating inside the inner (non-draggable) area. */
var innerClicked = /* @__PURE__ */ new WeakSet();
function useDraggable({ containerRef, innerRef, x, y, onMove }) {
	let relX = 0;
	let relY = 0;
	const listeningRef = React.useRef(false);
	const onMouseDown = useCallback((event) => {
		if (event.button !== 0 || !containerRef.current || event.defaultPrevented || innerClicked.has(event)) return;
		const { x, y } = containerRef.current.getBoundingClientRect();
		relX = event.screenX - x;
		relY = event.screenY - y;
		document.addEventListener("mousemove", onMouseMove);
		document.addEventListener("mouseup", onMouseUp);
		document.addEventListener("selectstart", onSelect);
		listeningRef.current = true;
	}, [containerRef, onMove]);
	const onMouseDownInner = useCallback((event) => {
		innerClicked.add(event);
	}, []);
	const onSelect = useCallback((event) => {
		event.preventDefault();
		event.stopPropagation();
	}, []);
	const onMouseUp = (event) => {
		document.removeEventListener("mousemove", onMouseMove);
		document.removeEventListener("mouseup", onMouseUp);
		document.removeEventListener("selectstart", onSelect);
		event.stopPropagation();
		listeningRef.current = false;
	};
	const onMouseMove = (event) => {
		if (event.target?.localName === "input" || !listeningRef.current) return;
		onMove({
			x: event.screenX - relX,
			y: event.screenY - relY
		});
		event.stopPropagation();
	};
	const update = () => {
		if (containerRef.current) {
			containerRef.current.style.top = `${y}px`;
			containerRef.current.style.left = `${x}px`;
		}
	};
	useEffect(() => {
		const current = containerRef.current;
		const innerCurrent = innerRef.current;
		if (!current || !innerCurrent) return;
		if (innerCurrent) innerCurrent.addEventListener("mousedown", onMouseDownInner);
		if (current) current.addEventListener("mousedown", onMouseDown);
		update();
		return () => {
			if (current) current.removeEventListener("mousedown", onMouseDown);
			if (innerCurrent) innerCurrent.removeEventListener("mousedown", onMouseDownInner);
		};
	}, [
		containerRef,
		innerRef,
		onMouseDownInner,
		onMouseDown
	]);
}
//#endregion
//#region src/components/CollectionTableBinding/internal/popup_field/useWindowSize.tsx
function useWindowSize() {
	const [size, setSize] = useState({
		width: 0,
		height: 0
	});
	useLayoutEffect(() => {
		function updateSize() {
			setSize({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener("resize", updateSize);
		updateSize();
		return () => window.removeEventListener("resize", updateSize);
	}, []);
	return size;
}
//#endregion
//#region src/components/CollectionTableBinding/internal/popup_field/PopupFormField.tsx
function PopupFormField(props) {
	if (!props.open) return null;
	return /* @__PURE__ */ jsx(PopupFormFieldLoading, { ...props });
}
function PopupFormFieldLoading({ tableKey, entityId, customFieldValidator, propertyKey, collection: inputCollection, path, cellRect, open, onClose, onCellValueChange, container }) {
	const dataClient = useData();
	const [entity, setEntity] = useState(void 0);
	useEffect(() => {
		if (entityId && inputCollection) dataClient.collection(path).findById(entityId).then((result) => setEntity(result));
	}, [
		entityId,
		inputCollection,
		dataClient,
		path
	]);
	if (!entity) return null;
	return /* @__PURE__ */ jsx(PopupFormFieldInternal, {
		tableKey,
		entityId,
		customFieldValidator,
		propertyKey,
		collection: inputCollection,
		path,
		cellRect,
		open,
		onClose,
		onCellValueChange,
		container,
		entity
	});
}
function PopupFormFieldInternal({ tableKey, entityId, customFieldValidator, propertyKey, collection, path, cellRect, open, onClose, onCellValueChange, container, entity }) {
	const rebaseContext = useRebaseContext();
	useAuthController();
	const customizationController = useCustomizationController();
	const [savingError, setSavingError] = React.useState();
	const [popupLocation, setPopupLocation] = useState();
	const windowSize = useWindowSize();
	const draggableRef = React.useRef(null);
	const innerRef = React.useRef(null);
	const initialPositionSet = React.useRef(false);
	const getInitialLocation = useCallback(() => {
		if (!cellRect) throw Error("getInitialLocation error");
		return {
			x: cellRect.left < windowSize.width - cellRect.right ? cellRect.x + cellRect.width / 2 : cellRect.x - cellRect.width / 2,
			y: cellRect.top < windowSize.height - cellRect.bottom ? cellRect.y + cellRect.height / 2 : cellRect.y - cellRect.height / 2
		};
	}, [
		cellRect,
		windowSize.height,
		windowSize.width
	]);
	const normalizePosition = useCallback((pos, draggableBoundingRect, currentWindowSize) => {
		if (!draggableBoundingRect || draggableBoundingRect.width === 0 || draggableBoundingRect.height === 0) return pos;
		return {
			x: Math.max(0, Math.min(pos.x, currentWindowSize.width - draggableBoundingRect.width)),
			y: Math.max(0, Math.min(pos.y, currentWindowSize.height - draggableBoundingRect.height))
		};
	}, []);
	const updatePopupLocation = useCallback((newPositionCandidate) => {
		const draggableBoundingRect = draggableRef.current?.getBoundingClientRect();
		if (!cellRect || !draggableBoundingRect || draggableBoundingRect.width === 0 || draggableBoundingRect.height === 0) return;
		const basePosition = newPositionCandidate ?? getInitialLocation();
		const newNormalizedPosition = normalizePosition(basePosition, draggableBoundingRect, windowSize);
		if (!popupLocation || newNormalizedPosition.x !== popupLocation.x || newNormalizedPosition.y !== popupLocation.y) setPopupLocation(newNormalizedPosition);
	}, [
		cellRect,
		getInitialLocation,
		normalizePosition,
		popupLocation,
		windowSize
	]);
	useDraggable({
		containerRef: draggableRef,
		innerRef,
		x: popupLocation?.x,
		y: popupLocation?.y,
		onMove: updatePopupLocation
	});
	useEffect(() => {
		initialPositionSet.current = false;
	}, [propertyKey, entity]);
	useLayoutEffect(() => {
		if (!cellRect || initialPositionSet.current) return;
		const draggableBoundingRect = draggableRef.current?.getBoundingClientRect();
		if (!draggableBoundingRect || draggableBoundingRect.width === 0 || draggableBoundingRect.height === 0) return;
		updatePopupLocation();
		initialPositionSet.current = true;
	}, [cellRect, updatePopupLocation]);
	useLayoutEffect(() => {
		updatePopupLocation(popupLocation);
	}, [
		windowSize,
		cellRect,
		updatePopupLocation,
		popupLocation
	]);
	const validationSchema = useMemo(() => {
		if (!collection || !entityId) return;
		return getEntitySchema(entityId, propertyKey && collection.properties[propertyKey] ? { [propertyKey]: collection.properties[propertyKey] } : {}, customFieldValidator);
	}, [
		collection,
		entityId,
		propertyKey,
		customFieldValidator
	]);
	const adaptResize = useCallback(() => {
		return updatePopupLocation(popupLocation);
	}, [popupLocation, updatePopupLocation]);
	useEffect(() => {
		const element = draggableRef.current;
		if (!element) return;
		const observer = new ResizeObserver(() => {
			adaptResize();
		});
		observer.observe(element);
		return () => {
			observer.unobserve(element);
			observer.disconnect();
		};
	}, [adaptResize, draggableRef]);
	const saveValue = async (values) => {
		setSavingError(null);
		if (collection && entity && onCellValueChange && propertyKey) return onCellValueChange({
			value: values[propertyKey],
			propertyKey,
			data: entity,
			setError: setSavingError,
			onValueUpdated: () => {}
		});
		return Promise.resolve();
	};
	const formex = useCreateFormex({
		initialValues: entity?.values ?? {},
		validation: async (values) => {
			if (!validationSchema) return {};
			const result = await validationSchema.safeParseAsync(values);
			if (result.success) return {};
			return zodToFormErrors(result.error);
		},
		validateOnInitialRender: true,
		onSubmit: (values, actions) => {
			saveValue(values).then(() => {
				formex.resetForm({ values });
				onClose();
			}).finally(() => actions.setSubmitting(false));
		}
	});
	const { values, isSubmitting, setFieldValue, handleSubmit } = formex;
	const disabled = isSubmitting;
	const formContext = {
		collection,
		entityId,
		values,
		path,
		setFieldValue,
		save: saveValue,
		submit: handleSubmit,
		formex,
		status: "existing",
		openEntityMode: "side_panel",
		disabled: false
	};
	const property = propertyKey && getPropertyInPath$1(collection?.properties ?? {}, propertyKey);
	const fieldProps = propertyKey && property ? {
		propertyKey,
		disabled: isSubmitting || isReadOnly(property) || isDisabled(property),
		property,
		includeDescription: false,
		underlyingValueHasChanged: false,
		context: formContext,
		partOfArray: false,
		minimalistView: true,
		autoFocus: open
	} : void 0;
	let internalForm = /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("div", {
		className: "w-[700px] max-w-full max-h-[85vh]",
		children: /* @__PURE__ */ jsxs("form", {
			onSubmit: handleSubmit,
			noValidate: true,
			children: [/* @__PURE__ */ jsx("div", {
				className: "mb-1 p-4 flex flex-col relative",
				children: /* @__PURE__ */ jsx("div", {
					ref: innerRef,
					className: "cursor-auto",
					style: { cursor: "auto !important" },
					children: fieldProps && /* @__PURE__ */ jsx(PropertyFieldBinding, { ...fieldProps })
				})
			}), /* @__PURE__ */ jsx(DialogActions, { children: /* @__PURE__ */ jsx(Button, {
				variant: "filled",
				color: "primary",
				type: "submit",
				disabled,
				children: "Save"
			}) })]
		})
	}, `popup_form_${tableKey}_${entityId}_${propertyKey}`) });
	const plugins = customizationController.plugins;
	if (plugins && plugins.length > 0) internalForm = /* @__PURE__ */ jsx(PluginProviderStack, {
		plugins,
		scope: "form",
		scopeProps: {
			status: "existing",
			path,
			collection,
			entity,
			context: rebaseContext,
			currentEntityId: entityId,
			formContext
		},
		children: internalForm
	});
	const form = /* @__PURE__ */ jsxs("div", {
		className: `text-surface-900 dark:text-white overflow-auto rounded-xs rounded-md bg-surface-card ${!open ? "hidden" : ""} cursor-grab max-w-[100vw]`,
		children: [internalForm, savingError && /* @__PURE__ */ jsx(Typography, {
			color: "error",
			children: savingError.message
		})]
	});
	const draggable = /* @__PURE__ */ jsx("div", {
		style: { boxShadow: "0 0 0 2px rgba(128,128,128,0.2)" },
		className: `inline-block fixed z-20 shadow-outline rounded-md bg-surface-card ${!open ? "invisible" : "visible"} cursor-grab overflow-visible`,
		ref: draggableRef,
		children: /* @__PURE__ */ jsxs("div", {
			className: "overflow-hidden",
			children: [form, /* @__PURE__ */ jsx("div", {
				className: "absolute -top-3.5 -right-3.5 bg-surface-500 rounded-full",
				style: {
					width: "32px",
					height: "32px"
				},
				children: /* @__PURE__ */ jsx(IconButton, {
					size: "small",
					onClick: (event) => {
						event.stopPropagation();
						onClose();
					},
					children: /* @__PURE__ */ jsx(XIcon, { className: "text-white" })
				})
			})]
		})
	}, `draggable_${propertyKey}_${entityId}_${open}`);
	return /* @__PURE__ */ jsx(Portal.Root, {
		asChild: true,
		container,
		children: /* @__PURE__ */ jsx(Formex, {
			value: formex,
			children: draggable
		})
	});
}
//#endregion
//#region src/components/ClearFilterSortButton.tsx
function ClearFilterSortButton({ tableController, enabled, compact }) {
	const { t } = useTranslation();
	if (!enabled) return null;
	const filterIsSet = !!tableController.filterValues && Object.keys(tableController.filterValues).length > 0;
	const sortIsSet = !!tableController.sortBy && tableController.sortBy.length > 0;
	if ((filterIsSet || sortIsSet) && (tableController.clearFilter || tableController.setSortBy)) {
		let label;
		if (filterIsSet && sortIsSet) label = t("clear_filter_sort");
		else if (filterIsSet) label = t("clear_filter");
		else label = t("clear_sort");
		return /* @__PURE__ */ jsx(Tooltip, {
			title: label,
			children: /* @__PURE__ */ jsx(IconButton, {
				size: "small",
				"aria-label": label,
				onClick: () => {
					tableController.clearFilter?.();
					tableController.setSortBy?.(void 0);
				},
				children: /* @__PURE__ */ jsx(FilterXIcon, { size: compact ? iconSize.smallest : iconSize.small })
			})
		});
	}
	return null;
}
//#endregion
//#region src/components/CollectionViewBinding/FiltersDialog.tsx
/**
* Dialog that displays all filterable properties from a collection
* and allows setting filter values for each.
*/
function FiltersDialog({ open, onOpenChange, properties, filterValues, setFilterValues, fixedFilter }) {
	const { t } = useTranslation();
	const engine = useCollectionScope()?.engine;
	const [localFilters, setLocalFilters] = useState(filterValues ?? {});
	const [hiddenFields, setHiddenFields] = useState({});
	React.useEffect(() => {
		if (open) setLocalFilters(filterValues ?? {});
	}, [open, filterValues]);
	const filterableProperties = useMemo(() => {
		return Object.entries(properties).filter(([key, property]) => {
			if (!property) return false;
			if (fixedFilter && key in fixedFilter) return false;
			const isArray = property.type === "array";
			const ofProp = isArray && "of" in property ? property.of : void 0;
			const baseProperty = isArray ? Array.isArray(ofProp) ? ofProp[0] : ofProp : property;
			if (!baseProperty) return false;
			if (baseProperty.admin?.Filter) return true;
			return resolveFilterOperators({
				property: baseProperty,
				isArray,
				engine
			}).length > 0;
		});
	}, [
		properties,
		fixedFilter,
		engine
	]);
	const handleFilterChange = useCallback((propertyKey, value) => {
		setLocalFilters((prev) => {
			const newFilters = { ...prev };
			if (value) newFilters[propertyKey] = value;
			else delete newFilters[propertyKey];
			return newFilters;
		});
	}, []);
	const handleApply = useCallback(() => {
		setFilterValues(Object.keys(localFilters).length > 0 ? {
			...localFilters,
			...fixedFilter
		} : fixedFilter || void 0);
		onOpenChange(false);
	}, [
		localFilters,
		setFilterValues,
		fixedFilter,
		onOpenChange
	]);
	const handleClearAll = useCallback(() => {
		setLocalFilters({});
	}, []);
	const setHiddenForField = useCallback((propertyKey, hidden) => {
		setHiddenFields((prev) => ({
			...prev,
			[propertyKey]: hidden
		}));
	}, []);
	const isAnyFieldHidden = Object.values(hiddenFields).some((hidden) => hidden);
	const activeFilterCount = Object.keys(localFilters).length;
	const renderFilterField = useCallback((propertyKey, property) => {
		const filterValue = localFilters[propertyKey];
		const setValue = (value) => handleFilterChange(propertyKey, value);
		return /* @__PURE__ */ jsx(FilterFieldBinding, {
			propertyKey,
			property,
			engine,
			value: filterValue,
			setValue,
			hidden: hiddenFields[propertyKey] ?? false,
			setHidden: (hidden) => setHiddenForField(propertyKey, hidden)
		});
	}, [
		localFilters,
		handleFilterChange,
		hiddenFields,
		setHiddenForField,
		engine
	]);
	return /* @__PURE__ */ jsxs(Dialog, {
		open,
		onOpenChange,
		maxWidth: "3xl",
		fullWidth: true,
		containerClassName: isAnyFieldHidden ? "hidden" : void 0,
		children: [
			/* @__PURE__ */ jsxs(DialogTitle, {
				className: "flex items-center gap-2",
				variant: "h6",
				children: [t("filters"), activeFilterCount > 0 && /* @__PURE__ */ jsx("span", {
					className: "ml-2 px-2 py-0.5 text-xs rounded-full bg-primary text-white",
					children: activeFilterCount
				})]
			}),
			/* @__PURE__ */ jsx(DialogContent, { children: filterableProperties.length === 0 ? /* @__PURE__ */ jsx(Typography, {
				color: "secondary",
				className: "py-8 text-center",
				children: t("no_filterable_properties")
			}) : /* @__PURE__ */ jsx("table", {
				className: "w-full border-collapse",
				children: /* @__PURE__ */ jsx("tbody", { children: filterableProperties.map(([propertyKey, property], index) => {
					const hasFilter = propertyKey in localFilters;
					return /* @__PURE__ */ jsxs("tr", {
						className: cls(index > 0 && "border-t", defaultBorderMixin),
						children: [/* @__PURE__ */ jsx("td", {
							className: "py-3 pr-4 align-middle w-[160px]",
							children: /* @__PURE__ */ jsx(Typography, {
								variant: "body2",
								className: cls("font-medium", hasFilter && "text-primary"),
								children: property.name || propertyKey
							})
						}), /* @__PURE__ */ jsx("td", {
							className: "py-3",
							children: renderFilterField(propertyKey, property)
						})]
					}, propertyKey);
				}) })
			}) }),
			/* @__PURE__ */ jsxs(DialogActions, { children: [
				/* @__PURE__ */ jsx(Button, {
					variant: "text",
					onClick: handleClearAll,
					disabled: activeFilterCount === 0,
					children: t("clear_all")
				}),
				/* @__PURE__ */ jsx("div", { className: "flex-grow" }),
				/* @__PURE__ */ jsx(Button, {
					variant: "text",
					onClick: () => onOpenChange(false),
					children: t("cancel")
				}),
				/* @__PURE__ */ jsx(Button, {
					variant: "filled",
					onClick: handleApply,
					children: t("apply_filters")
				})
			] })
		]
	});
}
//#endregion
//#region src/components/CollectionViewBinding/FilterPresetsButton.tsx
/**
* Maximum number of presets shown as inline toggle chips before the
* rest are collapsed into an overflow menu.
*/
var MAX_VISIBLE_PRESETS = 4;
/** Max characters for a chip label before truncation. */
var MAX_LABEL_LENGTH = 22;
/**
* Deep equality without JSON.stringify.
* Handles primitives, arrays, Dates, and plain objects recursively.
*/
function deepEqual$1(a, b) {
	if (a === b) return true;
	if (a == null || b == null) return false;
	if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
	if (Array.isArray(a) && Array.isArray(b)) {
		if (a.length !== b.length) return false;
		return a.every((v, i) => deepEqual$1(v, b[i]));
	}
	if (typeof a === "object" && typeof b === "object") {
		const aKeys = Object.keys(a);
		const bKeys = Object.keys(b);
		if (aKeys.length !== bKeys.length) return false;
		return aKeys.every((k) => deepEqual$1(a[k], b[k]));
	}
	return false;
}
/**
* Check if a preset's filters are a subset of the controller's
* current filter values (key-by-key deep comparison on the tuples).
*/
function isPresetActive(preset, controllerFilters) {
	if (!controllerFilters) return false;
	const entries = Object.entries(preset.filterValues);
	if (entries.length === 0) return false;
	for (const [key, presetTuple] of entries) {
		const controllerTuple = controllerFilters[key];
		if (!controllerTuple || !presetTuple) return false;
		if (!deepEqual$1(presetTuple, controllerTuple)) return false;
	}
	return true;
}
/**
* Generate a human-readable label from filter keys when no explicit label is provided.
*/
function generateLabel(filterValues) {
	const keys = Object.keys(filterValues);
	if (keys.length === 0) return "Filter";
	if (keys.length === 1) return keys[0].replace(/_/g, " ");
	if (keys.length === 2) return keys.map((k) => k.replace(/_/g, " ")).join(" + ");
	return `${keys[0].replace(/_/g, " ")} +${keys.length - 1}`;
}
/**
* Truncate a label if it exceeds MAX_LABEL_LENGTH.
*/
function truncateLabel(label) {
	if (label.length <= MAX_LABEL_LENGTH) return {
		display: label,
		truncated: false
	};
	return {
		display: label.slice(0, MAX_LABEL_LENGTH - 1) + "…",
		truncated: true
	};
}
function OverflowMenu({ presets, activeSet, onToggle }) {
	const activeCount = presets.filter((p) => activeSet.has(p.originalIndex)).length;
	return /* @__PURE__ */ jsx(Menu, {
		trigger: /* @__PURE__ */ jsxs(FilterChip, {
			active: activeCount > 0,
			icon: /* @__PURE__ */ jsx(ChevronsUpDownIcon, { size: 12 }),
			children: ["+", presets.length]
		}),
		side: "bottom",
		align: "start",
		children: /* @__PURE__ */ jsx("div", {
			className: "min-w-[180px] max-w-[300px] max-h-[320px] overflow-y-auto",
			children: presets.map(({ preset, originalIndex }) => {
				const rawLabel = preset.label ?? generateLabel(preset.filterValues);
				const active = activeSet.has(originalIndex);
				return /* @__PURE__ */ jsx(MenuItem, {
					dense: true,
					onClick: () => onToggle(originalIndex),
					className: cls(active && "bg-primary/10 dark:bg-primary/20"),
					children: /* @__PURE__ */ jsxs("span", {
						className: "flex items-center gap-2 w-full min-w-0",
						children: [active && /* @__PURE__ */ jsx(CheckIcon, {
							size: 14,
							className: "text-primary shrink-0"
						}), /* @__PURE__ */ jsx("span", {
							className: cls("truncate", active ? "text-primary font-medium" : ""),
							children: rawLabel
						})]
					})
				}, originalIndex);
			})
		})
	});
}
/**
* Filter Presets — displayed as inline toggle chips in the collection toolbar.
*
* Active state is **derived** from the controller's actual filter values,
* not tracked locally. A chip is "active" when ALL of its filter entries
* match the current controller state (deep value comparison, no JSON.stringify).
*
* This means:
* - Toggling a preset on adds its filters to the controller.
* - Toggling it off removes its filter keys.
* - Changing filters via the dialog automatically deactivates unmatched chips.
* - Clearing all filters deactivates all chips.
* - Multiple presets can be active simultaneously.
*/
function FilterPresetsButton({ filterPresets, tableController, compact }) {
	const activeSet = useMemo(() => {
		const set = /* @__PURE__ */ new Set();
		if (!filterPresets.length || !tableController.setFilterValues) return set;
		for (let i = 0; i < filterPresets.length; i++) if (isPresetActive(filterPresets[i], tableController.filterValues)) set.add(i);
		return set;
	}, [
		filterPresets,
		tableController.filterValues,
		tableController.setFilterValues
	]);
	const handleToggle = useCallback((index) => {
		const preset = filterPresets[index];
		const currentFilters = { ...tableController.filterValues ?? {} };
		const wasActive = isPresetActive(preset, currentFilters);
		if (wasActive) {
			for (const key of Object.keys(preset.filterValues)) delete currentFilters[key];
			for (let i = 0; i < filterPresets.length; i++) {
				if (i === index) continue;
				const other = filterPresets[i];
				if (isPresetActive(other, currentFilters)) Object.assign(currentFilters, other.filterValues);
			}
		} else Object.assign(currentFilters, preset.filterValues);
		if (Object.keys(currentFilters).length === 0) {
			if (tableController.clearFilter) tableController.clearFilter();
			else tableController.setFilterValues?.({});
			tableController.setSortBy?.(void 0);
		} else {
			tableController.setFilterValues?.(currentFilters);
			if (!wasActive && preset.sort) tableController.setSortBy?.(normalizeOrderBy(preset.sort));
			else if (wasActive) {
				let remainingSort;
				for (let i = 0; i < filterPresets.length; i++) {
					if (i === index) continue;
					const other = filterPresets[i];
					if (isPresetActive(other, currentFilters) && other.sort) remainingSort = normalizeOrderBy(other.sort);
				}
				tableController.setSortBy?.(remainingSort);
			}
		}
	}, [filterPresets, tableController]);
	if (!filterPresets.length || !tableController.setFilterValues) return null;
	const maxVisible = compact ? 2 : MAX_VISIBLE_PRESETS;
	const needsOverflow = filterPresets.length > maxVisible;
	const visibleCount = needsOverflow ? maxVisible - 1 : filterPresets.length;
	const visiblePresets = filterPresets.slice(0, visibleCount);
	const overflowPresets = needsOverflow ? filterPresets.slice(visibleCount).map((preset, i) => ({
		preset,
		originalIndex: visibleCount + i
	})) : [];
	const hasOverflow = overflowPresets.length > 0;
	return /* @__PURE__ */ jsxs("div", {
		className: "flex items-center gap-1 min-w-0 overflow-hidden",
		children: [/* @__PURE__ */ jsx("div", {
			className: "flex items-center gap-1 min-w-0 overflow-x-auto py-0.5",
			style: { scrollbarWidth: "none" },
			children: visiblePresets.map((preset, index) => {
				const rawLabel = preset.label ?? generateLabel(preset.filterValues);
				const { display, truncated } = truncateLabel(rawLabel);
				const chip = /* @__PURE__ */ jsx(FilterChip, {
					active: activeSet.has(index),
					onClick: () => handleToggle(index),
					size: "small",
					children: display
				}, index);
				if (truncated) return /* @__PURE__ */ jsx(Tooltip, {
					title: rawLabel,
					children: chip
				}, index);
				return chip;
			})
		}), hasOverflow && /* @__PURE__ */ jsx(OverflowMenu, {
			presets: overflowPresets,
			activeSet,
			onToggle: handleToggle
		})]
	});
}
//#endregion
//#region src/components/CollectionViewBinding/SortButton.tsx
/**
* Toolbar control that orders the collection.
*
* The table orders by clicking a column header, which leaves every other view
* mode — list, cards, and either of them inside a split view — with no way to
* order at all, even though the controller has always carried `sortBy` and the
* query has always honoured it. This binds a control to it.
*
* It edits the *whole* order rather than a single key. A sort can have several
* keys, applied in the order shown: the second decides between rows the first
* calls equal, the third between rows the first two do. So the active keys sit
* at the top, numbered and movable, and the properties below them are the ones
* that can still be added under the last. Shift-clicking a column header does
* the same thing from the table; this is the view for the modes that have no
* headers, and the only place the order between keys can be changed.
*
* Clicking an active key flips its direction, so ascending → descending is one
* click rather than a trip through a direction selector; clicking an inactive
* one appends it ascending. The popover stays open through all of it — building
* a two-key order out of a control that closes on every click is four round
* trips through a button.
*/
function SortButton({ tableController, properties, compact }) {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const options = useMemo(() => getSortablePropertyOptions(properties), [properties]);
	const { sortBy, setSortBy, setItemCount, pageSize, filterValues, checkFilterCombination } = tableController;
	const keys = useMemo(() => sortBy ?? [], [sortBy]);
	const activeIndex = useMemo(() => {
		const index = /* @__PURE__ */ new Map();
		keys.forEach(([key, direction], position) => {
			if (!index.has(key)) index.set(key, {
				direction,
				position
			});
		});
		return index;
	}, [keys]);
	const applySort = useCallback((next) => {
		setSortBy?.(next && next.length > 0 ? next : void 0);
		if (pageSize !== void 0) setItemCount?.(pageSize);
	}, [
		setSortBy,
		setItemCount,
		pageSize
	]);
	/** Flip an active key's direction, or append an inactive one ascending. */
	const onOptionClick = useCallback((key) => {
		const active = activeIndex.get(key);
		if (!active) {
			applySort([...keys, [key, "asc"]]);
			return;
		}
		applySort(keys.map((entry) => entry[0] === key ? [key, active.direction === "asc" ? "desc" : "asc"] : entry));
	}, [
		activeIndex,
		applySort,
		keys
	]);
	const removeKey = useCallback((key) => {
		applySort(keys.filter(([existing]) => existing !== key));
	}, [applySort, keys]);
	/** What a click on an active key will do to it, for the tooltip and the label. */
	const flipLabel = useCallback((direction) => direction === "asc" ? t("sort_descending") : t("sort_ascending"), [t]);
	/** Swap a key with its neighbour, which is what changes which one decides. */
	const moveKey = useCallback((position, delta) => {
		const target = position + delta;
		if (target < 0 || target >= keys.length) return;
		const next = [...keys];
		[next[position], next[target]] = [next[target], next[position]];
		applySort(next);
	}, [applySort, keys]);
	if (!setSortBy || options.length === 0) return null;
	const primary = keys[0];
	const primaryTitle = primary ? options.find((option) => option.key === primary[0])?.title ?? primary[0] : void 0;
	const label = primaryTitle ? keys.length > 1 ? `${t("sort_by")}: ${primaryTitle} +${keys.length - 1}` : `${t("sort_by")}: ${primaryTitle}` : t("sort");
	const arrowSize = compact ? iconSize.smallest : iconSize.small;
	const primaryDirection = primary?.[1];
	const trigger = /* @__PURE__ */ jsx(IconButton, {
		size: "small",
		"aria-label": label,
		title: label,
		className: cls(primaryTitle && "text-primary"),
		children: primaryDirection === "desc" ? /* @__PURE__ */ jsx(ArrowDownIcon, { size: arrowSize }) : primaryDirection === "asc" ? /* @__PURE__ */ jsx(ArrowUpIcon, { size: arrowSize }) : /* @__PURE__ */ jsx(ArrowUpDownIcon, { size: arrowSize })
	});
	const inactiveOptions = options.filter((option) => !activeIndex.has(option.key));
	return /* @__PURE__ */ jsx(Popover, {
		open,
		onOpenChange: setOpen,
		modal: false,
		side: "bottom",
		align: "start",
		trigger,
		children: /* @__PURE__ */ jsxs("div", {
			className: "py-2 min-w-[280px] max-w-[360px] flex flex-col",
			children: [
				/* @__PURE__ */ jsx(Typography, {
					variant: "caption",
					color: "secondary",
					className: "font-medium uppercase tracking-wider px-3 pb-1",
					children: t("sort_by")
				}),
				keys.length > 0 && /* @__PURE__ */ jsx("div", {
					className: "flex flex-col max-h-[200px] overflow-y-auto",
					children: keys.map(([key, direction], position) => {
						const option = options.find((o) => o.key === key);
						return /* @__PURE__ */ jsxs("div", {
							className: "flex items-center gap-1 pl-3 pr-2 py-1 text-sm text-primary",
							children: [
								/* @__PURE__ */ jsx("span", {
									className: "flex-shrink-0 w-4 text-xs tabular-nums text-text-secondary dark:text-text-secondary-dark",
									children: position + 1
								}),
								/* @__PURE__ */ jsxs("button", {
									type: "button",
									onClick: () => onOptionClick(key),
									title: flipLabel(direction),
									"aria-label": `${option?.title ?? key} — ${t("sort_key_position", { position: position + 1 })}. ${flipLabel(direction)}`,
									className: "flex items-center gap-2 flex-grow min-w-0 text-left cursor-pointer",
									children: [
										option && /* @__PURE__ */ jsx("span", {
											className: "flex-shrink-0 flex items-center",
											children: getIconForProperty(option.property, "smallest")
										}),
										/* @__PURE__ */ jsx("span", {
											className: "flex-grow truncate",
											children: option?.title ?? key
										}),
										/* @__PURE__ */ jsx("span", {
											className: "flex-shrink-0 flex items-center",
											children: direction === "desc" ? /* @__PURE__ */ jsx(ArrowDownIcon, { size: iconSize.smallest }) : /* @__PURE__ */ jsx(ArrowUpIcon, { size: iconSize.smallest })
										})
									]
								}),
								/* @__PURE__ */ jsxs("div", {
									className: cls("flex-shrink-0 flex items-center gap-0.5 ml-1 pl-1 border-l", defaultBorderMixin),
									children: [keys.length > 1 && /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(IconButton, {
										size: "smallest",
										"aria-label": t("sort_move_up"),
										title: t("sort_move_up"),
										disabled: position === 0,
										onClick: () => moveKey(position, -1),
										children: /* @__PURE__ */ jsx(ChevronUpIcon, { size: iconSize.smallest })
									}), /* @__PURE__ */ jsx(IconButton, {
										size: "smallest",
										"aria-label": t("sort_move_down"),
										title: t("sort_move_down"),
										disabled: position === keys.length - 1,
										onClick: () => moveKey(position, 1),
										children: /* @__PURE__ */ jsx(ChevronDownIcon, { size: iconSize.smallest })
									})] }), /* @__PURE__ */ jsx(IconButton, {
										size: "smallest",
										"aria-label": t("sort_remove_key"),
										title: t("sort_remove_key"),
										onClick: () => removeKey(key),
										children: /* @__PURE__ */ jsx(XIcon, { size: iconSize.smallest })
									})]
								})
							]
						}, key);
					})
				}),
				keys.length > 0 && inactiveOptions.length > 0 && /* @__PURE__ */ jsx(Typography, {
					variant: "caption",
					color: "secondary",
					className: "font-medium uppercase tracking-wider px-3 pt-2 pb-1",
					children: t("sort_then_by")
				}),
				/* @__PURE__ */ jsx("div", {
					className: "max-h-[280px] overflow-y-auto flex flex-col",
					children: inactiveOptions.map(({ key, title, property }) => {
						const disabled = checkFilterCombination ? !checkFilterCombination(filterValues ?? {}, [...keys, [key, "asc"]]) : false;
						return /* @__PURE__ */ jsxs("button", {
							type: "button",
							"aria-label": keys.length > 0 ? `${t("sort_then_by")} ${title}` : `${t("sort_by")} ${title}`,
							disabled,
							onClick: () => onOptionClick(key),
							className: cls("flex items-center gap-2 px-3 py-1.5 text-sm text-left w-full", disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-surface-hover"),
							children: [/* @__PURE__ */ jsx("span", {
								className: "flex-shrink-0 flex items-center",
								children: getIconForProperty(property, "smallest")
							}), /* @__PURE__ */ jsx("span", {
								className: "flex-grow truncate",
								children: title
							})]
						}, key);
					})
				}),
				/* @__PURE__ */ jsx("div", {
					className: "px-3 pt-2",
					children: /* @__PURE__ */ jsx(Button, {
						variant: "text",
						size: "small",
						className: "w-full",
						disabled: keys.length === 0,
						onClick: () => applySort(void 0),
						children: t("clear_sort")
					})
				})
			]
		})
	});
}
//#endregion
//#region src/components/CollectionViewBinding/CollectionViewStartActions.tsx
function CollectionViewStartActions({ collection, relativePath, parentCollectionSlugs, parentEntityIds, path, selectionController, tableController, collectionEntitiesCount, entitiesCount, resolvedProperties, viewMode, selectionEnabled, selectionQuery, compact, openNewDocument }) {
	const context = useAdminContext();
	const largeLayout = useLargeLayout();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const urlController = useUrlController();
	const splitView = useSplitView();
	const [filtersDialogOpen, setFiltersDialogOpen] = useState(false);
	const filterValues = tableController.filterValues;
	const fixedFilter = collection.fixedFilter;
	const activeFilterCount = filterValues ? Object.keys(filterValues).filter((key) => !fixedFilter || !(key in fixedFilter)).length : 0;
	const actionProps = {
		path,
		relativePath,
		parentCollectionSlugs,
		parentEntityIds,
		collection,
		selectionController,
		context,
		tableController,
		collectionEntitiesCount,
		openNewDocument
	};
	const handleBackClick = useCallback(() => {
		navigate(withViewMode(urlController.buildUrlCollectionPath(path)));
	}, [
		navigate,
		urlController,
		path
	]);
	const backButton = compact && !splitView?.detailOpen && /* @__PURE__ */ jsx(Tooltip, {
		title: t("close"),
		children: /* @__PURE__ */ jsx(IconButton, {
			size: "small",
			onClick: handleBackClick,
			"aria-label": t("close"),
			className: "mr-1",
			children: /* @__PURE__ */ jsx(XIcon, { size: iconSize.smallest })
		})
	}, "close_tooltip");
	const iconOnlyToolbar = !largeLayout || Boolean(compact);
	const filtersButton = resolvedProperties && tableController.setFilterValues && /* @__PURE__ */ jsx(Tooltip, {
		title: t("filters"),
		children: /* @__PURE__ */ jsx(Badge, {
			color: "primary",
			invisible: activeFilterCount === 0,
			children: largeLayout && !compact ? /* @__PURE__ */ jsx(Button, {
				variant: "text",
				size: "small",
				onClick: () => setFiltersDialogOpen(true),
				startIcon: /* @__PURE__ */ jsx(FilterIcon, { size: iconSize.small }),
				className: cls(activeFilterCount > 0 && "text-primary"),
				children: activeFilterCount > 0 ? `(${activeFilterCount})` : t("filters")
			}) : /* @__PURE__ */ jsx(IconButton, {
				size: "small",
				onClick: () => setFiltersDialogOpen(true),
				className: cls(activeFilterCount > 0 && "text-primary"),
				children: /* @__PURE__ */ jsx(FilterIcon, { size: iconSize.smallest })
			})
		})
	}, "filters_tooltip");
	const sortButton = resolvedProperties && viewMode !== "kanban" && /* @__PURE__ */ jsx(SortButton, {
		tableController,
		properties: resolvedProperties,
		compact: iconOnlyToolbar
	}, "sort_button");
	const filterPresetsButton = !compact && collection.filterPresets?.length ? /* @__PURE__ */ jsx(FilterPresetsButton, {
		filterPresets: collection.filterPresets,
		tableController,
		compact
	}, "filter_presets") : null;
	const countBadge = !iconOnlyToolbar && entitiesCount !== void 0 ? /* @__PURE__ */ jsx(Tooltip, {
		title: t("records_in_view"),
		children: entitiesCount === null ? /* @__PURE__ */ jsx(Skeleton, { className: "w-8 h-4 rounded-md mx-1" }) : /* @__PURE__ */ jsx("span", {
			className: "mx-1 text-xs font-mono tabular-nums text-text-secondary dark:text-text-secondary-dark",
			children: entitiesCount.toLocaleString()
		})
	}, "entities_count") : null;
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		[
			backButton,
			selectionEnabled && selectionQuery ? /* @__PURE__ */ jsx("div", {
				className: "mr-1 flex items-center",
				children: /* @__PURE__ */ jsx(SelectionMenu, {
					selectionController,
					loadedEntities: tableController.data,
					query: selectionQuery,
					collectionEntitiesCount,
					collectionName: collection.name
				})
			}, "select_all") : null,
			filtersButton,
			sortButton,
			/* @__PURE__ */ jsx(ClearFilterSortButton, {
				tableController,
				compact: iconOnlyToolbar,
				enabled: !collection.fixedFilter
			}, "clear_filter"),
			filterPresetsButton,
			countBadge
		],
		useSlot("collection.actions.start", actionProps),
		resolvedProperties && tableController.setFilterValues && /* @__PURE__ */ jsx(FiltersDialog, {
			open: filtersDialogOpen,
			onOpenChange: setFiltersDialogOpen,
			properties: resolvedProperties,
			filterValues: tableController.filterValues,
			setFilterValues: (filterValues) => tableController.setFilterValues?.(filterValues ?? {}),
			fixedFilter: collection.fixedFilter
		})
	] });
}
//#endregion
//#region src/hooks/useChildViewSource.ts
/**
* What kind of list a path addresses: a root collection, a contained
* subcollection, or a relation — and if a relation, whether the rows are owned
* by the parent or shared through a junction.
*
* Derived from the path rather than passed down, because the same question is
* asked from places a prop does not reach: the collection view's row actions,
* the entity form's own delete button, a deep link straight into a tab. All
* three have the path; only one of them was ever handed a descriptor.
*
* Returns `undefined` for a root collection path, and for any path whose parent
* or relation cannot be resolved — callers should read that as "an ordinary
* collection", which is the pre-existing behaviour.
*/
function useChildViewSource(path) {
	const collectionRegistry = useCollectionRegistryController();
	return useMemo(() => {
		if (!path) return void 0;
		const segments = path.split("/").filter((s) => s && s !== "undefined");
		if (segments.length < 3) return void 0;
		const childKey = segments[segments.length - 1];
		const parentPath = segments.slice(0, -2).join("/");
		let parentCollection;
		try {
			parentCollection = collectionRegistry.getCollection(parentPath);
		} catch {
			return;
		}
		if (!parentCollection) return void 0;
		return getEntityChildViews(parentCollection).find((view) => view.key === childKey)?.source;
	}, [path, collectionRegistry]);
}
//#endregion
//#region src/components/CollectionViewBinding/CollectionViewBinding.tsx
var EMPTY_ARRAY = [];
/**
* This component is in charge of binding a driver path with an {@link AdminCollection}
* where it's configuration is defined. It includes an infinite scrolling table
* and a 'Add' new entities button,
*
* This component is the default one used for displaying entity collections
* and is in charge of generating all the specific actions and customization
* of the lower level {@link CollectionTableBinding}
*
* Please **note** that you only need to use this component if you are building
* a custom view. If you just need to create a default view you can do it
* exclusively with config options.
*
* If you need a lower level implementation with more granular options, you
* can use {@link CollectionTableBinding}.
*
* If you need a generic table that is not bound to the driver or entities and
* properties at all, you can check {@link VirtualTable}
*
* @param path
* @param collection

* @group Components
*/
var CollectionViewBindingInner = React.memo(function CollectionViewBindingInner({ path: pathProp, parentCollectionSlugs, parentEntityIds, isSubCollection, className, updateUrl, selectedEntityId: selectedEntityIdProp, selectedTab: selectedTabProp, ...collectionProp }) {
	const { t } = useTranslation();
	const context = useAdminContext();
	const collectionRegistry = useCollectionRegistryController();
	const urlController = useUrlController();
	const path = pathProp ?? getCollectionDataPath(collectionProp);
	const dataClient = useData();
	const sidePanelController = useSidePanel();
	useAuthController();
	const userConfigPersistence = useUserConfigurationPersistence();
	const analyticsController = useAnalyticsController();
	const customizationController = useCustomizationController();
	const { canCreate, canEdit, canDelete } = usePermissions();
	/**
	* Rows shared with other parents through a junction. The parent owns
	* the link, not the row — so the destructive action is a removal from
	* this record, which is what the server performs for such a path.
	*/
	const childViewSource = useChildViewSource(path);
	const isLinkedChildView = childViewSource?.kind === "relation" && childViewSource.mode === "linked";
	const linkedTargetSlug = isLinkedChildView && childViewSource.kind === "relation" ? childViewSource.targetSlug : void 0;
	const containerRef = React.useRef(null);
	const scrollRestoration = useScrollRestoration();
	const collectionPropRef = React.useRef(collectionProp);
	if (!shallowEqual(collectionPropRef.current, collectionProp)) collectionPropRef.current = collectionProp;
	const stableCollectionProp = collectionPropRef.current;
	const collection = useMemo(() => {
		const registryCollection = collectionRegistry.getCollection(path) || stableCollectionProp;
		const userOverride = userConfigPersistence?.getCollectionConfig(path);
		return userOverride ? mergeDeep(registryCollection, userOverride) : registryCollection;
	}, [
		stableCollectionProp,
		path,
		userConfigPersistence,
		collectionRegistry
	]);
	const collectionRef = React.useRef(collection);
	useEffect(() => {
		collectionRef.current = collection;
	}, [collection]);
	const canCreateEntities = canCreate(collection, path);
	const [highlightedEntity, setHighlightedEntity] = useState(void 0);
	const [deleteEntityClicked, setDeleteEntityClicked] = React.useState(void 0);
	const [lastDeleteTimestamp, setLastDeleteTimestamp] = React.useState(0);
	const [deletedEntities, setDeletedEntities] = React.useState([]);
	const [docsCount, setDocsCount] = useState(null);
	const [localPropertiesOrder, setLocalPropertiesOrder] = useState(collection.propertiesOrder);
	useEffect(() => {
		setLocalPropertiesOrder((previous) => deepEqual(previous, collection.propertiesOrder) ? previous : collection.propertiesOrder);
	}, [collection.propertiesOrder]);
	const unselectNavigatedEntity = useCallback(() => {
		const currentSelection = highlightedEntity;
		setTimeout(() => {
			if (currentSelection === highlightedEntity) setHighlightedEntity(void 0);
		}, 2400);
	}, [highlightedEntity]);
	const checkInlineEditing = useCallback((entity) => {
		const collection = collectionRef.current;
		if (!canEdit(collection, path, entity ?? null)) return false;
		return collection.inlineEditing === void 0 || collection.inlineEditing;
	}, [canEdit, path]);
	const selectionEnabled = collection.selectionEnabled === void 0 || collection.selectionEnabled;
	const hoverRow = !checkInlineEditing();
	const [popOverOpen, setPopOverOpen] = useState(false);
	const resolvedCustomViews = useMemo(() => resolveCollectionViews(collection.customViews, customizationController.collectionViews), [collection.customViews, customizationController]);
	const customViewKeys = useMemo(() => resolvedCustomViews.map((v) => v.key), [resolvedCustomViews]);
	const defaultViewMode = isViewMode(collection.defaultViewMode, customViewKeys) ? collection.defaultViewMode : "list";
	const [searchParams, setSearchParams] = useSearchParams();
	const urlView = useMemo(() => {
		const v = searchParams.get(VIEW_MODE_PARAM);
		return isViewMode(v, customViewKeys) ? v : null;
	}, [searchParams, customViewKeys]);
	const getSavedView = useCallback(() => {
		const saved = userConfigPersistence?.getCollectionConfig(path)?.defaultViewMode;
		return isViewMode(saved, customViewKeys) ? saved : null;
	}, [
		userConfigPersistence,
		path,
		customViewKeys
	]);
	const [viewMode, setViewModeState] = useState(() => {
		if (urlView) return urlView;
		const savedView = getSavedView();
		if (savedView) return savedView;
		return defaultViewMode;
	});
	const activeCustomView = useMemo(() => resolvedCustomViews.find((v) => v.key === viewMode), [resolvedCustomViews, viewMode]);
	const openEntityMode = resolveOpenEntityMode({
		collection,
		viewMode,
		customView: activeCustomView
	});
	useEffect(() => {
		if (!urlView && viewMode !== defaultViewMode) setSearchParams(() => {
			const next = new URLSearchParams(window.location.search);
			next.set(VIEW_MODE_PARAM, viewMode);
			return next;
		}, { replace: true });
	}, []);
	const setViewMode = useCallback((newMode) => {
		setViewModeState(newMode);
		setSearchParams(() => {
			const next = new URLSearchParams(window.location.search);
			if (newMode === defaultViewMode) next.delete(VIEW_MODE_PARAM);
			else next.set(VIEW_MODE_PARAM, newMode);
			return next;
		});
	}, [defaultViewMode, setSearchParams]);
	useEffect(() => {
		if (urlView) setViewModeState(urlView);
		else {
			const savedView = getSavedView();
			setViewModeState(savedView ?? defaultViewMode);
		}
	}, [
		urlView,
		getSavedView,
		defaultViewMode
	]);
	const [listSize, setListSize] = useState(collection.defaultSize ?? "m");
	const [cardSize, setCardSize] = useState(collection.defaultSize ?? "m");
	const [tableSize, setTableSize] = useState(collection.defaultSize ?? "m");
	const [customViewSize, setCustomViewSize] = useState(collection.defaultSize ?? "m");
	const selectionController = useSelectionController();
	const usedSelectionController = collection.selectionController ?? selectionController;
	const { selection, clearSelection, toggleEntitySelection } = usedSelectionController;
	const tableController = useDataTableController({
		path,
		collection,
		lastDeleteTimestamp,
		scrollRestoration,
		updateUrl
	});
	const tableKey = React.useRef(Math.random().toString(36));
	const popupCell = tableController.popupCell;
	const onPopupClose = useCallback(() => {
		tableController.setPopupCell?.(void 0);
	}, [tableController.setPopupCell]);
	const onEntityClick = useCallback((clickedEntity) => {
		const collection = collectionRef.current;
		setHighlightedEntity(clickedEntity);
		analyticsController.onAnalyticsEvent?.("edit_entity_clicked", {
			path: clickedEntity.path,
			entityId: clickedEntity.id
		});
		if (collection) addRecentId(collection.slug, clickedEntity.id);
		const entityPath = path ?? clickedEntity.path;
		navigateToEntity({
			navigation: urlController,
			path: entityPath,
			sidePanelController,
			openEntityMode,
			collection,
			entityId: clickedEntity.id,
			replace: openEntityMode === "split" && selectedEntityIdProp !== void 0
		});
	}, [
		sidePanelController,
		openEntityMode,
		selectedEntityIdProp,
		path,
		urlController,
		analyticsController
	]);
	const onNewClick = useCallback(() => {
		const collection = collectionRef.current;
		analyticsController.onAnalyticsEvent?.("new_entity_click", { path });
		navigateToEntity({
			openEntityMode,
			collection,
			entityId: void 0,
			path,
			sidePanelController,
			navigation: urlController,
			onClose: unselectNavigatedEntity
		});
	}, [path, sidePanelController]);
	/**
	* Attach rows that already exist to this parent.
	*
	* Writing to the row's own address under this parent — `PUT
	* posts/1/tags/5` — is what asserts membership; the backend writes the
	* junction row idempotently. Sending no values keeps it a pure link:
	* the target's own fields are none of this tab's business.
	*/
	const linkExistingEntities = useCallback(async (entities) => {
		const alreadyLinked = new Set(tableController.data.map((e) => String(e.id)));
		const toLink = entities.filter((e) => !alreadyLinked.has(String(e.id)));
		if (toLink.length === 0) return;
		try {
			await Promise.all(toLink.map((entity) => saveEntityWithCallbacks({
				path,
				entityId: entity.id,
				values: {},
				status: "existing",
				collection,
				data: dataClient,
				context
			})));
			setLastDeleteTimestamp(Date.now());
		} catch (e) {
			context.snackbarController?.open({
				type: "error",
				message: e instanceof Error ? e.message : String(e)
			});
		}
	}, [
		dataClient,
		path,
		tableController.data,
		collection,
		context
	]);
	const selectionDialog = useSelectionDialog({
		path: linkedTargetSlug ?? false,
		multiselect: true,
		onMultipleEntitiesSelected: linkExistingEntities
	});
	const openNewDocument = useCallback((defaultValues) => {
		const collection = collectionRef.current;
		analyticsController.onAnalyticsEvent?.("new_entity_click", { path });
		navigateToEntity({
			openEntityMode,
			collection,
			entityId: void 0,
			defaultValues,
			path,
			sidePanelController,
			navigation: urlController,
			onClose: unselectNavigatedEntity
		});
	}, [
		path,
		sidePanelController,
		openEntityMode,
		urlController,
		unselectNavigatedEntity
	]);
	const onMultipleDeleteClick = () => {
		analyticsController.onAnalyticsEvent?.("multiple_delete_dialog_open", { path });
		setDeleteEntityClicked(selection);
	};
	const internalOnEntityDelete = (_path, entity) => {
		analyticsController.onAnalyticsEvent?.("single_entity_deleted", { path });
		toggleEntitySelection(entity, false);
		setDeletedEntities((prev) => [...prev, entity]);
		setLastDeleteTimestamp(Date.now());
	};
	const internalOnMultipleEntitiesDelete = (_path, entities) => {
		analyticsController.onAnalyticsEvent?.("multiple_entities_deleted", { path });
		clearSelection();
		setDeleteEntityClicked(void 0);
		setDeletedEntities((prev) => [...prev, ...entities]);
		setLastDeleteTimestamp(Date.now());
	};
	const pluginAddColumnComponents = useSlot("collection.add-column", {
		path,
		parentCollectionSlugs: parentCollectionSlugs ?? EMPTY_ARRAY,
		parentEntityIds: parentEntityIds ?? EMPTY_ARRAY,
		collection,
		tableController
	});
	const pluginToolbarWidgets = useSlot("collection.toolbar", {
		path,
		parentCollectionSlugs: parentCollectionSlugs ?? EMPTY_ARRAY,
		parentEntityIds: parentEntityIds ?? EMPTY_ARRAY,
		collection,
		tableController,
		selectionController: usedSelectionController
	});
	const pluginEmptyStates = useSlot("collection.empty-state", {
		path,
		parentCollectionSlugs: parentCollectionSlugs ?? EMPTY_ARRAY,
		parentEntityIds: parentEntityIds ?? EMPTY_ARRAY,
		collection,
		canCreate: canCreateEntities,
		onNewClick
	});
	const pluginWidgets = useSlot("collection.widgets", {
		path,
		parentCollectionSlugs: parentCollectionSlugs ?? EMPTY_ARRAY,
		parentEntityIds: parentEntityIds ?? EMPTY_ARRAY,
		collection
	});
	const onCollectionModifiedForUser = useCallback((path, partialCollection) => {
		if (userConfigPersistence) {
			const updatedConfig = mergeDeep(userConfigPersistence.getCollectionConfig(path), partialCollection);
			userConfigPersistence.onCollectionModified(path, updatedConfig);
		}
	}, [userConfigPersistence]);
	const onColumnResize = useCallback(({ width, key }) => {
		const collection = collectionRef.current;
		if (!getPropertyInPath$1(collection.properties, key)) return;
		const localCollection = buildPropertyWidthOverwrite(key, width);
		onCollectionModifiedForUser(path, localCollection);
	}, [onCollectionModifiedForUser, path]);
	const onListSizeChanged = useCallback((size) => {
		setListSize(size);
		if (userConfigPersistence) onCollectionModifiedForUser(path, { defaultSize: size });
	}, [
		onCollectionModifiedForUser,
		path,
		userConfigPersistence
	]);
	const onTableSizeChanged = useCallback((size) => {
		setTableSize(size);
		if (userConfigPersistence) onCollectionModifiedForUser(path, { defaultSize: size });
	}, [
		onCollectionModifiedForUser,
		path,
		userConfigPersistence
	]);
	const onViewModeChange = useCallback((mode) => {
		analyticsController.onAnalyticsEvent?.("view_mode_changed", {
			path,
			from: viewMode,
			to: mode
		});
		setViewMode(mode);
		if (userConfigPersistence) onCollectionModifiedForUser(path, { defaultViewMode: mode });
	}, [
		setViewMode,
		userConfigPersistence,
		onCollectionModifiedForUser,
		path,
		analyticsController,
		viewMode
	]);
	const createEnabled = canCreate(collection, path);
	const { onValueChange, uniqueFieldValidator } = useCollectionInlineEditor({
		path,
		collection,
		dataClient,
		context
	});
	const resolvedCollection = collection;
	useMemo(() => {
		if (!collection.kanban?.columnProperty) return false;
		const property = getPropertyInPath$1(resolvedCollection.properties, collection.kanban.columnProperty);
		if (!property || property.type !== "string") return false;
		return Boolean("enum" in property && property.enum);
	}, [collection.kanban?.columnProperty, resolvedCollection.properties]);
	const hasEnumProperty = useMemo(() => {
		return Object.values(resolvedCollection.properties).some((p) => p.type === "string" && "enum" in p && p.enum);
	}, [resolvedCollection.properties]);
	const enabledViews = useMemo(() => {
		const renderable = (collection.enabledViews ?? [...VIEW_MODES, ...customViewKeys]).filter((v) => isViewMode(v, customViewKeys));
		if (!hasEnumProperty) return renderable.filter((v) => v !== "kanban");
		return renderable;
	}, [
		collection.enabledViews,
		hasEnumProperty,
		customViewKeys
	]);
	const kanbanPropertyOptions = useMemo(() => {
		const options = [];
		const properties = resolvedCollection.properties;
		for (const [key, property] of Object.entries(properties)) {
			const prop = property;
			if (prop && prop.type === "string" && "enum" in prop && prop.enum) options.push({
				key,
				label: prop.name || key
			});
		}
		return options;
	}, [resolvedCollection.properties]);
	const getSavedKanbanProperty = useCallback(() => {
		return (userConfigPersistence?.getCollectionConfig(path))?.kanbanColumnProperty;
	}, [userConfigPersistence, path]);
	const [selectedKanbanProperty, setSelectedKanbanProperty] = useState(() => {
		const saved = getSavedKanbanProperty();
		if (saved && kanbanPropertyOptions.some((o) => o.key === saved)) return saved;
		if (collection.kanban?.columnProperty) return collection.kanban.columnProperty;
		return kanbanPropertyOptions[0]?.key ?? "";
	});
	useEffect(() => {
		if (kanbanPropertyOptions.length > 0 && !kanbanPropertyOptions.some((o) => o.key === selectedKanbanProperty)) {
			const saved = getSavedKanbanProperty();
			if (saved && kanbanPropertyOptions.some((o) => o.key === saved)) setSelectedKanbanProperty(saved);
			else if (collection.kanban?.columnProperty && kanbanPropertyOptions.some((o) => o.key === collection.kanban?.columnProperty)) setSelectedKanbanProperty(collection.kanban.columnProperty);
			else setSelectedKanbanProperty(kanbanPropertyOptions[0]?.key ?? "");
		}
	}, [
		kanbanPropertyOptions,
		selectedKanbanProperty,
		getSavedKanbanProperty,
		collection.kanban?.columnProperty
	]);
	const onKanbanPropertyChange = useCallback((property) => {
		analyticsController.onAnalyticsEvent?.("kanban_property_changed", {
			path,
			property
		});
		setSelectedKanbanProperty(property);
		if (userConfigPersistence) onCollectionModifiedForUser(path, { kanbanColumnProperty: property });
	}, [
		userConfigPersistence,
		onCollectionModifiedForUser,
		path,
		analyticsController
	]);
	const getPropertyFor = useCallback(({ propertyKey, entity }) => {
		let property = getPropertyInPath$1(collection.properties, propertyKey);
		if (!property) property = getPropertyInPath$1(resolvedCollection.properties, propertyKey);
		return property ?? null;
	}, [collection.properties, resolvedCollection.properties]);
	const collectionWithLocalOrder = useMemo(() => {
		if (localPropertiesOrder && localPropertiesOrder !== resolvedCollection.propertiesOrder) return {
			...resolvedCollection,
			propertiesOrder: localPropertiesOrder
		};
		return resolvedCollection;
	}, [resolvedCollection, localPropertiesOrder]);
	const displayedColumnIds = useColumnIds(collectionWithLocalOrder, true);
	const additionalFields = useMemo(() => {
		const redundant = getRedundantChildViewColumnIds(collectionWithLocalOrder);
		const subcollectionColumns = getEntityChildViews(collection).map((v) => v.collection).filter((child) => !redundant.has(getSubcollectionColumnId(child))).map((subcollection) => {
			return {
				key: getSubcollectionColumnId(subcollection),
				name: subcollection.name,
				width: 200,
				dependencies: [],
				Builder: ({ entity }) => /* @__PURE__ */ jsx(Button, {
					className: "max-w-full truncate justify-start",
					startIcon: /* @__PURE__ */ jsx(ArrowRightToLineIcon, { size: iconSize.small }),
					onClick: (event) => {
						event.stopPropagation();
						navigateToEntity({
							openEntityMode,
							collection,
							entityId: entity.id,
							selectedTab: subcollection.slug,
							path,
							navigation: urlController,
							sidePanelController
						});
					},
					children: subcollection.name
				})
			};
		}) ?? EMPTY_ARRAY;
		return [...collection.additionalFields ?? EMPTY_ARRAY, ...subcollectionColumns];
	}, [
		collection,
		collectionWithLocalOrder,
		path,
		sidePanelController
	]);
	const updateLastDeleteTimestamp = useCallback(() => {
		setLastDeleteTimestamp(Date.now());
	}, []);
	const largeLayout = useLargeLayout();
	const isSplitLayout = openEntityMode === "split";
	const isCompact = isSplitLayout && selectedEntityIdProp !== void 0;
	const activeSelectionEnabled = !isCompact && selectionEnabled;
	const getActionsForEntity = useCallback(({ entity, customEntityActions }) => {
		const deleteEnabled = entity ? canDelete(collection, path, entity) : true;
		const disableActions = collection.disableDefaultActions ?? [];
		const actions = [];
		if (!disableActions.includes("edit")) actions.push(editEntityAction);
		if (createEnabled && !disableActions.includes("copy")) actions.push(copyEntityAction);
		if (deleteEnabled && !disableActions.includes("delete")) actions.push(isLinkedChildView ? unlinkEntityAction : deleteEntityAction);
		if (customEntityActions) return mergeEntityActions(actions, customEntityActions);
		return actions;
	}, [
		canDelete,
		collection,
		path,
		createEnabled,
		isLinkedChildView
	]);
	const getIdColumnWidth = useCallback(() => {
		const entityActions = getActionsForEntity({});
		const collapsedActions = entityActions.filter((a) => a.collapsed !== false);
		const actionsWidth = entityActions.filter((a) => a.collapsed === false).length * (largeLayout ? 40 : 30);
		return (largeLayout ? 80 + actionsWidth : 70 + actionsWidth) + (collapsedActions.length > 0 ? largeLayout ? 40 : 30 : 0);
	}, [getActionsForEntity, largeLayout]);
	const tableRowActionsBuilder = useCallback(({ entity, size, width, frozen }) => {
		const isSelected = usedSelectionController.isEntitySelected(entity);
		const customEntityActions = (collection.entityActions ?? EMPTY_ARRAY).map((action) => resolveEntityAction(action, customizationController.entityActions)).filter(Boolean);
		const actions = getActionsForEntity({
			entity,
			customEntityActions
		});
		return /* @__PURE__ */ jsx(CollectionRowActions, {
			entity,
			width,
			frozen,
			isSelected,
			selectionEnabled: activeSelectionEnabled,
			size,
			highlightEntity: setHighlightedEntity,
			unhighlightEntity: unselectNavigatedEntity,
			collection,
			path,
			actions,
			hideId: collection?.hideIdFromCollection,
			onCollectionChange: updateLastDeleteTimestamp,
			selectionController: usedSelectionController,
			openEntityMode
		});
	}, [updateLastDeleteTimestamp, usedSelectionController]);
	const countFetcher = /* @__PURE__ */ jsx(EntitiesCount, {
		path,
		collection,
		filter: tableController.filterValues,
		sortBy: tableController.sortBy,
		searchString: tableController.searchString,
		onCountChange: setDocsCount
	});
	const liveSelectionQuery = useMemo(() => ({
		path,
		filterValues: tableController.filterValues,
		searchString: tableController.searchString,
		sortBy: tableController.sortBy
	}), [
		path,
		tableController.filterValues,
		tableController.searchString,
		tableController.sortBy
	]);
	const selectionQueryKey = selection.type === "query" ? serializeSelectionQuery(selection.query) : void 0;
	const liveQueryKey = serializeSelectionQuery(liveSelectionQuery);
	useEffect(() => {
		if (selectionQueryKey !== void 0 && selectionQueryKey !== liveQueryKey) clearSelection();
	}, [
		selectionQueryKey,
		liveQueryKey,
		clearSelection
	]);
	const { resolvedSlots } = customizationController;
	const headerActionContributions = useMemo(() => resolvedSlots.filter((s) => s.slot === "collection.header.action").sort((a, b) => (a.order ?? 50) - (b.order ?? 50)), [resolvedSlots]);
	const buildAdditionalHeaderWidget = useCallback(({ property, propertyKey, onHover }) => {
		const collection = collectionRef.current;
		const headerSlotProps = {
			property,
			propertyKey,
			onHover,
			path,
			collection,
			tableController,
			parentCollectionSlugs: parentCollectionSlugs ?? EMPTY_ARRAY,
			parentEntityIds: parentEntityIds ?? EMPTY_ARRAY
		};
		return /* @__PURE__ */ jsx(Fragment, { children: headerActionContributions.map((s, i) => /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(s.Component, {
			...headerSlotProps,
			...s.props ?? {}
		}) }, `header_action_${propertyKey}_${i}`)) });
	}, [
		headerActionContributions,
		path,
		parentCollectionSlugs
	]);
	const addColumnComponentInternal = pluginAddColumnComponents.length > 0 ? function() {
		return /* @__PURE__ */ jsx("div", {
			className: "flex flex-row items-center gap-2",
			children: pluginAddColumnComponents
		});
	} : void 0;
	const onColumnsOrderChange = useCallback((newColumns) => {
		const seenKeys = /* @__PURE__ */ new Set();
		const newPropertiesOrder = newColumns.filter((col) => !col.frozen && getPropertyInPath$1(collection.properties, col.key)).map((col) => col.key).filter((key) => {
			if (seenKeys.has(key)) return false;
			seenKeys.add(key);
			return true;
		});
		setLocalPropertiesOrder(newPropertiesOrder);
		if (customizationController?.plugins) customizationController.plugins.filter((plugin) => plugin.hooks?.onColumnsReorder).forEach((plugin) => {
			plugin.hooks.onColumnsReorder({
				fullPath: path,
				parentCollectionSlugs: parentCollectionSlugs ?? EMPTY_ARRAY,
				parentEntityIds: parentEntityIds ?? EMPTY_ARRAY,
				collection,
				newPropertiesOrder
			});
		});
		if (userConfigPersistence) onCollectionModifiedForUser(path, { propertiesOrder: newPropertiesOrder });
	}, [
		collection,
		setLocalPropertiesOrder,
		customizationController,
		path,
		parentCollectionSlugs,
		parentEntityIds,
		userConfigPersistence,
		onCollectionModifiedForUser
	]);
	const [viewModePopoverOpen, setViewModePopoverOpen] = useState(false);
	const viewModeToggleElement = /* @__PURE__ */ jsx(ViewModeToggle, {
		viewMode,
		onViewModeChange,
		enabledViews,
		customViews: resolvedCustomViews,
		size: activeCustomView ? activeCustomView.sizeable ? customViewSize : void 0 : viewMode === "list" ? listSize : viewMode === "table" ? tableSize : viewMode === "cards" ? cardSize : void 0,
		onSizeChanged: activeCustomView ? activeCustomView.sizeable ? setCustomViewSize : void 0 : viewMode === "list" ? onListSizeChanged : viewMode === "table" ? onTableSizeChanged : viewMode === "cards" ? setCardSize : void 0,
		open: viewModePopoverOpen,
		onOpenChange: setViewModePopoverOpen,
		kanbanPropertyOptions,
		selectedKanbanProperty,
		onKanbanPropertyChange
	});
	const pluginErrorViews = useSlot("collection.error", {
		path,
		collection,
		parentCollectionSlugs,
		parentEntityIds,
		error: tableController.dataLoadingError
	});
	const pluginErrorView = tableController.dataLoadingError && pluginErrorViews.length > 0 ? pluginErrorViews[0] : null;
	const isSearching = !!tableController.searchString;
	const isFilteredOrSorted = tableController.filterValues !== void 0 || tableController.sortBy !== void 0 || isSearching;
	const ResolvedEmptyState = useComponentOverride("Collection.EmptyState", DefaultCollectionEmptyState);
	const ResolvedCollectionActions = useComponentOverride("Collection.Actions", CollectionViewActions);
	const ResolvedCollectionTable = useComponentOverride("Collection.Table", CollectionTableBinding);
	const emptyComponent = pluginEmptyStates.length > 0 ? /* @__PURE__ */ jsx(Fragment, { children: pluginEmptyStates }) : /* @__PURE__ */ jsx(ResolvedEmptyState, {
		canCreate: canCreateEntities && !isFilteredOrSorted,
		onNewClick,
		isSearching,
		searchString: tableController.searchString ?? ""
	});
	const toolbarNode = /* @__PURE__ */ jsx(CollectionTableToolbar, {
		compact: isCompact,
		loading: tableController.dataLoading,
		onTextSearch: tableController.setSearchString,
		initialSearchText: tableController.searchString,
		viewModeToggle: viewModeToggleElement,
		actionsStart: /* @__PURE__ */ jsx(CollectionViewStartActions, {
			parentCollectionSlugs: parentCollectionSlugs ?? EMPTY_ARRAY,
			parentEntityIds: parentEntityIds ?? EMPTY_ARRAY,
			collection,
			tableController,
			path,
			relativePath: getCollectionDataPath(collection),
			selectionController: usedSelectionController,
			collectionEntitiesCount: docsCount ?? void 0,
			resolvedProperties: resolvedCollection.properties,
			viewMode,
			selectionEnabled: activeSelectionEnabled,
			selectionQuery: liveSelectionQuery,
			entitiesCount: docsCount,
			openNewDocument,
			compact: isCompact
		}),
		actions: /* @__PURE__ */ jsx(ResolvedCollectionActions, {
			parentCollectionSlugs: parentCollectionSlugs ?? EMPTY_ARRAY,
			parentEntityIds: parentEntityIds ?? EMPTY_ARRAY,
			collection,
			tableController,
			onMultipleDeleteClick,
			onNewClick,
			onAddExistingClick: linkedTargetSlug ? selectionDialog.open : void 0,
			openNewDocument,
			path,
			relativePath: getCollectionDataPath(collection),
			selectionController: usedSelectionController,
			selectionEnabled: activeSelectionEnabled,
			collectionEntitiesCount: docsCount ?? void 0,
			compact: isCompact,
			children: pluginToolbarWidgets
		})
	});
	const CustomViewBuilder = activeCustomView ? resolveComponentRef(activeCustomView.Builder) : void 0;
	const innerView = CustomViewBuilder ? /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(CustomViewBuilder, {
		collection,
		tableController,
		path,
		parentCollectionSlugs,
		parentEntityIds,
		onEntityClick,
		onNewClick: canCreateEntities ? onNewClick : void 0,
		canCreate: canCreateEntities,
		selectionController: usedSelectionController,
		selectionEnabled,
		highlightedEntities: highlightedEntity ? [highlightedEntity] : [],
		deletedEntities,
		emptyComponent,
		size: activeCustomView.sizeable ? customViewSize : void 0,
		viewMode
	}, `custom-view-${activeCustomView.key}-${path}`) }) : viewMode === "kanban" ? /* @__PURE__ */ jsx(CollectionBoardViewBinding, {
		collection,
		tableController,
		fullPath: path,
		parentCollectionSlugs,
		parentEntityIds,
		columnProperty: selectedKanbanProperty,
		onEntityClick,
		selectionController: usedSelectionController,
		selectionEnabled,
		highlightedEntities: highlightedEntity ? [highlightedEntity] : [],
		deletedEntities,
		emptyComponent
	}, `kanban-view-${path}-${selectedKanbanProperty}`) : viewMode === "cards" ? /* @__PURE__ */ jsx(CollectionCardViewBinding, {
		collection,
		tableController,
		onEntityClick,
		selectionController: usedSelectionController,
		selectionEnabled,
		highlightedEntities: highlightedEntity ? [highlightedEntity] : [],
		onScroll: tableController.onScroll,
		initialScroll: tableController.initialScroll,
		size: cardSize,
		emptyComponent
	}, `cards-view-${path}`) : viewMode === "list" ? /* @__PURE__ */ jsx(CollectionListViewBinding, {
		collection,
		tableController,
		onEntityClick,
		selectionController: usedSelectionController,
		selectionEnabled,
		highlightedEntities: highlightedEntity ? [highlightedEntity] : [],
		size: listSize,
		emptyComponent,
		selectedEntityId: selectedEntityIdProp,
		getActionsForEntity,
		path,
		openEntityMode
	}, `list-view-${path}`) : /* @__PURE__ */ jsx(ResolvedCollectionTable, {
		hideToolbar: true,
		additionalFields,
		tableController,
		enablePopupIcon: true,
		displayedColumnIds,
		onSizeChanged: onTableSizeChanged,
		onEntityClick,
		onColumnResize,
		onValueChange,
		tableRowActionsBuilder,
		uniqueFieldValidator,
		selectionController: usedSelectionController,
		highlightedEntities: highlightedEntity ? [highlightedEntity] : [],
		defaultSize: tableSize,
		properties: resolvedCollection.properties,
		getPropertyFor,
		onScroll: tableController.onScroll,
		initialScroll: tableController.initialScroll,
		emptyComponent,
		hoverRow,
		inlineEditing: checkInlineEditing(),
		AdditionalHeaderWidget: buildAdditionalHeaderWidget,
		AddColumnComponent: addColumnComponentInternal,
		getIdColumnWidth,
		additionalIDHeaderWidget: /* @__PURE__ */ jsx(EntityIdHeaderWidget, {
			path,
			idPath: path,
			collection,
			openEntityMode
		}),
		openEntityMode,
		onColumnsOrderChange
	}, `collection_table_${path}`);
	const detailOpen = selectedEntityIdProp !== void 0;
	const collectionSurface = viewMode === "list" ? /* @__PURE__ */ jsxs("div", {
		className: cls("flex flex-col w-full", detailOpen ? "" : "max-w-6xl mx-auto px-3 md:px-4 lg:px-6 py-4"),
		children: [
			/* @__PURE__ */ jsx("div", {
				className: cls("grid transition-[grid-template-rows,transform,margin] duration-150 ease-out", detailOpen ? "grid-rows-[0fr] -translate-y-2 mt-0 mb-0" : "grid-rows-[1fr] translate-y-0 mt-12 mb-6"),
				children: /* @__PURE__ */ jsx("div", {
					className: "overflow-hidden flex items-center gap-4",
					children: /* @__PURE__ */ jsx(Typography, {
						gutterBottom: true,
						variant: "h4",
						className: "grow mb-0",
						component: "h4",
						children: collection.name
					})
				})
			}),
			pluginWidgets.length > 0 && /* @__PURE__ */ jsx("div", {
				className: cls("grid transition-[grid-template-rows] duration-150 ease-out", detailOpen ? "grid-rows-[0fr]" : "grid-rows-[1fr]"),
				children: /* @__PURE__ */ jsx("div", {
					className: "overflow-hidden flex-shrink-0",
					children: pluginWidgets
				})
			}),
			innerView
		]
	}) : innerView;
	return /* @__PURE__ */ jsxs("div", {
		className: cls("overflow-hidden h-full w-full rounded-md flex flex-col bg-surface-sheet", className),
		ref: containerRef,
		children: [
			countFetcher,
			pluginErrorView ?? (tableController.dataLoadingError && tableController.data.length > 0 && /* @__PURE__ */ jsx("div", {
				className: "flex items-center gap-4 px-4 py-2 bg-red-50 dark:bg-red-900/20 border-b border-red-200 dark:border-red-800 flex-shrink-0",
				children: /* @__PURE__ */ jsxs(Typography, {
					variant: "body2",
					className: "text-red-700 dark:text-red-300 flex-1",
					children: [
						/* @__PURE__ */ jsx("strong", { children: "Warning:" }),
						" ",
						tableController.dataLoadingError.message || "Failed to update data."
					]
				})
			})),
			isSplitLayout ? /* @__PURE__ */ jsx(SplitListView, {
				collection,
				tableController,
				onEntityClick,
				onNewClick,
				selectionController: usedSelectionController,
				selectionEnabled,
				highlightedEntities: highlightedEntity ? [highlightedEntity] : [],
				onScroll: tableController.onScroll,
				initialScroll: tableController.initialScroll,
				size: listSize,
				emptyComponent,
				path,
				parentCollectionSlugs,
				parentEntityIds,
				selectedEntityId: selectedEntityIdProp,
				selectedTab: selectedTabProp,
				toolbar: toolbarNode,
				children: collectionSurface
			}, `split-list-view-${path}`) : /* @__PURE__ */ jsxs("div", {
				className: "flex flex-col w-full h-full",
				children: [toolbarNode, /* @__PURE__ */ jsx("div", {
					className: cls("flex-1 min-h-0 flex flex-col", (viewMode === "list" || viewMode === "cards") && "overflow-y-auto"),
					children: collectionSurface
				})]
			}),
			popupCell && /* @__PURE__ */ jsx(PopupFormField, {
				open: Boolean(popupCell),
				onClose: onPopupClose,
				cellRect: popupCell?.cellRect,
				propertyKey: popupCell?.propertyKey,
				collection,
				entityId: popupCell.entityId,
				tableKey: tableKey.current,
				customFieldValidator: uniqueFieldValidator,
				path,
				onCellValueChange: onValueChange,
				container: containerRef.current
			}, `popup_form_${popupCell?.propertyKey}_${popupCell?.entityId}`),
			deleteEntityClicked && /* @__PURE__ */ jsx(DeleteEntityDialog, {
				target: deleteEntityClicked,
				path,
				collection,
				open: Boolean(deleteEntityClicked),
				onEntityDelete: internalOnEntityDelete,
				onMultipleEntitiesDelete: internalOnMultipleEntitiesDelete,
				onClose: () => setDeleteEntityClicked(void 0)
			})
		]
	});
}, (a, b) => {
	return deepEqual(a.path, b.path) && deepEqual(a.parentCollectionSlugs, b.parentCollectionSlugs) && deepEqual(a.parentEntityIds, b.parentEntityIds) && deepEqual(a.isSubCollection, b.isSubCollection) && deepEqual(a.className, b.className) && deepEqual(a.properties, b.properties) && deepEqual(a.propertiesOrder, b.propertiesOrder) && deepEqual(a.hideIdFromCollection, b.hideIdFromCollection) && deepEqual(a.inlineEditing, b.inlineEditing) && deepEqual(a.selectionEnabled, b.selectionEnabled) && deepEqual(a.selectionController, b.selectionController) && deepEqual(a.Actions, b.Actions) && deepEqual(a.defaultSize, b.defaultSize) && deepEqual(a.includeJsonView, b.includeJsonView) && deepEqual(a.additionalFields, b.additionalFields) && deepEqual(a.sideDialogWidth, b.sideDialogWidth) && deepEqual(a.openEntityMode, b.openEntityMode) && deepEqual(a.exportable, b.exportable) && deepEqual(a.history, b.history) && deepEqual(a.fixedFilter, b.fixedFilter) && deepEqual(a.selectedEntityId, b.selectedEntityId) && deepEqual(a.selectedTab, b.selectedTab);
});
var CollectionViewBinding = React.memo(function CollectionViewBinding(props) {
	const collectionRegistry = useCollectionRegistryController();
	const path = props.path ?? props.slug;
	const collection = collectionRegistry.getCollection(path) ?? props;
	const content = /* @__PURE__ */ jsx(CollectionViewBindingInner, { ...props });
	if (collection) return /* @__PURE__ */ jsx(CollectionScopeProvider, {
		collection,
		children: content
	});
	return content;
});
/**
* Default empty state shown when a collection has no entities.
* Used as the fallback for the `"Collection.EmptyState"` component override.
*
* @internal
*/
function DefaultCollectionEmptyState({ canCreate, onNewClick, isSearching, searchString }) {
	const { t } = useTranslation();
	if (canCreate) return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col items-center justify-center",
		children: [/* @__PURE__ */ jsx(Typography, {
			variant: "subtitle2",
			children: t("so_empty")
		}), /* @__PURE__ */ jsxs(Button, {
			onClick: onNewClick,
			className: "mt-4",
			children: [/* @__PURE__ */ jsx(PlusIcon, {}), t("create_your_first_entry")]
		})]
	});
	return /* @__PURE__ */ jsx(Typography, {
		variant: "label",
		children: isSearching ? t("no_results_search", { search: searchString }) : t("no_results_filter_sort")
	});
}
/**
* Inflight count request deduplication map.
* Keyed by `path|filterKey|sort|search` so that concurrent
* callers (e.g. React StrictMode double-mount) share the same promise.
*/
var inflightCountRequests = /* @__PURE__ */ new Map();
function EntitiesCount({ path, collection, filter, sortBy, searchString, onCountChange }) {
	const dataClient = useData();
	const sortKey = React.useMemo(() => sortBy ? serializeOrderBy(sortBy) ?? "" : "", [sortBy]);
	const dataClientRef = React.useRef(dataClient);
	dataClientRef.current = dataClient;
	const onCountChangeRef = React.useRef(onCountChange);
	onCountChangeRef.current = onCountChange;
	const filterKey = React.useMemo(() => filter ? JSON.stringify(filter) : "", [filter]);
	useEffect(() => {
		const accessor = dataClientRef.current.collection(path);
		if (!accessor.count) {
			onCountChangeRef.current?.(void 0);
			return;
		}
		let cancelled = false;
		const whereParams = filter && Object.keys(filter).length > 0 ? filter : void 0;
		const orderByParams = sortBy && sortBy.length > 0 ? sortBy.map(([field, direction]) => [String(field), direction]) : void 0;
		const cacheKey = `${path}|${filterKey}|${sortKey}|${searchString ?? ""}`;
		let countPromise = inflightCountRequests.get(cacheKey);
		if (!countPromise) {
			countPromise = accessor.count({
				where: whereParams,
				orderBy: orderByParams,
				searchString
			});
			inflightCountRequests.set(cacheKey, countPromise);
			countPromise.finally(() => inflightCountRequests.delete(cacheKey));
		}
		countPromise.then((c) => {
			if (!cancelled) onCountChangeRef.current?.(c);
		}).catch((e) => {
			console.warn("Error fetching count", e);
			if (!cancelled) onCountChangeRef.current?.(void 0);
		});
		return () => {
			cancelled = true;
		};
	}, [
		path,
		filterKey,
		sortKey,
		searchString
	]);
	return null;
}
function buildPropertyWidthOverwrite(key, width) {
	if (key.includes(".")) {
		const [parentKey, ...childKey] = key.split(".");
		return { properties: { [parentKey]: buildPropertyWidthOverwrite(childKey.join("."), width) } };
	}
	return { properties: { [key]: { admin: { columnWidth: width } } } };
}
function EntityIdHeaderWidget({ collection, path, idPath, openEntityMode }) {
	const { t } = useTranslation();
	const urlController = useUrlController();
	const [openPopup, setOpenPopup] = React.useState(false);
	const [searchString, setSearchString] = React.useState("");
	const [recentIds, setRecentIds] = React.useState(getRecentIds(collection.slug).map(String));
	const sidePanelController = useSidePanel();
	return /* @__PURE__ */ jsx(Tooltip, {
		title: !openPopup ? t("find_by_id") : void 0,
		asChild: false,
		children: /* @__PURE__ */ jsx(Popover, {
			open: openPopup,
			onOpenChange: setOpenPopup,
			sideOffset: 0,
			align: "start",
			alignOffset: -117,
			trigger: /* @__PURE__ */ jsx(IconButton, {
				size: "small",
				children: /* @__PURE__ */ jsx(SearchIcon, { size: iconSize.small })
			}),
			children: /* @__PURE__ */ jsxs("div", {
				className: cls("my-2 rounded-lg bg-surface-sheet text-surface-900 dark:text-white"),
				children: [/* @__PURE__ */ jsx("form", {
					noValidate: true,
					onSubmit: (e) => {
						e.preventDefault();
						if (!searchString) return;
						setOpenPopup(false);
						const entityId = searchString.trim();
						setRecentIds(addRecentId(collection.slug, entityId).map(String));
						navigateToEntity({
							openEntityMode,
							collection,
							entityId,
							path,
							sidePanelController,
							navigation: urlController
						});
					},
					className: "w-96 max-w-full",
					children: /* @__PURE__ */ jsxs("div", {
						className: "flex p-2 w-full gap-2",
						children: [/* @__PURE__ */ jsx(TextField, {
							autoFocus: openPopup,
							"aria-label": t("find_entity_by_id"),
							placeholder: t("find_entity_by_id"),
							size: "small",
							onChange: (e) => {
								setSearchString(e.target.value);
							},
							value: searchString,
							className: "flex-grow",
							inputClassName: cls("rounded-lg bg-surface-card", focusedDisabled)
						}), /* @__PURE__ */ jsx(Button, {
							variant: "text",
							disabled: !searchString.trim(),
							type: "submit",
							children: /* @__PURE__ */ jsx(ArrowRightToLineIcon, {})
						})]
					})
				}), recentIds && recentIds.length > 0 && /* @__PURE__ */ jsx("div", {
					className: "flex flex-col gap-2 p-2",
					children: recentIds.map((id) => /* @__PURE__ */ jsx(ReferencePreview, {
						reference: new EntityReference({
							id,
							path
						}),
						hover: true,
						onClick: () => {
							setOpenPopup(false);
							navigateToEntity({
								openEntityMode,
								collection,
								entityId: id,
								path,
								sidePanelController,
								navigation: urlController
							});
						},
						includeEntityLink: false,
						size: "small"
					}, id))
				})]
			})
		})
	});
}
//#endregion
//#region src/form/form_utils.ts
function extractTouchedValues(values, touched) {
	let acc = {};
	if (!touched || typeof touched !== "object") return acc;
	Object.entries(touched).forEach(([key, value]) => {
		if (value) acc = setIn(acc, key, getIn(values, key));
	});
	return acc;
}
/**
* Recursively removes empty plain objects `{}` and empty arrays `[]` from a value tree.
* This prevents ghost containers created by `setIn` intermediate path construction
* (e.g. `{ address: {} }` when only `address.city` was touched but value is undefined)
* from falsely triggering the unsaved local changes indicator.
*/
/**
* Check if a value is semantically empty (null, undefined, or empty string).
*/
function isSemanticEmpty(v) {
	return v === null || v === void 0 || v === "";
}
function removeEmptyContainers(obj) {
	if (Array.isArray(obj)) return obj.map(removeEmptyContainers);
	if (obj && typeof obj === "object" && Object.getPrototypeOf(obj) === Object.prototype) {
		const result = {};
		for (const key of Object.keys(obj)) {
			const cleaned = removeEmptyContainers(obj[key]);
			if (cleaned && typeof cleaned === "object" && !Array.isArray(cleaned) && Object.getPrototypeOf(cleaned) === Object.prototype && Object.keys(cleaned).length === 0) continue;
			result[key] = cleaned;
		}
		if (Object.keys(result).length > 0 && Object.values(result).every(isSemanticEmpty)) return {};
		return result;
	}
	return obj;
}
function getChanges(source, comparison) {
	const changes = {};
	if (!source) return {};
	if (!comparison) return source;
	const allKeys = Array.from(/* @__PURE__ */ new Set([...Object.keys(source), ...Object.keys(comparison)]));
	for (const key of allKeys) {
		const sourceValue = source[key];
		const comparisonValue = comparison[key];
		if (deepEqual(sourceValue, comparisonValue)) continue;
		const sourceHasKey = source && typeof source === "object" && Object.prototype.hasOwnProperty.call(source, key);
		if (comparison && typeof comparison === "object" && Object.prototype.hasOwnProperty.call(comparison, key) && !sourceHasKey) changes[key] = void 0;
		else if (Array.isArray(sourceValue)) {
			const comparisonArray = Array.isArray(comparisonValue) ? comparisonValue : [];
			if (sourceValue.length !== comparisonArray.length) {
				changes[key] = sourceValue;
				continue;
			}
			if (sourceValue.some((item, index) => !deepEqual(item, comparisonArray[index]))) changes[key] = sourceValue;
		} else if (isObject(sourceValue) && sourceValue && isObject(comparisonValue) && comparisonValue) {
			const nestedChanges = getChanges(sourceValue, comparisonValue);
			if (Object.keys(nestedChanges).length > 0) changes[key] = nestedChanges;
		} else changes[key] = sourceValue;
	}
	return changes;
}
/**
* What the local-changes backup still has to offer, given what the form is
* already showing — the answer the "unsaved local changes" banner is asking for.
* `undefined` means there is nothing left to apply, and no banner.
*
* Measured against what the form *opens showing*, not against the stored
* record. The banner exists to offer a draft the form is not already displaying,
* and an edit carried across a change of layout is in both the backup and the
* form: measuring against the stored values alone offered to restore the values
* already on screen, over an edit the user had never left.
*/
function getUnappliedLocalChanges(backupValues, openingValues) {
	const cleaned = removeEmptyContainers(getChanges(backupValues, openingValues));
	if (!cleaned || typeof cleaned !== "object" || Object.keys(cleaned).length === 0) return;
	return cleaned;
}
/**
* What travels when the same record changes layout — the split's "hide list",
* full screen's "show list", the side panel's "open full screen". One mounted
* form is replaced by another showing the same record, so the edit in progress
* has to be handed over; left to the local-changes backup alone, the new form
* met it as a draft from a closed tab and raised the "unsaved local changes"
* banner over changes the user had made a second earlier and never left.
*
* Returns `undefined` when there is nothing to carry, which is its own answer: a
* record nobody edited must open in the next layout exactly as clean as it was.
*
* Only what was edited here travels, keyed by `touched` — the same subset the
* backup stores. Carrying the whole record instead marks every field touched in
* the receiving form, which lights up every empty required field as an error and
* writes the entire record back out as a "local change".
*/
function getEditHandoffValues({ status, dirty, values, touched, storedValues }) {
	if (!values) return void 0;
	if (status === "new" || status === "copy") return Object.keys(values).length > 0 ? values : void 0;
	if (!dirty) return void 0;
	const touchedValues = removeEmptyContainers(extractTouchedValues(values, touched ?? {}));
	if (touchedValues && Object.keys(touchedValues).length > 0) return touchedValues;
	const changes = getChanges(values, storedValues ?? {});
	return Object.keys(changes).length > 0 ? changes : void 0;
}
function getInitialEntityValues(authController, collection, path, status, entity, propertyConfigs) {
	const properties = collection.properties;
	if ((status === "existing" || status === "copy") && entity) {
		let values;
		if (!collection.alwaysApplyDefaultValues) values = entity.values ?? getDefaultValuesFor(properties);
		else values = mergeDeep(getDefaultValuesFor(properties), entity.values ?? {});
		if (status === "copy") {
			const result = { ...values };
			for (const [key, property] of Object.entries(properties)) if (property && "isId" in property && property.isId) delete result[key];
			return result;
		}
		return values;
	} else if (status === "new") return getDefaultValuesFor(properties);
	else {
		console.error({
			status,
			entity
		});
		throw new Error("Form has not been initialised with the correct parameters");
	}
}
function zodToFormErrors(zodError) {
	let errors = {};
	for (const issue of zodError.issues) {
		const path = issue.path.join(".");
		if (path && !getIn(errors, path)) errors = setIn(errors, path, issue.message);
	}
	return errors;
}
//#endregion
//#region src/components/EditFormActions.tsx
/**
* The entity form's footer.
*
* It used to render in two shapes: this footer, and a `w-80 2xl:w-96` sticky
* side rail carrying the same Save and Discard above several hundred pixels of
* nothing. The rail is gone, and Save/Discard have moved to the identity bar
* where they stay visible while the form scrolls — so with
* `showDefaultActions={false}` this renders only what the bar cannot host:
* record actions (copy, delete, custom), plugin actions, the saving error, and
* the side-panel-only "save and close".
*/
function EditFormActions({ collection, path, entity, savingError, formex, disabled, status, pluginActions, openEntityMode, showDefaultActions = true, navigateBack, formContext }) {
	const { canCreate, canDelete } = usePermissions();
	const context = useAdminContext();
	const sidePanelController = context.sidePanelController;
	const sideDialogContext = useSideDialogContext();
	const customizationController = useCustomizationController();
	const { t } = useTranslation();
	const childViewSource = useChildViewSource(path);
	const isLinkedChildView = childViewSource?.kind === "relation" && childViewSource.mode === "linked";
	return buildBottomActions$1({
		savingError,
		entity,
		formActions: useMemo(() => {
			const customEntityActions = (collection.entityActions ?? []).map((action) => resolveEntityAction(action, customizationController.entityActions)).filter(Boolean);
			const createEnabled = canCreate(collection, path);
			const deleteEnabled = entity ? canDelete(collection, path, entity) : false;
			const disableActions = collection.disableDefaultActions ?? [];
			const actions = [];
			if (createEnabled && !disableActions.includes("copy")) actions.push(copyEntityAction);
			if (deleteEnabled && !disableActions.includes("delete")) actions.push(isLinkedChildView ? unlinkEntityAction : deleteEntityAction);
			if (customEntityActions) return mergeEntityActions(actions, customEntityActions);
			return actions;
		}, [
			canCreate,
			canDelete,
			collection,
			path,
			customizationController.entityActions?.length,
			entity,
			collection.disableDefaultActions,
			isLinkedChildView
		]).filter((a) => a.includeInForm === void 0 || a.includeInForm),
		collection,
		context,
		sidePanelController,
		disabled,
		status,
		sideDialogContext,
		pluginActions,
		openEntityMode,
		navigateBack,
		formContext,
		formex,
		t,
		showDefaultActions
	});
}
function buildBottomActions$1({ savingError, entity, formActions, collection, context, sidePanelController, disabled, status, sideDialogContext, pluginActions, openEntityMode, navigateBack, formContext, formex, t, showDefaultActions, className }) {
	const hasErrors = Object.keys(formex.errors).length > 0 && formex.submitCount > 0;
	const canClose = openEntityMode === "side_panel" || openEntityMode === "dialog";
	const showBackToDetail = collection.defaultEntityAction === "view" && status === "existing";
	if (!(showDefaultActions || Boolean(savingError))) return null;
	return /* @__PURE__ */ jsxs(DialogActions, {
		className,
		position: "sticky",
		children: [
			savingError && /* @__PURE__ */ jsx("div", {
				className: "text-right",
				children: /* @__PURE__ */ jsx(Typography, {
					color: "error",
					children: savingError.message
				})
			}),
			formActions.length > 0 && /* @__PURE__ */ jsx("div", {
				className: "grow flex overflow-auto no-scrollbar",
				children: formActions.map((action, index) => {
					const props = {
						view: "form",
						entity,
						path: getCollectionDataPath(collection),
						collection,
						context,
						sidePanelController,
						openEntityMode,
						navigateBack,
						formContext
					};
					return /* @__PURE__ */ jsx(EntityActionButton, {
						action,
						enabled: !action.isEnabled || action.isEnabled(props),
						props
					}, action.key ?? action.name ?? index);
				})
			}),
			pluginActions,
			hasErrors ? /* @__PURE__ */ jsx(ErrorTooltip, {
				title: "This form has errors",
				children: /* @__PURE__ */ jsx(AlertCircleIcon, {
					className: "ml-4 text-red-500",
					size: iconSize.smallest
				})
			}) : null,
			showBackToDetail && /* @__PURE__ */ jsx(Button, {
				variant: "text",
				color: "primary",
				disabled,
				onClick: navigateBack,
				children: t("back_to_detail") ?? "Back to details"
			}),
			showDefaultActions && /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(Button, {
				variant: "text",
				color: "primary",
				disabled: disabled || formex.isSubmitting,
				type: "reset",
				children: status === "existing" ? t("discard") : t("clear")
			}), /* @__PURE__ */ jsx(Tooltip, {
				title: hasErrors ? t("fix_errors_before_saving") ?? "Fix highlighted errors before saving" : void 0,
				children: /* @__PURE__ */ jsxs(Button, {
					variant: canClose ? "text" : "filled",
					color: "primary",
					type: "submit",
					disabled: disabled || formex.isSubmitting,
					onClick: () => {
						sideDialogContext.setPendingClose(false);
					},
					children: [
						status === "existing" && t("save"),
						status === "copy" && t("create_copy"),
						status === "new" && t("create")
					]
				})
			})] }),
			canClose && /* @__PURE__ */ jsxs(LoadingButton, {
				variant: "filled",
				color: "primary",
				type: "submit",
				loading: formex.isSubmitting,
				disabled,
				onClick: () => {
					sideDialogContext.setPendingClose?.(true);
				},
				children: [
					status === "existing" && t("save_and_close"),
					status === "copy" && t("create_copy_and_close"),
					status === "new" && t("create_and_close")
				]
			})
		]
	});
}
function EntityActionButton({ action, enabled, props }) {
	const snackbarController = useSnackbarController();
	const [loading, setLoading] = React.useState(false);
	return /* @__PURE__ */ jsx(Tooltip, {
		title: action.name,
		children: /* @__PURE__ */ jsx(IconButton, {
			color: "primary",
			disabled: !enabled,
			onClick: (event) => {
				console.debug("Executing action", action.key, props);
				try {
					event.stopPropagation();
					if (props.entity) {
						const onClick = action.onClick(props);
						if (onClick instanceof Promise) {
							setLoading(true);
							onClick.catch((error) => {
								console.error("Error executing action", action.key, error);
								snackbarController.open({
									message: `Error executing action: ${error.message}`,
									type: "error"
								});
							}).finally(() => setLoading(false));
						} else snackbarController.open({
							message: `Action ${action.name} executed successfully`,
							type: "success"
						});
					}
				} catch (e) {
					console.error("Error executing action", action.key, e);
					snackbarController.open({
						message: `Error executing action: ${e instanceof Error ? e.message : String(e)}`,
						type: "error"
					});
				}
			},
			children: loading ? /* @__PURE__ */ jsx(CircularProgress, { size: "smallest" }) : getIcon(action.icon, void 0, void 0, "smallest")
		})
	});
}
//#endregion
//#region src/collection_editor/useSafeSnackbarController.ts
function useSafeSnackbarController() {
	try {
		return useSnackbarController();
	} catch {
		return;
	}
}
//#endregion
//#region src/form/useUndoableDiscard.ts
/**
* Throw away everything the user has typed, reversibly.
*
* "Discard" and "Clear" sit next to Save, take one click, and undo everything
* the user has done since they opened the record — the identity bar's version
* does not even stop to ask. So the reset goes *through* the undo history
* rather than around it (see `undoable` in `FormexResetProps`), and the
* confirmation carries the Undo, which is the only place it can be: the form
* has no undo button, only the ⌘Z the user has no reason to guess at.
*
* Pass `values` to reset to something other than the form's current baseline.
*/
function useUndoableDiscard() {
	const snackbarController = useSafeSnackbarController();
	return useCallback((formex, status, values) => {
		formex.resetForm(values !== void 0 ? {
			values,
			undoable: true
		} : { undoable: true });
		snackbarController?.open({
			type: "info",
			message: status === "existing" ? "Changes discarded" : "Form cleared",
			action: {
				label: "Undo",
				onClick: () => formex.undo()
			}
		});
	}, [snackbarController]);
}
//#endregion
//#region src/hooks/useRecordActions.tsx
/**
* The actions you can perform *on* a record — copy, delete, and whatever the
* collection adds — resolved against the current user's permissions.
*
* Extracted from the form's footer so the identity bar can own them. They are
* not ways to leave the form, so they never belonged next to Save; putting them
* in the bar's overflow menu is what let the footer disappear instead of
* becoming a full-width strip holding two icon buttons.
*/
function useRecordActions({ collection, path, entity }) {
	const { canCreate, canDelete } = usePermissions();
	const customizationController = useCustomizationController();
	const childViewSource = useChildViewSource(path);
	const isLinkedChildView = childViewSource?.kind === "relation" && childViewSource.mode === "linked";
	return useMemo(() => {
		const customEntityActions = (collection.entityActions ?? []).map((action) => resolveEntityAction(action, customizationController.entityActions)).filter(Boolean);
		const createEnabled = canCreate(collection, path);
		const deleteEnabled = entity ? canDelete(collection, path, entity) : false;
		const disableActions = collection.disableDefaultActions ?? [];
		const actions = [];
		if (createEnabled && !disableActions.includes("copy")) actions.push(copyEntityAction);
		if (deleteEnabled && !disableActions.includes("delete")) actions.push(isLinkedChildView ? unlinkEntityAction : deleteEntityAction);
		return (customEntityActions.length ? mergeEntityActions(actions, customEntityActions) : actions).filter((a) => a.includeInForm === void 0 || a.includeInForm);
	}, [
		canCreate,
		canDelete,
		collection,
		path,
		customizationController.entityActions?.length,
		entity,
		collection.disableDefaultActions,
		isLinkedChildView
	]);
}
//#endregion
//#region src/components/EditViewBinding.tsx
/**
* This is the default view that is used as the content of a side panel when
* a record is opened.
*/
function EditViewBinding({ entityId, ...props }) {
	const { entity, dataLoading, dataLoadingError } = useFetch({
		path: props.path,
		entityId,
		collection: props.collection,
		databaseId: props.databaseId,
		useCache: false
	});
	const carriesAsNew = props.copy || entityId === void 0;
	const handoffKey = carriesAsNew ? props.path + "#new" : props.path + "/" + entityId;
	const handoff = useRef(null);
	if (handoff.current?.key !== handoffKey) handoff.current = {
		key: handoffKey,
		values: getEntityFromMemoryCache(handoffKey)
	};
	useEffect(() => {
		removeEntityFromMemoryCache(handoffKey);
	}, [handoffKey]);
	const initialDirtyValues = carriesAsNew ? props.defaultValues ?? handoff.current.values : handoff.current.values;
	const { canEdit: canEditHook } = usePermissions();
	const { t } = useTranslation();
	const urlController = useUrlController();
	const [status, setStatus] = useState(props.copy ? "copy" : entityId ? "existing" : "new");
	const canEdit = useMemo(() => {
		if (status === "new" || status === "copy") return true;
		else return entity ? canEditHook(props.collection, props.path, entity ?? null) : void 0;
	}, [
		canEditHook,
		entity,
		status,
		props.collection,
		props.path
	]);
	if (!dataLoading && dataLoadingError) return /* @__PURE__ */ jsx(CenteredView, { children: /* @__PURE__ */ jsx(ErrorView, { error: dataLoadingError }) });
	if (!dataLoading && !initialDirtyValues && !entity && !!entityId && (status === "existing" || status === "copy")) {
		console.warn(`Entity with id ${entityId} not found in collection ${props.path}`);
		return /* @__PURE__ */ jsx(CenteredView, { children: /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col items-center gap-2 text-center",
			children: [
				/* @__PURE__ */ jsx(Typography, {
					variant: "label",
					children: t("entity_not_found")
				}),
				/* @__PURE__ */ jsx(Typography, {
					variant: "body2",
					color: "secondary",
					children: t("entity_not_found_body")
				}),
				/* @__PURE__ */ jsx(Button, {
					variant: "text",
					component: Link,
					to: urlController.buildUrlCollectionPath(props.path),
					children: t("back_to_collection", { name: props.collection.name ?? props.path })
				})
			]
		}) });
	}
	const content = /* @__PURE__ */ jsx(EditViewBindingInner, {
		...props,
		entityId,
		entity,
		initialDirtyValues,
		dataLoading,
		status,
		setStatus,
		canEdit
	});
	return /* @__PURE__ */ jsx(CollectionScopeProvider, {
		collection: props.collection,
		children: content
	});
}
function EditViewBindingInner({ path, entityId, selectedTab: selectedTabProp, collection, parentCollectionSlugs, parentEntityIds, onValuesModified, onSaved, onTabChange, navigateBack, onCloseRequest, entity, initialDirtyValues, dataLoading, layout = "side_panel", barActions, barActionsStart, onShowList, status, setStatus, formProps, canEdit }) {
	const ResolvedFormActions = useComponentOverride("EditView.FormActions", EditFormActions);
	const ResolvedEntityForm = useComponentOverride("Entity.Form", EntityFormBinding);
	const ResolvedCollectionView = useComponentOverride("Collection.View", CollectionViewBinding);
	const context = useRebaseContext();
	const adminContext = useAdminContext();
	const urlController = useUrlController();
	const navigate = useNavigate();
	const [usedEntity, setUsedEntity] = useState(entity);
	useEffect(() => {
		if (entity) setUsedEntity(entity);
	}, [entity]);
	const [formContext, setFormContext] = useState(void 0);
	useLargeLayout();
	const discard = useUndoableDiscard();
	const customizationController = useCustomizationController();
	const plugins = customizationController.plugins;
	const formActionTopProps = useMemo(() => ({
		entityId,
		parentCollectionSlugs,
		parentEntityIds,
		path,
		status,
		collection,
		context,
		formContext,
		openEntityMode: layout,
		disabled: false
	}), [
		entityId,
		parentCollectionSlugs,
		parentEntityIds,
		path,
		status,
		collection,
		context,
		formContext,
		layout
	]);
	const pluginActionsTop = useSlot("form.actions.top", formActionTopProps);
	const defaultSelectedView = useMemo(() => resolveDefaultSelectedView(collection ? collection.defaultSelectedView : void 0, {
		status,
		entityId
	}), [
		collection,
		status,
		entityId
	]);
	const userHasChangedTab = useRef(false);
	const [selectedTab, setSelectedTab] = useState(() => {
		const val = selectedTabProp ?? defaultSelectedView ?? "__main_##Q$SC^#S6";
		return val === "edit" ? MAIN_TAB_VALUE : val;
	});
	useEffect(() => {
		const val = userHasChangedTab.current ? selectedTabProp ?? "__main_##Q$SC^#S6" : selectedTabProp ?? defaultSelectedView ?? "__main_##Q$SC^#S6";
		const target = val === "edit" ? MAIN_TAB_VALUE : val;
		if (target !== selectedTab) setSelectedTab(target);
	}, [selectedTabProp, defaultSelectedView]);
	const childViews = getAdminEntityChildViews(collection).filter((v) => !v.collection.hideFromEntityViews);
	const subcollections = childViews.map((v) => v.collection);
	const subcollectionsCount = subcollections?.length ?? 0;
	const customViews = collection.entityViews ?? [];
	const customViewsCount = customViews?.length ?? 0;
	const includeJsonView = collection.includeJsonView === void 0 ? true : collection.includeJsonView;
	const includeHistoryView = Boolean(collection.history);
	const hasAdditionalViews = customViewsCount > 0 || subcollectionsCount > 0;
	const { resolvedEntityViews } = resolvedSelectedEntityView(customViews, customizationController, void 0, canEdit);
	const legacyInspectorTab = selectedTab === "__json" ? "json" : selectedTab === "__rebase_history" ? "history" : void 0;
	const activeTab = useMemo(() => {
		return /* @__PURE__ */ new Set([
			"__main_##Q$SC^#S6",
			...resolvedEntityViews.map((v) => v.key),
			...subcollections.map((s) => s.slug)
		]);
	}, [resolvedEntityViews, subcollections]).has(selectedTab) ? selectedTab : MAIN_TAB_VALUE;
	const { selectedEntityView, selectedSecondaryForm } = resolvedSelectedEntityView(customViews, customizationController, activeTab, canEdit);
	const mainViewVisible = activeTab === "__main_##Q$SC^#S6" || Boolean(selectedSecondaryForm);
	const mountedTabsRef = useRef(/* @__PURE__ */ new Set());
	if (activeTab) mountedTabsRef.current.add(activeTab);
	/**
	* The record as a context with no form behind it: what a view is handed
	* where nothing can edit the record — the read-only rendering for a user
	* without permission, and the entity-view tabs until the form has mounted
	* and published its own. Its writes throw, so it says `disabled`: that is
	* the flag every control already honours, and a stand-in reporting
	* `disabled: false` invited the very write it was about to refuse.
	*
	* Not dropped once the form's context arrives. The form mounts even where
	* it is hidden — for a user who cannot edit, the read-only view is shown
	* beside a hidden form — so its context always arrives, and the read-only
	* view lost its context the moment it did: a `formView` flipped to the
	* default rendering, and `additionalFields` vanished from the default one.
	*/
	const readOnlyFormContext = useMemo(() => {
		if (!entityId) return void 0;
		const formexStub = createFormexStub(usedEntity?.values ?? {});
		return {
			entityId,
			disabled: true,
			readOnly: true,
			openEntityMode: layout,
			status,
			values: usedEntity?.values ?? {},
			setFieldValue: (key, value) => {
				throw new Error("You can't update values in read only mode");
			},
			save: () => {
				throw new Error("You can't save in read only mode");
			},
			submit: () => {
				throw new Error("You can't submit in read only mode");
			},
			collection,
			path,
			entity: usedEntity,
			savingError: void 0,
			formex: formexStub
		};
	}, [
		entityId,
		layout,
		status,
		usedEntity,
		collection,
		path
	]);
	const nonActionCustomViews = useMemo(() => resolvedEntityViews.filter((e) => !e.includeActions), [resolvedEntityViews]);
	const customViewsView = customViews && nonActionCustomViews.map((customView) => {
		if (!customView) return null;
		const Builder = resolveComponentRef(customView.Builder);
		if (!Builder) {
			console.error("INTERNAL: customView.Builder is not defined or could not be resolved");
			return null;
		}
		if (!entityId) return null;
		const isActive = activeTab === customView.key;
		const hasBeenMounted = mountedTabsRef.current.has(customView.key);
		if (!isActive && !hasBeenMounted) return null;
		const usedFormContext = formContext ?? readOnlyFormContext;
		return /* @__PURE__ */ jsx("div", {
			className: cls(defaultBorderMixin, "relative flex-1 w-full h-full overflow-auto", { "hidden": !isActive }),
			role: "tabpanel",
			children: /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(Suspense, {
				fallback: /* @__PURE__ */ jsx(CircularProgressCenter, {}),
				children: usedFormContext && /* @__PURE__ */ jsx(Builder, {
					collection,
					parentCollectionSlugs,
					parentEntityIds,
					entity: usedEntity,
					modifiedValues: usedFormContext?.formex?.values ?? usedEntity?.values,
					formContext: usedFormContext
				})
			}) })
		}, `custom_view_${customView.key}`);
	}).filter(Boolean);
	const globalLoading = dataLoading && !usedEntity || canEdit === void 0 && (status === "existing" || status === "copy");
	const displayTitle = useEntityDisplayTitle({
		collection,
		entity: usedEntity,
		values: formContext?.values ?? usedEntity?.values,
		status
	});
	const formex = formContext?.formex;
	const hasFormErrors = Boolean(formex && Object.keys(formex.errors).length > 0 && formex.submitCount > 0);
	const saveDisabled = Boolean(!formContext || formContext.disabled || formex?.isSubmitting || status === "existing" && !formex?.dirty);
	/**
	* Hand this record's edit in progress to the layout about to replace this
	* one — the split's "hide list", full screen's "show list", the side panel's
	* "open full screen". None of them is a navigation *away* from the record:
	* the same record is about to be shown by a different form, and what the
	* user has typed belongs to the record, not to the pane it was typed in.
	*
	* Every control that changes layout has to call this, and none of them is
	* blocked by the unsaved-changes prompt — the prompt asks about leaving, and
	* these do not leave. What used to happen instead is that the edit reached
	* the next layout only as its local-changes backup, which is the channel for
	* a draft left behind by a closed tab: the record reopened *clean*, with a
	* banner offering to apply changes the user had never walked away from.
	*/
	const carryEdit = useCallback(() => {
		const carried = formex ? getEditHandoffValues({
			status,
			dirty: formex.dirty,
			values: formex.values,
			touched: formex.touched,
			storedValues: usedEntity?.values
		}) : void 0;
		if (!carried) return;
		saveEntityToMemoryCache(status === "new" || status === "copy" ? path + "#new" : path + "/" + entityId, carried);
	}, [
		formex,
		status,
		path,
		entityId,
		usedEntity
	]);
	const [inspectorTab, setInspectorTab] = useState(null);
	const [savedCount, setSavedCount] = useState(0);
	const sideDialogContext = useSideDialogContext();
	/**
	* Whether the save in flight was asked to dismiss the record afterwards.
	*
	* A ref, and for the reason {@link SideDialogs} keeps its own as one: the
	* flag is raised and the form submitted in a single click handler, and the
	* `onSaved` that has to act on it was captured before React could re-render.
	* As state it read one save late — the first "save and close" saved and
	* stayed open, and the *next* save closed the record.
	*
	* The side panel and the dialog use the side-dialog controller's flag,
	* which their own close path consumes; this one covers the layouts that
	* close by calling {@link onCloseRequest} instead.
	*/
	const pendingCloseRef = useRef(false);
	const canCloseAfterSave = layout === "side_panel" || layout === "dialog" || layout === "split" && Boolean(onCloseRequest);
	const recordActions = useRecordActions({
		collection,
		path,
		entity: usedEntity
	});
	const recordActionItems = usedEntity && recordActions.length ? recordActions.map((action, index) => {
		const clickProps = {
			view: "form",
			entity: usedEntity,
			path,
			collection,
			context,
			sidePanelController: adminContext.sidePanelController,
			openEntityMode: layout,
			navigateBack: navigateBack ?? (() => void 0),
			formContext
		};
		return /* @__PURE__ */ jsxs(MenuItem, {
			disabled: !(!action.isEnabled || action.isEnabled(clickProps)),
			onClick: () => action.onClick(clickProps),
			children: [getIcon(action.icon, void 0, void 0, "smallest"), action.name]
		}, action.key ?? action.name ?? index);
	}) : null;
	const formPluginActions = useSlot("form.actions", formActionTopProps);
	useEffect(() => {
		if (legacyInspectorTab) setInspectorTab(legacyInspectorTab);
	}, [legacyInspectorTab]);
	const subCollectionsViews = childViews && childViews.map(({ collection: subcollection }) => {
		const subcollectionId = subcollection.slug;
		const newFullPath = usedEntity ? `${path}/${usedEntity?.id}/${removeInitialAndTrailingSlashes(getCollectionDataPath(subcollection))}` : void 0;
		if (activeTab !== subcollectionId) return null;
		return /* @__PURE__ */ jsxs("div", {
			className: "relative flex-1 h-full overflow-auto w-full",
			role: "tabpanel",
			children: [globalLoading && /* @__PURE__ */ jsx(CircularProgressCenter, {}), !globalLoading && (usedEntity && newFullPath ? /* @__PURE__ */ jsx(ResolvedCollectionView, {
				path: newFullPath,
				parentCollectionSlugs: [...parentCollectionSlugs, collection.slug],
				parentEntityIds: [...parentEntityIds, String(usedEntity?.id)],
				updateUrl: false,
				...subcollection,
				openEntityMode: layout
			}) : /* @__PURE__ */ jsx("div", {
				className: "flex items-center justify-center w-full h-full p-3",
				children: /* @__PURE__ */ jsx(Typography, {
					variant: "label",
					children: "You need to save your entity before adding additional collections"
				})
			}))]
		}, `subcol_${subcollectionId}`);
	}).filter(Boolean);
	const onSideTabClick = useCallback((value) => {
		userHasChangedTab.current = true;
		setSelectedTab(value);
		if (status === "existing") onTabChange?.({
			path,
			entityId,
			selectedTab: value === "__main_##Q$SC^#S6" ? void 0 : value,
			collection
		});
	}, [
		status,
		onTabChange,
		path,
		entityId,
		collection
	]);
	const formViewConfig = collection.formView;
	const FormViewBuilder = resolveComponentRef(formViewConfig?.Builder);
	const formViewIncludeActions = formViewConfig?.includeActions !== false;
	/**
	* What the record form renders in place of its generated fields.
	*
	* A `formView` Builder is rendered *by the form*, never instead of it. It
	* used to be drawn here in the form's place, and the form is the only
	* thing that can hand it a working context — the real one arrives through
	* `onFormContextReady`, and with no form mounted it never did. Every
	* Builder got the read-only stand-in above: each keystroke threw inside
	* `setFieldValue`, and Save and Discard, which wait on that same context,
	* never appeared. A new record was worse: with no id there is not even a
	* stand-in, and the screen stayed blank.
	*
	* An entity view declared with `includeActions` is a second form over the
	* same record, and takes the place while its tab is open.
	*/
	const FormBuilder = selectedSecondaryForm ? resolveComponentRef(selectedSecondaryForm.Builder) : FormViewBuilder;
	/**
	* `formView.includeActions: false` leaves saving to the Builder — it holds
	* `formContext.submit` and `save` — so the bar offers no Save or Discard of
	* its own. Only for the collection's form: an entity view that declared
	* `includeActions` is on screen because it asked for them. Delete is a
	* record action, in the bar's overflow menu, and is not affected.
	*/
	const formActionsContext = canEdit && formContext && (!FormViewBuilder || formViewIncludeActions || selectedSecondaryForm) ? formContext : void 0;
	const entityReadOnlyView = !canEdit && entity ? FormViewBuilder && readOnlyFormContext ? /* @__PURE__ */ jsx("div", {
		className: cls("@container/form flex-1 flex flex-row w-full overflow-y-auto justify-center", canEdit || !mainViewVisible || selectedSecondaryForm ? "hidden" : ""),
		children: /* @__PURE__ */ jsx("div", {
			className: "w-full max-w-3xl @7xl/form:max-w-4xl 2xl:max-w-4xl flex flex-col pt-6 pb-16 px-5 sm:px-8",
			children: /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(Suspense, {
				fallback: /* @__PURE__ */ jsx(CircularProgressCenter, {}),
				children: /* @__PURE__ */ jsx(FormViewBuilder, {
					collection,
					parentCollectionSlugs,
					parentEntityIds,
					entity: usedEntity,
					modifiedValues: usedEntity?.values,
					formContext: readOnlyFormContext
				})
			}) })
		})
	}) : /* @__PURE__ */ jsx(EntityViewBinding, {
		className: cls(canEdit || !mainViewVisible || selectedSecondaryForm ? "hidden" : ""),
		entity,
		path,
		collection,
		asPage: true,
		openEntityMode: layout,
		formContext: readOnlyFormContext
	}) : null;
	const entityView = /* @__PURE__ */ jsx(ResolvedEntityForm, {
		collection,
		path,
		entityId: entityId ?? usedEntity?.id,
		onValuesModified,
		entity,
		initialDirtyValues,
		openEntityMode: layout,
		showDefaultActions: false,
		initialStatus: status,
		className: cls((!mainViewVisible || !canEdit) && !selectedSecondaryForm ? "hidden" : "", formProps?.className),
		EntityFormActionsComponent: ResolvedFormActions,
		disabled: !canEdit,
		navigateBack,
		...formProps,
		onEntityChange: (entity) => {
			setUsedEntity(entity);
			formProps?.onEntityChange?.(entity);
		},
		onStatusChange: (status) => {
			setStatus(status);
			formProps?.onStatusChange?.(status);
		},
		onFormContextReady: (formContext) => {
			setFormContext(formContext);
			formProps?.onFormContextReady?.(formContext);
		},
		onSaved: (params) => {
			setSavedCount((count) => count + 1);
			const res = {
				...params,
				selectedTab: "__main_##Q$SC^#S6" === activeTab ? void 0 : activeTab
			};
			onSaved?.(res);
			formProps?.onSaved?.(res);
			if (pendingCloseRef.current) {
				pendingCloseRef.current = false;
				setTimeout(() => onCloseRequest?.(), 0);
			}
		},
		Builder: FormBuilder,
		parentCollectionSlugs,
		parentEntityIds
	});
	const subcollectionTabs = subcollections && subcollections.map((subcollection) => {
		const icon = getIcon(subcollection.icon, void 0, void 0, "smallest");
		return /* @__PURE__ */ jsx(Tab, {
			className: cls("h-full", "text-sm min-w-[90px]"),
			value: subcollection.slug,
			children: /* @__PURE__ */ jsxs("span", {
				className: "flex items-center gap-1.5",
				children: [icon, subcollection.name]
			})
		}, `entity_detail_collection_tab_${subcollection.name}`);
	});
	const customViewTabsStart = resolvedEntityViews.filter((view) => view.position === "start").map((view) => {
		const icon = getIcon(view.icon, void 0, void 0, "smallest");
		return /* @__PURE__ */ jsx(Tab, {
			className: cls(ENTITY_VIEW_TAB_CLASS, !view.tabComponent && "text-sm min-w-[90px]"),
			value: view.key,
			children: view.tabComponent ?? /* @__PURE__ */ jsxs("span", {
				className: "flex items-center gap-1.5",
				children: [icon, view.name]
			})
		}, `entity_detail_collection_tab_${view.name}`);
	});
	const customViewTabsEnd = resolvedEntityViews.filter((view) => !view.position || view.position === "end").map((view) => {
		const icon = getIcon(view.icon, void 0, void 0, "smallest");
		return /* @__PURE__ */ jsx(Tab, {
			className: cls(ENTITY_VIEW_TAB_CLASS, !view.tabComponent && "text-sm min-w-[90px]"),
			value: view.key,
			children: view.tabComponent ?? /* @__PURE__ */ jsxs("span", {
				className: "flex items-center gap-1.5",
				children: [icon, view.name]
			})
		}, `entity_detail_collection_tab_${view.name}`);
	});
	const onSave = formActionsContext ? () => {
		sideDialogContext.setPendingClose?.(false);
		pendingCloseRef.current = false;
		formActionsContext.submit();
	} : void 0;
	const onSaveAndClose = formActionsContext && canCloseAfterSave ? () => {
		if (layout === "split") {
			pendingCloseRef.current = true;
			Promise.resolve(formActionsContext.submit()).finally(() => {
				pendingCloseRef.current = false;
			});
			return;
		}
		sideDialogContext.setPendingClose?.(true);
		Promise.resolve(formActionsContext.submit()).finally(() => sideDialogContext.setPendingClose?.(false));
	} : void 0;
	const onDiscard = formActionsContext ? () => discard(formActionsContext.formex, status) : void 0;
	/**
	* The dialog keeps Save at its foot, not in the bar.
	*
	* A dialog is filled in top to bottom and finished at the bottom, which is
	* where every other dialog in the app puts its buttons; up in the bar's
	* right-hand corner, Create was the one thing on screen the eye had to
	* travel back up to reach. The bar keeps what the record is and the ways
	* out of it. The side panel and the pages keep Save in the bar, where it
	* stays in view while a long form scrolls.
	*/
	const actionsInFooter = layout === "dialog";
	const fullScreenButton = !barActions && (layout === "side_panel" || layout === "dialog") && entityId ? /* @__PURE__ */ jsx(Tooltip, {
		title: "Open full screen",
		children: /* @__PURE__ */ jsx(IconButton, {
			size: "small",
			onClick: () => {
				carryEdit();
				const editSuffix = collection.defaultEntityAction === "view" ? "/edit" : "";
				const entityUrl = urlController.buildUrlCollectionPath(`${path}/${entityId}${editSuffix}`);
				navigate(`${entityUrl}#full`);
			},
			children: /* @__PURE__ */ jsx(Maximize2Icon, { size: iconSize.smallest })
		})
	}) : null;
	let result = /* @__PURE__ */ jsxs("div", {
		className: "relative flex flex-col h-full w-full bg-surface-card",
		children: [
			/* @__PURE__ */ jsx(EntityIdentityBar, {
				collection,
				collectionUrl: layout === "full_screen" || layout === "split" ? withListState(urlController.buildUrlCollectionPath(path)) : void 0,
				title: displayTitle,
				entityId: status === "existing" ? entityId : void 0,
				status,
				dirty: Boolean(formContext?.formex?.dirty),
				saving: Boolean(formContext?.isSaving),
				hasErrors: hasFormErrors,
				saveDisabled: !canEdit || saveDisabled,
				onBack: layout === "full_screen" && !onShowList ? () => navigate(withListState(urlController.buildUrlCollectionPath(path))) : void 0,
				onSave: actionsInFooter ? void 0 : onSave,
				onSaveAndClose: actionsInFooter ? void 0 : onSaveAndClose,
				saveAndClosePlacement: layout === "split" ? "menu" : "button",
				onClose: onCloseRequest,
				onDiscard: actionsInFooter ? void 0 : onDiscard,
				onInspect: includeJsonView ? () => setInspectorTab("json") : void 0,
				onViewHistory: includeHistoryView ? () => setInspectorTab("history") : void 0,
				externalLink: usedEntity ? customizationController?.entityLinkBuilder?.({ entity: usedEntity }) : void 0,
				recordActions: recordActionItems,
				pluginActions: formPluginActions,
				leading: /* @__PURE__ */ jsxs(Fragment, { children: [
					barActionsStart,
					layout === "split" && /* @__PURE__ */ jsx(SplitListCloseButton, { onBeforeHide: carryEdit }),
					layout === "full_screen" && onShowList && /* @__PURE__ */ jsx(SplitListShowButton, { onClick: () => {
						carryEdit();
						onShowList();
					} })
				] }),
				trailing: /* @__PURE__ */ jsxs(Fragment, { children: [
					pluginActionsTop,
					fullScreenButton,
					barActions?.({
						path,
						entityId,
						values: formContext?.values ?? usedEntity?.values ?? {},
						status,
						dirty: Boolean(formContext?.formex?.dirty),
						carryEdit
					})
				] })
			}),
			hasAdditionalViews && /* @__PURE__ */ jsx("div", {
				className: cls("h-10 shrink-0 flex items-stretch border-b px-2 min-w-0", "bg-surface-sheet", defaultBorderMixin),
				children: /* @__PURE__ */ jsxs(Tabs, {
					className: "!w-full items-stretch",
					innerClassName: "h-full",
					variant: "boxy",
					value: activeTab,
					onValueChange: (value) => {
						onSideTabClick(value);
					},
					children: [
						customViewTabsStart,
						/* @__PURE__ */ jsx(Tab, {
							value: "__main_##Q$SC^#S6",
							className: cls("h-full", "text-sm min-w-[90px]"),
							children: /* @__PURE__ */ jsxs("span", {
								className: "flex items-center gap-1.5",
								children: [getIcon(collection.icon, void 0, void 0, "smallest"), collection.singularName ?? collection.name]
							})
						}),
						customViewTabsEnd,
						subcollectionTabs
					]
				})
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "flex-1 min-h-0 flex",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "flex-1 min-w-0 flex flex-col",
					children: [
						globalLoading ? /* @__PURE__ */ jsx(EntityFormSkeleton, { collection }) : /* @__PURE__ */ jsxs(Fragment, { children: [entityReadOnlyView, entityView] }),
						customViewsView,
						subCollectionsViews
					]
				}), /* @__PURE__ */ jsx(EntityInspector, {
					tab: inspectorTab,
					onTabChange: setInspectorTab,
					onClose: () => setInspectorTab(null),
					collection,
					entity: usedEntity,
					formContext,
					values: formContext?.values ?? usedEntity?.values,
					refreshToken: savedCount,
					includeHistory: includeHistoryView
				})]
			}),
			actionsInFooter && onSave && /* @__PURE__ */ jsx(DialogActions, {
				translucent: false,
				children: /* @__PURE__ */ jsx(EntitySaveActions, {
					status,
					dirty: Boolean(formContext?.formex?.dirty),
					saving: Boolean(formContext?.isSaving),
					hasErrors: hasFormErrors,
					saveDisabled: !canEdit || saveDisabled,
					onSave,
					onSaveAndClose,
					onDiscard
				})
			})
		]
	});
	if (plugins && plugins.length > 0) result = /* @__PURE__ */ jsx(PluginProviderStack, {
		plugins,
		scope: "form",
		scopeProps: {
			status,
			path,
			collection,
			entity: usedEntity,
			context,
			formContext
		},
		children: result
	});
	return result;
}
function EntityFormSkeleton({ collection }) {
	return /* @__PURE__ */ jsx("div", {
		className: "flex-1 flex flex-row w-full overflow-y-auto justify-center",
		children: /* @__PURE__ */ jsx("div", {
			className: "relative flex flex-row max-w-4xl lg:max-w-3xl xl:max-w-4xl 2xl:max-w-6xl w-full h-fit",
			children: /* @__PURE__ */ jsxs("div", {
				className: "flex flex-col w-full pt-12 pb-16 px-4 sm:px-8 md:px-10",
				children: [
					/* @__PURE__ */ jsx("div", {
						className: "flex flex-row gap-4 self-end sticky top-4 z-10",
						children: /* @__PURE__ */ jsx(Skeleton, {
							height: 24,
							className: "w-8 rounded-full"
						})
					}),
					/* @__PURE__ */ jsxs("div", {
						className: "w-full flex flex-col items-start my-4 lg:my-6",
						children: [/* @__PURE__ */ jsx("div", {
							className: `py-1 my-4 w-2/3 ${collection.hideIdFromForm ? "mb-6" : ""}`,
							children: /* @__PURE__ */ jsx(Skeleton, {
								height: 28,
								className: "w-full rounded-md"
							})
						}), /* @__PURE__ */ jsx(Skeleton, {
							height: 32,
							className: "w-full rounded-md"
						})]
					}),
					/* @__PURE__ */ jsx("div", {
						className: "mt-12 flex flex-col gap-8",
						children: /* @__PURE__ */ jsxs("div", {
							className: "flex flex-wrap gap-x-4 w-full space-y-8",
							children: [
								/* @__PURE__ */ jsx("div", {
									className: "relative w-full",
									children: /* @__PURE__ */ jsx(Skeleton, {
										height: 60,
										className: "w-full rounded-md"
									})
								}),
								/* @__PURE__ */ jsx("div", {
									className: "relative w-full",
									children: /* @__PURE__ */ jsx(Skeleton, {
										height: 60,
										className: "w-full rounded-md"
									})
								}),
								/* @__PURE__ */ jsx("div", {
									className: "relative w-full",
									children: /* @__PURE__ */ jsx(Skeleton, {
										height: 60,
										className: "w-full rounded-md"
									})
								}),
								/* @__PURE__ */ jsx("div", {
									className: "relative w-full",
									children: /* @__PURE__ */ jsx(Skeleton, {
										height: 60,
										className: "w-full rounded-md"
									})
								})
							]
						})
					})
				]
			})
		})
	});
}
//#endregion
//#region src/components/SidePanelBinding.tsx
/**
* This is the component in charge of rendering the side dialog used
* for editing entities. Use the {@link useSidePanel} to open
* and control the dialogs.
* This component needs a parent {@link Rebase}
* {@link useSidePanel}
* @group Components
*/
function SidePanelBinding(props) {
	const { allowFullScreen = true, path, entityId, selectedTab, formProps } = props;
	const ResolvedDetailView = useComponentOverride("DetailView", DetailViewBinding);
	const { blocked, setBlocked, setBlockedNavigationMessage, close } = useSideDialogContext();
	const navigate = useNavigate();
	const sidePanelController = useSidePanel();
	const collectionRegistryController = useCollectionRegistryController();
	const sideDialogsController = useSideDialogContext();
	const urlController = useUrlController();
	/**
	* The X in the identity bar.
	*
	* Unforced, so it stops at the same unsaved-changes prompt that Escape and
	* a click outside already do. It used to clear `blocked` and force the
	* close, which made the one control actually labelled "close" the only way
	* out of the panel that dropped an edit without asking.
	*
	* `props.onClose` is not called here: the panel carries the same callback
	* (see `propsToSidePanel`) and {@link SideDialogs} fires it once the panel
	* really closes — which is after the prompt, not before it.
	*/
	const onClose = () => {
		close();
	};
	/**
	* Closing because the record was just saved, which is the one case that has
	* to force. `blocked` is driven by an effect on the form's dirty flag and is
	* still true for a tick after a save; prompting about unsaved changes here
	* would be asking about values that are already on the server.
	*/
	const closeAfterSave = () => {
		setBlocked(false);
		close(true);
	};
	/**
	* The panel's response to a save, and the one place it decides where the
	* panel goes next.
	*
	* Exactly **one** panel navigation is raised here. These branches used to
	* run independently — a `replace` onto the saved record's address *and* a
	* close — and because the last navigation is the one that survives, which
	* of them the user got was settled by statement order rather than by
	* intent. Closing wins by construction now: moving a panel to a new address
	* it is about to leave is work whose only effect is to fight the close.
	*
	* `props.onUpdate` runs last for the same reason. It belongs to whoever
	* opened the panel and it is free to navigate — the reference picker's
	* selects the record and closes the picker — so the opener's intent should
	* be the final word, not something this panel overwrites on its way out.
	*/
	const onUpdate = (params) => {
		setEditInDialog(false);
		if (sideDialogsController.pendingClose || props.closeOnSave) {
			sideDialogsController.setPendingClose(false);
			closeAfterSave();
		} else if (params.status !== "existing") sidePanelController.replace({
			path: params.path,
			entityId: params.entityId,
			selectedTab: params.selectedTab,
			updateUrl: collection?.openEntityMode !== "dialog",
			collection: params.collection
		});
		else closeEditView();
		props.onUpdate?.(params);
	};
	const parentCollectionSlugs = useMemo(() => {
		return collectionRegistryController.getParentCollectionSlugs(path);
	}, [collectionRegistryController, path]);
	const parentEntityIds = useMemo(() => {
		return collectionRegistryController.getParentEntityIds(path);
	}, [collectionRegistryController, path]);
	const collection = collectionRegistryController.getCollection(path) ?? props.collection;
	const isDialogMode = collection?.openEntityMode === "dialog";
	const [editInDialog, setEditInDialog] = useState(false);
	const showEditInPanel = isDialogMode ? editInDialog : selectedTab === "edit";
	const isDetailMode = collection?.defaultEntityAction === "view" && !showEditInPanel && Boolean(entityId);
	useEffect(() => {
		setEditInDialog(false);
	}, [entityId]);
	const openEditView = useCallback(() => {
		if (isDialogMode || !entityId) {
			setEditInDialog(true);
			return;
		}
		sidePanelController.replace({
			path,
			entityId,
			selectedTab: "edit",
			updateUrl: true,
			collection
		});
	}, [
		isDialogMode,
		entityId,
		path,
		collection,
		sidePanelController
	]);
	const closeEditView = useCallback(() => {
		if (isDialogMode || !entityId) {
			setEditInDialog(false);
			return;
		}
		sidePanelController.replace({
			path,
			entityId,
			selectedTab: void 0,
			updateUrl: true,
			collection
		});
	}, [
		isDialogMode,
		entityId,
		path,
		collection,
		sidePanelController
	]);
	const hasCorrectedDefaultView = useRef(false);
	useEffect(() => {
		hasCorrectedDefaultView.current = false;
	}, [entityId]);
	useEffect(() => {
		if (hasCorrectedDefaultView.current) return;
		if (selectedTab) return;
		if (!entityId || !collection?.defaultSelectedView) return;
		const effectiveDefault = resolveDefaultSelectedView(collection.defaultSelectedView, {
			status: "existing",
			entityId
		});
		if (effectiveDefault && effectiveDefault !== "edit") {
			hasCorrectedDefaultView.current = true;
			sidePanelController.replace({
				path,
				entityId,
				selectedTab: effectiveDefault,
				updateUrl: collection.openEntityMode !== "dialog",
				collection
			});
		}
	}, [
		selectedTab,
		entityId,
		collection,
		path,
		sidePanelController
	]);
	const onValuesModified = useCallback((modified) => {
		setBlockedNavigationMessage(modified ? /* @__PURE__ */ jsxs(Fragment, { children: [
			" You have unsaved changes in this ",
			/* @__PURE__ */ jsx("b", { children: collection?.singularName ?? collection?.name }),
			"."
		] }) : void 0);
		setBlocked(modified);
	}, [
		collection?.name,
		setBlocked,
		setBlockedNavigationMessage
	]);
	if (!props || !collection) return /* @__PURE__ */ jsx("div", { className: "w-full" });
	const closeButton = /* @__PURE__ */ jsx(IconButton, {
		className: "self-center",
		size: "small",
		onClick: onClose,
		children: /* @__PURE__ */ jsx(XIcon, {})
	});
	/**
	* Where the panel's own two controls sit, which is not the same question in
	* the two layouts that have them.
	*
	* A **side panel** slides in over the list from the right, and its leading
	* edge is the seam between the two. Close belongs on that seam — it points
	* back at the thing still visible behind it — and it is where the eye
	* already is, because the breadcrumb starts there.
	*
	* A **dialog** has no seam and nothing behind it to point at. It is a box
	* centred on a dimmed screen, and every box like it on every platform is
	* dismissed from its top-right corner. Close was sitting at the far left
	* of the bar, a full dialog's width from the expand button it belongs
	* beside, in the one corner that means "back" in a layout with no back.
	*
	* So in a dialog the two travel together at the trailing edge, expand then
	* close: the window controls, after the record's actions and its overflow
	* menu, in the corner a dialog is closed from.
	*/
	const barActionsStart = isDialogMode ? void 0 : closeButton;
	const windowControls = (expandButton) => /* @__PURE__ */ jsxs("div", {
		className: "flex gap-1 items-center",
		children: [expandButton, isDialogMode && closeButton]
	});
	return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(ErrorBoundary, { children: isDetailMode ? /* @__PURE__ */ jsx(ResolvedDetailView, {
		path,
		layout: collection?.openEntityMode === "dialog" ? "dialog" : "side_panel",
		collection,
		entityId,
		parentCollectionSlugs,
		parentEntityIds,
		onEditClick: openEditView,
		barActionsStart,
		barActions: () => windowControls(allowFullScreen && /* @__PURE__ */ jsx(IconButton, {
			className: "self-center",
			size: "small",
			onClick: () => {
				if (entityId) {
					const fullScreenUrl = urlController.buildUrlCollectionPath(`${path}/${entityId}`);
					navigate(fullScreenUrl, { state: null });
				}
			},
			children: /* @__PURE__ */ jsx(Maximize2Icon, {})
		})),
		onTabChange: ({ entityId: tabEntityId, selectedTab, collection: paramCollection }) => {
			if (collection?.openEntityMode === "dialog" || paramCollection?.openEntityMode === "dialog") return;
			if (tabEntityId) sidePanelController.replace({
				path,
				entityId: tabEntityId,
				selectedTab,
				updateUrl: true,
				collection: paramCollection ?? collection
			});
		}
	}) : /* @__PURE__ */ jsx(EditViewBinding, {
		...props,
		layout: collection?.openEntityMode === "dialog" ? "dialog" : "side_panel",
		collection,
		parentCollectionSlugs,
		parentEntityIds,
		onValuesModified,
		onSaved: onUpdate,
		navigateBack: closeEditView,
		barActionsStart,
		barActions: ({ carryEdit }) => windowControls(allowFullScreen && /* @__PURE__ */ jsx(IconButton, {
			className: "self-center",
			size: "small",
			onClick: () => {
				carryEdit?.();
				setBlocked(false);
				setBlockedNavigationMessage(void 0);
				if (entityId) {
					const fullScreenUrl = urlController.buildUrlCollectionPath(`${path}/${entityId}`);
					navigate(fullScreenUrl, { state: null });
				} else {
					const fullScreenUrl = urlController.buildUrlCollectionPath(path);
					navigate(fullScreenUrl + "#new", { state: null });
				}
			},
			children: /* @__PURE__ */ jsx(Maximize2Icon, {})
		})),
		onTabChange: ({ entityId: tabEntityId, selectedTab, collection: paramCollection }) => {
			if (collection?.openEntityMode === "dialog" || paramCollection?.openEntityMode === "dialog") return;
			if (tabEntityId) sidePanelController.replace({
				path,
				entityId: tabEntityId,
				selectedTab,
				updateUrl: true,
				collection: paramCollection ?? collection
			});
		},
		formProps
	}) }) });
}
//#endregion
//#region src/hooks/useBuildSidePanel.tsx
/**
* Thin wrapper that resolves the Entity.SidePanel component override.
* Because the JSX is created inside `propsToSidePanel` (a plain function,
* not a React component), we need this wrapper so the hook is called at the
* top level of a React component per the Rules of Hooks.
*/
function ResolvedSidePanelBindingInner(props) {
	return /* @__PURE__ */ jsx(useComponentOverride("Entity.SidePanel", SidePanelBinding), { ...props });
}
function ResolvedSidePanelBinding(props) {
	if (props.collection) return /* @__PURE__ */ jsx(CollectionScopeProvider, {
		collection: props.collection,
		children: /* @__PURE__ */ jsx(ResolvedSidePanelBindingInner, { ...props })
	});
	return /* @__PURE__ */ jsx(ResolvedSidePanelBindingInner, { ...props });
}
var NEW_URL_HASH = "new_side";
var SIDE_URL_HASH = "side";
/**
* How wide the side panel opens.
*
* One width for the whole panel, whatever tab is showing. It used to depend on
* the selected tab — the form got one width and a subcollection or custom view
* got `calc(55vw + 768px)` — so the panel physically resized under the cursor
* every time you switched tabs. And the "form" width was derived from how
* deeply nested the collection's *properties* were, which is not a thing anyone
* can predict from looking at the panel.
*
* Now: `width` prop, then the collection's `sideDialogWidth`, then a default
* sized for the content the panel actually has to hold — the form column plus
* its metadata rail — capped so it never eats the whole window.
*/
function getEntityViewWidth(props, small, customizationController) {
	if (small) return CONTAINER_FULL_WIDTH;
	if (props.width) return typeof props.width === "number" ? `${props.width}px` : props.width;
	if (props.collection?.sideDialogWidth) return typeof props.collection.sideDialogWidth === "number" ? `${props.collection.sideDialogWidth}px` : props.collection.sideDialogWidth;
	return SIDE_PANEL_DEFAULT_WIDTH;
}
var useBuildSidePanel = (collectionRegistryController, urlController, navigationStateController, sideDialogsController, authController) => {
	const location = useLocation();
	const initialised = useRef(false);
	const currentPanelKeysRef = useRef([]);
	const customizationController = useCustomizationController();
	const smallLayout = !useLargeLayout();
	useEffect(() => {
		const newFlag = location.hash === `#${NEW_URL_HASH}`;
		const sideFlag = location.hash === `#${SIDE_URL_HASH}`;
		if (!navigationStateController.loading) {
			if ((newFlag || sideFlag) && urlController.isUrlCollectionPath(location.pathname)) {
				const panelsFromUrl = buildSidePanelsFromUrl(urlController.urlPathToDataPath(location.pathname), collectionRegistryController.collections ?? [], newFlag);
				for (let i = 0; i < panelsFromUrl.length; i++) {
					const props = panelsFromUrl[i];
					if (i === 0) sideDialogsController.replace(propsToSidePanel(props, urlController.buildUrlCollectionPath, urlController.resolveDatabasePathsFrom, smallLayout, customizationController, authController, location.search));
					else sideDialogsController.open(propsToSidePanel(props, urlController.buildUrlCollectionPath, urlController.resolveDatabasePathsFrom, smallLayout, customizationController, authController, location.search));
				}
			}
			initialised.current = true;
		}
	}, [navigationStateController.loading]);
	currentPanelKeysRef.current = sideDialogsController.sidePanels.map((p) => p.key);
	useEffect(() => {
		if (initialised.current) {
			if (location.hash === `#${SIDE_URL_HASH}`) {
				const currentKeys = currentPanelKeysRef.current;
				const panelsFromUrl = buildSidePanelsFromUrl(urlController.urlPathToDataPath(location.pathname), collectionRegistryController.collections ?? [], false);
				if (panelsFromUrl.length <= currentKeys.length) return;
				const lastPanel = panelsFromUrl[panelsFromUrl.length - 1];
				const panelProps = propsToSidePanel(lastPanel, urlController.buildUrlCollectionPath, urlController.resolveDatabasePathsFrom, smallLayout, customizationController, authController, location.search);
				const lastCurrentPanel = currentKeys.length > 0 ? currentKeys[currentKeys.length - 1] : void 0;
				if (!lastCurrentPanel || lastCurrentPanel !== panelProps.key) sideDialogsController.replace(panelProps);
			}
		}
	}, [location.pathname, location.hash]);
	useEffect(() => {
		const updatedSidePanels = sideDialogsController.sidePanels.map((sidePanelProps) => {
			if (sidePanelProps.additional) {
				const entityProps = sidePanelProps.additional;
				const newWidth = getEntityViewWidth(entityProps, smallLayout, customizationController);
				if (sidePanelProps.width !== newWidth) return {
					...sidePanelProps,
					width: newWidth
				};
			}
			return sidePanelProps;
		});
		sideDialogsController.setSidePanels(updatedSidePanels);
	}, [smallLayout]);
	const close = useCallback(() => {
		sideDialogsController.close();
	}, [sideDialogsController]);
	const open = useCallback((props) => {
		if (props.copy && !props.entityId) throw Error("If you want to copy a entity you need to provide a entityId");
		const defaultSelectedView = resolveDefaultSelectedView(props.collection ? props.collection.defaultSelectedView : void 0, {
			status: props.copy ? "copy" : props.entityId ? "existing" : "new",
			entityId: props.entityId
		});
		sideDialogsController.open(propsToSidePanel({
			...props,
			selectedTab: props.selectedTab ?? defaultSelectedView
		}, urlController.buildUrlCollectionPath, urlController.resolveDatabasePathsFrom, smallLayout, customizationController, authController, location.search));
	}, [
		sideDialogsController,
		urlController.buildUrlCollectionPath,
		urlController.resolveDatabasePathsFrom,
		smallLayout,
		authController.user,
		location.search
	]);
	const replace = useCallback((props) => {
		if (props.copy && !props.entityId) throw Error("If you want to copy a entity you need to provide a entityId");
		sideDialogsController.replace(propsToSidePanel(props, urlController.buildUrlCollectionPath, urlController.resolveDatabasePathsFrom, smallLayout, customizationController, authController, location.search));
	}, [
		urlController.buildUrlCollectionPath,
		urlController.resolveDatabasePathsFrom,
		sideDialogsController,
		smallLayout,
		authController.user,
		location.search
	]);
	return useMemo(() => ({
		close,
		open,
		replace
	}), [
		close,
		open,
		replace
	]);
};
function buildSidePanelsFromUrl(path, collections, newFlag) {
	const navigationViewsForPath = getNavigationEntriesFromPath({
		path,
		collections
	});
	let sidePanel = void 0;
	let lastCollectionPath = "";
	for (let i = 0; i < navigationViewsForPath.length; i++) {
		const navigationEntry = navigationViewsForPath[i];
		if (navigationEntry.type === "collection") {
			lastCollectionPath = navigationEntry.slug;
			navigationEntry.collection.slug;
		}
		const previousEntry = navigationViewsForPath[i - 1];
		if (navigationEntry.type === "entity") sidePanel = {
			path: navigationEntry.slug,
			entityId: navigationEntry.entityId,
			copy: false,
			collection: navigationEntry.parentCollection,
			width: navigationEntry.parentCollection?.sideDialogWidth
		};
		else if (navigationEntry.type === "custom_view") {
			if (previousEntry?.type === "entity") {
				if (sidePanel) sidePanel.selectedTab = navigationEntry.view.key;
			}
		} else if (navigationEntry.type === "collection") {
			if (previousEntry?.type === "entity") {
				if (sidePanel) sidePanel.selectedTab = navigationEntry.collection.slug;
			}
		}
	}
	if (sidePanel && !sidePanel.selectedTab && removeTrailingSlash(path).endsWith("/edit")) sidePanel.selectedTab = "edit";
	if (sidePanel && !sidePanel.selectedTab && sidePanel.collection) {
		const defaultView = resolveDefaultSelectedView(sidePanel.collection.defaultSelectedView, {
			status: sidePanel.copy ? "copy" : sidePanel.entityId ? "existing" : "new",
			entityId: sidePanel.entityId
		});
		if (defaultView) sidePanel.selectedTab = defaultView;
	}
	if (newFlag) sidePanel = {
		path: lastCollectionPath,
		copy: false
	};
	return sidePanel ? [sidePanel] : [];
}
var propsToSidePanel = (props, buildUrlCollectionPath, resolveIdsFrom, smallLayout, customizationController, authController, locationSearch) => {
	const collectionPath = removeInitialAndTrailingSlashes(props.path);
	const shouldUpdateUrl = props.updateUrl !== false;
	const urlPath = shouldUpdateUrl ? props.entityId ? buildUrlCollectionPath(`${collectionPath}/${props.entityId}${props.selectedTab ? "/" + props.selectedTab : ""}${locationSearch}#${SIDE_URL_HASH}`) : buildUrlCollectionPath(`${collectionPath}${locationSearch}#${NEW_URL_HASH}`) : void 0;
	const parentUrlPath = shouldUpdateUrl ? buildUrlCollectionPath(collectionPath) : void 0;
	const resolvedPanelProps = {
		...props,
		formProps: props.formProps
	};
	const entityViewWidth = getEntityViewWidth(props, smallLayout, customizationController);
	return {
		key: `${props.path}/${props.entityId}`,
		component: /* @__PURE__ */ jsx(ResolvedSidePanelBinding, { ...resolvedPanelProps }),
		urlPath,
		parentUrlPath,
		width: entityViewWidth,
		onClose: props.onClose,
		additional: resolvedPanelProps
	};
};
//#endregion
//#region src/hooks/useResolvedNavigationFrom.tsx
/**
* Use this function to retrieve an array of navigation entries (resolved
* collection, entity or entity custom_view) for the given path. You need to pass the app context
* that you receive in different callbacks, such as the save hooks.
*
* It will take into account the `navigation` provided at the `Rebase` level.
*
* @param path
* @param context
* @group Hooks and utilities
*/
function resolveNavigationFrom({ path, context }) {
	const data = context.data;
	const { navigationStateController, collectionRegistryController } = context;
	if (!navigationStateController || !collectionRegistryController) throw Error("Calling resolveNavigationFrom, but main navigation has not yet been initialised");
	const resultPromises = getNavigationEntriesFromPath({
		path,
		collections: collectionRegistryController.collections ?? []
	}).map((entry) => {
		if (entry.type === "collection") return Promise.resolve(entry);
		else if (entry.type === "entity") {
			if (!collectionRegistryController.getCollection(entry.slug)) throw Error(`No collection defined in the navigation for the entity with path ${entry.slug}`);
			return data.collection(entry.slug).findById(entry.entityId).then((row) => {
				if (!row) return void 0;
				const entity = {
					id: entry.entityId,
					path: entry.slug,
					values: row
				};
				return {
					...entry,
					entity
				};
			});
		} else if (entry.type === "custom_view") return Promise.resolve(entry);
		else throw Error("Unmapped element in useEntitiesFromPath");
	}).filter((v) => Boolean(v));
	return Promise.all(resultPromises);
}
/**
* Use this hook to retrieve an array of navigation entries (resolved
* collection or entity) for the given path. You can use this hook
* in any React component that lives under `Rebase`
* @group Hooks and utilities
*/
function useResolvedNavigationFrom({ path }) {
	const context = useAdminContext();
	const { navigationStateController, collectionRegistryController } = context;
	const [data, setData] = useState();
	const [dataLoading, setDataLoading] = useState(false);
	const [dataLoadingError, setDataLoadingError] = useState();
	useEffect(() => {
		if (navigationStateController && collectionRegistryController) {
			setDataLoading(true);
			setDataLoadingError(void 0);
			resolveNavigationFrom({
				path,
				context
			}).then(setData).catch((e) => setDataLoadingError(e)).finally(() => setDataLoading(false));
		}
	}, [path, context]);
	return useMemo(() => {
		if (!navigationStateController) return { dataLoading: true };
		return {
			data,
			dataLoading,
			dataLoadingError
		};
	}, [
		navigationStateController,
		data,
		dataLoading,
		dataLoadingError
	]);
}
//#endregion
//#region src/hooks/useHistory.ts
/**
* Hook to fetch entity history from the backend REST API.
* Replaces the old subcollection-based approach with a proper API call.
*/
function useHistory(params) {
	const { slug, entityId, enabled = true, pageSize = 10, refreshToken } = params;
	const apiConfig = useApiConfig();
	const apiBase = useApiBase();
	const [entries, setEntries] = useState([]);
	const [total, setTotal] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const [error, setError] = useState();
	const [offset, setOffset] = useState(0);
	const [refreshTrigger, setRefreshTrigger] = useState(0);
	const entityKey = `${slug}/${entityId}/${refreshToken ?? 0}`;
	const currentEntityRef = useRef(void 0);
	const fetchEntries = useCallback(async (currentOffset, signal) => {
		if (!apiConfig?.apiUrl || !entityId || !enabled) return;
		setIsLoading(true);
		setError(void 0);
		try {
			const token = await apiConfig.getAuthToken?.();
			const headers = { "Content-Type": "application/json" };
			if (token) headers["Authorization"] = `Bearer ${token}`;
			const url = `${apiBase}/data/${slug}/${entityId}/history?limit=${pageSize}&offset=${currentOffset}`;
			const response = await fetch(url, {
				headers,
				signal
			});
			if (signal?.aborted) return;
			if (currentEntityRef.current !== entityKey) return;
			if (!response.ok) {
				const errorData = await response.json().catch(() => ({ error: { message: response.statusText } }));
				throw new Error(errorData.error?.message || `Failed to fetch history (${response.status})`);
			}
			const result = await response.json();
			if (currentOffset === 0) setEntries(result.data);
			else setEntries((prev) => [...prev, ...result.data]);
			setTotal(result.meta.total);
			setHasMore(result.meta.hasMore);
		} catch (err) {
			if (err instanceof DOMException && err.name === "AbortError") return;
			setError(err instanceof Error ? err : new Error(String(err)));
		} finally {
			setIsLoading(false);
		}
	}, [
		apiConfig,
		apiBase,
		slug,
		entityId,
		entityKey,
		enabled,
		pageSize
	]);
	useEffect(() => {
		const isNewEntity = currentEntityRef.current !== entityKey;
		if (isNewEntity) {
			currentEntityRef.current = entityKey;
			setEntries([]);
			setTotal(0);
			setHasMore(true);
			setOffset(0);
		}
		if (!enabled || !entityId) return;
		const abortController = new AbortController();
		fetchEntries(isNewEntity ? 0 : offset, abortController.signal);
		return () => {
			abortController.abort();
		};
	}, [
		fetchEntries,
		offset,
		enabled,
		entityId,
		entityKey,
		refreshTrigger
	]);
	const loadMore = useCallback(() => {
		if (!isLoading && hasMore && offset + entries.length < total) setOffset((prev) => prev + pageSize);
	}, [
		isLoading,
		hasMore,
		pageSize,
		offset,
		entries.length,
		total
	]);
	const revert = useCallback(async (historyId) => {
		if (!apiConfig?.apiUrl || !entityId) throw new Error("Cannot revert: missing API configuration or entity ID");
		const token = await apiConfig.getAuthToken?.();
		const headers = { "Content-Type": "application/json" };
		if (token) headers["Authorization"] = `Bearer ${token}`;
		const url = `${apiBase}/data/${slug}/${entityId}/history/${historyId}/revert`;
		const response = await fetch(url, {
			method: "POST",
			headers
		});
		if (!response.ok) {
			const errorData = await response.json().catch(() => ({ error: { message: response.statusText } }));
			throw new Error(errorData.error?.message || `Failed to revert (${response.status})`);
		}
		const result = await response.json();
		currentEntityRef.current = void 0;
		setRefreshTrigger((prev) => prev + 1);
		return result.data;
	}, [
		apiConfig,
		apiBase,
		slug,
		entityId
	]);
	return useMemo(() => ({
		entries,
		total,
		isLoading,
		hasMore,
		error,
		loadMore,
		revert
	}), [
		entries,
		total,
		isLoading,
		hasMore,
		error,
		loadMore,
		revert
	]);
}
//#endregion
//#region src/hooks/navigation/useBuildCollectionRegistryController.tsx
function useBuildCollectionRegistryController(props) {
	const { userConfigPersistence, dataSources } = props;
	const collectionRegistryRef = useRef(new CollectionRegistry(void 0, dataSources));
	if (dataSources) collectionRegistryRef.current.setDataSources(dataSources);
	const [initialised, setInitialised] = useState(false);
	const getCollection = useCallback((slugOrPath, includeUserOverride = false) => {
		const registry = collectionRegistryRef.current;
		const cleanedPath = removeInitialAndTrailingSlashes(slugOrPath);
		if (!cleanedPath) return void 0;
		const pathSegments = cleanedPath.split("/");
		let collectionPath = pathSegments.join("/");
		if (pathSegments.length > 0 && pathSegments.length % 2 === 0) collectionPath = pathSegments.slice(0, -1).join("/");
		if (!collectionPath) return void 0;
		let collection;
		collection = registry.get(collectionPath);
		if (!collection) try {
			collection = registry.resolvePathToCollections(collectionPath).finalCollection;
		} catch (e) {
			console.warn(`[rebase] Could not resolve a collection for "${collectionPath}"`, e);
			return;
		}
		if (!collection) return;
		const userOverride = includeUserOverride ? userConfigPersistence?.getCollectionConfig(slugOrPath) : void 0;
		const overriddenCollection = collection ? mergeDeep(collection, userOverride ?? {}) : void 0;
		if (!overriddenCollection) return void 0;
		let result = overriddenCollection;
		const subcollections = "subcollections" in overriddenCollection ? overriddenCollection.subcollections : void 0;
		const callbacks = overriddenCollection.callbacks;
		result = {
			...result,
			callbacks: result?.callbacks ?? callbacks
		};
		if (subcollections && "subcollections" in result) result.subcollections = result.subcollections ?? subcollections;
		return resolveAdminCollection({
			...overriddenCollection,
			...result
		});
	}, [userConfigPersistence]);
	const getRawCollection = useCallback((slugOrPath) => {
		const registry = collectionRegistryRef.current;
		if (registry === void 0) return void 0;
		const cleanedPath = removeInitialAndTrailingSlashes(slugOrPath);
		if (!cleanedPath) return void 0;
		const pathSegments = cleanedPath.split("/");
		return registry.getRaw(pathSegments.join("/"));
	}, []);
	const getParentReferencesFromPath$1 = useCallback((path) => {
		const registry = collectionRegistryRef.current;
		if (!registry) return [];
		return getParentReferencesFromPath({
			path: removeInitialAndTrailingSlashes(path).split("/").join("/"),
			collections: registry.getCollections()
		});
	}, []);
	const getParentCollectionSlugs = useCallback((path) => {
		const registry = collectionRegistryRef.current;
		if (!registry) return [];
		const oddPathSegments = removeInitialAndTrailingSlashes(path).split("/").filter((_, i) => i % 2 === 0);
		oddPathSegments.pop();
		const result = [];
		for (let i = 1; i <= oddPathSegments.length; i++) result.push(oddPathSegments.slice(0, i));
		const getCollectionFromPaths = (pathSegments) => {
			if (!pathSegments?.length) return void 0;
			const testPath = pathSegments.reduce((acc, segment, idx) => {
				if (idx === 0) return segment;
				return `${acc}/fake_id/${segment}`;
			}, "");
			try {
				return registry.resolvePathToCollections(testPath).finalCollection;
			} catch (e) {
				return;
			}
		};
		return result.map((r) => getCollectionFromPaths(r)?.slug).filter(Boolean);
	}, []);
	const getParentEntityIds = useCallback((path) => {
		const strings = removeInitialAndTrailingSlashes(path).split("/");
		const evenPathSegments = strings.filter((_, i) => i % 2 !== 0);
		if (strings.length % 2 === 0) evenPathSegments.pop();
		return evenPathSegments;
	}, []);
	const convertIdsToPaths = useCallback((ids) => {
		const registry = collectionRegistryRef.current;
		if (!registry) return [];
		let currentCollections = registry.getCollections();
		const paths = [];
		for (let i = 0; i < ids.length; i++) {
			const id = ids[i];
			const collection = currentCollections.find((c) => c.slug === id);
			if (!collection) throw Error(`Collection with id ${id} not found`);
			paths.push(collection.slug);
			currentCollections = getSubcollections(collection) ?? [];
		}
		return paths;
	}, []);
	const collections = collectionRegistryRef.current.getCollections().map(resolveAdminCollection);
	useEffect(() => {
		if (!initialised && collections.length > 0) setInitialised(true);
	}, [initialised, collections.length]);
	return useMemo(() => ({
		collections,
		initialised,
		getCollection,
		getRawCollection,
		getParentReferencesFromPath: getParentReferencesFromPath$1,
		getParentCollectionSlugs,
		getParentEntityIds,
		convertIdsToPaths,
		collectionRegistryRef
	}), [
		collections,
		initialised,
		getCollection,
		getRawCollection,
		getParentReferencesFromPath$1,
		getParentCollectionSlugs,
		getParentEntityIds,
		convertIdsToPaths
	]);
}
//#endregion
//#region src/hooks/navigation/useNavigationResolution.ts
/**
* Check whether a `RebaseCallContext` is actually the full frontend
* `RebaseContext` (which carries `dialogsController`).
*/
function isRebaseContext(ctx) {
	return typeof ctx === "object" && ctx !== null && "dialogsController" in ctx;
}
function filterOutNotAllowedCollections(resolvedCollections, authController) {
	return resolvedCollections.filter((c) => canReadCollection(c, authController)).map((c) => {
		if (!c.childCollections) return c;
		return {
			...c,
			childCollections: () => filterOutNotAllowedCollections(c.childCollections() ?? [], authController)
		};
	});
}
function applyPluginModifyCollection(resolvedCollections, modifyCollection) {
	return resolvedCollections.map((collection) => {
		const modifiedCollection = modifyCollection(collection);
		if (modifiedCollection.childCollections) return {
			...modifiedCollection,
			childCollections: () => applyPluginModifyCollection(modifiedCollection.childCollections() ?? [], modifyCollection)
		};
		return modifiedCollection;
	});
}
/**
* Auto-inject auth-specific entity actions and callbacks for collections
* with `auth: true` or `auth: { enabled: true }`.
*
* Injections:
* 1. **resetPasswordAction** — adds the entity action unless explicitly disabled,
*    or unless the auth adapter reports no `adminPasswordReset` support. Custom
*    adapters mount their own admin routes and may not implement
*    `POST /admin/users/:userId/reset-password`; injecting the action anyway
*    would show a button that can only ever 404.
* 2. **browserCallbacks.afterSave** — shows the `CreationResultDialog` when a
*    new user is created with `invitationSent` or `temporaryPassword` in the
*    response
*
* Skips injection if the collection already has the action/callback present.
*/
function injectAuthCollectionConfig(collections, adminPasswordResetSupported) {
	return collections.map((collection) => {
		const authProp = collection.auth;
		if (!authProp) return collection;
		if (!(authProp === true || typeof authProp === "object" && authProp.enabled === true)) return collection;
		const authConfig = typeof authProp === "object" ? authProp : void 0;
		let result = collection;
		const resetPref = authConfig?.actions?.resetPassword;
		let actionToInject;
		if (resetPref === false) actionToInject = void 0;
		else if (typeof resetPref === "object") actionToInject = resetPref;
		else if (!adminPasswordResetSupported) actionToInject = void 0;
		else actionToInject = resetPasswordAction;
		if (actionToInject) {
			const injectedAction = actionToInject;
			const existing = result.entityActions ?? [];
			if (!existing.some((a) => typeof a === "string" ? a === injectedAction.key : a.key != null && a.key === injectedAction.key)) result = {
				...result,
				entityActions: [...existing, injectedAction]
			};
		}
		const existingAfterSave = result.browserCallbacks?.afterSave;
		const injectedAfterSave = {
			...result.browserCallbacks,
			afterSave: (async (props) => {
				await existingAfterSave?.(props);
				const { values, status, context } = props;
				if (status !== "new" && status !== "copy") return;
				if (!(values.invitationSent !== void 0 || values.temporaryPassword !== void 0) || !isRebaseContext(context) || !context.dialogsController) return;
				const { dialogsController } = context;
				const creationResult = {
					user: {
						uid: String(props.id),
						email: typeof values.email === "string" ? values.email : "",
						displayName: typeof values.displayName === "string" ? values.displayName : "",
						roles: Array.isArray(values.roles) ? values.roles : [],
						photoURL: typeof values.photoURL === "string" ? values.photoURL : typeof values.photoUrl === "string" ? values.photoUrl : null,
						providerId: "password",
						isAnonymous: false
					},
					invitationSent: !!values.invitationSent,
					temporaryPassword: typeof values.temporaryPassword === "string" ? values.temporaryPassword : void 0,
					emailDeliveryFailed: !!values.emailDeliveryFailed
				};
				const { closeDialog } = dialogsController.open({
					key: "user_creation_result",
					Component: () => React.createElement(CreationResultDialog, {
						result: creationResult,
						onClose: () => closeDialog()
					})
				});
			})
		};
		result = {
			...result,
			browserCallbacks: injectedAfterSave,
			admin: {
				...result.admin,
				browserCallbacks: injectedAfterSave
			}
		};
		return result;
	});
}
async function resolveCollections(collections, authController, data, plugins) {
	let resolvedCollections = [];
	if (typeof collections === "function") resolvedCollections = await collections({
		user: authController.user,
		authController,
		data
	});
	else if (Array.isArray(collections)) resolvedCollections = collections;
	resolvedCollections = resolvedCollections.map(resolveAdminCollection);
	if (plugins) for (const plugin of plugins) {
		if (plugin.hooks?.modifyCollection) resolvedCollections = applyPluginModifyCollection(resolvedCollections, plugin.hooks.modifyCollection);
		if (plugin.hooks?.injectCollections) resolvedCollections = plugin.hooks.injectCollections(resolvedCollections).map(resolveAdminCollection);
	}
	resolvedCollections = injectAuthCollectionConfig(resolvedCollections, authController.capabilities?.adminPasswordReset ?? true);
	resolvedCollections = filterOutNotAllowedCollections(resolvedCollections, authController);
	return resolvedCollections;
}
async function resolveAppViews(baseViews, authController, data, plugins) {
	let resolvedViews = [];
	if (typeof baseViews === "function") resolvedViews = await baseViews({
		user: authController.user,
		authController,
		data
	}) ?? [];
	else if (Array.isArray(baseViews)) resolvedViews = baseViews;
	if (plugins) {
		for (const plugin of plugins) if (plugin.views && plugin.views.length > 0) resolvedViews = [...resolvedViews, ...plugin.views];
	}
	if (process.env.NODE_ENV !== "production") {
		const slugCounts = /* @__PURE__ */ new Map();
		resolvedViews.forEach((v) => {
			slugCounts.set(v.slug, (slugCounts.get(v.slug) ?? 0) + 1);
		});
		slugCounts.forEach((count, slug) => {
			if (count > 1) console.warn(`[Rebase] Duplicate view slug "${slug}" detected (${count} views). Last-write-wins. Ensure unique slugs across admin views and plugins.`);
		});
	}
	resolvedViews = filterViewsByRole(resolvedViews, authController);
	return resolvedViews;
}
/**
* Filter views by the `roles` field on AppView.
* When `roles` is set, the view is only included if the current user
* has at least one of the listed roles. Views without `roles` (or with
* an empty array) are always included.
*/
function filterViewsByRole(views, authController) {
	const userRoles = authController.user?.roles ?? [];
	return views.filter((view) => {
		if (!view.roles || view.roles.length === 0) return true;
		return view.roles.some((role) => userRoles.includes(role));
	});
}
//#endregion
//#region src/hooks/navigation/utils.ts
var NAVIGATION_DEFAULT_GROUP_NAME = "Views";
/**
* Group names that sink to the bottom of the drawer on their name alone.
*
* A magic string, and it stays one for compatibility: apps have been relying on
* `group: "Settings"` landing last since before there was a flag, and taking it
* away would silently reshuffle their navigation.
*
* It is a bad way to ask for the behaviour, though — it is invisible from the
* `group?: string` type, and it is defeated by the most ordinary edit there is:
* translating the label. `group: "Ajustes"` is the same group to a reader and a
* different one to this comparison, so the ordering just quietly stops
* happening. Set {@link AppView.pinToBottom} instead, which says so.
*/
var NAVIGATION_BOTTOM_GROUP_NAMES = ["Admin", "Settings"];
/** Whether a group sinks to the bottom by virtue of its name. @see NAVIGATION_BOTTOM_GROUP_NAMES */
function isBottomPinnedGroupName(groupName) {
	return groupName !== void 0 && NAVIGATION_BOTTOM_GROUP_NAMES.includes(groupName);
}
function getGroup(collectionOrView) {
	const trimmed = collectionOrView.group?.trim();
	if (!trimmed || trimmed === "") return NAVIGATION_DEFAULT_GROUP_NAME;
	return trimmed;
}
function computeNavigationGroups({ navigationGroupMappings, collections, views, plugins }) {
	let result = navigationGroupMappings ? navigationGroupMappings.map((g) => ({
		name: g.name,
		entries: [...g.entries],
		...g.collapsedByDefault !== void 0 && { collapsedByDefault: g.collapsedByDefault }
	})) : navigationGroupMappings;
	if (plugins) result = plugins.reduce((acc, plugin) => {
		if (plugin.hooks?.navigationEntries) plugin.hooks.navigationEntries.forEach((entry) => {
			const { name, entries } = entry;
			const existingGroup = acc.find((g) => g.name === name);
			if (existingGroup) existingGroup.entries.push(...entries);
			else acc.push({
				name,
				entries: [...entries]
			});
		});
		return acc;
	}, result ?? []);
	const assignedEntries = /* @__PURE__ */ new Set();
	if (result) result.forEach((group) => {
		group.entries.forEach((entry) => assignedEntries.add(entry));
	});
	const unassignedGroupMap = {};
	(collections ?? []).forEach((collection) => {
		if (collection.hideFromNavigation) return;
		const entry = collection.slug;
		if (!assignedEntries.has(entry)) {
			const groupName = getGroup(collection);
			if (!unassignedGroupMap[groupName]) unassignedGroupMap[groupName] = [];
			unassignedGroupMap[groupName].push(entry);
		}
	});
	(views ?? []).forEach((view) => {
		if (view.hideFromNavigation) return;
		const entry = Array.isArray(view.slug) ? view.slug[0] : view.slug;
		if (!assignedEntries.has(entry)) {
			const groupName = getGroup(view);
			if (!unassignedGroupMap[groupName]) unassignedGroupMap[groupName] = [];
			unassignedGroupMap[groupName].push(entry);
		}
	});
	Object.entries(unassignedGroupMap).forEach(([groupName, entries]) => {
		if (result) {
			const existingGroup = result.find((g) => g.name === groupName);
			if (existingGroup) existingGroup.entries.push(...entries);
			else result.push({
				name: groupName,
				entries
			});
		}
	});
	if (!result) {
		result = [];
		const groupMap = {};
		(collections ?? []).forEach((collection) => {
			if (collection.hideFromNavigation) return;
			const name = getGroup(collection);
			const entry = collection.slug;
			if (!groupMap[name]) groupMap[name] = [];
			groupMap[name].push(entry);
		});
		(views ?? []).forEach((view) => {
			if (view.hideFromNavigation) return;
			const name = getGroup(view);
			const entry = Array.isArray(view.slug) ? view.slug[0] : view.slug;
			if (!groupMap[name]) groupMap[name] = [];
			groupMap[name].push(entry);
		});
		result = Object.entries(groupMap).map(([name, entries]) => ({
			name,
			entries
		}));
	}
	result.forEach((group) => {
		group.entries = [...new Set(group.entries)];
	});
	return result;
}
function areCollectionListsEqual(a, b, visitedSlugs = []) {
	if (a.length !== b.length) return false;
	const aCopy = [...a];
	const bCopy = [...b];
	const aSorted = aCopy.sort((x, y) => x.slug.localeCompare(y.slug));
	const bSorted = bCopy.sort((x, y) => x.slug.localeCompare(y.slug));
	return aSorted.every((value, index) => areCollectionsEqual(value, bSorted[index], visitedSlugs));
}
function areCollectionsEqual(a, b, visitedSlugs = []) {
	if (a.slug !== b.slug) return false;
	if (visitedSlugs.includes(a.slug)) return true;
	const newVisited = [...visitedSlugs, a.slug];
	if (!areCollectionListsEqual(getSubcollections(a), getSubcollections(b), newVisited)) return false;
	return deepEqual(Object.fromEntries(Object.entries(a).filter(([k, v]) => typeof v !== "function" && k !== "subcollections")), Object.fromEntries(Object.entries(b).filter(([k, v]) => typeof v !== "function" && k !== "subcollections")));
}
//#endregion
//#region src/hooks/navigation/useAsyncResolver.ts
/**
* Generic hook that resolves an async value with loading/error/refresh
* state management, cancellation on unmount or deps change, and
* ref-based change detection to prevent unnecessary state updates.
*
* Extracted from the common pattern in useResolvedCollections and
* useResolvedViews.
*/
function useAsyncResolver({ resolver, initialValue, isEqual, deps, disabled }) {
	const [data, setData] = useState(initialValue);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(void 0);
	const [refreshTrigger, setRefreshTrigger] = useState(0);
	const refresh = useCallback(() => {
		setRefreshTrigger((prev) => prev + 1);
	}, []);
	const dataRef = useRef(initialValue);
	const resolverRef = useRef(resolver);
	resolverRef.current = resolver;
	const isEqualRef = useRef(isEqual);
	isEqualRef.current = isEqual;
	useEffect(() => {
		if (disabled) return;
		let cancelled = false;
		(async () => {
			try {
				const result = await resolverRef.current();
				if (cancelled) return;
				if (!isEqualRef.current(dataRef.current, result)) {
					dataRef.current = result;
					setData(result);
				}
				setError(void 0);
			} catch (e) {
				if (!cancelled) {
					console.error(e);
					setError(e);
				}
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [
		...deps,
		refreshTrigger,
		disabled
	]);
	return useMemo(() => ({
		data,
		loading,
		error,
		refresh
	}), [
		data,
		loading,
		error,
		refresh
	]);
}
//#endregion
//#region src/hooks/navigation/useResolvedCollections.ts
/**
* Hook that resolves collection props (which may be async builders or arrays)
* into concrete AdminCollection[], and registers them with the CollectionRegistry.
*
* When userManagement is provided, the default users collection is always
* prepended. Developer collections override via generic slug-based dedup
* (Map keyed by slug, last-write-wins). No hardcoded string checks.
*
* Uses refs for potentially-unstable dependencies (driver, authController,
* plugins) to avoid re-triggering effects when their object identity changes.
*/
function useResolvedCollections(props) {
	const { authController, collections: collectionsProp, data, plugins, disabled, collectionRegistryController } = props;
	const userIdentity = authController.user ? `${authController.user.uid}:${(authController.user.roles ?? []).sort().join(",")}` : null;
	const dataRef = useRef(data);
	dataRef.current = data;
	const authControllerRef = useRef(authController);
	authControllerRef.current = authController;
	const pluginsRef = useRef(plugins);
	pluginsRef.current = plugins;
	const { data: collections, loading, error, refresh } = useAsyncResolver({
		resolver: async () => {
			const deduped = [...await resolveCollections(collectionsProp, authControllerRef.current, dataRef.current, pluginsRef.current)];
			if (collectionRegistryController.collectionRegistryRef.current.registerMultiple(deduped)) console.debug("Collections have changed", deduped);
			return deduped;
		},
		initialValue: [],
		isEqual: areCollectionListsEqual,
		deps: [
			collectionsProp,
			userIdentity,
			disabled
		],
		disabled: disabled || authController.initialLoading
	});
	return useMemo(() => ({
		collections,
		loading,
		error,
		refresh
	}), [
		collections,
		loading,
		error,
		refresh
	]);
}
//#endregion
//#region src/hooks/navigation/useResolvedViews.tsx
/**
* Compare two view arrays by their slug identity.
* Returns true when the sets of slugs are identical (same order, same values).
* This avoids deepEqual on React elements, which have unstable internal refs.
*/
function viewSlugsEqual(a, b) {
	if (a === b) return true;
	if (!a || !b) return false;
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i++) if (a[i].slug !== b[i].slug) return false;
	return true;
}
/**
* Equality check for the combined views data.
* Compares both views and adminViews by slug identity.
*/
function areResolvedViewsEqual(a, b) {
	return viewSlugsEqual(a.views, b.views) && viewSlugsEqual(a.adminViews, b.adminViews);
}
/**
* Hook that resolves view and admin view props (which may be async builders or arrays)
* into concrete AppView[].
*
* Uses refs for potentially-unstable dependencies (driver, authController,
* plugins) to avoid re-triggering effects when their object identity changes.
*/
function useResolvedViews(props) {
	const { authController, views: viewsProp, adminViews: adminViewsProp, data, plugins, adminMode = "cms", effectiveRoleController } = props;
	const userIdentity = authController.user ? `${authController.user.uid}:${(authController.user.roles ?? []).sort().join(",")}` : null;
	const dataRef = useRef(data);
	dataRef.current = data;
	const authControllerRef = useRef(authController);
	authControllerRef.current = authController;
	const pluginsRef = useRef(plugins);
	pluginsRef.current = plugins;
	const resolvedAuthController = useMemo(() => {
		if (adminMode === "studio" && effectiveRoleController?.effectiveRole && authController.user) return {
			...authController,
			user: {
				...authController.user,
				roles: [effectiveRoleController.effectiveRole]
			}
		};
		return authController;
	}, [
		adminMode,
		effectiveRoleController?.effectiveRole,
		authController
	]);
	const resolvedAuthControllerRef = useRef(resolvedAuthController);
	resolvedAuthControllerRef.current = resolvedAuthController;
	const initialLoading = resolvedAuthController.initialLoading;
	const { data: resolvedData, loading, error, refresh } = useAsyncResolver({
		resolver: async () => {
			const [newViews, newAdminViews] = await Promise.all([resolveAppViews(viewsProp, resolvedAuthControllerRef.current, dataRef.current, pluginsRef.current), resolveAppViews(adminViewsProp, resolvedAuthControllerRef.current, dataRef.current)]);
			return {
				views: newViews,
				adminViews: newAdminViews
			};
		},
		initialValue: {
			views: void 0,
			adminViews: void 0
		},
		isEqual: areResolvedViewsEqual,
		deps: [
			viewsProp,
			adminViewsProp,
			adminMode,
			userIdentity
		],
		disabled: initialLoading
	});
	return useMemo(() => ({
		views: resolvedData.views,
		adminViews: resolvedData.adminViews,
		loading,
		error,
		refresh
	}), [
		resolvedData,
		loading,
		error,
		refresh
	]);
}
//#endregion
//#region src/hooks/navigation/useTopLevelNavigation.ts
/**
* Hook that computes the top-level NavigationResult from resolved collections,
* views, and admin views. Pure computation — no async, no effects.
*
* The `onNavigationEntriesUpdate` callback is embedded in the result for API
* compatibility, but its reference is stable via useCallback.
*/
function useTopLevelNavigation(props) {
	const { collections, views, adminViews, plugins, navigationGroupMappings, viewsOrder, urlController, adminMode, collectionRegistryController } = props;
	const pluginGroups = useMemo(() => {
		const allPluginGroups = plugins?.flatMap((plugin) => plugin.hooks?.navigationEntries ? plugin.hooks.navigationEntries.map((e) => e.name) : []) ?? [];
		return [...new Set(allPluginGroups)];
	}, [plugins]);
	const onNavigationEntriesOrderUpdate = useCallback((entries) => {
		if (!plugins) return;
		const filteredEntries = entries.filter((entry) => entry.entries.length > 0);
		if (plugins.some((plugin) => plugin.hooks?.onNavigationEntriesUpdate)) plugins.forEach((plugin) => {
			if (plugin.hooks?.onNavigationEntriesUpdate) plugin.hooks.onNavigationEntriesUpdate(filteredEntries);
		});
	}, [plugins]);
	const topLevelNavigationRef = useRef(void 0);
	const topLevelNavigation = useMemo(() => {
		if (!views && !adminViews && collections.length === 0) return;
		const finalNavigationGroupMappings = computeNavigationGroups({
			navigationGroupMappings,
			collections,
			views,
			plugins
		});
		const allPluginNavigationEntries = finalNavigationGroupMappings.map((g) => g.entries).flat() ?? [];
		const navigationEntriesOrder = [...new Set(allPluginNavigationEntries)];
		let navigationEntries = [
			...(collections ?? []).reduce((acc, collection) => {
				if (collection.hideFromNavigation) return acc;
				const pathKey = collection.slug;
				let groupName = getGroup(collection);
				if (finalNavigationGroupMappings) {
					for (const pluginGroupDef of finalNavigationGroupMappings) if (pluginGroupDef.entries.includes(pathKey)) {
						groupName = pluginGroupDef.name;
						break;
					}
				}
				acc.push({
					id: `collection:${pathKey}`,
					url: urlController.buildUrlCollectionPath(pathKey),
					type: "collection",
					name: collection.name.trim(),
					slug: pathKey,
					collection,
					description: collection.description?.trim(),
					group: groupName ?? "Views"
				});
				return acc;
			}, []),
			...(views ?? []).reduce((acc, view) => {
				if (view.hideFromNavigation) return acc;
				const pathKey = view.slug;
				let groupName = getGroup(view);
				if (finalNavigationGroupMappings) {
					for (const pluginGroupDef of finalNavigationGroupMappings) if (pluginGroupDef.entries.includes(pathKey)) {
						groupName = pluginGroupDef.name;
						break;
					}
				}
				const basePathKey = Array.isArray(pathKey) ? pathKey[0] : pathKey;
				acc.push({
					id: `view:${pathKey}`,
					url: urlController.buildAppUrlPath(basePathKey),
					name: view.name.trim(),
					type: "view",
					slug: view.slug,
					view,
					description: view.description?.trim(),
					group: groupName ?? "Views"
				});
				return acc;
			}, []),
			...(adminViews ?? []).reduce((acc, adminView) => {
				if (adminView.hideFromNavigation) return acc;
				const pathKey = adminView.slug;
				let groupName = adminView.group?.trim() || "Admin";
				if (finalNavigationGroupMappings) {
					for (const pluginGroupDef of finalNavigationGroupMappings) if (pluginGroupDef.entries.includes(pathKey)) {
						groupName = pluginGroupDef.name;
						break;
					}
				}
				acc.push({
					id: `admin:${pathKey}`,
					url: urlController.buildAppUrlPath(pathKey),
					name: adminView.name.trim(),
					type: "admin",
					slug: adminView.slug,
					view: adminView,
					description: adminView.description?.trim(),
					group: groupName
				});
				return acc;
			}, [])
		];
		const pinnedGroups = /* @__PURE__ */ new Set();
		for (const view of [...views ?? [], ...adminViews ?? []]) if (view.pinToBottom) pinnedGroups.add(getGroup(view));
		const groupOrderValue = (groupName) => isBottomPinnedGroupName(groupName) || groupName !== void 0 && pinnedGroups.has(groupName) ? 1 : 0;
		const usedViewsOrder = viewsOrder ?? navigationEntriesOrder;
		navigationEntries = navigationEntries.sort((a, b) => {
			const groupDiff = groupOrderValue(a.group) - groupOrderValue(b.group);
			if (groupDiff !== 0) return groupDiff;
			if (usedViewsOrder) {
				const getSortPath = (navEntry) => typeof navEntry.slug === "string" ? navEntry.slug : navEntry.slug[0];
				const aIndex = usedViewsOrder.indexOf(getSortPath(a));
				const bIndex = usedViewsOrder.indexOf(getSortPath(b));
				if (aIndex !== -1 || bIndex !== -1) {
					if (aIndex === -1) return 1;
					if (bIndex === -1) return -1;
					return aIndex - bIndex;
				}
			}
			return 0;
		});
		const collectedGroupsFromEntries = navigationEntries.map((e) => e.group).filter(Boolean);
		const groupsFromMappings = finalNavigationGroupMappings.map((g) => g.name);
		const additionalGroups = collectedGroupsFromEntries.filter((g) => !groupsFromMappings.includes(g));
		const allDefinedGroups = [
			...pluginGroups ?? [],
			...groupsFromMappings,
			...additionalGroups
		];
		const uniqueGroupsArray = [...new Set(allDefinedGroups)];
		const lastGroups = uniqueGroupsArray.filter((g) => groupOrderValue(g) === 1);
		const uniqueGroups = [...uniqueGroupsArray.filter((g) => groupOrderValue(g) === 0), ...lastGroups];
		const computedTopLevelNav = {
			allowDragAndDrop: plugins?.some((plugin) => plugin.hooks?.allowDragAndDrop) ?? false,
			navigationEntries,
			groups: uniqueGroups,
			onNavigationEntriesUpdate: onNavigationEntriesOrderUpdate
		};
		if (topLevelNavigationRef.current && deepEqual(topLevelNavigationRef.current.navigationEntries, computedTopLevelNav.navigationEntries) && deepEqual(topLevelNavigationRef.current.groups, computedTopLevelNav.groups) && topLevelNavigationRef.current.allowDragAndDrop === computedTopLevelNav.allowDragAndDrop) return topLevelNavigationRef.current;
		topLevelNavigationRef.current = computedTopLevelNav;
		return computedTopLevelNav;
	}, [
		collections,
		views,
		adminViews,
		navigationGroupMappings,
		urlController.buildAppUrlPath,
		urlController.buildUrlCollectionPath,
		pluginGroups,
		plugins,
		adminMode,
		viewsOrder,
		onNavigationEntriesOrderUpdate
	]);
	return useMemo(() => ({ topLevelNavigation }), [topLevelNavigation]);
}
//#endregion
//#region src/hooks/navigation/useBuildNavigationStateController.tsx
/**
* Main hook that resolves collections, views, and admin views into a
* NavigationStateController. This is a thin composition of three focused hooks:
*
* - useResolvedCollections: resolves collection props and registers with CollectionRegistry
* - useResolvedViews: resolves view/admin view props
* - useTopLevelNavigation: computes the NavigationResult from resolved data
*
* The NavigationStateController type is preserved as a public API.
*/
function useBuildNavigationStateController(props) {
	const { authController, collections: collectionsProp, views: viewsProp, adminViews: adminViewsProp, viewsOrder, plugins, data, disabled, navigationGroupMappings, collectionRegistryController, urlController, adminMode = "cms", effectiveRoleController } = props;
	const { collections, loading: collectionsLoading, error: collectionsError, refresh: refreshCollections } = useResolvedCollections({
		authController,
		collections: collectionsProp,
		data,
		plugins,
		disabled,
		collectionRegistryController
	});
	const { views, adminViews, loading: viewsLoading, error: viewsError, refresh: refreshViews } = useResolvedViews({
		authController,
		views: viewsProp,
		adminViews: adminViewsProp,
		data,
		plugins,
		adminMode,
		effectiveRoleController
	});
	const { topLevelNavigation } = useTopLevelNavigation({
		collections,
		views,
		adminViews,
		plugins,
		navigationGroupMappings,
		viewsOrder,
		urlController,
		adminMode,
		collectionRegistryController
	});
	const pendingRefreshRef = useRef(false);
	const refreshNavigation = useCallback(() => {
		if (pendingRefreshRef.current) return;
		pendingRefreshRef.current = true;
		queueMicrotask(() => {
			pendingRefreshRef.current = false;
			refreshCollections();
			refreshViews();
		});
	}, [refreshCollections, refreshViews]);
	return useMemo(() => ({
		views,
		adminViews,
		topLevelNavigation,
		loading: collectionsLoading || viewsLoading,
		navigationLoadingError: collectionsError ?? viewsError,
		refreshNavigation
	}), [
		views,
		adminViews,
		topLevelNavigation,
		collectionsLoading,
		viewsLoading,
		collectionsError,
		viewsError,
		refreshNavigation
	]);
}
//#endregion
//#region src/hooks/navigation/useBuildUrlController.tsx
function useBuildUrlController(props) {
	const { basePath, baseCollectionPath, collectionRegistryController } = props;
	const navigate = useNavigate();
	const homeUrl = basePath === "/" ? "/" : `/${removeInitialAndTrailingSlashes(basePath)}`;
	const buildUrlCollectionPath = useCallback((path) => {
		return (basePath === "/" ? `${baseCollectionPath}/${path}` : `${basePath}${baseCollectionPath}/${path}`).replace(/\/\//g, "/");
	}, [basePath, baseCollectionPath]);
	const buildAppUrlPath = useCallback((path) => {
		return (basePath === "/" ? `/${path}` : `${basePath}/${path}`).replace(/\/\//g, "/");
	}, [basePath]);
	const urlPathToDataPath = useCallback((cmsPath) => {
		let path = cmsPath;
		if (basePath !== "/" && path.startsWith(basePath)) path = path.replace(basePath, "");
		if (path.startsWith(baseCollectionPath)) path = path.replace(baseCollectionPath, "");
		return removeInitialAndTrailingSlashes(path);
	}, [basePath, baseCollectionPath]);
	const isUrlCollectionPath = useCallback((urlPath) => {
		let path = urlPath;
		if (basePath !== "/" && path.startsWith(basePath)) path = path.replace(basePath, "");
		return path === baseCollectionPath || path.startsWith(baseCollectionPath + "/");
	}, [basePath, baseCollectionPath]);
	const resolveDatabasePathsFrom = useCallback((path) => {
		return resolveCollectionPathIds(path, collectionRegistryController.collections ?? []);
	}, [collectionRegistryController]);
	const navigateTo = useCallback((to, options) => {
		navigate(to, options);
	}, [navigate]);
	return useMemo(() => ({
		basePath,
		baseCollectionPath,
		urlPathToDataPath,
		homeUrl,
		isUrlCollectionPath,
		buildUrlCollectionPath,
		buildAppUrlPath,
		resolveDatabasePathsFrom,
		navigate: navigateTo
	}), [
		basePath,
		baseCollectionPath,
		urlPathToDataPath,
		homeUrl,
		isUrlCollectionPath,
		buildUrlCollectionPath,
		buildAppUrlPath,
		resolveDatabasePathsFrom,
		navigateTo
	]);
}
//#endregion
//#region src/components/SideDialogs.tsx
var SideDialogContext = React.createContext({
	width: "",
	blocked: false,
	setBlocked: (blocked) => {},
	setBlockedNavigationMessage: (message) => {},
	close: () => {},
	pendingClose: false,
	setPendingClose: () => {}
});
/**
* This hook is used to access the properties of a particular side dialog,
* in contrast with {@link useSideDialogsController} which handles the
* state of all the dialogs.
*/
var useSideDialogContext = () => useContext(SideDialogContext);
/**
* This is the component in charge of rendering the side dialogs used
* for editing entities. Use the {@link useSidePanel} to open
* and control the dialogs.
* This component needs a parent {@link Rebase}
* {@link useSideDialogsController}
* @group Components
*/
function SideDialogs() {
	const sidePanels = useSideDialogsController().sidePanels;
	const panels = [...sidePanels];
	panels.push(void 0);
	return /* @__PURE__ */ jsx(Fragment, { children: panels.map((panel, index) => /* @__PURE__ */ jsx(SideDialogView, {
		panel,
		panelIndex: index,
		offsetPosition: sidePanels.length - index - 1,
		isTopPanel: index === sidePanels.length - 1
	}, `side_dialog_${index}`)) });
}
function SideDialogView({ offsetPosition, panel, panelIndex, isTopPanel }) {
	const [drawerCloseRequested, setDrawerCloseRequested] = useState(false);
	const [blocked, setBlocked] = useState(false);
	const [blockedNavigationMessage, setBlockedNavigationMessage] = useState();
	const pendingCloseRef = React.useRef(false);
	const setPendingClose = useCallback((value) => {
		pendingCloseRef.current = value;
	}, []);
	const widthRef = React.useRef(panel?.width);
	const width = widthRef.current;
	const sideDialogsController = useSideDialogsController();
	const preventDismiss = useCallback((e) => {
		e.preventDefault();
	}, []);
	const { dialogProps, triggerDialog } = useUnsavedChangesDialog(blocked, () => setBlocked(false));
	useEffect(() => {
		if (panel) widthRef.current = panel.width;
	}, [panel]);
	const handleDrawerCloseOk = () => {
		setBlocked(false);
		setDrawerCloseRequested(false);
		sideDialogsController.close();
		panel?.onClose?.();
	};
	const handleDrawerCloseCancel = () => {
		setDrawerCloseRequested(false);
	};
	const onCloseRequest = useCallback((force) => {
		if (blocked && !force) {
			setDrawerCloseRequested(true);
			triggerDialog();
		} else {
			sideDialogsController.close();
			panel?.onClose?.();
		}
	}, [
		blocked,
		triggerDialog,
		sideDialogsController,
		panel
	]);
	const contextValue = useMemo(() => ({
		blocked,
		setBlocked,
		setBlockedNavigationMessage,
		width,
		close: onCloseRequest,
		get pendingClose() {
			return pendingCloseRef.current;
		},
		setPendingClose
	}), [
		blocked,
		setBlockedNavigationMessage,
		width,
		onCloseRequest,
		setPendingClose
	]);
	const isDialogMode = (panel?.additional)?.collection?.openEntityMode === "dialog";
	return /* @__PURE__ */ jsxs(SideDialogContext.Provider, {
		value: contextValue,
		children: [isDialogMode ? /* @__PURE__ */ jsx(Dialog, {
			open: Boolean(panel),
			onOpenChange: (open) => {
				if (!open) onCloseRequest();
			},
			maxWidth: "4xl",
			scrollable: false,
			children: panel && /* @__PURE__ */ jsx("div", {
				className: "flex flex-col h-[75vh] min-h-[500px] w-full min-w-0 max-w-full overflow-hidden",
				children: /* @__PURE__ */ jsx(ErrorBoundary, { children: panel.component })
			})
		}) : /* @__PURE__ */ jsxs(Sheet, {
			open: Boolean(panel),
			includeBackgroundOverlay: true,
			overlayStyle: { zIndex: 40 + panelIndex * 10 },
			style: { zIndex: 45 + panelIndex * 10 },
			onOpenChange: (open) => {
				if (!open) onCloseRequest();
			},
			onPointerDownOutside: !isTopPanel ? preventDismiss : void 0,
			onInteractOutside: !isTopPanel ? preventDismiss : void 0,
			title: "Side dialog " + panel?.key,
			children: [panel && /* @__PURE__ */ jsx("div", {
				className: "transform max-w-[100vw] lg:max-w-[95vw] flex flex-col h-full transition-all duration-250 ease-in-out bg-surface-card ",
				style: {
					width: panel.width,
					transform: `translateX(-${offsetPosition * 200}px)`
				},
				children: /* @__PURE__ */ jsx(ErrorBoundary, { children: panel.component })
			}), !panel && /* @__PURE__ */ jsx("div", { style: { width } })]
		}), /* @__PURE__ */ jsx(UnsavedChangesDialog, {
			...dialogProps,
			handleOk: () => {
				dialogProps.handleOk();
				if (drawerCloseRequested) handleDrawerCloseOk();
			},
			handleCancel: () => {
				dialogProps.handleCancel();
				if (drawerCloseRequested) handleDrawerCloseCancel();
			},
			body: blockedNavigationMessage || "There are unsaved changes"
		})]
	});
}
//#endregion
//#region src/components/ReferenceTable/SelectionTableBinding.tsx
/** Stable identity, so the effect that propagates the picks does not re-fire. */
var EMPTY_ENTITIES = [];
/**
* This component allows to select entities from a given collection.
* You probably want to open this dialog as a side view using {@link useSelectionTableBinding}
* @group Components
*/
function SelectionTableBinding(props) {
	if (!props.collection) return /* @__PURE__ */ jsx(ErrorView, { error: "Could not find collection" });
	return /* @__PURE__ */ jsx(SelectionTableBindingInternal, {
		...props,
		collection: props.collection
	});
}
function SelectionTableBindingInternal({ onSingleEntitySelected, onMultipleEntitiesSelected, multiselect, collection, path: pathInput, selectedEntityIds: selectedEntityIdsProp, description, fixedFilter, maxSelection }) {
	const sideDialogContext = useSideDialogContext();
	const sidePanelController = useSidePanel();
	const urlController = useUrlController();
	const analyticsController = useAnalyticsController();
	const path = urlController.resolveDatabasePathsFrom(pathInput);
	const dataClient = useData();
	const [entitiesDisplayedFirst, setEntitiesDisplayedFirst] = useState([]);
	const selectionController = useSelectionController();
	const selectedEntities = selectionController.selection.type === "entities" ? selectionController.selection.entities : EMPTY_ENTITIES;
	const selectionInitializedRef = useRef(false);
	useEffect(() => {
		if (!selectionInitializedRef.current) return;
		if (onMultipleEntitiesSelected) onMultipleEntitiesSelected(selectedEntities);
	}, [selectedEntities]);
	/**
	* Fetch initially selected ids
	*/
	useEffect(() => {
		let unmounted = false;
		const selectedEntityIds = selectedEntityIdsProp?.map((id) => id?.toString()).filter(Boolean);
		if (selectedEntityIds && selectedEntityIds.length > 0 && collection) Promise.all(selectedEntityIds.map((entityId) => dataClient.collection(path).findById(entityId))).then((entities) => {
			if (!unmounted) {
				const result = entities.filter((e) => !!e);
				selectionController.setSelectedEntities(result);
				setEntitiesDisplayedFirst(result);
				selectionInitializedRef.current = true;
			}
		});
		else {
			selectionController.setSelectedEntities([]);
			setEntitiesDisplayedFirst([]);
			selectionInitializedRef.current = true;
		}
		return () => {
			unmounted = true;
		};
	}, [
		dataClient,
		path,
		selectedEntityIdsProp,
		collection,
		selectionController.setSelectedEntities
	]);
	const onClear = () => {
		analyticsController.onAnalyticsEvent?.("reference_selection_clear", { path });
		selectionController.setSelectedEntities([]);
		if (!multiselect && onSingleEntitySelected) onSingleEntitySelected(null);
	};
	const onEntityClick = useCallback((entity) => {
		if (!multiselect && onSingleEntitySelected) {
			analyticsController.onAnalyticsEvent?.("reference_selected_single", {
				path,
				entityId: entity.id
			});
			onSingleEntitySelected(entity);
			sideDialogContext.close(false);
		} else {
			analyticsController.onAnalyticsEvent?.("reference_selection_toggle", {
				path,
				entityId: entity.id
			});
			if (selectedEntities.map((e) => e.id).indexOf(entity.id) > -1) selectionController.setSelectedEntities(selectedEntities.filter((item) => item.id !== entity.id));
			else {
				if (maxSelection && selectedEntities.length >= maxSelection) return;
				selectionController.setSelectedEntities([...selectedEntities, entity]);
			}
		}
	}, [
		multiselect,
		onSingleEntitySelected,
		analyticsController,
		path,
		sideDialogContext,
		selectionController,
		selectedEntities,
		maxSelection
	]);
	const onNewClick = () => {
		analyticsController.onAnalyticsEvent?.("reference_selection_new_entity", { path });
		sidePanelController.open({
			path,
			collection,
			updateUrl: false,
			onUpdate: ({ entity }) => {
				setEntitiesDisplayedFirst([entity, ...entitiesDisplayedFirst]);
				onEntityClick(entity);
			},
			closeOnSave: true
		});
	};
	const tableRowActionsBuilder = ({ entity, size, width, frozen }) => {
		return /* @__PURE__ */ jsx(CollectionRowActions, {
			width,
			frozen,
			entity,
			size,
			isSelected: selectionController.isEntitySelected(entity),
			selectionEnabled: multiselect,
			hideId: collection?.hideIdFromCollection,
			path,
			selectionController,
			openEntityMode: "side_panel"
		});
	};
	const onDone = useCallback((event) => {
		event.stopPropagation();
		sideDialogContext.close(false);
	}, [sideDialogContext]);
	const displayedColumnIds = useColumnIds(collection, false);
	const tableController = useDataTableController({
		path,
		collection,
		entitiesDisplayedFirst,
		fixedFilter,
		updateUrl: false
	});
	return /* @__PURE__ */ jsx(CollectionScopeProvider, {
		collection,
		children: /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col h-full",
			children: [/* @__PURE__ */ jsx("div", {
				className: "grow",
				children: entitiesDisplayedFirst && /* @__PURE__ */ jsx(CollectionTableBinding, {
					additionalFields: collection.additionalFields,
					displayedColumnIds,
					onEntityClick,
					tableController,
					enablePopupIcon: false,
					tableRowActionsBuilder,
					openEntityMode: "side_panel",
					title: /* @__PURE__ */ jsxs(Typography, {
						variant: "subtitle2",
						className: "flex flex-row gap-2",
						children: [/* @__PURE__ */ jsx(IconForView, {
							size: "small",
							collectionOrView: collection,
							className: "text-surface-300 dark:text-surface-600"
						}), collection.singularName ? `Select ${collection.singularName}` : `Select from ${collection.name}`]
					}),
					defaultSize: collection.defaultSize,
					properties: collection.properties,
					fixedFilter,
					inlineEditing: false,
					selectionController,
					actions: /* @__PURE__ */ jsx(EntitySelectionDialogActions, {
						collection,
						path,
						onNewClick,
						onClear
					})
				})
			}), /* @__PURE__ */ jsxs(DialogActions, {
				translucent: false,
				children: [description && /* @__PURE__ */ jsx(Typography, {
					variant: "body2",
					className: "grow text-left",
					children: description
				}), /* @__PURE__ */ jsx(Button, {
					onClick: onDone,
					variant: "filled",
					children: "Done"
				})]
			})]
		})
	});
}
function EntitySelectionDialogActions({ collection, path, onClear, onNewClick }) {
	const { canCreate } = usePermissions();
	const largeLayout = useLargeLayout();
	const { t } = useTranslation();
	const onClick = onNewClick ? (e) => {
		e.preventDefault();
		onNewClick();
	} : void 0;
	const addButton = canCreate(collection, path) && onClick && (largeLayout ? /* @__PURE__ */ jsx(Button, {
		onClick,
		startIcon: /* @__PURE__ */ jsx(PlusIcon, {}),
		children: t("add_specific", { name: collection.singularName ?? collection.name })
	}) : /* @__PURE__ */ jsx(Button, {
		onClick,
		children: /* @__PURE__ */ jsx(PlusIcon, {})
	}));
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(Button, {
		onClick: onClear,
		variant: "text",
		children: "Clear"
	}), addButton] });
}
//#endregion
//#region src/hooks/useSelectionDialog.tsx
/**
* This hook is used to open a side dialog that allows the selection
* of entities under a given path.
* You can use it in custom views for selecting entities.
* You need to specify the path of the target collection at least.
* If your collection is not defined in your  top collection configuration
* (in your `Rebase` component), you need to specify explicitly.
* This is the same hook used internally when a reference property is defined.
* @group Hooks and utilities
*/
function useSelectionDialog(referenceDialogProps) {
	const navigation = useCollectionRegistryController();
	const sideDialogsController = useSideDialogsController();
	const open = useCallback(() => {
		if (referenceDialogProps.path) {
			let usedCollection = referenceDialogProps.collection;
			if (!usedCollection) usedCollection = navigation.getCollection(referenceDialogProps.path);
			if (!usedCollection) throw Error("Not able to resolve the collection in useSelectionDialog. Make sure a collection is registered in path " + referenceDialogProps.path);
			sideDialogsController.open({
				key: `reference_${referenceDialogProps.path}`,
				component: /* @__PURE__ */ jsx(SelectionTableBinding, {
					collection: usedCollection,
					...referenceDialogProps
				}),
				width: "90vw",
				onClose: () => {
					referenceDialogProps.onClose?.();
				}
			});
		} else throw Error("useReferenceDialog: You are trying to open a reference dialog, but have not declared the `path`");
	}, [
		navigation,
		referenceDialogProps,
		sideDialogsController
	]);
	const close = useCallback(() => {
		sideDialogsController.close();
	}, [sideDialogsController]);
	return useMemo(() => ({
		open,
		close
	}), [open, close]);
}
//#endregion
//#region src/form/field_bindings/ArrayOfReferencesFieldBinding.tsx
/**
* This field allows selecting multiple references.
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function ArrayOfReferencesFieldBinding({ propertyKey, value, error, showError, disabled, isSubmitting, minimalistView: minimalistViewProp, property, includeDescription, setValue, setFieldValue }) {
	const minimalistView = minimalistViewProp || property.admin?.minimalistView;
	const { t } = useTranslation();
	const ofProperty = property.of;
	if (ofProperty.type !== "reference") throw Error("ArrayOfReferencesField expected a property containing references");
	const expanded = property.admin?.expanded === void 0 ? true : property.admin?.expanded;
	const selectedEntityIds = value && Array.isArray(value) ? value.map((ref) => ref.id) : [];
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	const collectionRegistryController = useCollectionRegistryController();
	const collection = useMemo(() => {
		return ofProperty.path ? collectionRegistryController.getCollection(ofProperty.path) : void 0;
	}, [ofProperty.path]);
	if (!collection) throw Error(`Couldn't find the corresponding collection for the path: ${ofProperty.path}`);
	const onMultipleEntitiesSelected = useCallback((entities) => {
		setValue(entities.map((e) => getReferenceFrom(e)));
	}, [setValue]);
	const referenceDialogController = useSelectionDialog({
		multiselect: true,
		path: ofProperty.path,
		collection,
		onMultipleEntitiesSelected,
		selectedEntityIds,
		fixedFilter: ofProperty.admin?.fixedFilter
	});
	const onEntryClick = (e) => {
		e.preventDefault();
		referenceDialogController.open();
	};
	const buildEntry = useCallback(({ index, internalId, storedProps, storeProps }) => {
		const entryValue = value && value.length > index ? value[index] : void 0;
		if (!entryValue) return /* @__PURE__ */ jsx("div", { children: "Internal ERROR" });
		return /* @__PURE__ */ jsx(ReferencePreview, {
			disabled: !ofProperty.path,
			previewProperties: ofProperty.admin?.previewProperties,
			size: "medium",
			onClick: onEntryClick,
			hover: !disabled,
			reference: entryValue,
			includeId: ofProperty.admin?.includeId,
			includeEntityLink: ofProperty.admin?.includeEntityLink
		}, internalId);
	}, [
		ofProperty.path,
		ofProperty.admin?.previewProperties,
		value
	]);
	const title = /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(LabelWithIcon, {
		propertyKey,
		icon: getIconForProperty(property, "small"),
		required: property.validation?.required,
		title: property.name ?? propertyKey,
		className: "h-8 flex grow text-text-secondary dark:text-text-secondary-dark"
	}), Array.isArray(value) && /* @__PURE__ */ jsxs(Typography, {
		variant: "caption",
		className: "px-4",
		children: [
			"(",
			value.length,
			")"
		]
	})] });
	const body = /* @__PURE__ */ jsxs(Fragment, { children: [!collection && /* @__PURE__ */ jsx(ErrorView, { error: "The specified collection does not exist. Check console" }), collection && /* @__PURE__ */ jsxs("div", {
		className: "group",
		children: [/* @__PURE__ */ jsx(ArrayContainer, {
			droppableId: propertyKey,
			value,
			disabled: isSubmitting,
			buildEntry,
			canAddElements: false,
			addLabel: property.name ? t("add_reference_to", { name: property.name }) : t("add_reference"),
			newDefaultEntry: property.of && "defaultValue" in property.of ? property.of?.defaultValue : null,
			onValueChange: (value) => setFieldValue(propertyKey, value)
		}), /* @__PURE__ */ jsxs(Button, {
			className: "ml-3.5 my-4 justify-center text-left",
			variant: "text",
			disabled: isSubmitting,
			onClick: onEntryClick,
			children: [
				/* @__PURE__ */ jsx(PencilIcon, { size: 16 }),
				t("edit"),
				" ",
				property.name
			]
		})]
	})] });
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		!minimalistView && /* @__PURE__ */ jsx(ExpandablePanel, {
			titleClassName: fieldBackgroundMixin,
			innerClassName: cls("px-2 md:px-4 pb-2 md:pb-4 pt-1 md:pt-2", fieldBackgroundMixin),
			initiallyExpanded: expanded,
			title,
			children: body
		}),
		minimalistView && body,
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError,
			error,
			disabled,
			property
		})
	] });
}
//#endregion
//#region src/form/field_bindings/BlockFieldBinding.tsx
/**
* If the `oneOf` property is specified, this fields render each array entry as
* a `type` select and the corresponding field widget to the selected `type.
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function BlockFieldBinding({ propertyKey, value, error, showError, isSubmitting, setValue, setFieldValue, minimalistView: minimalistViewProp, property, includeDescription, underlyingValueHasChanged, context, disabled }) {
	const minimalistView = minimalistViewProp || property.admin?.minimalistView;
	const { t } = useTranslation();
	if (!property.oneOf) throw Error("ArrayOneOfField misconfiguration. Property `oneOf` not set");
	const expanded = property.admin?.expanded === void 0 ? true : property.admin?.expanded;
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	const [lastAddedId, setLastAddedId] = useState();
	const buildEntry = ({ index, internalId, storedProps, storeProps }) => {
		return /* @__PURE__ */ jsx(BlockEntry, {
			name: `${propertyKey}.${index}`,
			index,
			value: value[index],
			typeField: property.oneOf.typeField ?? DEFAULT_ONE_OF_TYPE,
			valueField: property.oneOf.valueField ?? DEFAULT_ONE_OF_VALUE,
			properties: property.oneOf.properties,
			autoFocus: internalId === lastAddedId,
			context,
			storeProps,
			storedProps
		}, `array_one_of_${internalId}`);
	};
	const title = /* @__PURE__ */ jsx(LabelWithIcon, {
		propertyKey,
		icon: getIconForProperty(property, "small"),
		required: property.validation?.required,
		title: property.name ?? propertyKey,
		className: "text-text-secondary dark:text-text-secondary-dark"
	});
	const firstOneOfKey = Object.keys(property.oneOf.properties)[0];
	const body = /* @__PURE__ */ jsx(ArrayContainer, {
		value,
		className: "flex flex-col gap-3",
		droppableId: propertyKey,
		addLabel: property.name ? t("add_to_field", { fieldName: property.name }) : t("add_entry"),
		buildEntry,
		onInternalIdAdded: setLastAddedId,
		disabled: isSubmitting || isDisabled(property),
		canAddElements: !isDisabled(property),
		onValueChange: (value) => setFieldValue(propertyKey, value),
		newDefaultEntry: {
			[property.oneOf.typeField ?? DEFAULT_ONE_OF_TYPE]: firstOneOfKey,
			[property.oneOf.valueField ?? DEFAULT_ONE_OF_VALUE]: getDefaultValueFor(property.oneOf.properties[firstOneOfKey])
		}
	});
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		!minimalistView && /* @__PURE__ */ jsx(ExpandablePanel, {
			innerClassName: "px-2 md:px-4 pb-2 md:pb-4 pt-1 md:pt-2",
			initiallyExpanded: expanded,
			title,
			children: body
		}),
		minimalistView && body,
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError,
			error,
			disabled,
			property
		})
	] });
}
function BlockEntry({ name, index, value, typeField, valueField, properties, autoFocus, context, storedProps, storeProps }) {
	const type = value && value[typeField];
	const [typeInternal, setTypeInternal] = useState(type ?? void 0);
	const formex = useFormex();
	const { t } = useTranslation();
	useEffect(() => {
		if (!type) {
			const defaultType = Object.keys(properties)[0];
			const newSelectedProperty = defaultType ? properties[defaultType] : void 0;
			setTypeInternal(defaultType);
			formex.setFieldValue(typeFieldName, defaultType);
			formex.setFieldValue(valueFieldName, newSelectedProperty ? getDefaultValueFor(newSelectedProperty) : null);
		}
	}, []);
	useEffect(() => {
		if (type !== typeInternal) setTypeInternal(type);
	}, [type]);
	const propertyInternal = typeInternal ? properties[typeInternal] : void 0;
	const property = storedProps && typeof propertyInternal === "object" ? mergeDeep(propertyInternal, storedProps) : propertyInternal;
	const enumValuesConfigs = Object.entries(properties).map(([key, property]) => ({
		id: key,
		label: property.name ?? key
	}));
	const typeFieldName = `${name}.${typeField}`;
	const valueFieldName = `${name}.${valueField}`;
	const fieldProps = property ? {
		propertyKey: valueFieldName,
		property,
		context,
		autoFocus,
		partOfArray: false,
		partOfBlock: true,
		minimalistView: true,
		onPropertyChange: storeProps
	} : void 0;
	const updateType = (newType) => {
		const newSelectedProperty = newType ? properties[newType] : void 0;
		setTypeInternal(newType);
		formex.setFieldTouched(typeFieldName, true);
		formex.setFieldValue(typeFieldName, newType);
		formex.setFieldValue(valueFieldName, newSelectedProperty ? getDefaultValueFor(newSelectedProperty) : null);
	};
	return /* @__PURE__ */ jsxs("div", {
		className: cls(paperMixin, "bg-transparent p-2"),
		children: [/* @__PURE__ */ jsx(Field, {
			name: typeFieldName,
			children: (fieldProps) => {
				const value1 = fieldProps.field.value !== void 0 && fieldProps.field.value !== null ? fieldProps.field.value : "";
				return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Select, {
					className: "mb-2",
					"aria-label": t("type"),
					placeholder: /* @__PURE__ */ jsx(Typography, {
						variant: "caption",
						className: "px-4 py-2 font-medium",
						children: t("type")
					}),
					size: "medium",
					fullWidth: true,
					position: "item-aligned",
					value: value1,
					renderValue: (enumKey) => /* @__PURE__ */ jsx(EnumValuesChip, {
						enumKey,
						enumValues: enumValuesConfigs,
						size: "small"
					}),
					onValueChange: (value) => {
						updateType(value);
					},
					children: enumValuesConfigs.map((enumConfig) => /* @__PURE__ */ jsx(SelectItem, {
						value: String(enumConfig.id),
						children: /* @__PURE__ */ jsx(EnumValuesChip, {
							enumKey: enumConfig.id,
							enumValues: enumValuesConfigs,
							size: "small"
						})
					}, enumConfig.id))
				}) });
			}
		}), fieldProps && /* @__PURE__ */ jsx(PropertyFieldBinding, { ...fieldProps }, `form_control_${name}_${typeInternal}`)]
	});
}
//#endregion
//#region src/form/field_bindings/DateTimeFieldBinding.tsx
/**
* Field that allows selecting a date
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function DateTimeFieldBinding({ propertyKey, value, setValue, autoFocus, error, showError, disabled, touched, property, includeDescription, hideLabel, size = "large" }) {
	const { locale } = useCustomizationController();
	const internalValue = value || null;
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(DateTimeField, {
		size,
		value: internalValue,
		onChange: (dateValue) => setValue(dateValue),
		mode: property.mode,
		clearable: property.admin?.clearable,
		locale,
		error: showError,
		disabled,
		label: hideLabel ? void 0 : /* @__PURE__ */ jsx(LabelWithIcon, {
			icon: getIconForProperty(property, "small"),
			required: property.validation?.required,
			className: showError ? "text-red-500 dark:text-red-500" : "text-text-secondary dark:text-text-secondary-dark",
			title: property.name ?? propertyKey
		}),
		"aria-label": hideLabel ? property.name ?? propertyKey : void 0
	}), /* @__PURE__ */ jsx(FieldHelperText, {
		includeDescription,
		showError,
		error,
		disabled,
		property
	})] });
}
//#endregion
//#region src/form/field_bindings/KeyValueFieldBinding.tsx
/**
* Field that allows edition of key value pairs.
*
* @group Form fields
*/
function KeyValueFieldBinding({ propertyKey, value, showError, error, disabled, property, setValue, minimalistView, includeDescription, underlyingValueHasChanged, autoFocus, context }) {
	const expanded = (property.admin?.expanded === void 0 ? true : property.admin?.expanded) || autoFocus;
	if (!property.keyValue) throw Error(`Your property ${propertyKey} needs to have the 'keyValue' prop in order to use this field binding`);
	const mapFormView = /* @__PURE__ */ jsx(MapEditView, {
		value,
		setValue,
		disabled,
		initialValue: getIn(context.formex.initialValues, propertyKey),
		fieldName: property.name ?? propertyKey
	});
	const title = /* @__PURE__ */ jsx(LabelWithIcon, {
		propertyKey,
		icon: getIconForProperty(property, "small"),
		required: property.validation?.required,
		title: property.name ?? propertyKey,
		className: "text-text-secondary dark:text-text-secondary-dark"
	});
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		!minimalistView && /* @__PURE__ */ jsx(ExpandablePanel, {
			initiallyExpanded: expanded,
			title,
			innerClassName: "px-2 md:px-4 pb-2 md:pb-4 pt-1 md:pt-2",
			children: mapFormView
		}),
		minimalistView && mapFormView,
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError,
			error,
			disabled,
			property
		})
	] });
}
function MapEditView({ value, initialValue, setValue, fieldName, disabled }) {
	const [internalState, setInternalState] = React.useState(Object.keys(initialValue ?? {}).map((key) => [getRandomId(), {
		key,
		type: gettype(initialValue?.[key]) ?? "string"
	}]));
	const { t } = useTranslation();
	useEffect(() => {
		const currentKeys = internalState.map(([id, { key }]) => key);
		const newKeys = Object.entries(value ?? {}).filter(([key, v]) => v !== void 0).map(([key]) => key);
		const keysToAdd = newKeys.filter((key) => !currentKeys.includes(key));
		const keysToRemove = currentKeys.filter((key) => !newKeys.includes(key));
		const newRowIds = [...internalState];
		keysToAdd.forEach((key) => {
			newRowIds.push([getRandomId(), {
				key,
				type: gettype(value?.[key]) ?? "string"
			}]);
		});
		keysToRemove.forEach((key) => {
			const index = newRowIds.findIndex(([id, { key: k }]) => k === key);
			newRowIds.splice(index, 1);
		});
		setInternalState(newRowIds);
	}, [value]);
	const updatetype = (id, type) => {
		if (!id) {
			console.warn("No key selected for data type update");
			return;
		}
		setInternalState(internalState.map((row) => {
			if (row[0] === id) return [row[0], {
				key: row[1].key,
				type
			}];
			return row;
		}));
		setValue({
			...value ?? {},
			[internalState.find((row) => row[0] === id)?.[1].key ?? ""]: getDefaultValueFortype(type)
		});
	};
	return /* @__PURE__ */ jsxs("div", {
		className: "py-1 flex flex-col gap-1",
		children: [internalState.map(([id, { key: fieldKey, type }], index) => {
			const entryValue = fieldKey ? value?.[fieldKey] : "";
			const onFieldKeyChange = (newKey) => {
				setInternalState(internalState.map((currentId) => {
					if (currentId[0] === id) return [id, {
						key: newKey ?? "",
						type: currentId[1].type
					}];
					return currentId;
				}));
				if (typeof value === "object" && newKey in value) return;
				const newValue = { ...value ?? {} };
				if (typeof initialValue === "object" && fieldKey in initialValue) newValue[fieldKey] = void 0;
				else delete newValue[fieldKey];
				setValue({
					...newValue,
					[newKey ?? ""]: entryValue
				});
			};
			return /* @__PURE__ */ jsx(MapKeyValueRow, {
				id,
				fieldKey,
				value: value ?? {},
				onDeleteClick: () => {
					const newValue = { ...value ?? {} };
					if (initialValue && fieldKey in initialValue) newValue[fieldKey] = void 0;
					else delete newValue[fieldKey];
					setInternalState(internalState.filter((currentId) => currentId[0] !== id));
					setValue({ ...newValue });
				},
				onFieldKeyChange,
				setValue,
				entryValue,
				type,
				disabled,
				updatetype
			}, id);
		}), /* @__PURE__ */ jsx(Button, {
			variant: "text",
			size: "small",
			className: "w-full",
			disabled,
			startIcon: /* @__PURE__ */ jsx(PlusIcon, {}),
			onClick: (e) => {
				e.preventDefault();
				setValue({
					...value ?? {},
					"": null
				});
				setInternalState([...internalState, [getRandomId(), {
					key: "",
					type: "string"
				}]]);
			},
			children: fieldName ? t("add_to_field", { fieldName }) : t("add")
		})]
	});
}
function MapKeyValueRow({ id, fieldKey, value, onFieldKeyChange, onDeleteClick, setValue, entryValue, type, updatetype, disabled }) {
	const { locale } = useCustomizationController();
	const { t } = useTranslation();
	function buildInput(entryValue, fieldKey, type) {
		if (type === "string" || type === "number") return /* @__PURE__ */ jsx(TextField, {
			"aria-label": fieldKey ? `${t("value")}: ${fieldKey}` : t("value"),
			placeholder: "value",
			value: entryValue,
			type: type === "number" ? "number" : "text",
			size: "medium",
			disabled: disabled || !fieldKey,
			onChange: (event) => {
				if (type === "number") {
					const numberValue = event.target.value ? parseFloat(event.target.value) : void 0;
					if (numberValue && isNaN(numberValue)) setValue({
						...value,
						[fieldKey]: null
					});
					else if (numberValue !== void 0 && numberValue !== null) setValue({
						...value,
						[fieldKey]: numberValue
					});
					else setValue({
						...value,
						[fieldKey]: null
					});
				} else setValue({
					...value,
					[fieldKey]: event.target.value
				});
			}
		}, type);
		else if (type === "date") return /* @__PURE__ */ jsx(DateTimeField, {
			value: entryValue,
			size: "medium",
			locale,
			disabled: disabled || !fieldKey,
			onChange: (date) => {
				setValue({
					...value,
					[fieldKey]: date
				});
			}
		});
		else if (type === "boolean") return /* @__PURE__ */ jsx(BooleanSwitchWithLabel, {
			value: entryValue,
			size: "medium",
			position: "start",
			disabled: disabled || !fieldKey,
			onValueChange: (newValue) => {
				setValue({
					...value,
					[fieldKey]: newValue
				});
			}
		});
		else if (type === "array") {
			const arrayValue = entryValue || [];
			return /* @__PURE__ */ jsx("div", {
				className: cls(defaultBorderMixin, "ml-2 pl-2 border-l border-solid"),
				children: /* @__PURE__ */ jsx(ArrayContainer, {
					value: arrayValue,
					newDefaultEntry: "",
					droppableId: id.toString(),
					addLabel: fieldKey ? t("add_to_field", { fieldName: fieldKey }) : t("add"),
					size: "small",
					disabled: disabled || !fieldKey,
					canAddElements: true,
					onValueChange: (newValue) => {
						setValue({
							...value,
							[fieldKey]: newValue
						});
					},
					buildEntry: ({ index, internalId }) => {
						return /* @__PURE__ */ jsx(ArrayKeyValueRow, {
							index,
							id: internalId,
							value: arrayValue[index],
							disabled: disabled || !fieldKey,
							setValue: (newValue) => {
								const newArrayValue = [...arrayValue];
								newArrayValue[index] = newValue;
								setValue({
									...value,
									[fieldKey]: newArrayValue
								});
							}
						});
					}
				})
			});
		} else if (type === "map") return /* @__PURE__ */ jsx("div", {
			className: cls(defaultBorderMixin, "ml-2 pl-2 border-l border-solid"),
			children: /* @__PURE__ */ jsx(MapEditView, {
				value: entryValue,
				fieldName: fieldKey,
				setValue: (updatedValue) => {
					setValue({
						...value,
						[fieldKey]: updatedValue
					});
				}
			})
		});
		else return /* @__PURE__ */ jsx(Typography, {
			variant: "caption",
			children: `Data type ${type} not supported yet`
		});
	}
	function doUpdatetype(type) {
		updatetype(id, type);
	}
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsxs(Typography, {
		component: "div",
		className: "font-mono flex flex-row gap-1",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "w-[300px] max-w-[30%]",
				children: /* @__PURE__ */ jsx(TextField, {
					value: fieldKey,
					"aria-label": t("key"),
					placeholder: "key",
					disabled: disabled || entryValue !== void 0 && entryValue !== null && entryValue !== "",
					size: "medium",
					onChange: (event) => {
						onFieldKeyChange(event.target.value);
					}
				})
			}),
			/* @__PURE__ */ jsx("div", {
				className: "grow",
				children: type !== "map" && type !== "array" && buildInput(entryValue, fieldKey, type)
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "flex flex-col",
				children: [/* @__PURE__ */ jsxs(Menu, {
					trigger: /* @__PURE__ */ jsx(IconButton, {
						size: "smallest",
						children: /* @__PURE__ */ jsx(ChevronDownIcon, { size: iconSize.small })
					}),
					children: [
						/* @__PURE__ */ jsx(MenuItem, {
							dense: true,
							onClick: () => doUpdatetype("string"),
							children: "string"
						}),
						/* @__PURE__ */ jsx(MenuItem, {
							dense: true,
							onClick: () => doUpdatetype("number"),
							children: "number"
						}),
						/* @__PURE__ */ jsx(MenuItem, {
							dense: true,
							onClick: () => doUpdatetype("boolean"),
							children: "boolean"
						}),
						/* @__PURE__ */ jsx(MenuItem, {
							dense: true,
							onClick: () => doUpdatetype("date"),
							children: "date"
						}),
						/* @__PURE__ */ jsx(MenuItem, {
							dense: true,
							onClick: () => doUpdatetype("map"),
							children: "map"
						}),
						/* @__PURE__ */ jsx(MenuItem, {
							dense: true,
							onClick: () => doUpdatetype("array"),
							children: "array"
						})
					]
				}), /* @__PURE__ */ jsx(IconButton, {
					"aria-label": "delete",
					size: "smallest",
					onClick: onDeleteClick,
					children: /* @__PURE__ */ jsx(MinusIcon, { size: iconSize.smallest })
				})]
			})
		]
	}, id.toString()), (type === "map" || type === "array") && buildInput(entryValue, fieldKey, type)] });
}
function ArrayKeyValueRow({ id, index, value, setValue }) {
	const { locale } = useCustomizationController();
	const [selectedtype, setSelectedtype] = useState(gettype(value) ?? "string");
	function doUpdatetype(type) {
		setSelectedtype(type);
	}
	function buildInput(entryValue, type) {
		if (type === "string" || type === "number") return /* @__PURE__ */ jsx(TextField, {
			value: entryValue,
			"aria-label": `Value ${index + 1}`,
			type: type === "number" ? "number" : "text",
			size: "medium",
			onChange: (event) => {
				if (type === "number") {
					const numberValue = event.target.value ? parseFloat(event.target.value) : void 0;
					if (numberValue && isNaN(numberValue)) setValue(null);
					else if (numberValue !== void 0 && numberValue !== null) setValue(numberValue);
					else setValue(null);
				} else setValue(event.target.value);
			}
		});
		else if (type === "date") return /* @__PURE__ */ jsx(DateTimeField, {
			value: entryValue,
			size: "medium",
			locale,
			onChange: (date) => {
				setValue(date);
			}
		});
		else if (type === "boolean") return /* @__PURE__ */ jsx(BooleanSwitchWithLabel, {
			value: entryValue,
			size: "small",
			position: "start",
			onValueChange: (v) => {
				setValue(v);
			}
		});
		else if (type === "array") return /* @__PURE__ */ jsx(Typography, {
			variant: "caption",
			children: "Arrays of arrays are not supported."
		});
		else if (type === "map") {
			const mapValue = entryValue && typeof entryValue === "object" ? entryValue : void 0;
			return /* @__PURE__ */ jsx("div", {
				className: cls(defaultBorderMixin, "ml-2 pl-2 border-l border-solid"),
				children: /* @__PURE__ */ jsx(MapEditView, {
					value: mapValue,
					setValue: (updatedValue) => {
						setValue(updatedValue);
					}
				})
			});
		} else return /* @__PURE__ */ jsx(Typography, {
			variant: "caption",
			children: `Data type ${type} not supported yet`
		});
	}
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsxs(Typography, {
		component: "div",
		className: "font-mono flex min-h-12 flex-row gap-1 items-center",
		children: [/* @__PURE__ */ jsx("div", {
			className: "grow",
			children: selectedtype !== "map" && buildInput(value, selectedtype)
		}), /* @__PURE__ */ jsxs(Menu, {
			trigger: /* @__PURE__ */ jsx(IconButton, {
				size: "small",
				className: "h-7 w-7",
				children: /* @__PURE__ */ jsx(ChevronDownIcon, {})
			}),
			children: [
				/* @__PURE__ */ jsx(MenuItem, {
					dense: true,
					onClick: () => doUpdatetype("string"),
					children: "string"
				}),
				/* @__PURE__ */ jsx(MenuItem, {
					dense: true,
					onClick: () => doUpdatetype("number"),
					children: "number"
				}),
				/* @__PURE__ */ jsx(MenuItem, {
					dense: true,
					onClick: () => doUpdatetype("boolean"),
					children: "boolean"
				}),
				/* @__PURE__ */ jsx(MenuItem, {
					dense: true,
					onClick: () => doUpdatetype("map"),
					children: "map"
				}),
				/* @__PURE__ */ jsx(MenuItem, {
					dense: true,
					onClick: () => doUpdatetype("date"),
					children: "date"
				})
			]
		})]
	}, id.toString()), selectedtype === "map" && buildInput(value, selectedtype)] });
}
function getRandomId() {
	return Math.floor(Math.random() * Math.floor(Number.MAX_SAFE_INTEGER));
}
function gettype(value) {
	if (typeof value === "string" || value === null) return "string";
	else if (typeof value === "number") return "number";
	else if (typeof value === "boolean") return "boolean";
	else if (Array.isArray(value)) return "array";
	else if (value instanceof Date) return "date";
	else if (value && typeof value === "object" && "isEntityReference" in value && typeof value.isEntityReference === "function" && value.isEntityReference()) return "reference";
	else if (value instanceof GeoPoint) return "geopoint";
	else if (typeof value === "object") return "map";
}
//#endregion
//#region src/form/field_bindings/MapFieldBinding.tsx
/**
* Field that renders the children property fields
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function MapFieldBinding({ propertyKey, value, showError, error, disabled, property, partOfArray, minimalistView: minimalistViewProp, includeDescription, autoFocus, context, onPropertyChange }) {
	const expanded = property.admin?.expanded === void 0 ? true : property.admin?.expanded;
	const minimalistView = minimalistViewProp || property.admin?.minimalistView;
	const { t } = useTranslation();
	if (!property.properties) throw Error(`You need to specify a 'properties' prop (or specify a custom field) in your map property '${propertyKey}'${property.name ? ` ("${property.name}")` : ""}`);
	const mapProperties = property.properties;
	const mapFormView = /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("div", {
		className: "py-1 flex flex-col space-y-2",
		children: Object.entries(mapProperties).filter(([_, property]) => !isHidden(property)).map(([entryKey, childProperty], index) => {
			const thisDisabled = isReadOnly(childProperty) || isDisabled(childProperty);
			return /* @__PURE__ */ jsx("div", {
				className: "relative",
				children: /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(PropertyFieldBinding, {
					propertyKey: `${propertyKey}.${entryKey}`,
					disabled: disabled || thisDisabled,
					property: childProperty,
					includeDescription,
					context,
					partOfArray: false,
					minimalistView: false,
					autoFocus: autoFocus && index === 0,
					onPropertyChange: function(updatedProperty) {
						onPropertyChange?.({ properties: { [entryKey]: updatedProperty } });
					}
				}) })
			}, `map-${propertyKey}-${index}`);
		})
	}) });
	return /* @__PURE__ */ jsxs(ErrorBoundary, { children: [
		!minimalistView && /* @__PURE__ */ jsx(ExpandablePanel, {
			initiallyExpanded: expanded,
			onExpandedChange: (expanded) => {
				onPropertyChange?.({ admin: {
					...property.admin,
					expanded
				} });
			},
			innerClassName: "px-2 md:px-4 pb-2 md:pb-4 pt-1 md:pt-2 bg-surface-card",
			title: /* @__PURE__ */ jsx(LabelWithIcon, {
				propertyKey,
				icon: getIconForProperty(property, "small"),
				required: property.validation?.required,
				title: property.name ?? propertyKey,
				className: "text-text-secondary dark:text-text-secondary-dark"
			}),
			children: mapFormView
		}),
		minimalistView && mapFormView,
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError: showError ?? false,
			error: error && !partOfArray ? error : void 0,
			disabled,
			property
		})
	] });
}
//#endregion
//#region src/form/field_bindings/MarkdownEditorFieldBinding.tsx
var RichTextEditor = lazyChunk(() => import("./editor.js").then((m) => ({ default: m.RichTextEditor })));
var loadMarkdownUtils = () => import("./markdown-CCqp8ibf.js").then((n) => n.t);
var _markdownUtils = null;
var getMarkdownUtils = async () => {
	if (!_markdownUtils) _markdownUtils = await loadMarkdownUtils();
	return _markdownUtils;
};
/**
* Normalize markdown for comparison purposes: collapse whitespace,
* normalize line endings, trim lines. This is NOT for display.
*/
function normalizeMarkdown(md) {
	if (!md) return "";
	return md.replace(/\r\n/g, "\n").replace(/\n{3,}/g, "\n\n").replace(/[ \t]+$/gm, "").trim();
}
/**
* Compute the canonical form of a markdown string by doing a full
* parse → serialize roundtrip through ProseMirror. This gives us
* the exact output the editor will produce for a given input,
* so we can compare against it to avoid false dirty states.
*
* Falls back to normalizeMarkdown if the ProseMirror module hasn't loaded yet.
*/
function canonicalizeMarkdown(md) {
	if (!md) return "";
	if (!_markdownUtils) return normalizeMarkdown(md);
	try {
		const doc = _markdownUtils.parser.parse(md);
		if (!doc) return normalizeMarkdown(md);
		return normalizeMarkdown(_markdownUtils.serializer.serialize(doc));
	} catch {
		return normalizeMarkdown(md);
	}
}
function MarkdownEditorFieldBinding({ property, propertyKey, value, setValue, includeDescription, hideLabel, showError, error, minimalistView, disabled: disabledProp, isSubmitting, context, customProps }) {
	useAuthController();
	const disabled = disabledProp || isSubmitting;
	const highlight = customProps?.highlight;
	const editorProps = customProps?.editorProps;
	const defaultStorageSource = useStorageSource();
	const storage = property.storage;
	const storageSources = useStorageSources();
	const storageSource = useMemo(() => resolveStorageSource({
		sourceKey: storage?.storageSource === void 0 ? void 0 : resourceKeyOf(storage.storageSource),
		sources: storageSources.sources,
		defaultSource: defaultStorageSource
	}), [
		storage?.storageSource,
		storageSources.sources,
		defaultStorageSource
	]);
	const entityValues = context.values;
	const entityId = context.entityId;
	const path = context.path;
	const [fieldVersion, setFieldVersion] = useState(0);
	const internalValue = useRef(value);
	useEffect(() => {
		getMarkdownUtils().then(() => {
			canonicalRef.current = canonicalizeMarkdown(value);
		});
	}, []);
	const canonicalRef = useRef(useMemo(() => canonicalizeMarkdown(value), []));
	const onContentChange = useCallback((content) => {
		const normalizedContent = normalizeMarkdown(content);
		if (normalizedContent === canonicalRef.current) return;
		if (normalizedContent === normalizeMarkdown(value)) return;
		internalValue.current = content;
		setValue(content);
	}, [setValue, value]);
	useEffect(() => {
		if (internalValue.current !== value) {
			internalValue.current = value;
			canonicalRef.current = canonicalizeMarkdown(value);
			setFieldVersion((v) => v + 1);
		}
	}, [value]);
	const fileNameBuilder = useCallback(async (file) => {
		if (storage?.fileName) {
			const fileName = await resolveStorageFilenameString({
				input: storage.fileName,
				storage,
				values: entityValues,
				entityId,
				path,
				property,
				file,
				propertyKey
			});
			if (!fileName || fileName.length === 0) throw Error("You need to return a valid filename");
			return fileName;
		}
		return randomString() + "_" + file.name;
	}, [
		entityId,
		entityValues,
		path,
		property,
		propertyKey,
		storage
	]);
	const storagePathBuilder = useCallback((file) => {
		if (!storage) return "/";
		return resolveStoragePathString({
			input: storage.storagePath,
			storage,
			values: entityValues,
			entityId,
			path,
			property,
			file,
			propertyKey
		}) ?? "/";
	}, [
		entityId,
		entityValues,
		path,
		property,
		propertyKey,
		storage
	]);
	const editor = /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(Skeleton, {
			height: 200,
			className: "w-full rounded-md"
		}),
		children: /* @__PURE__ */ jsx(RichTextEditor, {
			content: value,
			onMarkdownContentChange: onContentChange,
			version: context.formex.version + fieldVersion,
			highlight,
			disabled,
			handleImageUpload: async (file) => {
				const key = `${storagePathBuilder(file)}/${await fileNameBuilder(file)}`.replace(/^\/+/, "").replace(/\/+/g, "/");
				const result = await storageSource.putObject({
					file,
					key
				});
				const url = (await storageSource.getSignedUrl(result.key)).url;
				if (!url) throw new Error("Error uploading image");
				return url;
			},
			...editorProps
		})
	});
	if (minimalistView) return editor;
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		!hideLabel && /* @__PURE__ */ jsx("div", {
			className: "flex items-center w-full",
			children: /* @__PURE__ */ jsx(LabelWithIcon, {
				propertyKey,
				icon: getIconForProperty(property, "small"),
				required: property.validation?.required,
				title: property.name ?? propertyKey,
				className: "h-8 text-text-secondary dark:text-text-secondary-dark ml-3.5"
			})
		}),
		/* @__PURE__ */ jsxs("div", {
			className: cls("relative rounded-md", fieldBackgroundMixin, disabled ? fieldBackgroundDisabledMixin : fieldBackgroundHoverMixin),
			children: [property.admin?.clearable && !disabled && /* @__PURE__ */ jsx(IconButton, {
				size: "small",
				className: "absolute bottom-1 right-1 z-10",
				onClick: (e) => {
					e.stopPropagation();
					e.preventDefault();
					setValue(null);
				},
				children: /* @__PURE__ */ jsx(XIcon, {})
			}), editor]
		}),
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError,
			error,
			property
		})
	] });
}
//#endregion
//#region src/form/field_bindings/MultiSelectFieldBinding.tsx
/**
* This fields renders a dropdown with multiple selection.
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function MultiSelectFieldBinding({ propertyKey, value, setValue, error, showError, disabled, property, includeDescription, hideLabel, size = "large", autoFocus }) {
	const of = property.of;
	if (!of) throw Error("Using wrong component ArrayEnumSelect");
	if (Array.isArray(of)) throw Error("Using array properties instead of single one in `of` in ArrayProperty");
	if (of.type !== "string" && of.type !== "number") throw Error("Field misconfiguration: array field of type string or number");
	const enumValues = of.enum ? enumToObjectEntries(of.enum) : void 0;
	if (!enumValues) {
		console.error(property);
		throw Error("Field misconfiguration: array field of type string or number needs to have enumValues");
	}
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	const validValue = !!value && Array.isArray(value);
	const renderValue = useCallback((enumKey, list) => {
		const enumValue = enumKey !== void 0 ? getLabelOrConfigFrom(enumValues, enumKey) : void 0;
		return /* @__PURE__ */ jsxs(EnumValuesChip, {
			enumKey,
			enumValues,
			size: "medium",
			children: [enumValue?.label ?? enumKey, !list && /* @__PURE__ */ jsx("button", {
				className: "ml-1 ring-offset-background rounded-full outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
				onMouseDown: (e) => {
					e.preventDefault();
					e.stopPropagation();
				},
				onClick: (e) => {
					e.preventDefault();
					e.stopPropagation();
					setValue((value ?? []).filter((v) => v !== enumKey));
				},
				children: /* @__PURE__ */ jsx(XIcon, { size: iconSize.smallest })
			})]
		}, enumKey);
	}, [
		enumValues,
		setValue,
		value
	]);
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(MultiSelect, {
		className: "w-full",
		size,
		"aria-label": property.name ?? propertyKey,
		value: validValue ? value.map((v) => v?.toString()) : [],
		disabled,
		modalPopover: true,
		label: hideLabel ? void 0 : /* @__PURE__ */ jsx(LabelWithIcon, {
			propertyKey,
			icon: getIconForProperty(property, "small"),
			required: property.validation?.required,
			title: property.name ?? propertyKey,
			className: "h-8 text-text-secondary dark:text-text-secondary-dark ml-3.5"
		}),
		onValueChange: (updatedValue) => {
			let newValue;
			if (of && of?.type === "number") newValue = updatedValue ? updatedValue.map((e) => parseFloat(e)) : [];
			else newValue = updatedValue;
			return setValue(newValue);
		},
		children: enumValues.map((enumValue) => String(enumValue.id)).map((enumKey) => /* @__PURE__ */ jsx(MultiSelectItem, {
			value: enumKey,
			children: renderValue(enumKey, true)
		}, enumKey))
	}), /* @__PURE__ */ jsx(FieldHelperText, {
		includeDescription,
		showError,
		error,
		disabled,
		property
	})] });
}
//#endregion
//#region src/form/field_bindings/ReferenceFieldBinding.tsx
/**
* Field that opens a reference selection dialog.
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function ReferenceFieldBinding(props) {
	if (typeof props.property.path !== "string") return /* @__PURE__ */ jsx(ReadOnlyFieldBinding, { ...props });
	return /* @__PURE__ */ jsx(ReferenceFieldBindingInternal, { ...props });
}
function ReferenceFieldBindingInternal({ propertyKey, value, setValue, error, showError, isSubmitting, disabled, minimalistView, touched, autoFocus, property, includeDescription, hideLabel, size = "medium" }) {
	if (!property.path) throw new Error("Property path is required for ReferenceFieldBinding");
	const refValue = value;
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	const validValue = refValue && typeof refValue === "object" && "isEntityReference" in refValue && refValue.isEntityReference();
	const collectionRegistryController = useCollectionRegistryController();
	const collection = useMemo(() => {
		return property.path ? collectionRegistryController.getCollection(property.path) : void 0;
	}, [property.path]);
	if (!collection) throw Error(`Couldn't find the corresponding collection for the path: ${property.path}`);
	const onSingleEntitySelected = useCallback((e) => {
		setValue(e ? getReferenceFrom(e) : null);
	}, [setValue, propertyKey]);
	const referenceDialogController = useSelectionDialog({
		multiselect: false,
		path: property.path,
		collection,
		onSingleEntitySelected,
		selectedEntityIds: validValue && refValue ? [refValue.id] : void 0,
		fixedFilter: property.admin?.fixedFilter
	});
	const onEntryClick = (e) => {
		e.preventDefault();
		referenceDialogController.open();
	};
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		!minimalistView && !hideLabel && /* @__PURE__ */ jsx(LabelWithIcon, {
			propertyKey,
			icon: getIconForProperty(property, "small"),
			required: property.validation?.required,
			title: property.name ?? propertyKey,
			className: "h-8 text-text-secondary dark:text-text-secondary-dark ml-3.5"
		}),
		!collection && /* @__PURE__ */ jsx(ErrorView, { error: "The specified collection does not exist. Check console" }),
		collection && /* @__PURE__ */ jsxs(Fragment, { children: [refValue && /* @__PURE__ */ jsx(ReferencePreview, {
			disabled: !property.path,
			previewProperties: property.admin?.previewProperties,
			hover: !disabled,
			size,
			onClick: disabled || isSubmitting ? void 0 : onEntryClick,
			reference: refValue,
			includeEntityLink: property.admin?.includeEntityLink,
			includeId: property.admin?.includeId
		}), !refValue && /* @__PURE__ */ jsx("div", {
			className: "justify-center text-left",
			children: /* @__PURE__ */ jsxs(EntityPreviewContainer, {
				className: cls("px-6 h-12 text-sm font-medium flex items-center gap-6", disabled || isSubmitting ? "text-surface-accent-500" : "cursor-pointer text-surface-accent-700 dark:text-surface-accent-300 hover:bg-surface-hover group-hover:bg-surface-hover"),
				onClick: onEntryClick,
				size: "medium",
				children: [/* @__PURE__ */ jsx(IconForView, {
					collectionOrView: collection,
					className: "text-surface-300 dark:text-surface-600"
				}), `Edit ${property.name}`.toUpperCase()]
			})
		})] }),
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError,
			error,
			disabled,
			property
		})
	] });
}
//#endregion
//#region src/form/field_bindings/RepeatFieldBinding.tsx
/**
* Generic array field that allows reordering and renders the child property
* as nodes.
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function RepeatFieldBinding({ propertyKey, value, error, showError, isSubmitting, setValue, setFieldValue, minimalistView: minimalistViewProp, property, includeDescription, underlyingValueHasChanged, context, disabled }) {
	const authController = useAuthController();
	const { t } = useTranslation();
	if (property.type !== "array" || !property.of || Array.isArray(property.of)) throw Error("RepeatFieldBinding misconfiguration. Property `type` is not `array`");
	const minimalistView = minimalistViewProp || property.admin?.minimalistView;
	if (!property.of) throw Error("RepeatFieldBinding misconfiguration. Property `of` not set");
	const resolvedProperties = getArrayResolvedProperties({
		propertyValue: value,
		propertyKey,
		property,
		ignoreMissingFields: false,
		authController
	});
	const expanded = property.admin?.expanded === void 0 ? true : property.admin?.expanded;
	const ofProperty = property.of;
	const [lastAddedId, setLastAddedId] = useState();
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	const buildEntry = ({ index, internalId, storedProps, storeProps }) => {
		const childProperty = resolvedProperties?.[index] ?? ofProperty;
		return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(PropertyFieldBinding, {
			propertyKey: `${propertyKey}.${index}`,
			disabled,
			property: storedProps ? mergeDeep(childProperty, storedProps) : childProperty,
			onPropertyChange: storeProps,
			includeDescription,
			underlyingValueHasChanged,
			context,
			partOfArray: true,
			minimalistView: false,
			hideLabel: true,
			autoFocus: internalId === lastAddedId,
			index
		}) });
	};
	const canAddElements = !isDisabled(property) && !isSubmitting && !disabled && (property.admin?.canAddElements || property.admin?.canAddElements === void 0);
	const sortable = property.admin?.sortable === void 0 ? true : property.admin.sortable;
	const arrayContainer = /* @__PURE__ */ jsx(ArrayContainer, {
		droppableId: propertyKey,
		addLabel: property.name ? t("add_to_field", { fieldName: property.name }) : t("add_entry"),
		value: value ?? [],
		buildEntry,
		onInternalIdAdded: setLastAddedId,
		disabled: isSubmitting || isDisabled(property),
		canAddElements,
		sortable,
		newDefaultEntry: getDefaultValueFor(property.of),
		onValueChange: (value) => setFieldValue(propertyKey, value)
	});
	const title = /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(LabelWithIcon, {
		propertyKey,
		icon: getIconForProperty(property, "small"),
		required: property.validation?.required,
		title: property.name ?? propertyKey,
		className: "h-8 flex grow text-text-secondary dark:text-text-secondary-dark"
	}), Array.isArray(value) && /* @__PURE__ */ jsxs(Typography, {
		variant: "caption",
		className: "px-4",
		children: [
			"(",
			value.length,
			")"
		]
	})] });
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		!minimalistView && /* @__PURE__ */ jsx(ExpandablePanel, {
			initiallyExpanded: expanded,
			innerClassName: "px-2 md:px-4 pb-2 md:pb-4 pt-1 md:pt-2",
			title,
			children: arrayContainer
		}),
		minimalistView && arrayContainer,
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError,
			error,
			disabled,
			property
		})
	] });
}
//#endregion
//#region src/form/field_bindings/SelectFieldBinding.tsx
/**
* If `enumValues` are set in the string config, this field renders a select
* where each option is a colored chip.
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function SelectFieldBinding({ propertyKey, value, setValue, error, showError, disabled, autoFocus, touched, property, includeDescription, hideLabel, size = "large" }) {
	const enumValues = resolveEnumValues(property.enum ?? []);
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	const handleClearClick = useCallback((e) => {
		e.stopPropagation();
		e.preventDefault();
		setValue(null);
	}, [setValue]);
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(Select, {
		value: value !== void 0 && value != null ? value.toString() : "",
		"aria-label": property.name ?? propertyKey,
		disabled,
		size,
		fullWidth: true,
		position: "item-aligned",
		inputClassName: cls("w-full"),
		label: hideLabel ? void 0 : /* @__PURE__ */ jsx(LabelWithIcon, {
			icon: getIconForProperty(property, "small"),
			required: property.validation?.required,
			title: property.name ?? propertyKey,
			propertyKey,
			className: "h-8 text-text-secondary dark:text-text-secondary-dark ml-3.5 my-0"
		}),
		endAdornment: property.admin?.clearable && !disabled && /* @__PURE__ */ jsx(IconButton, {
			size: "small",
			onClick: handleClearClick,
			children: /* @__PURE__ */ jsx(XIcon, {})
		}),
		onValueChange: (updatedValue) => {
			return setValue(updatedValue ? property.type === "number" ? parseFloat(updatedValue) : updatedValue : null);
		},
		renderValue: (enumKey) => {
			return /* @__PURE__ */ jsx(EnumValuesChip, {
				enumKey,
				enumValues,
				size
			});
		},
		children: enumValues && enumValues.map((option) => {
			return /* @__PURE__ */ jsx(SelectItem, {
				value: String(option.id),
				children: /* @__PURE__ */ jsx(EnumValuesChip, {
					enumKey: String(option.id),
					enumValues,
					size
				})
			}, option.id);
		})
	}), /* @__PURE__ */ jsx(FieldHelperText, {
		includeDescription,
		showError,
		error,
		disabled,
		property
	})] });
}
//#endregion
//#region src/form/components/StorageItemPreview.tsx
function StorageItemPreview({ name, property, value, onRemove, disabled, size, placeholder, className }) {
	const { t } = useTranslation();
	return /* @__PURE__ */ jsxs("div", {
		className: cls("relative border-box flex items-center justify-center", size === "large" ? "min-w-[220px] min-h-[220px] max-w-[220px]" : "min-w-[118px] min-h-[118px] max-w-[118px]", paperMixin, className),
		children: [
			!placeholder && !disabled && /* @__PURE__ */ jsx("div", {
				className: "absolute rounded-full -top-2 -right-2 z-10 bg-surface-card",
				children: /* @__PURE__ */ jsx(Tooltip, {
					asChild: true,
					title: t("remove"),
					children: /* @__PURE__ */ jsx(IconButton, {
						size: "small",
						onClick: (event) => {
							event.stopPropagation();
							onRemove(value);
						},
						children: /* @__PURE__ */ jsx(MinusIcon, {})
					})
				})
			}),
			!placeholder && value && /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(PropertyPreview, {
				propertyKey: name,
				value,
				property,
				interactive: false,
				size
			}) }),
			placeholder && /* @__PURE__ */ jsx("div", {
				onClick: (e) => e.stopPropagation(),
				className: "flex flex-col items-center justify-center w-full h-full",
				children: /* @__PURE__ */ jsx(FileTextIcon, { className: "text-surface-700 dark:text-surface-300" })
			})
		]
	});
}
//#endregion
//#region src/form/field_bindings/StorageUploadFieldBinding.tsx
var dropZoneClasses = "box-border relative pt-[2px] h-[172px] items-center border border-transparent outline-none rounded-md duration-200 ease-[cubic-bezier(0.4,0,0.2,1)] focus:border-primary";
var disabledClasses = fieldBackgroundDisabledMixin;
var nonActiveDropClasses = fieldBackgroundHoverMixin;
var activeDropClasses = "pt-0 border-2 border-solid";
var acceptDropClasses = "transition-colors duration-200 ease-[cubic-bezier(0,0,0.2,1)] border-2 border-solid border-green-500";
var rejectDropClasses = "transition-colors duration-200 ease-[cubic-bezier(0,0,0.2,1)] border-2 border-solid border-red-500";
function StorageUploadFieldBinding({ propertyKey, value, setValue, error, showError, autoFocus, minimalistView, property, includeDescription, hideLabel, context, isSubmitting }) {
	useAuthController();
	const storageSource = useStorageSource();
	const disabled = isReadOnly(property) || isDisabled(property) || isSubmitting || context.disabled;
	const { internalValue, setInternalValue, onFilesAdded, storage, onFileUploadComplete, storagePathBuilder, multipleFilesSupported, resolvedStorageSource } = useStorageUploadController({
		entityValues: context.values,
		entityId: context.entityId,
		path: context.path,
		property,
		propertyKey,
		value,
		storageSource,
		disabled: disabled ?? false,
		onChange: setValue
	});
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		!minimalistView && !hideLabel && /* @__PURE__ */ jsx(LabelWithIcon, {
			propertyKey,
			icon: getIconForProperty(property, "small"),
			required: property.validation?.required,
			title: property.name ?? propertyKey,
			className: "h-8 text-text-secondary dark:text-text-secondary-dark ml-3.5"
		}),
		/* @__PURE__ */ jsx(StorageSourceContext.Provider, {
			value: resolvedStorageSource,
			children: /* @__PURE__ */ jsx(StorageUpload, {
				value: internalValue,
				name: propertyKey,
				disabled: disabled ?? false,
				autoFocus: autoFocus ?? false,
				property,
				onChange: setValue,
				setInternalValue,
				onFilesAdded,
				onFileUploadComplete,
				storagePathBuilder,
				storage,
				multipleFilesSupported
			})
		}),
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError,
			error,
			disabled,
			property
		})
	] });
}
function SortableStorageItem({ id, entry, property, metadata, storagePathBuilder, onFileUploadComplete, onClear, disabled }) {
	const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		zIndex: isDragging ? 100 : void 0
	};
	const getImageSizeNumber = (previewSize) => {
		switch (previewSize) {
			case "small": return 40;
			case "medium": return 118;
			case "large": return 220;
			default: return 118;
		}
	};
	let child;
	if (entry.storagePathOrDownloadUrl) child = /* @__PURE__ */ jsx(StorageItemPreview, {
		name: `storage_preview_${entry.storagePathOrDownloadUrl}`,
		property,
		disabled,
		value: entry.storagePathOrDownloadUrl,
		onRemove: () => onClear(entry.storagePathOrDownloadUrl),
		size: entry.size
	});
	else if (entry.file) child = /* @__PURE__ */ jsx(StorageUploadProgress, {
		entry,
		metadata,
		storagePath: storagePathBuilder(entry.file),
		onFileUploadComplete,
		imageSize: getImageSizeNumber(entry.size),
		simple: false
	});
	return /* @__PURE__ */ jsx("div", {
		ref: setNodeRef,
		style,
		...attributes,
		...listeners,
		className: cls("rounded-md shrink-0"),
		tabIndex: -1,
		children: child
	});
}
function FileDropComponent({ storage, disabled, onFilesAdded, multipleFilesSupported, autoFocus, internalValue, property, onClear, metadata, storagePathBuilder, onFileUploadComplete, name, helpText, isDndItemDragging }) {
	const snackbarContext = useSnackbarController();
	const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
		accept: storage.acceptedFiles ? storage.acceptedFiles.reduce((acc, ext) => ({
			...acc,
			[ext]: []
		}), {}) : void 0,
		disabled: disabled || isDndItemDragging,
		multiple: multipleFilesSupported,
		noDragEventsBubbling: true,
		maxSize: storage.maxSize,
		onDrop: onFilesAdded,
		onDropRejected: (fileRejections) => {
			for (const fileRejection of fileRejections) for (const error of fileRejection.errors) {
				console.error("Error uploading file: ", error);
				if (error.code === "file-too-large") snackbarContext.open({
					type: "error",
					message: `Error uploading file: File is larger than ${storage.maxSize} bytes`
				});
				else if (error.code === "file-invalid-type") snackbarContext.open({
					type: "error",
					message: "Error uploading file: File type is not supported"
				});
			}
		}
	});
	return /* @__PURE__ */ jsxs("div", {
		...getRootProps(),
		className: cls(fieldBackgroundMixin, disabled ? fieldBackgroundDisabledMixin : fieldBackgroundHoverMixin, disabled ? "text-surface-accent-600 dark:text-surface-accent-500" : "", dropZoneClasses, multipleFilesSupported && internalValue.length ? "" : "flex", {
			[nonActiveDropClasses]: !isDragActive,
			[activeDropClasses]: isDragActive,
			[rejectDropClasses]: isDragReject,
			[acceptDropClasses]: isDragAccept,
			[disabledClasses]: disabled || isDndItemDragging
		}),
		children: [/* @__PURE__ */ jsxs("div", {
			className: cls("flex items-center gap-2 p-1 px-3 no-scrollbar", multipleFilesSupported && internalValue.length ? "overflow-x-auto overflow-y-hidden" : "", "h-[126px]"),
			children: [/* @__PURE__ */ jsx("input", {
				autoFocus,
				...getInputProps()
			}), internalValue.map((entry) => /* @__PURE__ */ jsx(SortableStorageItem, {
				id: entry.id,
				entry,
				property,
				name,
				metadata,
				storagePathBuilder,
				onFileUploadComplete,
				onClear,
				disabled,
				isSortable: multipleFilesSupported
			}, entry.id))]
		}), /* @__PURE__ */ jsx("div", {
			className: "box-border mx-3 mb-2.5 h-[34px] flex items-center justify-center text-center",
			children: /* @__PURE__ */ jsx(Typography, {
				align: "center",
				variant: "caption",
				className: disabled ? "text-surface-accent-600 dark:text-surface-accent-500" : "",
				children: helpText
			})
		})]
	});
}
function StorageUpload({ property, name, value, setInternalValue, onChange, multipleFilesSupported, onFileUploadComplete, disabled, onFilesAdded, autoFocus, storage, storagePathBuilder }) {
	if (multipleFilesSupported) {
		const arrayProperty = property;
		if (arrayProperty.of) {
			if (Array.isArray(arrayProperty.of)) throw Error("Storage field using array must be of data type string");
			if (arrayProperty.of.type !== "string") throw Error("Storage field using array must be of data type string");
		} else throw Error("Storage field using array must be of data type string");
	}
	const metadata = storage?.metadata;
	const [isDndItemDragging, setIsDndItemDragging] = useState(false);
	const moveItem = useCallback((fromIndex, toIndex) => {
		if (!multipleFilesSupported || fromIndex === toIndex) return;
		const newValue = [...value];
		const item = newValue[fromIndex];
		newValue.splice(fromIndex, 1);
		newValue.splice(toIndex, 0, item);
		setInternalValue(newValue);
		onChange(newValue.filter((e) => !!e.storagePathOrDownloadUrl).map((e) => e.storagePathOrDownloadUrl));
	}, [
		multipleFilesSupported,
		onChange,
		setInternalValue,
		value
	]);
	const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }), useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }));
	const handleDragStart = useCallback((event) => {
		setIsDndItemDragging(true);
	}, []);
	const handleDragEnd = useCallback((event) => {
		setIsDndItemDragging(false);
		const { active, over } = event;
		if (over && active.id !== over.id) {
			const oldIndex = value.findIndex((item) => item.id === active.id);
			const newIndex = value.findIndex((item) => item.id === over.id);
			if (oldIndex !== -1 && newIndex !== -1) moveItem(oldIndex, newIndex);
		}
	}, [value, moveItem]);
	const onClear = useCallback((clearedStoragePathOrDownloadUrl) => {
		let newValue;
		if (multipleFilesSupported) {
			newValue = value.filter((v) => v.storagePathOrDownloadUrl !== clearedStoragePathOrDownloadUrl);
			onChange(newValue.filter((v) => !!v.storagePathOrDownloadUrl).map((v) => v.storagePathOrDownloadUrl));
		} else {
			newValue = [];
			onChange(null);
		}
		setInternalValue(newValue);
	}, [
		value,
		multipleFilesSupported,
		onChange,
		setInternalValue
	]);
	const { t } = useTranslation();
	const helpText = multipleFilesSupported ? t("drag_drop_multiple") : t("drag_drop_single");
	const fileDropProps = {
		storage,
		disabled,
		onFilesAdded,
		multipleFilesSupported,
		autoFocus,
		internalValue: value,
		property: multipleFilesSupported ? property.of : property,
		onClear,
		metadata,
		storagePathBuilder,
		onFileUploadComplete,
		name,
		helpText,
		isDndItemDragging
	};
	if (multipleFilesSupported) return /* @__PURE__ */ jsx(DndContext, {
		sensors,
		collisionDetection: closestCenter,
		onDragStart: handleDragStart,
		onDragEnd: handleDragEnd,
		children: /* @__PURE__ */ jsx(SortableContext, {
			items: (value ?? []).map((v) => v.id),
			strategy: horizontalListSortingStrategy,
			children: /* @__PURE__ */ jsx(FileDropComponent, { ...fileDropProps })
		})
	});
	else return /* @__PURE__ */ jsx(FileDropComponent, {
		...fileDropProps,
		isDndItemDragging: false
	});
}
//#endregion
//#region src/form/field_bindings/SwitchFieldBinding.tsx
/**
* Simple boolean switch biding to a boolean property.
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
var SwitchFieldBinding = function SwitchFieldBinding({ propertyKey, value, setValue, error, showError, autoFocus, disabled, size = "large", property, includeDescription, hideLabel }) {
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(BooleanSwitchWithLabel, {
		value,
		onValueChange: (v) => setValue(v),
		error: showError,
		position: hideLabel ? "start" : void 0,
		label: hideLabel ? void 0 : /* @__PURE__ */ jsx(LabelWithIcon, {
			icon: getIconForProperty(property, "small"),
			required: property.validation?.required,
			title: property.name ?? propertyKey
		}),
		disabled,
		autoFocus,
		size
	}), /* @__PURE__ */ jsx(FieldHelperText, {
		includeDescription,
		showError,
		error,
		disabled,
		property
	})] });
};
//#endregion
//#region src/form/field_bindings/TextFieldBinding.tsx
/**
* Generic text field.
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function TextFieldBinding({ propertyKey, value, setValue, error, showError, disabled, autoFocus, property, includeDescription, hideLabel, size = "large" }) {
	let multiline;
	let url;
	if (property.type === "string") {
		multiline = property.admin?.multiline;
		url = property.admin?.urlPreview ?? property.url;
	}
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	const displayValue = value !== void 0 && value !== null ? String(value) : "";
	const handleClearClick = useCallback((e) => {
		e.stopPropagation();
		e.preventDefault();
		setValue(null);
	}, [setValue]);
	const onChange = (event) => {
		if (inputType === "number") {
			const numberValue = event.target.value ? parseFloat(event.target.value) : void 0;
			if (numberValue && isNaN(numberValue)) setValue(null);
			else if (numberValue !== void 0 && numberValue !== null) setValue(numberValue);
			else setValue(null);
		} else setValue(event.target.value);
	};
	const isMultiline = Boolean(multiline);
	let inputType = void 0;
	if (property.type === "number") inputType = "number";
	else if (property.type === "string") {
		if (property.email) inputType = "email";
		else if (property.admin?.urlPreview || property.url) inputType = "url";
	}
	const label = hideLabel ? void 0 : /* @__PURE__ */ jsx(LabelWithIcon, {
		icon: getIconForProperty(property, "small"),
		required: property.validation?.required || property.isId === true,
		title: property.name ?? propertyKey
	});
	const accessibleName = property.name ?? propertyKey;
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		isMultiline ? /* @__PURE__ */ jsxs("div", {
			className: cls("rounded-md relative max-w-full min-h-[64px]", fieldBackgroundMixin, fieldBackgroundHoverMixin, showError && error ? "border border-red-500 dark:border-red-600" : ""),
			children: [
				label && /* @__PURE__ */ jsx("div", {
					className: "pointer-events-none absolute top-1 text-xs font-medium px-3 text-text-secondary dark:text-text-secondary-dark",
					children: label
				}),
				/* @__PURE__ */ jsx(TextareaAutosize, {
					value: displayValue,
					onChange,
					autoFocus,
					disabled,
					"aria-label": accessibleName,
					className: cls("rounded-md resize-none w-full outline-none text-sm bg-transparent min-h-[64px] px-3", label ? "pt-8 pb-2" : "py-2", disabled && "outline-none opacity-50 text-surface-accent-600 dark:text-surface-accent-500", showError && error ? "text-red-500 dark:text-red-600" : "")
				}),
				property.admin?.clearable && /* @__PURE__ */ jsx("div", {
					className: "flex flex-row justify-center items-center absolute h-full right-0 top-0 mr-4",
					children: /* @__PURE__ */ jsx(IconButton, {
						onClick: handleClearClick,
						children: /* @__PURE__ */ jsx(XIcon, {})
					})
				})
			]
		}) : /* @__PURE__ */ jsx(TextField, {
			size,
			value: displayValue,
			onChange,
			autoFocus,
			label,
			"aria-label": label ? void 0 : accessibleName,
			type: inputType,
			disabled,
			endAdornment: property.admin?.clearable && /* @__PURE__ */ jsx(IconButton, {
				onClick: handleClearClick,
				children: /* @__PURE__ */ jsx(XIcon, {})
			}),
			error: showError ? !!error : void 0,
			inputClassName: error ? "text-red-500 dark:text-red-600" : ""
		}),
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError,
			error,
			disabled,
			property
		}),
		url && /* @__PURE__ */ jsx(Collapse, {
			className: "mt-1 ml-1",
			in: Boolean(value),
			children: /* @__PURE__ */ jsx(PropertyPreview, {
				value,
				property,
				size
			})
		})
	] });
}
//#endregion
//#region src/form/field_bindings/VectorFieldBinding.tsx
/**
* Custom field binding to render vector fields (e.g. for high-dimensional embeddings).
* Shows a compact metadata card by default, and lets users expand values or edit them.
*
* Automatically parses inputs to number arrays and packages them into the canonical
* Vector object structure expected by Rebase driver.
* @group Form fields
*/
function VectorFieldBinding({ propertyKey, value, setValue, error, showError, disabled, autoFocus, property, includeDescription, hideLabel, size = "large" }) {
	const isVectorObject = (val) => {
		return typeof val === "object" && val !== null && "value" in val;
	};
	const arrayValue = isVectorObject(value) ? value.value : Array.isArray(value) ? value : [];
	const [textValue, setTextValue] = useState(() => arrayValue.join(", "));
	const [isEditing, setIsEditing] = useState(false);
	const [showValues, setShowValues] = useState(false);
	useEffect(() => {
		setTextValue(arrayValue.join(", "));
	}, [JSON.stringify(arrayValue)]);
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	const handleClearClick = useCallback((e) => {
		e.stopPropagation();
		e.preventDefault();
		setValue(null);
		setTextValue("");
	}, [setValue]);
	const onChange = (event) => {
		const raw = event.target.value;
		setTextValue(raw);
		setValue({
			__type: "Vector",
			value: raw.split(",").map((str) => str.trim()).filter((str) => str !== "").map(Number)
		});
	};
	const label = hideLabel ? null : /* @__PURE__ */ jsx(LabelWithIcon, {
		icon: getIconForProperty(property, "small"),
		required: property.validation?.required,
		title: property.name ?? propertyKey
	});
	const isPopulated = arrayValue.length > 0;
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col gap-2 w-full",
		children: [
			label && /* @__PURE__ */ jsx("div", {
				className: "flex items-center justify-between mb-1",
				children: label
			}),
			/* @__PURE__ */ jsx("div", {
				className: "w-full",
				children: !isEditing ? /* @__PURE__ */ jsxs("div", {
					className: cls("flex flex-col gap-3 p-4 rounded-xl border bg-surface-field transition-all duration-200", defaultBorderMixin),
					children: [/* @__PURE__ */ jsxs("div", {
						className: "flex items-center justify-between flex-wrap gap-2",
						children: [/* @__PURE__ */ jsxs("div", {
							className: "flex items-center gap-2.5",
							children: [
								/* @__PURE__ */ jsx("div", { className: `w-2.5 h-2.5 rounded-full ${isPopulated ? "bg-emerald-500 animate-pulse" : "bg-surface-300 dark:bg-surface-600"}` }),
								/* @__PURE__ */ jsx("span", {
									className: "text-sm font-semibold text-text-primary dark:text-text-primary-dark",
									children: isPopulated ? `${arrayValue.length} Dimensions` : "Empty Vector"
								}),
								isPopulated && /* @__PURE__ */ jsx("span", {
									className: "text-xs text-text-secondary dark:text-text-secondary-dark px-2 py-0.5 rounded-full bg-surface-raised font-medium",
									children: "Embedding"
								})
							]
						}), /* @__PURE__ */ jsxs("div", {
							className: "flex items-center gap-2",
							children: [
								isPopulated && /* @__PURE__ */ jsx(Button, {
									variant: "text",
									size: "small",
									onClick: () => setShowValues(!showValues),
									startIcon: showValues ? /* @__PURE__ */ jsx(EyeOffIcon, { size: 14 }) : /* @__PURE__ */ jsx(EyeIcon, { size: 14 }),
									children: showValues ? "Hide values" : "Show values"
								}),
								!disabled && /* @__PURE__ */ jsx(Button, {
									variant: "outlined",
									size: "small",
									onClick: () => setIsEditing(true),
									startIcon: /* @__PURE__ */ jsx(PencilIcon, { size: 14 }),
									children: isPopulated ? "Edit values" : "Add values"
								}),
								isPopulated && !disabled && /* @__PURE__ */ jsx(IconButton, {
									size: "small",
									onClick: handleClearClick,
									className: "text-text-secondary hover:text-red-500",
									children: /* @__PURE__ */ jsx(Trash2Icon, { size: 14 })
								})
							]
						})]
					}), showValues && isPopulated && /* @__PURE__ */ jsx("div", {
						className: "mt-1 p-3 rounded-lg bg-surface-well border border-hairline max-h-36 overflow-y-auto font-mono text-[11px] leading-relaxed text-text-secondary dark:text-text-secondary-dark break-all selection:bg-primary/20",
						children: arrayValue.join(", ")
					})]
				}) : /* @__PURE__ */ jsxs("div", {
					className: cls("flex flex-col gap-2 p-4 rounded-xl border bg-surface-field", defaultBorderMixin),
					children: [/* @__PURE__ */ jsx(TextField, {
						size,
						"aria-label": `${property.name ?? propertyKey} vector values`,
						value: textValue,
						onChange,
						autoFocus: true,
						placeholder: `e.g., 0.15, -0.42, 0.88 (Requires ${property.dimensions} dimensions)`,
						disabled,
						error: showError ? !!error : void 0,
						inputClassName: error ? "text-red-500 dark:text-red-600 font-mono text-xs" : "font-mono text-xs"
					}), /* @__PURE__ */ jsxs("div", {
						className: "flex justify-end gap-2 mt-2",
						children: [/* @__PURE__ */ jsx(Button, {
							variant: "outlined",
							size: "small",
							onClick: () => setIsEditing(false),
							children: "Cancel"
						}), /* @__PURE__ */ jsx(Button, {
							variant: "filled",
							size: "small",
							onClick: () => setIsEditing(false),
							startIcon: /* @__PURE__ */ jsx(CheckIcon, { size: 14 }),
							children: "Done"
						})]
					})]
				})
			}),
			/* @__PURE__ */ jsx(FieldHelperText, {
				includeDescription,
				showError,
				error,
				disabled,
				property
			})
		]
	});
}
//#endregion
//#region src/form/field_bindings/GeopointFieldBinding.tsx
/** Latitude runs −90…90, longitude −180…180. Anything else is not a place. */
var LAT_RANGE = [-90, 90];
var LNG_RANGE = [-180, 180];
/**
* Read whatever the driver handed us as a pair of coordinates.
*
* A geopoint arrives as a `GeoPoint` instance from the client, but as a plain
* object once it has been through JSON — and PostGIS-backed rows may present it
* as `{ x, y }`, where `x` is the longitude. Reading only one of those shapes
* would render an empty field over data that is actually there.
*/
function readCoordinates(value) {
	if (!value || typeof value !== "object") return null;
	const v = value;
	const lat = typeof v.latitude === "number" ? v.latitude : typeof v.y === "number" ? v.y : void 0;
	const lng = typeof v.longitude === "number" ? v.longitude : typeof v.x === "number" ? v.x : void 0;
	if (typeof lat !== "number" || typeof lng !== "number") return null;
	return {
		latitude: lat,
		longitude: lng
	};
}
var inRange = (n, [min, max]) => n >= min && n <= max;
/**
* Field binding for `type: "geopoint"`.
*
* The model has defined this type all along and the admin had no way to render
* it: the widget lookup fell off the end of its chain, logged to the console
* and returned undefined, so the field simply did not appear on the form. A
* geopoint column was invisible in the admin panel, and unreachable in the
* property editor.
*
* Two number inputs rather than a map. A map needs a tile provider, which means
* a network dependency and an API key, and neither belongs in a field binding
* that has to work offline and in every deployment. Coordinates are typed,
* pasted and copied far more often than they are dropped on a map.
*
* @group Form fields
*/
function GeopointFieldBinding({ propertyKey, value, setValue, error, showError, disabled, autoFocus, property, includeDescription, hideLabel, size = "large" }) {
	const coordinates = readCoordinates(value);
	const [latText, setLatText] = useState(() => coordinates ? String(coordinates.latitude) : "");
	const [lngText, setLngText] = useState(() => coordinates ? String(coordinates.longitude) : "");
	useEffect(() => {
		const next = readCoordinates(value);
		setLatText(next ? String(next.latitude) : "");
		setLngText(next ? String(next.longitude) : "");
	}, [coordinates?.latitude, coordinates?.longitude]);
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	const commit = useCallback((rawLat, rawLng) => {
		if (rawLat.trim() === "" && rawLng.trim() === "") {
			setValue(null);
			return;
		}
		if (rawLat.trim() === "" || rawLng.trim() === "") return;
		const latitude = Number(rawLat);
		const longitude = Number(rawLng);
		if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return;
		setValue({
			latitude,
			longitude
		});
	}, [setValue]);
	const handleClear = useCallback((e) => {
		e.stopPropagation();
		e.preventDefault();
		setLatText("");
		setLngText("");
		setValue(null);
	}, [setValue]);
	const latNumber = Number(latText);
	const lngNumber = Number(lngText);
	const latInvalid = latText.trim() !== "" && (!Number.isFinite(latNumber) || !inRange(latNumber, LAT_RANGE));
	const lngInvalid = lngText.trim() !== "" && (!Number.isFinite(lngNumber) || !inRange(lngNumber, LNG_RANGE));
	const halfEntered = latText.trim() === "" !== (lngText.trim() === "");
	const localError = latInvalid ? `Latitude must be between ${LAT_RANGE[0]} and ${LAT_RANGE[1]}` : lngInvalid ? `Longitude must be between ${LNG_RANGE[0]} and ${LNG_RANGE[1]}` : halfEntered ? "A location needs both a latitude and a longitude" : void 0;
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col gap-2 w-full",
		children: [
			!hideLabel && /* @__PURE__ */ jsx("div", {
				className: "flex items-center justify-between mb-1",
				children: /* @__PURE__ */ jsx(LabelWithIcon, {
					icon: getIconForProperty(property, "small"),
					required: property.validation?.required,
					title: property.name ?? propertyKey
				})
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "flex gap-4 w-full items-center",
				children: [
					/* @__PURE__ */ jsx(TextField, {
						className: "flex-1",
						size,
						label: "Latitude",
						value: latText,
						autoFocus,
						disabled,
						error: showError ? Boolean(error) || latInvalid : latInvalid,
						onChange: (e) => {
							setLatText(e.target.value);
							commit(e.target.value, lngText);
						},
						placeholder: "e.g. 41.3874",
						inputClassName: "font-mono"
					}),
					/* @__PURE__ */ jsx(TextField, {
						className: "flex-1",
						size,
						label: "Longitude",
						value: lngText,
						disabled,
						error: showError ? Boolean(error) || lngInvalid : lngInvalid,
						onChange: (e) => {
							setLngText(e.target.value);
							commit(latText, e.target.value);
						},
						placeholder: "e.g. 2.1686",
						inputClassName: "font-mono"
					}),
					!disabled && (latText || lngText) && /* @__PURE__ */ jsx(IconButton, {
						size: "small",
						onClick: handleClear,
						className: "shrink-0 text-text-secondary hover:text-red-500",
						"aria-label": "Clear location",
						children: /* @__PURE__ */ jsx(Trash2Icon, { size: 14 })
					})
				]
			}),
			/* @__PURE__ */ jsx(FieldHelperText, {
				includeDescription,
				showError: showError || Boolean(localError),
				error: error || localError,
				disabled,
				property
			})
		]
	});
}
//#endregion
//#region src/form/field_bindings/BinaryFieldBinding.tsx
/** Base64, optionally padded. Empty is allowed — that is a cleared field. */
var BASE64 = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
/** Decoded byte count of a base64 string, without decoding it. */
function decodedBytes(base64) {
	const clean = base64.replace(/\s/g, "");
	if (!clean) return 0;
	const padding = clean.endsWith("==") ? 2 : clean.endsWith("=") ? 1 : 0;
	return Math.max(0, clean.length * 3 / 4 - padding);
}
function humanSize(bytes) {
	if (bytes < 1024) return `${bytes} B`;
	if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
	return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
/**
* Field binding for `type: "binary"`, whose value is a base64-encoded string.
*
* Before this there was no binary field. The widget lookup mapped the type
* straight to `text_field`, so a binary column rendered as an ordinary string
* input — offering multiline, markdown and email options that mean nothing for
* bytes, and, worse, pushing the property through a widget whose editor merges
* `type: "string"`. Opening a binary property and touching its widget silently
* changed its type.
*
* Shown collapsed by default. Base64 is long, unreadable and never worth
* scrolling past to reach the next field; what a person actually wants to know
* is whether there is anything in there and how big it is.
*
* @group Form fields
*/
function BinaryFieldBinding({ propertyKey, value, setValue, error, showError, disabled, autoFocus, property, includeDescription, hideLabel, size = "large" }) {
	const [text, setText] = useState(typeof value === "string" ? value : "");
	const [isEditing, setIsEditing] = useState(false);
	useEffect(() => {
		setText(typeof value === "string" ? value : "");
	}, [value]);
	useClearRestoreValue({
		property,
		value,
		setValue
	});
	const handleClear = useCallback((e) => {
		e.stopPropagation();
		e.preventDefault();
		setText("");
		setValue(null);
	}, [setValue]);
	const onChange = useCallback((e) => {
		const raw = e.target.value;
		setText(raw);
		setValue(raw === "" ? null : raw);
	}, [setValue]);
	const malformed = text.trim() !== "" && !BASE64.test(text.replace(/\s/g, ""));
	const bytes = malformed ? 0 : decodedBytes(text);
	const isPopulated = text.trim() !== "";
	const localError = malformed ? "Not valid base64" : void 0;
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col gap-2 w-full",
		children: [
			!hideLabel && /* @__PURE__ */ jsx("div", {
				className: "flex items-center justify-between mb-1",
				children: /* @__PURE__ */ jsx(LabelWithIcon, {
					icon: getIconForProperty(property, "small"),
					required: property.validation?.required,
					title: property.name ?? propertyKey
				})
			}),
			/* @__PURE__ */ jsx("div", {
				className: "w-full",
				children: !isEditing ? /* @__PURE__ */ jsxs("div", {
					className: cls("flex items-center justify-between gap-2 p-4 rounded-xl border bg-surface-field", defaultBorderMixin),
					children: [/* @__PURE__ */ jsxs("div", {
						className: "flex items-center gap-2.5 min-w-0",
						children: [/* @__PURE__ */ jsx("div", { className: `w-2.5 h-2.5 rounded-full shrink-0 ${isPopulated ? "bg-emerald-500" : "bg-surface-300 dark:bg-surface-600"}` }), /* @__PURE__ */ jsx("span", {
							className: "text-sm font-semibold text-text-primary truncate",
							children: malformed ? "Invalid base64" : isPopulated ? `${humanSize(bytes)} of binary data` : "Empty"
						})]
					}), /* @__PURE__ */ jsxs("div", {
						className: "flex items-center gap-2 shrink-0",
						children: [!disabled && /* @__PURE__ */ jsx(Button, {
							variant: "outlined",
							size: "small",
							onClick: () => setIsEditing(true),
							startIcon: /* @__PURE__ */ jsx(PencilIcon, { size: 14 }),
							children: isPopulated ? "Edit base64" : "Add base64"
						}), isPopulated && !disabled && /* @__PURE__ */ jsx(IconButton, {
							size: "small",
							onClick: handleClear,
							className: "text-text-secondary hover:text-red-500",
							"aria-label": "Clear binary value",
							children: /* @__PURE__ */ jsx(Trash2Icon, { size: 14 })
						})]
					})]
				}) : /* @__PURE__ */ jsxs("div", {
					className: cls("flex flex-col gap-2 p-4 rounded-xl border", defaultBorderMixin),
					children: [/* @__PURE__ */ jsx(TextField, {
						size,
						"aria-label": `${property.name ?? propertyKey} base64 value`,
						value: text,
						onChange,
						autoFocus: autoFocus ?? true,
						multiline: true,
						minRows: 4,
						disabled,
						placeholder: "Base64-encoded bytes, e.g. iVBORw0KGgo…",
						error: showError ? Boolean(error) || malformed : malformed,
						inputClassName: `font-mono text-xs ${malformed ? "text-red-500" : ""}`
					}), /* @__PURE__ */ jsx("div", {
						className: "flex justify-end",
						children: /* @__PURE__ */ jsx(Button, {
							variant: "filled",
							size: "small",
							onClick: () => setIsEditing(false),
							startIcon: /* @__PURE__ */ jsx(CheckIcon, { size: 14 }),
							children: "Done"
						})
					})]
				})
			}),
			/* @__PURE__ */ jsx(FieldHelperText, {
				includeDescription,
				showError: showError || malformed,
				error: error || localError,
				disabled,
				property
			})
		]
	});
}
//#endregion
//#region src/form/field_bindings/MultipleRelationFieldBinding.tsx
/**
* This field allows selecting multiple references.
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function MultipleRelationFieldBinding({ propertyKey, value: valueProp, error, showError, disabled, isSubmitting, property, includeDescription, setValue, setFieldValue, context }) {
	const value = Array.isArray(valueProp) ? valueProp : [];
	const { t } = useTranslation();
	if (property.type !== "relation") throw Error("RelationFieldBinding expected a property containing a relation");
	const parentCollection = context.collection;
	const capabilities = parentCollection ? getDataSourceCapabilities(parentCollection.engine) : void 0;
	if (!parentCollection || !capabilities?.supportsRelations) throw Error("MultipleRelationFieldBinding expected a collection whose engine supports relations");
	const relation = resolveRelationProperty(property, parentCollection, propertyKey);
	if (!relation) throw Error("Property relation is required for MultipleRelationFieldBinding");
	const selectedEntityIds = value && Array.isArray(value) ? value.map((ref) => ref.id) : [];
	const collection = relation.target();
	const onMultipleEntitiesSelected = useCallback((entities) => {
		setValue(entities.map((e) => getRelationFrom(e)));
	}, [setValue]);
	const referenceDialogController = useSelectionDialog({
		multiselect: true,
		path: getCollectionDataPath(collection),
		collection,
		onMultipleEntitiesSelected,
		selectedEntityIds,
		fixedFilter: property.admin?.fixedFilter
	});
	const onEntryClick = (e) => {
		e.preventDefault();
		referenceDialogController.open();
	};
	const buildEntry = useCallback(({ index, internalId, storedProps, storeProps }) => {
		const entryValue = value && Array.isArray(value) && value.length > index ? value[index] : void 0;
		if (!entryValue) return /* @__PURE__ */ jsx("div", { children: "Internal ERROR" });
		return /* @__PURE__ */ jsx(RelationPreview, {
			previewProperties: property.admin?.previewProperties,
			size: "medium",
			onClick: onEntryClick,
			hover: !disabled,
			relation: entryValue,
			includeId: property.admin?.includeId,
			includeEntityLink: property.admin?.includeEntityLink
		}, internalId);
	}, [
		relation,
		property.admin?.previewProperties,
		value
	]);
	const title = /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(LabelWithIcon, {
		propertyKey,
		icon: getIconForProperty(property, "small"),
		required: property.validation?.required,
		title: property.name ?? propertyKey,
		className: "h-8 flex grow text-text-secondary dark:text-text-secondary-dark"
	}), Array.isArray(value) && /* @__PURE__ */ jsxs(Typography, {
		variant: "caption",
		className: "px-4",
		children: [
			"(",
			value.length,
			")"
		]
	})] });
	const body = /* @__PURE__ */ jsxs(Fragment, { children: [!collection && /* @__PURE__ */ jsx(ErrorView, { error: "The specified collection does not exist. Check console" }), collection && /* @__PURE__ */ jsxs("div", {
		className: "group",
		children: [/* @__PURE__ */ jsx(ArrayContainer, {
			droppableId: propertyKey,
			value,
			disabled: isSubmitting,
			buildEntry,
			canAddElements: false,
			addLabel: property.name ? t("add_reference_to", { name: property.name }) : t("add_reference"),
			newDefaultEntry: null,
			onValueChange: (value) => setFieldValue(propertyKey, value)
		}), /* @__PURE__ */ jsxs(Button, {
			className: "ml-3.5 my-4 justify-center text-left",
			variant: "text",
			color: "primary",
			disabled: isSubmitting,
			onClick: onEntryClick,
			children: [
				/* @__PURE__ */ jsx(PencilIcon, { size: 16 }),
				t("edit"),
				" ",
				property.name
			]
		})]
	})] });
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(ExpandablePanel, {
		titleClassName: fieldBackgroundMixin,
		innerClassName: cls("px-2 md:px-4 pb-2 md:pb-4 pt-1 md:pt-2", fieldBackgroundMixin),
		title,
		children: body
	}), /* @__PURE__ */ jsx(FieldHelperText, {
		includeDescription,
		showError,
		error,
		disabled,
		property
	})] });
}
//#endregion
//#region src/form/field_bindings/RelationFieldBinding.tsx
function RelationFieldBinding(props) {
	const { property, propertyKey, context } = props;
	if (property.type !== "relation") throw Error("RelationFieldBinding expected a property containing a relation");
	const collection = context.collection;
	const capabilities = collection ? getDataSourceCapabilities(collection.engine) : void 0;
	if (!collection || !capabilities?.supportsRelations) throw Error("RelationFieldBinding expected a collection whose engine supports relations");
	const relation = resolveRelationProperty(property, collection, propertyKey);
	const manyRelation = relation?.cardinality === "many";
	if ((property.admin?.widget ?? "select") === "select" && relation) return /* @__PURE__ */ jsx(RelationSelectorBinding, {
		...props,
		relation,
		manyRelation
	});
	if (manyRelation) return /* @__PURE__ */ jsx(MultipleRelationFieldBinding, { ...props });
	return /* @__PURE__ */ jsx(SingleRelationFieldBinding, {
		...props,
		relation
	});
}
function RelationSelectorBinding({ propertyKey, value, size, error, showError, disabled, isSubmitting, property, includeDescription, hideLabel, setValue, relation, manyRelation }) {
	const singleValue = (!manyRelation && value && !Array.isArray(value) ? normalizeToEntityRelation(value) : null) ?? null;
	const multipleValue = manyRelation && Array.isArray(value) ? value : [];
	const selectorSize = size;
	return /* @__PURE__ */ jsxs("div", {
		className: "",
		children: [
			!hideLabel && /* @__PURE__ */ jsx(LabelWithIcon, {
				propertyKey,
				icon: getIconForProperty(property, "small"),
				required: property.validation?.required,
				title: property.name ?? propertyKey,
				className: "h-8 text-text-secondary dark:text-text-secondary-dark ml-3.5"
			}),
			/* @__PURE__ */ jsx(RelationSelector, {
				relation,
				value: manyRelation ? multipleValue : singleValue,
				onValueChange: (newVal) => {
					if (manyRelation) setValue(Array.isArray(newVal) ? newVal : []);
					else setValue(!Array.isArray(newVal) ? newVal ?? null : null);
				},
				disabled: disabled || isSubmitting,
				fixedFilter: property.admin?.fixedFilter,
				size: selectorSize
			}),
			/* @__PURE__ */ jsx(FieldHelperText, {
				includeDescription,
				showError,
				error,
				disabled,
				property
			})
		]
	});
}
function SingleRelationFieldBinding({ propertyKey, value, size, error, showError, disabled, isSubmitting, property, includeDescription, hideLabel, setValue, relation }) {
	const normalizedValue = value && !Array.isArray(value) ? normalizeToEntityRelation(value) : null;
	const validValue = !!normalizedValue;
	const collection = relation?.target();
	if (!collection) throw Error(`Couldn't find the corresponding collection for the relation: ${propertyKey}`);
	const onSingleEntitySelected = useCallback((e) => {
		setValue(e ? getRelationFrom(e) : null);
	}, [setValue]);
	const referenceDialogController = useSelectionDialog({
		multiselect: false,
		path: getCollectionDataPath(collection),
		collection,
		onSingleEntitySelected,
		selectedEntityIds: validValue && normalizedValue ? [normalizedValue.id] : void 0,
		fixedFilter: property.admin?.fixedFilter
	});
	const onEntryClick = (e) => {
		e.preventDefault();
		referenceDialogController.open();
	};
	const usedRelation = Array.isArray(value) ? void 0 : normalizedValue ?? void 0;
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		!hideLabel && /* @__PURE__ */ jsx(LabelWithIcon, {
			propertyKey,
			icon: getIconForProperty(property, "small"),
			required: property.validation?.required,
			title: property.name ?? propertyKey,
			className: "h-8 text-text-secondary dark:text-text-secondary-dark ml-3.5"
		}),
		!collection && /* @__PURE__ */ jsx(ErrorView, { error: "The specified collection does not exist. Check console" }),
		collection && /* @__PURE__ */ jsxs(Fragment, { children: [usedRelation && /* @__PURE__ */ jsx(RelationPreview, {
			disabled: !usedRelation,
			previewProperties: property.admin?.previewProperties,
			hover: !disabled,
			size,
			onClick: disabled || isSubmitting ? void 0 : onEntryClick,
			relation: usedRelation,
			includeEntityLink: property.admin?.includeEntityLink,
			includeId: property.admin?.includeId
		}), !value && /* @__PURE__ */ jsx("div", {
			className: "justify-center text-left",
			children: /* @__PURE__ */ jsxs(EntityPreviewContainer, {
				className: cls("px-6 h-12 text-sm font-medium flex items-center gap-6", disabled || isSubmitting ? "text-surface-accent-500" : "cursor-pointer text-surface-accent-700 dark:text-surface-accent-300 hover:bg-surface-hover group-hover:bg-surface-hover"),
				onClick: onEntryClick,
				size: "medium",
				children: [/* @__PURE__ */ jsx(IconForView, {
					collectionOrView: collection,
					className: "text-surface-300 dark:text-surface-600"
				}), `Edit ${property.name}`.toUpperCase()]
			})
		})] }),
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError,
			error,
			disabled,
			property
		})
	] });
}
//#endregion
//#region src/form/field_bindings/UserSelectFieldBinding.tsx
/**
* Field binding for selecting a user from the internal user management system.
* Renders a searchable popover dropdown with user information including name and email,
* with server-side search and pagination support.
*
* This is one of the internal components that get mapped natively inside forms
* and tables to the specified properties.
* @group Form fields
*/
function UserSelectFieldBinding({ propertyKey, value, setValue, error, showError, disabled, autoFocus, touched, property, includeDescription, hideLabel, size = "large" }) {
	const selectorSize = size;
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		!hideLabel && /* @__PURE__ */ jsx(LabelWithIcon, {
			icon: getIconForProperty(property, "small"),
			required: property.validation?.required,
			title: property.name,
			propertyKey,
			className: "h-8 text-text-secondary dark:text-text-secondary-dark ml-3.5 my-0"
		}),
		/* @__PURE__ */ jsx(UserSelector, {
			value,
			onValueChange: (userId) => {
				setValue(userId);
			},
			disabled,
			clearable: property.admin?.clearable,
			size: selectorSize
		}),
		/* @__PURE__ */ jsx(FieldHelperText, {
			includeDescription,
			showError,
			error,
			disabled,
			property
		})
	] });
}
//#endregion
//#region src/components/field_configs.tsx
/**
* Every `Field` below is a getter on purpose — do not inline it back to
* `Field: SomeBinding`.
*
* This module and the field bindings form an import cycle: we import the
* bindings, the container bindings (map, repeat, block, custom-shaped array)
* import `PropertyFieldBinding` to render their children, and that imports
* `getFieldConfig` from here. Enter the cycle at a binding rather than here and
* this object is built while that binding's module is still initialising.
*
* As a plain value the binding would be read at that moment. It happens to
* survive today only because every binding is declared `export function`, which
* hoists; rewriting a single one as `export const` would make the read a
* temporal dead zone ReferenceError at import time, surfacing as a blank screen
* far from its cause. The getter defers the read to first access, long after
* every module has initialised, so declaration style stops mattering.
*/
var DEFAULT_FIELD_CONFIGS = {
	text_field: {
		key: "text_field",
		name: "Text field",
		description: "Simple short text",
		Icon: TextIcon,
		color: "#2d7ff9",
		property: {
			type: "string",
			admin: { get Field() {
				return TextFieldBinding;
			} }
		}
	},
	multiline: {
		key: "multiline",
		name: "Multiline",
		description: "Text with multiple lines",
		Icon: AlignLeftIcon,
		color: "#2d7ff9",
		property: {
			type: "string",
			admin: {
				multiline: true,
				get Field() {
					return TextFieldBinding;
				}
			}
		}
	},
	markdown: {
		key: "markdown",
		name: "Markdown",
		description: "Text with advanced markdown syntax",
		Icon: QuoteIcon,
		color: "#2d7ff9",
		property: {
			type: "string",
			admin: {
				markdown: true,
				get Field() {
					return MarkdownEditorFieldBinding;
				}
			}
		}
	},
	url: {
		key: "url",
		name: "Url",
		description: "Text with URL validation",
		Icon: GlobeIcon,
		color: "#154fb3",
		property: {
			type: "string",
			url: true,
			admin: { get Field() {
				return TextFieldBinding;
			} }
		}
	},
	email: {
		key: "email",
		name: "Email",
		description: "Text with email validation",
		Icon: MailIcon,
		color: "#154fb3",
		property: {
			type: "string",
			email: true,
			admin: { get Field() {
				return TextFieldBinding;
			} }
		}
	},
	switch: {
		key: "switch",
		name: "Switch",
		description: "Boolean true or false field (or yes or no, 0 or 1...)",
		Icon: FlagIcon,
		color: "#20d9d2",
		property: {
			type: "boolean",
			admin: { get Field() {
				return SwitchFieldBinding;
			} }
		}
	},
	select: {
		key: "select",
		name: "Select/enum",
		description: "Select one text value from within an enumeration",
		Icon: ListIcon,
		color: "#4223c9",
		property: {
			type: "string",
			enum: [],
			admin: { get Field() {
				return SelectFieldBinding;
			} }
		}
	},
	multi_select: {
		key: "multi_select",
		name: "Multi select (enum)",
		description: "Select multiple text values from within an enumeration",
		Icon: ListIcon,
		color: "#4223c9",
		property: {
			type: "array",
			of: {
				type: "string",
				enum: []
			},
			admin: { get Field() {
				return MultiSelectFieldBinding;
			} }
		}
	},
	user_select: {
		key: "user_select",
		name: "User select",
		description: "Select a user from the user management system. Store the user ID.",
		Icon: UserIcon,
		property: {
			type: "string",
			admin: { get Field() {
				return UserSelectFieldBinding;
			} }
		}
	},
	number_input: {
		key: "number_input",
		name: "Number input",
		description: "Simple number field with validation",
		Icon: HashIcon,
		color: "#bec920",
		property: {
			type: "number",
			admin: { get Field() {
				return TextFieldBinding;
			} }
		}
	},
	number_select: {
		key: "number_select",
		name: "Number select",
		description: "Select a number value from within an enumeration",
		Icon: ListOrderedIcon,
		color: "#bec920",
		property: {
			type: "number",
			enum: [],
			admin: { get Field() {
				return SelectFieldBinding;
			} }
		}
	},
	multi_number_select: {
		key: "multi_number_select",
		name: "Multiple number select",
		description: "Select multiple number values from within an enumeration",
		Icon: ListOrderedIcon,
		color: "#bec920",
		property: {
			type: "array",
			of: {
				type: "number",
				enum: []
			},
			admin: { get Field() {
				return MultiSelectFieldBinding;
			} }
		}
	},
	file_upload: {
		key: "file_upload",
		name: "File upload",
		description: "Input for uploading single files",
		Icon: UploadIcon,
		color: "#f92d9a",
		property: {
			type: "string",
			storage: { storagePath: "{path}" },
			admin: { get Field() {
				return StorageUploadFieldBinding;
			} }
		}
	},
	multi_file_upload: {
		key: "multi_file_upload",
		name: "Multiple file upload",
		description: "Input for uploading multiple files",
		Icon: FolderUpIcon,
		color: "#f92d9a",
		property: {
			type: "array",
			of: {
				type: "string",
				storage: { storagePath: "{path}" }
			},
			admin: { get Field() {
				return StorageUploadFieldBinding;
			} }
		}
	},
	reference: {
		key: "reference",
		name: "Reference",
		description: "The value refers to a different collection (it is saved as a reference)",
		Icon: LinkIcon,
		color: "#ff0042",
		property: {
			type: "reference",
			admin: { get Field() {
				return ReferenceFieldBinding;
			} }
		}
	},
	multi_references: {
		key: "multi_references",
		name: "Multiple references",
		description: "Multiple values that refer to a different collection",
		Icon: LinkIcon,
		color: "#ff0042",
		property: {
			type: "array",
			of: { type: "reference" },
			admin: { get Field() {
				return ArrayOfReferencesFieldBinding;
			} }
		}
	},
	relation: {
		key: "relation",
		name: "Relation",
		description: "Multiple values that refer to a different collection",
		Icon: LinkIcon,
		color: "#ff0042",
		property: {
			type: "relation",
			admin: { get Field() {
				return RelationFieldBinding;
			} }
		}
	},
	date_time: {
		key: "date_time",
		name: "Date/time",
		description: "A date time select field",
		Icon: CalendarIcon,
		color: "#8b46ff",
		property: {
			type: "date",
			admin: { get Field() {
				return DateTimeFieldBinding;
			} }
		}
	},
	group: {
		key: "group",
		name: "Group",
		description: "Group of multiple fields",
		Icon: VoteIcon,
		color: "#ff9408",
		property: {
			type: "map",
			properties: {},
			admin: { get Field() {
				return MapFieldBinding;
			} }
		}
	},
	key_value: {
		key: "key_value",
		name: "Key-value",
		description: "Flexible field that allows the user to add multiple key-value pairs",
		Icon: VoteIcon,
		color: "#ff9408",
		property: {
			type: "map",
			keyValue: true,
			admin: { get Field() {
				return KeyValueFieldBinding;
			} }
		}
	},
	repeat: {
		key: "repeat",
		name: "Repeat/list",
		description: "A field that gets repeated multiple times (e.g. multiple text fields)",
		Icon: RepeatIcon,
		color: "#ff9408",
		property: {
			type: "array",
			of: { type: "string" },
			admin: { get Field() {
				return RepeatFieldBinding;
			} }
		}
	},
	custom_array: {
		key: "custom_array",
		name: "Custom array",
		description: "A field that saved its value as an array of custom objects",
		Icon: RepeatIcon,
		color: "#ff9408",
		property: {
			type: "array",
			admin: { get Field() {
				return ArrayCustomShapedFieldBinding;
			} }
		}
	},
	block: {
		key: "block",
		name: "Block",
		description: "A complex field that allows the user to compose different fields together, with a key/value format",
		Icon: Rows3Icon,
		color: "#ff9408",
		property: {
			type: "array",
			oneOf: { properties: {} },
			admin: { get Field() {
				return BlockFieldBinding;
			} }
		}
	},
	vector_input: {
		key: "vector_input",
		name: "Vector input",
		description: "Vector array for embeddings",
		Icon: HashIcon,
		color: "#bec920",
		property: {
			type: "vector",
			dimensions: 1536,
			admin: { get Field() {
				return VectorFieldBinding;
			} }
		}
	},
	geopoint: {
		key: "geopoint",
		name: "Location",
		description: "A latitude and longitude",
		Icon: GlobeIcon,
		color: "#3f9e5c",
		property: {
			type: "geopoint",
			admin: { get Field() {
				return GeopointFieldBinding;
			} }
		}
	},
	binary: {
		key: "binary",
		name: "Binary",
		description: "Base64-encoded bytes",
		Icon: HashIcon,
		color: "#7a6ff0",
		property: {
			type: "binary",
			admin: { get Field() {
				return BinaryFieldBinding;
			} }
		}
	}
};
function getDefaultFieldConfig(property) {
	const fieldId = getDefaultFieldId(property);
	if (!fieldId) {
		console.error("No field id found for property", property);
		return;
	}
	return DEFAULT_FIELD_CONFIGS[fieldId];
}
function getFieldConfig(property, propertyConfigs) {
	const fieldId = getFieldId(property);
	const defaultFieldId = getDefaultFieldId(property);
	if (!defaultFieldId) {
		console.error("No field id found for property", property);
		return;
	}
	const defaultFieldConfig = defaultFieldId ? DEFAULT_FIELD_CONFIGS[defaultFieldId] : void 0;
	const customField = fieldId && propertyConfigs ? propertyConfigs[fieldId] : void 0;
	return mergeDeep(defaultFieldConfig ?? {}, customField ?? {});
}
function getDefaultFieldId(property) {
	if (property.type === "string") if (property.admin?.markdown) return "markdown";
	else if (property.admin?.multiline) return "multiline";
	else if (property.storage) return "file_upload";
	else if (property.admin?.urlPreview) return "url";
	else if (property.email) return "email";
	else if (property.enum) return "select";
	else if (property.userSelect) return "user_select";
	else return "text_field";
	else if (property.type === "number") {
		if (property.enum) return "number_select";
		return "number_input";
	} else if (property.type === "map") {
		if (property.keyValue) return "key_value";
		return "group";
	} else if (property.type === "array") {
		const of = property.of;
		if (property.oneOf) return "block";
		else if (Array.isArray(of)) return "custom_array";
		else if (isPropertyBuilder(of)) return "repeat";
		else if (of) {
			const ofProperty = of;
			if (ofProperty.type === "string" && ofProperty.enum) return "multi_select";
			else if (ofProperty.type === "number" && ofProperty.enum) return "multi_number_select";
			else if (ofProperty.type === "string" && ofProperty.storage) return "multi_file_upload";
			else if (ofProperty.type === "reference") return "multi_references";
			else if (of?.type === "relation") {
				console.error("A `relation` cannot go inside an array — a relation is a join, not a stored value. Use a `reference` for an array of links, or declare a to-many relation on the collection.", property);
				return;
			} else return "repeat";
		} else return "repeat";
	} else if (property.type === "boolean") return "switch";
	else if (property.type === "date") return "date_time";
	else if (property.type === "relation") return "relation";
	else if (property.type === "reference") return "reference";
	else if (property.type === "vector") return "vector_input";
	else if (property.type === "binary") return "binary";
	else if (property.type === "geopoint") return "geopoint";
	console.error("Unsupported field config mapping", property);
}
function getFieldId(property) {
	if (property.propertyConfig) return property.propertyConfig;
	return getDefaultFieldId(property);
}
//#endregion
//#region src/form/PropertyFieldBinding.tsx
/**
* This component renders a form field creating the corresponding configuration
* from a property. For example if bound to a string property, it will generate
* a text field.
*
* You can use it when you are creating a custom field, and need to
* render additional fields mapped to properties. This is useful if you
* need to build a complex property mapping, like an array where each index
* is a different property.
*
* Please note that if you build a custom field in a component, the
* **validation** passed in the property will have no effect. You need to set
* the validation in the `AdminCollection` definition.
*
* @param propertyKey You can use nested names such as `address.street` or `friends[2]`
* @param property
* @param context
* @param includeDescription
* @param underlyingValueHasChanged
* @param disabled
* @param tableMode
* @param partOfArray
* @param autoFocus
* @group Form custom fields
*/
var PropertyFieldBinding = React.memo(PropertyFieldBindingInternal, (a, b) => {
	if (a.propertyKey !== b.propertyKey) return false;
	if (a.index !== b.index) return false;
	if (a.size !== b.size) return false;
	if (!((isPropertyBuilder(a.property) === isPropertyBuilder(b.property) || deepEqual(a.property, b.property)) && a.disabled === b.disabled)) return false;
	if (shouldPropertyReRender(b.property)) return false;
	return false;
});
function PropertyFieldBindingInternal({ propertyKey, property, context, includeDescription, hideLabel, underlyingValueHasChanged, disabled: disabledProp, partOfArray, partOfBlock, minimalistView, autoFocus, index, size, onPropertyChange }) {
	const authController = useAuthController();
	const customizationController = useCustomizationController();
	return /* @__PURE__ */ jsx(Field, {
		name: propertyKey,
		children: (fieldProps) => {
			let Component;
			const resolvedProperty = resolveProperty({
				propertyKey,
				property,
				values: fieldProps.form.values,
				path: context.path,
				entityId: context.entityId,
				propertyConfigs: customizationController.propertyConfigs,
				index,
				authController
			});
			const readOnly = resolvedProperty ? isReadOnly(resolvedProperty) : true;
			const disabled = disabledProp || readOnly || (resolvedProperty ? isDisabled(resolvedProperty) : false) || context.disabled;
			if (resolvedProperty === null || isHidden(resolvedProperty)) return /* @__PURE__ */ jsx(Fragment, {});
			else if (readOnly) Component = ReadOnlyFieldBinding;
			else if (resolvedProperty.admin?.Field) {
				const resolved = resolveComponentRef(resolvedProperty.admin.Field);
				if (resolved) Component = resolved;
			} else {
				const propertyConfig = getFieldConfig(resolvedProperty, customizationController.propertyConfigs);
				if (!propertyConfig) throw new Error(`INTERNAL: Could not find field config for property ${propertyKey}`);
				Component = resolveComponentRef(resolveProperty({
					propertyKey,
					property: propertyConfig.property,
					values: fieldProps.form.values,
					path: context.path,
					entityId: context.entityId,
					propertyConfigs: customizationController.propertyConfigs,
					index,
					authController
				})?.admin?.Field);
			}
			if (!Component) {
				console.warn(`No field component found for property ${propertyKey}`);
				console.warn("Property:", property);
				return /* @__PURE__ */ jsx("div", {
					className: "w-full",
					children: `Currently the field ${resolvedProperty.type} is not supported`
				});
			}
			return /* @__PURE__ */ jsx(FieldInternal, {
				Component,
				componentProps: {
					propertyKey,
					property: resolvedProperty,
					includeDescription,
					hideLabel,
					underlyingValueHasChanged,
					context,
					disabled,
					partOfArray,
					partOfBlock,
					minimalistView,
					autoFocus,
					size,
					onPropertyChange
				},
				formexFieldProps: fieldProps
			});
		}
	}, propertyKey);
}
function FieldInternal({ Component, componentProps: { propertyKey, property, includeDescription, hideLabel, underlyingValueHasChanged, partOfArray, partOfBlock, minimalistView, autoFocus, context, disabled, size, onPropertyChange }, formexFieldProps }) {
	const { plugins } = useCustomizationController();
	const rebaseContext = useRebaseContext();
	const fieldSlotProps = React.useMemo(() => ({
		propertyKey,
		property,
		path: context.path ?? "",
		entityId: context.entityId,
		collection: context.collection,
		context: rebaseContext
	}), [
		propertyKey,
		property,
		context.path,
		context.entityId,
		context.collection,
		rebaseContext
	]);
	const beforeField = useSlot("entity.field.before", fieldSlotProps);
	const afterField = useSlot("entity.field.after", fieldSlotProps);
	const customFieldProps = property.admin?.customProps;
	const value = formexFieldProps.field.value;
	const error = getIn(formexFieldProps.form.errors, propertyKey);
	const touched = getIn(formexFieldProps.form.touched, propertyKey);
	const showError = Boolean(error && (formexFieldProps.form.submitCount > 0 || property.validation?.unique) && (!Array.isArray(error) || !!error.filter((e) => !!e).length));
	const UsedComponent = useWrappedComponent({
		path: context.path,
		collection: context.collection,
		propertyKey,
		property,
		Component,
		plugins
	}) ?? Component;
	const isSubmitting = formexFieldProps.form.isSubmitting;
	return /* @__PURE__ */ jsxs(ErrorBoundary, { children: [
		beforeField,
		/* @__PURE__ */ jsx(Suspense, {
			fallback: null,
			children: /* @__PURE__ */ jsx(UsedComponent, {
				propertyKey,
				value,
				setValue: useCallback((value, shouldValidate) => {
					formexFieldProps.form.setFieldTouched(propertyKey, true, false);
					formexFieldProps.form.setFieldValue(propertyKey, value, shouldValidate);
				}, []),
				setFieldValue: useCallback((otherPropertyKey, value, shouldValidate) => {
					formexFieldProps.form.setFieldTouched(propertyKey, true, false);
					formexFieldProps.form.setFieldValue(otherPropertyKey, value, shouldValidate);
				}, []),
				error,
				touched,
				showError,
				isSubmitting,
				includeDescription: includeDescription ?? true,
				hideLabel: hideLabel ?? false,
				property,
				disabled: disabled ?? false,
				underlyingValueHasChanged: underlyingValueHasChanged ?? false,
				partOfArray: partOfArray ?? false,
				partOfBlock: partOfBlock ?? false,
				minimalistView: minimalistView ?? false,
				autoFocus: autoFocus ?? false,
				customProps: customFieldProps,
				context,
				size,
				onPropertyChange
			})
		}),
		afterField,
		underlyingValueHasChanged && !isSubmitting && /* @__PURE__ */ jsx(Typography, {
			variant: "caption",
			className: "ml-3.5",
			children: "This value has been updated elsewhere"
		})
	] });
}
var shouldPropertyReRender = (property, plugins) => {
	if (plugins?.some((plugin) => plugin.fieldBuilder)) return true;
	if (isPropertyBuilder(property)) return true;
	const defAProperty = property;
	const rerenderThisProperty = Boolean(defAProperty.admin?.Field);
	if (defAProperty.type === "map" && defAProperty.properties) return Boolean(rerenderThisProperty || Object.values(defAProperty.properties).some((childProperty) => shouldPropertyReRender(childProperty, plugins)));
	else return Boolean(rerenderThisProperty);
};
function useWrappedComponent({ path, collection, propertyKey, property, Component, plugins }) {
	return useRef((() => {
		let Wrapper = null;
		if (plugins) plugins.forEach((plugin) => {
			const fieldId = getFieldId(property);
			if (fieldId && plugin.fieldBuilder) {
				const params = {
					fieldConfigId: fieldId,
					propertyKey,
					property,
					Field: Component,
					plugin,
					path,
					collection
				};
				const enabled = plugin.fieldBuilder.enabled?.(params);
				if (enabled === void 0 || enabled) Wrapper = plugin.fieldBuilder.wrap(params) ?? Wrapper;
			}
			if (!fieldId) console.warn("INTERNAL: Field id not found for property", property);
		});
		return Wrapper;
	})()).current;
}
//#endregion
//#region src/form/components/ErrorFocus.tsx
var ErrorFocus = ({ containerRef }) => {
	const { isValidating, errors, version } = useFormex();
	const prevVersion = useRef(version);
	useEffect(() => {
		if (version === prevVersion.current) return;
		const keys = Object.keys(errors);
		if (!isValidating && keys.length > 0) {
			const errorElement = containerRef?.current?.querySelector(`#form_field_${keys[0]}`);
			if (errorElement) {
				errorElement.scrollIntoView({
					behavior: "smooth",
					block: "center"
				});
				const input = errorElement.querySelector("input");
				if (input) input.focus();
			}
			prevVersion.current = version;
		}
	}, [
		isValidating,
		errors,
		containerRef,
		version
	]);
	return null;
};
//#endregion
//#region src/form/EntityFormActions.tsx
/**
* The form's own action bar.
*
* There used to be two variants: this one, and a `w-80 2xl:w-96` sticky rail
* holding the same two buttons above several hundred pixels of nothing — a
* fifth of a 1440px viewport reserved for a Save button. The rail is gone. When
* the container supplies its own actions (the entity view's identity bar does)
* it passes `showDefaultActions={false}`, and this renders only what the bar
* cannot host: the saving error, plugin actions, and collection form actions.
*/
function EntityFormActions({ path, collection, entity, savingError, formex, disabled, status, pluginActions, openEntityMode, navigateBack, formContext, showDefaultActions = true }) {
	return buildBottomActions({
		path,
		savingError,
		entity,
		collection,
		disabled,
		status,
		pluginActions,
		openEntityMode,
		navigateBack,
		formContext,
		formex,
		showDefaultActions
	});
}
function buildBottomActions({ savingError, entity, path, formActions, collection, disabled, status, pluginActions, openEntityMode, navigateBack, formContext, formex, showDefaultActions, className }) {
	const hasErrors = Object.keys(formex.errors).length > 0 && formex.submitCount > 0;
	const entityActions = entity ? formActions ?? [] : [];
	const hasPluginActions = Boolean(pluginActions && pluginActions.length > 0);
	if (!showDefaultActions && !savingError && !entityActions.length && !hasPluginActions) return null;
	return /* @__PURE__ */ jsxs(DialogActions, {
		position: "sticky",
		className,
		children: [
			savingError && /* @__PURE__ */ jsx("div", {
				className: "text-right",
				children: /* @__PURE__ */ jsx(Typography, {
					color: "error",
					children: savingError.message
				})
			}),
			entityActions.length > 0 && /* @__PURE__ */ jsx("div", {
				className: "grow flex overflow-auto no-scrollbar",
				children: entityActions.map((action) => /* @__PURE__ */ jsx(IconButton, {
					color: "primary",
					onClick: (event) => {
						event.stopPropagation();
						if (entity) action.onClick({
							view: "form",
							entity,
							path: path ?? getCollectionDataPath(collection),
							collection,
							context: void 0,
							sidePanelController: void 0,
							openEntityMode,
							navigateBack,
							formContext
						});
					},
					children: getIcon(action.icon, void 0, void 0, "smallest")
				}, action.name))
			}),
			pluginActions,
			showDefaultActions && /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(Button, {
				variant: "text",
				disabled: disabled || formex.isSubmitting,
				color: "primary",
				type: "reset",
				children: status === "existing" ? "Discard" : "Clear"
			}), /* @__PURE__ */ jsx(Tooltip, {
				title: hasErrors ? "Fix highlighted errors before saving" : void 0,
				children: /* @__PURE__ */ jsxs(LoadingButton, {
					variant: "filled",
					color: "primary",
					type: "submit",
					loading: formex.isSubmitting,
					disabled: disabled || formex.isSubmitting,
					startIcon: hasErrors ? /* @__PURE__ */ jsx(AlertCircleIcon, {}) : void 0,
					children: [
						status === "existing" && "Save",
						status === "copy" && "Create copy",
						status === "new" && "Create"
					]
				})
			})] })
		]
	});
}
//#endregion
//#region src/components/PropertyCollectionView.tsx
/**
* Build a readable label for a path and resolve the property
* Supports map and array (including arrays of maps)
*/
function buildPropertyLabelAndGetProperty(properties, key) {
	if (!key) return {
		label: "",
		property: void 0
	};
	const segments = [];
	const re = /([^[.\]]+)|\[(\d+)\]/g;
	let m;
	while ((m = re.exec(key)) !== null) if (m[1] !== void 0) segments.push(m[1]);
	else if (m[2] !== void 0) segments.push(Number(m[2]));
	let currentProps = properties;
	let currentProp;
	let lastLabel = "";
	const getArrayOfProp = (p) => {
		if (!p || p.type !== "array") return void 0;
		return Array.isArray(p.of) ? p.of[0] : p.of;
	};
	for (const seg of segments) {
		if (typeof seg === "number") {
			lastLabel = `[${seg}]`;
			if (currentProp?.type === "array") {
				currentProp = getArrayOfProp(currentProp);
				if (currentProp?.type === "map" && currentProp.properties) currentProps = currentProp.properties;
				else currentProps = void 0;
			} else {
				currentProp = void 0;
				currentProps = void 0;
			}
			continue;
		}
		if (currentProps && currentProps[seg]) {
			const nextProp = currentProps[seg];
			currentProp = nextProp;
			lastLabel = nextProp.name || String(seg);
			if (nextProp.type === "map" && nextProp.properties) currentProps = nextProp.properties;
			else if (nextProp.type === "array") currentProps = void 0;
			else currentProps = void 0;
		} else {
			currentProp = void 0;
			currentProps = void 0;
			lastLabel = String(seg);
		}
	}
	return {
		label: lastLabel,
		property: currentProp
	};
}
var pathEndsWithIndex = (p) => /\[\d+\]$/.test(p);
/**
* Improved simple layout for nested changes:
* - Map or Array-of-Map -> section header + indented rows
* - Leaf or Array-of-Primitives -> single row with label and value
*/
var PropertyCollectionView = ({ data, properties, baseKey = "", suppressHeader = false, size = "small" }) => {
	const isTopLevel = !!baseKey && !baseKey.includes(".") && !baseKey.includes("[");
	if (Array.isArray(data)) {
		const { label: arrayLabel, property } = baseKey ? buildPropertyLabelAndGetProperty(properties, baseKey) : {
			label: "",
			property: void 0
		};
		const ofProp = property?.type === "array" ? Array.isArray(property.of) ? property.of[0] : property.of : void 0;
		const isArrayOfMaps = ofProp?.type === "map";
		const isArrayOfPrimitives = property?.type === "array" && ofProp && ofProp.type !== "map";
		const isRelationArray = property?.type === "relation";
		if (baseKey && property && (isArrayOfPrimitives || isRelationArray)) return /* @__PURE__ */ jsxs("div", {
			className: `grid grid-cols-12 gap-x-4 ${isTopLevel ? "py-4" : "py-2"} items-start ${isTopLevel ? `border-b ${defaultBorderMixin} last:border-b-0` : ""}`,
			children: [/* @__PURE__ */ jsx("div", {
				className: "col-span-4 pr-2",
				children: /* @__PURE__ */ jsx(Typography, {
					variant: "caption",
					color: "secondary",
					component: "span",
					className: "break-words",
					children: arrayLabel
				})
			}), /* @__PURE__ */ jsx("div", {
				className: "col-span-8",
				children: /* @__PURE__ */ jsx(PropertyPreview, {
					propertyKey: baseKey,
					value: data,
					property,
					size
				})
			})]
		});
		return /* @__PURE__ */ jsxs("div", {
			className: `${isTopLevel ? "py-4" : "py-1"} ${isTopLevel ? `border-b ${defaultBorderMixin} last:border-b-0` : ""}`,
			children: [baseKey && arrayLabel && !suppressHeader && /* @__PURE__ */ jsx(Typography, {
				variant: "caption",
				color: "secondary",
				component: "span",
				children: arrayLabel
			}), /* @__PURE__ */ jsx("div", {
				className: baseKey ? `pl-4 mt-1 border-l ${defaultBorderMixin}` : "",
				children: data.map((item, index) => {
					if (item === null || item === void 0) return null;
					const currentKey = baseKey ? `${baseKey}[${index}]` : `[${index}]`;
					return /* @__PURE__ */ jsxs("div", {
						className: "py-1",
						children: [/* @__PURE__ */ jsx(Typography, {
							variant: "caption",
							color: "secondary",
							component: "span",
							children: isArrayOfMaps && ofProp?.name ? `${ofProp.name} [${index}]` : `[${index}]`
						}), /* @__PURE__ */ jsx("div", {
							className: `pl-4 mt-1 border-l ${defaultBorderMixin}`,
							children: /* @__PURE__ */ jsx(PropertyCollectionView, {
								data: item,
								properties,
								baseKey: currentKey,
								suppressHeader: true,
								size
							})
						})]
					}, currentKey);
				})
			})]
		});
	}
	if (typeof data === "object" && data !== null) {
		const { label, property } = baseKey ? buildPropertyLabelAndGetProperty(properties, baseKey) : {
			label: "",
			property: void 0
		};
		if (baseKey && (!property || property.type !== "map" || !property.properties)) {
			if (!property) return null;
			return /* @__PURE__ */ jsxs("div", {
				className: `grid grid-cols-12 gap-x-4 ${isTopLevel ? "py-4" : "py-2"} items-start ${isTopLevel ? `border-b ${defaultBorderMixin} last:border-b-0` : ""}`,
				children: [/* @__PURE__ */ jsx("div", {
					className: "col-span-4 pr-2",
					children: /* @__PURE__ */ jsx(Typography, {
						variant: "caption",
						color: "secondary",
						component: "span",
						className: "break-words",
						children: label
					})
				}), /* @__PURE__ */ jsx("div", {
					className: "col-span-8",
					children: /* @__PURE__ */ jsx(PropertyPreview, {
						propertyKey: baseKey,
						value: data,
						property,
						size
					})
				})]
			});
		}
		const showMapHeader = baseKey && !suppressHeader && property?.type === "map" && (property.name || !pathEndsWithIndex(baseKey));
		const headerText = property?.name || label;
		return /* @__PURE__ */ jsxs("div", {
			className: `${isTopLevel ? "py-4" : "py-1"} ${isTopLevel ? `border-b ${defaultBorderMixin} last:border-b-0` : ""}`,
			children: [showMapHeader && /* @__PURE__ */ jsx(Typography, {
				variant: "caption",
				color: "secondary",
				component: "span",
				children: headerText
			}), /* @__PURE__ */ jsx("div", {
				className: baseKey ? `pl-4 mt-1 border-l ${defaultBorderMixin}` : "",
				children: Object.entries(data).map(([key, value]) => {
					if (value === null || value === void 0) return null;
					if (baseKey === "" && !properties[key]) return null;
					const currentKey = baseKey ? `${baseKey}.${key}` : key;
					return /* @__PURE__ */ jsx(PropertyCollectionView, {
						data: value,
						properties,
						baseKey: currentKey,
						size
					}, currentKey);
				})
			})]
		});
	}
	if (baseKey) {
		const { label, property } = buildPropertyLabelAndGetProperty(properties, baseKey);
		if (!property) return null;
		return /* @__PURE__ */ jsxs("div", {
			className: `grid grid-cols-12 gap-x-4 ${isTopLevel ? "py-4" : "py-2"} items-start ${isTopLevel ? `border-b ${defaultBorderMixin} last:border-b-0` : ""}`,
			children: [/* @__PURE__ */ jsx("div", {
				className: "col-span-4 pr-2",
				children: /* @__PURE__ */ jsx(Typography, {
					variant: "caption",
					color: "secondary",
					component: "span",
					className: "break-words",
					children: label
				})
			}), /* @__PURE__ */ jsx("div", {
				className: "col-span-8",
				children: /* @__PURE__ */ jsx(PropertyPreview, {
					propertyKey: baseKey,
					value: data,
					property,
					size
				})
			})]
		});
	}
	return null;
};
//#endregion
//#region src/form/components/LocalChangesMenu.tsx
function LocalChangesMenu({ cachedData, formex, onClearLocalChanges, cacheKey, properties }) {
	const snackbarController = useSnackbarController();
	const { t } = useTranslation();
	const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
	const [open, setOpen] = useState(false);
	const handleOpenMenu = () => setOpen(true);
	const handleCloseMenu = () => setOpen(false);
	const handlePreview = () => {
		setPreviewDialogOpen(true);
		handleCloseMenu();
	};
	const handleApply = () => {
		const mergedValues = mergeDeep(formex.values, cachedData, true);
		const touched = { ...formex.touched };
		flattenKeys(cachedData).forEach((key) => {
			touched[key] = true;
		});
		formex.setTouched(touched);
		formex.setValues(mergedValues);
		snackbarController.open({
			type: "info",
			message: t("local_changes_applied")
		});
		handleCloseMenu();
		onClearLocalChanges?.();
	};
	const handleDiscard = () => {
		removeEntityFromCache(cacheKey);
		snackbarController.open({
			type: "info",
			message: t("local_changes_discarded")
		});
		handleCloseMenu();
		onClearLocalChanges?.();
	};
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsxs(Menu, {
		trigger: /* @__PURE__ */ jsxs(Button, {
			size: "small",
			className: "font-semibold text-xs rounded-full px-4 py-1 bg-yellow-200 dark:bg-yellow-900 hover:bg-yellow-300 dark:hover:bg-yellow-800 text-yellow-800 dark:text-yellow-200",
			onClick: handleOpenMenu,
			children: [
				/* @__PURE__ */ jsx(AlertTriangleIcon, {
					size: iconSize.smallest,
					className: "mr-1 text-yellow-600 dark:text-yellow-400"
				}),
				t("unsaved_local_changes"),
				/* @__PURE__ */ jsx(ChevronDownIcon, { size: iconSize.smallest })
			]
		}),
		open,
		onOpenChange: setOpen,
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "max-w-xs px-4 py-4 text-sm text-gray-700 dark:text-gray-300",
				children: t("unsaved_local_changes_description")
			}),
			/* @__PURE__ */ jsxs(MenuItem, {
				dense: true,
				onClick: handlePreview,
				children: [/* @__PURE__ */ jsx(EyeIcon, { size: iconSize.small }), t("preview_changes")]
			}),
			/* @__PURE__ */ jsxs(MenuItem, {
				dense: true,
				onClick: handleApply,
				children: [/* @__PURE__ */ jsx(CheckIcon, { size: iconSize.small }), t("apply_changes")]
			}),
			/* @__PURE__ */ jsxs(MenuItem, {
				dense: true,
				onClick: handleDiscard,
				children: [/* @__PURE__ */ jsx(XCircleIcon, { size: iconSize.small }), t("discard_local_changes")]
			})
		]
	}), /* @__PURE__ */ jsxs(Dialog, {
		open: previewDialogOpen,
		onOpenChange: setPreviewDialogOpen,
		maxWidth: "4xl",
		children: [
			/* @__PURE__ */ jsx(DialogTitle, {
				variant: "h6",
				children: t("preview_local_changes")
			}),
			/* @__PURE__ */ jsxs(DialogContent, {
				className: "my-4",
				children: [/* @__PURE__ */ jsx(Typography, {
					variant: "body2",
					className: "mb-4",
					children: t("preview_local_changes_description")
				}), /* @__PURE__ */ jsx("div", {
					className: `border rounded-lg ${defaultBorderMixin}`,
					style: {
						maxHeight: 520,
						overflow: "auto"
					},
					children: /* @__PURE__ */ jsx("div", {
						className: "p-4",
						children: /* @__PURE__ */ jsx(PropertyCollectionView, {
							data: cachedData,
							properties
						})
					})
				})]
			}),
			/* @__PURE__ */ jsxs(DialogActions, { children: [/* @__PURE__ */ jsx(Button, {
				onClick: () => setPreviewDialogOpen(false),
				children: t("close")
			}), /* @__PURE__ */ jsx(Button, {
				variant: "filled",
				onClick: () => {
					handleApply();
					setPreviewDialogOpen(false);
				},
				children: t("apply_changes")
			})] })
		]
	})] });
}
//#endregion
//#region src/form/EntityForm.tsx
/**
* Headless entity form component.
*
* Renders a form for a entity collection without any admin or backend dependencies.
* All backend concerns (save, caching, analytics, plugin slots) are provided via
* callback props. For admin-connected usage, use {@link EntityFormBinding} instead.
*
* @group Components
*/
function EntityForm({ path, entityId: entityIdProp, collection, onValuesModified, onIdChange, onSaved, entity, initialDirtyValues, onFormContextReady, initialStatus, className, onStatusChange, onEntityChange, openEntityMode = "full_screen", formex: formexProp, disabled: disabledProp, Builder, parentCollectionSlugs, parentEntityIds, EntityFormActionsComponent = EntityFormActions, showDefaultActions = true, navigateBack: navigateBackProp, children, onSubmit: onSubmitProp, onValuesChangeDeferred: onValuesChangeDeferredProp, onReset: onResetProp, uniqueFieldValidator: uniqueFieldValidatorProp, beforeFields, afterFields, pluginActions: pluginActionsProp, computedInitialValues, hasLocalChanges: hasLocalChangesProp, localChangesData, manualApplyLocalChanges, localChangesCacheKey, onClearLocalChanges }) {
	const navigateBack = useCallback(() => {
		if (navigateBackProp) navigateBackProp();
	}, [navigateBackProp]);
	const [status, setStatus] = useState(initialStatus);
	const updateStatus = (status) => {
		setStatus(status);
		onStatusChange?.(status);
	};
	const [valuesToBeSaved, setValuesToBeSaved] = useState(void 0);
	useDebouncedCallback(valuesToBeSaved, () => {
		if (valuesToBeSaved && onSubmitProp) {
			setIsSavingAutoSave(true);
			Promise.resolve(onSubmitProp(valuesToBeSaved, formex)).finally(() => setIsSavingAutoSave(false));
		}
	}, false, 2e3);
	const [underlyingChanges] = useState({});
	const initialEntityId = useMemo(() => {
		if (status === "new" || status === "copy") return;
		else return entityIdProp;
	}, [entityIdProp, status]);
	const [entityId, setEntityId] = useState(initialEntityId);
	const [savingError, setSavingError] = useState();
	const [isSavingAutoSave, setIsSavingAutoSave] = useState(false);
	const [discardDialogOpen, setDiscardDialogOpen] = useState(false);
	const discard = useUndoableDiscard();
	const autoSave = collection.formAutoSave;
	const baseInitialValues = useMemo(() => {
		if (computedInitialValues !== void 0) return computedInitialValues;
		if ((status === "existing" || status === "copy") && entity) return entity.values ?? getDefaultValuesFor(collection.properties);
		return getDefaultValuesFor(collection.properties);
	}, [
		computedInitialValues,
		collection.properties,
		status,
		entity
	]);
	const [localChangesCleared, setLocalChangesCleared] = useState(false);
	const hasLocalChanges = hasLocalChangesProp !== void 0 ? hasLocalChangesProp && !localChangesCleared : false;
	const onSubmit = (values, formexController) => {
		setSavingError(void 0);
		if (status === "existing") {
			if (!entity?.id) throw Error("Form misconfiguration when saving, no id for existing entity");
		} else if (status !== "new" && status !== "copy") throw Error("New FormType added, check EntityForm");
		if (!onSubmitProp) {
			console.warn("EntityForm: no onSubmit callback provided. Form submission has no effect.");
			formexController.setSubmitting(false);
			return;
		}
		return Promise.resolve(save(values))?.then((savedEntity) => {
			if (savedEntity) formexController.resetForm({
				values: savedEntity.values || values,
				submitCount: 0,
				touched: {}
			});
		}).finally(() => {
			formexController.setSubmitting(false);
		});
	};
	/**
	* What the form opens showing, when that is not what is stored — an edit
	* carried over from the side panel's "open full screen", or a draft
	* restored from the local-changes backup.
	*
	* The merge is deliberately *not* folded into the baseline. `mergeDeep`
	* used to produce a single `initialValues` that served as both, with a
	* `initialDirty: true` bolted on beside it to say what the baseline could
	* no longer show — and that flag survived exactly one render, because the
	* record's data arriving replaced the baseline and the form recomputed
	* dirty as false against a baseline that already contained the edit.
	*
	* Read once, at mount: this is a handoff, and re-reading it every render
	* tied the form to a cache that is cleared as soon as it has been consumed.
	*/
	const initialModifiedValues = useRef(initialDirtyValues && Object.keys(initialDirtyValues).length > 0 ? mergeDeep(baseInitialValues, initialDirtyValues) : void 0).current;
	const internalFormex = useCreateFormex({
		initialValues: baseInitialValues,
		initialModifiedValues,
		debugId: `EntityForm:${path}/${entityIdProp}`,
		initialTouched: initialDirtyValues ? flattenKeys(initialDirtyValues).reduce((previousValue, currentValue) => ({
			...previousValue,
			[currentValue]: true
		}), {}) : {},
		onSubmit,
		onReset: () => {
			onResetProp?.();
			onValuesModified?.(false, baseInitialValues);
		},
		onValuesChangeDeferred: onValuesChangeDeferredProp,
		validation: async (values) => {
			if (!validationSchema) return {};
			const result = await validationSchema.safeParseAsync(values);
			if (result.success) return {};
			return zodToFormErrors(result.error);
		}
	});
	const formex = formexProp ?? internalFormex;
	useEffect(() => {
		const handleKeyDown = (e) => {
			const isUndo = (e.metaKey || e.ctrlKey) && !e.shiftKey && e.key.toLowerCase() === "z";
			const isRedo = (e.metaKey || e.ctrlKey) && e.shiftKey && e.key.toLowerCase() === "z" || (e.metaKey || e.ctrlKey) && !e.shiftKey && e.key.toLowerCase() === "y";
			if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "s" && !disabled && formex.dirty) {
				e.preventDefault();
				formex.handleSubmit();
			} else if (isUndo && formex.canUndo) {
				e.preventDefault();
				formex.undo();
			} else if (isRedo && formex.canRedo) {
				e.preventDefault();
				formex.redo();
			}
		};
		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [formex]);
	const afterSave = (updatedEntity) => {
		onResetProp?.();
		onValuesModified?.(false, updatedEntity.values);
		onEntityChange?.(updatedEntity);
		updateStatus("existing");
		setEntityId(updatedEntity.id);
		if (onSaved) onSaved({
			entity: updatedEntity,
			status,
			path,
			entityId: updatedEntity.id,
			collection
		});
	};
	const lastSavedValues = useRef(entity?.values);
	const save = async (values) => {
		const valuesToSave = status === "existing" ? getChanges(values, entity?.values || {}) : values;
		if (status === "existing" && Object.keys(valuesToSave).length === 0 && entity) return Promise.resolve(entity);
		lastSavedValues.current = values;
		if (!onSubmitProp) return;
		if (autoSave ?? false) {
			setValuesToBeSaved(values);
			return Promise.resolve();
		}
		return Promise.resolve(onSubmitProp(valuesToSave, formex)).then((result) => {
			if (result) afterSave(result);
			return result;
		}).catch((e) => {
			console.error(e);
			setSavingError(e);
		});
	};
	const disabled = formex.isSubmitting || Boolean(disabledProp);
	const rebaseContext = useRebaseContext();
	const formContext = {
		setFieldValue: useCallback((key, value) => formex.setFieldValue(key, value), []),
		values: formex.values,
		collection,
		entityId,
		path,
		save,
		submit: formex.handleSubmit,
		formex,
		entity,
		savingError,
		status,
		openEntityMode,
		disabled,
		isSaving: formex.isSubmitting || isSavingAutoSave
	};
	useEffect(() => {
		onFormContextReady?.(formContext);
	}, [
		formex.version,
		collection,
		entityId,
		path,
		formex.dirty,
		formex.isSubmitting,
		formex.submitCount,
		isSavingAutoSave
	]);
	const actionsDisabled = disabled || formex.isSubmitting || status === "existing" && !formex.dirty || Boolean(disabledProp);
	const modified = formex.dirty;
	useEffect(() => {
		if (!autoSave) onValuesModified?.(modified, formex.values);
	}, [formex.dirty]);
	const defaultUniqueFieldValidator = useCallback(async () => true, []);
	const uniqueFieldValidator = useMemo(() => {
		if (uniqueFieldValidatorProp) return uniqueFieldValidatorProp;
		return defaultUniqueFieldValidator;
	}, [uniqueFieldValidatorProp, defaultUniqueFieldValidator]);
	const validationSchema = useMemo(() => getEntitySchema(entityId, collection.properties, uniqueFieldValidator), [
		entityId,
		collection.properties,
		uniqueFieldValidator
	]);
	useOnAutoSave(autoSave, formex, lastSavedValues, save);
	useEffect(() => {
		if (!autoSave && !formex.isSubmitting && underlyingChanges && entity) Object.entries(underlyingChanges).forEach(([key, value]) => {
			const formValue = formex.values[key];
			if (!deepEqual(value, formValue) && !formex.touched[key]) {
				console.debug("Updated value from the driver:", key, value);
				formex.setFieldValue(key, value !== void 0 ? value : null);
			}
		});
	}, [
		formex.isSubmitting,
		autoSave,
		underlyingChanges,
		entity,
		formex.values,
		formex.touched,
		formex.setFieldValue
	]);
	const formFieldKeys = getFormFieldKeys(collection);
	const layout = useMemo(() => resolveFormLayout({
		collection,
		fieldKeys: formFieldKeys,
		status
	}), [
		collection,
		formFieldKeys.join(","),
		status
	]);
	const formElementRef = useRef(null);
	const railVisible = useRailVisible(formElementRef);
	const showRail = !Builder && layout.hasRail && railVisible;
	const [collapsedSections, setCollapsedSections] = useState(() => new Set(layout.sections.filter((s) => s.collapsed).map((s) => s.key)));
	const toggleSection = useCallback((key) => {
		setCollapsedSections((prev) => {
			const next = new Set(prev);
			if (next.has(key)) next.delete(key);
			else next.add(key);
			return next;
		});
	}, []);
	const errorKeys = useMemo(() => new Set(formex.submitCount > 0 ? Object.keys(formex.errors) : []), [formex.errors, formex.submitCount]);
	const autoFocusKey = useMemo(() => {
		if (status !== "new" && status !== "copy") return void 0;
		return [...layout.sections.flatMap((s) => s.fields), ...layout.sidebar].find((field) => {
			const property = collection.properties?.[field.key];
			return property ? !isFieldDisabled(property) : false;
		})?.key;
	}, [
		layout,
		collection,
		status,
		disabledProp
	]);
	function isFieldDisabled(property) {
		const isNew = status === "new" || status === "copy";
		const isIdAndAuto = (property.type === "string" || property.type === "number") && "isId" in property && typeof property.isId === "string" && property.isId !== "manual";
		return Boolean(disabledProp || !autoSave && formex.isSubmitting || isReadOnly(property) || isDisabled(property) || !isNew && "isId" in property && Boolean(property.isId) || isNew && isIdAndAuto);
	}
	const renderField = (field) => {
		if (field.additional) {
			const additionalField = collection.additionalFields?.find((f) => f.key === field.key);
			if (!additionalField || !entity) return null;
			const AdditionalFieldBuilder = additionalField.Builder;
			if (!AdditionalFieldBuilder && !additionalField.value) throw new Error("When using additional fields you need to provide a Builder or a value");
			const child = AdditionalFieldBuilder ? /* @__PURE__ */ jsx(AdditionalFieldBuilder, {
				entity,
				context: rebaseContext
			}) : /* @__PURE__ */ jsx("div", {
				className: "w-full",
				children: /* @__PURE__ */ jsx(AdditionalFieldValue, {
					field: additionalField,
					entity,
					context: rebaseContext
				})
			});
			return /* @__PURE__ */ jsx("div", {
				className: spanClass(field.span),
				children: /* @__PURE__ */ jsx(FieldBlock, {
					propertyKey: field.key,
					showLabel: true,
					label: additionalField.name,
					icon: /* @__PURE__ */ jsx(AlignLeftIcon, { size: 14 }),
					children: /* @__PURE__ */ jsx("div", {
						className: cls(paperMixin, "w-full min-h-12 p-4 md:p-6 overflow-x-auto no-scrollbar"),
						children: child
					})
				})
			}, `additional_${field.key}`);
		}
		const property = collection.properties?.[field.key];
		if (!property) {
			console.warn(`Property ${field.key} not found in collection ${collection.name} in properties or additional fields. Skipping.`);
			return null;
		}
		const underlyingValueHasChanged = !!underlyingChanges && Object.keys(underlyingChanges).includes(field.key) && formex.touched[field.key];
		const disabled = isFieldDisabled(property);
		const selfLabelling = isSelfLabellingProperty(property);
		const cmsFormFieldProps = {
			propertyKey: field.key,
			disabled,
			property,
			includeDescription: false,
			hideLabel: !selfLabelling,
			underlyingValueHasChanged: underlyingValueHasChanged && !autoSave,
			context: formContext,
			partOfArray: false,
			minimalistView: false,
			size: "large",
			autoFocus: autoFocusKey === field.key
		};
		return /* @__PURE__ */ jsx("div", {
			className: spanClass(field.span),
			children: /* @__PURE__ */ jsx(FieldBlock, {
				propertyKey: field.key,
				property,
				showLabel: !selfLabelling,
				children: /* @__PURE__ */ jsx(PropertyFieldBinding, { ...cmsFormFieldProps })
			})
		}, `field_${field.key}`);
	};
	const formFields = () => {
		if (Builder) return /* @__PURE__ */ jsx(Suspense, {
			fallback: /* @__PURE__ */ jsx(CircularProgressCenter, {}),
			children: /* @__PURE__ */ jsx(Builder, {
				collection,
				parentCollectionSlugs,
				parentEntityIds,
				entity,
				modifiedValues: formex.values,
				formContext
			})
		});
		return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(FormSections, {
			sections: showRail || !layout.sidebar.length ? layout.sections : [...layout.sections, {
				key: "__rail",
				title: "Settings",
				collapsible: false,
				collapsed: false,
				fields: layout.sidebar
			}],
			collapsed: collapsedSections,
			onToggle: toggleSection,
			errorKeys,
			renderField
		}), !showRail && layout.showRecordMeta && status === "existing" && entity && /* @__PURE__ */ jsx("div", {
			className: cls("mt-8 pt-5 border-t max-w-sm", defaultBorderMixin),
			children: /* @__PURE__ */ jsx(RecordMeta, { entity })
		})] });
	};
	const formRef = useRef(null);
	const hasFormErrors = Object.keys(formex.errors).length > 0 && formex.submitCount > 0;
	const formView = /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxs(Fragment, { children: [
		beforeFields,
		!entity?.values && initialStatus === "existing" && /* @__PURE__ */ jsx(Alert, {
			color: "warning",
			size: "small",
			outerClassName: "w-full mb-4 text-xs",
			children: "This entity does not exist yet"
		}),
		children,
		initialEntityId && !entity && initialStatus !== "new" && /* @__PURE__ */ jsx(Alert, {
			color: "info",
			size: "small",
			children: "This entity does not exist yet"
		}),
		hasFormErrors && /* @__PURE__ */ jsx(Alert, {
			color: "error",
			size: "small",
			outerClassName: "w-full mt-2",
			children: "Please fix the highlighted errors before saving."
		}),
		formContext && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", {
			ref: formRef,
			children: [formFields(), /* @__PURE__ */ jsx(ErrorFocus, { containerRef: formRef })]
		}) }),
		afterFields,
		/* @__PURE__ */ jsxs(Dialog, {
			open: discardDialogOpen,
			onOpenChange: setDiscardDialogOpen,
			maxWidth: "sm",
			children: [
				/* @__PURE__ */ jsx(DialogTitle, { children: status === "existing" ? "Discard changes?" : "Clear form?" }),
				/* @__PURE__ */ jsx(DialogContent, { children: /* @__PURE__ */ jsxs(Typography, { children: [status === "existing" ? "All unsaved changes will be lost. " : "All entered values will be cleared. ", "You can bring them back with Undo (⌘Z / Ctrl+Z), or from the notification, for as long as this form stays open."] }) }),
				/* @__PURE__ */ jsxs(DialogActions, { children: [/* @__PURE__ */ jsx(Button, {
					variant: "text",
					onClick: () => setDiscardDialogOpen(false),
					children: "Cancel"
				}), /* @__PURE__ */ jsx(Button, {
					variant: "filled",
					color: "error",
					onClick: () => {
						setDiscardDialogOpen(false);
						discard(formex, status, baseInitialValues);
					},
					children: status === "existing" ? "Discard" : "Clear"
				})] })
			]
		})
	] }) });
	useEffect(() => {
		if (entityId && onIdChange) onIdChange(entityId);
	}, [entityId, onIdChange]);
	if (!collection || !path) throw Error("INTERNAL: Collection and path must be defined in form context");
	const dialogActions = /* @__PURE__ */ jsx(EntityFormActionsComponent, {
		collection,
		path,
		entity,
		savingError,
		formex,
		disabled: actionsDisabled,
		status,
		pluginActions: pluginActionsProp ?? [],
		openEntityMode,
		showDefaultActions,
		navigateBack,
		formContext
	});
	return /* @__PURE__ */ jsx(Formex, {
		value: formex,
		children: /* @__PURE__ */ jsxs("form", {
			ref: formElementRef,
			onSubmit: formex.handleSubmit,
			onReset: (e) => {
				e.preventDefault();
				if (formex.dirty) setDiscardDialogOpen(true);
				else formex.resetForm({ values: baseInitialValues });
			},
			noValidate: true,
			className: cls("@container/form flex-1 flex flex-col w-full min-h-0", className),
			children: [/* @__PURE__ */ jsxs("div", {
				className: "flex-1 min-h-0 flex flex-row w-full",
				children: [/* @__PURE__ */ jsx("div", {
					className: "flex-1 min-w-0 overflow-y-auto flex justify-center items-start",
					children: /* @__PURE__ */ jsxs("div", {
						id: `form_${path}`,
						className: cls("@container/col w-full max-w-3xl @7xl/form:max-w-4xl 2xl:max-w-4xl flex flex-col", openEntityMode === "dialog" ? "pt-5 pb-8 px-6 sm:px-8" : "pt-6 pb-12 px-5 sm:px-8"),
						children: [manualApplyLocalChanges && hasLocalChanges && localChangesCacheKey && /* @__PURE__ */ jsx("div", {
							className: "flex justify-end mb-3",
							children: /* @__PURE__ */ jsx(LocalChangesMenu, {
								cacheKey: localChangesCacheKey,
								properties: collection.properties,
								cachedData: localChangesData,
								formex,
								onClearLocalChanges: () => {
									setLocalChangesCleared(true);
									onClearLocalChanges?.();
								}
							})
						}), formView]
					})
				}), showRail && /* @__PURE__ */ jsx(FormRail, {
					fields: layout.sidebar,
					showRecordMeta: layout.showRecordMeta && status === "existing",
					entity,
					renderField
				})]
			}), dialogActions]
		})
	});
}
function useOnAutoSave(autoSave, formex, lastSavedValues, save) {
	useEffect(() => {
		if (!autoSave) return;
		if (formex.values && !deepEqual(formex.values, lastSavedValues.current)) save(formex.values);
	}, [autoSave, formex.values]);
}
//#endregion
//#region src/form/EntityFormBinding.tsx
/**
* admin-connected wrapper around EntityForm.
*
* Provides all backend concerns that the headless EntityForm delegates via callbacks:
* - Save via the data layer (`saveEntityWithCallbacks`)
* - Unique field validation via the data layer
* - Entity caching (local changes backup/restore)
* - Plugin slots (form.before, form.after, form.actions)
* - Snackbar notifications on save success/error
* - Analytics events
* - Navigation via side entity controller
*
* Use this component inside the admin (`<RebaseShell>`).
* For headless usage outside the admin, use `EntityForm` directly.
*
* @group Components
*/
function EntityFormBinding({ path, entityId: entityIdProp, collection, entity, initialStatus, onSaved, onValuesModified, onEntityChange, onStatusChange, openEntityMode = "full_screen", navigateBack: navigateBackProp, initialDirtyValues, ...restProps }) {
	const { t } = useTranslation();
	const sidePanelController = useSidePanel();
	const collectionRegistryController = useCollectionRegistryController();
	const authController = useAuthController();
	const dataClient = useData();
	const snackbarController = useSnackbarController();
	const customizationController = useCustomizationController();
	const context = useAdminContext();
	const analyticsController = useAnalyticsController();
	const [status, setStatus] = useState(initialStatus);
	const [entityId, setEntityId] = useState(() => {
		if (status === "new" || status === "copy") return void 0;
		return entityIdProp;
	});
	const baseInitialValues = useMemo(() => getInitialEntityValues(authController, collection, path, status, entity, customizationController.propertyConfigs), [
		authController,
		collection,
		path,
		status,
		entity,
		customizationController.propertyConfigs
	]);
	const localChangesBackup = getLocalChangesBackup(collection);
	const autoApplyLocalChanges = localChangesBackup === "auto_apply";
	const manualApplyLocalChanges = localChangesBackup === "manual_apply";
	const localChangesDataRaw = useMemo(() => entityId ? getEntityFromCache(path + "/" + entityId) : getEntityFromCache(path + "#new"), [entityId, path]);
	const [localChangesCleared, setLocalChangesCleared] = useState(false);
	const computedInitialValues = useMemo(() => {
		return autoApplyLocalChanges && localChangesDataRaw ? mergeDeep(baseInitialValues, localChangesDataRaw) : baseInitialValues;
	}, [
		autoApplyLocalChanges,
		localChangesDataRaw,
		baseInitialValues
	]);
	const localChangesData = useMemo(() => {
		if (!localChangesDataRaw) return void 0;
		const openingValues = initialDirtyValues ? mergeDeep(computedInitialValues, initialDirtyValues) : computedInitialValues;
		return getUnappliedLocalChanges(localChangesDataRaw, openingValues);
	}, [
		localChangesDataRaw,
		computedInitialValues,
		initialDirtyValues
	]);
	const hasLocalChanges = !localChangesCleared && !!localChangesData && Object.keys(localChangesData).length > 0;
	const localChangesCacheKey = useMemo(() => {
		return status === "new" || status === "copy" ? path + "#new" : path + "/" + entityId;
	}, [
		status,
		path,
		entityId
	]);
	const navigateBack = useCallback(() => {
		if (navigateBackProp) {
			navigateBackProp();
			return;
		}
		if (openEntityMode === "side_panel" || openEntityMode === "dialog") sidePanelController.close();
		else window.history.back();
	}, [
		navigateBackProp,
		openEntityMode,
		sidePanelController
	]);
	const clearDirtyCache = useCallback(() => {
		if (status === "new" || status === "copy") {
			removeEntityFromMemoryCache(path + "#new");
			removeEntityFromCache(path + "#new");
		} else {
			removeEntityFromMemoryCache(path + "/" + entityId);
			removeEntityFromCache(path + "/" + entityId);
		}
	}, [
		status,
		path,
		entityId
	]);
	const onReset = useCallback(() => {
		clearDirtyCache();
	}, [clearDirtyCache]);
	const onValuesChangeDeferred = useCallback((values, controller) => {
		const key = status === "new" || status === "copy" ? path + "#new" : path + "/" + entityId;
		if (controller.dirty) {
			const touchedValues = removeEmptyContainers(extractTouchedValues(values, controller.touched));
			if (touchedValues && Object.keys(touchedValues).length > 0) saveEntityToCache(key, touchedValues);
			else removeEntityFromCache(key);
		}
	}, [
		status,
		path,
		entityId
	]);
	const onSubmit = useCallback(async (values, formex) => {
		try {
			const savedEntity = await saveEntityWithCallbacks({
				path,
				entityId,
				values,
				previousValues: entity?.values,
				collection,
				status,
				data: dataClient,
				context,
				afterSave: (updatedEntity) => {
					clearDirtyCache();
					onValuesModified?.(false, updatedEntity.values);
					onEntityChange?.(updatedEntity);
					setStatus("existing");
					setEntityId(updatedEntity.id);
					onStatusChange?.("existing");
					if (onSaved) onSaved({
						entity: updatedEntity,
						status,
						path,
						entityId: updatedEntity.id,
						collection
					});
				},
				afterSaveError: (e) => {
					snackbarController.open({
						type: "error",
						title: t("error_saving_entity"),
						message: e?.message
					});
					console.error("Error saving entity", path, entityId, e);
				}
			});
			if (!collection.formAutoSave) snackbarController.open({
				type: "success",
				message: `${collection.singularName ?? collection.name}: ${t("saved_correctly")}`
			});
			const eventName = status === "new" ? "new_entity_saved" : status === "copy" ? "entity_copied" : status === "existing" ? "entity_edited" : "unmapped_event";
			analyticsController.onAnalyticsEvent?.(eventName, { path });
			return savedEntity;
		} catch (e) {
			console.error(e);
			throw e;
		}
	}, [
		path,
		entityId,
		entity,
		collection,
		status,
		dataClient,
		context,
		clearDirtyCache,
		onValuesModified,
		onEntityChange,
		onSaved,
		onStatusChange,
		snackbarController,
		analyticsController,
		t
	]);
	const uniqueFieldValidator = useCallback(async ({ name, value }) => {
		try {
			const { data } = await dataClient.collection(path).find({
				where: { [name]: ["==", value] },
				limit: 2
			});
			return (entityId ? data.filter((e) => e.id !== entityId) : data).length === 0;
		} catch (e) {
			console.error("Error checking unique field", e);
			return true;
		}
	}, [
		dataClient,
		path,
		entityId
	]);
	const parentCollectionSlugs = collectionRegistryController.getParentCollectionSlugs(path);
	const parentEntityIds = collectionRegistryController.getParentEntityIds(path);
	const formActionProps = useMemo(() => ({
		entityId,
		parentCollectionSlugs,
		parentEntityIds,
		path,
		status,
		collection,
		context,
		formContext: void 0,
		openEntityMode,
		disabled: false
	}), [
		entityId,
		parentCollectionSlugs,
		parentEntityIds,
		path,
		status,
		collection,
		context,
		openEntityMode
	]);
	const pluginFormBefore = useSlot("form.before", formActionProps);
	const pluginFormAfter = useSlot("form.after", formActionProps);
	return /* @__PURE__ */ jsx(EntityForm, {
		...restProps,
		path,
		entityId: entityIdProp,
		collection,
		entity,
		initialStatus,
		initialDirtyValues,
		onSaved,
		onValuesModified,
		onEntityChange,
		onStatusChange,
		openEntityMode,
		navigateBack,
		onSubmit,
		onValuesChangeDeferred,
		onReset,
		uniqueFieldValidator,
		beforeFields: pluginFormBefore,
		afterFields: pluginFormAfter,
		pluginActions: [],
		computedInitialValues,
		hasLocalChanges,
		localChangesData,
		manualApplyLocalChanges,
		localChangesCacheKey,
		onClearLocalChanges: () => setLocalChangesCleared(true)
	});
}
//#endregion
//#region src/collection_editor/liveSchemaClient.ts
var LiveSchemaError = class extends Error {
	code;
	changes;
	constructor(message, code, changes) {
		super(message);
		this.code = code;
		this.changes = changes;
		this.name = "LiveSchemaError";
	}
};
var UNAVAILABLE = {
	SCHEMA_EDITING_UNSUPPORTED: "unsupported",
	SCHEMA_EDITING_NO_REPOSITORY: "no-repository"
};
function createLiveSchemaClient(options) {
	const doFetch = options.fetchImpl ?? fetch;
	const base = options.baseUrl.replace(/\/$/, "");
	const post = async (path, body) => {
		const token = await options.getAuthToken?.();
		const headers = { "Content-Type": "application/json" };
		if (token) headers.Authorization = `Bearer ${token}`;
		const response = await doFetch(`${base}${path}`, {
			method: "POST",
			headers,
			body: JSON.stringify(body)
		});
		if (response.ok) return await response.json();
		let payload = {};
		try {
			payload = await response.json();
		} catch {
			payload = { error: { message: await response.text().catch(() => "") } };
		}
		throw new LiveSchemaError(payload.error?.message || `Schema request failed with ${response.status}`, payload.error?.code, payload.error?.details?.changes);
	};
	return {
		/**
		* Whether this backend can edit its schema.
		*
		* Never throws. Every way of failing to get an answer — a backend too
		* old to have the endpoint, an unreachable one, a session that is not
		* an admin — means the same thing to a caller deciding whether to offer
		* the control, and turning that into an exception each caller has to
		* catch would only produce four copies of this `catch`.
		*/
		status: async () => {
			try {
				const token = await options.getAuthToken?.();
				const response = await doFetch(`${base}/status`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
				const body = await response.json().catch(() => ({}));
				if (response.ok) return {
					enabled: body.enabled === true,
					canPlan: body.canPlan === true,
					canApply: body.canApply ?? body.enabled === true,
					applyRefusedBecause: body.applyRefusedBecause,
					applyRefusedCode: body.applyRefusedCode,
					repository: body.repository,
					branch: body.branch,
					code: body.code,
					reason: body.reason
				};
				return {
					enabled: false,
					canPlan: false,
					canApply: false,
					code: body.error?.code,
					reason: body.error?.message ?? `The backend refused to say whether its schema is editable (HTTP ${response.status}).`
				};
			} catch (err) {
				return {
					enabled: false,
					canPlan: false,
					canApply: false,
					reason: err instanceof Error ? err.message : "The backend could not be reached."
				};
			}
		},
		/** What the change would do. No side effects. */
		plan: (change) => post("/plan", change),
		/** Commit the change, then apply it. */
		apply: (change) => post("/apply", change)
	};
}
/**
* Whether an error means live editing is unavailable here, rather than that the
* change was wrong.
*
* Returns the reason so a caller can say which, and `undefined` for anything
* else — a refused change is not an unavailable feature, and conflating them
* would hide the refusal that the user needs to read.
*/
function asUnavailable(err) {
	if (!(err instanceof LiveSchemaError) || !err.code) return void 0;
	const reason = UNAVAILABLE[err.code];
	return reason ? {
		reason,
		message: err.message
	} : void 0;
}
/** The person closed the dialog without applying. Not an error; an answer. */
var SchemaChangeCancelled = class extends Error {
	constructor() {
		super("The schema change was not applied.");
		this.name = "SchemaChangeCancelled";
	}
};
/**
* Was this rejection the person saying no?
*
* A save has to *reject* when it is cancelled — resolving would leave the form
* believing it saved. But a caller that treats every rejection as a failure
* then reports the user's own choice back to them as an error, which is what
* the collection editor did: a console error and a red snackbar reading "Error
* persisting collection: The schema change was not applied."
*
* Matched by name rather than `instanceof`, which is unreliable the moment two
* copies of this module end up in one bundle — the class is then a different
* identity and every check silently answers false.
*/
function isSchemaChangeCancelled(err) {
	return err instanceof Error && err.name === "SchemaChangeCancelled";
}
//#endregion
//#region src/collection_editor/useCollectionsConfigController.tsx
/**
* Use this hook to access the configuration controller.
* You can use it to get the list of collections, and to save/delete collections.
*/
var useCollectionsConfigController = () => useContext(ConfigControllerContext);
//#endregion
//#region src/collection_editor/serializable_utils.ts
/**
* Conversion utilities between the full Rebase types and their
* JSON-serializable counterparts.
*
* - `toSerializableCollectionConfig` / `toSerializableProperty` — strip non-serializable fields
* - `fromSerializableCollectionConfig` / `fromSerializableProperty` — reconstruct original types
*
* @module
*/
/**
* Rebuild a serialized relation's `target` slug into the thunk consumers call.
*
* Shared by the relation *property* and the collection-level `relations` array.
* They are the same shape on the wire and they need the same treatment coming
* back, but only the property path had it — so a collection imported from an
* existing table came off disk with `relations[n].target` still a string, which
* typechecks (the serializable shape erases the difference) and throws "target
* is not a function" at the first consumer.
*
* The lookup is consulted lazily, inside the thunk, so collections may
* reference each other in any order, including circularly.
*/
function fromSerializableRelation(relation, label, lookup) {
	const slug = relation.target;
	return {
		...relation,
		target: () => {
			const found = slug ? lookup?.(slug) : void 0;
			if (!found) throw new Error(`Relation "${relation.relationName ?? label}" targets collection "${slug ?? "(none)"}", which is not among the collections it was deserialized with. Pass the whole set to \`fromSerializableCollectionConfigs\` so slugs can be resolved against each other.`);
			return found;
		}
	};
}
/**
* Strip non-serializable fields from a `AdminPropertyOptions`.
* Removes `Field` and `Preview` (ComponentRef).
*/
/**
* Every `ComponentRef` on a property's admin block. These are components, not
* data, and none of them survives `JSON.stringify` — a function-valued key is
* dropped from the output object with no error, so a component written here
* would leave a key that reads back as missing rather than as itself.
*
* `Filter` was absent from this list while `Field` and `Preview` were named
* twice, once destructured and once compared by string.
*/
var NON_SERIALIZABLE_ADMIN_KEYS = [
	"Field",
	"Preview",
	"Filter"
];
function toSerializableAdminOptions(ui) {
	if (!ui) return void 0;
	const result = {};
	for (const [key, value] of Object.entries(ui)) if (!NON_SERIALIZABLE_ADMIN_KEYS.includes(key) && value !== void 0) result[key] = value;
	return Object.keys(result).length > 0 ? result : void 0;
}
/**
* Convert a `StorageConfig` to its serializable form.
* Drops function variants of `storagePath`, `fileName`, and all function fields.
*/
function toSerializableStorageConfig(storage) {
	if (!storage) return void 0;
	const storagePath = typeof storage.storagePath === "string" ? storage.storagePath : void 0;
	if (!storagePath) return void 0;
	const result = { storagePath };
	if (storage.acceptedFiles) result.acceptedFiles = storage.acceptedFiles;
	if (storage.imageResize) result.imageResize = storage.imageResize;
	if (storage.metadata) result.metadata = storage.metadata;
	if (typeof storage.fileName === "string") result.fileName = storage.fileName;
	if (storage.includeBucketUrl !== void 0) result.includeBucketUrl = storage.includeBucketUrl;
	if (storage.storeUrl !== void 0) result.storeUrl = storage.storeUrl;
	if (storage.maxSize !== void 0) result.maxSize = storage.maxSize;
	if (storage.storageSource !== void 0) result.storageSource = resourceKeyOf(storage.storageSource);
	return result;
}
/**
* Convert a RegExp or string `matches` validation to a plain string.
*/
function serializeMatches(matches) {
	if (matches === void 0) return void 0;
	if (typeof matches === "string") return matches;
	return matches.source;
}
/**
* Resolve a relation target to a string slug.
* Functions are called to extract the target; AdminCollection objects
* use their slug.
*/
function resolveRelationTarget(target) {
	if (!target) return void 0;
	if (typeof target === "string") return target;
	if (typeof target === "function") try {
		const resolved = target();
		if (typeof resolved === "string") return resolved;
		if (resolved && typeof resolved === "object" && "slug" in resolved) return resolved.slug;
	} catch {}
}
/**
* A `Relation` as JSON: `target` resolved from its thunk down to a slug.
*
* Switched on `kind` and assigned without a cast, so the compiler checks that
* each branch writes the fields its kind owns and no others. This used to be
* built as an untyped bag and cast into place — which is how the target
* interface drifted a whole refactor behind the code writing to it.
*
* Shared by the relation *property* and the collection-level `relations` array,
* which had no serializer at all: `buildCollectionFromTableMetadata` fills that
* array from the table's foreign keys and junctions on import, and every one of
* them was dropped on save.
*/
function toSerializableRelation(link) {
	const target = resolveRelationTarget(link.target);
	const common = {
		...target ? { target } : {},
		...link.relationName ? { relationName: link.relationName } : {},
		...link.onUpdate ? { onUpdate: link.onUpdate } : {},
		...link.onDelete ? { onDelete: link.onDelete } : {}
	};
	switch (link.kind) {
		case "belongsTo": return {
			kind: "belongsTo",
			...common,
			...link.localKey ? { localKey: link.localKey } : {}
		};
		case "hasOne":
		case "hasMany": return {
			kind: link.kind,
			...common,
			...link.foreignKeyOnTarget ? { foreignKeyOnTarget: link.foreignKeyOnTarget } : {},
			...link.sourceKey ? { sourceKey: link.sourceKey } : {}
		};
		case "manyToMany": return {
			kind: "manyToMany",
			...common,
			...link.through ? { through: link.through } : {}
		};
		case "via": return {
			kind: "via",
			...common,
			cardinality: link.cardinality,
			joinPath: link.joinPath
		};
		default: throw new Error(`Unhandled relation kind: ${JSON.stringify(link)}`);
	}
}
/**
* Strip non-serializable base property fields.
* Returns a clean object with only the common serializable fields from BaseProperty.
* Validation is intentionally excluded — each property type handles its own.
*/
function toSerializableBaseFields(property) {
	const result = { name: property.name };
	if (property.description) result.description = property.description;
	if (property.propertyConfig) result.propertyConfig = property.propertyConfig;
	if (property.columnName) result.columnName = property.columnName;
	if (property.excludeFromApi !== void 0) result.excludeFromApi = property.excludeFromApi;
	if (property.access !== void 0) result.access = property.access;
	if (property.defaultValue !== void 0) result.defaultValue = property.defaultValue;
	if (property.conditions) result.conditions = property.conditions;
	if (property.metadata) result.metadata = property.metadata;
	const ui = toSerializableAdminOptions(property.admin);
	if (ui) result.admin = ui;
	return result;
}
/**
* Convert a single `Property` to its JSON-serializable form.
* Strips functions, converts RegExp to string, Date to ISO string.
*/
function toSerializableProperty(property) {
	const base = toSerializableBaseFields(property);
	switch (property.type) {
		case "string": {
			const sp = property;
			const result = {
				...base,
				type: "string"
			};
			if (sp.columnType) result.columnType = sp.columnType;
			if (sp.isId !== void 0) result.isId = sp.isId;
			if (sp.enum) result.enum = sp.enum;
			if (sp.userSelect) result.userSelect = sp.userSelect;
			if (sp.email) result.email = sp.email;
			if (sp.url) result.url = sp.url;
			if (sp.autoValue) result.autoValue = sp.autoValue;
			if (sp.validation) {
				const { matches, ...restValidation } = sp.validation;
				const serializedValidation = { ...restValidation };
				const matchStr = serializeMatches(matches);
				if (matchStr !== void 0) serializedValidation.matches = matchStr;
				result.validation = serializedValidation;
			}
			const storage = toSerializableStorageConfig(sp.storage);
			if (storage) result.storage = storage;
			return result;
		}
		case "number": {
			const np = property;
			const result = {
				...base,
				type: "number"
			};
			if (np.columnType) result.columnType = np.columnType;
			if (np.validation) result.validation = np.validation;
			if (np.isId !== void 0) result.isId = np.isId;
			if (np.enum) result.enum = np.enum;
			if (np.precision !== void 0) result.precision = np.precision;
			if (np.scale !== void 0) result.scale = np.scale;
			return result;
		}
		case "boolean": {
			const bp = property;
			const result = {
				...base,
				type: "boolean"
			};
			if (bp.validation) result.validation = bp.validation;
			return result;
		}
		case "date": {
			const dp = property;
			const result = {
				...base,
				type: "date"
			};
			if (dp.columnType) result.columnType = dp.columnType;
			if (dp.mode) result.mode = dp.mode;
			if (dp.timezone) result.timezone = dp.timezone;
			if (dp.autoValue) result.autoValue = dp.autoValue;
			if (dp.validation) {
				const serializedValidation = {};
				if (dp.validation.required !== void 0) serializedValidation.required = dp.validation.required;
				if (dp.validation.requiredMessage) serializedValidation.requiredMessage = dp.validation.requiredMessage;
				if (dp.validation.unique) serializedValidation.unique = dp.validation.unique;
				if (dp.validation.uniqueInArray) serializedValidation.uniqueInArray = dp.validation.uniqueInArray;
				if (dp.validation.min instanceof Date) serializedValidation.min = dp.validation.min.toISOString();
				else if (typeof dp.validation.min === "string") serializedValidation.min = dp.validation.min;
				if (dp.validation.max instanceof Date) serializedValidation.max = dp.validation.max.toISOString();
				else if (typeof dp.validation.max === "string") serializedValidation.max = dp.validation.max;
				result.validation = serializedValidation;
			}
			return result;
		}
		case "geopoint": {
			const gp = property;
			const result = {
				...base,
				type: "geopoint"
			};
			if (gp.validation) result.validation = gp.validation;
			return result;
		}
		case "reference": {
			const rp = property;
			const result = {
				...base,
				type: "reference"
			};
			if (rp.isId !== void 0) result.isId = rp.isId;
			if (rp.path) result.path = rp.path;
			return result;
		}
		case "relation": {
			const rl = property;
			const result = {
				...base,
				type: "relation"
			};
			if (rl.isId !== void 0) result.isId = rl.isId;
			const link = rl.relation;
			if (link) result.relation = toSerializableRelation(link);
			return result;
		}
		case "array": {
			const ap = property;
			const result = {
				...base,
				type: "array"
			};
			if (ap.columnType) result.columnType = ap.columnType;
			if (ap.validation) result.validation = ap.validation;
			if (ap.of) if (Array.isArray(ap.of)) result.of = ap.of.map(toSerializableProperty);
			else result.of = toSerializableProperty(ap.of);
			if (ap.oneOf) {
				result.oneOf = { properties: toSerializableProperties(ap.oneOf.properties) };
				if (ap.oneOf.propertiesOrder) result.oneOf.propertiesOrder = ap.oneOf.propertiesOrder;
				if (ap.oneOf.typeField) result.oneOf.typeField = ap.oneOf.typeField;
				if (ap.oneOf.valueField) result.oneOf.valueField = ap.oneOf.valueField;
			}
			return result;
		}
		case "map": {
			const mp = property;
			const result = {
				...base,
				type: "map"
			};
			if (mp.columnType) result.columnType = mp.columnType;
			if (mp.validation) result.validation = mp.validation;
			if (mp.propertiesOrder) result.propertiesOrder = mp.propertiesOrder;
			if (mp.keyValue) result.keyValue = mp.keyValue;
			if (mp.properties) result.properties = toSerializableProperties(mp.properties);
			return result;
		}
		case "vector": {
			const vp = property;
			const result = {
				...base,
				type: "vector",
				dimensions: vp.dimensions
			};
			if (vp.validation) result.validation = vp.validation;
			return result;
		}
		case "binary": {
			const bp = property;
			const result = {
				...base,
				type: "binary"
			};
			if (bp.validation) result.validation = bp.validation;
			return result;
		}
		default: return base;
	}
}
/**
* Convert a `Properties` record to its serializable form.
*/
function toSerializableProperties(properties) {
	const result = {};
	for (const [key, property] of Object.entries(properties)) result[key] = toSerializableProperty(property);
	return result;
}
/**
* Convert an `AdminCollection` to its JSON-serializable form.
*
* Strips all non-serializable fields (functions, React nodes, class instances)
* while preserving the structural schema that the collection editor works with.
*
* The result is safe for `JSON.stringify()` and database storage.
*/
function toSerializableCollectionConfig(collection) {
	const result = {
		slug: collection.slug,
		name: collection.name,
		properties: toSerializableProperties(collection.properties)
	};
	if (collection.singularName) result.singularName = collection.singularName;
	if (collection.description) result.description = collection.description;
	if (collection.group) result.group = collection.group;
	if (collection.engine) result.engine = collection.engine;
	if (collection.dataSource) result.dataSource = collection.dataSource;
	if (collection.databaseId) result.databaseId = collection.databaseId;
	if (collection.ownerId) result.ownerId = collection.ownerId;
	if (collection.metadata) result.metadata = collection.metadata;
	if (isRelationalCollectionConfig(collection) && collection.table) result.table = collection.table;
	if (isRelationalCollectionConfig(collection) && collection.relations?.length) result.relations = collection.relations.map(toSerializableRelation);
	if ("schema" in collection && collection.schema) result.schema = collection.schema;
	if (collection.orderProperty) result.orderProperty = collection.orderProperty;
	if (typeof collection.icon === "string") result.icon = collection.icon;
	if (collection.propertiesOrder) result.propertiesOrder = collection.propertiesOrder;
	if (collection.previewProperties) result.previewProperties = collection.previewProperties;
	if (collection.listProperties) result.listProperties = collection.listProperties;
	if (collection.enabledViews) result.enabledViews = collection.enabledViews;
	if (collection.customViews) {
		const keys = collection.customViews.filter((v) => typeof v === "string");
		if (keys.length > 0) result.customViews = keys;
	}
	if (collection.disableDefaultActions) result.disableDefaultActions = collection.disableDefaultActions;
	if (collection.securityRules) result.securityRules = collection.securityRules;
	if (isRelationalCollectionConfig(collection) && collection.disableDefaultPolicies !== void 0) result.disableDefaultPolicies = collection.disableDefaultPolicies;
	if (collection.strictWrites !== void 0) result.strictWrites = collection.strictWrites;
	if (collection.openEntityMode) result.openEntityMode = collection.openEntityMode;
	if (collection.defaultEntityAction) result.defaultEntityAction = collection.defaultEntityAction;
	if (collection.defaultViewMode) result.defaultViewMode = collection.defaultViewMode;
	if (collection.defaultSize) result.defaultSize = collection.defaultSize;
	if (collection.localChangesBackup !== void 0) result.localChangesBackup = collection.localChangesBackup;
	if (collection.kanban) result.kanban = collection.kanban;
	if (collection.fixedFilter) result.fixedFilter = collection.fixedFilter;
	if (collection.defaultFilter) result.defaultFilter = collection.defaultFilter;
	if (collection.filterPresets) result.filterPresets = collection.filterPresets;
	if (collection.sort) result.sort = collection.sort;
	if (collection.pagination !== void 0) result.pagination = collection.pagination;
	if (collection.selectionEnabled !== void 0) result.selectionEnabled = collection.selectionEnabled;
	if (collection.inlineEditing !== void 0) result.inlineEditing = collection.inlineEditing;
	if (collection.hideFromNavigation !== void 0) result.hideFromNavigation = collection.hideFromNavigation;
	if (collection.hideIdFromForm !== void 0) result.hideIdFromForm = collection.hideIdFromForm;
	if (collection.hideIdFromCollection !== void 0) result.hideIdFromCollection = collection.hideIdFromCollection;
	if (collection.formAutoSave !== void 0) result.formAutoSave = collection.formAutoSave;
	if (collection.alwaysApplyDefaultValues !== void 0) result.alwaysApplyDefaultValues = collection.alwaysApplyDefaultValues;
	if (collection.includeJsonView !== void 0) result.includeJsonView = collection.includeJsonView;
	if (collection.history !== void 0) result.history = collection.history;
	if (collection.sideDialogWidth !== void 0) result.sideDialogWidth = collection.sideDialogWidth;
	if (typeof collection.exportable === "boolean") result.exportable = collection.exportable;
	if (typeof collection.auth === "boolean") result.auth = collection.auth;
	if (typeof collection.defaultSelectedView === "string") result.defaultSelectedView = collection.defaultSelectedView;
	return result;
}
/**
* Convert a serializable property back to the original `Property` type.
*
* This is a mostly pass-through operation since serializable properties
* are a subset of the original types. The main conversions are:
* - `validation.matches` (string) stays as string (compatible with Property)
* - `validation.min/max` on dates: ISO strings → Date objects
*/
function fromSerializableProperty(serialized, lookup) {
	switch (serialized.type) {
		case "date": {
			const { validation: dateValidation, ...dateRest } = serialized;
			const result = {
				...dateRest,
				type: "date"
			};
			if (dateValidation) {
				const convertedValidation = { ...dateValidation };
				if (typeof dateValidation.min === "string") convertedValidation.min = new Date(dateValidation.min);
				if (typeof dateValidation.max === "string") convertedValidation.max = new Date(dateValidation.max);
				result.validation = convertedValidation;
			}
			return result;
		}
		case "array": {
			const sp = serialized;
			const result = { ...sp };
			if (sp.of) if (Array.isArray(sp.of)) result.of = sp.of.map((prop) => fromSerializableProperty(prop, lookup));
			else result.of = fromSerializableProperty(sp.of, lookup);
			if (sp.oneOf) result.oneOf = {
				...sp.oneOf,
				properties: fromSerializableProperties(sp.oneOf.properties, lookup)
			};
			return result;
		}
		case "map": {
			const sp = serialized;
			const result = { ...sp };
			if (sp.properties) result.properties = fromSerializableProperties(sp.properties, lookup);
			return result;
		}
		case "string": return { ...serialized };
		case "relation": {
			const sp = serialized;
			const { relation, ...rest } = sp;
			const result = {
				...rest,
				type: "relation"
			};
			if (relation) result.relation = fromSerializableRelation(relation, sp.name ?? "", lookup);
			return result;
		}
		default: return serialized;
	}
}
/**
* Convert a `SerializableProperties` record back to `Properties`.
*/
function fromSerializableProperties(serialized, lookup) {
	const result = {};
	for (const [key, property] of Object.entries(serialized)) result[key] = fromSerializableProperty(property, lookup);
	return result;
}
/**
* Convert a `SerializableCollectionConfig` back to an `AdminCollection`.
*
* The result will NOT contain any of the non-serializable fields
* (callbacks, entityActions, etc.) — those must be re-attached by the
* consumer if needed.
*/
function fromSerializableCollectionConfig(serialized, lookup) {
	const { properties, relations, ...rest } = serialized;
	return {
		...rest,
		...relations ? { relations: relations.map((relation, index) => fromSerializableRelation(relation, `relations[${index}]`, lookup)) } : {},
		properties: fromSerializableProperties(properties, lookup)
	};
}
/**
* Deserialize a whole set of collections, resolving relation targets against
* each other.
*
* This is the entry point to prefer. A relation's `target` is a slug on the
* wire, and a slug only means something relative to the other collections — so
* deserializing one at a time cannot rebuild a working thunk, and produces
* relations that throw the moment anything resolves them.
*
* The lookup is consulted lazily, inside the thunk, so the collections may
* reference each other in any order, including circularly.
*/
function fromSerializableCollectionConfigs(serialized) {
	const bySlug = /* @__PURE__ */ new Map();
	const lookup = (slug) => bySlug.get(slug);
	const collections = serialized.map((c) => fromSerializableCollectionConfig(c, lookup));
	for (const collection of collections) if (collection.slug) bySlug.set(collection.slug, collection);
	return collections;
}
//#endregion
//#region src/collection_editor/validateCollectionJson.ts
/**
* Valid dataType values for properties
*/
var VALID_DATA_TYPES = [
	"string",
	"number",
	"boolean",
	"date",
	"geopoint",
	"reference",
	"relation",
	"array",
	"map",
	"vector",
	"binary"
];
/**
* Validates a property object recursively
*/
function validateProperty(property, path, errors) {
	if (typeof property !== "object" || property === null) {
		errors.push({
			path,
			message: "Property must be an object"
		});
		return;
	}
	if (!property.type) errors.push({
		path: `${path}.type`,
		message: "Required field is missing"
	});
	else if (!VALID_DATA_TYPES.includes(property.type)) errors.push({
		path: `${path}.type`,
		message: `Invalid value "${property.type}", expected one of: ${VALID_DATA_TYPES.join(", ")}`
	});
	if (property.name !== void 0 && typeof property.name !== "string") errors.push({
		path: `${path}.name`,
		message: "Must be a string"
	});
	if (property.type === "array") {
		if (property.of) if (Array.isArray(property.of)) property.of.forEach((ofProp, index) => {
			validateProperty(ofProp, `${path}.of[${index}]`, errors);
		});
		else validateProperty(property.of, `${path}.of`, errors);
		if (property.oneOf) {
			if (typeof property.oneOf !== "object") errors.push({
				path: `${path}.oneOf`,
				message: "Must be an object"
			});
			else if (property.oneOf.properties) validateProperties(property.oneOf.properties, `${path}.oneOf.properties`, errors);
		}
	}
	if (property.type === "map" && property.properties) validateProperties(property.properties, `${path}.properties`, errors);
	if (property.type === "reference") {
		if (property.path !== void 0 && typeof property.path !== "string") errors.push({
			path: `${path}.path`,
			message: "Must be a string"
		});
	}
	if (property.type === "relation") {
		const link = property.relation;
		if (link !== void 0) {
			const KINDS = [
				"belongsTo",
				"hasOne",
				"hasMany",
				"manyToMany",
				"via"
			];
			if (typeof link.kind !== "string" || !KINDS.includes(link.kind)) errors.push({
				path: `${path}.relation.kind`,
				message: `Must be one of ${KINDS.join(", ")}`
			});
			if (link.target !== void 0 && typeof link.target !== "string" && typeof link.target !== "function") errors.push({
				path: `${path}.relation.target`,
				message: "Must be a collection slug or a thunk returning a collection"
			});
			const allowedByKind = {
				belongsTo: ["localKey"],
				hasOne: ["foreignKeyOnTarget", "sourceKey"],
				hasMany: ["foreignKeyOnTarget", "sourceKey"],
				manyToMany: ["through"],
				via: ["joinPath", "cardinality"]
			};
			const linkFields = [
				"localKey",
				"foreignKeyOnTarget",
				"sourceKey",
				"through",
				"joinPath",
				"cardinality"
			];
			const allowed = allowedByKind[String(link.kind)] ?? [];
			for (const field of linkFields) if (link[field] !== void 0 && !allowed.includes(field)) errors.push({
				path: `${path}.relation.${field}`,
				message: `Not valid on a "${String(link.kind)}" relation`
			});
			if (link.kind === "via" && !Array.isArray(link.joinPath)) errors.push({
				path: `${path}.relation.joinPath`,
				message: "A `via` relation requires a joinPath array"
			});
		}
	}
	if (property.type === "vector") {
		if (property.dimensions !== void 0 && (typeof property.dimensions !== "number" || isNaN(property.dimensions) || property.dimensions <= 0)) errors.push({
			path: `${path}.dimensions`,
			message: "Must be a positive number"
		});
	}
	if (property.type === "string" && property.storage) {
		if (typeof property.storage !== "object") errors.push({
			path: `${path}.storage`,
			message: "Must be an object"
		});
	}
	if (property.enum !== void 0) {
		if (!Array.isArray(property.enum) && typeof property.enum !== "object") errors.push({
			path: `${path}.enum`,
			message: "Must be an array or object"
		});
	}
}
/**
* Validates a properties object (collection of property definitions)
*/
function validateProperties(properties, path, errors) {
	if (typeof properties !== "object" || properties === null) {
		errors.push({
			path,
			message: "Must be an object"
		});
		return;
	}
	for (const [key, property] of Object.entries(properties)) validateProperty(property, `${path}.${key}`, errors);
}
/**
* Validates optional collection fields
*/
function validateOptionalFields(collection, errors) {
	for (const field of [
		"singularName",
		"description",
		"group",
		"databaseId"
	]) if (collection[field] !== void 0 && typeof collection[field] !== "string") errors.push({
		path: field,
		message: "Must be a string"
	});
	for (const field of [
		"selectionEnabled",
		"inlineEditing",
		"hideFromNavigation",
		"hideIdFromForm",
		"hideIdFromCollection",
		"formAutoSave",
		"alwaysApplyDefaultValues",
		"includeJsonView",
		"history"
	]) if (collection[field] !== void 0 && typeof collection[field] !== "boolean") errors.push({
		path: field,
		message: "Must be a boolean"
	});
	if (collection.icon !== void 0 && typeof collection.icon !== "string" && typeof collection.icon !== "object") errors.push({
		path: "icon",
		message: "Must be a string (icon key) or object"
	});
	if (collection.propertiesOrder !== void 0) {
		if (!Array.isArray(collection.propertiesOrder)) errors.push({
			path: "propertiesOrder",
			message: "Must be an array of strings"
		});
		else if (!collection.propertiesOrder.every((item) => typeof item === "string")) errors.push({
			path: "propertiesOrder",
			message: "All items must be strings"
		});
	}
	if (collection.subcollections !== void 0) if (!Array.isArray(collection.subcollections)) errors.push({
		path: "subcollections",
		message: "Must be an array"
	});
	else collection.subcollections.forEach((sub, index) => {
		const subErrors = [];
		validateCollectionObject(sub, subErrors);
		subErrors.forEach((err) => {
			errors.push({
				path: `subcollections[${index}].${err.path}`,
				message: err.message
			});
		});
	});
	const validViewModes = [
		"table",
		"cards",
		"kanban"
	];
	if (collection.defaultViewMode !== void 0) {
		if (!validViewModes.includes(collection.defaultViewMode)) errors.push({
			path: "defaultViewMode",
			message: `Invalid value, expected one of: ${validViewModes.join(", ")}`
		});
	}
	if (collection.kanban !== void 0) {
		if (typeof collection.kanban !== "object" || collection.kanban === null) errors.push({
			path: "kanban",
			message: "Must be an object"
		});
		else if (collection.kanban.columnProperty !== void 0 && typeof collection.kanban.columnProperty !== "string") errors.push({
			path: "kanban.columnProperty",
			message: "Must be a string"
		});
	}
}
/**
* Validates a collection object
*/
function validateCollectionObject(collection, errors) {
	if (!collection.id) errors.push({
		path: "id",
		message: "Required field is missing"
	});
	else if (typeof collection.id !== "string") errors.push({
		path: "id",
		message: "Must be a string"
	});
	if (!collection.name) errors.push({
		path: "name",
		message: "Required field is missing"
	});
	else if (typeof collection.name !== "string") errors.push({
		path: "name",
		message: "Must be a string"
	});
	if (!collection.path) errors.push({
		path: "path",
		message: "Required field is missing"
	});
	else if (typeof collection.path !== "string") errors.push({
		path: "path",
		message: "Must be a string"
	});
	if (collection.properties !== void 0) validateProperties(collection.properties, "properties", errors);
	validateOptionalFields(collection, errors);
}
/**
* Validates a JSON string representing a collection configuration.
* Returns detailed validation errors if the JSON is invalid or doesn't match
* the expected collection schema.
*/
function validateCollectionJson(jsonString) {
	const errors = [];
	let parsed;
	try {
		parsed = JSON.parse(jsonString);
	} catch (e) {
		const message_ = e instanceof Error ? e.message : String(e);
		const match = message_.match(/position (\d+)/);
		let message = "Invalid JSON syntax";
		if (match) {
			const position = parseInt(match[1], 10);
			const lines = jsonString.substring(0, position).split("\n");
			message = `Invalid JSON syntax at line ${lines.length}, column ${lines[lines.length - 1].length + 1}: ${message_}`;
		} else message = `Invalid JSON syntax: ${message_}`;
		return {
			valid: false,
			errors: [{
				path: "",
				message
			}]
		};
	}
	if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) return {
		valid: false,
		errors: [{
			path: "",
			message: "Collection must be an object"
		}]
	};
	validateCollectionObject(parsed, errors);
	return {
		valid: errors.length === 0,
		errors,
		collection: errors.length === 0 ? parsed : void 0
	};
}
//#endregion
//#region src/collection_editor/api/generateCollectionApi.ts
var CollectionGenerationApiError = class extends Error {
	code;
	constructor(message, code) {
		super(message);
		this.code = code;
		this.name = "CollectionGenerationApiError";
	}
};
/**
* Default endpoint for AI collection generation
*/
var DEFAULT_COLLECTION_GENERATION_ENDPOINT = "https://api.rebase.pro/collections/generate";
/**
* Build a callback for AI collection generation.
* This helper allows self-hosted Rebase users to enable the AI collection
* generation feature.
*
* @example
* ```tsx
* import { RebaseCMS, buildCollectionGenerationCallback } from "@rebasepro/cms";
* import { useFirebaseAuthController } from "@rebasepro/firebase";
*
* const authController = useFirebaseAuthController({ firebaseApp });
*
* export function App() {
*     return (
*         <RebaseCMS
*             collectionEditor={{
*                 generateCollection: buildCollectionGenerationCallback({
*                     getAuthToken: authController.getAuthToken
*                 })
*             }}
*         />
*     );
* }
* ```
*/
function buildCollectionGenerationCallback({ getAuthToken, apiEndpoint = DEFAULT_COLLECTION_GENERATION_ENDPOINT }) {
	return async (request) => {
		const token = await getAuthToken();
		const response = await fetch(apiEndpoint, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(request)
		});
		if (!response.ok) {
			const errorData = await response.json().catch(() => ({}));
			throw new CollectionGenerationApiError(errorData.error || "Failed to generate collection", errorData.code);
		}
		const data = await response.json();
		return {
			collection: data.data.collection,
			operations: data.data.operations
		};
	};
}
//#endregion
//#region src/collection_editor/ui/collection_editor/util.ts
function idToPropertiesPath(id) {
	return "properties." + id.replaceAll(".", ".properties.");
}
function namespaceToPropertiesPath(namespace) {
	return namespace ? "properties." + namespace.replaceAll(".", ".properties.") + ".properties" : "properties";
}
function namespaceToPropertiesOrderPath(namespace) {
	return namespace ? "properties." + namespace.replaceAll(".", ".properties.") + ".propertiesOrder" : "propertiesOrder";
}
function getFullId(propertyKey, propertyNamespace) {
	return propertyNamespace ? `${propertyNamespace}.${propertyKey}` : propertyKey;
}
function getFullIdPath(propertyKey, propertyNamespace) {
	return idToPropertiesPath(propertyNamespace ? `${propertyNamespace}.${propertyKey}` : propertyKey);
}
//#endregion
export { NAVIGATION_DEFAULT_GROUP_NAME as $, CollectionRegistryContext as $n, getCollectionBySlugWithin as $t, getFieldId as A, ReadOnlyFieldBinding as An, getIconForWidget as Ar, convertDataToEntity as At, MapFieldBinding as B, MapPropertyPreview as Bn, detectCsvDelimiter as Bt, EntityFormBinding as C, NavigationStateContext as Cn, LABEL_ICON_SIZE as Cr, EntityCardBinding as Ct, getDefaultFieldConfig as D, SelectableTableContext as Dn, getBracketNotation as Dr, useCollectionEditorDialogsState as Dt, DEFAULT_FIELD_CONFIGS as E, SideDialogsControllerContext as En, PropertyKeyHint as Er, ConfigControllerProvider as Et, SelectFieldBinding as F, UserPreview as Fn, isRelationProperty as Fr, ImportSaveInProgress as Ft, useSelectionDialog as G, ArrayOfStorageComponentsPreview as Gn, SearchIconsView as Gt, DateTimeFieldBinding as H, ArrayOfStringsPreview as Hn, parseCsvToObjects as Ht, RepeatFieldBinding as I, NumberPropertyPreview as In, IMPORT_BATCH_SIZE as It, useBuildUrlController as J, InlineEntityListPreview as Jn, BreadcrumbsProvider as Jt, SelectionTableBinding as K, RelationPreview as Kn, FieldCaption as Kt, ReferenceFieldBinding as L, BooleanPreview as Ln, saveImportedEntities as Lt, TextFieldBinding as M, FieldHelperText as Mn, getPropertyInPath$1 as Mr, processValueMapping as Mt, SwitchFieldBinding as N, ArrayOfMapsPreview as Nn, getResolvedPropertyInPath as Nr, getInferenceType as Nt, getDefaultFieldId as O, ArrayCustomShapedFieldBinding as On, getDefaultPropertiesOrder as Or, ImportNewPropertyFieldPreview as Ot, StorageUploadFieldBinding as P, PropertyPreview as Pn, isReferenceProperty as Pr, useImportConfig as Pt, useResolvedCollections as Q, useSidePanel as Qn, addInitialSlash as Qt, MultiSelectFieldBinding as R, DatePreview as Rn, ImportFileUpload as Rt, isSchemaChangeCancelled as S, useUrlController as Sn, FieldBlock as Sr, CollectionCardViewBinding as St, PropertyFieldBinding as T, useSideDialogsController as Tn, spanClass as Tr, useCollectionEditorController as Tt, BlockFieldBinding as U, ArrayPropertyEnumPreview as Un, ArrayContainer as Ut, KeyValueFieldBinding as V, ArrayOneOfPreview as Vn, parseCsvRows as Vt, ArrayOfReferencesFieldBinding as W, ArrayEnumPreview as Wn, PropertyConfigBadge as Wt, useTopLevelNavigation as X, EntityPreviewBinding as Xn, resolveEntityView as Xt, useBuildNavigationStateController as Y, ReferencePreview as Yn, resolveEntityAction as Yt, useResolvedViews as Z, SidePanelControllerContext as Zn, mergeEntityActions as Zt, useCollectionsConfigController as _, CollectionTableBinding as _n, ImagePreview as _r, editEntityAction as _t, namespaceToPropertiesPath as a, resolveCollectionPathIds$1 as an, getEntityTitlePropertyKeyForEntity as ar, getEntityViewWidth as at, asUnavailable as b, useAdminContext as bn, FormRail as br, DetailViewBinding as bt, buildCollectionGenerationCallback as c, SelectionMenu as cn, EnumValuesChip as cr, useSafeSnackbarController as ct, fromSerializableCollectionConfigs as d, resolveSelection as dn, SkeletonPropertyComponent as dr, getInitialEntityValues as dt, getCollectionPathsCombinations as en, useCollectionRegistryController as er, useBuildCollectionRegistryController as et, fromSerializableProperties as f, selectionQueryToFindParams as fn, renderSkeletonCaptionText as fr, removeEmptyContainers as ft, toSerializableProperty as g, VirtualTableInput$1 as gn, UrlComponentPreview as gr, deleteEntityAction as gt, toSerializableProperties as h, useSelectionController as hn, renderSkeletonText as hr, copyEntityAction as ht, namespaceToPropertiesOrderPath as i, removeTrailingSlash$1 as in, getEntityTitlePropertyKey as ir, buildSidePanelsFromUrl as it, VectorFieldBinding as j, LabelWithIcon as jn, getPropertiesWithPropertiesOrder as jr, flattenEntry as jt, getFieldConfig as k, useClearRestoreValue as kn, getIconForProperty as kr, DataNewPropertiesMapping as kt, validateCollectionJson as l, MAX_SELECTION_ROWS as ln, StorageThumbnail as lr, extractTouchedValues as lt, toSerializableCollectionConfig as m, walkEntityPages as mn, renderSkeletonImageThumbnail as mr, CollectionViewBinding as mt, getFullIdPath as n, removeInitialAndTrailingSlashes$1 as nn, useResolvedUser as nr, resolveNavigationFrom as nt, CollectionGenerationApiError as o, resolveOpenEntityMode as on, ArrayPropertyPreview as or, useBuildSidePanel as ot, fromSerializableProperty as p, serializeSelectionQuery as pn, renderSkeletonIcon as pr, zodToFormErrors as pt, SideDialogs as q, ArrayOfReferencesPreview as qn, useBreadcrumbsController as qt, idToPropertiesPath as r, removeInitialSlash as rn, getEntityPreviewKeys as rr, useResolvedNavigationFrom as rt, DEFAULT_COLLECTION_GENERATION_ENDPOINT as s, resolveViewMode as sn, StringPropertyPreview as sr, EditViewBinding as st, getFullId as t, getLastSegment$1 as tn, getUserLabel as tr, useHistory as tt, fromSerializableCollectionConfig as u, SELECTION_PAGE_SIZE as un, StorageThumbnailInternal as ur, getChanges as ut, LiveSchemaError as v, SelectableTable as vn, EmptyValue as vr, resetPasswordAction as vt, EntityForm as w, useNavigationStateController as wn, isSelfLabellingProperty as wr, CollectionViewActions as wt, createLiveSchemaClient as x, UrlContext as xn, RecordMeta as xr, EntityViewBinding as xt, SchemaChangeCancelled as y, CollectionRowActions as yn, FormSections as yr, CreationResultDialog as yt, MarkdownEditorFieldBinding as z, KeyValuePreview as zn, convertFileToJson as zt };

//# sourceMappingURL=util-CyIcgnv2.js.map